import * as Q from "react";
import Ot, { useState as Ye, useMemo as sr, useEffect as Tt, useContext as Mn, useRef as Mt, createElement as ev, useCallback as Nr, useReducer as Ja, useLayoutEffect as hr, createContext as ls, forwardRef as H0 } from "react";
import { createPortal as Dd } from "react-dom";
var f6 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function B0(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Ah, Uu = { exports: {} }, Aa = {}, Mh, qo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
process.env.NODE_ENV === "production" ? Uu.exports = function() {
  if (Ah)
    return Aa;
  Ah = 1;
  var t = Ot, n = Symbol.for("react.element"), e = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(o, l, c) {
    var u, d = {}, h = null, p = null;
    for (u in c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (p = l.ref), l)
      r.call(l, u) && !s.hasOwnProperty(u) && (d[u] = l[u]);
    if (o && o.defaultProps)
      for (u in l = o.defaultProps)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: n, type: o, key: h, ref: p, props: d, _owner: i.current };
  }
  return Aa.Fragment = e, Aa.jsx = a, Aa.jsxs = a, Aa;
}() : Uu.exports = (Mh || (Mh = 1, process.env.NODE_ENV !== "production" && function() {
  var t = Ot, n = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), f = Symbol.iterator, m = "@@iterator", v = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  function E(z) {
    for (var Ne = arguments.length, Oe = new Array(Ne > 1 ? Ne - 1 : 0), De = 1; De < Ne; De++)
      Oe[De - 1] = arguments[De];
    (function(Ge, st, Je) {
      var He = v.ReactDebugCurrentFrame.getStackAddendum();
      He !== "" && (st += "%s", Je = Je.concat([He]));
      var lt = Je.map(function(dt) {
        return String(dt);
      });
      lt.unshift("Warning: " + st), Function.prototype.apply.call(console[Ge], console, lt);
    })("error", z, Oe);
  }
  var y, b = !1, T = !1, w = !1, N = !1, M = !1;
  function I(z) {
    return z.displayName || "Context";
  }
  function x(z) {
    if (z == null)
      return null;
    if (typeof z.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof z == "function")
      return z.displayName || z.name || null;
    if (typeof z == "string")
      return z;
    switch (z) {
      case r:
        return "Fragment";
      case e:
        return "Portal";
      case s:
        return "Profiler";
      case i:
        return "StrictMode";
      case c:
        return "Suspense";
      case u:
        return "SuspenseList";
    }
    if (typeof z == "object")
      switch (z.$$typeof) {
        case o:
          return I(z) + ".Consumer";
        case a:
          return I(z._context) + ".Provider";
        case l:
          return function(st, Je, He) {
            var lt = st.displayName;
            if (lt)
              return lt;
            var dt = Je.displayName || Je.name || "";
            return dt !== "" ? He + "(" + dt + ")" : He;
          }(z, z.render, "ForwardRef");
        case d:
          var Ne = z.displayName || null;
          return Ne !== null ? Ne : x(z.type) || "Memo";
        case h:
          var Oe = z, De = Oe._payload, Ge = Oe._init;
          try {
            return x(Ge(De));
          } catch {
            return null;
          }
      }
    return null;
  }
  y = Symbol.for("react.module.reference");
  var R, L, j, P, q, G, X, Ce = Object.assign, Be = 0;
  function se() {
  }
  se.__reactDisabledLog = !0;
  var Ee, ee = v.ReactCurrentDispatcher;
  function ge(z, Ne, Oe) {
    if (Ee === void 0)
      try {
        throw Error();
      } catch (Ge) {
        var De = Ge.stack.trim().match(/\n( *(at )?)/);
        Ee = De && De[1] || "";
      }
    return `
` + Ee + z;
  }
  var ve, H = !1, oe = typeof WeakMap == "function" ? WeakMap : Map;
  function J(z, Ne) {
    if (!z || H)
      return "";
    var Oe, De = ve.get(z);
    if (De !== void 0)
      return De;
    H = !0;
    var Ge, st = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0, Ge = ee.current, ee.current = null, function() {
      if (Be === 0) {
        R = console.log, L = console.info, j = console.warn, P = console.error, q = console.group, G = console.groupCollapsed, X = console.groupEnd;
        var ut = { configurable: !0, enumerable: !0, value: se, writable: !0 };
        Object.defineProperties(console, { info: ut, log: ut, warn: ut, error: ut, group: ut, groupCollapsed: ut, groupEnd: ut });
      }
      Be++;
    }();
    try {
      if (Ne) {
        var Je = function() {
          throw Error();
        };
        if (Object.defineProperty(Je.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(Je, []);
          } catch (ut) {
            Oe = ut;
          }
          Reflect.construct(z, [], Je);
        } else {
          try {
            Je.call();
          } catch (ut) {
            Oe = ut;
          }
          z.call(Je.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (ut) {
          Oe = ut;
        }
        z();
      }
    } catch (ut) {
      if (ut && Oe && typeof ut.stack == "string") {
        for (var He = ut.stack.split(`
`), lt = Oe.stack.split(`
`), dt = He.length - 1, qe = lt.length - 1; dt >= 1 && qe >= 0 && He[dt] !== lt[qe]; )
          qe--;
        for (; dt >= 1 && qe >= 0; dt--, qe--)
          if (He[dt] !== lt[qe]) {
            if (dt !== 1 || qe !== 1)
              do
                if (dt--, --qe < 0 || He[dt] !== lt[qe]) {
                  var Ke = `
` + He[dt].replace(" at new ", " at ");
                  return z.displayName && Ke.includes("<anonymous>") && (Ke = Ke.replace("<anonymous>", z.displayName)), typeof z == "function" && ve.set(z, Ke), Ke;
                }
              while (dt >= 1 && qe >= 0);
            break;
          }
      }
    } finally {
      H = !1, ee.current = Ge, function() {
        if (--Be == 0) {
          var ut = { configurable: !0, enumerable: !0, writable: !0 };
          Object.defineProperties(console, { log: Ce({}, ut, { value: R }), info: Ce({}, ut, { value: L }), warn: Ce({}, ut, { value: j }), error: Ce({}, ut, { value: P }), group: Ce({}, ut, { value: q }), groupCollapsed: Ce({}, ut, { value: G }), groupEnd: Ce({}, ut, { value: X }) });
        }
        Be < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }(), Error.prepareStackTrace = st;
    }
    var ct = z ? z.displayName || z.name : "", nt = ct ? ge(ct) : "";
    return typeof z == "function" && ve.set(z, nt), nt;
  }
  function Me(z, Ne, Oe) {
    if (z == null)
      return "";
    if (typeof z == "function")
      return J(z, !(!(De = z.prototype) || !De.isReactComponent));
    var De;
    if (typeof z == "string")
      return ge(z);
    switch (z) {
      case c:
        return ge("Suspense");
      case u:
        return ge("SuspenseList");
    }
    if (typeof z == "object")
      switch (z.$$typeof) {
        case l:
          return function(He, lt, dt) {
            return J(He, !1);
          }(z.render);
        case d:
          return Me(z.type, Ne, Oe);
        case h:
          var Ge = z, st = Ge._payload, Je = Ge._init;
          try {
            return Me(Je(st), Ne, Oe);
          } catch {
          }
      }
    return "";
  }
  ve = new oe();
  var V = Object.prototype.hasOwnProperty, ie = {}, ae = v.ReactDebugCurrentFrame;
  function ce(z) {
    if (z) {
      var Ne = z._owner, Oe = Me(z.type, z._source, Ne ? Ne.type : null);
      ae.setExtraStackFrame(Oe);
    } else
      ae.setExtraStackFrame(null);
  }
  var le = Array.isArray;
  function re(z) {
    return le(z);
  }
  function te(z) {
    return "" + z;
  }
  function Te(z) {
    if (function(Ne) {
      try {
        return te(Ne), !1;
      } catch {
        return !0;
      }
    }(z))
      return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", function(Ne) {
        return typeof Symbol == "function" && Symbol.toStringTag && Ne[Symbol.toStringTag] || Ne.constructor.name || "Object";
      }(z)), te(z);
  }
  var ke, he, ye, ze = v.ReactCurrentOwner, ot = { key: !0, ref: !0, __self: !0, __source: !0 };
  ye = {};
  var W = function(z, Ne, Oe, De, Ge, st, Je) {
    var He = { $$typeof: n, type: z, key: Ne, ref: Oe, props: Je, _owner: st, _store: {} };
    return Object.defineProperty(He._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: !1 }), Object.defineProperty(He, "_self", { configurable: !1, enumerable: !1, writable: !1, value: De }), Object.defineProperty(He, "_source", { configurable: !1, enumerable: !1, writable: !1, value: Ge }), Object.freeze && (Object.freeze(He.props), Object.freeze(He)), He;
  };
  function xe(z, Ne, Oe, De, Ge) {
    var st, Je = {}, He = null, lt = null;
    for (st in Oe !== void 0 && (Te(Oe), He = "" + Oe), function(Ke) {
      if (V.call(Ke, "key")) {
        var ct = Object.getOwnPropertyDescriptor(Ke, "key").get;
        if (ct && ct.isReactWarning)
          return !1;
      }
      return Ke.key !== void 0;
    }(Ne) && (Te(Ne.key), He = "" + Ne.key), function(Ke) {
      if (V.call(Ke, "ref")) {
        var ct = Object.getOwnPropertyDescriptor(Ke, "ref").get;
        if (ct && ct.isReactWarning)
          return !1;
      }
      return Ke.ref !== void 0;
    }(Ne) && (lt = Ne.ref, function(Ke, ct) {
      if (typeof Ke.ref == "string" && ze.current && ct && ze.current.stateNode !== ct) {
        var nt = x(ze.current.type);
        ye[nt] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', x(ze.current.type), Ke.ref), ye[nt] = !0);
      }
    }(Ne, Ge)), Ne)
      V.call(Ne, st) && !ot.hasOwnProperty(st) && (Je[st] = Ne[st]);
    if (z && z.defaultProps) {
      var dt = z.defaultProps;
      for (st in dt)
        Je[st] === void 0 && (Je[st] = dt[st]);
    }
    if (He || lt) {
      var qe = typeof z == "function" ? z.displayName || z.name || "Unknown" : z;
      He && function(Ke, ct) {
        var nt = function() {
          ke || (ke = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ct));
        };
        nt.isReactWarning = !0, Object.defineProperty(Ke, "key", { get: nt, configurable: !0 });
      }(Je, qe), lt && function(Ke, ct) {
        var nt = function() {
          he || (he = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ct));
        };
        nt.isReactWarning = !0, Object.defineProperty(Ke, "ref", { get: nt, configurable: !0 });
      }(Je, qe);
    }
    return W(z, He, lt, Ge, De, ze.current, Je);
  }
  var be, ue = v.ReactCurrentOwner, Se = v.ReactDebugCurrentFrame;
  function Fe(z) {
    if (z) {
      var Ne = z._owner, Oe = Me(z.type, z._source, Ne ? Ne.type : null);
      Se.setExtraStackFrame(Oe);
    } else
      Se.setExtraStackFrame(null);
  }
  function et(z) {
    return typeof z == "object" && z !== null && z.$$typeof === n;
  }
  function je() {
    if (ue.current) {
      var z = x(ue.current.type);
      if (z)
        return `

Check the render method of \`` + z + "`.";
    }
    return "";
  }
  be = !1;
  var Xe = {};
  function Et(z, Ne) {
    if (z._store && !z._store.validated && z.key == null) {
      z._store.validated = !0;
      var Oe = function(Ge) {
        var st = je();
        if (!st) {
          var Je = typeof Ge == "string" ? Ge : Ge.displayName || Ge.name;
          Je && (st = `

Check the top-level render call using <` + Je + ">.");
        }
        return st;
      }(Ne);
      if (!Xe[Oe]) {
        Xe[Oe] = !0;
        var De = "";
        z && z._owner && z._owner !== ue.current && (De = " It was passed a child from " + x(z._owner.type) + "."), Fe(z), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Oe, De), Fe(null);
      }
    }
  }
  function $e(z, Ne) {
    if (typeof z == "object") {
      if (re(z))
        for (var Oe = 0; Oe < z.length; Oe++) {
          var De = z[Oe];
          et(De) && Et(De, Ne);
        }
      else if (et(z))
        z._store && (z._store.validated = !0);
      else if (z) {
        var Ge = function(He) {
          if (He === null || typeof He != "object")
            return null;
          var lt = f && He[f] || He[m];
          return typeof lt == "function" ? lt : null;
        }(z);
        if (typeof Ge == "function" && Ge !== z.entries)
          for (var st, Je = Ge.call(z); !(st = Je.next()).done; )
            et(st.value) && Et(st.value, Ne);
      }
    }
  }
  function Rt(z) {
    var Ne, Oe = z.type;
    if (Oe != null && typeof Oe != "string") {
      if (typeof Oe == "function")
        Ne = Oe.propTypes;
      else {
        if (typeof Oe != "object" || Oe.$$typeof !== l && Oe.$$typeof !== d)
          return;
        Ne = Oe.propTypes;
      }
      if (Ne) {
        var De = x(Oe);
        (function(Ge, st, Je, He, lt) {
          var dt = Function.call.bind(V);
          for (var qe in Ge)
            if (dt(Ge, qe)) {
              var Ke = void 0;
              try {
                if (typeof Ge[qe] != "function") {
                  var ct = Error((He || "React class") + ": " + Je + " type `" + qe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Ge[qe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw ct.name = "Invariant Violation", ct;
                }
                Ke = Ge[qe](st, qe, He, Je, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (nt) {
                Ke = nt;
              }
              !Ke || Ke instanceof Error || (ce(lt), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", He || "React class", Je, qe, typeof Ke), ce(null)), Ke instanceof Error && !(Ke.message in ie) && (ie[Ke.message] = !0, ce(lt), E("Failed %s type: %s", Je, Ke.message), ce(null));
            }
        })(Ne, z.props, "prop", De, z);
      } else
        Oe.PropTypes === void 0 || be || (be = !0, E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x(Oe) || "Unknown"));
      typeof Oe.getDefaultProps != "function" || Oe.getDefaultProps.isReactClassApproved || E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
  }
  var xt = {};
  function Gt(z, Ne, Oe, De, Ge, st) {
    var Je = function(ft) {
      return typeof ft == "string" || typeof ft == "function" || !!(ft === r || ft === s || M || ft === i || ft === c || ft === u || N || ft === p || b || T || w) || typeof ft == "object" && ft !== null && (ft.$$typeof === h || ft.$$typeof === d || ft.$$typeof === a || ft.$$typeof === o || ft.$$typeof === l || ft.$$typeof === y || ft.getModuleId !== void 0);
    }(z);
    if (!Je) {
      var He, lt = "";
      (z === void 0 || typeof z == "object" && z !== null && Object.keys(z).length === 0) && (lt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), lt += je(), z === null ? He = "null" : re(z) ? He = "array" : z !== void 0 && z.$$typeof === n ? (He = "<" + (x(z.type) || "Unknown") + " />", lt = " Did you accidentally export a JSX literal instead of a component?") : He = typeof z, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", He, lt);
    }
    var dt = xe(z, Ne, Oe, Ge, st);
    if (dt == null)
      return dt;
    if (Je) {
      var qe = Ne.children;
      if (qe !== void 0)
        if (De)
          if (re(qe)) {
            for (var Ke = 0; Ke < qe.length; Ke++)
              $e(qe[Ke], z);
            Object.freeze && Object.freeze(qe);
          } else
            E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
        else
          $e(qe, z);
    }
    if (V.call(Ne, "key")) {
      var ct = x(z), nt = Object.keys(Ne).filter(function(ft) {
        return ft !== "key";
      }), ut = nt.length > 0 ? "{key: someKey, " + nt.join(": ..., ") + ": ...}" : "{key: someKey}";
      xt[ct + ut] || (E(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ut, ct, nt.length > 0 ? "{" + nt.join(": ..., ") + ": ...}" : "{}", ct), xt[ct + ut] = !0);
    }
    return z === r ? function(ft) {
      for (var un = Object.keys(ft.props), dn = 0; dn < un.length; dn++) {
        var hn = un[dn];
        if (hn !== "children" && hn !== "key") {
          Fe(ft), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", hn), Fe(null);
          break;
        }
      }
      ft.ref !== null && (Fe(ft), E("Invalid attribute `ref` supplied to `React.Fragment`."), Fe(null));
    }(dt) : Rt(dt), dt;
  }
  var qt = function(z, Ne, Oe) {
    return Gt(z, Ne, Oe, !1);
  }, Xt = function(z, Ne, Oe) {
    return Gt(z, Ne, Oe, !0);
  };
  qo.Fragment = r, qo.jsx = qt, qo.jsxs = Xt;
}()), qo);
var xh, C = Uu.exports, Pu = { exports: {} }, Ht = {}, kh, Wt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
process.env.NODE_ENV === "production" ? Pu.exports = function() {
  if (xh)
    return Ht;
  xh = 1;
  var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, e = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, s = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, o = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, h = t ? Symbol.for("react.suspense_list") : 60120, p = t ? Symbol.for("react.memo") : 60115, f = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, v = t ? Symbol.for("react.fundamental") : 60117, E = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
  function b(w) {
    if (typeof w == "object" && w !== null) {
      var N = w.$$typeof;
      switch (N) {
        case n:
          switch (w = w.type) {
            case l:
            case c:
            case r:
            case s:
            case i:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof) {
                case o:
                case u:
                case f:
                case p:
                case a:
                  return w;
                default:
                  return N;
              }
          }
        case e:
          return N;
      }
    }
  }
  function T(w) {
    return b(w) === c;
  }
  return Ht.AsyncMode = l, Ht.ConcurrentMode = c, Ht.ContextConsumer = o, Ht.ContextProvider = a, Ht.Element = n, Ht.ForwardRef = u, Ht.Fragment = r, Ht.Lazy = f, Ht.Memo = p, Ht.Portal = e, Ht.Profiler = s, Ht.StrictMode = i, Ht.Suspense = d, Ht.isAsyncMode = function(w) {
    return T(w) || b(w) === l;
  }, Ht.isConcurrentMode = T, Ht.isContextConsumer = function(w) {
    return b(w) === o;
  }, Ht.isContextProvider = function(w) {
    return b(w) === a;
  }, Ht.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === n;
  }, Ht.isForwardRef = function(w) {
    return b(w) === u;
  }, Ht.isFragment = function(w) {
    return b(w) === r;
  }, Ht.isLazy = function(w) {
    return b(w) === f;
  }, Ht.isMemo = function(w) {
    return b(w) === p;
  }, Ht.isPortal = function(w) {
    return b(w) === e;
  }, Ht.isProfiler = function(w) {
    return b(w) === s;
  }, Ht.isStrictMode = function(w) {
    return b(w) === i;
  }, Ht.isSuspense = function(w) {
    return b(w) === d;
  }, Ht.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === c || w === s || w === i || w === d || w === h || typeof w == "object" && w !== null && (w.$$typeof === f || w.$$typeof === p || w.$$typeof === a || w.$$typeof === o || w.$$typeof === u || w.$$typeof === v || w.$$typeof === E || w.$$typeof === y || w.$$typeof === m);
  }, Ht.typeOf = b, Ht;
}() : Pu.exports = (kh || (kh = 1, process.env.NODE_ENV !== "production" && function() {
  var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, e = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, s = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, o = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, h = t ? Symbol.for("react.suspense_list") : 60120, p = t ? Symbol.for("react.memo") : 60115, f = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, v = t ? Symbol.for("react.fundamental") : 60117, E = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
  function b(se) {
    if (typeof se == "object" && se !== null) {
      var Ee = se.$$typeof;
      switch (Ee) {
        case n:
          var ee = se.type;
          switch (ee) {
            case l:
            case c:
            case r:
            case s:
            case i:
            case d:
              return ee;
            default:
              var ge = ee && ee.$$typeof;
              switch (ge) {
                case o:
                case u:
                case f:
                case p:
                case a:
                  return ge;
                default:
                  return Ee;
              }
          }
        case e:
          return Ee;
      }
    }
  }
  var T = l, w = c, N = o, M = a, I = n, x = u, R = r, L = f, j = p, P = e, q = s, G = i, X = d, Ce = !1;
  function Be(se) {
    return b(se) === c;
  }
  Wt.AsyncMode = T, Wt.ConcurrentMode = w, Wt.ContextConsumer = N, Wt.ContextProvider = M, Wt.Element = I, Wt.ForwardRef = x, Wt.Fragment = R, Wt.Lazy = L, Wt.Memo = j, Wt.Portal = P, Wt.Profiler = q, Wt.StrictMode = G, Wt.Suspense = X, Wt.isAsyncMode = function(se) {
    return Ce || (Ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Be(se) || b(se) === l;
  }, Wt.isConcurrentMode = Be, Wt.isContextConsumer = function(se) {
    return b(se) === o;
  }, Wt.isContextProvider = function(se) {
    return b(se) === a;
  }, Wt.isElement = function(se) {
    return typeof se == "object" && se !== null && se.$$typeof === n;
  }, Wt.isForwardRef = function(se) {
    return b(se) === u;
  }, Wt.isFragment = function(se) {
    return b(se) === r;
  }, Wt.isLazy = function(se) {
    return b(se) === f;
  }, Wt.isMemo = function(se) {
    return b(se) === p;
  }, Wt.isPortal = function(se) {
    return b(se) === e;
  }, Wt.isProfiler = function(se) {
    return b(se) === s;
  }, Wt.isStrictMode = function(se) {
    return b(se) === i;
  }, Wt.isSuspense = function(se) {
    return b(se) === d;
  }, Wt.isValidElementType = function(se) {
    return typeof se == "string" || typeof se == "function" || se === r || se === c || se === s || se === i || se === d || se === h || typeof se == "object" && se !== null && (se.$$typeof === f || se.$$typeof === p || se.$$typeof === a || se.$$typeof === o || se.$$typeof === u || se.$$typeof === v || se.$$typeof === E || se.$$typeof === y || se.$$typeof === m);
  }, Wt.typeOf = b;
}()), Wt);
var _c = Pu.exports, tv = function(t, n, e, r) {
  var i = e ? e.call(r, t, n) : void 0;
  if (i !== void 0)
    return !!i;
  if (t === n)
    return !0;
  if (typeof t != "object" || !t || typeof n != "object" || !n)
    return !1;
  var s = Object.keys(t), a = Object.keys(n);
  if (s.length !== a.length)
    return !1;
  for (var o = Object.prototype.hasOwnProperty.bind(n), l = 0; l < s.length; l++) {
    var c = s[l];
    if (!o(c))
      return !1;
    var u = t[c], d = n[c];
    if ((i = e ? e.call(r, u, d, c) : void 0) === !1 || i === void 0 && u !== d)
      return !1;
  }
  return !0;
};
const nv = B0(tv);
function rv(t) {
  function n(Ee, ee, ge, ve, H) {
    for (var oe, J, Me, V, ie, ae = 0, ce = 0, le = 0, re = 0, te = 0, Te = 0, ke = Me = oe = 0, he = 0, ye = 0, ze = 0, ot = 0, W = ge.length, xe = W - 1, be = "", ue = "", Se = "", Fe = ""; he < W; ) {
      if (J = ge.charCodeAt(he), he === xe && ce + re + le + ae !== 0 && (ce !== 0 && (J = ce === 47 ? 10 : 47), re = le = ae = 0, W++, xe++), ce + re + le + ae === 0) {
        if (he === xe && (0 < ye && (be = be.replace(d, "")), 0 < be.trim().length)) {
          switch (J) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              be += ge.charAt(he);
          }
          J = 59;
        }
        switch (J) {
          case 123:
            for (oe = (be = be.trim()).charCodeAt(0), Me = 1, ot = ++he; he < W; ) {
              switch (J = ge.charCodeAt(he)) {
                case 123:
                  Me++;
                  break;
                case 125:
                  Me--;
                  break;
                case 47:
                  switch (J = ge.charCodeAt(he + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (ke = he + 1; ke < xe; ++ke)
                          switch (ge.charCodeAt(ke)) {
                            case 47:
                              if (J === 42 && ge.charCodeAt(ke - 1) === 42 && he + 2 !== ke) {
                                he = ke + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (J === 47) {
                                he = ke + 1;
                                break e;
                              }
                          }
                        he = ke;
                      }
                  }
                  break;
                case 91:
                  J++;
                case 40:
                  J++;
                case 34:
                case 39:
                  for (; he++ < xe && ge.charCodeAt(he) !== J; )
                    ;
              }
              if (Me === 0)
                break;
              he++;
            }
            if (Me = ge.substring(ot, he), oe === 0 && (oe = (be = be.replace(u, "").trim()).charCodeAt(0)), oe === 64) {
              switch (0 < ye && (be = be.replace(d, "")), J = be.charCodeAt(1)) {
                case 100:
                case 109:
                case 115:
                case 45:
                  ye = ee;
                  break;
                default:
                  ye = G;
              }
              if (ot = (Me = n(ee, ye, Me, J, H + 1)).length, 0 < Ce && (ie = o(3, Me, ye = e(G, be, ze), ee, j, L, ot, J, H, ve), be = ye.join(""), ie !== void 0 && (ot = (Me = ie.trim()).length) === 0 && (J = 0, Me = "")), 0 < ot)
                switch (J) {
                  case 115:
                    be = be.replace(w, a);
                  case 100:
                  case 109:
                  case 45:
                    Me = be + "{" + Me + "}";
                    break;
                  case 107:
                    Me = (be = be.replace(E, "$1 $2")) + "{" + Me + "}", Me = q === 1 || q === 2 && s("@" + Me, 3) ? "@-webkit-" + Me + "@" + Me : "@" + Me;
                    break;
                  default:
                    Me = be + Me, ve === 112 && (ue += Me, Me = "");
                }
              else
                Me = "";
            } else
              Me = n(ee, e(ee, be, ze), Me, ve, H + 1);
            Se += Me, Me = ze = ye = ke = oe = 0, be = "", J = ge.charCodeAt(++he);
            break;
          case 125:
          case 59:
            if (1 < (ot = (be = (0 < ye ? be.replace(d, "") : be).trim()).length))
              switch (ke === 0 && (oe = be.charCodeAt(0), oe === 45 || 96 < oe && 123 > oe) && (ot = (be = be.replace(" ", ":")).length), 0 < Ce && (ie = o(1, be, ee, Ee, j, L, ue.length, ve, H, ve)) !== void 0 && (ot = (be = ie.trim()).length) === 0 && (be = "\0\0"), oe = be.charCodeAt(0), J = be.charCodeAt(1), oe) {
                case 0:
                  break;
                case 64:
                  if (J === 105 || J === 99) {
                    Fe += be + ge.charAt(he);
                    break;
                  }
                default:
                  be.charCodeAt(ot - 1) !== 58 && (ue += i(be, oe, J, be.charCodeAt(2)));
              }
            ze = ye = ke = oe = 0, be = "", J = ge.charCodeAt(++he);
        }
      }
      switch (J) {
        case 13:
        case 10:
          ce === 47 ? ce = 0 : 1 + oe === 0 && ve !== 107 && 0 < be.length && (ye = 1, be += "\0"), 0 < Ce * se && o(0, be, ee, Ee, j, L, ue.length, ve, H, ve), L = 1, j++;
          break;
        case 59:
        case 125:
          if (ce + re + le + ae === 0) {
            L++;
            break;
          }
        default:
          switch (L++, V = ge.charAt(he), J) {
            case 9:
            case 32:
              if (re + ae + ce === 0)
                switch (te) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    V = "";
                    break;
                  default:
                    J !== 32 && (V = " ");
                }
              break;
            case 0:
              V = "\\0";
              break;
            case 12:
              V = "\\f";
              break;
            case 11:
              V = "\\v";
              break;
            case 38:
              re + ce + ae === 0 && (ye = ze = 1, V = "\f" + V);
              break;
            case 108:
              if (re + ce + ae + P === 0 && 0 < ke)
                switch (he - ke) {
                  case 2:
                    te === 112 && ge.charCodeAt(he - 3) === 58 && (P = te);
                  case 8:
                    Te === 111 && (P = Te);
                }
              break;
            case 58:
              re + ce + ae === 0 && (ke = he);
              break;
            case 44:
              ce + le + re + ae === 0 && (ye = 1, V += "\r");
              break;
            case 34:
            case 39:
              ce === 0 && (re = re === J ? 0 : re === 0 ? J : re);
              break;
            case 91:
              re + ce + le === 0 && ae++;
              break;
            case 93:
              re + ce + le === 0 && ae--;
              break;
            case 41:
              re + ce + ae === 0 && le--;
              break;
            case 40:
              re + ce + ae === 0 && (oe === 0 && (2 * te + 3 * Te == 533 || (oe = 1)), le++);
              break;
            case 64:
              ce + le + re + ae + ke + Me === 0 && (Me = 1);
              break;
            case 42:
            case 47:
              if (!(0 < re + ae + le))
                switch (ce) {
                  case 0:
                    switch (2 * J + 3 * ge.charCodeAt(he + 1)) {
                      case 235:
                        ce = 47;
                        break;
                      case 220:
                        ot = he, ce = 42;
                    }
                    break;
                  case 42:
                    J === 47 && te === 42 && ot + 2 !== he && (ge.charCodeAt(ot + 2) === 33 && (ue += ge.substring(ot, he + 1)), V = "", ce = 0);
                }
          }
          ce === 0 && (be += V);
      }
      Te = te, te = J, he++;
    }
    if (0 < (ot = ue.length)) {
      if (ye = ee, 0 < Ce && (ie = o(2, ue, ye, Ee, j, L, ot, ve, H, ve)) !== void 0 && (ue = ie).length === 0)
        return Fe + ue + Se;
      if (ue = ye.join(",") + "{" + ue + "}", q * P != 0) {
        switch (q !== 2 || s(ue, 2) || (P = 0), P) {
          case 111:
            ue = ue.replace(b, ":-moz-$1") + ue;
            break;
          case 112:
            ue = ue.replace(y, "::-webkit-input-$1") + ue.replace(y, "::-moz-$1") + ue.replace(y, ":-ms-input-$1") + ue;
        }
        P = 0;
      }
    }
    return Fe + ue + Se;
  }
  function e(Ee, ee, ge) {
    var ve = ee.trim().split(m);
    ee = ve;
    var H = ve.length, oe = Ee.length;
    switch (oe) {
      case 0:
      case 1:
        var J = 0;
        for (Ee = oe === 0 ? "" : Ee[0] + " "; J < H; ++J)
          ee[J] = r(Ee, ee[J], ge).trim();
        break;
      default:
        var Me = J = 0;
        for (ee = []; J < H; ++J)
          for (var V = 0; V < oe; ++V)
            ee[Me++] = r(Ee[V] + " ", ve[J], ge).trim();
    }
    return ee;
  }
  function r(Ee, ee, ge) {
    var ve = ee.charCodeAt(0);
    switch (33 > ve && (ve = (ee = ee.trim()).charCodeAt(0)), ve) {
      case 38:
        return ee.replace(v, "$1" + Ee.trim());
      case 58:
        return Ee.trim() + ee.replace(v, "$1" + Ee.trim());
      default:
        if (0 < 1 * ge && 0 < ee.indexOf("\f"))
          return ee.replace(v, (Ee.charCodeAt(0) === 58 ? "" : "$1") + Ee.trim());
    }
    return Ee + ee;
  }
  function i(Ee, ee, ge, ve) {
    var H = Ee + ";", oe = 2 * ee + 3 * ge + 4 * ve;
    if (oe === 944) {
      Ee = H.indexOf(":", 9) + 1;
      var J = H.substring(Ee, H.length - 1).trim();
      return J = H.substring(0, Ee).trim() + J + ";", q === 1 || q === 2 && s(J, 1) ? "-webkit-" + J + J : J;
    }
    if (q === 0 || q === 2 && !s(H, 1))
      return H;
    switch (oe) {
      case 1015:
        return H.charCodeAt(10) === 97 ? "-webkit-" + H + H : H;
      case 951:
        return H.charCodeAt(3) === 116 ? "-webkit-" + H + H : H;
      case 963:
        return H.charCodeAt(5) === 110 ? "-webkit-" + H + H : H;
      case 1009:
        if (H.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + H + H;
      case 978:
        return "-webkit-" + H + "-moz-" + H + H;
      case 1019:
      case 983:
        return "-webkit-" + H + "-moz-" + H + "-ms-" + H + H;
      case 883:
        if (H.charCodeAt(8) === 45)
          return "-webkit-" + H + H;
        if (0 < H.indexOf("image-set(", 11))
          return H.replace(R, "$1-webkit-$2") + H;
        break;
      case 932:
        if (H.charCodeAt(4) === 45)
          switch (H.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + H.replace("-grow", "") + "-webkit-" + H + "-ms-" + H.replace("grow", "positive") + H;
            case 115:
              return "-webkit-" + H + "-ms-" + H.replace("shrink", "negative") + H;
            case 98:
              return "-webkit-" + H + "-ms-" + H.replace("basis", "preferred-size") + H;
          }
        return "-webkit-" + H + "-ms-" + H + H;
      case 964:
        return "-webkit-" + H + "-ms-flex-" + H + H;
      case 1023:
        if (H.charCodeAt(8) !== 99)
          break;
        return "-webkit-box-pack" + (J = H.substring(H.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + H + "-ms-flex-pack" + J + H;
      case 1005:
        return p.test(H) ? H.replace(h, ":-webkit-") + H.replace(h, ":-moz-") + H : H;
      case 1e3:
        switch (ee = (J = H.substring(13).trim()).indexOf("-") + 1, J.charCodeAt(0) + J.charCodeAt(ee)) {
          case 226:
            J = H.replace(T, "tb");
            break;
          case 232:
            J = H.replace(T, "tb-rl");
            break;
          case 220:
            J = H.replace(T, "lr");
            break;
          default:
            return H;
        }
        return "-webkit-" + H + "-ms-" + J + H;
      case 1017:
        if (H.indexOf("sticky", 9) === -1)
          break;
      case 975:
        switch (ee = (H = Ee).length - 10, oe = (J = (H.charCodeAt(ee) === 33 ? H.substring(0, ee) : H).substring(Ee.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | J.charCodeAt(7))) {
          case 203:
            if (111 > J.charCodeAt(8))
              break;
          case 115:
            H = H.replace(J, "-webkit-" + J) + ";" + H;
            break;
          case 207:
          case 102:
            H = H.replace(J, "-webkit-" + (102 < oe ? "inline-" : "") + "box") + ";" + H.replace(J, "-webkit-" + J) + ";" + H.replace(J, "-ms-" + J + "box") + ";" + H;
        }
        return H + ";";
      case 938:
        if (H.charCodeAt(5) === 45)
          switch (H.charCodeAt(6)) {
            case 105:
              return J = H.replace("-items", ""), "-webkit-" + H + "-webkit-box-" + J + "-ms-flex-" + J + H;
            case 115:
              return "-webkit-" + H + "-ms-flex-item-" + H.replace(M, "") + H;
            default:
              return "-webkit-" + H + "-ms-flex-line-pack" + H.replace("align-content", "").replace(M, "") + H;
          }
        break;
      case 973:
      case 989:
        if (H.charCodeAt(3) !== 45 || H.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (x.test(Ee) === !0)
          return (J = Ee.substring(Ee.indexOf(":") + 1)).charCodeAt(0) === 115 ? i(Ee.replace("stretch", "fill-available"), ee, ge, ve).replace(":fill-available", ":stretch") : H.replace(J, "-webkit-" + J) + H.replace(J, "-moz-" + J.replace("fill-", "")) + H;
        break;
      case 962:
        if (H = "-webkit-" + H + (H.charCodeAt(5) === 102 ? "-ms-" + H : "") + H, ge + ve === 211 && H.charCodeAt(13) === 105 && 0 < H.indexOf("transform", 10))
          return H.substring(0, H.indexOf(";", 27) + 1).replace(f, "$1-webkit-$2") + H;
    }
    return H;
  }
  function s(Ee, ee) {
    var ge = Ee.indexOf(ee === 1 ? ":" : "{"), ve = Ee.substring(0, ee !== 3 ? ge : 10);
    return ge = Ee.substring(ge + 1, Ee.length - 1), Be(ee !== 2 ? ve : ve.replace(I, "$1"), ge, ee);
  }
  function a(Ee, ee) {
    var ge = i(ee, ee.charCodeAt(0), ee.charCodeAt(1), ee.charCodeAt(2));
    return ge !== ee + ";" ? ge.replace(N, " or ($1)").substring(4) : "(" + ee + ")";
  }
  function o(Ee, ee, ge, ve, H, oe, J, Me, V, ie) {
    for (var ae, ce = 0, le = ee; ce < Ce; ++ce)
      switch (ae = X[ce].call(c, Ee, le, ge, ve, H, oe, J, Me, V, ie)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          le = ae;
      }
    if (le !== ee)
      return le;
  }
  function l(Ee) {
    return (Ee = Ee.prefix) !== void 0 && (Be = null, Ee ? typeof Ee != "function" ? q = 1 : (q = 2, Be = Ee) : q = 0), l;
  }
  function c(Ee, ee) {
    var ge = Ee;
    if (33 > ge.charCodeAt(0) && (ge = ge.trim()), ge = [ge], 0 < Ce) {
      var ve = o(-1, ee, ge, ge, j, L, 0, 0, 0, 0);
      ve !== void 0 && typeof ve == "string" && (ee = ve);
    }
    var H = n(G, ge, ee, 0, 0);
    return 0 < Ce && (ve = o(-2, H, ge, ge, j, L, H.length, 0, 0, 0)) !== void 0 && (H = ve), P = 0, L = j = 1, H;
  }
  var u = /^\0+/g, d = /[\0\r\f]/g, h = /: */g, p = /zoo|gra/, f = /([,: ])(transform)/g, m = /,\r+?/g, v = /([\t\r\n ])*\f?&/g, E = /@(k\w+)\s*(\S*)\s*/, y = /::(place)/g, b = /:(read-only)/g, T = /[svh]\w+-[tblr]{2}/, w = /\(\s*(.*)\s*\)/g, N = /([\s\S]*?);/g, M = /-self|flex-/g, I = /[^]*?(:[rp][el]a[\w-]+)[^]*/, x = /stretch|:\s*\w+\-(?:conte|avail)/, R = /([^-])(image-set\()/, L = 1, j = 1, P = 0, q = 1, G = [], X = [], Ce = 0, Be = null, se = 0;
  return c.use = function Ee(ee) {
    switch (ee) {
      case void 0:
      case null:
        Ce = X.length = 0;
        break;
      default:
        if (typeof ee == "function")
          X[Ce++] = ee;
        else if (typeof ee == "object")
          for (var ge = 0, ve = ee.length; ge < ve; ++ge)
            Ee(ee[ge]);
        else
          se = 0 | !!ee;
    }
    return Ee;
  }, c.set = l, t !== void 0 && l(t), c;
}
var iv = { animationIterationCount: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, boxFlex: 1, boxFlexGroup: 1, boxOrdinalGroup: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexPositive: 1, flexShrink: 1, flexNegative: 1, flexOrder: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, msGridRow: 1, msGridRowSpan: 1, msGridColumn: 1, msGridColumnSpan: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 };
function sv(t) {
  var n = /* @__PURE__ */ Object.create(null);
  return function(e) {
    return n[e] === void 0 && (n[e] = t(e)), n[e];
  };
}
var av = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, eo = sv(function(t) {
  return av.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
}), Fu = _c, ov = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, lv = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, z0 = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, ju = {};
function Oh(t) {
  return Fu.isMemo(t) ? z0 : ju[t.$$typeof] || ov;
}
ju[Fu.ForwardRef] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, ju[Fu.Memo] = z0;
var cv = Object.defineProperty, uv = Object.getOwnPropertyNames, Rh = Object.getOwnPropertySymbols, dv = Object.getOwnPropertyDescriptor, hv = Object.getPrototypeOf, Dh = Object.prototype, pv = function t(n, e, r) {
  if (typeof e != "string") {
    if (Dh) {
      var i = hv(e);
      i && i !== Dh && t(n, i, r);
    }
    var s = uv(e);
    Rh && (s = s.concat(Rh(e)));
    for (var a = Oh(n), o = Oh(e), l = 0; l < s.length; ++l) {
      var c = s[l];
      if (!(lv[c] || r && r[c] || o && o[c] || a && a[c])) {
        var u = dv(e, c);
        try {
          cv(n, c, u);
        } catch {
        }
      }
    }
  }
  return n;
};
const fv = B0(pv);
function ui() {
  return (ui = Object.assign || function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }
    return t;
  }).apply(this, arguments);
}
var Lh = function(t, n) {
  for (var e = [t[0]], r = 0, i = n.length; r < i; r += 1)
    e.push(n[r], t[r + 1]);
  return e;
}, Hu = function(t) {
  return t !== null && typeof t == "object" && (t.toString ? t.toString() : Object.prototype.toString.call(t)) === "[object Object]" && !_c.typeOf(t);
}, Pl = Object.freeze([]), Xi = Object.freeze({});
function ca(t) {
  return typeof t == "function";
}
function Bu(t) {
  return process.env.NODE_ENV !== "production" && typeof t == "string" && t || t.displayName || t.name || "Component";
}
function Ld(t) {
  return t && typeof t.styledComponentId == "string";
}
var ua = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", Ud = typeof window < "u" && "HTMLElement" in window, mv = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production")), _v = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
` } : {};
function gv() {
  for (var t = arguments.length <= 0 ? void 0 : arguments[0], n = [], e = 1, r = arguments.length; e < r; e += 1)
    n.push(e < 0 || arguments.length <= e ? void 0 : arguments[e]);
  return n.forEach(function(i) {
    t = t.replace(/%[a-z]/, i);
  }), t;
}
function Ri(t) {
  for (var n = arguments.length, e = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    e[r - 1] = arguments[r];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + t + " for more information." + (e.length > 0 ? " Args: " + e.join(", ") : "")) : new Error(gv.apply(void 0, [_v[t]].concat(e)).trim());
}
var vv = function() {
  function t(e) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
  }
  var n = t.prototype;
  return n.indexOfGroup = function(e) {
    for (var r = 0, i = 0; i < e; i++)
      r += this.groupSizes[i];
    return r;
  }, n.insertRules = function(e, r) {
    if (e >= this.groupSizes.length) {
      for (var i = this.groupSizes, s = i.length, a = s; e >= a; )
        (a <<= 1) < 0 && Ri(16, "" + e);
      this.groupSizes = new Uint32Array(a), this.groupSizes.set(i), this.length = a;
      for (var o = s; o < a; o++)
        this.groupSizes[o] = 0;
    }
    for (var l = this.indexOfGroup(e + 1), c = 0, u = r.length; c < u; c++)
      this.tag.insertRule(l, r[c]) && (this.groupSizes[e]++, l++);
  }, n.clearGroup = function(e) {
    if (e < this.length) {
      var r = this.groupSizes[e], i = this.indexOfGroup(e), s = i + r;
      this.groupSizes[e] = 0;
      for (var a = i; a < s; a++)
        this.tag.deleteRule(i);
    }
  }, n.getGroup = function(e) {
    var r = "";
    if (e >= this.length || this.groupSizes[e] === 0)
      return r;
    for (var i = this.groupSizes[e], s = this.indexOfGroup(e), a = s + i, o = s; o < a; o++)
      r += this.tag.getRule(o) + `/*!sc*/
`;
    return r;
  }, t;
}(), El = /* @__PURE__ */ new Map(), Fl = /* @__PURE__ */ new Map(), to = 1, Ko = function(t) {
  if (El.has(t))
    return El.get(t);
  for (; Fl.has(to); )
    to++;
  var n = to++;
  return process.env.NODE_ENV !== "production" && ((0 | n) < 0 || n > 1 << 30) && Ri(16, "" + n), El.set(t, n), Fl.set(n, t), n;
}, yv = function(t) {
  return Fl.get(t);
}, bv = function(t, n) {
  n >= to && (to = n + 1), El.set(t, n), Fl.set(n, t);
}, Ev = "style[" + ua + '][data-styled-version="5.3.11"]', Cv = new RegExp("^" + ua + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), Tv = function(t, n, e) {
  for (var r, i = e.split(","), s = 0, a = i.length; s < a; s++)
    (r = i[s]) && t.registerName(n, r);
}, wv = function(t, n) {
  for (var e = (n.textContent || "").split(`/*!sc*/
`), r = [], i = 0, s = e.length; i < s; i++) {
    var a = e[i].trim();
    if (a) {
      var o = a.match(Cv);
      if (o) {
        var l = 0 | parseInt(o[1], 10), c = o[2];
        l !== 0 && (bv(c, l), Tv(t, c, o[3]), t.getTag().insertRules(l, r)), r.length = 0;
      } else
        r.push(a);
    }
  }
}, V0 = function(t) {
  var n = document.head, e = t || n, r = document.createElement("style"), i = function(o) {
    for (var l = o.childNodes, c = l.length; c >= 0; c--) {
      var u = l[c];
      if (u && u.nodeType === 1 && u.hasAttribute(ua))
        return u;
    }
  }(e), s = i !== void 0 ? i.nextSibling : null;
  r.setAttribute(ua, "active"), r.setAttribute("data-styled-version", "5.3.11");
  var a = typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
  return a && r.setAttribute("nonce", a), e.insertBefore(r, s), r;
}, Sv = function() {
  function t(e) {
    var r = this.element = V0(e);
    r.appendChild(document.createTextNode("")), this.sheet = function(i) {
      if (i.sheet)
        return i.sheet;
      for (var s = document.styleSheets, a = 0, o = s.length; a < o; a++) {
        var l = s[a];
        if (l.ownerNode === i)
          return l;
      }
      Ri(17);
    }(r), this.length = 0;
  }
  var n = t.prototype;
  return n.insertRule = function(e, r) {
    try {
      return this.sheet.insertRule(r, e), this.length++, !0;
    } catch {
      return !1;
    }
  }, n.deleteRule = function(e) {
    this.sheet.deleteRule(e), this.length--;
  }, n.getRule = function(e) {
    var r = this.sheet.cssRules[e];
    return r !== void 0 && typeof r.cssText == "string" ? r.cssText : "";
  }, t;
}(), Nv = function() {
  function t(e) {
    var r = this.element = V0(e);
    this.nodes = r.childNodes, this.length = 0;
  }
  var n = t.prototype;
  return n.insertRule = function(e, r) {
    if (e <= this.length && e >= 0) {
      var i = document.createTextNode(r), s = this.nodes[e];
      return this.element.insertBefore(i, s || null), this.length++, !0;
    }
    return !1;
  }, n.deleteRule = function(e) {
    this.element.removeChild(this.nodes[e]), this.length--;
  }, n.getRule = function(e) {
    return e < this.length ? this.nodes[e].textContent : "";
  }, t;
}(), Iv = function() {
  function t(e) {
    this.rules = [], this.length = 0;
  }
  var n = t.prototype;
  return n.insertRule = function(e, r) {
    return e <= this.length && (this.rules.splice(e, 0, r), this.length++, !0);
  }, n.deleteRule = function(e) {
    this.rules.splice(e, 1), this.length--;
  }, n.getRule = function(e) {
    return e < this.length ? this.rules[e] : "";
  }, t;
}(), Uh = Ud, Av = { isServer: !Ud, useCSSOMInjection: !mv }, G0 = function() {
  function t(e, r, i) {
    e === void 0 && (e = Xi), r === void 0 && (r = {}), this.options = ui({}, Av, {}, e), this.gs = r, this.names = new Map(i), this.server = !!e.isServer, !this.server && Ud && Uh && (Uh = !1, function(s) {
      for (var a = document.querySelectorAll(Ev), o = 0, l = a.length; o < l; o++) {
        var c = a[o];
        c && c.getAttribute(ua) !== "active" && (wv(s, c), c.parentNode && c.parentNode.removeChild(c));
      }
    }(this));
  }
  t.registerId = function(e) {
    return Ko(e);
  };
  var n = t.prototype;
  return n.reconstructWithOptions = function(e, r) {
    return r === void 0 && (r = !0), new t(ui({}, this.options, {}, e), this.gs, r && this.names || void 0);
  }, n.allocateGSInstance = function(e) {
    return this.gs[e] = (this.gs[e] || 0) + 1;
  }, n.getTag = function() {
    return this.tag || (this.tag = (i = (r = this.options).isServer, s = r.useCSSOMInjection, a = r.target, e = i ? new Iv(a) : s ? new Sv(a) : new Nv(a), new vv(e)));
    var e, r, i, s, a;
  }, n.hasNameForId = function(e, r) {
    return this.names.has(e) && this.names.get(e).has(r);
  }, n.registerName = function(e, r) {
    if (Ko(e), this.names.has(e))
      this.names.get(e).add(r);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(r), this.names.set(e, i);
    }
  }, n.insertRules = function(e, r, i) {
    this.registerName(e, r), this.getTag().insertRules(Ko(e), i);
  }, n.clearNames = function(e) {
    this.names.has(e) && this.names.get(e).clear();
  }, n.clearRules = function(e) {
    this.getTag().clearGroup(Ko(e)), this.clearNames(e);
  }, n.clearTag = function() {
    this.tag = void 0;
  }, n.toString = function() {
    return function(e) {
      for (var r = e.getTag(), i = r.length, s = "", a = 0; a < i; a++) {
        var o = yv(a);
        if (o !== void 0) {
          var l = e.names.get(o), c = r.getGroup(a);
          if (l && c && l.size) {
            var u = ua + ".g" + a + '[id="' + o + '"]', d = "";
            l !== void 0 && l.forEach(function(h) {
              h.length > 0 && (d += h + ",");
            }), s += "" + c + u + '{content:"' + d + `"}/*!sc*/
`;
          }
        }
      }
      return s;
    }(this);
  }, t;
}(), Mv = /(a)(d)/gi, Ph = function(t) {
  return String.fromCharCode(t + (t > 25 ? 39 : 97));
};
function zu(t) {
  var n, e = "";
  for (n = Math.abs(t); n > 52; n = n / 52 | 0)
    e = Ph(n % 52) + e;
  return (Ph(n % 52) + e).replace(Mv, "$1-$2");
}
var Ts = function(t, n) {
  for (var e = n.length; e; )
    t = 33 * t ^ n.charCodeAt(--e);
  return t;
}, q0 = function(t) {
  return Ts(5381, t);
}, xv = q0("5.3.11"), kv = function() {
  function t(n, e, r) {
    this.rules = n, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (r === void 0 || r.isStatic) && function(i) {
      for (var s = 0; s < i.length; s += 1) {
        var a = i[s];
        if (ca(a) && !Ld(a))
          return !1;
      }
      return !0;
    }(n), this.componentId = e, this.baseHash = Ts(xv, e), this.baseStyle = r, G0.registerId(e);
  }
  return t.prototype.generateAndInjectStyles = function(n, e, r) {
    var i = this.componentId, s = [];
    if (this.baseStyle && s.push(this.baseStyle.generateAndInjectStyles(n, e, r)), this.isStatic && !r.hash)
      if (this.staticRulesId && e.hasNameForId(i, this.staticRulesId))
        s.push(this.staticRulesId);
      else {
        var a = da(this.rules, n, e, r).join(""), o = zu(Ts(this.baseHash, a) >>> 0);
        if (!e.hasNameForId(i, o)) {
          var l = r(a, "." + o, void 0, i);
          e.insertRules(i, o, l);
        }
        s.push(o), this.staticRulesId = o;
      }
    else {
      for (var c = this.rules.length, u = Ts(this.baseHash, r.hash), d = "", h = 0; h < c; h++) {
        var p = this.rules[h];
        if (typeof p == "string")
          d += p, process.env.NODE_ENV !== "production" && (u = Ts(u, p + h));
        else if (p) {
          var f = da(p, n, e, r), m = Array.isArray(f) ? f.join("") : f;
          u = Ts(u, m + h), d += m;
        }
      }
      if (d) {
        var v = zu(u >>> 0);
        if (!e.hasNameForId(i, v)) {
          var E = r(d, "." + v, void 0, i);
          e.insertRules(i, v, E);
        }
        s.push(v);
      }
    }
    return s.join(" ");
  }, t;
}(), Ov = /^\s*\/\/.*$/gm, Rv = [":", "[", ".", "#"];
function K0(t) {
  var n, e, r, i, s = t === void 0 ? Xi : t, a = s.options, o = a === void 0 ? Xi : a, l = s.plugins, c = l === void 0 ? Pl : l, u = new rv(o), d = [], h = /* @__PURE__ */ function(m) {
    function v(E) {
      if (E)
        try {
          m(E + "}");
        } catch {
        }
    }
    return function(E, y, b, T, w, N, M, I, x, R) {
      switch (E) {
        case 1:
          if (x === 0 && y.charCodeAt(0) === 64)
            return m(y + ";"), "";
          break;
        case 2:
          if (I === 0)
            return y + "/*|*/";
          break;
        case 3:
          switch (I) {
            case 102:
            case 112:
              return m(b[0] + y), "";
            default:
              return y + (R === 0 ? "/*|*/" : "");
          }
        case -2:
          y.split("/*|*/}").forEach(v);
      }
    };
  }(function(m) {
    d.push(m);
  }), p = function(m, v, E) {
    return v === 0 && Rv.indexOf(E[e.length]) !== -1 || E.match(i) ? m : "." + n;
  };
  function f(m, v, E, y) {
    y === void 0 && (y = "&");
    var b = m.replace(Ov, ""), T = v && E ? E + " " + v + " { " + b + " }" : b;
    return n = y, e = v, r = new RegExp("\\" + e + "\\b", "g"), i = new RegExp("(\\" + e + "\\b){2,}"), u(E || !v ? "" : v, T);
  }
  return u.use([].concat(c, [function(m, v, E) {
    m === 2 && E.length && E[0].lastIndexOf(e) > 0 && (E[0] = E[0].replace(r, p));
  }, h, function(m) {
    if (m === -2) {
      var v = d;
      return d = [], v;
    }
  }])), f.hash = c.length ? c.reduce(function(m, v) {
    return v.name || Ri(15), Ts(m, v.name);
  }, 5381).toString() : "", f;
}
var Pd = Ot.createContext();
Pd.Consumer;
var Fd = Ot.createContext(), Dv = (Fd.Consumer, new G0()), Vu = K0();
function W0() {
  return Mn(Pd) || Dv;
}
function Lv(t) {
  var n = Ye(t.stylisPlugins), e = n[0], r = n[1], i = W0(), s = sr(function() {
    var o = i;
    return t.sheet ? o = t.sheet : t.target && (o = o.reconstructWithOptions({ target: t.target }, !1)), t.disableCSSOMInjection && (o = o.reconstructWithOptions({ useCSSOMInjection: !1 })), o;
  }, [t.disableCSSOMInjection, t.sheet, t.target]), a = sr(function() {
    return K0({ options: { prefix: !t.disableVendorPrefixes }, plugins: e });
  }, [t.disableVendorPrefixes, e]);
  return Tt(function() {
    nv(e, t.stylisPlugins) || r(t.stylisPlugins);
  }, [t.stylisPlugins]), Ot.createElement(Pd.Provider, { value: s }, Ot.createElement(Fd.Provider, { value: a }, process.env.NODE_ENV !== "production" ? Ot.Children.only(t.children) : t.children));
}
var Uv = function() {
  function t(n, e) {
    var r = this;
    this.inject = function(i, s) {
      s === void 0 && (s = Vu);
      var a = r.name + s.hash;
      i.hasNameForId(r.id, a) || i.insertRules(r.id, a, s(r.rules, a, "@keyframes"));
    }, this.toString = function() {
      return Ri(12, String(r.name));
    }, this.name = n, this.id = "sc-keyframes-" + n, this.rules = e;
  }
  return t.prototype.getName = function(n) {
    return n === void 0 && (n = Vu), this.name + n.hash;
  }, t;
}(), Pv = /([A-Z])/, Fv = /([A-Z])/g, jv = /^ms-/, Hv = function(t) {
  return "-" + t.toLowerCase();
};
function Fh(t) {
  return Pv.test(t) ? t.replace(Fv, Hv).replace(jv, "-ms-") : t;
}
var jh = function(t) {
  return t == null || t === !1 || t === "";
};
function da(t, n, e, r) {
  if (Array.isArray(t)) {
    for (var i, s = [], a = 0, o = t.length; a < o; a += 1)
      (i = da(t[a], n, e, r)) !== "" && (Array.isArray(i) ? s.push.apply(s, i) : s.push(i));
    return s;
  }
  if (jh(t))
    return "";
  if (Ld(t))
    return "." + t.styledComponentId;
  if (ca(t)) {
    if (typeof (c = t) != "function" || c.prototype && c.prototype.isReactComponent || !n)
      return t;
    var l = t(n);
    return process.env.NODE_ENV !== "production" && _c.isElement(l) && console.warn(Bu(t) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), da(l, n, e, r);
  }
  var c;
  return t instanceof Uv ? e ? (t.inject(e, r), t.getName(r)) : t : Hu(t) ? function u(d, h) {
    var p, f, m = [];
    for (var v in d)
      d.hasOwnProperty(v) && !jh(d[v]) && (Array.isArray(d[v]) && d[v].isCss || ca(d[v]) ? m.push(Fh(v) + ":", d[v], ";") : Hu(d[v]) ? m.push.apply(m, u(d[v], v)) : m.push(Fh(v) + ": " + (p = v, ((f = d[v]) == null || typeof f == "boolean" || f === "" ? "" : typeof f != "number" || f === 0 || p in iv || p.startsWith("--") ? String(f).trim() : f + "px") + ";")));
    return h ? [h + " {"].concat(m, ["}"]) : m;
  }(t) : t.toString();
}
var Hh = function(t) {
  return Array.isArray(t) && (t.isCss = !0), t;
};
function jl(t) {
  for (var n = arguments.length, e = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    e[r - 1] = arguments[r];
  return ca(t) || Hu(t) ? Hh(da(Lh(Pl, [t].concat(e)))) : e.length === 0 && t.length === 1 && typeof t[0] == "string" ? t : Hh(da(Lh(t, e)));
}
var Bh = /invalid hook call/i, Wo = /* @__PURE__ */ new Set(), Bv = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, zv = /(^-|-$)/g;
function Vc(t) {
  return t.replace(Bv, "-").replace(zv, "");
}
function Qo(t) {
  return typeof t == "string" && (process.env.NODE_ENV === "production" || t.charAt(0) === t.charAt(0).toLowerCase());
}
var Gu = function(t) {
  return typeof t == "function" || typeof t == "object" && t !== null && !Array.isArray(t);
}, Vv = function(t) {
  return t !== "__proto__" && t !== "constructor" && t !== "prototype";
};
function Gv(t, n, e) {
  var r = t[e];
  Gu(n) && Gu(r) ? Q0(r, n) : t[e] = n;
}
function Q0(t) {
  for (var n = arguments.length, e = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    e[r - 1] = arguments[r];
  for (var i = 0, s = e; i < s.length; i++) {
    var a = s[i];
    if (Gu(a))
      for (var o in a)
        Vv(o) && Gv(t, a[o], o);
  }
  return t;
}
var Co = Ot.createContext();
function qv(t) {
  var n = Mn(Co), e = sr(function() {
    return function(r, i) {
      if (!r)
        return Ri(14);
      if (ca(r)) {
        var s = r(i);
        return process.env.NODE_ENV === "production" || s !== null && !Array.isArray(s) && typeof s == "object" ? s : Ri(7);
      }
      return Array.isArray(r) || typeof r != "object" ? Ri(8) : i ? ui({}, i, {}, r) : r;
    }(t.theme, n);
  }, [t.theme, n]);
  return t.children ? Ot.createElement(Co.Provider, { value: e }, t.children) : null;
}
Co.Consumer;
var Gc = {};
function Y0(t, n, e) {
  var r = Ld(t), i = !Qo(t), s = n.attrs, a = s === void 0 ? Pl : s, o = n.componentId, l = o === void 0 ? function(y, b) {
    var T = typeof y != "string" ? "sc" : Vc(y);
    Gc[T] = (Gc[T] || 0) + 1;
    var w = T + "-" + function(N) {
      return zu(q0(N) >>> 0);
    }("5.3.11" + T + Gc[T]);
    return b ? b + "-" + w : w;
  }(n.displayName, n.parentComponentId) : o, c = n.displayName, u = c === void 0 ? function(y) {
    return Qo(y) ? "styled." + y : "Styled(" + Bu(y) + ")";
  }(t) : c, d = n.displayName && n.componentId ? Vc(n.displayName) + "-" + n.componentId : n.componentId || l, h = r && t.attrs ? Array.prototype.concat(t.attrs, a).filter(Boolean) : a, p = n.shouldForwardProp;
  r && t.shouldForwardProp && (p = n.shouldForwardProp ? function(y, b, T) {
    return t.shouldForwardProp(y, b, T) && n.shouldForwardProp(y, b, T);
  } : t.shouldForwardProp);
  var f, m = new kv(e, d, r ? t.componentStyle : void 0), v = m.isStatic && a.length === 0, E = function(y, b) {
    return function(T, w, N, M) {
      var I = T.attrs, x = T.componentStyle, R = T.defaultProps, L = T.foldedComponentIds, j = T.shouldForwardProp, P = T.styledComponentId, q = T.target, G = function(oe, J, Me) {
        oe === void 0 && (oe = Xi);
        var V = ui({}, J, { theme: oe }), ie = {};
        return Me.forEach(function(ae) {
          var ce, le, re, te = ae;
          for (ce in ca(te) && (te = te(V)), te)
            V[ce] = ie[ce] = ce === "className" ? (le = ie[ce], re = te[ce], le && re ? le + " " + re : le || re) : te[ce];
        }), [V, ie];
      }(function(oe, J, Me) {
        return Me === void 0 && (Me = Xi), oe.theme !== Me.theme && oe.theme || J || Me.theme;
      }(w, Mn(Co), R) || Xi, w, I), X = G[0], Ce = G[1], Be = function(oe, J, Me, V) {
        var ie = W0(), ae = Mn(Fd) || Vu, ce = J ? oe.generateAndInjectStyles(Xi, ie, ae) : oe.generateAndInjectStyles(Me, ie, ae);
        return process.env.NODE_ENV !== "production" && !J && V && V(ce), ce;
      }(x, M, X, process.env.NODE_ENV !== "production" ? T.warnTooManyClasses : void 0), se = N, Ee = Ce.$as || w.$as || Ce.as || w.as || q, ee = Qo(Ee), ge = Ce !== w ? ui({}, w, {}, Ce) : w, ve = {};
      for (var H in ge)
        H[0] !== "$" && H !== "as" && (H === "forwardedAs" ? ve.as = ge[H] : (j ? j(H, eo, Ee) : !ee || eo(H)) && (ve[H] = ge[H]));
      return w.style && Ce.style !== w.style && (ve.style = ui({}, w.style, {}, Ce.style)), ve.className = Array.prototype.concat(L, P, Be !== P ? Be : null, w.className, Ce.className).filter(Boolean).join(" "), ve.ref = se, ev(Ee, ve);
    }(f, y, b, v);
  };
  return E.displayName = u, (f = Ot.forwardRef(E)).attrs = h, f.componentStyle = m, f.displayName = u, f.shouldForwardProp = p, f.foldedComponentIds = r ? Array.prototype.concat(t.foldedComponentIds, t.styledComponentId) : Pl, f.styledComponentId = d, f.target = r ? t.target : t, f.withComponent = function(y) {
    var b = n.componentId, T = function(N, M) {
      if (N == null)
        return {};
      var I, x, R = {}, L = Object.keys(N);
      for (x = 0; x < L.length; x++)
        I = L[x], M.indexOf(I) >= 0 || (R[I] = N[I]);
      return R;
    }(n, ["componentId"]), w = b && b + "-" + (Qo(y) ? y : Vc(Bu(y)));
    return Y0(y, ui({}, T, { attrs: h, componentId: w }), e);
  }, Object.defineProperty(f, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(y) {
    this._foldedDefaultProps = r ? Q0({}, t.defaultProps, y) : y;
  } }), process.env.NODE_ENV !== "production" && (function(y, b) {
    if (process.env.NODE_ENV !== "production") {
      var T = "The component " + y + (b ? ' with the id of "' + b + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, w = console.error;
      try {
        var N = !0;
        console.error = function(M) {
          if (Bh.test(M))
            N = !1, Wo.delete(T);
          else {
            for (var I = arguments.length, x = new Array(I > 1 ? I - 1 : 0), R = 1; R < I; R++)
              x[R - 1] = arguments[R];
            w.apply(void 0, [M].concat(x));
          }
        }, Mt(), N && !Wo.has(T) && (console.warn(T), Wo.add(T));
      } catch (M) {
        Bh.test(M.message) && Wo.delete(T);
      } finally {
        console.error = w;
      }
    }
  }(u, d), f.warnTooManyClasses = /* @__PURE__ */ function(y, b) {
    var T = {}, w = !1;
    return function(N) {
      if (!w && (T[N] = !0, Object.keys(T).length >= 200)) {
        var M = b ? ' with the id of "' + b + '"' : "";
        console.warn("Over 200 classes were generated for component " + y + M + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), w = !0, T = {};
      }
    };
  }(u, d)), Object.defineProperty(f, "toString", { value: function() {
    return "." + f.styledComponentId;
  } }), i && fv(f, t, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), f;
}
var qu = function(t) {
  return function n(e, r, i) {
    if (i === void 0 && (i = Xi), !_c.isValidElementType(r))
      return Ri(1, String(r));
    var s = function() {
      return e(r, i, jl.apply(void 0, arguments));
    };
    return s.withConfig = function(a) {
      return n(e, r, ui({}, i, {}, a));
    }, s.attrs = function(a) {
      return n(e, r, ui({}, i, { attrs: Array.prototype.concat(i.attrs, a).filter(Boolean) }));
    }, s;
  }(Y0, t);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(t) {
  qu[t] = qu(t);
});
var Ro = function() {
  return Mn(Co);
};
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const Ie = qu;
var Ku = function(t, n) {
  return Ku = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, r) {
    e.__proto__ = r;
  } || function(e, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
  }, Ku(t, n);
};
function S(t, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
  function e() {
    this.constructor = t;
  }
  Ku(t, n), t.prototype = n === null ? Object.create(n) : (e.prototype = n.prototype, new e());
}
var A = function() {
  return A = Object.assign || function(t) {
    for (var n, e = 1, r = arguments.length; e < r; e++)
      for (var i in n = arguments[e])
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    return t;
  }, A.apply(this, arguments);
};
function g(t, n, e, r) {
  return new (e || (e = Promise))(function(i, s) {
    function a(c) {
      try {
        l(r.next(c));
      } catch (u) {
        s(u);
      }
    }
    function o(c) {
      try {
        l(r.throw(c));
      } catch (u) {
        s(u);
      }
    }
    function l(c) {
      var u;
      c.done ? i(c.value) : (u = c.value, u instanceof e ? u : new e(function(d) {
        d(u);
      })).then(a, o);
    }
    l((r = r.apply(t, [])).next());
  });
}
function _(t, n) {
  var e, r, i, s = { label: 0, sent: function() {
    if (1 & i[0])
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = o(0), a.throw = o(1), a.return = o(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function o(l) {
    return function(c) {
      return function(u) {
        if (e)
          throw new TypeError("Generator is already executing.");
        for (; a && (a = 0, u[0] && (s = 0)), s; )
          try {
            if (e = 1, r && (i = 2 & u[0] ? r.return : u[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, u[1])).done)
              return i;
            switch (r = 0, i && (u = [2 & u[0], i.value]), u[0]) {
              case 0:
              case 1:
                i = u;
                break;
              case 4:
                return s.label++, { value: u[1], done: !1 };
              case 5:
                s.label++, r = u[1], u = [0];
                continue;
              case 7:
                u = s.ops.pop(), s.trys.pop();
                continue;
              default:
                if (!((i = (i = s.trys).length > 0 && i[i.length - 1]) || u[0] !== 6 && u[0] !== 2)) {
                  s = 0;
                  continue;
                }
                if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
                  s.label = u[1];
                  break;
                }
                if (u[0] === 6 && s.label < i[1]) {
                  s.label = i[1], i = u;
                  break;
                }
                if (i && s.label < i[2]) {
                  s.label = i[2], s.ops.push(u);
                  break;
                }
                i[2] && s.ops.pop(), s.trys.pop();
                continue;
            }
            u = n.call(t, s);
          } catch (d) {
            u = [6, d], r = 0;
          } finally {
            e = i = 0;
          }
        if (5 & u[0])
          throw u[1];
        return { value: u[0] ? u[1] : void 0, done: !0 };
      }([l, c]);
    };
  }
}
function de(t) {
  var n = typeof Symbol == "function" && Symbol.iterator, e = n && t[n], r = 0;
  if (e)
    return e.call(t);
  if (t && typeof t.length == "number")
    return { next: function() {
      return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
    } };
  throw new TypeError(n ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function we(t, n) {
  var e = typeof Symbol == "function" && t[Symbol.iterator];
  if (!e)
    return t;
  var r, i, s = e.call(t), a = [];
  try {
    for (; (n === void 0 || n-- > 0) && !(r = s.next()).done; )
      a.push(r.value);
  } catch (o) {
    i = { error: o };
  } finally {
    try {
      r && !r.done && (e = s.return) && e.call(s);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return a;
}
function Re(t, n, e) {
  if (arguments.length === 2)
    for (var r, i = 0, s = n.length; i < s; i++)
      !r && i in n || (r || (r = Array.prototype.slice.call(n, 0, i)), r[i] = n[i]);
  return t.concat(r || Array.prototype.slice.call(n));
}
var me, $0 = "4.14.5", ts = function() {
  function t() {
  }
  return Object.defineProperty(t, "OS_VERSION", { get: function() {
    return typeof navigator < "u" && navigator.userAgent ? navigator.userAgent.replace(/,/g, ".") : "noAgent";
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t, "SDK_VERSION", { get: function() {
    return $0;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t, "SDK_MAJOR_VERSION", { get: function() {
    return t.SDK_VERSION.split(".")[0];
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t, "DEFAULT_MAX_UNREAD_COUNT_OF_SUPER_GROUP_CHANNEL", { get: function() {
    return 100;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t, "INTERNAL_CALL", { get: function() {
    return "ic";
  }, enumerable: !1, configurable: !0 }), t;
}();
(function(t) {
  t[t.NON_AUTHORIZED = 400108] = "NON_AUTHORIZED", t[t.INVALID_TOKEN = 400111] = "INVALID_TOKEN", t[t.NOT_FOUND_IN_DATABASE = 400201] = "NOT_FOUND_IN_DATABASE", t[t.USER_AUTH_DEACTIVATED = 400300] = "USER_AUTH_DEACTIVATED", t[t.USER_AUTH_DELETED_OR_NOT_FOUND = 400301] = "USER_AUTH_DELETED_OR_NOT_FOUND", t[t.SESSION_TOKEN_EXPIRED = 400302] = "SESSION_TOKEN_EXPIRED", t[t.APPLICATION_NOT_FOUND = 400304] = "APPLICATION_NOT_FOUND", t[t.SESSION_KEY_EXPIRED = 400309] = "SESSION_KEY_EXPIRED", t[t.SESSION_REVOKED = 400310] = "SESSION_REVOKED", t[t.INVALID_SESSION_TYPE = 400312] = "INVALID_SESSION_TYPE", t[t.INVALID_AUTH_FOR_SERVICE = 400313] = "INVALID_AUTH_FOR_SERVICE", t[t.STAT_UPLOAD_NOT_ALLOWED = 403200] = "STAT_UPLOAD_NOT_ALLOWED", t[t.NOT_SUPPORTED_PINNED_MESSAGE_IN_REVIEW_MESSAGE = 400940] = "NOT_SUPPORTED_PINNED_MESSAGE_IN_REVIEW_MESSAGE", t[t.INTERNAL_SERVER_ERROR = 500901] = "INTERNAL_SERVER_ERROR", t[t.RATE_LIMIT_EXCEEDED = 500910] = "RATE_LIMIT_EXCEEDED", t[t.INVALID_REQUIRED_FORM_VALUE = 400105] = "INVALID_REQUIRED_FORM_VALUE", t[t.UNKNOWN_SERVER_ERROR = 900200] = "UNKNOWN_SERVER_ERROR", t[t.NOT_SUPPORTED_FEATURE_IN_IN_REVIEW_MESSAGE = 901500] = "NOT_SUPPORTED_FEATURE_IN_IN_REVIEW_MESSAGE", t[t.ERR_DUPLICATED_DATA = 400202] = "ERR_DUPLICATED_DATA", t[t.DEBUG_MODE_REQUIRED = 7e5] = "DEBUG_MODE_REQUIRED", t[t.LOST_INSTANCE = 700100] = "LOST_INSTANCE", t[t.CONNECTION_RENEW = 700102] = "CONNECTION_RENEW", t[t.INVALID_CONNECTION_STATE_TRANSITION = 700200] = "INVALID_CONNECTION_STATE_TRANSITION", t[t.INVALID_COMMAND = 700700] = "INVALID_COMMAND", t[t.XMLHTTPREQUEST_NOT_SUPPORTED = 700800] = "XMLHTTPREQUEST_NOT_SUPPORTED", t[t.UNKNOWN_ERROR = 77e4] = "UNKNOWN_ERROR", t[t.INVALID_INITIALIZATION = 800100] = "INVALID_INITIALIZATION", t[t.CONNECTION_REQUIRED = 800101] = "CONNECTION_REQUIRED", t[t.CONNECTION_CANCELED = 800102] = "CONNECTION_CANCELED", t[t.INVALID_PARAMETER = 800110] = "INVALID_PARAMETER", t[t.NOT_SUPPORTED_ERROR = 800111] = "NOT_SUPPORTED_ERROR", t[t.NETWORK_ERROR = 800120] = "NETWORK_ERROR", t[t.NETWORK_ROUTING_ERROR = 800121] = "NETWORK_ROUTING_ERROR", t[t.MALFORMED_DATA = 800130] = "MALFORMED_DATA", t[t.MALFORMED_ERROR_DATA = 800140] = "MALFORMED_ERROR_DATA", t[t.WRONG_CHANNEL_TYPE = 800150] = "WRONG_CHANNEL_TYPE", t[t.MARK_AS_READ_RATE_LIMIT_EXCEEDED = 800160] = "MARK_AS_READ_RATE_LIMIT_EXCEEDED", t[t.QUERY_IN_PROGRESS = 800170] = "QUERY_IN_PROGRESS", t[t.ACK_TIMEOUT = 800180] = "ACK_TIMEOUT", t[t.LOGIN_TIMEOUT = 800190] = "LOGIN_TIMEOUT", t[t.WEBSOCKET_CONNECTION_CLOSED = 800200] = "WEBSOCKET_CONNECTION_CLOSED", t[t.WEBSOCKET_CONNECTION_FAILED = 800210] = "WEBSOCKET_CONNECTION_FAILED", t[t.REQUEST_FAILED = 800220] = "REQUEST_FAILED", t[t.FILE_UPLOAD_CANCEL_FAILED = 800230] = "FILE_UPLOAD_CANCEL_FAILED", t[t.REQUEST_CANCELED = 800240] = "REQUEST_CANCELED", t[t.REQUEST_DUPLICATED = 800250] = "REQUEST_DUPLICATED", t[t.FILE_SIZE_LIMIT_EXCEEDED = 800260] = "FILE_SIZE_LIMIT_EXCEEDED", t[t.ERR_UPLOAD_STAT_RETRY_COUNT_EXCEEDED = 800270] = "ERR_UPLOAD_STAT_RETRY_COUNT_EXCEEDED", t[t.SESSION_TOKEN_REQUEST_FAILED = 800500] = "SESSION_TOKEN_REQUEST_FAILED", t[t.SESSION_TOKEN_REFRESHED = 800501] = "SESSION_TOKEN_REFRESHED", t[t.SESSION_TOKEN_REFRESH_FAILED = 800502] = "SESSION_TOKEN_REFRESH_FAILED", t[t.COLLECTION_DISPOSED = 800600] = "COLLECTION_DISPOSED", t[t.DATABASE_ERROR = 800700] = "DATABASE_ERROR", t[t.USER_DEACTIVATED = 900021] = "USER_DEACTIVATED", t[t.CHANNEL_IS_FROZEN = 900050] = "CHANNEL_IS_FROZEN", t[t.RECEIVER_USER_DEACTIVATED = 900081] = "RECEIVER_USER_DEACTIVATED";
})(me || (me = {}));
var Qn, xs, yn, Wu, no, rr = function(t) {
  return !(t instanceof D && !t.shouldThrowOutside);
}, D = function(t) {
  function n(e) {
    var r = e.code, i = r === void 0 ? 0 : r, s = e.message, a = s === void 0 ? "" : s, o = t.call(this, a) || this;
    return o.shouldThrowOutside = !1, o._detail = "", o.name = "SendbirdError", o.code = i, Object.setPrototypeOf(o, n.prototype), o;
  }
  return S(n, t), Object.defineProperty(n.prototype, "detail", { get: function() {
    return this._detail;
  }, enumerable: !1, configurable: !0 }), n.prototype.setDetail = function(e) {
    this._detail = e;
  }, Object.defineProperty(n.prototype, "isInvalidTokenError", { get: function() {
    return this.code === me.INVALID_TOKEN;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isSessionExpiredError", { get: function() {
    return this.isSessionTokenExpiredError || this.isSessionKeyExpiredError;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isSessionTokenExpiredError", { get: function() {
    return this.code === me.SESSION_TOKEN_EXPIRED;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isSessionKeyExpiredError", { get: function() {
    return this.code === me.SESSION_KEY_EXPIRED;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isSessionInvalidatedError", { get: function() {
    return this.isSessionRevokedError || this.isUserAuthDeactivedError || this.isUserAuthDeletedOrNotFoundError;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isSessionRevokedError", { get: function() {
    return this.code === me.SESSION_REVOKED;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isUserAuthDeactivedError", { get: function() {
    return this.code === me.USER_AUTH_DEACTIVATED;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isUserAuthDeletedOrNotFoundError", { get: function() {
    return this.code === me.USER_AUTH_DELETED_OR_NOT_FOUND;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isNetworkError", { get: function() {
    return this.code === me.NETWORK_ERROR || this.code === me.NETWORK_ROUTING_ERROR;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "debugModeRequired", { get: function() {
    return new n({ code: me.DEBUG_MODE_REQUIRED, message: "Cannot run this operation in production mode." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "lostInstance", { get: function() {
    return new n({ code: me.LOST_INSTANCE, message: "Instance ID is missing. It should belong to an instance." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "invalidCommand", { get: function() {
    return new n({ code: me.INVALID_COMMAND, message: "Cannot send invalid command." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "unknown", { get: function() {
    return new n({ code: me.UNKNOWN_ERROR, message: "Unknown error occurred." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "connectionRenew", { get: function() {
    return new n({ code: me.CONNECTION_RENEW, message: "Connection restarts." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "invalidConnectionStateTransition", { get: function() {
    return new n({ code: me.INVALID_CONNECTION_STATE_TRANSITION, message: "Invalid connection state transition." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "xmlHttpRequestNotSupported", { get: function() {
    return new n({ code: me.XMLHTTPREQUEST_NOT_SUPPORTED, message: "Cannot upload file. XMLHttpRequest is not defined in this environment." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "connectionRequired", { get: function() {
    return new n({ code: me.CONNECTION_REQUIRED, message: "Connection is required." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "connectionCanceled", { get: function() {
    return new n({ code: me.CONNECTION_CANCELED, message: "Connection is canceled." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "invalidParameters", { get: function() {
    return new n({ code: me.INVALID_PARAMETER, message: "Invalid parameters." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "notSupportedError", { get: function() {
    return new n({ code: me.NOT_SUPPORTED_ERROR, message: "Given parameters are not supported." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "channelTypeNotSupportedError", { get: function() {
    return new n({ code: me.NOT_SUPPORTED_ERROR, message: "Called method is not supported in the current channel's channel type." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "networkError", { get: function() {
    return new n({ code: me.NETWORK_ERROR, message: "There was a network error." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "markAsReadAllRateLimitExceeded", { get: function() {
    return new n({ code: me.MARK_AS_READ_RATE_LIMIT_EXCEEDED, message: "markAsRead rate limit exceeded." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "queryInProgress", { get: function() {
    return new n({ code: me.QUERY_IN_PROGRESS, message: "Query in progress." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "noAckTimeout", { get: function() {
    return new n({ code: me.ACK_TIMEOUT, message: "Command received no ack." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "loginTimeout", { get: function() {
    return new n({ code: me.LOGIN_TIMEOUT, message: "Connection timeout." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "connectionClosed", { get: function() {
    return new n({ code: me.WEBSOCKET_CONNECTION_CLOSED, message: "Connection is closed. Please reconnect." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "requestFailed", { get: function() {
    return new n({ code: me.REQUEST_FAILED, message: "Request failed." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "tooManyRequests", { get: function() {
    return new n({ code: me.REQUEST_DUPLICATED, message: "Too many requests." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "alreadyConnectedAsAnotherUser", { get: function() {
    return new n({ code: me.REQUEST_FAILED, message: "Already logged in as a different user. Call disconnect() first." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "fileUploadCanceled", { get: function() {
    return new n({ code: me.FILE_UPLOAD_CANCEL_FAILED, message: "File upload has been canceled." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "requestCanceled", { get: function() {
    return new n({ code: me.REQUEST_CANCELED, message: "Request has been canceled." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "sessionTokenRefreshFailed", { get: function() {
    return new n({ code: me.SESSION_TOKEN_REFRESH_FAILED, message: "Failed to refresh the session key." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "sessionTokenRequestFailed", { get: function() {
    return new n({ code: me.SESSION_TOKEN_REQUEST_FAILED, message: "Failed to get the session token." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "databaseError", { get: function() {
    return new n({ code: me.DATABASE_ERROR, message: "Database error." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "fileSizeLimitExceededError", { get: function() {
    return new n({ code: me.FILE_SIZE_LIMIT_EXCEEDED, message: "File size exceeds the file size limit." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "statLogUploadLimitExceededError", { get: function() {
    return new n({ code: me.ERR_UPLOAD_STAT_RETRY_COUNT_EXCEEDED, message: "The upload request failed due to the retry count being exceeded." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "malformedDataError", { get: function() {
    return new n({ code: me.MALFORMED_DATA, message: "Malformed data." });
  }, enumerable: !1, configurable: !0 }), n.prototype.throwOutside = function() {
    throw this.shouldThrowOutside = !0, this;
  }, n;
}(Error), Kv = [me.CONNECTION_REQUIRED, me.NETWORK_ERROR, me.ACK_TIMEOUT, me.WEBSOCKET_CONNECTION_CLOSED, me.WEBSOCKET_CONNECTION_FAILED, me.FILE_UPLOAD_CANCEL_FAILED, me.REQUEST_CANCELED, me.INTERNAL_SERVER_ERROR, me.RATE_LIMIT_EXCEEDED, me.UNKNOWN_SERVER_ERROR, me.USER_DEACTIVATED, me.CHANNEL_IS_FROZEN, me.RECEIVER_USER_DEACTIVATED], Wv = [me.WEBSOCKET_CONNECTION_CLOSED, me.WEBSOCKET_CONNECTION_FAILED, me.CONNECTION_REQUIRED, me.CHANNEL_IS_FROZEN], Z0 = function(t, n) {
  if (t !== n) {
    var e = A({}, t), r = A({}, n);
    return !(e.hasOwnProperty("messageId") && r.hasOwnProperty("messageId") && e.messageId !== r.messageId || e.hasOwnProperty("reqId") && r.hasOwnProperty("reqId") && e.reqId !== r.reqId || (e.hasOwnProperty("messageId") && delete e.messageId, e.hasOwnProperty("reqId") && delete e.reqId, r.hasOwnProperty("messageId") && delete r.messageId, r.hasOwnProperty("reqId") && delete r.reqId, JSON.stringify(e) !== JSON.stringify(r)));
  }
  return !0;
}, O = function(t, n, e) {
  return e === void 0 && (e = !1), !(!e || !Do(n)) || (typeof t != "string" ? typeof t == "object" ? Ze(t, n) : Qv(t, n) : typeof n === t);
}, Ze = function(t, n, e) {
  return e === void 0 && (e = !1), !(!e || !Do(n)) || Object.values(t).includes(n);
}, Qv = function(t, n) {
  return n instanceof t;
}, tt = function(t, n, e) {
  return e === void 0 && (e = !1), !(!e || !Do(n)) || Array.isArray(n) && n.every(function(r) {
    return O(t, r);
  });
}, zh = function(t, n) {
  return n === void 0 && (n = !1), !(!n || !Do(t)) || typeof t == "number" && t.toString().length === 13;
}, Hl = function(t) {
  return t > 0 && Wv.indexOf(t) >= 0;
}, qn = function(t, n) {
  if (n === void 0 && (n = !1), n && Do(t))
    return !0;
  var e = typeof t == "object" && t !== null && t.hasOwnProperty("name") && typeof t.name == "string" && t.hasOwnProperty("uri") && typeof t.uri == "string" && t.hasOwnProperty("type") && typeof t.type == "string";
  if (!e) {
    if (typeof Blob < "u")
      return t instanceof Blob;
    if (typeof File < "u")
      return t instanceof File;
  }
  return e;
}, Yv = function(t, n) {
  if (t === n)
    return !0;
  if (t == null || n == null || t.length !== n.length)
    return !1;
  for (var e = Re([], we(t), !1).sort(), r = Re([], we(n), !1).sort(), i = 0; i < e.length; ++i)
    if (e[i] !== r[i])
      return !1;
  return !0;
}, Do = function(t) {
  return t == null;
}, X0 = function() {
  function t(n) {
    var e = n === void 0 ? {} : n, r = e.useMemberInfoInMessage, i = r === void 0 || r, s = e.typingIndicatorInvalidateTime, a = s === void 0 ? 1e4 : s, o = e.typingIndicatorThrottle, l = o === void 0 ? 1e3 : o, c = e.websocketResponseTimeout, u = c === void 0 ? 1e4 : c, d = e.websocketPayloadDecompression, h = d === void 0 || d, p = e.sessionTokenRefreshTimeout, f = p === void 0 ? 60 : p;
    this._useMemberInfoInMessage = !0, this._typingIndicatorInvalidateTime = 1e4, this._typingIndicatorThrottle = 1e3, this._websocketResponseTimeout = 1e4, this._sessionTokenRefreshTimeout = 60, this._useMemberInfoInMessage = i, this._typingIndicatorInvalidateTime = a, this._typingIndicatorThrottle = l, this._websocketResponseTimeout = u, this._sessionTokenRefreshTimeout = f, this.websocketPayloadDecompression = h;
  }
  return Object.defineProperty(t.prototype, "useMemberInfoInMessage", { get: function() {
    return this._useMemberInfoInMessage;
  }, set: function(n) {
    O("boolean", n) && (this._useMemberInfoInMessage = n);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "typingIndicatorInvalidateTime", { get: function() {
    return this._typingIndicatorInvalidateTime;
  }, set: function(n) {
    O("number", n) && (this._typingIndicatorInvalidateTime = n);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "typingIndicatorThrottle", { get: function() {
    return this._typingIndicatorThrottle;
  }, set: function(n) {
    O("number", n) && n >= 1e3 && n <= 9e3 && (this._typingIndicatorThrottle = n);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "websocketResponseTimeout", { get: function() {
    return this._websocketResponseTimeout;
  }, set: function(n) {
    O("number", n) && n >= 5e3 && n <= 3e4 && (this._websocketResponseTimeout = n);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "sessionTokenRefreshTimeout", { get: function() {
    return this._sessionTokenRefreshTimeout;
  }, set: function(n) {
    O("number", n) && (n < 60 ? n = 60 : n > 1800 && (n = 1800), this._sessionTokenRefreshTimeout = n);
  }, enumerable: !1, configurable: !0 }), t;
}(), J0 = { encrypt: function(t) {
  return t;
}, decrypt: function(t) {
  return t;
} }, Vh = function() {
  function t(n) {
    var e = n.store;
    this._preference = /* @__PURE__ */ new Map(), this._store = e;
  }
  return t.prototype._savePreferenceKeys = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, this._store.set({ key: this._keysAddress, value: Re([], we(this._preference.keys()), !1) })];
          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, t.prototype.init = function(n, e) {
    var r;
    return e === void 0 && (e = 1), g(this, 0, void 0, function() {
      var i, s, a, o, l, c, u, d, h, p;
      return _(this, function(f) {
        switch (f.label) {
          case 0:
            return this._version = e, this._keysAddress = n, i = "".concat(n, ".metadata.version"), [4, this._store.get(i)];
          case 1:
            return s = f.sent(), [4, this._store.get(n)];
          case 2:
            return a = (r = f.sent()) !== null && r !== void 0 ? r : [], !s || s.version < this._version ? [4, this._resetPreferenceData(a, i)] : [3, 4];
          case 3:
            return f.sent(), [3, 11];
          case 4:
            f.trys.push([4, 9, 10, 11]), o = de(a), l = o.next(), f.label = 5;
          case 5:
            return l.done ? [3, 8] : (c = l.value, [4, this._store.get(c)]);
          case 6:
            (u = f.sent()) && this._preference.set(c, u), f.label = 7;
          case 7:
            return l = o.next(), [3, 5];
          case 8:
            return [3, 11];
          case 9:
            return d = f.sent(), h = { error: d }, [3, 11];
          case 10:
            try {
              l && !l.done && (p = o.return) && p.call(o);
            } finally {
              if (h)
                throw h.error;
            }
            return [7];
          case 11:
            return [2];
        }
      });
    });
  }, t.prototype._resetPreferenceData = function(n, e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this._preference = /* @__PURE__ */ new Map(), [4, this._store.removeMany(n)];
          case 1:
            return r.sent(), [4, this._store.set({ key: e, value: { version: this._version } })];
          case 2:
            return r.sent(), [2];
        }
      });
    });
  }, t.prototype.get = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        return [2, this._preference.get(n)];
      });
    });
  }, t.prototype.set = function(n, e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = !this._preference.has(n), [4, this._store.set({ key: n, value: e })];
          case 1:
            return i.sent(), this._preference.set(n, e), r ? [4, this._savePreferenceKeys()] : [3, 3];
          case 2:
            i.sent(), i.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, t.prototype.remove = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this._store.remove(n)];
          case 1:
            return e.sent(), this._preference.delete(n), [4, this._savePreferenceKeys()];
          case 2:
            return e.sent(), [2];
        }
      });
    });
  }, t.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, this._store.removeMany(Re([], we(this._preference.keys()), !1))];
          case 1:
            return n.sent(), this._preference.clear(), [4, this._savePreferenceKeys()];
          case 2:
            return n.sent(), [2];
        }
      });
    });
  }, t;
}(), $v = function() {
  function t(n) {
    var e = n.encryption, r = n.store, i = n.localCacheEnabled, s = n.localCacheConfig;
    this.store = r, this.preference = new Vh({ store: r }), this.encryption = e ?? J0, this.localCacheEnabled = i, this.localCacheConfig = s;
  }
  return t.prototype.replaceStore = function(n) {
    this.store = n, this.preference = new Vh({ store: n });
  }, t;
}();
(function(t) {
  t.SUCCESS = "success", t.PENDING = "pending", t.ERROR = "error";
})(Qn || (Qn = {})), function(t) {
  t.DEFAULT = "default", t.ALL = "all", t.MENTION_ONLY = "mention_only", t.OFF = "off";
}(xs || (xs = {})), function(t) {
  t.FCM = "gcm", t.APNS = "apns", t.UNKNOWN = "unknown";
}(yn || (yn = {})), function(t) {
  t.ALTERNATIVE = "alternative", t.DEFAULT = "default";
}(Wu || (Wu = {})), function(t) {
  t.CUSTOM = "custom", t.MESSAGE_COLLECTION_ACCESSED_AT = "messagecollection_accessed_at";
}(no || (no = {}));
var Bl, Zv = function() {
  function t(n) {
    var e = n.channel, r = n.cachedMessageCount;
    this._cachedMessageCount = 0, this._channel = e, this._cachedMessageCount = r;
  }
  return Object.defineProperty(t.prototype, "channel", { get: function() {
    return this._channel;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "cachedMessageCount", { get: function() {
    return this._cachedMessageCount;
  }, enumerable: !1, configurable: !0 }), t;
}(), em = function() {
  function t(n) {
    var e = n === void 0 ? {} : n, r = e.maxSize, i = r === void 0 ? 256 : r, s = e.clearOrder, a = s === void 0 ? no.MESSAGE_COLLECTION_ACCESSED_AT : s, o = e.customClearOrderComparator, l = e.enableAutoResend, c = l === void 0 || l;
    this._clearOrderComparatorUseMessageCollectionAccessedAt = function(u, d) {
      return u.channel.messageCollectionLastAccessedAt === d.channel.messageCollectionLastAccessedAt ? u.channel.lastMessage && !d.channel.lastMessage ? 1 : !u.channel.lastMessage && d.channel.lastMessage ? -1 : u.channel.lastMessage || d.channel.lastMessage ? u.channel.lastMessage.createdAt - d.channel.lastMessage.createdAt : 0 : u.channel.messageCollectionLastAccessedAt > d.channel.messageCollectionLastAccessedAt ? 1 : -1;
    }, this._maxSize = Math.max(i, 64), o ? (this._clearOrder = a, this._customClearOrderComparator = o) : this._clearOrder = no.MESSAGE_COLLECTION_ACCESSED_AT, this._enableAutoResend = c;
  }
  return Object.defineProperty(t.prototype, "maxSize", { get: function() {
    return this._maxSize;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "clearOrder", { get: function() {
    return this._clearOrder;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "clearOrderComparator", { get: function() {
    var n;
    return this._clearOrder === no.MESSAGE_COLLECTION_ACCESSED_AT ? this._clearOrderComparatorUseMessageCollectionAccessedAt : (n = this._customClearOrderComparator) !== null && n !== void 0 ? n : this._clearOrderComparatorUseMessageCollectionAccessedAt;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "enableAutoResend", { get: function() {
    return this._enableAutoResend;
  }, enumerable: !1, configurable: !0 }), t;
}();
(function(t) {
  t.FEED = "feed", t.CHAT = "chat", t.CHAT_API = "chat_api";
})(Bl || (Bl = {}));
var yt, Lr, ai, Yt, Pn, ha, jn, Fn, Yr, St, Gh, Qu, Yu, Xv = function() {
  function t() {
    this.isRefreshing = !1;
  }
  return Object.defineProperty(t.prototype, "hasSession", { get: function() {
    return !!this.sessionKey;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "hasChatServicePermission", { get: function() {
    var n;
    return !!(!((n = this.services) === null || n === void 0) && n.includes(Bl.CHAT));
  }, enumerable: !1, configurable: !0 }), t.prototype.clear = function() {
    this.authToken = void 0, this.sessionKey = void 0, this.services = [];
  }, t;
}(), Pi = function() {
  var t = (/* @__PURE__ */ new Date()).getTime();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(n) {
    var e = (t + 16 * Math.random()) % 16 | 0;
    return t = Math.floor(t / 16), (n === "x" ? e : 3 & e | 8).toString(16);
  });
}, qh = function() {
  function t(n) {
    var e = n.container;
    this._container = {}, this._container = e, this.key = Pi();
  }
  return t.prototype._register = function(n, e, r) {
    var i;
    return n in this._container || (this._container[n] = /* @__PURE__ */ new Map()), (i = this._container[n]) === null || i === void 0 || i.set(this.key, { occurence: e, handler: r }), this;
  }, t.prototype.on = function(n, e) {
    return this._register(n, -1, e);
  }, t.prototype.once = function(n, e) {
    return this._register(n, 1, e);
  }, t.prototype.close = function() {
    var n = this;
    Object.keys(this._container).forEach(function(e) {
      var r;
      (r = n._container[e]) === null || r === void 0 || r.delete(n.key);
    });
  }, t;
}(), Qs = function() {
  function t() {
    this._container = {};
  }
  return t.prototype.on = function(n, e) {
    return new qh({ container: this._container }).on(n, e);
  }, t.prototype.once = function(n, e) {
    return new qh({ container: this._container }).once(n, e);
  }, t.prototype.dispatch = function(n, e) {
    var r, i, s = this._container[n];
    if (s) {
      var a = [];
      try {
        for (var o = de(s.keys()), l = o.next(); !l.done; l = o.next()) {
          var c = l.value, u = s.get(c);
          u.handler(e), u.occurence > 0 && (u.occurence--, u.occurence === 0 && a.push(c));
        }
      } catch (d) {
        r = { error: d };
      } finally {
        try {
          l && !l.done && (i = o.return) && i.call(o);
        } finally {
          if (r)
            throw r.error;
        }
      }
      a.forEach(function(d) {
        return s.delete(d);
      });
    }
  }, t;
}(), Jv = function() {
  function t() {
    this._dispatcher = new Qs();
  }
  return t.prototype.on = function(n) {
    return this._dispatcher.on("event", n);
  }, t.prototype.once = function(n) {
    return this._dispatcher.once("event", n);
  }, t.prototype.dispatch = function(n) {
    this._dispatcher.dispatch("event", n);
  }, t;
}(), Vt = function() {
}, fe = function(t) {
  var n = {};
  return t && Object.keys(t).forEach(function(e) {
    t[e] === void 0 || Number.isNaN(t[e]) || t[e] === null || (n[e] = t[e]);
  }), n;
}, Ae = function(t) {
  if (t != null) {
    if (typeof t == "object") {
      if (Array.isArray(t)) {
        for (var n = Re([], we(t), !1), e = 0; e < n.length; e++)
          n[e] = Ae(n[e]);
        return n;
      }
      return Object.keys(t).forEach(function(r) {
        t[r] === null && delete t[r];
      }), t;
    }
    return t;
  }
};
(function(t) {
  t.BASE = "base", t.GROUP = "group", t.OPEN = "open", t.FEED = "feed";
})(yt || (yt = {})), function(t) {
  t.OPERATOR = "operator", t.NONE = "none";
}(Lr || (Lr = {})), function(t) {
  t.MUTED = "muted", t.UNMUTED = "unmuted";
}(ai || (ai = {})), function(t) {
  t.BASE = "base", t.USER = "user", t.FILE = "file", t.ADMIN = "admin";
}(Yt || (Yt = {})), function(t) {
  t.ALL = "", t.USER = "MESG", t.FILE = "FILE", t.ADMIN = "ADMM";
}(Pn || (Pn = {})), function(t) {
  t.USER = "MESG", t.FILE = "FILE", t.ADMIN = "ADMM";
}(ha || (ha = {})), function(t) {
  t.USERS = "users", t.CHANNEL = "channel";
}(jn || (jn = {})), function(t) {
  t.ALL = "all", t.NONE = "none", t.ONLY_REPLY_TO_CHANNEL = "only_reply_to_channel";
}(Fn || (Fn = {})), function(t) {
  t.DEFAULT = "default", t.SUPPRESS = "suppress";
}(Yr || (Yr = {})), function(t) {
  t.PENDING = "pending", t.SCHEDULED = "scheduled", t.SUCCEEDED = "succeeded", t.FAILED = "failed", t.CANCELED = "canceled";
}(St || (St = {})), function(t) {
  t.INREVIEW = "InReview", t.APPROVED = "Approved";
}(Gh || (Gh = {})), function(t) {
  t.HIGH = "high", t.NORMAL = "normal", t.LOW = "low";
}(Qu || (Qu = {})), function(t) {
  t.CREATED_AT = "created_at", t.UPDATED_AT = "updated_at";
}(Yu || (Yu = {}));
var Y, Hn = "v3", vt = "/".concat(Hn, "/users"), ey = "/".concat(Hn, "/sdk/users"), ty = "/".concat(Hn, "/storage/file"), Wn = "/".concat(Hn, "/group_channels"), ny = "/".concat(Hn, "/sdk/group_channels"), ry = "/".concat(Hn, "/open_channels"), iy = "/".concat(Hn, "/search"), $u = "/".concat(Hn, "/report"), sy = "/".concat(Hn, "/emojis"), tm = "/".concat(Hn, "/emoji_categories"), Zr = "/".concat(Hn, "/polls"), nm = "/".concat(Hn, "/scheduled_messages"), ay = "/".concat(Hn, "/sdk/ui_kit/configuration"), oy = "/".concat(Hn, "/sdk/statistics"), ly = "/".concat(Hn, "/sdk/statistics/notification_statistics"), rm = "/".concat(Hn, "/message_templates"), cy = "/".concat(Hn, "/sdk/push_delivery"), uy = "/".concat(Hn, "/forms"), gt = function(t) {
  switch (t) {
    case yt.FEED:
    case yt.GROUP:
      return Wn;
    case yt.OPEN:
      return ry;
    default:
      return null;
  }
}, im = function(t) {
  switch (t) {
    case yt.GROUP:
      return "".concat($u, "/group_channels");
    case yt.OPEN:
      return "".concat($u, "/open_channels");
    default:
      return null;
  }
}, pa = function(t, n, e) {
  var r, i;
  switch (t) {
    case jn.CHANNEL:
      return !0;
    case jn.USERS:
      if (n)
        try {
          for (var s = de(n), a = s.next(); !a.done; a = s.next())
            if (a.value === e)
              return !0;
        } catch (o) {
          r = { error: o };
        } finally {
          try {
            a && !a.done && (i = s.return) && i.call(s);
          } finally {
            if (r)
              throw r.error;
          }
        }
  }
  return !1;
}, jd = function(t, n, e) {
  var r, i, s, a, o = pa((r = t.mentionType) !== null && r !== void 0 ? r : null, (i = t.mentionedUserIds) !== null && i !== void 0 ? i : [], e), l = pa((s = n.mentionType) !== null && s !== void 0 ? s : null, (a = n.mentionedUserIds) !== null && a !== void 0 ? a : [], e);
  return !o && l ? 1 : o && !l ? -1 : 0;
}, sm = function(t, n, e) {
  var r, i = n || new FormData();
  for (var s in t)
    if (t.hasOwnProperty(s)) {
      var a = t[s], o = e ? "".concat(e, "[").concat(s, "]") : s;
      qn(a) ? i.append(o, a, (r = a.name) !== null && r !== void 0 ? r : "filename") : typeof a != "object" || a === null || Array.isArray(a) || a instanceof Blob ? i.append(o, String(a)) : i = sm(a, i, o);
    }
  return i;
};
(function(t) {
  t.GET = "GET", t.POST = "POST", t.PUT = "PUT", t.DELETE = "DELETE";
})(Y || (Y = {}));
var Ft, $ = function(t) {
  function n() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e.params = {}, e.requireAuth = !0, e.headers = {}, e.requestId = Pi(), e;
  }
  return S(n, t), n.prototype.encodeParams = function(e) {
    var r = this;
    return e == null || e === "" ? encodeURIComponent("") : Array.isArray(e) ? e.map(function(i) {
      return r.encodeParams(i);
    }).join(",") : encodeURIComponent(typeof e == "object" ? JSON.stringify(e) : String(e));
  }, Object.defineProperty(n.prototype, "query", { get: function() {
    var e = this, r = fe(this.params);
    return "?".concat(Object.keys(r).map(function(i) {
      return "".concat(encodeURIComponent(i), "=").concat(e.encodeParams(r[i]));
    }).join("&"));
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "payload", { get: function() {
    var e = fe(this.params);
    return Object.keys(e).some(function(r) {
      return qn(e[r]);
    }) ? sm(e) : JSON.stringify(e);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "hasSessionKey", { get: function() {
    return this.headers["Session-Key"] !== void 0;
  }, enumerable: !1, configurable: !0 }), n;
}(Vt), ne = function(t) {
  function n(e, r) {
    var i = t.call(this) || this;
    return i._iid = e, i._payload = r, i;
  }
  return S(n, t), Object.defineProperty(n.prototype, "payload", { get: function() {
    return A({}, this._payload);
  }, enumerable: !1, configurable: !0 }), n.prototype.as = function(e) {
    return new e(this._iid, this.payload);
  }, n;
}(Vt), dy = function(t) {
  function n(e) {
    var r = t.call(this) || this;
    return r.requestId = e, r;
  }
  return S(n, t), n;
}(Vt), fa = function(t) {
  function n(e) {
    var r = e.expires_in, i = e.reason, s = i === void 0 ? me.SESSION_KEY_EXPIRED : i, a = e.message, o = a === void 0 ? "" : a, l = t.call(this) || this;
    switch (l.expiresIn = r ?? 0, s) {
      case me.SESSION_KEY_EXPIRED:
      case me.SESSION_TOKEN_EXPIRED:
      case me.SESSION_REVOKED:
      case me.USER_AUTH_DEACTIVATED:
      case me.USER_AUTH_DELETED_OR_NOT_FOUND:
        l.error = new D({ code: s, message: o });
    }
    return l;
  }
  return S(n, t), Object.defineProperty(n.prototype, "invalidateSessionToken", { get: function() {
    var e;
    return !!(!((e = this.error) === null || e === void 0) && e.isSessionTokenExpiredError);
  }, enumerable: !1, configurable: !0 }), n;
}(Vt), Lt = function(t) {
  function n(e, r, i, s) {
    s === void 0 && (s = "");
    var a, o = this;
    return (o = t.call(this) || this)._iid = e, o.code = r, o.payload = i, o.requestId = (a = i.req_id) !== null && a !== void 0 ? a : s, o;
  }
  return S(n, t), n.createFromRawMessage = function(e, r) {
    var i = r.substring(0, 4), s = {};
    try {
      s = JSON.parse(r.substring(4));
    } catch {
      i = "NOOP";
    } finally {
      return new n(e, i, s);
    }
  }, n.prototype.convertToMessage = function() {
    return "".concat(this.code).concat(JSON.stringify(this.payload), `
`);
  }, n.prototype.as = function(e) {
    return new e(this._iid, this.code, this.payload);
  }, n;
}(Vt), Zn = function(t) {
  function n(e) {
    var r, i = e.code, s = e.ackRequired, a = e.payload, o = a === void 0 ? {} : a, l = this;
    return (l = t.call(this) || this).code = i, l.payload = o, l.requestId = (r = l.payload.req_id) !== null && r !== void 0 ? r : Pi(), l.ackRequired = s, l.payload.req_id = l.requestId, l;
  }
  return S(n, t), n.prototype.convertToMessage = function() {
    return "".concat(this.code).concat(JSON.stringify(this.payload), `
`);
  }, n;
}(Vt), Hd = function(t) {
  function n(e) {
    var r = e.userId, i = e.authToken, s = e.services, a = e.expiringSession, o = a === void 0 || a, l = t.call(this) || this;
    return l.path = "".concat(vt, "/").concat(r, "/session_key"), l.method = Y.POST, l.params = fe({ token: i, services: s, expiring_session: !!o }), l.requireAuth = !1, l;
  }
  return S(n, t), n;
}($), hy = function(t) {
  function n(e) {
    var r = e.authToken, i = e.expiringSession, s = i === void 0 || i, a = e.requestId, o = a === void 0 ? void 0 : a;
    return t.call(this, { code: "LOGI", payload: fe({ token: r, expiring_session: s ? 1 : 0, req_id: o }), ackRequired: !0 }) || this;
  }
  return S(n, t), n;
}(Zn), py = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this, s = r.key, a = r.expires_at, o = r.services;
    return i.key = s, i.expiresAt = a, i.services = o, i;
  }
  return S(n, t), n;
}(ne), fy = function(t) {
  function n(e, r, i) {
    var s, a = this;
    return (a = t.call(this, e, "LOGI", i) || this).error = null, a.newKey = null, a.newKey = (s = i.new_key) !== null && s !== void 0 ? s : null, a.error = i.error ? new D(i) : null, a;
  }
  return S(n, t), n;
}(Lt), Bd = function(t) {
  function n(e) {
    var r = t.call(this) || this;
    return r.statLog = e, r;
  }
  return S(n, t), n;
}(Vt), am = function(t) {
  function n(e) {
    var r = e.request, i = e.deferred, s = e.error, a = s === void 0 ? D.requestFailed : s, o = t.call(this) || this;
    return o.request = r, o.deferred = i, o.error = a, o;
  }
  return S(n, t), n;
}(Vt);
(function(t) {
  t.FEATURE_LOCALCACHE = "feature:local_cache", t.FEATURE_LOCALCACHE_EVENT = "feature:local_cache_event", t.NOTIFICATION = "noti:stats", t.WEBSOCKET_CONNECT = "ws:connect", t.API_RESULT = "api:result";
})(Ft || (Ft = {}));
var Zu, Fs, Ji, Zt = function() {
  function t(n) {
    var e = n.type, r = n.data, i = n.ts, s = i === void 0 ? Date.now() : i;
    this.type = e, this.createdAt = s, this.data = r;
  }
  return t.payloadify = function(n) {
    return fe({ stat_type: n.type, ts: n.createdAt, data: fe(n.data) });
  }, t;
}(), Xu = function() {
  return typeof document > "u" && typeof navigator < "u" && navigator.product == "ReactNative";
}, Kh = function() {
  return !(typeof navigator > "u" || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(navigator.userAgent));
};
(function(t) {
  t.CHAT = "chat", t.CALLS = "calls", t.DESK = "desk", t.LIVE = "live", t.UIKIT_CHAT = "uikit-chat", t.UIKIT_LIVE = "uikit-live";
})(Zu || (Zu = {})), function(t) {
  t.ANDROID = "android", t.IOS = "ios", t.JS = "js", t.UNREAL = "unreal", t.UNITY = "unity", t.REACT_NATIVE = "react-native", t.FLUTTER = "flutter";
}(Fs || (Fs = {})), function(t) {
  t.ANDROID = "android", t.IOS = "ios", t.WEB = "web", t.MOBILE_WEB = "mobile_web", t.WINDOWS = "windows";
}(Ji || (Ji = {}));
var zl = function() {
  function t() {
  }
  return t.sendbirdSdkUserAgentWithExtension = function(n) {
    var e = Xu() ? Fs.REACT_NATIVE : Fs.JS, r = { main_sdk_info: "chat/".concat(e, "/").concat(ts.SDK_VERSION), device_os_platform: Kh() ? "mobile-web" : "web", os_version: ts.OS_VERSION };
    if (n) {
      var i = n.sendbirdExtensions, s = n.deviceOS, a = n.customData, o = a === void 0 ? {} : a;
      s.version && (r.os_version = s.version), s.platform && (r.device_os_platform = s.platform), i.length > 0 && (r.extension_sdk_info = i.map(function(l) {
        var c = l.product, u = l.platform, d = l.version;
        return "".concat(c, "/").concat(u, "/").concat(d);
      }).join(",")), Object.keys(r).forEach(function(l) {
        return delete o[l];
      }), Object.keys(o).length > 0 && (r = A(A({}, r), o));
    }
    return Object.entries(r).map(function(l) {
      var c = we(l, 2), u = c[0], d = c[1];
      return "".concat(u, "=").concat(d);
    }).join("&");
  }, t.userAgentWithExtension = function(n) {
    var e = Xu() ? "reactnative" : "JS", r = n.sb_syncmanager ? "s".concat(n.sb_syncmanager) : "", i = n.sb_uikit ? "u".concat(n.sb_uikit) : "", s = n["device-os-platform"] ? "o".concat(n["device-os-platform"]) : Kh() ? "omobile-web" : "oweb";
    return "".concat(e, "/c").concat(ts.SDK_VERSION, "/").concat(r, "/").concat(i, "/").concat(s);
  }, t;
}(), $n = function() {
  var t = this;
  this.promise = new Promise(function(n, e) {
    t.resolve = n, t.reject = function(r) {
      e(r);
    };
  });
}, Vl = function(t) {
  function n(e) {
    var r = t.call(this) || this;
    return r.requestId = e.requestId, r;
  }
  return S(n, t), n;
}(Vt), om = function(t) {
  function n(e) {
    var r = t.call(this) || this;
    return r.method = Y.DELETE, r.path = "".concat(gt(e.channelType), "/").concat(e.channelUrl, "/messages/").concat(e.messageId), e.messageToken && (r.params = fe({ mesg_token: e.messageToken })), r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var my = function(t) {
  function n(e, r, i) {
    var s, a = this;
    return (a = t.call(this, e, "DELM", i) || this).channelUrl = i.channel_url, a.channelType = i.channel_type, a.messageId = Number(i.msg_id), a.silent = i.silent, a.messageCreatedAt = i.message_created_at ? Number(i.message_created_at) : -1, a.senderId = (s = i.sender_id) !== null && s !== void 0 ? s : void 0, a;
  }
  return S(n, t), n;
}(Lt), _y = function() {
  function t(n, e) {
    var r = e.session, i = e.sdkState, s = e.dispatcher, a = e.logger, o = e.useFetchCompat, l = o !== void 0 && o, c = this;
    this._abortControl = /* @__PURE__ */ new Map(), this._shouldImportFetchCompat = !1, this._iid = n, this._session = r, this._sdkState = i, this._dispatcher = s, this._dispatcher.on(function(u) {
      u instanceof dy && c.cancel(u.requestId);
    }), this._logger = a, this._shouldImportFetchCompat = l;
  }
  return t.prototype._createHeader = function(n, e) {
    var r = this._sdkState, i = r.appId, s = r.appVersion, a = r.sendbirdRuntimeEnvironment, o = A(A({}, n.headers), { SendBird: "JS,".concat(ts.OS_VERSION, ",").concat(ts.SDK_VERSION, ",").concat(i).concat(s ? ",".concat(s) : ""), "SB-User-Agent": zl.userAgentWithExtension(this._sdkState.extensions), "Request-Sent-Timestamp": Date.now().toString(), "SB-SDK-User-Agent": zl.sendbirdSdkUserAgentWithExtension(a) });
    return e || (o["Content-Type"] = "application/json; charset=utf-8"), n.requireAuth && !n.hasSessionKey && this._session.hasSession && (o["Session-Key"] = this._session.sessionKey), o["App-Id"] = i, this._session && this._session.authToken && (o["Access-Token"] = this._session.authToken), o;
  }, t.prototype._statLogApiResult = function(n, e, r) {
    n.path.includes("/sdk/statistics") || this._dispatcher.dispatch(new Bd(new Zt({ type: Ft.API_RESULT, data: { endpoint: n.path, method: n.method, success: !r, latency: Date.now() - e, error_code: r == null ? void 0 : r.code, error_description: r == null ? void 0 : r.message } })));
  }, t.prototype._isBodyRequired = function(n) {
    var e = n.method;
    return e !== Y.GET && (e !== Y.DELETE || n instanceof om);
  }, t.prototype.send = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c, u, d, h, p, f, m, v, E, y, b, T;
      return _(this, function(w) {
        switch (w.label) {
          case 0:
            e = n.path, r = n.method, i = n.uploadProgressHandler, s = this._isBodyRequired(n), a = this._sdkState.api, o = "".concat(a.host).concat(e).concat(s ? "" : n.query), l = s ? n.payload : null, c = this._createHeader(n, l instanceof FormData ? l : void 0), u = new AbortController(), d = u.signal, this._abortControl.set(n.requestId, u), h = Date.now(), w.label = 1;
          case 1:
            return w.trys.push([1, 13, , 14]), i ? [4, import("./__bundle-b5ef7de4-OUUtHxBl.js")] : [3, 6];
          case 2:
            p = w.sent().xmlHttpRequest, w.label = 3;
          case 3:
            return w.trys.push([3, 5, , 6]), [4, p(this._iid, { requestId: n.requestId, method: n.method, url: o, headers: c, data: l ?? void 0, uploadProgressHandler: i })];
          case 4:
            return f = w.sent(), this._logger.debug("receive api response", n.requestId), this._statLogApiResult(n, h), [2, f];
          case 5:
            if (!((m = w.sent()) instanceof D && m.code === me.XMLHTTPREQUEST_NOT_SUPPORTED))
              throw m;
            return this._logger.debug("XMLHttpRequest is not available in this environment. progressHandler is ignored."), [3, 6];
          case 6:
            return this._shouldImportFetchCompat && (this._shouldImportFetchCompat = !1, (typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof global < "u" && global || { fetch: null }).fetch = null), typeof AbortController < "u" ? [3, 8] : [4, import("./__bundle-7c3d40f4-l0sNRNKZ.js")];
          case 7:
            w.sent(), w.label = 8;
          case 8:
            return typeof fetch == "function" ? [3, 10] : [4, import("./__bundle-46d64517-rKHPvbCK.js").then((N) => N._)];
          case 9:
            w.sent(), w.label = 10;
          case 10:
            return [4, fetch(o, { method: r, body: l, headers: c, signal: d })];
          case 11:
            return [4, (v = w.sent()).json()];
          case 12:
            if (E = w.sent(), v.ok || v.redirected)
              return this._logger.debug("receive api response", n.requestId), this._statLogApiResult(n, h), [2, new ne(this._iid, E)];
            if (E) {
              if ((y = new D(E)).isSessionExpiredError) {
                if (this._dispatcher.dispatch(new fa({ reason: y.code, message: y.message })), !(n instanceof Hd))
                  return b = new $n(), this._dispatcher.dispatch(new am({ request: n, deferred: b, error: y })), [2, b.promise];
                throw y;
              }
              throw y.isSessionInvalidatedError && this._dispatcher.dispatch(new fa({ reason: y.code, message: y.message })), y;
            }
            throw D.requestFailed;
          case 13:
            throw T = w.sent(), this._statLogApiResult(n, h, T), T instanceof D ? (this._logger.debug("fail api request", T), T) : (T == null ? void 0 : T.name) === "AbortError" ? D.requestCanceled : (this._logger.debug("fail api request", T), D.networkError);
          case 14:
            return [2];
        }
      });
    });
  }, t.prototype.cancel = function(n) {
    this._abortControl.has(n) && (this._abortControl.get(n).abort(), this._abortControl.delete(n)), this._dispatcher.dispatch(new Vl({ requestId: n }));
  }, t.prototype.cancelAll = function() {
    var n, e;
    try {
      for (var r = de(this._abortControl.values()), i = r.next(); !i.done; i = r.next())
        i.value.abort();
    } catch (s) {
      n = { error: s };
    } finally {
      try {
        i && !i.done && (e = r.return) && e.call(r);
      } finally {
        if (n)
          throw n.error;
      }
    }
    this._abortControl.clear(), this._dispatcher.dispatch(new Vl({}));
  }, t;
}(), rt = function() {
};
function Ea(t) {
  let n = t.length;
  for (; --n >= 0; )
    t[n] = 0;
}
const Ju = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]), Cl = new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]), gy = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]), Wh = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), Ti = new Array(576);
Ea(Ti);
const Ba = new Array(60);
Ea(Ba);
const To = new Array(512);
Ea(To);
const ro = new Array(256);
Ea(ro);
const zd = new Array(29);
Ea(zd);
const Gl = new Array(30);
function qc(t, n, e, r, i) {
  this.static_tree = t, this.extra_bits = n, this.extra_base = e, this.elems = r, this.max_length = i, this.has_stree = t && t.length;
}
let Qh, Yh, $h;
function Kc(t, n) {
  this.dyn_tree = t, this.max_code = 0, this.stat_desc = n;
}
Ea(Gl);
const lm = (t) => t < 256 ? To[t] : To[256 + (t >>> 7)], wo = (t, n) => {
  t.pending_buf[t.pending++] = 255 & n, t.pending_buf[t.pending++] = n >>> 8 & 255;
}, dr = (t, n, e) => {
  t.bi_valid > 16 - e ? (t.bi_buf |= n << t.bi_valid & 65535, wo(t, t.bi_buf), t.bi_buf = n >> 16 - t.bi_valid, t.bi_valid += e - 16) : (t.bi_buf |= n << t.bi_valid & 65535, t.bi_valid += e);
}, oi = (t, n, e) => {
  dr(t, e[2 * n], e[2 * n + 1]);
}, cm = (t, n) => {
  let e = 0;
  do
    e |= 1 & t, t >>>= 1, e <<= 1;
  while (--n > 0);
  return e >>> 1;
}, um = (t, n, e) => {
  const r = new Array(16);
  let i, s, a = 0;
  for (i = 1; i <= 15; i++)
    a = a + e[i - 1] << 1, r[i] = a;
  for (s = 0; s <= n; s++) {
    let o = t[2 * s + 1];
    o !== 0 && (t[2 * s] = cm(r[o]++, o));
  }
}, Zh = (t) => {
  let n;
  for (n = 0; n < 286; n++)
    t.dyn_ltree[2 * n] = 0;
  for (n = 0; n < 30; n++)
    t.dyn_dtree[2 * n] = 0;
  for (n = 0; n < 19; n++)
    t.bl_tree[2 * n] = 0;
  t.dyn_ltree[512] = 1, t.opt_len = t.static_len = 0, t.sym_next = t.matches = 0;
}, dm = (t) => {
  t.bi_valid > 8 ? wo(t, t.bi_buf) : t.bi_valid > 0 && (t.pending_buf[t.pending++] = t.bi_buf), t.bi_buf = 0, t.bi_valid = 0;
}, Xh = (t, n, e, r) => {
  const i = 2 * n, s = 2 * e;
  return t[i] < t[s] || t[i] === t[s] && r[n] <= r[e];
}, Wc = (t, n, e) => {
  const r = t.heap[e];
  let i = e << 1;
  for (; i <= t.heap_len && (i < t.heap_len && Xh(n, t.heap[i + 1], t.heap[i], t.depth) && i++, !Xh(n, r, t.heap[i], t.depth)); )
    t.heap[e] = t.heap[i], e = i, i <<= 1;
  t.heap[e] = r;
}, Jh = (t, n, e) => {
  let r, i, s, a, o = 0;
  if (t.sym_next !== 0)
    do
      r = 255 & t.pending_buf[t.sym_buf + o++], r += (255 & t.pending_buf[t.sym_buf + o++]) << 8, i = t.pending_buf[t.sym_buf + o++], r === 0 ? oi(t, i, n) : (s = ro[i], oi(t, s + 256 + 1, n), a = Ju[s], a !== 0 && (i -= zd[s], dr(t, i, a)), r--, s = lm(r), oi(t, s, e), a = Cl[s], a !== 0 && (r -= Gl[s], dr(t, r, a)));
    while (o < t.sym_next);
  oi(t, 256, n);
}, Qc = (t, n) => {
  const e = n.dyn_tree, r = n.stat_desc.static_tree, i = n.stat_desc.has_stree, s = n.stat_desc.elems;
  let a, o, l, c = -1;
  for (t.heap_len = 0, t.heap_max = 573, a = 0; a < s; a++)
    e[2 * a] !== 0 ? (t.heap[++t.heap_len] = c = a, t.depth[a] = 0) : e[2 * a + 1] = 0;
  for (; t.heap_len < 2; )
    l = t.heap[++t.heap_len] = c < 2 ? ++c : 0, e[2 * l] = 1, t.depth[l] = 0, t.opt_len--, i && (t.static_len -= r[2 * l + 1]);
  for (n.max_code = c, a = t.heap_len >> 1; a >= 1; a--)
    Wc(t, e, a);
  l = s;
  do
    a = t.heap[1], t.heap[1] = t.heap[t.heap_len--], Wc(t, e, 1), o = t.heap[1], t.heap[--t.heap_max] = a, t.heap[--t.heap_max] = o, e[2 * l] = e[2 * a] + e[2 * o], t.depth[l] = (t.depth[a] >= t.depth[o] ? t.depth[a] : t.depth[o]) + 1, e[2 * a + 1] = e[2 * o + 1] = l, t.heap[1] = l++, Wc(t, e, 1);
  while (t.heap_len >= 2);
  t.heap[--t.heap_max] = t.heap[1], ((u, d) => {
    const h = d.dyn_tree, p = d.max_code, f = d.stat_desc.static_tree, m = d.stat_desc.has_stree, v = d.stat_desc.extra_bits, E = d.stat_desc.extra_base, y = d.stat_desc.max_length;
    let b, T, w, N, M, I, x = 0;
    for (N = 0; N <= 15; N++)
      u.bl_count[N] = 0;
    for (h[2 * u.heap[u.heap_max] + 1] = 0, b = u.heap_max + 1; b < 573; b++)
      T = u.heap[b], N = h[2 * h[2 * T + 1] + 1] + 1, N > y && (N = y, x++), h[2 * T + 1] = N, T > p || (u.bl_count[N]++, M = 0, T >= E && (M = v[T - E]), I = h[2 * T], u.opt_len += I * (N + M), m && (u.static_len += I * (f[2 * T + 1] + M)));
    if (x !== 0) {
      do {
        for (N = y - 1; u.bl_count[N] === 0; )
          N--;
        u.bl_count[N]--, u.bl_count[N + 1] += 2, u.bl_count[y]--, x -= 2;
      } while (x > 0);
      for (N = y; N !== 0; N--)
        for (T = u.bl_count[N]; T !== 0; )
          w = u.heap[--b], w > p || (h[2 * w + 1] !== N && (u.opt_len += (N - h[2 * w + 1]) * h[2 * w], h[2 * w + 1] = N), T--);
    }
  })(t, n), um(e, c, t.bl_count);
}, ep = (t, n, e) => {
  let r, i, s = -1, a = n[1], o = 0, l = 7, c = 4;
  for (a === 0 && (l = 138, c = 3), n[2 * (e + 1) + 1] = 65535, r = 0; r <= e; r++)
    i = a, a = n[2 * (r + 1) + 1], ++o < l && i === a || (o < c ? t.bl_tree[2 * i] += o : i !== 0 ? (i !== s && t.bl_tree[2 * i]++, t.bl_tree[32]++) : o <= 10 ? t.bl_tree[34]++ : t.bl_tree[36]++, o = 0, s = i, a === 0 ? (l = 138, c = 3) : i === a ? (l = 6, c = 3) : (l = 7, c = 4));
}, tp = (t, n, e) => {
  let r, i, s = -1, a = n[1], o = 0, l = 7, c = 4;
  for (a === 0 && (l = 138, c = 3), r = 0; r <= e; r++)
    if (i = a, a = n[2 * (r + 1) + 1], !(++o < l && i === a)) {
      if (o < c)
        do
          oi(t, i, t.bl_tree);
        while (--o != 0);
      else
        i !== 0 ? (i !== s && (oi(t, i, t.bl_tree), o--), oi(t, 16, t.bl_tree), dr(t, o - 3, 2)) : o <= 10 ? (oi(t, 17, t.bl_tree), dr(t, o - 3, 3)) : (oi(t, 18, t.bl_tree), dr(t, o - 11, 7));
      o = 0, s = i, a === 0 ? (l = 138, c = 3) : i === a ? (l = 6, c = 3) : (l = 7, c = 4);
    }
};
let np = !1;
const rp = (t, n, e, r) => {
  dr(t, 0 + (r ? 1 : 0), 3), dm(t), wo(t, e), wo(t, ~e), e && t.pending_buf.set(t.window.subarray(n, n + e), t.pending), t.pending += e;
};
var vy = { _tr_init: (t) => {
  np || ((() => {
    let n, e, r, i, s;
    const a = new Array(16);
    for (r = 0, i = 0; i < 28; i++)
      for (zd[i] = r, n = 0; n < 1 << Ju[i]; n++)
        ro[r++] = i;
    for (ro[r - 1] = i, s = 0, i = 0; i < 16; i++)
      for (Gl[i] = s, n = 0; n < 1 << Cl[i]; n++)
        To[s++] = i;
    for (s >>= 7; i < 30; i++)
      for (Gl[i] = s << 7, n = 0; n < 1 << Cl[i] - 7; n++)
        To[256 + s++] = i;
    for (e = 0; e <= 15; e++)
      a[e] = 0;
    for (n = 0; n <= 143; )
      Ti[2 * n + 1] = 8, n++, a[8]++;
    for (; n <= 255; )
      Ti[2 * n + 1] = 9, n++, a[9]++;
    for (; n <= 279; )
      Ti[2 * n + 1] = 7, n++, a[7]++;
    for (; n <= 287; )
      Ti[2 * n + 1] = 8, n++, a[8]++;
    for (um(Ti, 287, a), n = 0; n < 30; n++)
      Ba[2 * n + 1] = 5, Ba[2 * n] = cm(n, 5);
    Qh = new qc(Ti, Ju, 257, 286, 15), Yh = new qc(Ba, Cl, 0, 30, 15), $h = new qc(new Array(0), gy, 0, 19, 7);
  })(), np = !0), t.l_desc = new Kc(t.dyn_ltree, Qh), t.d_desc = new Kc(t.dyn_dtree, Yh), t.bl_desc = new Kc(t.bl_tree, $h), t.bi_buf = 0, t.bi_valid = 0, Zh(t);
}, _tr_stored_block: rp, _tr_flush_block: (t, n, e, r) => {
  let i, s, a = 0;
  t.level > 0 ? (t.strm.data_type === 2 && (t.strm.data_type = ((o) => {
    let l, c = 4093624447;
    for (l = 0; l <= 31; l++, c >>>= 1)
      if (1 & c && o.dyn_ltree[2 * l] !== 0)
        return 0;
    if (o.dyn_ltree[18] !== 0 || o.dyn_ltree[20] !== 0 || o.dyn_ltree[26] !== 0)
      return 1;
    for (l = 32; l < 256; l++)
      if (o.dyn_ltree[2 * l] !== 0)
        return 1;
    return 0;
  })(t)), Qc(t, t.l_desc), Qc(t, t.d_desc), a = ((o) => {
    let l;
    for (ep(o, o.dyn_ltree, o.l_desc.max_code), ep(o, o.dyn_dtree, o.d_desc.max_code), Qc(o, o.bl_desc), l = 18; l >= 3 && o.bl_tree[2 * Wh[l] + 1] === 0; l--)
      ;
    return o.opt_len += 3 * (l + 1) + 5 + 5 + 4, l;
  })(t), i = t.opt_len + 3 + 7 >>> 3, s = t.static_len + 3 + 7 >>> 3, s <= i && (i = s)) : i = s = e + 5, e + 4 <= i && n !== -1 ? rp(t, n, e, r) : t.strategy === 4 || s === i ? (dr(t, 2 + (r ? 1 : 0), 3), Jh(t, Ti, Ba)) : (dr(t, 4 + (r ? 1 : 0), 3), ((o, l, c, u) => {
    let d;
    for (dr(o, l - 257, 5), dr(o, c - 1, 5), dr(o, u - 4, 4), d = 0; d < u; d++)
      dr(o, o.bl_tree[2 * Wh[d] + 1], 3);
    tp(o, o.dyn_ltree, l - 1), tp(o, o.dyn_dtree, c - 1);
  })(t, t.l_desc.max_code + 1, t.d_desc.max_code + 1, a + 1), Jh(t, t.dyn_ltree, t.dyn_dtree)), Zh(t), r && dm(t);
}, _tr_tally: (t, n, e) => (t.pending_buf[t.sym_buf + t.sym_next++] = n, t.pending_buf[t.sym_buf + t.sym_next++] = n >> 8, t.pending_buf[t.sym_buf + t.sym_next++] = e, n === 0 ? t.dyn_ltree[2 * e]++ : (t.matches++, n--, t.dyn_ltree[2 * (ro[e] + 256 + 1)]++, t.dyn_dtree[2 * lm(n)]++), t.sym_next === t.sym_end), _tr_align: (t) => {
  dr(t, 2, 3), oi(t, 256, Ti), ((n) => {
    n.bi_valid === 16 ? (wo(n, n.bi_buf), n.bi_buf = 0, n.bi_valid = 0) : n.bi_valid >= 8 && (n.pending_buf[n.pending++] = 255 & n.bi_buf, n.bi_buf >>= 8, n.bi_valid -= 8);
  })(t);
} }, io = (t, n, e, r) => {
  let i = 65535 & t, s = t >>> 16 & 65535, a = 0;
  for (; e !== 0; ) {
    a = e > 2e3 ? 2e3 : e, e -= a;
    do
      i = i + n[r++] | 0, s = s + i | 0;
    while (--a);
    i %= 65521, s %= 65521;
  }
  return i | s << 16;
};
const yy = new Uint32Array((() => {
  let t, n = [];
  for (var e = 0; e < 256; e++) {
    t = e;
    for (var r = 0; r < 8; r++)
      t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
    n[e] = t;
  }
  return n;
})());
var Dn = (t, n, e, r) => {
  const i = yy, s = r + e;
  t ^= -1;
  for (let a = r; a < s; a++)
    t = t >>> 8 ^ i[255 & (t ^ n[a])];
  return ~t;
}, Vs = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" }, Ys = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_MEM_ERROR: -4, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
const { _tr_init: by, _tr_stored_block: ed, _tr_flush_block: Ey, _tr_tally: ns, _tr_align: Cy } = vy, { Z_NO_FLUSH: rs, Z_PARTIAL_FLUSH: Ty, Z_FULL_FLUSH: wy, Z_FINISH: Rr, Z_BLOCK: ip, Z_OK: Bn, Z_STREAM_END: sp, Z_STREAM_ERROR: ri, Z_DATA_ERROR: Sy, Z_BUF_ERROR: Yc, Z_DEFAULT_COMPRESSION: Ny, Z_FILTERED: Iy, Z_HUFFMAN_ONLY: Yo, Z_RLE: Ay, Z_FIXED: My, Z_DEFAULT_STRATEGY: xy, Z_UNKNOWN: ky, Z_DEFLATED: ql } = Ys, ks = 258, hi = 262, aa = 42, ws = 113, za = 666, Ss = (t, n) => (t.msg = Vs[n], n), ap = (t) => 2 * t - (t > 4 ? 9 : 0), Zi = (t) => {
  let n = t.length;
  for (; --n >= 0; )
    t[n] = 0;
}, Oy = (t) => {
  let n, e, r, i = t.w_size;
  n = t.hash_size, r = n;
  do
    e = t.head[--r], t.head[r] = e >= i ? e - i : 0;
  while (--n);
  n = i, r = n;
  do
    e = t.prev[--r], t.prev[r] = e >= i ? e - i : 0;
  while (--n);
};
let is = (t, n, e) => (n << t.hash_shift ^ e) & t.hash_mask;
const gr = (t) => {
  const n = t.state;
  let e = n.pending;
  e > t.avail_out && (e = t.avail_out), e !== 0 && (t.output.set(n.pending_buf.subarray(n.pending_out, n.pending_out + e), t.next_out), t.next_out += e, n.pending_out += e, t.total_out += e, t.avail_out -= e, n.pending -= e, n.pending === 0 && (n.pending_out = 0));
}, Cr = (t, n) => {
  Ey(t, t.block_start >= 0 ? t.block_start : -1, t.strstart - t.block_start, n), t.block_start = t.strstart, gr(t.strm);
}, Ut = (t, n) => {
  t.pending_buf[t.pending++] = n;
}, Ma = (t, n) => {
  t.pending_buf[t.pending++] = n >>> 8 & 255, t.pending_buf[t.pending++] = 255 & n;
}, td = (t, n, e, r) => {
  let i = t.avail_in;
  return i > r && (i = r), i === 0 ? 0 : (t.avail_in -= i, n.set(t.input.subarray(t.next_in, t.next_in + i), e), t.state.wrap === 1 ? t.adler = io(t.adler, n, i, e) : t.state.wrap === 2 && (t.adler = Dn(t.adler, n, i, e)), t.next_in += i, t.total_in += i, i);
}, hm = (t, n) => {
  let e, r, i = t.max_chain_length, s = t.strstart, a = t.prev_length, o = t.nice_match;
  const l = t.strstart > t.w_size - hi ? t.strstart - (t.w_size - hi) : 0, c = t.window, u = t.w_mask, d = t.prev, h = t.strstart + ks;
  let p = c[s + a - 1], f = c[s + a];
  t.prev_length >= t.good_match && (i >>= 2), o > t.lookahead && (o = t.lookahead);
  do
    if (e = n, c[e + a] === f && c[e + a - 1] === p && c[e] === c[s] && c[++e] === c[s + 1]) {
      s += 2, e++;
      do
        ;
      while (c[++s] === c[++e] && c[++s] === c[++e] && c[++s] === c[++e] && c[++s] === c[++e] && c[++s] === c[++e] && c[++s] === c[++e] && c[++s] === c[++e] && c[++s] === c[++e] && s < h);
      if (r = ks - (h - s), s = h - ks, r > a) {
        if (t.match_start = n, a = r, r >= o)
          break;
        p = c[s + a - 1], f = c[s + a];
      }
    }
  while ((n = d[n & u]) > l && --i != 0);
  return a <= t.lookahead ? a : t.lookahead;
}, ra = (t) => {
  const n = t.w_size;
  let e, r, i;
  do {
    if (r = t.window_size - t.lookahead - t.strstart, t.strstart >= n + (n - hi) && (t.window.set(t.window.subarray(n, n + n - r), 0), t.match_start -= n, t.strstart -= n, t.block_start -= n, t.insert > t.strstart && (t.insert = t.strstart), Oy(t), r += n), t.strm.avail_in === 0)
      break;
    if (e = td(t.strm, t.window, t.strstart + t.lookahead, r), t.lookahead += e, t.lookahead + t.insert >= 3)
      for (i = t.strstart - t.insert, t.ins_h = t.window[i], t.ins_h = is(t, t.ins_h, t.window[i + 1]); t.insert && (t.ins_h = is(t, t.ins_h, t.window[i + 3 - 1]), t.prev[i & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = i, i++, t.insert--, !(t.lookahead + t.insert < 3)); )
        ;
  } while (t.lookahead < hi && t.strm.avail_in !== 0);
}, pm = (t, n) => {
  let e, r, i, s = t.pending_buf_size - 5 > t.w_size ? t.w_size : t.pending_buf_size - 5, a = 0, o = t.strm.avail_in;
  do {
    if (e = 65535, i = t.bi_valid + 42 >> 3, t.strm.avail_out < i || (i = t.strm.avail_out - i, r = t.strstart - t.block_start, e > r + t.strm.avail_in && (e = r + t.strm.avail_in), e > i && (e = i), e < s && (e === 0 && n !== Rr || n === rs || e !== r + t.strm.avail_in)))
      break;
    a = n === Rr && e === r + t.strm.avail_in ? 1 : 0, ed(t, 0, 0, a), t.pending_buf[t.pending - 4] = e, t.pending_buf[t.pending - 3] = e >> 8, t.pending_buf[t.pending - 2] = ~e, t.pending_buf[t.pending - 1] = ~e >> 8, gr(t.strm), r && (r > e && (r = e), t.strm.output.set(t.window.subarray(t.block_start, t.block_start + r), t.strm.next_out), t.strm.next_out += r, t.strm.avail_out -= r, t.strm.total_out += r, t.block_start += r, e -= r), e && (td(t.strm, t.strm.output, t.strm.next_out, e), t.strm.next_out += e, t.strm.avail_out -= e, t.strm.total_out += e);
  } while (a === 0);
  return o -= t.strm.avail_in, o && (o >= t.w_size ? (t.matches = 2, t.window.set(t.strm.input.subarray(t.strm.next_in - t.w_size, t.strm.next_in), 0), t.strstart = t.w_size, t.insert = t.strstart) : (t.window_size - t.strstart <= o && (t.strstart -= t.w_size, t.window.set(t.window.subarray(t.w_size, t.w_size + t.strstart), 0), t.matches < 2 && t.matches++, t.insert > t.strstart && (t.insert = t.strstart)), t.window.set(t.strm.input.subarray(t.strm.next_in - o, t.strm.next_in), t.strstart), t.strstart += o, t.insert += o > t.w_size - t.insert ? t.w_size - t.insert : o), t.block_start = t.strstart), t.high_water < t.strstart && (t.high_water = t.strstart), a ? 4 : n !== rs && n !== Rr && t.strm.avail_in === 0 && t.strstart === t.block_start ? 2 : (i = t.window_size - t.strstart, t.strm.avail_in > i && t.block_start >= t.w_size && (t.block_start -= t.w_size, t.strstart -= t.w_size, t.window.set(t.window.subarray(t.w_size, t.w_size + t.strstart), 0), t.matches < 2 && t.matches++, i += t.w_size, t.insert > t.strstart && (t.insert = t.strstart)), i > t.strm.avail_in && (i = t.strm.avail_in), i && (td(t.strm, t.window, t.strstart, i), t.strstart += i, t.insert += i > t.w_size - t.insert ? t.w_size - t.insert : i), t.high_water < t.strstart && (t.high_water = t.strstart), i = t.bi_valid + 42 >> 3, i = t.pending_buf_size - i > 65535 ? 65535 : t.pending_buf_size - i, s = i > t.w_size ? t.w_size : i, r = t.strstart - t.block_start, (r >= s || (r || n === Rr) && n !== rs && t.strm.avail_in === 0 && r <= i) && (e = r > i ? i : r, a = n === Rr && t.strm.avail_in === 0 && e === r ? 1 : 0, ed(t, t.block_start, e, a), t.block_start += e, gr(t.strm)), a ? 3 : 1);
}, $c = (t, n) => {
  let e, r;
  for (; ; ) {
    if (t.lookahead < hi) {
      if (ra(t), t.lookahead < hi && n === rs)
        return 1;
      if (t.lookahead === 0)
        break;
    }
    if (e = 0, t.lookahead >= 3 && (t.ins_h = is(t, t.ins_h, t.window[t.strstart + 3 - 1]), e = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), e !== 0 && t.strstart - e <= t.w_size - hi && (t.match_length = hm(t, e)), t.match_length >= 3)
      if (r = ns(t, t.strstart - t.match_start, t.match_length - 3), t.lookahead -= t.match_length, t.match_length <= t.max_lazy_match && t.lookahead >= 3) {
        t.match_length--;
        do
          t.strstart++, t.ins_h = is(t, t.ins_h, t.window[t.strstart + 3 - 1]), e = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart;
        while (--t.match_length != 0);
        t.strstart++;
      } else
        t.strstart += t.match_length, t.match_length = 0, t.ins_h = t.window[t.strstart], t.ins_h = is(t, t.ins_h, t.window[t.strstart + 1]);
    else
      r = ns(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++;
    if (r && (Cr(t, !1), t.strm.avail_out === 0))
      return 1;
  }
  return t.insert = t.strstart < 2 ? t.strstart : 2, n === Rr ? (Cr(t, !0), t.strm.avail_out === 0 ? 3 : 4) : t.sym_next && (Cr(t, !1), t.strm.avail_out === 0) ? 1 : 2;
}, Js = (t, n) => {
  let e, r, i;
  for (; ; ) {
    if (t.lookahead < hi) {
      if (ra(t), t.lookahead < hi && n === rs)
        return 1;
      if (t.lookahead === 0)
        break;
    }
    if (e = 0, t.lookahead >= 3 && (t.ins_h = is(t, t.ins_h, t.window[t.strstart + 3 - 1]), e = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), t.prev_length = t.match_length, t.prev_match = t.match_start, t.match_length = 2, e !== 0 && t.prev_length < t.max_lazy_match && t.strstart - e <= t.w_size - hi && (t.match_length = hm(t, e), t.match_length <= 5 && (t.strategy === Iy || t.match_length === 3 && t.strstart - t.match_start > 4096) && (t.match_length = 2)), t.prev_length >= 3 && t.match_length <= t.prev_length) {
      i = t.strstart + t.lookahead - 3, r = ns(t, t.strstart - 1 - t.prev_match, t.prev_length - 3), t.lookahead -= t.prev_length - 1, t.prev_length -= 2;
      do
        ++t.strstart <= i && (t.ins_h = is(t, t.ins_h, t.window[t.strstart + 3 - 1]), e = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart);
      while (--t.prev_length != 0);
      if (t.match_available = 0, t.match_length = 2, t.strstart++, r && (Cr(t, !1), t.strm.avail_out === 0))
        return 1;
    } else if (t.match_available) {
      if (r = ns(t, 0, t.window[t.strstart - 1]), r && Cr(t, !1), t.strstart++, t.lookahead--, t.strm.avail_out === 0)
        return 1;
    } else
      t.match_available = 1, t.strstart++, t.lookahead--;
  }
  return t.match_available && (r = ns(t, 0, t.window[t.strstart - 1]), t.match_available = 0), t.insert = t.strstart < 2 ? t.strstart : 2, n === Rr ? (Cr(t, !0), t.strm.avail_out === 0 ? 3 : 4) : t.sym_next && (Cr(t, !1), t.strm.avail_out === 0) ? 1 : 2;
};
function ti(t, n, e, r, i) {
  this.good_length = t, this.max_lazy = n, this.nice_length = e, this.max_chain = r, this.func = i;
}
const Va = [new ti(0, 0, 0, 0, pm), new ti(4, 4, 8, 4, $c), new ti(4, 5, 16, 8, $c), new ti(4, 6, 32, 32, $c), new ti(4, 4, 16, 16, Js), new ti(8, 16, 32, 32, Js), new ti(8, 16, 128, 128, Js), new ti(8, 32, 128, 256, Js), new ti(32, 128, 258, 1024, Js), new ti(32, 258, 258, 4096, Js)];
function Ry() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = ql, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(1146), this.dyn_dtree = new Uint16Array(122), this.bl_tree = new Uint16Array(78), Zi(this.dyn_ltree), Zi(this.dyn_dtree), Zi(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(16), this.heap = new Uint16Array(573), Zi(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(573), Zi(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const Ga = (t) => {
  if (!t)
    return 1;
  const n = t.state;
  return !n || n.strm !== t || n.status !== aa && n.status !== 57 && n.status !== 69 && n.status !== 73 && n.status !== 91 && n.status !== 103 && n.status !== ws && n.status !== za ? 1 : 0;
}, fm = (t) => {
  if (Ga(t))
    return Ss(t, ri);
  t.total_in = t.total_out = 0, t.data_type = ky;
  const n = t.state;
  return n.pending = 0, n.pending_out = 0, n.wrap < 0 && (n.wrap = -n.wrap), n.status = n.wrap === 2 ? 57 : n.wrap ? aa : ws, t.adler = n.wrap === 2 ? 0 : 1, n.last_flush = -2, by(n), Bn;
}, mm = (t) => {
  const n = fm(t);
  var e;
  return n === Bn && ((e = t.state).window_size = 2 * e.w_size, Zi(e.head), e.max_lazy_match = Va[e.level].max_lazy, e.good_match = Va[e.level].good_length, e.nice_match = Va[e.level].nice_length, e.max_chain_length = Va[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = 2, e.match_available = 0, e.ins_h = 0), n;
}, op = (t, n, e, r, i, s) => {
  if (!t)
    return ri;
  let a = 1;
  if (n === Ny && (n = 6), r < 0 ? (a = 0, r = -r) : r > 15 && (a = 2, r -= 16), i < 1 || i > 9 || e !== ql || r < 8 || r > 15 || n < 0 || n > 9 || s < 0 || s > My || r === 8 && a !== 1)
    return Ss(t, ri);
  r === 8 && (r = 9);
  const o = new Ry();
  return t.state = o, o.strm = t, o.status = aa, o.wrap = a, o.gzhead = null, o.w_bits = r, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + 3 - 1) / 3), o.window = new Uint8Array(2 * o.w_size), o.head = new Uint16Array(o.hash_size), o.prev = new Uint16Array(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new Uint8Array(o.pending_buf_size), o.sym_buf = o.lit_bufsize, o.sym_end = 3 * (o.lit_bufsize - 1), o.level = n, o.strategy = s, o.method = e, mm(t);
};
var so = { deflateInit: (t, n) => op(t, n, ql, 15, 8, xy), deflateInit2: op, deflateReset: mm, deflateResetKeep: fm, deflateSetHeader: (t, n) => Ga(t) || t.state.wrap !== 2 ? ri : (t.state.gzhead = n, Bn), deflate: (t, n) => {
  if (Ga(t) || n > ip || n < 0)
    return t ? Ss(t, ri) : ri;
  const e = t.state;
  if (!t.output || t.avail_in !== 0 && !t.input || e.status === za && n !== Rr)
    return Ss(t, t.avail_out === 0 ? Yc : ri);
  const r = e.last_flush;
  if (e.last_flush = n, e.pending !== 0) {
    if (gr(t), t.avail_out === 0)
      return e.last_flush = -1, Bn;
  } else if (t.avail_in === 0 && ap(n) <= ap(r) && n !== Rr)
    return Ss(t, Yc);
  if (e.status === za && t.avail_in !== 0)
    return Ss(t, Yc);
  if (e.status === aa && e.wrap === 0 && (e.status = ws), e.status === aa) {
    let i = ql + (e.w_bits - 8 << 4) << 8, s = -1;
    if (s = e.strategy >= Yo || e.level < 2 ? 0 : e.level < 6 ? 1 : e.level === 6 ? 2 : 3, i |= s << 6, e.strstart !== 0 && (i |= 32), i += 31 - i % 31, Ma(e, i), e.strstart !== 0 && (Ma(e, t.adler >>> 16), Ma(e, 65535 & t.adler)), t.adler = 1, e.status = ws, gr(t), e.pending !== 0)
      return e.last_flush = -1, Bn;
  }
  if (e.status === 57) {
    if (t.adler = 0, Ut(e, 31), Ut(e, 139), Ut(e, 8), e.gzhead)
      Ut(e, (e.gzhead.text ? 1 : 0) + (e.gzhead.hcrc ? 2 : 0) + (e.gzhead.extra ? 4 : 0) + (e.gzhead.name ? 8 : 0) + (e.gzhead.comment ? 16 : 0)), Ut(e, 255 & e.gzhead.time), Ut(e, e.gzhead.time >> 8 & 255), Ut(e, e.gzhead.time >> 16 & 255), Ut(e, e.gzhead.time >> 24 & 255), Ut(e, e.level === 9 ? 2 : e.strategy >= Yo || e.level < 2 ? 4 : 0), Ut(e, 255 & e.gzhead.os), e.gzhead.extra && e.gzhead.extra.length && (Ut(e, 255 & e.gzhead.extra.length), Ut(e, e.gzhead.extra.length >> 8 & 255)), e.gzhead.hcrc && (t.adler = Dn(t.adler, e.pending_buf, e.pending, 0)), e.gzindex = 0, e.status = 69;
    else if (Ut(e, 0), Ut(e, 0), Ut(e, 0), Ut(e, 0), Ut(e, 0), Ut(e, e.level === 9 ? 2 : e.strategy >= Yo || e.level < 2 ? 4 : 0), Ut(e, 3), e.status = ws, gr(t), e.pending !== 0)
      return e.last_flush = -1, Bn;
  }
  if (e.status === 69) {
    if (e.gzhead.extra) {
      let i = e.pending, s = (65535 & e.gzhead.extra.length) - e.gzindex;
      for (; e.pending + s > e.pending_buf_size; ) {
        let o = e.pending_buf_size - e.pending;
        if (e.pending_buf.set(e.gzhead.extra.subarray(e.gzindex, e.gzindex + o), e.pending), e.pending = e.pending_buf_size, e.gzhead.hcrc && e.pending > i && (t.adler = Dn(t.adler, e.pending_buf, e.pending - i, i)), e.gzindex += o, gr(t), e.pending !== 0)
          return e.last_flush = -1, Bn;
        i = 0, s -= o;
      }
      let a = new Uint8Array(e.gzhead.extra);
      e.pending_buf.set(a.subarray(e.gzindex, e.gzindex + s), e.pending), e.pending += s, e.gzhead.hcrc && e.pending > i && (t.adler = Dn(t.adler, e.pending_buf, e.pending - i, i)), e.gzindex = 0;
    }
    e.status = 73;
  }
  if (e.status === 73) {
    if (e.gzhead.name) {
      let i, s = e.pending;
      do {
        if (e.pending === e.pending_buf_size) {
          if (e.gzhead.hcrc && e.pending > s && (t.adler = Dn(t.adler, e.pending_buf, e.pending - s, s)), gr(t), e.pending !== 0)
            return e.last_flush = -1, Bn;
          s = 0;
        }
        i = e.gzindex < e.gzhead.name.length ? 255 & e.gzhead.name.charCodeAt(e.gzindex++) : 0, Ut(e, i);
      } while (i !== 0);
      e.gzhead.hcrc && e.pending > s && (t.adler = Dn(t.adler, e.pending_buf, e.pending - s, s)), e.gzindex = 0;
    }
    e.status = 91;
  }
  if (e.status === 91) {
    if (e.gzhead.comment) {
      let i, s = e.pending;
      do {
        if (e.pending === e.pending_buf_size) {
          if (e.gzhead.hcrc && e.pending > s && (t.adler = Dn(t.adler, e.pending_buf, e.pending - s, s)), gr(t), e.pending !== 0)
            return e.last_flush = -1, Bn;
          s = 0;
        }
        i = e.gzindex < e.gzhead.comment.length ? 255 & e.gzhead.comment.charCodeAt(e.gzindex++) : 0, Ut(e, i);
      } while (i !== 0);
      e.gzhead.hcrc && e.pending > s && (t.adler = Dn(t.adler, e.pending_buf, e.pending - s, s));
    }
    e.status = 103;
  }
  if (e.status === 103) {
    if (e.gzhead.hcrc) {
      if (e.pending + 2 > e.pending_buf_size && (gr(t), e.pending !== 0))
        return e.last_flush = -1, Bn;
      Ut(e, 255 & t.adler), Ut(e, t.adler >> 8 & 255), t.adler = 0;
    }
    if (e.status = ws, gr(t), e.pending !== 0)
      return e.last_flush = -1, Bn;
  }
  if (t.avail_in !== 0 || e.lookahead !== 0 || n !== rs && e.status !== za) {
    let i = e.level === 0 ? pm(e, n) : e.strategy === Yo ? ((s, a) => {
      let o;
      for (; ; ) {
        if (s.lookahead === 0 && (ra(s), s.lookahead === 0)) {
          if (a === rs)
            return 1;
          break;
        }
        if (s.match_length = 0, o = ns(s, 0, s.window[s.strstart]), s.lookahead--, s.strstart++, o && (Cr(s, !1), s.strm.avail_out === 0))
          return 1;
      }
      return s.insert = 0, a === Rr ? (Cr(s, !0), s.strm.avail_out === 0 ? 3 : 4) : s.sym_next && (Cr(s, !1), s.strm.avail_out === 0) ? 1 : 2;
    })(e, n) : e.strategy === Ay ? ((s, a) => {
      let o, l, c, u;
      const d = s.window;
      for (; ; ) {
        if (s.lookahead <= ks) {
          if (ra(s), s.lookahead <= ks && a === rs)
            return 1;
          if (s.lookahead === 0)
            break;
        }
        if (s.match_length = 0, s.lookahead >= 3 && s.strstart > 0 && (c = s.strstart - 1, l = d[c], l === d[++c] && l === d[++c] && l === d[++c])) {
          u = s.strstart + ks;
          do
            ;
          while (l === d[++c] && l === d[++c] && l === d[++c] && l === d[++c] && l === d[++c] && l === d[++c] && l === d[++c] && l === d[++c] && c < u);
          s.match_length = ks - (u - c), s.match_length > s.lookahead && (s.match_length = s.lookahead);
        }
        if (s.match_length >= 3 ? (o = ns(s, 1, s.match_length - 3), s.lookahead -= s.match_length, s.strstart += s.match_length, s.match_length = 0) : (o = ns(s, 0, s.window[s.strstart]), s.lookahead--, s.strstart++), o && (Cr(s, !1), s.strm.avail_out === 0))
          return 1;
      }
      return s.insert = 0, a === Rr ? (Cr(s, !0), s.strm.avail_out === 0 ? 3 : 4) : s.sym_next && (Cr(s, !1), s.strm.avail_out === 0) ? 1 : 2;
    })(e, n) : Va[e.level].func(e, n);
    if (i !== 3 && i !== 4 || (e.status = za), i === 1 || i === 3)
      return t.avail_out === 0 && (e.last_flush = -1), Bn;
    if (i === 2 && (n === Ty ? Cy(e) : n !== ip && (ed(e, 0, 0, !1), n === wy && (Zi(e.head), e.lookahead === 0 && (e.strstart = 0, e.block_start = 0, e.insert = 0))), gr(t), t.avail_out === 0))
      return e.last_flush = -1, Bn;
  }
  return n !== Rr ? Bn : e.wrap <= 0 ? sp : (e.wrap === 2 ? (Ut(e, 255 & t.adler), Ut(e, t.adler >> 8 & 255), Ut(e, t.adler >> 16 & 255), Ut(e, t.adler >> 24 & 255), Ut(e, 255 & t.total_in), Ut(e, t.total_in >> 8 & 255), Ut(e, t.total_in >> 16 & 255), Ut(e, t.total_in >> 24 & 255)) : (Ma(e, t.adler >>> 16), Ma(e, 65535 & t.adler)), gr(t), e.wrap > 0 && (e.wrap = -e.wrap), e.pending !== 0 ? Bn : sp);
}, deflateEnd: (t) => {
  if (Ga(t))
    return ri;
  const n = t.state.status;
  return t.state = null, n === ws ? Ss(t, Sy) : Bn;
}, deflateSetDictionary: (t, n) => {
  let e = n.length;
  if (Ga(t))
    return ri;
  const r = t.state, i = r.wrap;
  if (i === 2 || i === 1 && r.status !== aa || r.lookahead)
    return ri;
  if (i === 1 && (t.adler = io(t.adler, n, e, 0)), r.wrap = 0, e >= r.w_size) {
    i === 0 && (Zi(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0);
    let l = new Uint8Array(r.w_size);
    l.set(n.subarray(e - r.w_size, e), 0), n = l, e = r.w_size;
  }
  const s = t.avail_in, a = t.next_in, o = t.input;
  for (t.avail_in = e, t.next_in = 0, t.input = n, ra(r); r.lookahead >= 3; ) {
    let l = r.strstart, c = r.lookahead - 2;
    do
      r.ins_h = is(r, r.ins_h, r.window[l + 3 - 1]), r.prev[l & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = l, l++;
    while (--c);
    r.strstart = l, r.lookahead = 2, ra(r);
  }
  return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = 2, r.match_available = 0, t.next_in = a, t.input = o, t.avail_in = s, r.wrap = i, Bn;
}, deflateInfo: "pako deflate (from Nodeca project)" };
const Dy = (t, n) => Object.prototype.hasOwnProperty.call(t, n);
var _m = function(t) {
  const n = Array.prototype.slice.call(arguments, 1);
  for (; n.length; ) {
    const e = n.shift();
    if (e) {
      if (typeof e != "object")
        throw new TypeError(e + "must be non-object");
      for (const r in e)
        Dy(e, r) && (t[r] = e[r]);
    }
  }
  return t;
}, gm = (t) => {
  let n = 0;
  for (let r = 0, i = t.length; r < i; r++)
    n += t[r].length;
  const e = new Uint8Array(n);
  for (let r = 0, i = 0, s = t.length; r < s; r++) {
    let a = t[r];
    e.set(a, i), i += a.length;
  }
  return e;
};
let vm = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  vm = !1;
}
const So = new Uint8Array(256);
for (let t = 0; t < 256; t++)
  So[t] = t >= 252 ? 6 : t >= 248 ? 5 : t >= 240 ? 4 : t >= 224 ? 3 : t >= 192 ? 2 : 1;
So[254] = So[254] = 1;
var Vd = (t) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(t);
  let n, e, r, i, s, a = t.length, o = 0;
  for (i = 0; i < a; i++)
    e = t.charCodeAt(i), (64512 & e) == 55296 && i + 1 < a && (r = t.charCodeAt(i + 1), (64512 & r) == 56320 && (e = 65536 + (e - 55296 << 10) + (r - 56320), i++)), o += e < 128 ? 1 : e < 2048 ? 2 : e < 65536 ? 3 : 4;
  for (n = new Uint8Array(o), s = 0, i = 0; s < o; i++)
    e = t.charCodeAt(i), (64512 & e) == 55296 && i + 1 < a && (r = t.charCodeAt(i + 1), (64512 & r) == 56320 && (e = 65536 + (e - 55296 << 10) + (r - 56320), i++)), e < 128 ? n[s++] = e : e < 2048 ? (n[s++] = 192 | e >>> 6, n[s++] = 128 | 63 & e) : e < 65536 ? (n[s++] = 224 | e >>> 12, n[s++] = 128 | e >>> 6 & 63, n[s++] = 128 | 63 & e) : (n[s++] = 240 | e >>> 18, n[s++] = 128 | e >>> 12 & 63, n[s++] = 128 | e >>> 6 & 63, n[s++] = 128 | 63 & e);
  return n;
}, Ly = (t, n) => {
  const e = n || t.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(t.subarray(0, n));
  let r, i;
  const s = new Array(2 * e);
  for (i = 0, r = 0; r < e; ) {
    let a = t[r++];
    if (a < 128) {
      s[i++] = a;
      continue;
    }
    let o = So[a];
    if (o > 4)
      s[i++] = 65533, r += o - 1;
    else {
      for (a &= o === 2 ? 31 : o === 3 ? 15 : 7; o > 1 && r < e; )
        a = a << 6 | 63 & t[r++], o--;
      o > 1 ? s[i++] = 65533 : a < 65536 ? s[i++] = a : (a -= 65536, s[i++] = 55296 | a >> 10 & 1023, s[i++] = 56320 | 1023 & a);
    }
  }
  return ((a, o) => {
    if (o < 65534 && a.subarray && vm)
      return String.fromCharCode.apply(null, a.length === o ? a : a.subarray(0, o));
    let l = "";
    for (let c = 0; c < o; c++)
      l += String.fromCharCode(a[c]);
    return l;
  })(s, i);
}, Uy = (t, n) => {
  (n = n || t.length) > t.length && (n = t.length);
  let e = n - 1;
  for (; e >= 0 && (192 & t[e]) == 128; )
    e--;
  return e < 0 || e === 0 ? n : e + So[t[e]] > n ? e : n;
}, ym = function() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
};
const bm = Object.prototype.toString, { Z_NO_FLUSH: Py, Z_SYNC_FLUSH: Fy, Z_FULL_FLUSH: jy, Z_FINISH: Hy, Z_OK: Kl, Z_STREAM_END: By, Z_DEFAULT_COMPRESSION: zy, Z_DEFAULT_STRATEGY: Vy, Z_DEFLATED: Gy } = Ys;
function ao(t) {
  this.options = _m({ level: zy, method: Gy, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: Vy }, t || {});
  let n = this.options;
  n.raw && n.windowBits > 0 ? n.windowBits = -n.windowBits : n.gzip && n.windowBits > 0 && n.windowBits < 16 && (n.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new ym(), this.strm.avail_out = 0;
  let e = so.deflateInit2(this.strm, n.level, n.method, n.windowBits, n.memLevel, n.strategy);
  if (e !== Kl)
    throw new Error(Vs[e]);
  if (n.header && so.deflateSetHeader(this.strm, n.header), n.dictionary) {
    let r;
    if (r = typeof n.dictionary == "string" ? Vd(n.dictionary) : bm.call(n.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(n.dictionary) : n.dictionary, e = so.deflateSetDictionary(this.strm, r), e !== Kl)
      throw new Error(Vs[e]);
    this._dict_set = !0;
  }
}
function Zc(t, n) {
  const e = new ao(n);
  if (e.push(t, !0), e.err)
    throw e.msg || Vs[e.err];
  return e.result;
}
ao.prototype.push = function(t, n) {
  const e = this.strm, r = this.options.chunkSize;
  let i, s;
  if (this.ended)
    return !1;
  for (s = n === ~~n ? n : n === !0 ? Hy : Py, typeof t == "string" ? e.input = Vd(t) : bm.call(t) === "[object ArrayBuffer]" ? e.input = new Uint8Array(t) : e.input = t, e.next_in = 0, e.avail_in = e.input.length; ; )
    if (e.avail_out === 0 && (e.output = new Uint8Array(r), e.next_out = 0, e.avail_out = r), (s === Fy || s === jy) && e.avail_out <= 6)
      this.onData(e.output.subarray(0, e.next_out)), e.avail_out = 0;
    else {
      if (i = so.deflate(e, s), i === By)
        return e.next_out > 0 && this.onData(e.output.subarray(0, e.next_out)), i = so.deflateEnd(this.strm), this.onEnd(i), this.ended = !0, i === Kl;
      if (e.avail_out !== 0) {
        if (s > 0 && e.next_out > 0)
          this.onData(e.output.subarray(0, e.next_out)), e.avail_out = 0;
        else if (e.avail_in === 0)
          break;
      } else
        this.onData(e.output);
    }
  return !0;
}, ao.prototype.onData = function(t) {
  this.chunks.push(t);
}, ao.prototype.onEnd = function(t) {
  t === Kl && (this.result = gm(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
};
var qy = { Deflate: ao, deflate: Zc, deflateRaw: function(t, n) {
  return (n = n || {}).raw = !0, Zc(t, n);
}, gzip: function(t, n) {
  return (n = n || {}).gzip = !0, Zc(t, n);
}, constants: Ys };
const $o = 16209;
var Ky = function(t, n) {
  let e, r, i, s, a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M, I, x;
  const R = t.state;
  e = t.next_in, I = t.input, r = e + (t.avail_in - 5), i = t.next_out, x = t.output, s = i - (n - t.avail_out), a = i + (t.avail_out - 257), o = R.dmax, l = R.wsize, c = R.whave, u = R.wnext, d = R.window, h = R.hold, p = R.bits, f = R.lencode, m = R.distcode, v = (1 << R.lenbits) - 1, E = (1 << R.distbits) - 1;
  e:
    do {
      p < 15 && (h += I[e++] << p, p += 8, h += I[e++] << p, p += 8), y = f[h & v];
      t:
        for (; ; ) {
          if (b = y >>> 24, h >>>= b, p -= b, b = y >>> 16 & 255, b === 0)
            x[i++] = 65535 & y;
          else {
            if (!(16 & b)) {
              if (64 & b) {
                if (32 & b) {
                  R.mode = 16191;
                  break e;
                }
                t.msg = "invalid literal/length code", R.mode = $o;
                break e;
              }
              y = f[(65535 & y) + (h & (1 << b) - 1)];
              continue t;
            }
            for (T = 65535 & y, b &= 15, b && (p < b && (h += I[e++] << p, p += 8), T += h & (1 << b) - 1, h >>>= b, p -= b), p < 15 && (h += I[e++] << p, p += 8, h += I[e++] << p, p += 8), y = m[h & E]; ; ) {
              if (b = y >>> 24, h >>>= b, p -= b, b = y >>> 16 & 255, 16 & b) {
                if (w = 65535 & y, b &= 15, p < b && (h += I[e++] << p, p += 8, p < b && (h += I[e++] << p, p += 8)), w += h & (1 << b) - 1, w > o) {
                  t.msg = "invalid distance too far back", R.mode = $o;
                  break e;
                }
                if (h >>>= b, p -= b, b = i - s, w > b) {
                  if (b = w - b, b > c && R.sane) {
                    t.msg = "invalid distance too far back", R.mode = $o;
                    break e;
                  }
                  if (N = 0, M = d, u === 0) {
                    if (N += l - b, b < T) {
                      T -= b;
                      do
                        x[i++] = d[N++];
                      while (--b);
                      N = i - w, M = x;
                    }
                  } else if (u < b) {
                    if (N += l + u - b, b -= u, b < T) {
                      T -= b;
                      do
                        x[i++] = d[N++];
                      while (--b);
                      if (N = 0, u < T) {
                        b = u, T -= b;
                        do
                          x[i++] = d[N++];
                        while (--b);
                        N = i - w, M = x;
                      }
                    }
                  } else if (N += u - b, b < T) {
                    T -= b;
                    do
                      x[i++] = d[N++];
                    while (--b);
                    N = i - w, M = x;
                  }
                  for (; T > 2; )
                    x[i++] = M[N++], x[i++] = M[N++], x[i++] = M[N++], T -= 3;
                  T && (x[i++] = M[N++], T > 1 && (x[i++] = M[N++]));
                } else {
                  N = i - w;
                  do
                    x[i++] = x[N++], x[i++] = x[N++], x[i++] = x[N++], T -= 3;
                  while (T > 2);
                  T && (x[i++] = x[N++], T > 1 && (x[i++] = x[N++]));
                }
                break;
              }
              if (64 & b) {
                t.msg = "invalid distance code", R.mode = $o;
                break e;
              }
              y = m[(65535 & y) + (h & (1 << b) - 1)];
            }
          }
          break;
        }
    } while (e < r && i < a);
  T = p >> 3, e -= T, p -= T << 3, h &= (1 << p) - 1, t.next_in = e, t.next_out = i, t.avail_in = e < r ? r - e + 5 : 5 - (e - r), t.avail_out = i < a ? a - i + 257 : 257 - (i - a), R.hold = h, R.bits = p;
};
const Wy = new Uint16Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]), Qy = new Uint8Array([16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78]), Yy = new Uint16Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]), $y = new Uint8Array([16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64]);
var oo = (t, n, e, r, i, s, a, o) => {
  const l = o.bits;
  let c, u, d, h, p, f, m = 0, v = 0, E = 0, y = 0, b = 0, T = 0, w = 0, N = 0, M = 0, I = 0, x = null;
  const R = new Uint16Array(16), L = new Uint16Array(16);
  let j, P, q, G = null;
  for (m = 0; m <= 15; m++)
    R[m] = 0;
  for (v = 0; v < r; v++)
    R[n[e + v]]++;
  for (b = l, y = 15; y >= 1 && R[y] === 0; y--)
    ;
  if (b > y && (b = y), y === 0)
    return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
  for (E = 1; E < y && R[E] === 0; E++)
    ;
  for (b < E && (b = E), N = 1, m = 1; m <= 15; m++)
    if (N <<= 1, N -= R[m], N < 0)
      return -1;
  if (N > 0 && (t === 0 || y !== 1))
    return -1;
  for (L[1] = 0, m = 1; m < 15; m++)
    L[m + 1] = L[m] + R[m];
  for (v = 0; v < r; v++)
    n[e + v] !== 0 && (a[L[n[e + v]]++] = v);
  if (t === 0 ? (x = G = a, f = 20) : t === 1 ? (x = Wy, G = Qy, f = 257) : (x = Yy, G = $y, f = 0), I = 0, v = 0, m = E, p = s, T = b, w = 0, d = -1, M = 1 << b, h = M - 1, t === 1 && M > 852 || t === 2 && M > 592)
    return 1;
  for (; ; ) {
    j = m - w, a[v] + 1 < f ? (P = 0, q = a[v]) : a[v] >= f ? (P = G[a[v] - f], q = x[a[v] - f]) : (P = 96, q = 0), c = 1 << m - w, u = 1 << T, E = u;
    do
      u -= c, i[p + (I >> w) + u] = j << 24 | P << 16 | q;
    while (u !== 0);
    for (c = 1 << m - 1; I & c; )
      c >>= 1;
    if (c !== 0 ? (I &= c - 1, I += c) : I = 0, v++, --R[m] == 0) {
      if (m === y)
        break;
      m = n[e + a[v]];
    }
    if (m > b && (I & h) !== d) {
      for (w === 0 && (w = b), p += E, T = m - w, N = 1 << T; T + w < y && (N -= R[T + w], !(N <= 0)); )
        T++, N <<= 1;
      if (M += 1 << T, t === 1 && M > 852 || t === 2 && M > 592)
        return 1;
      d = I & h, i[d] = b << 24 | T << 16 | p - s;
    }
  }
  return I !== 0 && (i[p + I] = m - w << 24 | 64 << 16), o.bits = b, 0;
};
const { Z_FINISH: lp, Z_BLOCK: Zy, Z_TREES: Zo, Z_OK: Ns, Z_STREAM_END: Xy, Z_NEED_DICT: Jy, Z_STREAM_ERROR: Or, Z_DATA_ERROR: cp, Z_MEM_ERROR: up, Z_BUF_ERROR: e1, Z_DEFLATED: dp } = Ys, gc = 16180, Xo = 16190, bi = 16191, Xc = 16192, Jc = 16194, Jo = 16199, el = 16200, eu = 16206, an = 16209, hp = (t) => (t >>> 24 & 255) + (t >>> 8 & 65280) + ((65280 & t) << 8) + ((255 & t) << 24);
function t1() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const Os = (t) => {
  if (!t)
    return 1;
  const n = t.state;
  return !n || n.strm !== t || n.mode < gc || n.mode > 16211 ? 1 : 0;
}, Em = (t) => {
  if (Os(t))
    return Or;
  const n = t.state;
  return t.total_in = t.total_out = n.total = 0, t.msg = "", n.wrap && (t.adler = 1 & n.wrap), n.mode = gc, n.last = 0, n.havedict = 0, n.flags = -1, n.dmax = 32768, n.head = null, n.hold = 0, n.bits = 0, n.lencode = n.lendyn = new Int32Array(852), n.distcode = n.distdyn = new Int32Array(592), n.sane = 1, n.back = -1, Ns;
}, Cm = (t) => {
  if (Os(t))
    return Or;
  const n = t.state;
  return n.wsize = 0, n.whave = 0, n.wnext = 0, Em(t);
}, Tm = (t, n) => {
  let e;
  if (Os(t))
    return Or;
  const r = t.state;
  return n < 0 ? (e = 0, n = -n) : (e = 5 + (n >> 4), n < 48 && (n &= 15)), n && (n < 8 || n > 15) ? Or : (r.window !== null && r.wbits !== n && (r.window = null), r.wrap = e, r.wbits = n, Cm(t));
}, pp = (t, n) => {
  if (!t)
    return Or;
  const e = new t1();
  t.state = e, e.strm = t, e.window = null, e.mode = gc;
  const r = Tm(t, n);
  return r !== Ns && (t.state = null), r;
};
let tu, nu, fp = !0;
const n1 = (t) => {
  if (fp) {
    tu = new Int32Array(512), nu = new Int32Array(32);
    let n = 0;
    for (; n < 144; )
      t.lens[n++] = 8;
    for (; n < 256; )
      t.lens[n++] = 9;
    for (; n < 280; )
      t.lens[n++] = 7;
    for (; n < 288; )
      t.lens[n++] = 8;
    for (oo(1, t.lens, 0, 288, tu, 0, t.work, { bits: 9 }), n = 0; n < 32; )
      t.lens[n++] = 5;
    oo(2, t.lens, 0, 32, nu, 0, t.work, { bits: 5 }), fp = !1;
  }
  t.lencode = tu, t.lenbits = 9, t.distcode = nu, t.distbits = 5;
}, mp = (t, n, e, r) => {
  let i;
  const s = t.state;
  return s.window === null && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new Uint8Array(s.wsize)), r >= s.wsize ? (s.window.set(n.subarray(e - s.wsize, e), 0), s.wnext = 0, s.whave = s.wsize) : (i = s.wsize - s.wnext, i > r && (i = r), s.window.set(n.subarray(e - r, e - r + i), s.wnext), (r -= i) ? (s.window.set(n.subarray(e - r, e), 0), s.wnext = r, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
};
var Ai = { inflateReset: Cm, inflateReset2: Tm, inflateResetKeep: Em, inflateInit: (t) => pp(t, 15), inflateInit2: pp, inflate: (t, n) => {
  let e, r, i, s, a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M, I = 0;
  const x = new Uint8Array(4);
  let R, L;
  const j = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
  if (Os(t) || !t.output || !t.input && t.avail_in !== 0)
    return Or;
  e = t.state, e.mode === bi && (e.mode = Xc), a = t.next_out, i = t.output, l = t.avail_out, s = t.next_in, r = t.input, o = t.avail_in, c = e.hold, u = e.bits, d = o, h = l, M = Ns;
  e:
    for (; ; )
      switch (e.mode) {
        case gc:
          if (e.wrap === 0) {
            e.mode = Xc;
            break;
          }
          for (; u < 16; ) {
            if (o === 0)
              break e;
            o--, c += r[s++] << u, u += 8;
          }
          if (2 & e.wrap && c === 35615) {
            e.wbits === 0 && (e.wbits = 15), e.check = 0, x[0] = 255 & c, x[1] = c >>> 8 & 255, e.check = Dn(e.check, x, 2, 0), c = 0, u = 0, e.mode = 16181;
            break;
          }
          if (e.head && (e.head.done = !1), !(1 & e.wrap) || (((255 & c) << 8) + (c >> 8)) % 31) {
            t.msg = "incorrect header check", e.mode = an;
            break;
          }
          if ((15 & c) !== dp) {
            t.msg = "unknown compression method", e.mode = an;
            break;
          }
          if (c >>>= 4, u -= 4, N = 8 + (15 & c), e.wbits === 0 && (e.wbits = N), N > 15 || N > e.wbits) {
            t.msg = "invalid window size", e.mode = an;
            break;
          }
          e.dmax = 1 << e.wbits, e.flags = 0, t.adler = e.check = 1, e.mode = 512 & c ? 16189 : bi, c = 0, u = 0;
          break;
        case 16181:
          for (; u < 16; ) {
            if (o === 0)
              break e;
            o--, c += r[s++] << u, u += 8;
          }
          if (e.flags = c, (255 & e.flags) !== dp) {
            t.msg = "unknown compression method", e.mode = an;
            break;
          }
          if (57344 & e.flags) {
            t.msg = "unknown header flags set", e.mode = an;
            break;
          }
          e.head && (e.head.text = c >> 8 & 1), 512 & e.flags && 4 & e.wrap && (x[0] = 255 & c, x[1] = c >>> 8 & 255, e.check = Dn(e.check, x, 2, 0)), c = 0, u = 0, e.mode = 16182;
        case 16182:
          for (; u < 32; ) {
            if (o === 0)
              break e;
            o--, c += r[s++] << u, u += 8;
          }
          e.head && (e.head.time = c), 512 & e.flags && 4 & e.wrap && (x[0] = 255 & c, x[1] = c >>> 8 & 255, x[2] = c >>> 16 & 255, x[3] = c >>> 24 & 255, e.check = Dn(e.check, x, 4, 0)), c = 0, u = 0, e.mode = 16183;
        case 16183:
          for (; u < 16; ) {
            if (o === 0)
              break e;
            o--, c += r[s++] << u, u += 8;
          }
          e.head && (e.head.xflags = 255 & c, e.head.os = c >> 8), 512 & e.flags && 4 & e.wrap && (x[0] = 255 & c, x[1] = c >>> 8 & 255, e.check = Dn(e.check, x, 2, 0)), c = 0, u = 0, e.mode = 16184;
        case 16184:
          if (1024 & e.flags) {
            for (; u < 16; ) {
              if (o === 0)
                break e;
              o--, c += r[s++] << u, u += 8;
            }
            e.length = c, e.head && (e.head.extra_len = c), 512 & e.flags && 4 & e.wrap && (x[0] = 255 & c, x[1] = c >>> 8 & 255, e.check = Dn(e.check, x, 2, 0)), c = 0, u = 0;
          } else
            e.head && (e.head.extra = null);
          e.mode = 16185;
        case 16185:
          if (1024 & e.flags && (p = e.length, p > o && (p = o), p && (e.head && (N = e.head.extra_len - e.length, e.head.extra || (e.head.extra = new Uint8Array(e.head.extra_len)), e.head.extra.set(r.subarray(s, s + p), N)), 512 & e.flags && 4 & e.wrap && (e.check = Dn(e.check, r, p, s)), o -= p, s += p, e.length -= p), e.length))
            break e;
          e.length = 0, e.mode = 16186;
        case 16186:
          if (2048 & e.flags) {
            if (o === 0)
              break e;
            p = 0;
            do
              N = r[s + p++], e.head && N && e.length < 65536 && (e.head.name += String.fromCharCode(N));
            while (N && p < o);
            if (512 & e.flags && 4 & e.wrap && (e.check = Dn(e.check, r, p, s)), o -= p, s += p, N)
              break e;
          } else
            e.head && (e.head.name = null);
          e.length = 0, e.mode = 16187;
        case 16187:
          if (4096 & e.flags) {
            if (o === 0)
              break e;
            p = 0;
            do
              N = r[s + p++], e.head && N && e.length < 65536 && (e.head.comment += String.fromCharCode(N));
            while (N && p < o);
            if (512 & e.flags && 4 & e.wrap && (e.check = Dn(e.check, r, p, s)), o -= p, s += p, N)
              break e;
          } else
            e.head && (e.head.comment = null);
          e.mode = 16188;
        case 16188:
          if (512 & e.flags) {
            for (; u < 16; ) {
              if (o === 0)
                break e;
              o--, c += r[s++] << u, u += 8;
            }
            if (4 & e.wrap && c !== (65535 & e.check)) {
              t.msg = "header crc mismatch", e.mode = an;
              break;
            }
            c = 0, u = 0;
          }
          e.head && (e.head.hcrc = e.flags >> 9 & 1, e.head.done = !0), t.adler = e.check = 0, e.mode = bi;
          break;
        case 16189:
          for (; u < 32; ) {
            if (o === 0)
              break e;
            o--, c += r[s++] << u, u += 8;
          }
          t.adler = e.check = hp(c), c = 0, u = 0, e.mode = Xo;
        case Xo:
          if (e.havedict === 0)
            return t.next_out = a, t.avail_out = l, t.next_in = s, t.avail_in = o, e.hold = c, e.bits = u, Jy;
          t.adler = e.check = 1, e.mode = bi;
        case bi:
          if (n === Zy || n === Zo)
            break e;
        case Xc:
          if (e.last) {
            c >>>= 7 & u, u -= 7 & u, e.mode = eu;
            break;
          }
          for (; u < 3; ) {
            if (o === 0)
              break e;
            o--, c += r[s++] << u, u += 8;
          }
          switch (e.last = 1 & c, c >>>= 1, u -= 1, 3 & c) {
            case 0:
              e.mode = 16193;
              break;
            case 1:
              if (n1(e), e.mode = Jo, n === Zo) {
                c >>>= 2, u -= 2;
                break e;
              }
              break;
            case 2:
              e.mode = 16196;
              break;
            case 3:
              t.msg = "invalid block type", e.mode = an;
          }
          c >>>= 2, u -= 2;
          break;
        case 16193:
          for (c >>>= 7 & u, u -= 7 & u; u < 32; ) {
            if (o === 0)
              break e;
            o--, c += r[s++] << u, u += 8;
          }
          if ((65535 & c) != (c >>> 16 ^ 65535)) {
            t.msg = "invalid stored block lengths", e.mode = an;
            break;
          }
          if (e.length = 65535 & c, c = 0, u = 0, e.mode = Jc, n === Zo)
            break e;
        case Jc:
          e.mode = 16195;
        case 16195:
          if (p = e.length, p) {
            if (p > o && (p = o), p > l && (p = l), p === 0)
              break e;
            i.set(r.subarray(s, s + p), a), o -= p, s += p, l -= p, a += p, e.length -= p;
            break;
          }
          e.mode = bi;
          break;
        case 16196:
          for (; u < 14; ) {
            if (o === 0)
              break e;
            o--, c += r[s++] << u, u += 8;
          }
          if (e.nlen = 257 + (31 & c), c >>>= 5, u -= 5, e.ndist = 1 + (31 & c), c >>>= 5, u -= 5, e.ncode = 4 + (15 & c), c >>>= 4, u -= 4, e.nlen > 286 || e.ndist > 30) {
            t.msg = "too many length or distance symbols", e.mode = an;
            break;
          }
          e.have = 0, e.mode = 16197;
        case 16197:
          for (; e.have < e.ncode; ) {
            for (; u < 3; ) {
              if (o === 0)
                break e;
              o--, c += r[s++] << u, u += 8;
            }
            e.lens[j[e.have++]] = 7 & c, c >>>= 3, u -= 3;
          }
          for (; e.have < 19; )
            e.lens[j[e.have++]] = 0;
          if (e.lencode = e.lendyn, e.lenbits = 7, R = { bits: e.lenbits }, M = oo(0, e.lens, 0, 19, e.lencode, 0, e.work, R), e.lenbits = R.bits, M) {
            t.msg = "invalid code lengths set", e.mode = an;
            break;
          }
          e.have = 0, e.mode = 16198;
        case 16198:
          for (; e.have < e.nlen + e.ndist; ) {
            for (; I = e.lencode[c & (1 << e.lenbits) - 1], v = I >>> 24, E = I >>> 16 & 255, y = 65535 & I, !(v <= u); ) {
              if (o === 0)
                break e;
              o--, c += r[s++] << u, u += 8;
            }
            if (y < 16)
              c >>>= v, u -= v, e.lens[e.have++] = y;
            else {
              if (y === 16) {
                for (L = v + 2; u < L; ) {
                  if (o === 0)
                    break e;
                  o--, c += r[s++] << u, u += 8;
                }
                if (c >>>= v, u -= v, e.have === 0) {
                  t.msg = "invalid bit length repeat", e.mode = an;
                  break;
                }
                N = e.lens[e.have - 1], p = 3 + (3 & c), c >>>= 2, u -= 2;
              } else if (y === 17) {
                for (L = v + 3; u < L; ) {
                  if (o === 0)
                    break e;
                  o--, c += r[s++] << u, u += 8;
                }
                c >>>= v, u -= v, N = 0, p = 3 + (7 & c), c >>>= 3, u -= 3;
              } else {
                for (L = v + 7; u < L; ) {
                  if (o === 0)
                    break e;
                  o--, c += r[s++] << u, u += 8;
                }
                c >>>= v, u -= v, N = 0, p = 11 + (127 & c), c >>>= 7, u -= 7;
              }
              if (e.have + p > e.nlen + e.ndist) {
                t.msg = "invalid bit length repeat", e.mode = an;
                break;
              }
              for (; p--; )
                e.lens[e.have++] = N;
            }
          }
          if (e.mode === an)
            break;
          if (e.lens[256] === 0) {
            t.msg = "invalid code -- missing end-of-block", e.mode = an;
            break;
          }
          if (e.lenbits = 9, R = { bits: e.lenbits }, M = oo(1, e.lens, 0, e.nlen, e.lencode, 0, e.work, R), e.lenbits = R.bits, M) {
            t.msg = "invalid literal/lengths set", e.mode = an;
            break;
          }
          if (e.distbits = 6, e.distcode = e.distdyn, R = { bits: e.distbits }, M = oo(2, e.lens, e.nlen, e.ndist, e.distcode, 0, e.work, R), e.distbits = R.bits, M) {
            t.msg = "invalid distances set", e.mode = an;
            break;
          }
          if (e.mode = Jo, n === Zo)
            break e;
        case Jo:
          e.mode = el;
        case el:
          if (o >= 6 && l >= 258) {
            t.next_out = a, t.avail_out = l, t.next_in = s, t.avail_in = o, e.hold = c, e.bits = u, Ky(t, h), a = t.next_out, i = t.output, l = t.avail_out, s = t.next_in, r = t.input, o = t.avail_in, c = e.hold, u = e.bits, e.mode === bi && (e.back = -1);
            break;
          }
          for (e.back = 0; I = e.lencode[c & (1 << e.lenbits) - 1], v = I >>> 24, E = I >>> 16 & 255, y = 65535 & I, !(v <= u); ) {
            if (o === 0)
              break e;
            o--, c += r[s++] << u, u += 8;
          }
          if (E && !(240 & E)) {
            for (b = v, T = E, w = y; I = e.lencode[w + ((c & (1 << b + T) - 1) >> b)], v = I >>> 24, E = I >>> 16 & 255, y = 65535 & I, !(b + v <= u); ) {
              if (o === 0)
                break e;
              o--, c += r[s++] << u, u += 8;
            }
            c >>>= b, u -= b, e.back += b;
          }
          if (c >>>= v, u -= v, e.back += v, e.length = y, E === 0) {
            e.mode = 16205;
            break;
          }
          if (32 & E) {
            e.back = -1, e.mode = bi;
            break;
          }
          if (64 & E) {
            t.msg = "invalid literal/length code", e.mode = an;
            break;
          }
          e.extra = 15 & E, e.mode = 16201;
        case 16201:
          if (e.extra) {
            for (L = e.extra; u < L; ) {
              if (o === 0)
                break e;
              o--, c += r[s++] << u, u += 8;
            }
            e.length += c & (1 << e.extra) - 1, c >>>= e.extra, u -= e.extra, e.back += e.extra;
          }
          e.was = e.length, e.mode = 16202;
        case 16202:
          for (; I = e.distcode[c & (1 << e.distbits) - 1], v = I >>> 24, E = I >>> 16 & 255, y = 65535 & I, !(v <= u); ) {
            if (o === 0)
              break e;
            o--, c += r[s++] << u, u += 8;
          }
          if (!(240 & E)) {
            for (b = v, T = E, w = y; I = e.distcode[w + ((c & (1 << b + T) - 1) >> b)], v = I >>> 24, E = I >>> 16 & 255, y = 65535 & I, !(b + v <= u); ) {
              if (o === 0)
                break e;
              o--, c += r[s++] << u, u += 8;
            }
            c >>>= b, u -= b, e.back += b;
          }
          if (c >>>= v, u -= v, e.back += v, 64 & E) {
            t.msg = "invalid distance code", e.mode = an;
            break;
          }
          e.offset = y, e.extra = 15 & E, e.mode = 16203;
        case 16203:
          if (e.extra) {
            for (L = e.extra; u < L; ) {
              if (o === 0)
                break e;
              o--, c += r[s++] << u, u += 8;
            }
            e.offset += c & (1 << e.extra) - 1, c >>>= e.extra, u -= e.extra, e.back += e.extra;
          }
          if (e.offset > e.dmax) {
            t.msg = "invalid distance too far back", e.mode = an;
            break;
          }
          e.mode = 16204;
        case 16204:
          if (l === 0)
            break e;
          if (p = h - l, e.offset > p) {
            if (p = e.offset - p, p > e.whave && e.sane) {
              t.msg = "invalid distance too far back", e.mode = an;
              break;
            }
            p > e.wnext ? (p -= e.wnext, f = e.wsize - p) : f = e.wnext - p, p > e.length && (p = e.length), m = e.window;
          } else
            m = i, f = a - e.offset, p = e.length;
          p > l && (p = l), l -= p, e.length -= p;
          do
            i[a++] = m[f++];
          while (--p);
          e.length === 0 && (e.mode = el);
          break;
        case 16205:
          if (l === 0)
            break e;
          i[a++] = e.length, l--, e.mode = el;
          break;
        case eu:
          if (e.wrap) {
            for (; u < 32; ) {
              if (o === 0)
                break e;
              o--, c |= r[s++] << u, u += 8;
            }
            if (h -= l, t.total_out += h, e.total += h, 4 & e.wrap && h && (t.adler = e.check = e.flags ? Dn(e.check, i, h, a - h) : io(e.check, i, h, a - h)), h = l, 4 & e.wrap && (e.flags ? c : hp(c)) !== e.check) {
              t.msg = "incorrect data check", e.mode = an;
              break;
            }
            c = 0, u = 0;
          }
          e.mode = 16207;
        case 16207:
          if (e.wrap && e.flags) {
            for (; u < 32; ) {
              if (o === 0)
                break e;
              o--, c += r[s++] << u, u += 8;
            }
            if (4 & e.wrap && c !== (4294967295 & e.total)) {
              t.msg = "incorrect length check", e.mode = an;
              break;
            }
            c = 0, u = 0;
          }
          e.mode = 16208;
        case 16208:
          M = Xy;
          break e;
        case an:
          M = cp;
          break e;
        case 16210:
          return up;
        default:
          return Or;
      }
  return t.next_out = a, t.avail_out = l, t.next_in = s, t.avail_in = o, e.hold = c, e.bits = u, (e.wsize || h !== t.avail_out && e.mode < an && (e.mode < eu || n !== lp)) && mp(t, t.output, t.next_out, h - t.avail_out), d -= t.avail_in, h -= t.avail_out, t.total_in += d, t.total_out += h, e.total += h, 4 & e.wrap && h && (t.adler = e.check = e.flags ? Dn(e.check, i, h, t.next_out - h) : io(e.check, i, h, t.next_out - h)), t.data_type = e.bits + (e.last ? 64 : 0) + (e.mode === bi ? 128 : 0) + (e.mode === Jo || e.mode === Jc ? 256 : 0), (d === 0 && h === 0 || n === lp) && M === Ns && (M = e1), M;
}, inflateEnd: (t) => {
  if (Os(t))
    return Or;
  let n = t.state;
  return n.window && (n.window = null), t.state = null, Ns;
}, inflateGetHeader: (t, n) => {
  if (Os(t))
    return Or;
  const e = t.state;
  return 2 & e.wrap ? (e.head = n, n.done = !1, Ns) : Or;
}, inflateSetDictionary: (t, n) => {
  const e = n.length;
  let r, i, s;
  return Os(t) ? Or : (r = t.state, r.wrap !== 0 && r.mode !== Xo ? Or : r.mode === Xo && (i = 1, i = io(i, n, e, 0), i !== r.check) ? cp : (s = mp(t, n, e, e), s ? (r.mode = 16210, up) : (r.havedict = 1, Ns)));
}, inflateInfo: "pako inflate (from Nodeca project)" }, r1 = function() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
};
const wm = Object.prototype.toString, { Z_NO_FLUSH: i1, Z_FINISH: s1, Z_OK: lo, Z_STREAM_END: ru, Z_NEED_DICT: iu, Z_STREAM_ERROR: a1, Z_DATA_ERROR: _p, Z_MEM_ERROR: o1 } = Ys;
function co(t) {
  this.options = _m({ chunkSize: 65536, windowBits: 15, to: "" }, t || {});
  const n = this.options;
  n.raw && n.windowBits >= 0 && n.windowBits < 16 && (n.windowBits = -n.windowBits, n.windowBits === 0 && (n.windowBits = -15)), !(n.windowBits >= 0 && n.windowBits < 16) || t && t.windowBits || (n.windowBits += 32), n.windowBits > 15 && n.windowBits < 48 && (15 & n.windowBits || (n.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new ym(), this.strm.avail_out = 0;
  let e = Ai.inflateInit2(this.strm, n.windowBits);
  if (e !== lo)
    throw new Error(Vs[e]);
  if (this.header = new r1(), Ai.inflateGetHeader(this.strm, this.header), n.dictionary && (typeof n.dictionary == "string" ? n.dictionary = Vd(n.dictionary) : wm.call(n.dictionary) === "[object ArrayBuffer]" && (n.dictionary = new Uint8Array(n.dictionary)), n.raw && (e = Ai.inflateSetDictionary(this.strm, n.dictionary), e !== lo)))
    throw new Error(Vs[e]);
}
function su(t, n) {
  const e = new co(n);
  if (e.push(t), e.err)
    throw e.msg || Vs[e.err];
  return e.result;
}
co.prototype.push = function(t, n) {
  const e = this.strm, r = this.options.chunkSize, i = this.options.dictionary;
  let s, a, o;
  if (this.ended)
    return !1;
  for (a = n === ~~n ? n : n === !0 ? s1 : i1, wm.call(t) === "[object ArrayBuffer]" ? e.input = new Uint8Array(t) : e.input = t, e.next_in = 0, e.avail_in = e.input.length; ; ) {
    for (e.avail_out === 0 && (e.output = new Uint8Array(r), e.next_out = 0, e.avail_out = r), s = Ai.inflate(e, a), s === iu && i && (s = Ai.inflateSetDictionary(e, i), s === lo ? s = Ai.inflate(e, a) : s === _p && (s = iu)); e.avail_in > 0 && s === ru && e.state.wrap > 0 && t[e.next_in] !== 0; )
      Ai.inflateReset(e), s = Ai.inflate(e, a);
    switch (s) {
      case a1:
      case _p:
      case iu:
      case o1:
        return this.onEnd(s), this.ended = !0, !1;
    }
    if (o = e.avail_out, e.next_out && (e.avail_out === 0 || s === ru))
      if (this.options.to === "string") {
        let l = Uy(e.output, e.next_out), c = e.next_out - l, u = Ly(e.output, l);
        e.next_out = c, e.avail_out = r - c, c && e.output.set(e.output.subarray(l, l + c), 0), this.onData(u);
      } else
        this.onData(e.output.length === e.next_out ? e.output : e.output.subarray(0, e.next_out));
    if (s !== lo || o !== 0) {
      if (s === ru)
        return s = Ai.inflateEnd(this.strm), this.onEnd(s), this.ended = !0, !0;
      if (e.avail_in === 0)
        break;
    }
  }
  return !0;
}, co.prototype.onData = function(t) {
  this.chunks.push(t);
}, co.prototype.onEnd = function(t) {
  t === lo && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = gm(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
};
var l1 = { Inflate: co, inflate: su, inflateRaw: function(t, n) {
  return (n = n || {}).raw = !0, su(t, n);
}, ungzip: su, constants: Ys };
const { Deflate: c1, deflate: u1, deflateRaw: d1, gzip: h1 } = qy, { Inflate: p1, inflate: f1, inflateRaw: m1, ungzip: _1 } = l1;
var li, g1 = { Deflate: c1, deflate: u1, deflateRaw: d1, gzip: h1, Inflate: p1, inflate: f1, inflateRaw: m1, ungzip: _1, constants: Ys }, au = function(t) {
  return g(void 0, 0, void 0, function() {
    var n;
    return _(this, function(e) {
      return n = g1.ungzip(t), [2, String.fromCharCode.apply(null, n)];
    });
  });
};
(function(t) {
  t.CONNECTING = "CONNECTING", t.OPEN = "OPEN", t.CLOSED = "CLOSED";
})(li || (li = {}));
var bt, v1 = function(t) {
  function n(e, r) {
    var i = r.sdkState, s = r.dispatcher, a = r.logger, o = t.call(this) || this;
    return o.lastActive = 0, o._iid = e, o._sdkState = i, o._dispatcher = s, o._logger = a, o;
  }
  return S(n, t), Object.defineProperty(n.prototype, "isOpen", { get: function() {
    return this.connectionState === li.OPEN;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "connectionState", { get: function() {
    if (this._ws)
      switch (this._ws.readyState) {
        case 0:
          return li.CONNECTING;
        case 1:
          return li.OPEN;
      }
    return li.CLOSED;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "ws", { get: function() {
    var e;
    return (e = this._ws) !== null && e !== void 0 ? e : null;
  }, enumerable: !1, configurable: !0 }), n.prototype._handleMessage = function(e) {
    var r = this;
    e.split(`
`).forEach(function(i) {
      if (i) {
        var s = Lt.createFromRawMessage(r._iid, i);
        if (r._logger.debug("receive websocket event", s), s.code === "LOGI")
          r.dispatch("message", s);
        else if (s.code === "PONG")
          r.dispatch("pong");
        else if (s.code === "EXPR") {
          if (s.payload) {
            var a = new fa(s.payload);
            a.expiresIn >= 0 && r._dispatcher.dispatch(a);
          }
        } else
          s.code === "NOOP" || r.dispatch("message", s);
      }
    });
  }, n.prototype.connect = function(e, r) {
    return r === void 0 && (r = ""), g(this, 0, void 0, function() {
      var i = this;
      return _(this, function(s) {
        return this._ws = new WebSocket(e, encodeURIComponent(r)), this._ws.onopen = function() {
          i._logger.debug("websocket open"), i.dispatch("open");
        }, this._ws.onmessage = function(a) {
          return g(i, 0, void 0, function() {
            var o, l, c, u, d, h, p, f = this;
            return _(this, function(m) {
              switch (m.label) {
                case 0:
                  return !((p = this._sdkState.websocket) === null || p === void 0) && p.compression ? a.data instanceof Blob ? ((o = new FileReader()).readAsArrayBuffer(a.data), o.onloadend = function() {
                    return g(f, 0, void 0, function() {
                      var v, E;
                      return _(this, function(y) {
                        switch (y.label) {
                          case 0:
                            return y.trys.push([0, 2, , 3]), [4, au(o.result)];
                          case 1:
                            return v = y.sent(), this._handleMessage(v), [3, 3];
                          case 2:
                            return E = y.sent(), this.error(E), [3, 3];
                          case 3:
                            return [2];
                        }
                      });
                    });
                  }, [3, 12]) : [3, 1] : [3, 13];
                case 1:
                  if (!(a.data instanceof ArrayBuffer))
                    return [3, 6];
                  m.label = 2;
                case 2:
                  return m.trys.push([2, 4, , 5]), [4, au(new Uint8Array(a.data))];
                case 3:
                  return d = m.sent(), this._handleMessage(d), [3, 5];
                case 4:
                  return l = m.sent(), this.error(l), [3, 5];
                case 5:
                  return [3, 12];
                case 6:
                  if (!(typeof Buffer < "u" && a.data instanceof Buffer))
                    return [3, 11];
                  m.label = 7;
                case 7:
                  return m.trys.push([7, 9, , 10]), c = a.data, u = c.buffer.slice(c.byteOffset, c.byteOffset + c.byteLength), [4, au(u)];
                case 8:
                  return d = m.sent(), this._handleMessage(d), [3, 10];
                case 9:
                  return h = m.sent(), this.error(h), [3, 10];
                case 10:
                  return [3, 12];
                case 11:
                  typeof a.data == "string" && this._handleMessage(a.data), m.label = 12;
                case 12:
                  return [3, 14];
                case 13:
                  this._handleMessage(a.data), m.label = 14;
                case 14:
                  return [2];
              }
            });
          });
        }, this._ws.onerror = function() {
          i._logger.debug("websocket error"), i.dispatch("error", D.networkError);
        }, this._ws.onclose = function() {
          i._logger.debug("websocket close"), i.dispatch("close");
        }, this.lastActive = Date.now(), [2];
      });
    });
  }, n.prototype.disconnect = function() {
    var e = this;
    return new Promise(function(r) {
      e._logger.debug("websocket disconnect"), e._ws ? (e._ws.onopen = rt, e._ws.onmessage = rt, e._ws.onerror = rt, e.connectionState !== li.CLOSED ? (e._ws.onclose = function() {
        e.dispatch("close"), r();
      }, e._ws.close(), e._ws = void 0) : r()) : r();
    });
  }, n.prototype.send = function(e) {
    if (!this._ws)
      throw D.connectionClosed;
    e.code !== "PING" ? this.dispatch("ping-refresh") : this._logger.debug("send ping", e), this._ws.send(e.convertToMessage());
  }, n.prototype.error = function(e) {
    this._logger.debug("websocket error", e), this.dispatch("error", e);
  }, n;
}(Qs), Sm = function(t) {
  function n(e) {
    var r = e.all, i = e.feed, s = e.custom_types, a = e.ts, o = t.call(this) || this;
    return o.all = r, o.feed = i, o.customTypes = s, o.ts = a, o;
  }
  return S(n, t), n;
}(Vt), y1 = function() {
  function t(n, e) {
    var r = e.session, i = e.sdkState, s = e.dispatcher, a = e.logger, o = e.useFetchCompat, l = o !== void 0 && o, c = this;
    this._ackStateMap = /* @__PURE__ */ new Map(), this._sdkState = i, this._dispatcher = s, this._logger = a, this.apiClient = new _y(n, { session: r, sdkState: i, dispatcher: s, logger: a, useFetchCompat: l }), this.websocketClient = new v1(n, { sdkState: i, dispatcher: s, logger: a }), this.websocketClient.on("message", function(u) {
      if (u.payload.unread_cnt && c._dispatcher.dispatch(new Sm(u.payload.unread_cnt)), u.requestId) {
        if (c._ackStateMap.has(u.requestId)) {
          var d = c._ackStateMap.get(u.requestId);
          u.code !== "EROR" ? d.resolve(u) : d.reject(new D({ code: u.payload.code, message: u.payload.message }));
        }
      } else
        c._dispatcher.dispatch(u);
    }).on("close", function() {
      c._ackStateMap.forEach(function(u) {
        u.reject(D.connectionClosed);
      }), c._ackStateMap.clear();
    });
  }
  return t.prototype._sendApiRequest = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this.apiClient.send(n)];
          case 1:
            return [2, e.sent()];
        }
      });
    });
  }, t.prototype._sendWebsocketRequest = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s = this;
      return _(this, function(a) {
        if (!this._sdkState.websocket)
          throw D.connectionRequired;
        if (e = new $n(), n.ackRequired) {
          i = function(o, l) {
            s._ackStateMap.has(n.requestId) && (s._ackStateMap.delete(n.requestId), r && (clearTimeout(r), r = null), o ? (s._logger.debug("fail websocket request", n.requestId, o), e.reject(o)) : (s._logger.debug("receive websocket ack", n.requestId, n), s._logger.debug("receive websocket ack", l), e.resolve(l)));
          };
          try {
            r = setTimeout(function() {
              return i(D.noAckTimeout);
            }, this._sdkState.websocket.responseTimeout), this._ackStateMap.set(n.requestId, { resolve: function(o) {
              return i(void 0, o);
            }, reject: function(o) {
              return i(o);
            } }), this.websocketClient.send(n);
          } catch (o) {
            i(o);
          }
        } else
          try {
            this.websocketClient.send(n), e.resolve();
          } catch (o) {
            e.reject(o);
          }
        return [2, e.promise];
      });
    });
  }, t.prototype.send = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return n instanceof $ ? [4, this._sendApiRequest(n)] : [3, 2];
          case 1:
          case 3:
            return [2, e.sent()];
          case 2:
            return n instanceof Zn ? [4, this._sendWebsocketRequest(n)] : [3, 4];
          case 4:
            throw D.invalidParameters;
        }
      });
    });
  }, t.prototype.cancel = function(n) {
    this.apiClient.cancel(n);
  }, t.prototype.cancelAll = function() {
    this.apiClient.cancelAll();
  }, t;
}();
(function(t) {
  t[t.NONE = 0] = "NONE", t[t.INITIALIZED = 1] = "INITIALIZED", t[t.CONNECTING = 2] = "CONNECTING", t[t.CONNECTED = 3] = "CONNECTED", t[t.RECONNECTING = 4] = "RECONNECTING", t[t.INTERNAL_DISCONNECTED = 5] = "INTERNAL_DISCONNECTED", t[t.EXTERNAL_DISCONNECTED = 6] = "EXTERNAL_DISCONNECTED", t[t.LOGOUT = 7] = "LOGOUT";
})(bt || (bt = {}));
var Rs, Ds, Ar = function(t) {
  function n(e) {
    var r = e.stateType, i = t.call(this) || this;
    return i.stateType = r, i;
  }
  return S(n, t), n;
}(Vt), Nm = function(t) {
  function n() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return S(n, t), n;
}(Vt), nd = function(t) {
  function n() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return S(n, t), n;
}(Vt), Im = function(t) {
  function n() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return S(n, t), n;
}(Vt), gp = function() {
  function t(n) {
    var e, r, i, s;
    this.isEnabled = (e = n.enabled) !== null && e !== void 0 && e, this.feedChannels = (r = n.feed_channels) !== null && r !== void 0 ? r : {}, this.templateListToken = (i = n.template_list_token) !== null && i !== void 0 ? i : null, this.settingsUpdatedAt = (s = n.settings_updated_at) !== null && s !== void 0 ? s : 0;
  }
  return t.payloadify = function(n) {
    return fe(Ae({ enabled: n.isEnabled, feed_channels: n.feedChannels, template_list_token: n.templateListToken, settings_updated_at: n.settingsUpdatedAt }));
  }, t;
}(), Gd = function(t) {
  return "sendbird@".concat(t, "/changelog_include_chat_notifications");
}, vp = function() {
  function t(n) {
    var e;
    this.lastUpdatedAt = (e = n.last_updated_at) !== null && e !== void 0 ? e : 0;
  }
  return t.payloadify = function(n) {
    return fe(Ae({ last_updated_at: n.lastUpdatedAt }));
  }, t;
}(), yp = function() {
  function t(n) {
    var e;
    this.token = (e = n.template_list_token) !== null && e !== void 0 ? e : "";
  }
  return t.payloadify = function(n) {
    return fe(Ae({ template_list_token: n.token }));
  }, t;
}(), tl = function() {
  function t(n) {
    n === void 0 && (n = { min_stat_count: 100, min_interval: 10800, max_stat_count_per_request: 1e3, lower_threshold: 10, request_delay_range: 180 }), this.minStatCount = n.min_stat_count, this.minInterval = 1e3 * n.min_interval, this.maxStatCountPerRequest = n.max_stat_count_per_request, this.lowerThreshold = n.lower_threshold, this.requestDelayRange = 1e3 * n.request_delay_range;
  }
  return t.payloadify = function(n) {
    return fe(Ae({ min_stat_count: n.minStatCount, min_interval: n.minInterval / 1e3, max_stat_count_per_request: n.maxStatCountPerRequest, lower_threshold: n.lowerThreshold, request_delay_range: n.requestDelayRange / 1e3 }));
  }, t;
}(), ou = function() {
  function t(n) {
    n === void 0 && (n = { default: { min_stat_count: 100, min_interval: 10800, max_stat_count_per_request: 1e3, lower_threshold: 10, request_delay_range: 180 } }), this.default = new tl(n.default), this.realTime = new tl(n.realtime);
  }
  return t.payloadify = function(n) {
    return fe(Ae({ default: tl.payloadify(n.default), realtime: tl.payloadify(n.realTime) }));
  }, t;
}(), bp = 1048576;
(function(t) {
  t[t.NONE = 0] = "NONE", t[t.INCLUDE_REPLY = 1] = "INCLUDE_REPLY", t[t.EXCLUDE_REPLY = 2] = "EXCLUDE_REPLY", t[t.INCLUDE_REPLY_TO_CHANNEL = 3] = "INCLUDE_REPLY_TO_CHANNEL";
})(Rs || (Rs = {})), function(t) {
  t[t.NONE = 0] = "NONE", t[t.INCLUDE_REPLY = 1] = "INCLUDE_REPLY", t[t.EXCLUDE_REPLY = 2] = "EXCLUDE_REPLY", t[t.INCLUDE_REPLY_TO_CHANNEL = 3] = "INCLUDE_REPLY_TO_CHANNEL";
}(Ds || (Ds = {}));
var Ep = function() {
  function t(n) {
    var e, r, i, s, a, o, l;
    n === void 0 && (n = {}), this.emojiHash = n.emoji_hash || "", this.uploadSizeLimit = n.file_upload_size_limit ? n.file_upload_size_limit * bp : Number.MAX_SAFE_INTEGER, this.useReaction = !!n.use_reaction, this.applicationAttributes = (e = n.application_attributes) !== null && e !== void 0 ? e : [], this.premiumFeatureList = (r = n.premium_feature_list) !== null && r !== void 0 ? r : [], this.deviceTokenCache = this.applicationAttributes.includes("sdk_device_token_cache"), this.enabledChannelMemberShipHistory = this.applicationAttributes.includes("channel_membership_history"), this.multipleFilesMessageFileCountLimit = (i = n.multiple_file_send_max_size) !== null && i !== void 0 ? i : 5, this.allowSdkStatsUpload = (s = n.allow_sdk_log_ingestion) === null || s === void 0 || s, this.unreadCountThreadingPolicy = (a = n.unread_cnt_threading_policy) !== null && a !== void 0 ? a : Rs.NONE, this.lastMessageThreadingPolicy = (o = n.last_msg_threading_policy) !== null && o !== void 0 ? o : Ds.NONE, this.uikitConfigInfo = new vp((l = n.uikit_config) !== null && l !== void 0 ? l : {}), this.notificationInfo = n.notifications ? new gp(n.notifications) : null, this.messageTemplateInfo = n.message_template ? new yp(n.message_template) : null, this.statConfigInfo = n.log_publish_config ? new ou(n.log_publish_config) : new ou();
  }
  return t.payloadify = function(n) {
    return fe(Ae({ emoji_hash: n.emojiHash, file_upload_size_limit: n.uploadSizeLimit / bp, application_attributes: n.applicationAttributes, premium_feature_list: n.premiumFeatureList, use_reaction: n.useReaction, allow_sdk_log_ingestion: n.allowSdkStatsUpload, unread_cnt_threading_policy: n.unreadCountThreadingPolicy, last_msg_threading_policy: n.lastMessageThreadingPolicy, uikit_config: n.uikitConfigInfo ? vp.payloadify(n.uikitConfigInfo) : null, notifications: n.notificationInfo ? gp.payloadify(n.notificationInfo) : null, message_template: n.messageTemplateInfo ? yp.payloadify(n.messageTemplateInfo) : null, log_publish_config: n.statConfigInfo ? ou.payloadify(n.statConfigInfo) : null }));
  }, t;
}(), xn = function() {
  function t(n) {
    this._iid = "", this._iid = n;
  }
  return t.payloadify = function(n) {
    return {};
  }, t;
}(), b1 = function(t) {
  function n(e) {
    var r = e.userId, i = e.metadata, s = t.call(this) || this;
    return s.method = Y.POST, s.path = "".concat(vt, "/").concat(r, "/metadata"), s.params = { metadata: i }, s;
  }
  return S(n, t), n;
}($), E1 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.metaData = r, i;
  }
  return S(n, t), n;
}(ne), C1 = function(t) {
  function n(e) {
    var r = e.userId, i = e.metadata, s = e.upsert, a = t.call(this) || this;
    return a.method = Y.PUT, a.path = "".concat(vt, "/").concat(r, "/metadata"), a.params = { metadata: i, upsert: s }, a;
  }
  return S(n, t), n;
}($), T1 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.metadata = r, i;
  }
  return S(n, t), n;
}(ne), w1 = function(t) {
  function n(e) {
    var r = e.userId, i = e.metadataKey, s = t.call(this) || this;
    return s.method = Y.DELETE, s.path = "".concat(vt, "/").concat(r, "/metadata/").concat(i), s;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var S1 = function(t) {
  function n(e) {
    var r = e.userId, i = t.call(this) || this;
    return i.method = Y.DELETE, i.path = "".concat(vt, "/").concat(r, "/metadata"), i;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var ia, Lo = function(t, n) {
  var e = JSON.parse(JSON.stringify(t));
  return e._iid && delete e._iid, n && n(e), e;
}, js = function(t, n) {
  return JSON.parse(JSON.stringify(t));
}, Z = function(t) {
  return { do: function(n) {
    t || n();
  }, throw: function(n) {
    if (!t)
      throw n;
  } };
};
(function(t) {
  t.ONLINE = "online", t.OFFLINE = "offline", t.NON_AVAILABLE = "nonavailable";
})(ia || (ia = {}));
var ma, pt = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d, h, p, f, m, v = this;
    return (v = t.call(this, e) || this).userId = (s = (i = r.guest_id) !== null && i !== void 0 ? i : r.user_id) !== null && s !== void 0 ? s : "", v.nickname = (o = (a = r.nickname) !== null && a !== void 0 ? a : r.name) !== null && o !== void 0 ? o : "", v.plainProfileUrl = (c = (l = r.profile_url) !== null && l !== void 0 ? l : r.image) !== null && c !== void 0 ? c : "", v.requireAuth = (u = r.require_auth_for_profile_image) !== null && u !== void 0 && u, v.metaData = (d = r.metadata) !== null && d !== void 0 ? d : {}, v.connectionStatus = ia.NON_AVAILABLE, Ze(ia, r.is_online) ? v.connectionStatus = r.is_online : O("boolean", r.is_online) && (v.connectionStatus = r.is_online ? ia.ONLINE : ia.OFFLINE), v.isActive = (h = r.is_active) === null || h === void 0 || h, v.lastSeenAt = (p = r.last_seen_at) !== null && p !== void 0 ? p : null, v.preferredLanguages = r.preferred_languages ? Re([], we(r.preferred_languages), !1) : null, v.friendDiscoveryKey = (f = r.friend_discovery_key) !== null && f !== void 0 ? f : null, v.friendName = (m = r.friend_name) !== null && m !== void 0 ? m : null, v;
  }
  return S(n, t), n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { user_id: e.userId, nickname: e.nickname, profile_url: e.plainProfileUrl, require_auth_for_profile_image: e.requireAuth, metadata: e.metaData, is_online: e.connectionStatus, is_active: e.isActive, last_seen_at: e.lastSeenAt, preferred_languages: e.preferredLanguages, friend_discovery_key: e.friendDiscoveryKey, friend_name: e.friendName })));
  }, Object.defineProperty(n.prototype, "profileUrl", { get: function() {
    var e = k.of(this._iid).sessionManager;
    return this.requireAuth && e.ekey ? "".concat(this.plainProfileUrl, "?auth=").concat(e.ekey) : this.plainProfileUrl;
  }, enumerable: !1, configurable: !0 }), n.prototype.serialize = function() {
    return Lo(this);
  }, n.prototype._isValidMetaData = function(e) {
    return !Array.isArray(e) && Object.keys(e).length > 0 && Object.keys(e).map(function(r) {
      return e[r];
    }).every(function(r) {
      return O("string", r);
    });
  }, n.prototype._applyMetaData = function(e, r) {
    var i = this;
    r === void 0 && (r = !1), Object.keys(e).forEach(function(s) {
      r ? delete i.metaData[s] : i.metaData[s] = e[s];
    });
  }, n.prototype.createMetaData = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return Z(this._isValidMetaData(e)).throw(D.invalidParameters), r = k.of(this._iid), i = r.sdkState, s = r.requestQueue, a = new b1({ userId: i.userId, metadata: e }), [4, s.send(a)];
          case 1:
            return o = c.sent(), l = o.as(E1).metaData, this._applyMetaData(l), [2, this.metaData];
        }
      });
    });
  }, n.prototype.updateMetaData = function(e, r) {
    return r === void 0 && (r = !1), g(this, 0, void 0, function() {
      var i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return Z(this._isValidMetaData(e)).throw(D.invalidParameters), i = k.of(this._iid), s = i.sdkState, a = i.requestQueue, o = new C1({ userId: s.userId, metadata: e, upsert: r }), [4, a.send(o)];
          case 1:
            return l = u.sent(), c = l.as(T1).metadata, this._applyMetaData(c), [2, this.metaData];
        }
      });
    });
  }, n.prototype.deleteMetaData = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return Z(O("string", e)).throw(D.invalidParameters), r = k.of(this._iid), i = r.sdkState, s = r.requestQueue, a = new w1({ userId: i.userId, metadataKey: e }), [4, s.send(a)];
          case 1:
            return l.sent(), this._applyMetaData(((o = {})[e] = !0, o), !0), [2, this.metaData];
        }
      });
    });
  }, n.prototype.deleteAllMetaData = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new S1({ userId: r.userId }), [4, i.send(s)];
          case 1:
            return a.sent(), this.metaData = {}, [2];
        }
      });
    });
  }, n;
}(xn), Am = function(t) {
  function n(e) {
    var r = e.userProfile, i = t.call(this) || this;
    return i.userProfile = r, i;
  }
  return S(n, t), n;
}(Vt), rd = function() {
  function t(n, e) {
    var r, i, s, a, o, l, c, u, d, h, p, f, m, v;
    this._iid = n, this.appInfo = new Ep(e), this.user = new pt(n, e), this.connectedAt = (r = e.login_ts) !== null && r !== void 0 ? r : 0, this.firstConnectedAt = 0, this.pingInterval = (i = e.ping_interval) !== null && i !== void 0 ? i : 15e3, this.pongTimeout = (s = e.pong_timeout) !== null && s !== void 0 ? s : 5e3, this.reconnectInterval = (o = (a = e.reconnect) === null || a === void 0 ? void 0 : a.interval) !== null && o !== void 0 ? o : 3e3, this.reconnectMaxInterval = (c = (l = e.reconnect) === null || l === void 0 ? void 0 : l.max_interval) !== null && c !== void 0 ? c : 6e4, this.reconnectRetryCount = (d = (u = e.reconnect) === null || u === void 0 ? void 0 : u.retry_cnt) !== null && d !== void 0 ? d : 5, this.reconnectIntervalMultiple = (p = (h = e.reconnect) === null || h === void 0 ? void 0 : h.mul) !== null && p !== void 0 ? p : 2, this.maxUnreadCountOnSuperGroup = (f = e.max_unread_cnt_on_super_group) !== null && f !== void 0 ? f : 100, this.profileImageEncryption = !!e.profile_image_encryption, this.concurrentCallLimit = (m = e.concurrent_call_limit) !== null && m !== void 0 ? m : 5, this.backOffDelay = (v = e.back_off_delay) !== null && v !== void 0 ? v : 100;
  }
  return t.payloadify = function(n) {
    return fe(Ae(A(A(A({}, pt.payloadify(n.user)), Ep.payloadify(n.appInfo)), { login_ts: n.connectedAt, ping_interval: n.pingInterval, pong_timeout: n.pongTimeout, reconnect: { interval: n.reconnectInterval, max_interval: n.reconnectMaxInterval, retry_cnt: n.reconnectRetryCount, mul: n.reconnectIntervalMultiple }, max_unread_cnt_on_super_group: n.maxUnreadCountOnSuperGroup, profile_image_encryption: n.profileImageEncryption, concurrent_call_limit: n.concurrentCallLimit, back_off_delay: n.backOffDelay })));
  }, t.prototype.apply = function() {
    var n = this.reconnectInterval, e = this.reconnectMaxInterval, r = this.reconnectIntervalMultiple, i = k.of(this._iid);
    i.sdkState.websocket && (i.sdkState.websocket.pingInterval = 1e3 * this.pingInterval, i.sdkState.websocket.pongTimeout = 1e3 * this.pongTimeout, i.sdkState.websocket.reconnectMaxRetry = this.reconnectRetryCount, i.sdkState.websocket.reconnectRetryStrategy = { calcTimeout: function(s) {
      return s > 0 ? 1e3 * Math.min(n * Math.pow(r, s - 1), e) : 10;
    } }), i.appInfo = this.appInfo, i.sessionManager.currentUser = this.user, i.connectedAt = this.connectedAt, this.firstConnectedAt || (i.firstConnectedAt = this.connectedAt), i.maxSuperGroupChannelUnreadCount = this.maxUnreadCountOnSuperGroup, i.concurrentCallLimit = this.concurrentCallLimit, i.backOffDelay = this.backOffDelay, i.dispatcher.dispatch(new Am({ userProfile: this }));
  }, t;
}(), Mm = function(t) {
  function n(e) {
    var r = e.request, i = r === void 0 || r, s = e.features, a = s === void 0 ? {} : s, o = e.options, l = o === void 0 ? {} : o, c = e.statConfigInfo, u = t.call(this) || this;
    return u.request = i, u.features = A({ localCache: !0, notification: !0 }, a), u.options = A({ ingestion: !0 }, l), u.statConfigInfo = c, u;
  }
  return S(n, t), n;
}(Vt), Tl = function(t) {
  function n(e, r, i) {
    var s, a, o, l, c = this;
    return (c = t.call(this, e, r, i) || this).error = null, c.services = [], c.userProfile = new rd(e, i), c.deviceTokenLastDeletedAt = (s = i.device_token_last_deleted_at) !== null && s !== void 0 ? s : 0, c.key = (a = i.key) !== null && a !== void 0 ? a : "", c.ekey = (o = i.ekey) !== null && o !== void 0 ? o : "", c.error = i.error ? new D(i) : null, c.services = (l = i.services) !== null && l !== void 0 ? l : [], c;
  }
  return S(n, t), n.asError = function(e) {
    return new n("", "LOGI", A({ user_id: "", error: !0 }, e));
  }, n.prototype.applyTo = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return this.error ? [3, 4] : (r = k.of(e)) ? (i = r.sessionManager, s = r.dispatcher, [4, i.login(this)]) : [3, 2];
          case 1:
            return a.sent(), this.userProfile.apply(), s.dispatch(new Mm({ request: this.userProfile.appInfo.applicationAttributes.includes("allow_sdk_request_log_publish"), features: { localCache: this.userProfile.appInfo.applicationAttributes.includes("allow_sdk_feature_local_cache_log_publish"), notification: this.userProfile.appInfo.applicationAttributes.includes("allow_sdk_noti_stats_log_publish") }, options: { ingestion: this.userProfile.appInfo.allowSdkStatsUpload }, statConfigInfo: this.userProfile.appInfo.statConfigInfo })), [3, 3];
          case 2:
            throw D.lostInstance;
          case 3:
            return [3, 5];
          case 4:
            throw this.error;
          case 5:
            return [2];
        }
      });
    });
  }, n;
}(Lt), $s = function() {
  function t() {
    this.type = bt.NONE, this.name = "none";
  }
  return t.prototype.run = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        return [2];
      });
    });
  }, t.prototype.onConnect = function(n, e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return [2];
      });
    });
  }, t.prototype.onReconnect = function(n, e) {
    return e.resetReconnectCount, g(this, 0, void 0, function() {
      return _(this, function(r) {
        return [2];
      });
    });
  }, t.prototype.onDisconnect = function(n, e) {
    return e.error, e.autoReconnect, e.cause, g(this, 0, void 0, function() {
      return _(this, function(r) {
        return [2];
      });
    });
  }, t.prototype.onDisconnectWebSocket = function(n, e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return [2];
      });
    });
  }, t.prototype.onLogout = function(n, e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return [2];
      });
    });
  }, t;
}(), Ue = function(t) {
  return g(void 0, 0, void 0, function() {
    var n;
    return _(this, function(e) {
      switch (e.label) {
        case 0:
          return e.trys.push([0, 2, , 3]), [4, t()];
        case 1:
          return e.sent(), [3, 3];
        case 2:
          if (!((n = e.sent()) instanceof D))
            throw n;
          return n.throwOutside(), [3, 3];
        case 3:
          return [2];
      }
    });
  });
}, tn = function(t) {
  return g(void 0, 0, void 0, function() {
    return _(this, function(n) {
      switch (n.label) {
        case 0:
          return n.trys.push([0, 2, , 3]), [4, t()];
        case 1:
        case 2:
          return n.sent(), [3, 3];
        case 3:
          return [2];
      }
    });
  });
}, ss = function(t) {
  function n(e) {
    e === void 0 && (e = {});
    var r, i = this;
    return (i = t.call(this) || this).type = bt.LOGOUT, i.name = "logout", i._wasPreviouslyConnected = (r = e.wasPreviouslyConnected) === null || r === void 0 || r, i;
  }
  return S(n, t), n.prototype.run = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s = this;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return r = Date.now(), i = e.sdkState.userId, [4, e.logout()];
          case 1:
            return a.sent(), [4, e.changeState(new qd(), r)];
          case 2:
            return a.sent(), this._wasPreviouslyConnected && Ue(function() {
              return g(s, 0, void 0, function() {
                return _(this, function(o) {
                  return e.connectionHandlers.forEach(function(l) {
                    l.onDisconnected && l.onDisconnected(i);
                  }), [2];
                });
              });
            }), [2];
        }
      });
    });
  }, n;
}($s), vc = function(t) {
  function n() {
    var e = t.call(this) || this;
    return e.type = bt.EXTERNAL_DISCONNECTED, e.name = "externaldisconnected", e;
  }
  return S(n, t), n.prototype.run = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, e.disconnect()];
          case 1:
            return r.sent(), [2];
        }
      });
    });
  }, n.prototype.onConnect = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = Date.now(), [4, e.disconnect()];
          case 1:
            return s.sent(), [4, e.changeState(new bc({ authToken: r }), i)];
          case 2:
            return s.sent(), [2];
        }
      });
    });
  }, n.prototype.onReconnect = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = Date.now(), [4, e.changeState(new Ql(), r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.onLogout = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = Date.now(), [4, e.changeState(new ss(), r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n;
}($s), Wl = function(t) {
  function n(e) {
    var r = e.autoReconnect, i = t.call(this) || this;
    return i.type = bt.INTERNAL_DISCONNECTED, i.name = "internaldisconnected", i._autoReconnect = !1, i._autoReconnect = r, i;
  }
  return S(n, t), n.prototype.run = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = Date.now(), [4, e.disconnect()];
          case 1:
            return i.sent(), this._autoReconnect ? [4, e.changeState(new Ql(), r)] : [3, 3];
          case 2:
            i.sent(), i.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, n.prototype.onConnect = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = Date.now(), [4, e.disconnect()];
          case 1:
            return s.sent(), [4, e.changeState(new bc({ authToken: r }), i)];
          case 2:
            return s.sent(), [2];
        }
      });
    });
  }, n.prototype.onReconnect = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = Date.now(), [4, e.changeState(new Ql(), r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.onDisconnectWebSocket = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = Date.now(), [4, e.changeState(new vc(), r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.onLogout = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = Date.now(), [4, e.changeState(new ss(), r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n;
}($s), er = function(t) {
  return g(void 0, 0, void 0, function() {
    return _(this, function(n) {
      return [2, new Promise(function(e) {
        return setTimeout(e, t);
      })];
    });
  });
}, xm = function() {
  function t() {
  }
  return t.prototype.calcTimeout = function() {
    return 0;
  }, t;
}(), yc = function(t, n, e) {
  return e === void 0 && (e = new xm()), g(void 0, 0, void 0, function() {
    var r, i, s, a, o, l;
    return _(this, function(c) {
      switch (c.label) {
        case 0:
          r = 0, i = null, s = function(u) {
            return i = u ?? new Error("Halted");
          }, a = function() {
            r = 0;
          }, c.label = 1;
        case 1:
          if (!(n === -1 || r < n))
            return [3, 9];
          c.label = 2;
        case 2:
          return c.trys.push([2, 4, , 8]), [4, t(s, a)];
        case 3:
          if (o = c.sent(), i)
            throw i;
          return [2, o];
        case 4:
          if (l = c.sent(), i)
            return [3, 6];
          if (++r === n)
            throw l;
          return [4, er(e.calcTimeout(r))];
        case 5:
          return c.sent(), [3, 7];
        case 6:
          throw i;
        case 7:
          return [3, 8];
        case 8:
          return [3, 1];
        case 9:
          throw "It should not happen.";
      }
    });
  });
}, Ql = function(t) {
  function n() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e.type = bt.RECONNECTING, e.name = "reconnecting", e._callbacks = [], e;
  }
  return S(n, t), n.prototype._halt = function(e) {
    this._haltConnect && (this._haltConnect(e), this._haltConnect = void 0);
  }, n.prototype._flushCallbacks = function(e) {
    this._haltConnect = void 0, this._resetConnect = void 0, this._callbacks.forEach(function(r) {
      return r(e);
    });
  }, n.prototype.run = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c = this;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            r = Date.now(), i = new $n(), this._callbacks.push(function(d) {
              return d ? i.reject(d) : i.resolve();
            }), Ue(function() {
              return g(c, 0, void 0, function() {
                return _(this, function(d) {
                  return e.connectionHandlers.forEach(function(h) {
                    h.onReconnectStarted && h.onReconnectStarted();
                  }), [2];
                });
              });
            }), u.label = 1;
          case 1:
            return u.trys.push([1, 4, , 9]), s = e.sdkState.websocket, a = s.reconnectMaxRetry, o = s.reconnectRetryStrategy, [4, yc(function(d, h) {
              return g(c, 0, void 0, function() {
                var p;
                return _(this, function(f) {
                  switch (f.label) {
                    case 0:
                      this._haltConnect = d, this._resetConnect = h, f.label = 1;
                    case 1:
                      return f.trys.push([1, 3, , 4]), [4, e.connect()];
                    case 2:
                      return f.sent(), [3, 4];
                    case 3:
                      if (p = f.sent(), e.clearLoginTimer(), p instanceof D) {
                        if (p.code === me.CONNECTION_CANCELED)
                          return d(p), [2];
                        if (p.isSessionExpiredError || p.isSessionInvalidatedError)
                          return d(p), [2];
                      }
                      throw p;
                    case 4:
                      return [2];
                  }
                });
              });
            }, a, o)];
          case 2:
            return u.sent(), [4, e.changeState(new km(), r)];
          case 3:
            return u.sent(), this._flushCallbacks(), Ue(function() {
              return g(c, 0, void 0, function() {
                return _(this, function(d) {
                  return e.connectionHandlers.forEach(function(h) {
                    h.onReconnectSucceeded && h.onReconnectSucceeded();
                  }), [2];
                });
              });
            }), [3, 9];
          case 4:
            return l = u.sent(), rr(l) ? [3, 7] : l instanceof D ? l.code === me.CONNECTION_CANCELED ? [3, 6] : [4, e.changeState(new Wl({ autoReconnect: !1 }), r)] : [3, 6];
          case 5:
            u.sent(), u.label = 6;
          case 6:
            return this._flushCallbacks(l), Ue(function() {
              return g(c, 0, void 0, function() {
                return _(this, function(d) {
                  return e.connectionHandlers.forEach(function(h) {
                    h.onReconnectFailed && h.onReconnectFailed();
                  }), [2];
                });
              });
            }), [3, 8];
          case 7:
            throw l;
          case 8:
            return [3, 9];
          case 9:
            return [2, i.promise];
        }
      });
    });
  }, n.prototype.onConnect = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        return i = new $n(), this._halt(D.connectionCanceled), e.cancelConnectForRetry(), this._callbacks.push(function() {
          var a = Date.now();
          e.changeState(new bc({ authToken: r }), a).then(function() {
            i.resolve();
          }).catch(function(o) {
            i.reject(o);
          });
        }), [2, i.promise];
      });
    });
  }, n.prototype.onReconnect = function(e, r) {
    var i = r.resetReconnectCount, s = i !== void 0 && i;
    return g(this, 0, void 0, function() {
      var a;
      return _(this, function(o) {
        return a = new $n(), this._resetConnect && s && this._resetConnect(), this._callbacks.push(function(l) {
          return l ? a.reject(l) : a.resolve();
        }), [2, a.promise];
      });
    });
  }, n.prototype.onDisconnect = function(e, r) {
    r._error;
    var i = r.autoReconnect, s = i === void 0 || i;
    return g(this, 0, void 0, function() {
      var a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return a = Date.now(), this._halt(D.connectionCanceled), [4, e.changeState(new Wl({ autoReconnect: s }), a)];
          case 1:
            return o.sent(), [2];
        }
      });
    });
  }, n.prototype.onDisconnectWebSocket = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = Date.now(), this._halt(D.connectionCanceled), [4, e.changeState(new vc(), r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.onLogout = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = Date.now(), this._halt(D.connectionCanceled), [4, e.changeState(new ss(), r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n;
}($s), km = function(t) {
  function n() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e.type = bt.CONNECTED, e.name = "connected", e;
  }
  return S(n, t), n.prototype.onReconnect = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = Date.now(), [4, e.disconnect()];
          case 1:
            return i.sent(), [4, e.changeState(new Ql(), r)];
          case 2:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.onDisconnect = function(e, r) {
    var i = r.autoReconnect;
    return g(this, 0, void 0, function() {
      var s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return s = Date.now(), [4, e.changeState(new Wl({ autoReconnect: i }), s)];
          case 1:
            return a.sent(), [2];
        }
      });
    });
  }, n.prototype.onDisconnectWebSocket = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = Date.now(), [4, e.changeState(new vc(), r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.onLogout = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = Date.now(), [4, e.changeState(new ss(), r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n;
}($s);
(function(t) {
  t.ExternalSetBackground = "ExternalSetBackground", t.ExternalDisconnectWebSocket = "ExternalDisconnectWebSocket";
})(ma || (ma = {}));
var N1 = function() {
  function t(n, e) {
    var r = e.sdkState, i = e.cacheContext, s = e.connectionHandlers, a = e.sessionManager, o = e.websocketClient, l = e.dispatcher, c = e.logger, u = e.disableWebSocketCloseEventHandling, d = u !== void 0 && u;
    this._disableWebSocketCloseEventHandling = !1, this._webSocketClosedCause = null, this._logger = c, this._disableWebSocketCloseEventHandling = d, this._context = new M1(n, { sdkState: r, cacheContext: i, connectionHandlers: s, sessionManager: a, websocketClient: o, dispatcher: l, logger: c }), this._sdkState = r, this._sessionManager = a, this._websocketClient = o;
  }
  return t.prototype._registerEventDispatcher = function() {
    var n = this;
    this._disableWebSocketCloseEventHandling || (this._clearEventDispatcher(), this._sessionEventDispatcherContext = this._sessionManager.on("refresh", function() {
      n.isConnecting || n.isConnected || (n._logger.debug("try reconnect by session key refresh"), tn(function() {
        return g(n, 0, void 0, function() {
          return _(this, function(e) {
            switch (e.label) {
              case 0:
                return [4, this.reconnect()];
              case 1:
                return e.sent(), [2];
            }
          });
        });
      }));
    }), this._websocketEventDispatcherContext = this._websocketClient.on("close", function() {
      n._sdkState.appState !== "foreground" || n._webSocketClosedCause || tn(function() {
        return g(n, 0, void 0, function() {
          return _(this, function(e) {
            switch (e.label) {
              case 0:
                return this._sessionManager.isSessionKeyRefreshing ? [3, 2] : (this._logger.debug("try reconnect by websocket connection closed"), [4, this.reconnect()]);
              case 1:
                return e.sent(), [3, 4];
              case 2:
                return [4, this.disconnectWebSocket()];
              case 3:
                e.sent(), e.label = 4;
              case 4:
                return [2];
            }
          });
        });
      });
    }));
  }, t.prototype._clearEventDispatcher = function() {
    this._sessionEventDispatcherContext && (this._sessionEventDispatcherContext.close(), this._sessionEventDispatcherContext = void 0), this._websocketEventDispatcherContext && (this._websocketEventDispatcherContext.close(), this._websocketEventDispatcherContext = void 0);
  }, Object.defineProperty(t.prototype, "isConnected", { get: function() {
    return this._context.currentState.type === bt.CONNECTED;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "isConnecting", { get: function() {
    var n = this._context.currentState;
    return n.type === bt.CONNECTING || n.type === bt.RECONNECTING;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "websocketClient", { get: function() {
    return this._websocketClient;
  }, enumerable: !1, configurable: !0 }), t.prototype.connect = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return e = this._context.currentState, this._webSocketClosedCause = null, [4, e.onConnect(this._context, n)];
          case 1:
            return r.sent(), this._registerEventDispatcher(), [2];
        }
      });
    });
  }, t.prototype.reconnect = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return n = this._context.currentState, this._webSocketClosedCause = null, [4, n.onReconnect(this._context, {})];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, t.prototype.resetAndReconnect = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return n = this._context.currentState, this._webSocketClosedCause = null, [4, n.onReconnect(this._context, { resetReconnectCount: !0 })];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, t.prototype.background = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return n = this._context.currentState, this._webSocketClosedCause = ma.ExternalSetBackground, [4, n.onDisconnect(this._context, { autoReconnect: !1, cause: this._webSocketClosedCause })];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, t.prototype.disconnect = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this._context.currentState.onDisconnect(this._context, { error: n, autoReconnect: !0, cause: this._webSocketClosedCause })];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, t.prototype.disconnectWebSocket = function(n) {
    return n === void 0 && (n = !1), g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return e = this._context.currentState, n && (this._webSocketClosedCause = ma.ExternalDisconnectWebSocket), [4, e.onDisconnectWebSocket(this._context, { cause: this._webSocketClosedCause })];
          case 1:
            return r.sent(), [2];
        }
      });
    });
  }, t.prototype.logout = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return e = this._context.currentState, this._clearEventDispatcher(), [4, e.onLogout(this._context, n)];
          case 1:
            return r.sent(), [2];
        }
      });
    });
  }, t;
}(), bc = function(t) {
  function n(e) {
    var r = e.authToken, i = t.call(this) || this;
    return i.type = bt.CONNECTING, i.name = "connecting", i._authToken = "", i._callbacks = [], i._authToken = r, i;
  }
  return S(n, t), n.prototype._halt = function(e) {
    this._haltConnect && (this._haltConnect(e), this._haltConnect = void 0);
  }, n.prototype._flushCallbacks = function(e) {
    this._haltConnect = void 0, this._callbacks.forEach(function(r) {
      return r(e);
    });
  }, n.prototype.run = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a = this;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            r = Date.now(), i = new $n(), this._callbacks.push(function(l) {
              return l ? i.reject(l) : i.resolve();
            }), o.label = 1;
          case 1:
            return o.trys.push([1, 4, , 10]), [4, yc(function(l) {
              return g(a, 0, void 0, function() {
                var c;
                return _(this, function(u) {
                  switch (u.label) {
                    case 0:
                      this._haltConnect = l, u.label = 1;
                    case 1:
                      return u.trys.push([1, 3, , 4]), [4, e.connect(this._authToken)];
                    case 2:
                      return u.sent(), [3, 4];
                    case 3:
                      if (c = u.sent(), e.clearLoginTimer(), c instanceof D && c.code === me.CONNECTION_CANCELED)
                        return l(c), [2];
                      throw c;
                    case 4:
                      return [2];
                  }
                });
              });
            }, e.sdkState.websocket.connectMaxRetry)];
          case 2:
            return o.sent(), [4, e.changeState(new km(), r)];
          case 3:
            return o.sent(), Ue(function() {
              return g(a, 0, void 0, function() {
                return _(this, function(l) {
                  return this._flushCallbacks(), e.connectionHandlers.forEach(function(c) {
                    c.onConnected && c.onConnected(e.sdkState.userId);
                  }), [2];
                });
              });
            }), [3, 10];
          case 4:
            return s = o.sent(), rr(s) ? [3, 8] : [4, e.disconnect()];
          case 5:
            return o.sent(), s instanceof D ? s.code === me.CONNECTION_CANCELED ? [3, 7] : [4, e.changeState(new qd(), r)] : [3, 7];
          case 6:
            o.sent(), o.label = 7;
          case 7:
            return Ue(function() {
              return g(a, 0, void 0, function() {
                return _(this, function(l) {
                  return this._flushCallbacks(s), [2];
                });
              });
            }), [3, 9];
          case 8:
            throw s;
          case 9:
            return [3, 10];
          case 10:
            return [2, i.promise];
        }
      });
    });
  }, n.prototype.onConnect = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        return r = new $n(), this._callbacks.push(function(s) {
          return s ? r.reject(s) : r.resolve();
        }), [2, r.promise];
      });
    });
  }, n.prototype.onDisconnect = function(e, r) {
    var i = r.error, s = i === void 0 ? null : i, a = r.autoReconnect, o = a !== void 0 && a, l = r.cause, c = l === void 0 ? null : l;
    return g(this, 0, void 0, function() {
      var u;
      return _(this, function(d) {
        switch (d.label) {
          case 0:
            return u = Date.now(), this._halt(s ?? Cp(c)), e.hasSession ? [4, e.changeState(new Wl({ autoReconnect: o }), u)] : [3, 2];
          case 1:
            return d.sent(), [3, 4];
          case 2:
            return [4, e.changeState(new ss(), u)];
          case 3:
            d.sent(), d.label = 4;
          case 4:
            return [2];
        }
      });
    });
  }, n.prototype.onDisconnectWebSocket = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return this._halt(Cp((r == null ? void 0 : r.cause) || null)), i = Date.now(), e.hasSession ? [4, e.changeState(new vc(), i)] : [3, 2];
          case 1:
            return s.sent(), [3, 4];
          case 2:
            return [4, e.changeState(new ss(), i)];
          case 3:
            s.sent(), s.label = 4;
          case 4:
            return [2];
        }
      });
    });
  }, n.prototype.onLogout = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = Date.now(), this._halt(r ?? D.connectionCanceled), [4, e.changeState(new ss(), i)];
          case 1:
            return s.sent(), [2];
        }
      });
    });
  }, n;
}($s);
function Cp(t) {
  var n = D.connectionCanceled;
  if (t) {
    var e = null;
    switch (t) {
      case ma.ExternalSetBackground:
        e = "Connection has been canceled due to the application having externally moved to background while in ConnectingState.";
        break;
      case ma.ExternalDisconnectWebSocket:
        e = "Connection has been canceled because sb.disconnectWebSocket() was called while in ConnectingState.";
    }
    e && n.setDetail(e);
  }
  return n;
}
var Yi, qd = function(t) {
  function n() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e.type = bt.INITIALIZED, e.name = "initialized", e;
  }
  return S(n, t), n.prototype.onConnect = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = Date.now(), [4, e.changeState(new bc({ authToken: r }), i)];
          case 1:
            return s.sent(), [2];
        }
      });
    });
  }, n.prototype.onLogout = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = Date.now(), [4, e.changeState(new ss({ wasPreviouslyConnected: !1 }), r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n;
}($s), I1 = function(t) {
  function n() {
    return t.call(this, { code: "PING", payload: { id: Date.now(), active: 1 }, ackRequired: !1 }) || this;
  }
  return S(n, t), n;
}(Zn), A1 = function() {
  function t(n) {
    var e = n.pingDelegate, r = n.sdkState, i = n.logger;
    this.pingDelegate = e, this.sdkState = r, this._logger = i;
  }
  return Object.defineProperty(t.prototype, "isWaiting", { get: function() {
    return !!this._pingTimeoutTimer;
  }, enumerable: !1, configurable: !0 }), t.prototype.ping = function() {
    var n, e = this;
    if (!this.sdkState.websocket)
      throw D.connectionRequired;
    var r = new I1();
    try {
      var i = (n = this.sdkState.websocket.pongTimeout) !== null && n !== void 0 ? n : 5e3;
      this._pingTimeoutTimer = setTimeout(function() {
        e._logger.debug("pinger.ping() timeout"), e.pingDelegate.error();
      }, i), this.pingDelegate.send(r), this._logger.debug("pinger.ping()");
    } catch (s) {
      this._logger.debug("pinger.ping() error", s), this._pingTimeoutTimer && (clearTimeout(this._pingTimeoutTimer), this._pingTimeoutTimer = void 0), this.pingDelegate.error();
    }
    return r;
  }, t.prototype.pong = function() {
    this._logger.debug("pinger.pong()"), this._pingTimeoutTimer && (clearTimeout(this._pingTimeoutTimer), this._pingTimeoutTimer = void 0);
  }, t.prototype.refreshTimer = function() {
    var n, e = this;
    if (!this.sdkState.websocket)
      throw D.connectionRequired;
    this._logger.debug("pinger.refreshTimer()");
    var r = (n = this.sdkState.websocket.pingInterval) !== null && n !== void 0 ? n : 15e3;
    this.stop(), this._pingTimer = setInterval(function() {
      e.ping();
    }, r);
  }, t.prototype.start = function() {
    this._logger.debug("pinger.start()"), this.refreshTimer(), this.ping();
  }, t.prototype.stop = function() {
    this._logger.debug("pinger.stop()"), this._pingTimer && (clearInterval(this._pingTimer), this._pingTimer = void 0), this._pingTimeoutTimer && (clearTimeout(this._pingTimeoutTimer), this._pingTimeoutTimer = void 0);
  }, t;
}(), Om = ["premium_feature_list", "file_upload_size_limit", "application_attributes", "emoji_hash", "multiple_file_send_max_size", "notifications", "message_template"], M1 = function(t) {
  function n(e, r) {
    var i, s = r.sdkState, a = r.cacheContext, o = r.connectionHandlers, l = r.sessionManager, c = r.websocketClient, u = r.dispatcher, d = r.logger, h = r.entryState, p = h === void 0 ? new qd() : h, f = this;
    return (f = t.call(this) || this)._stateUpdatedAt = 0, f._connectingAt = 0, f._connectedAt = 0, f._logiReceivedAt = 0, f._connectionRequestQueue = [], f._iid = e, f.sdkState = s, f.cacheContext = a, f.connectionHandlers = o, f._sessionManager = l, f._websocketClient = c, f._dispatcher = u, f._logger = d, f._currentState = p, !((i = f.sdkState.websocket) === null || i === void 0) && i.pingerDisabled || (f._pinger = new A1({ pingDelegate: { send: function(m) {
      return f._websocketClient.send(m);
    }, error: function(m) {
      return f._websocketClient.error(m);
    } }, sdkState: f.sdkState, logger: d })), f._websocketClient.on("open", function() {
      f._connectedAt = Date.now(), f._tryResolveConnectionRequest();
    }).on("message", function(m) {
      m.code === "LOGI" && (f.clearLoginTimer(), f._dispatcher.dispatch(m.as(Tl)));
    }).on("ping-refresh", function() {
      var m;
      return (m = f._pinger) === null || m === void 0 ? void 0 : m.refreshTimer();
    }).on("pong", function() {
      var m;
      return (m = f._pinger) === null || m === void 0 ? void 0 : m.pong();
    }).on("error", function() {
      var m;
      return (m = f._pinger) === null || m === void 0 ? void 0 : m.stop();
    }).on("close", function() {
      f._logiProcessingTimer = setTimeout(function() {
        f._logiProcessingTimer = void 0, f._unresolvedLogi || f._rejectConnectionRequest(D.networkError);
      }, 500);
    }), f._dispatcher.on(function(m) {
      m instanceof Tl && (f._unresolvedLogi = m, f._tryResolveConnectionRequest());
    }), f;
  }
  return S(n, t), Object.defineProperty(n.prototype, "currentState", { get: function() {
    return this._currentState;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "hasSession", { get: function() {
    return this._sessionManager.session.hasSession;
  }, enumerable: !1, configurable: !0 }), n.prototype.changeState = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r >= this._stateUpdatedAt ? (this._currentState = e, this._stateUpdatedAt = r, this._dispatcher.dispatch(new Ar({ stateType: e.type })), this._logger.debug("connection state changes to ".concat(e.name)), [4, this._currentState.run(this)]) : [3, 2];
          case 1:
            return i.sent(), [2, !0];
          case 2:
            return [2, !1];
        }
      });
    });
  }, n.prototype._tryResolveConnectionRequest = function() {
    var e;
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = this._unresolvedLogi, this._websocketClient.isOpen && r ? (this._unresolvedLogi = void 0, this._logiReceivedAt = Date.now(), r.error ? [3, 2] : [4, r.applyTo(this._iid)]) : [3, 3];
          case 1:
            return i.sent(), this._statLogConnection(), (e = this._pinger) === null || e === void 0 || e.start(), this._connectionRequestQueue.forEach(function(s) {
              return s.resolve();
            }), this._connectionRequestQueue = [], this.sdkState.appState = "foreground", [3, 3];
          case 2:
            this._sessionManager.session.authToken = void 0, r.error.isSessionExpiredError || r.error.isSessionInvalidatedError ? this._dispatcher.dispatch(new fa({ reason: r.error.code, message: r.error.message })) : this._logger.warn("login failed: ".concat(r.error)), this._rejectConnectionRequest(r.error), i.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, n.prototype._rejectConnectionRequest = function(e) {
    var r;
    if ((r = this._pinger) === null || r === void 0 || r.stop(), this.clearLoginTimer(), this._connectionRequestQueue.length > 0) {
      var i = this._connectionRequestQueue;
      this._connectionRequestQueue = [], i.forEach(function(s) {
        return s.reject(e);
      }), this._statLogConnection(e);
    }
  }, n.prototype._url = function() {
    var e, r = this.sdkState, i = r.appId, s = r.appVersion, a = r.userId, o = r.extensions, l = r.sendbirdRuntimeEnvironment, c = this.cacheContext.localCacheEnabled, u = this._sessionManager.session, d = (e = this.sdkState.websocket) === null || e === void 0 ? void 0 : e.compression, h = !!(o ?? {}).sb_uikit, p = zl.userAgentWithExtension(o);
    return "".concat(this.sdkState.websocket.host, "/?p=JS&pv=").concat(encodeURIComponent(ts.OS_VERSION), "&sv=").concat(encodeURIComponent(ts.SDK_VERSION), "&ai=").concat(i).concat(s ? "&av=".concat(s) : "").concat(u.hasSession ? "" : "&user_id=".concat(encodeURIComponent(a)), "&pmce=").concat(d ? 1 : 0, "&active=1&device_token_types=").concat(encodeURIComponent(["gcm", "huawei", "apns"].join(",")), "&SB-User-Agent=").concat(p, "&SB-SDK-User-Agent=").concat(encodeURIComponent(zl.sendbirdSdkUserAgentWithExtension(l)), "&Request-Sent-Timestamp=").concat(Date.now().toString(), "&include_extra_data=").concat(encodeURIComponent(String(Om))).concat(this._sessionManager.handler ? "&expiring_session=1" : "", "&use_local_cache=").concat(c ? 1 : 0, "&include_poll_details=1").concat(h ? "&uikit_config=1" : "");
  }, n.prototype._statLogConnection = function(e) {
    var r;
    this._dispatcher.dispatch(new Bd(new Zt({ type: Ft.WEBSOCKET_CONNECT, data: { host_url: (r = this.sdkState.websocket) === null || r === void 0 ? void 0 : r.host, success: !e, latency: this._connectedAt > 0 ? this._connectedAt - this._connectingAt : 0, logi_latency: this._logiReceivedAt > 0 ? this._logiReceivedAt - this._connectedAt : void 0, error_code: e == null ? void 0 : e.code, error_description: e == null ? void 0 : e.message } })));
  }, n.prototype.connect = function(e) {
    var r;
    return e === void 0 && (e = ""), g(this, 0, void 0, function() {
      var i, s, a, o = this;
      return _(this, function(l) {
        return this._logiProcessingTimer && (clearTimeout(this._logiProcessingTimer), this._logiProcessingTimer = void 0, this._rejectConnectionRequest(D.connectionCanceled)), i = new $n(), this._connectionRequestQueue.push(i), this._connectionRequestQueue.length === 1 && (this._connectingAt = Date.now(), this._connectedAt = 0, this._logiReceivedAt = 0, this._loginTimer = setTimeout(function() {
          o._loginTimer = void 0, o._rejectConnectionRequest(D.loginTimeout);
        }, (r = this.sdkState.websocket) === null || r === void 0 ? void 0 : r.responseTimeout), s = this._sessionManager.session, e && (s.authToken = e, s.sessionKey = void 0), a = this._url(), s.sessionKey || s.authToken ? this._websocketClient.connect(a, JSON.stringify(s.hasSession ? { auth: s.sessionKey } : { token: s.authToken })) : this._websocketClient.connect(a, JSON.stringify({}))), [2, i.promise];
      });
    });
  }, n.prototype.cancelConnectForRetry = function() {
    this._dispatcher.dispatch(Tl.asError(D.connectionRenew));
  }, n.prototype.disconnect = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this._websocketClient.disconnect()];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, n.prototype.logout = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return this.sdkState.userId = void 0, this._unresolvedLogi = void 0, [4, this.disconnect()];
          case 1:
            return e.sent(), [4, this._sessionManager.clear()];
          case 2:
            return e.sent(), [2];
        }
      });
    });
  }, n.prototype.clearLoginTimer = function() {
    this._loginTimer && (clearTimeout(this._loginTimer), this._loginTimer = void 0);
  }, n;
}(Qs), Rm = function(t) {
  function n(e) {
    var r = e.appId, i = e.userId, s = e.includeUIKitConfig, a = s !== void 0 && s, o = e.localCacheEnabled, l = o === void 0 || o, c = e.expiringSession, u = c === void 0 || c, d = t.call(this) || this;
    return d.path = "".concat(ey, "/").concat(i, "/authentication"), d.method = Y.POST, d.params = fe({ expiring_session: !!u, include_logi: !0, include_extra_data: String(Om), uikit_config: a, use_local_cache: l, app_id: r }), d.requireAuth = !1, d;
  }
  return S(n, t), n;
}($), x1 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.logi = new Tl(e, "LOGI", r), i;
  }
  return S(n, t), n;
}(ne);
(function(t) {
  t[t.ALL = 0] = "ALL", t[t.WEBSOCKET = 1] = "WEBSOCKET", t[t.API = 2] = "API";
})(Yi || (Yi = {}));
var jt, Tp, k1 = [Hd, Rm], O1 = function() {
  function t(n, e) {
    var r = e.session, i = e.sdkState, s = e.dispatcher, a = e.logger, o = e.useFetchCompat, l = o !== void 0 && o, c = this;
    this._currentConnectionStateType = bt.INITIALIZED, this._lazyCallQueue = [], this.commandRouter = new y1(n, { session: r, sdkState: i, dispatcher: s, logger: a, useFetchCompat: l }), this._session = r, this._logger = a, this._dispatcher = s, this._dispatcher.on(function(u) {
      var d, h, p;
      if (u instanceof Ar) {
        var f = u.stateType;
        switch (c._currentConnectionStateType = f, f) {
          case bt.CONNECTED:
            c._resolveLazyCallQueue();
            break;
          case bt.INITIALIZED:
          case bt.INTERNAL_DISCONNECTED:
          case bt.EXTERNAL_DISCONNECTED:
          case bt.LOGOUT:
            c._rejectLazyCallQueue(!((p = c._session) === null || p === void 0) && p.hasSession ? D.connectionClosed : D.connectionRequired);
        }
      } else if (u instanceof Nm)
        c._session.hasChatServicePermission || c._resolveLazyCallQueue(Yi.API);
      else if (u instanceof nd || u instanceof Im)
        c._rejectLazyCallQueue(D.connectionClosed);
      else if (u instanceof am) {
        var m = u.request, v = u.deferred, E = u.error;
        try {
          for (var y = de(k1), b = y.next(); !b.done; b = y.next())
            if (m instanceof b.value)
              return void v.reject(E);
        } catch (T) {
          d = { error: T };
        } finally {
          try {
            b && !b.done && (h = y.return) && h.call(y);
          } finally {
            if (d)
              throw d.error;
          }
        }
        c._lazyCallQueue.push({ command: m, deferred: v });
      }
    });
  }
  return Object.defineProperty(t.prototype, "isReady", { get: function() {
    return this._currentConnectionStateType === bt.CONNECTED;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "isLazyCallActivated", { get: function() {
    return this._currentConnectionStateType === bt.CONNECTING || this._currentConnectionStateType === bt.RECONNECTING || this._session.isRefreshing;
  }, enumerable: !1, configurable: !0 }), t.prototype._classifyLazyCallQueueByScope = function(n) {
    var e, r = [], i = [];
    switch (n) {
      case Yi.ALL:
        e = null;
        break;
      case Yi.WEBSOCKET:
        e = Zn;
        break;
      case Yi.API:
        e = $;
    }
    var s = !1;
    return this._lazyCallQueue.forEach(function(a) {
      !e || a.command instanceof e || (s = !0), s ? i.push(a) : r.push(a);
    }), [r, i];
  }, t.prototype._resolveLazyCallQueue = function(n) {
    var e = this;
    n === void 0 && (n = Yi.ALL);
    var r = we(this._classifyLazyCallQueueByScope(n), 2), i = r[0], s = r[1];
    this._lazyCallQueue = s, i.forEach(function(a) {
      return g(e, 0, void 0, function() {
        var o, l, c, u, d;
        return _(this, function(h) {
          switch (h.label) {
            case 0:
              o = a.command, l = a.deferred, (c = a.timeout) && clearTimeout(c), h.label = 1;
            case 1:
              return h.trys.push([1, 3, , 4]), [4, this.send(o)];
            case 2:
              return u = h.sent(), l.resolve(u), [3, 4];
            case 3:
              return d = h.sent(), l.reject(d), [3, 4];
            case 4:
              return [2];
          }
        });
      });
    });
  }, t.prototype._rejectLazyCallQueue = function(n, e) {
    var r = this;
    e === void 0 && (e = Yi.ALL);
    var i = we(this._classifyLazyCallQueueByScope(e), 2), s = i[0], a = i[1];
    this._lazyCallQueue = a, s.forEach(function(o) {
      return g(r, 0, void 0, function() {
        var l, c;
        return _(this, function(u) {
          return l = o.deferred, c = o.timeout, clearTimeout(c), l.reject(n), [2];
        });
      });
    });
  }, t.prototype.send = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i = this;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return n instanceof Zn ? this.isReady ? (this._logger.debug("send websocket request", n), [4, this.commandRouter.send(n)]) : [3, 2] : [3, 4];
          case 1:
          case 5:
          case 7:
            return [2, s.sent()];
          case 2:
            if (this.isLazyCallActivated)
              return this._logger.debug("wait websocket request", n), e = new $n(), this._lazyCallQueue.push({ command: n, deferred: e, timeout: setTimeout(function() {
                return i.timeout(n.requestId);
              }, 1e4) }), [2, e.promise];
            throw this._logger.debug("fail websocket request"), D.connectionRequired;
          case 3:
          case 9:
            return [3, 11];
          case 4:
            return n instanceof $ ? this._session.hasSession ? (this._logger.debug("send api request", n), [4, this.commandRouter.send(n)]) : [3, 6] : [3, 10];
          case 6:
            return n.hasSessionKey ? (this._logger.debug("send api request with tmp session key", n), [4, this.commandRouter.send(n)]) : [3, 8];
          case 8:
            if (this.isLazyCallActivated)
              return this._logger.debug("wait api request", n), e = new $n(), this._lazyCallQueue.push({ command: n, deferred: e, timeout: setTimeout(function() {
                return i.timeout(n.requestId);
              }, 1e4) }), [2, e.promise];
            throw r = D.connectionRequired, this._logger.debug("fail api request", r), r;
          case 10:
            throw D.invalidCommand;
          case 11:
            return [2];
        }
      });
    });
  }, t.prototype.forceSend = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return this._logger.debug("send forced request", n), n instanceof Zn || n instanceof $ ? [4, this.commandRouter.send(n)] : [3, 2];
          case 1:
            return [2, e.sent()];
          case 2:
            throw D.invalidCommand;
        }
      });
    });
  }, t.prototype.timeout = function(n) {
    this._logger.debug("timeout request", n);
    var e = this._lazyCallQueue.findIndex(function(r) {
      return r.command.requestId === n;
    });
    e > -1 && (this._lazyCallQueue[e].deferred.reject(D.connectionRequired), this._lazyCallQueue.splice(e, 1));
  }, t.prototype.cancel = function(n) {
    this._logger.debug("cancel api request", n), this.commandRouter.cancel(n);
  }, t.prototype.cancelAll = function() {
    this._logger.debug("cancel all api requests"), this.commandRouter.cancelAll();
  }, t;
}(), lu = "sendbird@devicetokens", cu = function() {
  function t(n) {
    var e = n.type, r = n.token, i = n.device_os, s = n.device_manufacturer, a = n.system_push_enabled;
    this.type = e, this.token = r, this.deviceOS = i, this.deviceManufacturer = s, this.systemPushEnabled = a;
  }
  return t.payloadify = function(n) {
    return fe(Ae({ type: n.type, token: n.token, device_os: n.deviceOS, device_manufacturer: n.deviceManufacturer, system_push_enabled: n.systemPushEnabled }));
  }, t;
}(), uu = /* @__PURE__ */ new WeakMap(), R1 = function(t) {
  function n(e) {
    var r = e._iid, i = e.session, s = e.cacheContext, a = e.sdkState, o = e.dispatcher, l = e.requestQueue, c = e.logger, u = e.pushNotificationAckManager, d = t.call(this) || this;
    return d._currentConnectionStateType = bt.INITIALIZED, d._isRefreshingAuthToken = !1, d.currentUser = null, d.session = i, d._iid = r, d._cacheContext = s, d._sdkState = a, d._dispatcher = o, d._requestQueue = l, d._logger = c, d._pushNotificationAckManager = u, d._deviceTokens = [], d._dispatcher.on(function(h) {
      var p, f, m;
      if (h instanceof Ar) {
        var v = h.stateType;
        d._currentConnectionStateType = v;
      } else if (h instanceof fa && d.handler && !d.isSessionKeyRefreshing) {
        if (d._currentConnectionStateType === bt.CONNECTING)
          return;
        !((p = h.error) === null || p === void 0) && p.isSessionInvalidatedError ? d.close() : (!((f = h.error) === null || f === void 0) && f.isSessionTokenExpiredError && d.refreshAuthToken().catch(function(E) {
          if (rr(E) && d._sdkState.appState === "foreground")
            throw E;
        }), !((m = h.error) === null || m === void 0) && m.isSessionKeyExpiredError && (d._logger.debug("session expired"), d.handler.onSessionExpired && d.handler.onSessionExpired(), d.refreshSessionKey().catch(function(E) {
          if (rr(E) && d._sdkState.appState === "foreground")
            throw E;
        })));
      }
    }), d;
  }
  return S(n, t), Object.defineProperty(n.prototype, "ekey", { get: function() {
    return uu.get(this);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "deviceTokens", { get: function() {
    return this._deviceTokens;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "deviceTokenLastDeletedAt", { get: function() {
    return this._deviceTokenLastDeletedAt;
  }, enumerable: !1, configurable: !0 }), n.prototype.indexOfDeviceToken = function(e, r) {
    return this._deviceTokens.findIndex(function(i) {
      return i.type === e && i.token === r;
    });
  }, n.prototype.hasDeviceToken = function(e, r) {
    return this.indexOfDeviceToken(e, r) >= 0;
  }, n.prototype.createRefreshWebsocketCommand = function(e, r) {
    return new hy({ authToken: e, expiringSession: !0, requestId: r });
  }, n.prototype._refreshSessionKeyByWebSocket = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return r = this.createRefreshWebsocketCommand(e), [4, this._requestQueue.forceSend(r)];
          case 1:
            if (i = l.sent(), s = i.as(fy), a = s.newKey, o = s.error)
              throw o;
            return this.session.sessionKey = a ?? this.session.sessionKey, [2];
        }
      });
    });
  }, n.prototype._refreshSessionKeyByApi = function(e) {
    return g(this, 0, void 0, function() {
      var r, i = this;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return r = new Hd({ userId: this._sdkState.userId, authToken: e, services: this.session.services && this.session.services.length > 0 ? this.session.services : void 0, expiringSession: !0 }), [4, yc(function(a) {
              return g(i, 0, void 0, function() {
                var o, l, c, u, d;
                return _(this, function(h) {
                  switch (h.label) {
                    case 0:
                      return h.trys.push([0, 2, , 3]), [4, this._requestQueue.forceSend(r)];
                    case 1:
                      return o = h.sent(), l = o.as(py), c = l.key, u = l.services, this.session.sessionKey = c, this.session.services = u, [3, 3];
                    case 2:
                      if (d = h.sent(), !this._isSessionRelatedError(d))
                        throw d;
                      return a(d), [3, 3];
                    case 3:
                      return [2];
                  }
                });
              });
            }, 3)];
          case 1:
            return s.sent(), [2];
        }
      });
    });
  }, n.prototype._refreshSessionKey = function(e, r) {
    return r === void 0 && (r = !0), g(this, 0, void 0, function() {
      var i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            if (this._currentConnectionStateType !== bt.CONNECTED)
              return [3, 8];
            a.label = 1;
          case 1:
            return a.trys.push([1, 3, , 8]), [4, this._refreshSessionKeyByWebSocket(e)];
          case 2:
            return a.sent(), this.complete(), [2];
          case 3:
            i = a.sent(), a.label = 4;
          case 4:
            return a.trys.push([4, 6, , 7]), [4, this._handleSessionRefreshError(i, r)];
          case 5:
            return a.sent(), [2];
          case 6:
            return a.sent(), [3, 7];
          case 7:
            return [3, 8];
          case 8:
            return a.trys.push([8, 10, , 12]), [4, this._refreshSessionKeyByApi(e)];
          case 9:
            return a.sent(), this.complete(), [3, 12];
          case 10:
            return s = a.sent(), [4, this._handleSessionRefreshError(s, r)];
          case 11:
            return a.sent(), [3, 12];
          case 12:
            return [2];
        }
      });
    });
  }, n.prototype._receiveNewAuthToken = function() {
    var e, r = this, i = new $n();
    if (this._isRefreshingAuthToken = !0, this.session.sessionKey = void 0, this.session.authToken = void 0, (e = this.handler) === null || e === void 0 ? void 0 : e.onSessionTokenRequired) {
      var s = null, a = function() {
        s && (clearTimeout(s), s = null);
      }, o = function(c) {
        a(), r._isRefreshingAuthToken && (r._isRefreshingAuthToken = !1, i.resolve(c));
      }, l = function(c) {
        a(), r._isRefreshingAuthToken && (r._isRefreshingAuthToken = !1, i.reject(c));
      };
      s = setTimeout(function() {
        return l();
      }, 1e3 * this._sdkState.sessionTokenRefreshTimeout), Ue(function() {
        return g(r, 0, void 0, function() {
          var c;
          return _(this, function(u) {
            return !((c = this.handler) === null || c === void 0) && c.onSessionTokenRequired && this.handler.onSessionTokenRequired(o, l), [2];
          });
        });
      });
    } else
      i.resolve(null);
    return i.promise;
  }, n.prototype._handleSessionRefreshError = function(e, r) {
    return r === void 0 && (r = !1), g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return e instanceof D && (e.isSessionTokenExpiredError || e.code === me.APPLICATION_NOT_FOUND) ? (this.session.authToken = void 0, r ? [4, this._receiveNewAuthToken()] : [3, 6]) : [3, 6];
          case 1:
            return (i = s.sent()) ? (this.session.authToken = i, [4, this._refreshSessionKey(this.session.authToken, !1)]) : [3, 3];
          case 2:
            return s.sent(), [3, 5];
          case 3:
            return [4, this.clear()];
          case 4:
            s.sent(), s.label = 5;
          case 5:
            return [2];
          case 6:
            throw e;
        }
      });
    });
  }, n.prototype._isSessionRelatedError = function(e) {
    return e instanceof D && (e.isSessionExpiredError || e.isSessionInvalidatedError);
  }, Object.defineProperty(n.prototype, "isSessionKeyRefreshing", { get: function() {
    return this.session.isRefreshing;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isRefreshingAuthToken", { get: function() {
    return this._isRefreshingAuthToken;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isSessionExpiring", { get: function() {
    return !!this.handler;
  }, enumerable: !1, configurable: !0 }), n.prototype.authenticate = function(e, r) {
    var i;
    return g(this, 0, void 0, function() {
      var s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this.session.authToken = r, s = new Rm({ appId: this._sdkState.appId, userId: e, includeUIKitConfig: !!((i = this._sdkState.extensions) !== null && i !== void 0 ? i : {}).sb_uikit, localCacheEnabled: this._cacheContext.localCacheEnabled, expiringSession: !r || this.isSessionExpiring }), [4, this._requestQueue.commandRouter.send(s)];
          case 1:
            return a = l.sent(), (o = a.as(x1).logi).error ? [3, 4] : this.session.hasChatServicePermission ? [3, 3] : [4, o.applyTo(this._iid)];
          case 2:
            l.sent(), l.label = 3;
          case 3:
            return [3, 5];
          case 4:
            throw o.error;
          case 5:
            return [2];
        }
      });
    });
  }, n.prototype.login = function(e) {
    var r;
    return g(this, 0, void 0, function() {
      var i, s, a, o, l, c, u, d;
      return _(this, function(h) {
        switch (h.label) {
          case 0:
            return i = e.key, s = e.ekey, a = e.services, o = e.userProfile, l = e.deviceTokenLastDeletedAt, c = l === void 0 ? 0 : l, this.session.sessionKey = i, this.session.services = a, uu.set(this, s), this._deviceTokenCacheEnabled = (r = o == null ? void 0 : o.appInfo) === null || r === void 0 ? void 0 : r.deviceTokenCache, u = this._cacheContext.preference, this._deviceTokenCacheEnabled ? [4, u.get(lu)] : [3, 5];
          case 1:
            return !(d = h.sent()) || d.lastDeletedAt < c ? (this._deviceTokens = [], this._deviceTokenLastDeletedAt = c, [4, this.saveDeviceToken()]) : [3, 3];
          case 2:
            return h.sent(), [3, 4];
          case 3:
            this._deviceTokens = d.tokens.map(function(p) {
              return new cu(cu.payloadify(p));
            }), this._deviceTokenLastDeletedAt = d.lastDeletedAt, h.label = 4;
          case 4:
            return [3, 7];
          case 5:
            return [4, u.remove(lu)];
          case 6:
            h.sent(), h.label = 7;
          case 7:
            return [2];
        }
      });
    });
  }, n.prototype.complete = function() {
    var e = this;
    this.dispatch("refresh"), this._dispatcher.dispatch(new Nm()), Ue(function() {
      return g(e, 0, void 0, function() {
        var r;
        return _(this, function(i) {
          return this._logger.debug("session refreshed"), !((r = this.handler) === null || r === void 0) && r.onSessionRefreshed && this.handler.onSessionRefreshed(), [2];
        });
      });
    });
  }, n.prototype.error = function(e) {
    var r = this;
    Ue(function() {
      return g(r, 0, void 0, function() {
        var i;
        return _(this, function(s) {
          return !((i = this.handler) === null || i === void 0) && i.onSessionError && this.handler.onSessionError(e), [2];
        });
      });
    });
  }, n.prototype.close = function() {
    var e = this;
    this.dispatch("close"), this._dispatcher.dispatch(new Im()), Ue(function() {
      return g(e, 0, void 0, function() {
        var r;
        return _(this, function(i) {
          return this._logger.debug("session closed"), !((r = this.handler) === null || r === void 0) && r.onSessionClosed && this.handler.onSessionClosed(), [2];
        });
      });
    });
  }, n.prototype.refreshAuthToken = function() {
    return g(this, 0, void 0, function() {
      var e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            if (e = null, !this.isSessionExpiring || this.session.isRefreshing)
              return [3, 9];
            this.session.isRefreshing = !0, i.label = 1;
          case 1:
            return i.trys.push([1, 7, 8, 9]), [4, this._receiveNewAuthToken()];
          case 2:
            return (e = i.sent()) ? (this._logger.debug("session refreshing.."), this.session.authToken = e, [4, this._refreshSessionKey(this.session.authToken)]) : [3, 4];
          case 3:
            return i.sent(), [3, 6];
          case 4:
            return [4, this.clear()];
          case 5:
            i.sent(), i.label = 6;
          case 6:
            return [3, 9];
          case 7:
            throw i.sent(), r = e ? D.sessionTokenRefreshFailed : D.sessionTokenRequestFailed, this._dispatcher.dispatch(new nd()), this.error(r), this._logger.debug("refresh auth token error = ", r), r;
          case 8:
            return this.session.isRefreshing = !1, [7];
          case 9:
            return [2];
        }
      });
    });
  }, n.prototype.refreshSessionKey = function() {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            if (!this.isSessionExpiring || this.session.isRefreshing)
              return [3, 5];
            this.session.isRefreshing = !0, r.label = 1;
          case 1:
            return r.trys.push([1, 3, 4, 5]), [4, this._refreshSessionKey(this.session.authToken)];
          case 2:
            return r.sent(), [3, 5];
          case 3:
            throw r.sent(), e = D.sessionTokenRefreshFailed, this._dispatcher.dispatch(new nd()), this.error(e), e;
          case 4:
            return this.session.isRefreshing = !1, [7];
          case 5:
            return [2];
        }
      });
    });
  }, n.prototype.setDeviceToken = function(e, r, i) {
    if (this._deviceTokenCacheEnabled && this.indexOfDeviceToken(e, r) < 0) {
      var s = new cu({ type: e, token: r, device_os: i == null ? void 0 : i.deviceOS, device_manufacturer: i == null ? void 0 : i.deviceManufacturer, system_push_enabled: i == null ? void 0 : i.systemPushEnabled });
      return this._deviceTokens.push(s), !0;
    }
    return !1;
  }, n.prototype.unsetDeviceToken = function(e, r) {
    if (this._deviceTokenCacheEnabled) {
      var i = this.indexOfDeviceToken(e, r);
      i >= 0 && this._deviceTokens.splice(i, 1);
    }
  }, n.prototype.unsetDeviceTokens = function(e) {
    this._deviceTokenCacheEnabled && (this._deviceTokens = e ? this._deviceTokens.filter(function(r) {
      return r.type !== e;
    }) : []);
  }, n.prototype.setDeviceTokenDeletedAt = function(e) {
    e > 0 && (this._deviceTokenLastDeletedAt = e);
  }, n.prototype.saveDeviceToken = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return this._deviceTokenCacheEnabled ? [4, this._cacheContext.preference.set(lu, { tokens: this._deviceTokens, lastDeletedAt: this._deviceTokenLastDeletedAt })] : [3, 2];
          case 1:
            e.sent(), e.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return this.currentUser = null, this.session.clear(), this.close(), uu.delete(this), this._deviceTokens = [], this._deviceTokenLastDeletedAt = 0, [4, this.saveDeviceToken()];
          case 1:
            return e.sent(), this._pushNotificationAckManager.clear(), [2];
        }
      });
    });
  }, n;
}(Qs), Dm = function(t, n) {
  var e, r;
  if (t !== null && n !== null) {
    var i = Object.keys(t), s = Object.keys(n), a = Re([], we(new Set(Re(Re([], we(i), !1), we(s), !1))), !1), o = {};
    try {
      for (var l = de(a), c = l.next(); !c.done; c = l.next()) {
        var u = c.value, d = typeof t[u], h = typeof n[u];
        d === "undefined" ? o[u] = n[u] : h === "undefined" ? o[u] = t[u] : d !== h ? o[u] = n[u] : d === "object" && t[u] && n[u] ? o[u] = Dm(t[u], n[u]) : o[u] = n[u];
      }
    } catch (p) {
      e = { error: p };
    } finally {
      try {
        c && !c.done && (r = l.return) && r.call(l);
      } finally {
        if (e)
          throw e.error;
      }
    }
    return o;
  }
  return n;
};
(function(t) {
  t[t.PENDING = 0] = "PENDING", t[t.COLLECT_ONLY = 1] = "COLLECT_ONLY", t[t.ENABLED = 2] = "ENABLED", t[t.DISABLED = 3] = "DISABLED";
})(jt || (jt = {})), function(t) {
  t.DAILY = "daily", t.DEFAULT = "default", t.REALTIME = "realtime";
}(Tp || (Tp = {}));
var Yl, Ec = 100, Kd = function() {
  function t(n) {
    var e = n.deviceId, r = n.cacheContext, i = n.requestQueue;
    this.queue = [], this.flushWaitQueue = [], this.enabledState = jt.PENDING, this.isFlushing = !1, this._sentLogStats = [], this.deviceId = e, this.cacheContext = r, this.requestQueue = i, this.logInfo = { deviceId: e, statLogs: [], generation: 1, lastFlushedAt: 0 }, this.limit = Ec;
  }
  return Object.defineProperty(t.prototype, "isEnabled", { get: function() {
    return this.enabledState === jt.ENABLED;
  }, enumerable: !1, configurable: !0 }), t.prototype.init = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this.key = n, [4, this.cacheContext.preference.get(this.key)];
          case 1:
            return (e = r.sent()) && (this.logInfo = e), [2];
        }
      });
    });
  }, t.prototype._mergeQueue = function() {
    this.flushWaitQueue.length > 0 && (this.queue = this.queue.concat(this.flushWaitQueue), this.flushWaitQueue = []);
  }, t.prototype._isDuplicateStat = function(n) {
    var e = this._sentLogStats.find(function(r) {
      var i;
      return r.channelUrl === n.data.channel_url && r.messageId === ((i = n.data.notificationId) !== null && i !== void 0 ? i : n.data.message_id) && r.action === n.data.action;
    });
    return e || this._sentLogStats.push({ channelUrl: n.data.channel_url, messageId: n.data.message_id, action: n.data.action }), !!e;
  }, t.prototype._save = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return n = Re(Re([], we(this.queue), !1), we(this.flushWaitQueue), !1), [4, this.cacheContext.preference.set(this.key, { deviceId: this.logInfo.deviceId, statLogs: n.map(function(r) {
              return Zt.payloadify(r);
            }), generation: this.logInfo.generation++, lastFlushedAt: this.logInfo.lastFlushedAt })];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, t.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        return this.queue = [], this.flushWaitQueue = [], this.logInfo.generation = 1, this._save(), [2];
      });
    });
  }, t;
}(), No = function(t) {
  function n(e) {
    var r, i, s, a, o = e.type, l = e.data, c = e.ts, u = c === void 0 ? Date.now() : c, d = t.call(this, { type: o, data: l, ts: u }) || this;
    return d.date = new Date(u), d.key = "".concat((r = d.date, i = r.getFullYear(), s = String(r.getMonth() + 1).padStart(2, "0"), a = String(r.getDate()).padStart(2, "0"), "".concat(i).concat(s).concat(a)), "_").concat(o), d;
  }
  return S(n, t), n;
}(Zt), Lm = function(t) {
  function n(e) {
    var r = e.deviceId, i = e.statLogs, s = t.call(this) || this;
    return s.method = Y.POST, s.path = "".concat(oy), s.params = { device_id: r, log_entries: i.map(function(a) {
      return Zt.payloadify(a);
    }) }, s;
  }
  return S(n, t), n;
}($), D1 = function(t) {
  function n(e) {
    var r = e.deviceId, i = e.cacheContext, s = e.requestQueue;
    return t.call(this, { deviceId: r, cacheContext: i, requestQueue: s }) || this;
  }
  return S(n, t), Object.defineProperty(n.prototype, "_isSendable", { get: function() {
    return this.queue.length !== 0 && Date.now() - this.logInfo.lastFlushedAt >= this.statConfig.minInterval;
  }, enumerable: !1, configurable: !0 }), n.prototype.init = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, t.prototype.init.call(this, e + ".daily")];
          case 1:
            return r.sent(), this.queue = this.logInfo.statLogs.map(function(i) {
              return new Zt({ type: i.stat_type, ts: i.ts, data: i.data });
            }), [2];
        }
      });
    });
  }, n.prototype.setConfig = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this.statConfig = e, this.statConfig.minInterval = 864e5, this._mergeQueue(), r.localCacheStat ? (this.enabledState = r.enabledStat ? jt.ENABLED : jt.COLLECT_ONLY, [3, 3]) : [3, 1];
          case 1:
            return this.enabledState = jt.DISABLED, [4, this.clear()];
          case 2:
            l.sent(), l.label = 3;
          case 3:
            return this.isEnabled && this._isSendable ? [4, this._getUploadStats()] : [3, 9];
          case 4:
            i = l.sent(), s = Math.max(Math.floor(Math.random() * this.statConfig.requestDelayRange), 100), a = 0, l.label = 5;
          case 5:
            return a < i.length ? (o = i.slice(a, 1 + this.statConfig.maxStatCountPerRequest), [4, er(s)]) : [3, 9];
          case 6:
            return l.sent(), [4, this._flush(o)];
          case 7:
            l.sent(), l.label = 8;
          case 8:
            return a += this.statConfig.maxStatCountPerRequest, [3, 5];
          case 9:
            return [2];
        }
      });
    });
  }, n.prototype.put = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return this.enabledState === jt.DISABLED ? [2, !0] : (r = this.enabledState === jt.PENDING || this.isFlushing ? this.flushWaitQueue : this.queue, i = we(r.filter(function(l) {
              return l instanceof No && l.key === e.key;
            }), 1), (s = i[0]) ? s.data = Dm(s.data, e.data) : r.push(e), this.enabledState === jt.PENDING ? [3, 2] : [4, this._save()]);
          case 1:
            o.sent(), o.label = 2;
          case 2:
            return this.isEnabled ? (this._mergeQueue(), this._isSendable ? [4, this._getUploadStats()] : [3, 5]) : [3, 5];
          case 3:
            return a = o.sent(), [4, this._flush(a)];
          case 4:
            return [2, o.sent()];
          case 5:
            return [2, !0];
        }
      });
    });
  }, n.prototype._getUploadStats = function() {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        return e = this.queue.filter(function(i) {
          if (i instanceof No) {
            var s = /* @__PURE__ */ new Date(), a = we([i.date.getFullYear(), s.getFullYear()], 2), o = a[0], l = a[1];
            if (o < l)
              return !0;
            if (o === l) {
              var c = we([i.date.getMonth(), s.getMonth()], 2), u = c[0], d = c[1];
              if (u < d)
                return !0;
              if (u === d) {
                var h = we([i.date.getDate(), s.getDate()], 2);
                return h[0] < h[1];
              }
            }
          }
          return !1;
        }), [2, e];
      });
    });
  }, n.prototype._flush = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            if (r = !0, !(e.length > 0))
              return [3, 10];
            if (this.isFlushing)
              return [3, 9];
            this.isFlushing = !0, o.label = 1;
          case 1:
            return o.trys.push([1, 4, 8, 9]), i = Re([], we(e), !1).slice(0, Math.min(this.limit, this.statConfig.maxStatCountPerRequest)), s = new Lm({ deviceId: this.deviceId, statLogs: i }), [4, this.requestQueue.send(s)];
          case 2:
            return o.sent(), this.queue = Re([], we(e), !1).slice(i.length).concat(this.flushWaitQueue), this.flushWaitQueue = [], this.limit = Ec, this.logInfo.lastFlushedAt = Date.now(), [4, this._save()];
          case 3:
            return o.sent(), [3, 9];
          case 4:
            return (a = o.sent()) instanceof D ? a.code !== me.NON_AUTHORIZED ? [3, 6] : [4, this.clear()] : [3, 7];
          case 5:
            return o.sent(), this.enabledState = jt.DISABLED, [3, 7];
          case 6:
            a.code === me.STAT_UPLOAD_NOT_ALLOWED && (this.enabledState = jt.COLLECT_ONLY), o.label = 7;
          case 7:
            return this.limit = this.limit + 20, r = !1, [3, 9];
          case 8:
            return this.isFlushing = !1, [7];
          case 9:
            return [3, 11];
          case 10:
            this.isFlushing = !1, o.label = 11;
          case 11:
            return [2, r];
        }
      });
    });
  }, n;
}(Kd), L1 = function(t) {
  function n(e) {
    var r = e.deviceId, i = e.cacheContext, s = e.requestQueue;
    return t.call(this, { deviceId: r, cacheContext: i, requestQueue: s }) || this;
  }
  return S(n, t), n.prototype._isSendable = function(e) {
    if (e === void 0 && (e = !1), this.queue.length < this.statConfig.lowerThreshold)
      return !1;
    if (e) {
      if (Date.now() - this.logInfo.lastFlushedAt < this.statConfig.minInterval)
        return !1;
    } else if (this.queue.length < this.statConfig.minStatCount)
      return !1;
    return !0;
  }, n.prototype._filterQueueByType = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        return [2, r ? e.filter(function(s) {
          return s.type !== Ft.FEATURE_LOCALCACHE_EVENT;
        }) : e.filter(function(s) {
          return s.type === Ft.FEATURE_LOCALCACHE_EVENT;
        })];
      });
    });
  }, n.prototype.init = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, t.prototype.init.call(this, e + ".default")];
          case 1:
            return r.sent(), this.queue = this.logInfo.statLogs.map(function(i) {
              return i.data = A({ message_init_policy: "", starting_point: 0 }, i.data), new Zt({ type: i.stat_type, ts: i.ts, data: i.data });
            }), [2];
        }
      });
    });
  }, n.prototype.setConfig = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this.statConfig = e, this._mergeQueue(), r.requestStat || r.localCacheStat ? (this.enabledState = r.enabledStat ? jt.ENABLED : jt.COLLECT_ONLY, i = void 0, r.requestStat || (i = !1), r.localCacheStat || (i = !0), i === void 0 ? [3, 3] : (s = this, [4, this._filterQueueByType(this.queue, i)])) : [3, 4];
          case 1:
            return s.queue = l.sent(), a = this, [4, this._filterQueueByType(this.flushWaitQueue, i)];
          case 2:
            a.flushWaitQueue = l.sent(), this._save(), l.label = 3;
          case 3:
            return [3, 6];
          case 4:
            return this.enabledState = jt.DISABLED, [4, this.clear()];
          case 5:
            l.sent(), l.label = 6;
          case 6:
            return this.isEnabled && this._isSendable(!0) ? (o = Math.max(Math.floor(Math.random() * this.statConfig.requestDelayRange), 100), [4, er(o)]) : [3, 9];
          case 7:
            return l.sent(), [4, this._flush(this.queue)];
          case 8:
            l.sent(), l.label = 9;
          case 9:
            return [2];
        }
      });
    });
  }, n.prototype.put = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.enabledState === jt.DISABLED ? [2, !0] : ((r = this.enabledState === jt.PENDING || this.isFlushing ? this.flushWaitQueue : this.queue).push(e), this.enabledState === jt.PENDING ? [3, 2] : [4, this._save()]);
          case 1:
            i.sent(), i.label = 2;
          case 2:
            return this.isEnabled ? (this._mergeQueue(), this._isSendable() ? [4, this._flush(r)] : [3, 4]) : [3, 4];
          case 3:
            return [2, i.sent()];
          case 4:
            return [2, !0];
        }
      });
    });
  }, n.prototype._flush = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            if (r = !0, !(e.length > 0))
              return [3, 10];
            if (this.isFlushing)
              return [3, 9];
            this.isFlushing = !0, o.label = 1;
          case 1:
            return o.trys.push([1, 4, 8, 9]), i = Re([], we(e), !1).slice(0, Math.min(this.limit, this.statConfig.maxStatCountPerRequest)), s = new Lm({ deviceId: this.deviceId, statLogs: i }), [4, this.requestQueue.send(s)];
          case 2:
            return o.sent(), this.queue = Re([], we(e), !1).slice(i.length).concat(this.flushWaitQueue), this.flushWaitQueue = [], this.limit = Ec, this.logInfo.lastFlushedAt = Date.now(), [4, this._save()];
          case 3:
            return o.sent(), [3, 9];
          case 4:
            return (a = o.sent()) instanceof D ? a.code !== me.NON_AUTHORIZED ? [3, 6] : [4, this.clear()] : [3, 7];
          case 5:
            return o.sent(), this.enabledState = jt.DISABLED, [3, 7];
          case 6:
            a.code === me.STAT_UPLOAD_NOT_ALLOWED && (this.enabledState = jt.COLLECT_ONLY), o.label = 7;
          case 7:
            return this.limit = this.limit + 20, r = !1, [3, 9];
          case 8:
            return this.isFlushing = !1, [7];
          case 9:
            return [3, 11];
          case 10:
            this.isFlushing = !1, o.label = 11;
          case 11:
            return [2, r];
        }
      });
    });
  }, n;
}(Kd), U1 = function(t) {
  function n(e) {
    var r = e.deviceId, i = e.statLogs, s = t.call(this) || this;
    return s.method = Y.POST, s.path = "".concat(ly), s.params = { device_id: r, log_entries: i.map(function(a) {
      return Zt.payloadify(a);
    }) }, s;
  }
  return S(n, t), n;
}($), P1 = function(t) {
  function n(e) {
    var r = e.deviceId, i = e.cacheContext, s = e.requestQueue;
    return t.call(this, { deviceId: r, cacheContext: i, requestQueue: s }) || this;
  }
  return S(n, t), Object.defineProperty(n.prototype, "_isSendable", { get: function() {
    return this.queue.length >= this.statConfig.minStatCount && this.queue.length > this.statConfig.lowerThreshold || this.logInfo.lastFlushedAt > 0 && Date.now() - this.logInfo.lastFlushedAt >= this.statConfig.minInterval;
  }, enumerable: !1, configurable: !0 }), n.prototype.init = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, t.prototype.init.call(this, e + ".realtime")];
          case 1:
            return r.sent(), this.queue = this.logInfo.statLogs.map(function(i) {
              var s;
              return i.data = fe(A(A({}, i.data), { message_id: (s = i.data.notificationId) !== null && s !== void 0 ? s : i.data.message_id, notificationId: void 0 })), new Zt({ type: i.stat_type, ts: i.ts, data: i.data });
            }), this._sentLogStats = this.queue.map(function(i) {
              var s;
              return { channelUrl: i.data.channelUrl, messageId: (s = i.data.notificationId) !== null && s !== void 0 ? s : i.data.message_id, action: i.data.action };
            }), [2];
        }
      });
    });
  }, n.prototype.setConfig = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return this.statConfig = e, this._mergeQueue(), r.notificationStat ? (this.enabledState = r.enabledStat ? jt.ENABLED : jt.COLLECT_ONLY, [3, 3]) : [3, 1];
          case 1:
            return this.enabledState = jt.DISABLED, [4, this.clear()];
          case 2:
            s.sent(), s.label = 3;
          case 3:
            return this.isEnabled && this._isSendable ? (i = Math.max(Math.floor(Math.random() * this.statConfig.requestDelayRange), 100), [4, er(i)]) : [3, 6];
          case 4:
            return s.sent(), [4, this._flush(this.queue)];
          case 5:
            s.sent(), s.label = 6;
          case 6:
            return [2];
        }
      });
    });
  }, n.prototype.put = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.enabledState === jt.DISABLED ? [2, !0] : (r = this.enabledState === jt.PENDING || this.isFlushing ? this.flushWaitQueue : this.queue, this._isDuplicateStat(e) ? [2, !0] : (r.push(e), this.enabledState === jt.PENDING ? [3, 2] : [4, this._save()]));
          case 1:
            i.sent(), i.label = 2;
          case 2:
            return this.isEnabled ? (this._mergeQueue(), this.isEnabled && this._isSendable ? [4, this._flush(r)] : [3, 4]) : [3, 4];
          case 3:
            return [2, i.sent()];
          case 4:
            return [2, !0];
        }
      });
    });
  }, n.prototype._flush = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            if (r = !0, !(e.length > 0))
              return [3, 10];
            if (this.isFlushing)
              return [3, 9];
            this.isFlushing = !0, o.label = 1;
          case 1:
            return o.trys.push([1, 4, 8, 9]), i = Re([], we(e), !1).slice(0, Math.min(this.limit, this.statConfig.maxStatCountPerRequest)), s = new U1({ deviceId: this.deviceId, statLogs: i }), [4, this.requestQueue.send(s)];
          case 2:
            return o.sent(), this.queue = Re([], we(e), !1).slice(i.length).concat(this.flushWaitQueue), this.flushWaitQueue = [], this.limit = Ec, this.logInfo.lastFlushedAt = Date.now(), [4, this._save()];
          case 3:
            return o.sent(), [3, 9];
          case 4:
            return (a = o.sent()) instanceof D ? a.code !== me.NON_AUTHORIZED ? [3, 6] : [4, this.clear()] : [3, 7];
          case 5:
            return o.sent(), this.enabledState = jt.DISABLED, [3, 7];
          case 6:
            a.code === me.STAT_UPLOAD_NOT_ALLOWED && (this.enabledState = jt.COLLECT_ONLY), o.label = 7;
          case 7:
            return this.limit = this.limit + 20, r = !1, [3, 9];
          case 8:
            return this.isFlushing = !1, [7];
          case 9:
            return [3, 11];
          case 10:
            this.isFlushing = !1, o.label = 11;
          case 11:
            return [2, r];
        }
      });
    });
  }, n;
}(Kd), F1 = function() {
  function t(n) {
    var e = n.cacheContext, r = n.requestQueue, i = n.dispatcher, s = n.logger;
    this._collectRequestStat = !0, this._collectFeatureLocalCacheStat = !0, this._collectionNotificationStat = !0, this._retryCount = 0, this.deviceId = Pi(), this.cacheContext = e, this.requestQueue = r, this.dispatcher = i, this.logger = s, this._dailyStatCollector = new D1({ deviceId: this.deviceId, cacheContext: this.cacheContext, requestQueue: this.requestQueue }), this._defaultStatCollector = new L1({ deviceId: this.deviceId, cacheContext: this.cacheContext, requestQueue: this.requestQueue }), this._notificationStatCollector = new P1({ deviceId: this.deviceId, cacheContext: this.cacheContext, requestQueue: this.requestQueue });
  }
  return t.prototype._migration = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return [4, this.cacheContext.preference.get(this.key)];
          case 1:
            return (n = s.sent()) ? (e = [], n.statLogs.forEach(function(a) {
              a.stat_type === Ft.FEATURE_LOCALCACHE && e.push(new Zt({ type: a.stat_type, ts: a.ts, data: a.data }));
            }), [4, this.cacheContext.preference.set(this.key + ".daily", { deviceId: n.deviceId, statLogs: e.map(function(a) {
              return Zt.payloadify(a);
            }), generation: n.generation, lastFlushedAt: n.lastFlushedAt })]) : [3, 6];
          case 2:
            return s.sent(), r = [], n.statLogs.forEach(function(a) {
              a.stat_type !== Ft.FEATURE_LOCALCACHE && a.stat_type !== Ft.NOTIFICATION && (a.stat_type === Ft.FEATURE_LOCALCACHE_EVENT && (a.data = A({ message_init_policy: "", starting_point: 0 }, a.data)), r.push(new Zt({ type: a.stat_type, ts: a.ts, data: a.data })));
            }), [4, this.cacheContext.preference.set(this.key + ".default", { deviceId: n.deviceId, statLogs: r.map(function(a) {
              return Zt.payloadify(a);
            }), generation: n.generation, lastFlushedAt: n.lastFlushedAt })];
          case 3:
            return s.sent(), i = [], n.statLogs.forEach(function(a) {
              var o;
              a.stat_type === Ft.NOTIFICATION && (a.data = fe(A(A({}, a.data), { message_id: (o = a.data.notificationId) !== null && o !== void 0 ? o : a.data.message_id, notificationId: void 0 })), i.push(new Zt({ type: a.stat_type, ts: a.ts, data: a.data })));
            }), [4, this.cacheContext.preference.set(this.key + ".realtime", { deviceId: n.deviceId, statLogs: i.map(function(a) {
              return Zt.payloadify(a);
            }), generation: n.generation, lastFlushedAt: n.lastFlushedAt })];
          case 4:
            return s.sent(), [4, this.cacheContext.preference.remove(this.key)];
          case 5:
            s.sent(), s.label = 6;
          case 6:
            return [2];
        }
      });
    });
  }, t.prototype.init = function(n) {
    return g(this, 0, void 0, function() {
      var e = this;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this.key = n, [4, this._migration()];
          case 1:
            return r.sent(), [4, this._dailyStatCollector.init(this.key)];
          case 2:
            return r.sent(), [4, this._defaultStatCollector.init(this.key)];
          case 3:
            return r.sent(), [4, this._notificationStatCollector.init(this.key)];
          case 4:
            return r.sent(), this.commandEventContext || (this.commandEventContext = this.dispatcher.on(function(i) {
              return g(e, 0, void 0, function() {
                var s, a, o, l, c, u;
                return _(this, function(d) {
                  return i instanceof Bd ? (s = i.statLog, this.put(s)) : i instanceof Mm && (a = i.request, o = i.features, l = i.options, c = i.statConfigInfo, this._retryCount = 0, this._collectRequestStat = a, this._collectFeatureLocalCacheStat = o == null ? void 0 : o.localCache, this._collectionNotificationStat = o == null ? void 0 : o.notification, this._statConfig = c, this._dailyStatCollector.setConfig(this._statConfig.default, { localCacheStat: this._collectFeatureLocalCacheStat, enabledStat: l.ingestion }), this._defaultStatCollector.setConfig(this._statConfig.default, { requestStat: this._collectRequestStat, localCacheStat: this._collectFeatureLocalCacheStat, enabledStat: l.ingestion }), this._notificationStatCollector.setConfig((u = this._statConfig.realTime) !== null && u !== void 0 ? u : this._statConfig.default, { notificationStat: this._collectionNotificationStat, enabledStat: l.ingestion })), [2];
                });
              });
            })), [2];
        }
      });
    });
  }, t.prototype.put = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return e = !0, n instanceof No ? this._collectFeatureLocalCacheStat ? [4, this._dailyStatCollector.put(n)] : [3, 2] : [3, 3];
          case 1:
            e = r.sent(), r.label = 2;
          case 2:
            return [3, 13];
          case 3:
            switch (n.type) {
              case Ft.API_RESULT:
              case Ft.WEBSOCKET_CONNECT:
                return [3, 4];
              case Ft.FEATURE_LOCALCACHE:
              case Ft.FEATURE_LOCALCACHE_EVENT:
                return [3, 7];
              case Ft.NOTIFICATION:
                return [3, 10];
            }
            return [3, 13];
          case 4:
            return this._collectRequestStat ? [4, this._defaultStatCollector.put(n)] : [3, 6];
          case 5:
            e = r.sent(), r.label = 6;
          case 6:
            return [3, 13];
          case 7:
            return this._collectFeatureLocalCacheStat ? [4, this._defaultStatCollector.put(n)] : [3, 9];
          case 8:
            e = r.sent(), r.label = 9;
          case 9:
            return [3, 13];
          case 10:
            return this._collectionNotificationStat ? [4, this._notificationStatCollector.put(n)] : [3, 12];
          case 11:
            e = r.sent(), r.label = 12;
          case 12:
            return [3, 13];
          case 13:
            return e ? this._retryCount = 0 : (this._retryCount++, this._retryCount > 20 && (this._dailyStatCollector.enabledState = jt.COLLECT_ONLY, this._defaultStatCollector.enabledState = jt.COLLECT_ONLY, this._notificationStatCollector.enabledState = jt.COLLECT_ONLY, this.logger.debug(D.statLogUploadLimitExceededError))), [2];
        }
      });
    });
  }, t.prototype.close = function() {
    this.commandEventContext && (this.commandEventContext.close(), this.commandEventContext = void 0);
  }, t;
}(), j1 = function() {
  function t(n) {
    var e = n.limit, r = e === void 0 ? 5 : e;
    this.workersByKey = {}, this.limit = r;
  }
  return t.prototype.run = function(n, e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.workersByKey[n] || (this.workersByKey[n] = []), this.workersByKey[n].length < this.limit ? (this.workersByKey[n].push(e), [4, e()]) : [3, 2];
          case 1:
            return r = i.sent(), this.workersByKey[n].pop(), [2, r];
          case 2:
            throw D.tooManyRequests;
        }
      });
    });
  }, t.prototype.clear = function(n) {
    this.workersByKey[n] = [];
  }, t;
}();
(function(t) {
  t.DELIVERY_RECEIPT = "delivery_receipt", t.PUSH_ACKNOWLEDGEMENT = "push_acknowledgement";
})(Yl || (Yl = {}));
var B, _a, H1 = function(t) {
  function n() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e._pushAckedCache = {}, e;
  }
  return S(n, t), n.prototype.isAcked = function(e, r) {
    var i, s = "".concat(e, "_").concat(r);
    return (i = this._pushAckedCache[s]) !== null && i !== void 0 && i;
  }, n.prototype.markAsAcked = function(e, r) {
    var i = "".concat(e, "_").concat(r);
    this._pushAckedCache[i] = !0;
  }, n.prototype.clear = function() {
    k.of(this._iid).logger.debug("clear push acked cache"), this._pushAckedCache = {};
  }, n.prototype.parseData = function(e) {
    var r, i, s, a, o = k.of(this._iid).logger, l = e.sendbird;
    if (typeof l == "string")
      try {
        l = JSON.parse(l);
      } catch {
        throw o.info("push notification payload does not contain sendbird payload in JSON format."), D.malformedDataError;
      }
    if (!l || typeof l != "object")
      throw o.info("push notification payload does not contain sendbird payload in JSON format."), D.malformedDataError;
    var c = (r = l.push_tracking_id) !== null && r !== void 0 ? r : "", u = l.notification_message_id, d = l.notification_channel_key, h = l.notification_template_key, p = l.notification_event_deadline, f = (i = l.session_key) !== null && i !== void 0 ? i : {}, m = (s = f == null ? void 0 : f.key) !== null && s !== void 0 ? s : "", v = (a = f == null ? void 0 : f.topics) !== null && a !== void 0 ? a : [];
    if (typeof c != "string" || c.length === 0)
      throw o.info("push tracking id is not available"), D.malformedDataError;
    if (typeof u != "string" || u.length === 0)
      throw o.info("message id is not available"), D.malformedDataError;
    return { pushTrackingId: c, sessionKey: m, sessionTopics: v, messageId: u, channelKey: d, templateKey: h, notificationEventDeadline: p };
  }, n;
}(xn), _s = {}, k = function() {
  function t(n, e) {
    var r, i, s, a, o, l, c, u, d;
    if (this.connectedAt = 0, this.firstConnectedAt = 0, this.connectionHandlers = /* @__PURE__ */ new Map(), this.userEventHandlers = /* @__PURE__ */ new Map(), !_s[n]) {
      _s[n] = this;
      var h = (r = e.options) !== null && r !== void 0 ? r : new X0(), p = this.sdkState = { appId: e.appId, appVersion: (i = e.appVersion) !== null && i !== void 0 ? i : "", appState: "foreground", userId: void 0, extensions: {}, api: { host: (s = e.apiHost) !== null && s !== void 0 ? s : "https://api-".concat(e.appId, ".sendbird.com") }, websocket: { host: (a = e.websocketHost) !== null && a !== void 0 ? a : "wss://ws-".concat(e.appId, ".sendbird.com"), pingerDisabled: !!e.noPingpong, pingInterval: void 0, pongTimeout: void 0, connectMaxRetry: 2, compression: !0, reconnectMaxRetry: -1, reconnectRetryStrategy: new xm(), responseTimeout: h.websocketResponseTimeout }, sessionTokenRefreshTimeout: h.sessionTokenRefreshTimeout };
      this.appInfo = void 0, this.subscribedUnreadMessageCount = { all: 0, feed: 0, customTypes: {}, ts: 0 };
      var f = this.logger = e.logger;
      this.connectedAt = 0, this.firstConnectedAt = 0, this.connectionHandlers = /* @__PURE__ */ new Map(), this.userEventHandlers = /* @__PURE__ */ new Map();
      var m = this.cacheContext = new $v({ encryption: e.encryption, store: e.store, localCacheEnabled: (o = e.localCacheEnabled) !== null && o !== void 0 && o, localCacheConfig: (l = e.localCacheConfig) !== null && l !== void 0 ? l : new em() });
      this.debugMode = (c = e.debugMode) !== null && c !== void 0 && c, this.maxSuperGroupChannelUnreadCount = ts.DEFAULT_MAX_UNREAD_COUNT_OF_SUPER_GROUP_CHANNEL, this.useMemberInfoInMessage = h.useMemberInfoInMessage, this.typingIndicatorInvalidateTime = h.typingIndicatorInvalidateTime, this.typingIndicatorThrottle = h.typingIndicatorThrottle, this.concurrentCallLimit = void 0, this.backOffDelay = void 0;
      var v = this.dispatcher = new Jv(), E = new Xv();
      this.requestQueue = new O1(n, { session: E, sdkState: p, dispatcher: v, logger: f, useFetchCompat: e.useFetchCompat }), this.pushNotificationAckManager = new H1(n), this.sessionManager = new R1({ _iid: n, session: E, cacheContext: m, sdkState: p, dispatcher: v, requestQueue: this.requestQueue, logger: f, pushNotificationAckManager: this.pushNotificationAckManager }), this.connectionManager = new N1(n, { sdkState: p, cacheContext: this.cacheContext, connectionHandlers: this.connectionHandlers, dispatcher: v, sessionManager: this.sessionManager, websocketClient: this.requestQueue.commandRouter.websocketClient, disableWebSocketCloseEventHandling: (u = e.disableWebSocketCloseEventHandling) !== null && u !== void 0 && u, logger: f }), this.statManager = new F1({ cacheContext: this.cacheContext, requestQueue: this.requestQueue, dispatcher: this.dispatcher, logger: f }), this.appStateToggleEnabled = (d = e.appStateToggleEnabled) === null || d === void 0 || d, this.messageBackgroundSyncThrottleController = new j1({ limit: 5 });
    }
    return _s[n];
  }
  return t.of = function(n) {
    if (_s[n])
      return _s[n];
    throw D.lostInstance;
  }, t.clear = function(n) {
    _s[n] && delete _s[n];
  }, t.prototype.hasExtension = function(n) {
    return this.sdkState.extensions && this.sdkState.extensions[n];
  }, t;
}(), Wd = function() {
  function t() {
  }
  return t.prototype.init = function(n, e) {
    var r = e.sdkState, i = e.dispatcher, s = e.sessionManager, a = e.requestQueue, o = e.logger;
    e.onlineDetector;
    var l = e.cacheContext;
    this._iid = n, this._cacheContext = l, this._sdkState = r, this._dispatcher = i, this._sessionManager = s, this._requestQueue = a, this._logger = o;
  }, t;
}();
(function(t) {
  t.UNKNOWN = "UNKNOWN", t.EVENT_CHANNEL_CREATED = "EVENT_CHANNEL_CREATED", t.EVENT_CHANNEL_UPDATED = "EVENT_CHANNEL_UPDATED", t.EVENT_CHANNEL_DELETED = "EVENT_CHANNEL_DELETED", t.EVENT_CHANNEL_READ = "EVENT_CHANNEL_READ", t.EVENT_CHANNEL_DELIVERED = "EVENT_CHANNEL_DELIVERED", t.EVENT_CHANNEL_INVITED = "EVENT_CHANNEL_INVITED", t.EVENT_CHANNEL_JOINED = "EVENT_CHANNEL_JOINED", t.EVENT_CHANNEL_LEFT = "EVENT_CHANNEL_LEFT", t.EVENT_CHANNEL_ACCEPTED_INVITE = "EVENT_CHANNEL_ACCEPTED_INVITE", t.EVENT_CHANNEL_DECLINED_INVITE = "EVENT_CHANNEL_DECLINED_INVITE", t.EVENT_CHANNEL_OPERATOR_UPDATED = "EVENT_CHANNEL_OPERATOR_UPDATED", t.EVENT_CHANNEL_BANNED = "EVENT_CHANNEL_BANNED", t.EVENT_CHANNEL_UNBANNED = "EVENT_CHANNEL_UNBANNED", t.EVENT_CHANNEL_MUTED = "EVENT_CHANNEL_MUTED", t.EVENT_CHANNEL_UNMUTED = "EVENT_CHANNEL_UNMUTED", t.EVENT_CHANNEL_FROZEN = "EVENT_CHANNEL_FROZEN", t.EVENT_CHANNEL_UNFROZEN = "EVENT_CHANNEL_UNFROZEN", t.EVENT_CHANNEL_HIDDEN = "EVENT_CHANNEL_HIDDEN", t.EVENT_CHANNEL_UNHIDDEN = "EVENT_CHANNEL_UNHIDDEN", t.EVENT_CHANNEL_RESET_HISTORY = "EVENT_CHANNEL_RESET_HISTORY", t.EVENT_CHANNEL_TYPING_STATUS_UPDATE = "EVENT_CHANNEL_TYPING_STATUS_UPDATE", t.EVENT_CHANNEL_MEMBER_COUNT_UPDATED = "EVENT_CHANNEL_MEMBER_COUNT_UPDATED", t.EVENT_CHANNEL_METADATA_CREATED = "EVENT_CHANNEL_METADATA_CREATED", t.EVENT_CHANNEL_METADATA_UPDATED = "EVENT_CHANNEL_METADATA_UPDATED", t.EVENT_CHANNEL_METADATA_DELETED = "EVENT_CHANNEL_METADATA_DELETED", t.EVENT_CHANNEL_METACOUNTER_CREATED = "EVENT_CHANNEL_METACOUNTER_CREATED", t.EVENT_CHANNEL_METACOUNTER_UPDATED = "EVENT_CHANNEL_METACOUNTER_UPDATED", t.EVENT_CHANNEL_METACOUNTER_DELETED = "EVENT_CHANNEL_METACOUNTER_DELETED", t.EVENT_MESSAGE_SENT = "EVENT_MESSAGE_SENT", t.EVENT_MESSAGE_RECEIVED = "EVENT_MESSAGE_RECEIVED", t.EVENT_MESSAGE_UPDATED = "EVENT_MESSAGE_UPDATED", t.EVENT_PINNED_MESSAGE_UPDATED = "EVENT_PINNED_MESSAGE_UPDATED", t.REQUEST_CHANNEL = "REQUEST_CHANNEL", t.REQUEST_CHANNEL_CHANGELOGS = "REQUEST_CHANNEL_CHANGELOGS", t.REFRESH_CHANNEL = "REFRESH_CHANNEL", t.CHANNEL_LASTACCESSEDAT_UPDATED = "CHANNEL_LASTACCESSEDAT_UPDATED", t.SYNC_CHANNEL_BACKGROUND = "SYNC_CHANNEL_BACKGROUND", t.SYNC_CHANNEL_CHANGELOGS = "SYNC_CHANNEL_CHANGELOGS", t.EVENT_MESSAGE_SENT_SUCCESS = "EVENT_MESSAGE_SENT_SUCCESS", t.EVENT_MESSAGE_SENT_FAILED = "EVENT_MESSAGE_SENT_FAILED", t.EVENT_MESSAGE_SENT_PENDING = "EVENT_MESSAGE_SENT_PENDING", t.EVENT_MESSAGE_DELETED = "EVENT_MESSAGE_DELETED", t.EVENT_MESSAGE_FEEDBACK_ADDED = "EVENT_MESSAGE_FEEDBACK_ADDED", t.EVENT_MESSAGE_FEEDBACK_UPDATED = "EVENT_MESSAGE_FEEDBACK_UPDATED", t.EVENT_MESSAGE_FEEDBACK_DELETED = "EVENT_MESSAGE_FEEDBACK_DELETED", t.EVENT_MESSAGE_READ = "EVENT_MESSAGE_READ", t.EVENT_MESSAGE_DELIVERED = "EVENT_MESSAGE_DELIVERED", t.EVENT_MESSAGE_REACTION_UPDATED = "EVENT_MESSAGE_REACTION_UPDATED", t.EVENT_MESSAGE_THREADINFO_UPDATED = "EVENT_MESSAGE_THREADINFO_UPDATED", t.EVENT_MESSAGE_OFFSET_UPDATED = "EVENT_MESSAGE_OFFSET_UPDATED", t.REQUEST_MESSAGE = "REQUEST_MESSAGE", t.EVENT_THREAD_INFO_UPDATED = "EVENT_THREADINFO_UPDATED", t.EVENT_POLL_UPDATED = "EVENT_POLL_UPDATED", t.EVENT_POLL_VOTED = "EVENT_POLL_VOTED", t.SYNC_POLL_CHANGELOGS = "SYNC_POLL_CHANGELOGS", t.REQUEST_RESEND_MESSAGE = "REQUEST_RESEND_MESSAGE", t.REQUEST_THREADED_MESSAGE = "REQUEST_THREADED_MESSAGE", t.REQUEST_MESSAGE_CHANGELOGS = "REQUEST_MESSAGE_CHANGELOGS", t.SYNC_MESSAGE_FILL = "SYNC_MESSAGE_FILL", t.SYNC_MESSAGE_BACKGROUND = "SYNC_MESSAGE_BACKGROUND", t.SYNC_MESSAGE_CHANGELOGS = "SYNC_MESSAGE_CHANGELOGS", t.LOCAL_MESSAGE_PENDING_CREATED = "LOCAL_MESSAGE_PENDING_CREATED", t.LOCAL_MESSAGE_FAILED = "LOCAL_MESSAGE_FAILED", t.LOCAL_MESSAGE_CANCELED = "LOCAL_MESSAGE_CANCELED", t.LOCAL_MESSAGE_RESEND_STARTED = "LOCAL_MESSAGE_RESEND_STARTED";
})(B || (B = {})), A({}, B);
var Si = function(t) {
  return t.startsWith("EVENT_") || t.startsWith("LOCAL_MESSAGE_") || t === B.SYNC_MESSAGE_FILL || t === B.SYNC_MESSAGE_CHANGELOGS || t === B.SYNC_POLL_CHANGELOGS;
}, Pt = function(t) {
  function n(e) {
    var r = e.messages, i = e.source, s = e.isWebSocketEventComing, a = s !== void 0 && s, o = t.call(this) || this;
    return o.messages = r, o.source = i, o.isWebSocketEventComing = a, o;
  }
  return S(n, t), n;
}(Vt), Qd = function(t) {
  function n(e) {
    var r = e.messageIds, i = e.source, s = e.isWebSocketEventComing, a = s !== void 0 && s, o = t.call(this) || this;
    return o.messageIds = r, o.source = i, o.isWebSocketEventComing = a, o;
  }
  return S(n, t), n;
}(Vt), Um = function(t) {
  function n(e) {
    var r = e.event, i = e.source, s = e.isWebSocketEventComing, a = s !== void 0 && s, o = t.call(this) || this;
    return o.event = r, o.source = i, o.isWebSocketEventComing = a, o;
  }
  return S(n, t), n;
}(Vt), Pm = function(t) {
  function n(e) {
    var r = e.event, i = e.source, s = e.isWebSocketEventComing, a = s !== void 0 && s, o = t.call(this) || this;
    return o.event = r, o.source = i, o.isWebSocketEventComing = a, o;
  }
  return S(n, t), n;
}(Vt), Fm = function(t) {
  function n(e) {
    var r = e.reqId, i = e.source, s = t.call(this) || this;
    return s.reqId = r, s.source = i, s;
  }
  return S(n, t), n;
}(Vt), jm = function(t) {
  function n(e) {
    var r = e.polls, i = e.source, s = t.call(this) || this;
    return s.polls = r, s.source = i, s;
  }
  return S(n, t), n;
}(Vt), Hm = function(t) {
  function n(e) {
    var r = e.event, i = e.source, s = t.call(this) || this;
    return s.event = r, s.source = i, s;
  }
  return S(n, t), n;
}(Vt), Yd = function(t) {
  function n(e) {
    var r = e.event, i = e.source, s = t.call(this) || this;
    return s.event = r, s.source = i, s;
  }
  return S(n, t), n;
}(Vt);
(function(t) {
  t.OPEN = "open", t.CLOSED = "closed";
})(_a || (_a = {}));
var Io, id = function(t) {
  switch (t) {
    case "open":
      return _a.OPEN;
    case "closed":
      return _a.CLOSED;
    default:
      return null;
  }
}, Bm = function(t) {
  return !t || !!t.text && O("string", t.text);
}, wl = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d = this;
    return (d = t.call(this, e) || this).pollId = 0, d.id = 0, d.text = null, d.voteCount = 0, d.createdBy = null, d.createdAt = 0, d.updatedAt = 0, d._lastVotedAt = 0, d.pollId = (i = r.poll_id) !== null && i !== void 0 ? i : 0, d.id = (s = r.id) !== null && s !== void 0 ? s : 0, d.text = (a = r.text) !== null && a !== void 0 ? a : null, d.voteCount = (o = r.vote_count) !== null && o !== void 0 ? o : 0, d.createdBy = (l = r.created_by) !== null && l !== void 0 ? l : null, d.createdAt = (c = r.created_at) !== null && c !== void 0 ? c : 0, d.updatedAt = (u = r.updated_at) !== null && u !== void 0 ? u : 0, d;
  }
  return S(n, t), n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { vote_count: e.voteCount, poll_id: e.pollId, text: e.text, created_at: e.createdAt, id: e.id, created_by: e.createdBy, updated_at: e.updatedAt })));
  }, n;
}(xn), Pr = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d, h, p, f, m, v, E = this;
    return (E = t.call(this, e) || this).id = 0, E.title = null, E.createdAt = 0, E.updatedAt = 0, E.closeAt = -1, E.status = _a.CLOSED, E.messageId = 0, E.data = null, E.voterCount = -1, E.options = [], E.createdBy = null, E.allowUserSuggestion = !1, E.allowMultipleVotes = !1, E.votedPollOptionIds = [], E.id = (i = r.id) !== null && i !== void 0 ? i : 0, E.title = (s = r.title) !== null && s !== void 0 ? s : null, E.createdAt = (a = r.created_at) !== null && a !== void 0 ? a : 0, E.updatedAt = (o = r.updated_at) !== null && o !== void 0 ? o : 0, E.closeAt = (l = r.close_at) !== null && l !== void 0 ? l : -1, E.status = (c = id(r.status)) !== null && c !== void 0 ? c : _a.CLOSED, E.messageId = (u = r.message_id) !== null && u !== void 0 ? u : 0, E.data = (d = r.data) !== null && d !== void 0 ? d : null, E.voterCount = (h = r.voter_count) !== null && h !== void 0 ? h : -1, E.options = r.options ? r.options.map(function(y) {
      return new wl(E._iid, y);
    }) : [], E.createdBy = (p = r.created_by) !== null && p !== void 0 ? p : null, E.allowUserSuggestion = (f = r.allow_user_suggestion) !== null && f !== void 0 && f, E.allowMultipleVotes = (m = r.allow_multiple_votes) !== null && m !== void 0 && m, E.votedPollOptionIds = (v = r.voted_option_ids) !== null && v !== void 0 ? v : [], E;
  }
  return S(n, t), n.prototype._applyPollUpdatePayload = function(e) {
    var r, i, s, a, o, l, c, u, d = this;
    this.title = (r = e.title) !== null && r !== void 0 ? r : this.title, this.updatedAt = (i = e.updated_at) !== null && i !== void 0 ? i : this.updatedAt, this.closeAt = (s = e.close_at) !== null && s !== void 0 ? s : this.closeAt, this.status = (a = id(e.status)) !== null && a !== void 0 ? a : this.status, this.data = (o = e.data) !== null && o !== void 0 ? o : this.data, this.voterCount = (l = e.voter_count) !== null && l !== void 0 ? l : this.voterCount, e.options && (this.options = e.options.map(function(h) {
      return new wl(d._iid, h);
    }), this.votedPollOptionIds = e.options.filter(function(h) {
      return h.vote_count > 0;
    }).map(function(h) {
      return h.id;
    })), this.allowUserSuggestion = (c = e.allow_user_suggestion) !== null && c !== void 0 ? c : this.allowUserSuggestion, this.allowMultipleVotes = (u = e.allow_multiple_votes) !== null && u !== void 0 ? u : this.allowMultipleVotes;
  }, n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { id: e.id, title: e.title, created_at: e.createdAt, updated_at: e.updatedAt, close_at: e.closeAt, status: e.status, message_id: e.messageId, data: e.data, voter_count: e.voterCount, options: e.options.map(function(r) {
      return wl.payloadify(r);
    }), created_by: e.createdBy, allow_user_suggestion: e.allowUserSuggestion, allow_multiple_votes: e.allowMultipleVotes, voted_option_ids: e.votedPollOptionIds })));
  }, n.prototype.applyPollUpdateEvent = function(e) {
    var r = e._payload.poll;
    return !(!r || this.id !== r.id || r.updated_at < this.updatedAt || (this._applyPollUpdatePayload(r), 0));
  }, n.prototype.applyPollVoteEvent = function(e) {
    if (this.id !== e.pollId)
      return !1;
    var r = this.options, i = r.map(function(o) {
      return o.id;
    }), s = e._payload, a = Math.floor(s.ts / 1e3);
    return s.updated_vote_counts.forEach(function(o) {
      var l = i.indexOf(o.option_id);
      if (l > -1) {
        var c = r[l];
        a >= c._lastVotedAt && (c.voteCount = o.vote_count, c._lastVotedAt = a);
      }
    }), s.req_id && s.voted_option_ids && (this.votedPollOptionIds = s.voted_option_ids), typeof s.voter_count == "number" && (this.voterCount = s.voter_count), !0;
  }, n.prototype.serialize = function() {
    return Lo(this);
  }, n;
}(xn), cs = function() {
  function t(n, e) {
    var r;
    this.limit = 20, this._isLoading = !1, this._hasNext = !0, this._token = "", this._iid = n, this.limit = (r = e.limit) !== null && r !== void 0 ? r : 20;
  }
  return Object.defineProperty(t.prototype, "hasNext", { get: function() {
    return this._hasNext;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "isLoading", { get: function() {
    return this._isLoading;
  }, enumerable: !1, configurable: !0 }), t.prototype._validate = function() {
    return O("number", this.limit) && this.limit > 0;
  }, t;
}(), Hi = function(t) {
  function n(e, r, i, s) {
    var a = t.call(this, e, s) || this;
    return a.channelUrl = r, a.channelType = i, a;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this) && O("string", this.channelUrl) && Ze(yt, this.channelType);
  }, n;
}(cs), B1 = function(t) {
  this.pollId = 0, this.messageId = 0, this.pollId = t.poll_id, this.messageId = t.message_id, this._payload = t;
}, z1 = function(t) {
  function n(e) {
    var r = e.title, i = e.optionTexts, s = e.data, a = e.allowUserSuggestion, o = e.allowMultipleVotes, l = e.closeAt, c = t.call(this) || this;
    return c.method = Y.POST, c.path = Zr, c.params = { title: r, options: i, data: s, allow_user_suggestion: a, allow_multiple_votes: o, close_at: l }, c;
  }
  return S(n, t), n;
}($), V1 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.poll = new Pr(e, r), i;
  }
  return S(n, t), n;
}(ne), G1 = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.channelType, s = e.pollId, a = t.call(this) || this;
    return a.method = Y.GET, a.path = "".concat(Zr, "/").concat(encodeURIComponent(s)), a.params = { channel_url: r, channel_type: i }, a;
  }
  return S(n, t), n;
}($), q1 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.poll = new Pr(e, r), i;
  }
  return S(n, t), n;
}(ne), K1 = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.channelType, s = e.pollId, a = e.pollOptionId, o = t.call(this) || this;
    return o.method = Y.GET, o.path = "".concat(Zr, "/").concat(encodeURIComponent(s), "/options/").concat(encodeURIComponent(a)), o.params = { channel_url: r, channel_type: i }, o;
  }
  return S(n, t), n;
}($), W1 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.pollOption = new wl(e, r), i;
  }
  return S(n, t), n;
}(ne), Q1 = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.timestamp, a = e.token, o = t.call(this) || this;
    return o.method = Y.GET, o.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/polls/changelogs"), o.params = fe({ change_ts: s, token: a }), o;
  }
  return S(n, t), n;
}($), Y1 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.updatedPolls = r.updated.map(function(s) {
      return function(a, o) {
        return new Pr(a, o);
      }(e, s);
    }), i.deletedPollIds = r.deleted.map(function(s) {
      return s;
    }), i.hasMore = r.has_more, i.nextToken = r.next, i;
  }
  return S(n, t), n;
}(ne), $1 = { title: "", optionTexts: [], data: void 0, allowUserSuggestion: void 0, allowMultipleVotes: void 0, closeAt: -1 }, zm = function(t) {
  return O("string", t.title) && (n = t.optionTexts, tt("string", n) && n.every(function(e) {
    return e.trim() !== "";
  })) && Bm(t.data) && O("boolean", t.allowUserSuggestion, !0) && O("boolean", t.allowMultipleVotes, !0) && O("number", t.closeAt, !0);
  var n;
}, Z1 = { channelUrl: "", channelType: yt.BASE, pollId: 0, pollOptionId: 0 }, Vm = function(t) {
  return O("string", t.channelUrl) && t.channelUrl !== "" && Ze(yt, t.channelType) && O("number", t.pollId) && t.pollId > 0 && O("number", t.pollOptionId) && t.pollOptionId > 0;
}, X1 = { channelUrl: "", channelType: yt.BASE, pollId: 0 }, Gm = function(t) {
  return O("string", t.channelUrl) && t.channelUrl !== "" && Ze(yt, t.channelType) && O("number", t.pollId);
}, wp = {}, $l = function() {
  function t(n, e) {
    var r = e.sdkState, i = e.dispatcher, s = e.sessionManager, a = e.requestQueue, o = e.logger;
    this._iid = n, this._sdkState = r, this._sessionManager = s, this._requestQueue = a, this._dispatcher = i, this._logger = o, wp[n] = this;
  }
  return t.of = function(n) {
    return wp[n];
  }, t.prototype.buildPollFromSerializedData = function(n) {
    var e = js(n);
    return new Pr(this._iid, Pr.payloadify(e));
  }, t.prototype.get = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return Z(Gm(n)).throw(D.invalidParameters), e = new G1(A({}, n)), [4, this._requestQueue.send(e)];
          case 1:
            return [2, r.sent().as(q1).poll];
        }
      });
    });
  }, t.prototype.create = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return Z(zm(n)).throw(D.invalidParameters), e = new z1(A({}, n)), [4, this._requestQueue.send(e)];
          case 1:
            return [2, r.sent().as(V1).poll];
        }
      });
    });
  }, t.prototype.getOption = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return Z(Vm(n)).throw(D.invalidParameters), e = new K1(A({}, n)), [4, this._requestQueue.send(e)];
          case 1:
            return [2, r.sent().as(W1).pollOption];
        }
      });
    });
  }, t.prototype.getPollChangeLogs = function(n, e, r, i) {
    return i === void 0 && (i = B.SYNC_POLL_CHANGELOGS), g(this, 0, void 0, function() {
      var s, a, o, l, c, u, d;
      return _(this, function(h) {
        switch (h.label) {
          case 0:
            return s = new Q1(Ae({ channelType: e, channelUrl: n, timestamp: typeof r == "number" ? r : null, token: typeof r == "string" ? r : null })), [4, this._requestQueue.send(s)];
          case 1:
            return a = h.sent(), o = a.as(Y1), l = o.updatedPolls, c = o.deletedPollIds, u = o.hasMore, d = o.nextToken, l.length > 0 && this._dispatcher.dispatch(new jm({ polls: l, source: i })), [2, { updatedPolls: l, deletedPollIds: c, hasMore: u, token: d }];
        }
      });
    });
  }, t;
}(), J1 = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.channelType, s = e.token, a = e.limit, o = t.call(this) || this;
    return o.method = Y.GET, o.path = Zr, o.params = { channel_url: r, channel_type: i, token: s, limit: a }, o;
  }
  return S(n, t), n;
}($), eb = function(t) {
  function n(e, r) {
    var i, s = this;
    return (s = t.call(this, e, r) || this).polls = ((i = r.polls) !== null && i !== void 0 ? i : []).map(function(a) {
      return new Pr(e, a);
    }), s.token = r.next, s;
  }
  return S(n, t), n;
}(ne), qm = function(t) {
  function n(e, r) {
    return t.call(this, e, r.channelUrl, r.channelType, r) || this;
  }
  return S(n, t), n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = k.of(this._iid).requestQueue, r = new J1(A(A({}, this), { token: this._token })), [4, e.send(r)]) : [3, 2] : [3, 5];
          case 1:
            return i = l.sent(), s = i.as(eb), a = s.polls, o = s.token, this._token = o, this._hasNext = !!o, this._isLoading = !1, [2, a];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(Hi), tb = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.channelType, s = e.pollId, a = e.pollOptionId, o = e.token, l = e.limit, c = t.call(this) || this;
    return c.method = Y.GET, c.path = "".concat(Zr, "/").concat(encodeURIComponent(s), "/options/").concat(encodeURIComponent(a), "/voters"), c.params = { channel_url: r, channel_type: i, token: o, limit: l }, c;
  }
  return S(n, t), n;
}($), nb = function(t) {
  function n(e, r) {
    var i, s = this;
    return (s = t.call(this, e, r) || this).voters = ((i = r.voters) !== null && i !== void 0 ? i : []).map(function(a) {
      return new pt(e, a);
    }), s.token = r.next, s;
  }
  return S(n, t), n;
}(ne), Km = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r.channelUrl, r.channelType, r) || this;
    return i.pollId = r.pollId, i.pollOptionId = r.pollOptionId, i;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this) && O("number", this.pollId) && O("number", this.pollOptionId);
  }, n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = k.of(this._iid).requestQueue, r = new tb(A(A({}, this), { pollId: this.pollId, pollOptionId: this.pollOptionId, token: this._token })), [4, e.send(r)]) : [3, 2] : [3, 5];
          case 1:
            return i = l.sent(), s = i.as(nb), a = s.voters, o = s.token, this._token = o, this._hasNext = !!o, this._isLoading = !1, [2, a];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(Hi), Bi = function() {
  function t(n, e, r) {
    var i, s;
    this.width = 0, this.height = 0, this.realWidth = 0, this.realHeight = 0, this._requireAuth = !1, this._iid = n, this.plainUrl = e.url, this.width = e.width, this.height = e.height, this.realWidth = (i = e.real_width) !== null && i !== void 0 ? i : e.width, this.realHeight = (s = e.real_height) !== null && s !== void 0 ? s : e.height, this._requireAuth = r;
  }
  return t.payloadify = function(n) {
    return fe(Ae(n instanceof t ? { url: n.plainUrl, width: n.width, height: n.height, real_width: n.realWidth, real_height: n.realHeight } : { url: "", width: n.maxWidth, height: n.maxHeight, real_width: 0, real_height: 0 }));
  }, Object.defineProperty(t.prototype, "url", { get: function() {
    var n = k.of(this._iid).sessionManager;
    return this._requireAuth && n.ekey ? "".concat(this.plainUrl, "?auth=").concat(n.ekey) : this.plainUrl;
  }, enumerable: !1, configurable: !0 }), t;
}(), Zl = function(t) {
  function n(e) {
    var r = t.call(this) || this;
    if (r.method = Y.POST, r.path = "".concat(ty), r.params = fe({ file: e.file, channel_url: e.channelUrl }), e.thumbnailSizes)
      for (var i = 0; i < e.thumbnailSizes.length; i++) {
        var s = e.thumbnailSizes[i], a = s.maxWidth, o = s.maxHeight;
        r.params["thumbnail".concat(i + 1)] = "".concat(a, ",").concat(o);
      }
    return r.requestId = e.requestId, r;
  }
  return S(n, t), n;
}($), Xl = function(t) {
  function n(e, r) {
    var i, s, a, o, l = this;
    return (l = t.call(this, e, r) || this).url = r.url, l.fileSize = (i = r.file_size) !== null && i !== void 0 ? i : 0, l.thumbnails = (a = (s = r.thumbnails) === null || s === void 0 ? void 0 : s.map(function(c) {
      return new Bi(e, c, !1);
    })) !== null && a !== void 0 ? a : [], l.requireAuth = (o = r.require_auth) !== null && o !== void 0 && o, l;
  }
  return S(n, t), n;
}(ne), Jl = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c = this;
    return (c = t.call(this, e) || this).replyCount = 0, c.memberCount = 0, c.lastRepliedAt = 0, c.updatedAt = 0, c.replyCount = (i = r.reply_count) !== null && i !== void 0 ? i : 0, c.memberCount = (s = r.member_count) !== null && s !== void 0 ? s : 0, c.mostRepliedUsers = r.most_replies && tt("object", r.most_replies) ? r.most_replies.map(function(u) {
      return new pt(c._iid, u);
    }) : [], c.unreadReplyCount = (a = r.unread_message_count) !== null && a !== void 0 ? a : 0, c.isPushNotificationEnabled = typeof r.push_enabled == "number" ? r.push_enabled > 0 : void 0, c.lastRepliedAt = (o = r.last_replied_at) !== null && o !== void 0 ? o : 0, c.updatedAt = (l = r.updated_at) !== null && l !== void 0 ? l : 0, c;
  }
  return S(n, t), n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { reply_count: e.replyCount, unread_message_count: e.unreadReplyCount, member_count: e.memberCount, most_replies: Array.isArray(e.mostRepliedUsers) ? e.mostRepliedUsers.map(function(r) {
      return pt.payloadify(r);
    }) : [], push_enabled: typeof e.isPushNotificationEnabled == "boolean" ? e.isPushNotificationEnabled ? 1 : 0 : void 0, last_replied_at: e.lastRepliedAt, updated_at: e.updatedAt })));
  }, Object.defineProperty(n.prototype, "_isUpdateRequired", { get: function() {
    return this.unreadReplyCount === void 0 || this.isPushNotificationEnabled === void 0;
  }, enumerable: !1, configurable: !0 }), n.prototype._updateFrom = function(e) {
    var r, i;
    this.unreadReplyCount = (r = e.unreadReplyCount) !== null && r !== void 0 ? r : this.unreadReplyCount, this.isPushNotificationEnabled = (i = e.isPushNotificationEnabled) !== null && i !== void 0 ? i : this.isPushNotificationEnabled;
  }, n;
}(xn);
(function(t) {
  t.ADD = "add", t.DELETE = "delete";
})(Io || (Io = {}));
var $i, $d = function(t) {
  this.messageId = 0, this.operation = null, this.updatedAt = 0;
  var n = O("string", t.msg_id) ? parseInt(t.msg_id) : t.msg_id, e = t.user_id, r = t.operation ? t.operation.toLowerCase() : null, i = t.reaction, s = t.updated_at;
  n && O("string", e) && O("string", r) && Ze(Io, r) && O("string", i) && i && O("number", s) && (this.messageId = n, this.userId = e, this.key = i, this.operation = r, this.updatedAt = s);
}, nl = function() {
  function t(n) {
    var e, r, i, s = n.key, a = (i = Re([], we(n.user_ids), !1)) !== null && i !== void 0 ? i : [], o = n.updated_at;
    O("string", s) && s && tt("string", a) && a.length > 0 && O("number", o) && (this.key = s, this.userIds = a, this.updatedAt = o);
    var l = {};
    try {
      for (var c = de(this.userIds), u = c.next(); !u.done; u = c.next())
        l[u.value] = this.updatedAt;
    } catch (d) {
      e = { error: d };
    } finally {
      try {
        u && !u.done && (r = c.return) && r.call(c);
      } finally {
        if (e)
          throw e.error;
      }
    }
    this._version = l;
  }
  return Object.defineProperty(t.prototype, "isEmpty", { get: function() {
    return this.userIds.length === 0;
  }, enumerable: !1, configurable: !0 }), t.payloadify = function(n) {
    return fe(Ae({ key: n.key, user_ids: n.userIds, updated_at: n.updatedAt }));
  }, t.prototype.applyEvent = function(n) {
    if (n.key === this.key && this.updatedAt <= n.updatedAt) {
      if (!this._version[n.userId] || this._version[n.userId] <= n.updatedAt) {
        var e = this.userIds.indexOf(n.userId);
        switch (n.operation) {
          case Io.ADD:
            e < 0 && this.userIds.push(n.userId);
            break;
          case Io.DELETE:
            e >= 0 && this.userIds.splice(e, 1);
        }
        this._version[n.userId] = n.updatedAt;
      }
      this.updatedAt = Math.max(this.updatedAt, n.updatedAt);
    }
  }, t;
}(), Sp = function() {
  function t(n) {
    this.secureUrl = null, this.type = null, this.width = 0, this.height = 0, this.alt = null, this.url = n.url, n.secure_url && (this.secureUrl = n.secure_url), n.type && (this.type = n.type), n.width && (this.width = n.width), n.height && (this.height = n.height), n.alt && (this.alt = n.alt);
  }
  return t.payloadify = function(n) {
    var e, r;
    return fe(Ae({ url: n.url, secure_url: n.secureUrl, type: n.type, width: (e = n.width) !== null && e !== void 0 ? e : 0, height: (r = n.height) !== null && r !== void 0 ? r : 0, alt: n.alt }));
  }, t;
}(), Np = function() {
  function t(n) {
    this.title = null, this.url = null, this.description = null, this.defaultImage = null, n["og:title"] && (this.title = n["og:title"]), n["og:url"] && (this.url = n["og:url"]), n["og:description"] && (this.description = n["og:description"]), n["og:image"] && (this.defaultImage = new Sp(n["og:image"]));
  }
  return t.payloadify = function(n) {
    return fe(Ae({ "og:title": n.title, "og:url": n.url, "og:description": n.description, "og:image": n.defaultImage ? Sp.payloadify(n.defaultImage) : null }));
  }, t;
}(), Fr = function() {
  function t(n) {
    var e, r;
    this.volume = 0, this.name = (e = n.name) !== null && e !== void 0 ? e : "default", this.volume = (r = n.volume) !== null && r !== void 0 ? r : 1;
  }
  return t.prototype.serialize = function() {
    return { name: this.name, volume: this.volume };
  }, t.payloadify = function(n) {
    return fe(Ae({ name: n.name, volume: n.volume }));
  }, t;
}();
(function(t) {
  t.GOOD = "good", t.BAD = "bad";
})($i || ($i = {}));
var ki = function() {
  function t(n) {
    this.id = n.id, this.rating = n.rating, this.comment = n.comment;
  }
  return t._getStatus = function(n) {
    return n ? "id" in n ? "SUBMITTED" : "NO_FEEDBACK" : "NOT_APPLICABLE";
  }, t._isSubmitted = function(n) {
    return t._getStatus(n) === "SUBMITTED";
  }, t._getPayloadByStatus = function(n) {
    return n === "NO_FEEDBACK" ? {} : null;
  }, t.payloadify = function(n) {
    return fe(Ae({ id: n.id, rating: n.rating, comment: n.comment }));
  }, t;
}(), ga = function(t) {
  function n(e, r) {
    var i, s = this;
    return (s = t.call(this, e, r) || this).isBlockedByMe = !1, s.role = Ze(Lr, r.role) ? r.role : Lr.NONE, s.isBlockedByMe = (i = r.is_blocked_by_me) !== null && i !== void 0 && i, s;
  }
  return S(n, t), n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { role: e.role, is_blocked_by_me: e.isBlockedByMe })));
  }, n;
}(pt), Yn = function() {
  function t(n) {
    this.key = n.key, this.value = tt("string", n.value) ? Re([], we(n.value), !1) : [];
  }
  return t.payloadify = function(n) {
    var e;
    return fe(Ae({ key: n.key, value: (e = n.value) !== null && e !== void 0 ? e : [] }));
  }, t;
}(), Wm = function(t) {
  switch (t) {
    case Yt.BASE:
      return "";
    case Yt.USER:
      return "MESG";
    case Yt.FILE:
      return "FILE";
    case Yt.ADMIN:
      return "ADMM";
  }
}, Qm = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d, h, p = this;
    (p = t.call(this, e) || this).channelType = yt.BASE, p.messageType = Yt.BASE, p.mentionType = null, p.mentionedUsers = null, p.mentionedUserIds = null, p.mentionedMessageTemplate = void 0, p.metaArrays = [], p.extendedMessage = {}, p.createdAt = 0, p.updatedAt = 0, p.channelUrl = r.channel_url, p.channelType = Ze(yt, r.channel_type) ? r.channel_type : yt.GROUP, r.channel && (r.channel.channel_url && (p.channelUrl = r.channel.channel_url), r.channel.channel_type && (p.channelType = r.channel.channel_type)), p.data = (i = r.data) !== null && i !== void 0 ? i : "", p.customType = (s = r.custom_type) !== null && s !== void 0 ? s : "", p.mentionType = Ze(jn, r.mention_type) ? r.mention_type : null, p.mentionedUsers = r.mentioned_users ? r.mentioned_users.map(function(y) {
      return new pt(p._iid, y);
    }) : null, p.mentionedUserIds = (a = r.mentioned_user_ids) !== null && a !== void 0 ? a : null, p.mentionedUsers && !p.mentionedUserIds && (p.mentionedUserIds = p.mentionedUsers.map(function(y) {
      return y.userId;
    })), p.mentionedMessageTemplate = r.mentioned_message_template;
    var f = (o = r.metaarray) !== null && o !== void 0 ? o : {}, m = (l = r.metaarray_key_order) !== null && l !== void 0 ? l : Object.keys(f).sort(function(y, b) {
      return y.localeCompare(b);
    });
    p.metaArrays = [];
    for (var v = 0; v < m.length; v++) {
      var E = m[v];
      p.metaArrays.push(new Yn({ key: E, value: f[E] || [] }));
    }
    return r.sorted_metaarray && (p.metaArrays = r.sorted_metaarray.map(function(y) {
      return new Yn(y);
    })), p.extendedMessage = (c = r.extended_message) !== null && c !== void 0 ? c : {}, p.extendedMessagePayload = r.extended_message_payload, p.createdAt = (d = (u = r.created_at) !== null && u !== void 0 ? u : r.ts) !== null && d !== void 0 ? d : 0, p.updatedAt = (h = r.updated_at) !== null && h !== void 0 ? h : 0, p;
  }
  return S(n, t), n.payloadify = function(e) {
    var r, i;
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { channel_url: e.channelUrl, channel_type: e.channelType, type: Wm(e.messageType), data: e.data, custom_type: e.customType, mention_type: e.mentionType, mentioned_user_ids: e.mentionedUserIds, mentioned_users: (r = e.mentionedUsers) === null || r === void 0 ? void 0 : r.map(function(s) {
      return pt.payloadify(s);
    }), mentioned_message_template: e.mentionedMessageTemplate, sorted_metaarray: (i = e.metaArrays) === null || i === void 0 ? void 0 : i.map(function(s) {
      return Yn.payloadify(s);
    }), extended_message: e.extendedMessage, extended_message_payload: e.extendedMessagePayload, created_at: e.createdAt, updated_at: e.updatedAt })));
  }, n.prototype.isIdentical = function(e) {
    return !0;
  }, n.prototype.isEqual = function(e) {
    return Z0(this, e);
  }, n.prototype.isUserMessage = function() {
    return this.messageType === Yt.USER;
  }, n.prototype.isFileMessage = function() {
    return this.messageType === Yt.FILE && !Object.prototype.hasOwnProperty.call(this, "fileInfoList");
  }, n.prototype.isMultipleFilesMessage = function() {
    return this.messageType === Yt.FILE && Object.prototype.hasOwnProperty.call(this, "fileInfoList");
  }, n.prototype.isAdminMessage = function() {
    return this.messageType === Yt.ADMIN;
  }, n.prototype.serialize = function() {
    return Lo(this);
  }, n.prototype.getMetaArraysByKeys = function(e) {
    return this.metaArrays.filter(function(r) {
      return e.includes(r.key);
    });
  }, n;
}(xn), Ym = function(t) {
  function n(e, r) {
    var i, s, a = this;
    return (a = t.call(this, e) || this).channelUrl = (i = r.channel_url) !== null && i !== void 0 ? i : "", a.channelType = (s = r.channel_type) !== null && s !== void 0 ? s : yt.GROUP, a.reader = new pt(a._iid, r.user), a.readAt = r.ts, a;
  }
  return S(n, t), n;
}(xn), rb = function(t) {
  function n(e) {
    var r = e.channelUrl;
    return t.call(this, { code: "READ", ackRequired: !0, payload: { channel_url: r } }) || this;
  }
  return S(n, t), n;
}(Zn);
(function(t) {
  function n(e) {
    var r = t.call(this) || this, i = e.channelUrl, s = e.channelType, a = e.userId, o = e.notificationIds;
    return r.method = Y.PUT, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/messages/mark_as_read"), r.params = fe(Ae({ user_id: a, message_ids: o })), r;
  }
  S(n, t);
})($);
var $m = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "READ", i) || this;
    return s.readStatus = new Ym(e, i), s;
  }
  return S(n, t), n;
}(Lt);
(function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.readAt = r.ts, i.unreadMessageCount = r.unread_message_count, i;
  }
  S(n, t);
})(ne);
var ib = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.messageId;
    return t.call(this, { code: "READ", ackRequired: !0, payload: { channel_url: r, parent_message_id: i } }) || this;
  }
  return S(n, t), n;
}(Zn), sb = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.messageId, a = e.pushEnabled, o = t.call(this) || this;
    return o.method = Y.PUT, o.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages/").concat(s, "/thread_push"), o.params = { push_enabled: a }, o;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    return t.call(this, n, e) || this;
  }, t);
})(ne);
var ab = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.messageId, a = e.rating, o = e.comment, l = t.call(this) || this;
    return l.method = Y.POST, l.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages/").concat(s, "/feedbacks"), l.params = { rating: a, comment: o }, l;
  }
  return S(n, t), n;
}($), ob = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.feedback = new ki(r), i;
  }
  return S(n, t), n;
}(ne), lb = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.messageId, a = e.feedbackId, o = e.rating, l = e.comment, c = t.call(this) || this;
    return c.method = Y.PUT, c.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages/").concat(s, "/feedbacks/").concat(a), c.params = { rating: o, comment: l }, c;
  }
  return S(n, t), n;
}($), cb = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.feedback = new ki(r), i;
  }
  return S(n, t), n;
}(ne), ub = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.messageId, a = e.feedbackId, o = t.call(this) || this;
    return o.method = Y.DELETE, o.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages/").concat(s, "/feedbacks/").concat(a), o;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    var r = t.call(this, n, e) || this;
    return r.feedback = new ki(e), r;
  }, t);
})(ne);
var Is, Ip, sd = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c = this;
    return (c = t.call(this, e) || this).plainUrl = "", c.fileName = null, c.mimeType = null, c.fileSize = 0, c.thumbnails = [], c._requireAuth = !1, c.plainUrl = (i = r.url) !== null && i !== void 0 ? i : "", c.fileName = (s = r.file_name) !== null && s !== void 0 ? s : null, c.mimeType = (a = r.file_type) !== null && a !== void 0 ? a : null, c.fileSize = (o = r.file_size) !== null && o !== void 0 ? o : 0, c._requireAuth = (l = r.require_auth) !== null && l !== void 0 && l, c.thumbnails = r.thumbnails ? r.thumbnails.map(function(u) {
      var d;
      return new Bi(c._iid, typeof u == "string" ? { url: u, width: 0, height: 0 } : A(A({}, u), { url: ((d = u.url) !== null && d !== void 0 ? d : "").split("auth=")[0] }), c._requireAuth);
    }) : [], c;
  }
  return S(n, t), n.payloadify = function(e) {
    var r;
    return fe(Ae({ url: e.plainUrl, file_name: e.fileName, file_type: e.mimeType, file_size: e.fileSize, thumbnails: (r = e.thumbnails) === null || r === void 0 ? void 0 : r.map(function(i) {
      var s;
      return { url: ((s = i.plainUrl) !== null && s !== void 0 ? s : "").split("auth=")[0], width: i.width, height: i.height, real_width: i.realWidth, real_height: i.realHeight };
    }), require_auth: e._requireAuth }));
  }, Object.defineProperty(n.prototype, "url", { get: function() {
    var e = k.of(this._iid).sessionManager;
    return this._requireAuth && e.ekey ? "".concat(this.plainUrl, "?auth=").concat(e.ekey) : this.plainUrl;
  }, enumerable: !1, configurable: !0 }), n;
}(xn), Zm = function(t) {
  var n = t.channelUrl, e = t.channelType, r = t.parentMessage;
  this.channelUrl = n, this.channelType = e, this.parentMessage = r;
};
(function(t) {
  t.NUMBER = "number", t.ENUM = "enum", t.TEXT = "text", t.REGEX = "regex", t.DECIMAL_PLACE = "decimal_place";
})(Is || (Is = {})), function(t) {
  t.TEXT = "text", t.TEXTAREA = "textarea", t.NUMBER = "number", t.PHONE = "phone", t.EMAIL = "email", t.CHIP = "chip";
}(Ip || (Ip = {}));
var es, Tr, Ap = function() {
  function t(n, e) {
    var r = e.id, i = e.name, s = e.items, a = e.version, o = e.is_submitted;
    this.messageId = n, this.id = r, this.name = i, this.items = s.map(function(l) {
      return new Mp(l);
    }).sort(function(l, c) {
      return l.sortOrder - c.sortOrder;
    }), this.version = a ?? 1, this._isSubmitted = o;
  }
  return Object.defineProperty(t.prototype, "isSubmitted", { get: function() {
    var n;
    return (n = this._isSubmitted) !== null && n !== void 0 ? n : this.items.some(function(e) {
      return Array.isArray(e.submittedValues);
    });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "isSubmittable", { get: function() {
    return this.items.every(function(n) {
      return n.required ? !!(Array.isArray(n.draftValues) && n.draftValues.length > 0) && n.isValid(n.draftValues) : !(Array.isArray(n.draftValues) && n.draftValues.length > 0) || n.isValid(n.draftValues);
    });
  }, enumerable: !1, configurable: !0 }), t.payloadify = function(n) {
    return fe(Ae({ id: n.id, name: n.name, items: n.items.map(function(e) {
      return Mp.payloadify(e);
    }), version: n.version, is_submitted: n._isSubmitted }));
  }, t.isMessageFormPayload = function(n) {
    return !!(n != null && n.message_form);
  }, t;
}(), Mp = function() {
  function t(n) {
    var e = n.id, r = n.name, i = n.required, s = n.sort_order, a = n.placeholder, o = n.style, l = n.item_type, c = n.validators, u = n.value, d = n.values;
    this.id = e, this.name = r, this.required = i, this.sortOrder = s, this.placeholder = a, Object.keys(o).length === 0 ? this.style = { layout: l } : this.style = fe({ layout: o.layout, options: o.options, defaultOptions: o.default_options, resultCount: o.result_count }), d ? this.submittedValues = d : u && (this.submittedValues = [u]), this._validators = c;
  }
  return t.prototype.isValid = function(n) {
    var e = this;
    return n.every(function(r) {
      var i = function(s, a) {
        return a.every(function(o) {
          switch (o.key) {
            case Is.NUMBER:
              var l = Number(s);
              return !(isNaN(l) || o.min && typeof o.min != "number" || o.max && typeof o.max != "number" || typeof o.min == "number" && l < o.min || typeof o.max == "number" && l > o.max);
            case Is.ENUM:
              return typeof s == "string" && (!(o.enums && Array.isArray(o.enums) && o.enums.length > 0 && !o.enums.includes(s)) || o.allow_other);
            case Is.TEXT:
              return !(typeof s != "string" || typeof o.min_length == "number" && s.length < o.min_length || typeof o.max_length == "number" && s.length > o.max_length);
            case Is.REGEX:
              return !(typeof s != "string" || o.regex && (typeof o.regex != "string" || !new RegExp(o.regex).test(s)));
            case Is.DECIMAL_PLACE:
              return s.length !== 0 && (l = Number(s), !(isNaN(l) || (!o.max_decimal_place || typeof o.max_decimal_place == "number") && o.max_decimal_place && !function(c, u) {
                var d = c.toString(), h = d.indexOf(".");
                return h === -1 || d.slice(h + 1).length <= u;
              }(l, o.max_decimal_place)));
            default:
              return !0;
          }
        });
      }(r, e._validators);
      return i;
    });
  }, t.payloadify = function(n) {
    return fe(Ae({ id: n.id, name: n.name, required: n.required, sort_order: n.sortOrder, placeholder: n.placeholder, style: fe({ layout: n.style.layout, options: n.style.options, default_options: n.style.defaultOptions, result_count: n.style.resultCount }), item_type: n.style.layout, validators: n._validators, values: n.submittedValues }));
  }, t;
}(), db = function(t) {
  function n(e) {
    var r = t.call(this) || this;
    return r.method = Y.POST, r.path = "".concat(uy, "/").concat(e.formId, "/submit"), r.params = fe({ message_id: e.messageId, items: e.items }), r;
  }
  return S(n, t), n;
}($);
(function(t) {
  t.PENDING = "pending", t.SENT = "sent", t.FAILED = "failed", t.CANCELED = "canceled";
})(es || (es = {})), function(t) {
  t.PENDING = "pending", t.IN_QUEUE = "in_queue", t.SENT = "sent", t.FAILED = "failed", t.CANCELED = "canceled", t.REMOVED = "removed";
}(Tr || (Tr = {}));
var Ls, Vn = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d, h, p = this;
    return (p = t.call(this, e, r) || this).parentMessage = null, p.silent = !1, p.isOperatorMessage = !1, p.threadInfo = null, p.reactions = [], p.appleCriticalAlertOptions = null, p.scheduledInfo = null, p.suggestedReplies = null, p.myFeedback = null, p.myFeedbackStatus = "NOT_APPLICABLE", p.messageForm = null, p._isContinuousMessages = !1, p._scheduledStatus = null, p.messageId = (s = (i = r.msg_id) !== null && i !== void 0 ? i : r.message_id) !== null && s !== void 0 ? s : 0, p.parentMessageId = (a = typeof r.parent_message_id == "string" ? parseInt(r.parent_message_id) : r.parent_message_id) !== null && a !== void 0 ? a : 0, p.threadInfo = r.thread_info ? new Jl(p._iid, r.thread_info) : null, p.reactions = r.reactions ? r.reactions.map(function(f) {
      return new nl(f);
    }) : [], p.ogMetaData = r.og_tag ? new Np(r.og_tag) : null, p.silent = (o = r.silent) !== null && o !== void 0 && o, p.isOperatorMessage = (l = r.is_op_msg) !== null && l !== void 0 && l, p.appleCriticalAlertOptions = r.apple_critical_alert_options ? new Fr(r.apple_critical_alert_options) : null, typeof r.scheduled_message_id == "number" && typeof r.scheduled_at == "number" && r.scheduled_status && (p.scheduledInfo = { scheduledMessageId: r.scheduled_message_id, scheduledAt: r.scheduled_at }, p._scheduledStatus = r.scheduled_status), p._isContinuousMessages = (c = r.is_continuous_messages) !== null && c !== void 0 && c, p.myFeedback = ki._isSubmitted(r.feedback) ? new ki(r.feedback) : null, p.myFeedbackStatus = ki._getStatus(r.feedback), p.suggestedReplies = (d = (u = r.extended_message_payload) === null || u === void 0 ? void 0 : u.suggested_replies) !== null && d !== void 0 ? d : null, p.messageForm = Ap.isMessageFormPayload(r.extended_message_payload) ? new Ap(p.messageId, r.extended_message_payload.message_form) : null, p.message = (h = r.message) !== null && h !== void 0 ? h : "", p;
  }
  return S(n, t), n.payloadify = function(e) {
    var r, i;
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { message_id: e.messageId, parent_message_id: e.parentMessageId, thread_info: e.threadInfo ? Jl.payloadify(e.threadInfo) : null, reactions: e.reactions.map(function(s) {
      return nl.payloadify(s);
    }), og_tag: e.ogMetaData ? Np.payloadify(e.ogMetaData) : null, silent: e.silent, is_op_msg: e.isOperatorMessage, apple_critical_alert_options: e.appleCriticalAlertOptions ? Fr.payloadify(e.appleCriticalAlertOptions) : null, scheduled_message_id: (r = e.scheduledInfo) === null || r === void 0 ? void 0 : r.scheduledMessageId, scheduled_at: (i = e.scheduledInfo) === null || i === void 0 ? void 0 : i.scheduledAt, scheduled_status: e._scheduledStatus, feedback: e.myFeedback ? ki.payloadify(e.myFeedback) : ki._getPayloadByStatus(e.myFeedbackStatus), message: e.message })));
  }, n._getParentMessageInfoPayload = function(e) {
    return fe(Ae({ type: Wm(e.messageType), ts: e.createdAt, user: e.sender ? ga.payloadify(e.sender) : null, message: e.message, file: { url: e.plainUrl, name: e.name, type: e.type, require_auth: e.requireAuth }, files: Array.isArray(e.fileInfoList) ? e.fileInfoList.map(function(r) {
      return sd.payloadify(r);
    }) : null }));
  }, n.prototype.isIdentical = function(e) {
    return this.messageId === e.messageId;
  }, n.prototype.applyThreadInfoUpdateEvent = function(e) {
    return this.messageId === e.targetMessageId && (e.threadInfo._isUpdateRequired && this.threadInfo && e.threadInfo._updateFrom(this.threadInfo), this.threadInfo = e.threadInfo, !0);
  }, n.prototype.applyReactionEvent = function(e) {
    if (this.messageId === e.messageId) {
      for (var r = !1, i = 0; i < this.reactions.length; i++)
        if (this.reactions[i].key === e.key) {
          this.reactions[i].applyEvent(e), this.reactions[i].isEmpty && this.reactions.splice(i, 1), r = !0;
          break;
        }
      r || e.operation !== "add" || this.reactions.push(new nl(nl.payloadify({ key: e.key, userIds: [e.userId], updatedAt: e.updatedAt })));
    }
  }, n.prototype.applyParentMessage = function(e) {
    if (!this.parentMessage)
      return this.parentMessage = e, !0;
    if (this.parentMessageId === e.messageId) {
      var r = this.parentMessage.updatedAt;
      if (e.updatedAt >= r)
        return this.parentMessage = e, !0;
    }
    return !1;
  }, n.prototype._triggerThreadInfoUpdatedEvent = function() {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        return (e = k.of(this._iid).dispatcher).dispatch(new Zm({ channelType: yt.GROUP, channelUrl: this.channelUrl, parentMessage: this })), e.dispatch(new Pt({ messages: [this], source: B.EVENT_MESSAGE_THREADINFO_UPDATED })), [2];
      });
    });
  }, n.prototype.markThreadAsRead = function() {
    return g(this, 0, void 0, function() {
      var e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return e = k.of(this._iid).requestQueue, r = new ib({ channelUrl: this.channelUrl, messageId: this.messageId }), [4, e.send(r)];
          case 1:
            return i.sent(), this.threadInfo && this.threadInfo.unreadReplyCount !== 0 ? (this.threadInfo.unreadReplyCount = 0, [4, this._triggerThreadInfoUpdatedEvent()]) : [3, 3];
          case 2:
            i.sent(), i.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, n.prototype.setPushNotificationEnabled = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return r = k.of(this._iid).requestQueue, i = new sb({ channelUrl: this.channelUrl, channelType: this.channelType, messageId: this.messageId, pushEnabled: e }), [4, r.send(i)];
          case 1:
            return s.sent(), this.threadInfo && this.threadInfo.isPushNotificationEnabled !== e && (this.threadInfo.isPushNotificationEnabled = e), [2];
        }
      });
    });
  }, n.prototype.submitMessageForm = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            if (r = k.of(this._iid).requestQueue, i = null, s = null, a = this.messageForm, !e && a) {
              if (!a.isSubmittable)
                throw new D({ code: me.INVALID_PARAMETER, message: "The form is not submittable. Please check all form items are valid before submitting." });
              if (a.isSubmitted)
                throw new D({ code: me.INVALID_PARAMETER, message: "The form has already been submitted." });
              i = a.id, s = a.items.reduce(function(c, u) {
                return c.push({ form_item_id: u.id, values: Array.isArray(u.draftValues) ? u.draftValues : [] }), c;
              }, []);
            } else
              e && (i = e.formId, s = Object.entries(e.answers).reduce(function(c, u) {
                var d = we(u, 2), h = d[0], p = d[1], f = Number(h);
                if (Number.isNaN(f))
                  throw new D({ code: me.INVALID_PARAMETER, message: "Keys in answers must be numeric string." });
                return c.push({ form_item_id: f, value: p }), c;
              }, []));
            if (!i || !s)
              throw new D({ code: me.INVALID_PARAMETER, message: "Missing one or more required inputs: formId, answers." });
            return o = new db({ messageId: this.messageId, formId: i, items: s }), [4, r.send(o)];
          case 1:
            return l.sent(), [2];
        }
      });
    });
  }, n.prototype.submitFeedback = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return r = k.of(this._iid), i = r.requestQueue, s = r.dispatcher, a = new ab({ channelUrl: this.channelUrl, channelType: this.channelType, messageId: this.messageId, rating: e.rating, comment: e.comment }), [4, i.send(a)];
          case 1:
            return o = c.sent(), l = o.as(ob), this.myFeedback = l.feedback, this.myFeedbackStatus = "SUBMITTED", s.dispatch(new Pt({ messages: [this], source: B.EVENT_MESSAGE_FEEDBACK_ADDED })), [2];
        }
      });
    });
  }, n.prototype.updateFeedback = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return r = k.of(this._iid), i = r.requestQueue, s = r.dispatcher, a = new lb({ channelUrl: this.channelUrl, channelType: this.channelType, messageId: this.messageId, feedbackId: e.id, rating: e.rating, comment: e.comment }), [4, i.send(a)];
          case 1:
            return o = c.sent(), l = o.as(cb), this.myFeedback = l.feedback, this.myFeedbackStatus = "SUBMITTED", s.dispatch(new Pt({ messages: [this], source: B.EVENT_MESSAGE_FEEDBACK_UPDATED })), [2];
        }
      });
    });
  }, n.prototype.deleteFeedback = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return r = k.of(this._iid), i = r.requestQueue, s = r.dispatcher, a = new ub({ channelUrl: this.channelUrl, channelType: this.channelType, messageId: this.messageId, feedbackId: e }), [4, i.send(a)];
          case 1:
            return o.sent(), this.myFeedback = null, this.myFeedbackStatus = "NO_FEEDBACK", s.dispatch(new Pt({ messages: [this], source: B.EVENT_MESSAGE_FEEDBACK_DELETED })), [2];
        }
      });
    });
  }, n;
}(Qm), en = function(t) {
  function n(e, r) {
    var i, s, a, o, l = this;
    if ((l = t.call(this, e, r) || this).reqId = "", l.replyToChannel = !1, l.errorCode = 0, l.sender = r.user ? new ga(l._iid, r.user) : r.sender_id, l.reqId = (s = (i = r.req_id) !== null && i !== void 0 ? i : r.request_id) !== null && s !== void 0 ? s : "", l.replyToChannel = (a = r.is_reply_to_channel) !== null && a !== void 0 && a, r.request_state && Ze(St, r.request_state) && (l.sendingStatus = r.request_state), !l.sendingStatus)
      if (l.messageId > 0)
        l.sendingStatus = St.SUCCEEDED;
      else if (l.scheduledInfo)
        switch (r.scheduled_status && (l._scheduledStatus = r.scheduled_status), r.scheduled_status) {
          case Tr.SENT:
          case Tr.IN_QUEUE:
            l.sendingStatus = St.SUCCEEDED;
            break;
          case Tr.PENDING:
            l.sendingStatus = St.SCHEDULED;
            break;
          case Tr.FAILED:
          case Tr.REMOVED:
            l.sendingStatus = St.FAILED;
            break;
          case Tr.CANCELED:
            l.sendingStatus = St.CANCELED;
        }
      else
        l.sendingStatus = St.PENDING;
    return l.errorCode = (o = r.error_code) !== null && o !== void 0 ? o : 0, l._messageToken = r.mesg_token, l;
  }
  return S(n, t), n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { user: ga.payloadify(e.sender), req_id: e.reqId, is_reply_to_channel: e.replyToChannel, request_state: e.sendingStatus, error_code: e.errorCode, mesg_token: e._messageToken })));
  }, Object.defineProperty(n.prototype, "isResendable", { get: function() {
    return (this.sendingStatus === St.FAILED || this.sendingStatus === St.CANCELED) && function(e) {
      return e > 0 && Kv.indexOf(e) >= 0;
    }(this.errorCode);
  }, enumerable: !1, configurable: !0 }), n.prototype.isIdentical = function(e) {
    return this.messageId > 0 && e.messageId > 0 ? this.messageId === e.messageId : this.reqId === e.reqId;
  }, n;
}(Vn), Uo = { prevResultSize: 0, nextResultSize: 0, isInclusive: !1, reverse: !1, messageTypeFilter: Pn.ALL, customTypesFilter: void 0, senderUserIdsFilter: void 0, includeReactions: !1, includeMetaArray: !1, includeParentMessageInfo: !1 }, Cc = function(t) {
  return O("number", t.prevResultSize) && O("number", t.nextResultSize) && O("boolean", t.isInclusive) && O("boolean", t.reverse) && O("string", t.messageTypeFilter) && Ze(Pn, t.messageTypeFilter) && tt("string", t.customTypesFilter, !0) && tt("string", t.senderUserIdsFilter, !0) && O("boolean", t.includeMetaArray) && O("boolean", t.includeReactions) && O("boolean", t.includeParentMessageInfo);
}, va = function(t) {
  function n(e, r) {
    var i, s, a, o = this;
    if ((o = t.call(this, e, r) || this).translations = {}, o.messageType = Yt.ADMIN, o.translations = (i = r.translations) !== null && i !== void 0 ? i : {}, r.parent_message_info) {
      var l = r.parent_message_info;
      o.parentMessage = Kn(e, fe(Ae(A(A({}, l), { message_id: o.parentMessageId, channel_url: o.channelUrl, channel_type: o.channelType, file: l.file, url: (s = l.file) === null || s === void 0 ? void 0 : s.url, require_auth: (a = l.file) === null || a === void 0 ? void 0 : a.require_auth }))));
    }
    return o;
  }
  return S(n, t), n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { translations: e.translations, parent_message_info: e.parentMessage ? t._getParentMessageInfoPayload.call(this, e.parentMessage) : null })));
  }, n.prototype.getThreadedMessagesByTimestamp = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = A(A({}, Uo), r), Z(this.messageId > 0 && O("number", e) && Cc(i)).throw(D.invalidParameters), [4, bn.of(this._iid).getThreadedMessagesByTimestamp(this, e, i)];
          case 1:
            return [2, s.sent()];
        }
      });
    });
  }, n;
}(Vn), xp = function() {
  function t(n) {
    var e, r;
    this.detail = {}, this.type = (e = n.type) !== null && e !== void 0 ? e : "", this.vendor = (r = n.vendor) !== null && r !== void 0 ? r : "", n.detail && O("object", n.detail) && !Array.isArray(n.detail) && (this.detail = n.detail);
  }
  return t.payloadify = function(n) {
    return fe(Ae({ type: n.type, vendor: n.vendor, detail: n.detail }));
  }, t;
}(), kp = function() {
  function t(n) {
    this.status = n.status, n.original_message_info && (this.originalMessageInfo = { createdAt: n.original_message_info.ts, messageId: n.original_message_info.id });
  }
  return t.payloadify = function(n) {
    return fe({ status: n.status, original_message_info: n.originalMessageInfo ? { id: n.originalMessageInfo.messageId, ts: n.originalMessageInfo.createdAt } : void 0 });
  }, t;
}(), Ln = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d = this;
    if ((d = t.call(this, e, r) || this).messageParams = null, d.translations = {}, d.translationTargetLanguages = [], d.messageSurvivalSeconds = -1, d.plugins = [], d._poll = null, d.messageType = Yt.USER, d.translations = (a = r.translations) !== null && a !== void 0 ? a : {}, d.translationTargetLanguages = (o = r.target_langs) !== null && o !== void 0 ? o : [], Object.keys(d.translations).length === 0 && d.translationTargetLanguages.length > 0)
      try {
        for (var h = de(d.translationTargetLanguages), p = h.next(); !p.done; p = h.next()) {
          var f = p.value;
          d.translations[f] = "";
        }
      } catch (v) {
        i = { error: v };
      } finally {
        try {
          p && !p.done && (s = h.return) && s.call(h);
        } finally {
          if (i)
            throw i.error;
        }
      }
    if (d.messageSurvivalSeconds = (l = r.message_survival_seconds) !== null && l !== void 0 ? l : -1, d.plugins = r.plugins ? r.plugins.map(function(v) {
      return new xp(v);
    }) : [], d._poll = r.poll ? new Pr(d._iid, r.poll) : null, r.parent_message_info) {
      var m = r.parent_message_info;
      d.parentMessage = Kn(e, fe(Ae(A(A({}, m), { created_at: m.ts, message_id: d.parentMessageId, channel_url: d.channelUrl, channel_type: d.channelType, file: m.file, url: (c = m.file) === null || c === void 0 ? void 0 : c.url, require_auth: (u = m.file) === null || u === void 0 ? void 0 : u.require_auth }))));
    }
    return r.review_info && (d.messageReviewInfo = new kp(r.review_info)), d;
  }
  return S(n, t), n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { translations: e.translations, message_survival_seconds: e.messageSurvivalSeconds, plugins: e.plugins.map(function(r) {
      return xp.payloadify(r);
    }), poll: e._poll ? Pr.payloadify(e._poll) : null, parent_message_info: e.parentMessage ? t._getParentMessageInfoPayload.call(this, e.parentMessage) : null, review_info: e.messageReviewInfo ? kp.payloadify(e.messageReviewInfo) : void 0 })));
  }, n.prototype.getThreadedMessagesByTimestamp = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = A(A({}, Uo), r), Z(this.messageId > 0 && O("number", e) && Cc(i)).throw(D.invalidParameters), [4, bn.of(this._iid).getThreadedMessagesByTimestamp(this, e, i)];
          case 1:
            return [2, s.sent()];
        }
      });
    });
  }, n.prototype.applyPoll = function(e) {
    return !(this._poll && this._poll.id === e.id && this._poll.updatedAt > e.updatedAt || (this._poll = e, 0));
  }, Object.defineProperty(n.prototype, "poll", { get: function() {
    return this._poll;
  }, enumerable: !1, configurable: !0 }), n;
}(en), Sr = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d, h = this;
    if ((h = t.call(this, e, r) || this).messageParams = null, h.fileInfoList = [], h.messageSurvivalSeconds = -1, h.messageType = Yt.FILE, h.data = (a = (s = (i = r.file) === null || i === void 0 ? void 0 : i.data) !== null && s !== void 0 ? s : r.custom) !== null && a !== void 0 ? a : "", h.fileInfoList = (l = (o = r.files) === null || o === void 0 ? void 0 : o.map(function(f) {
      return new sd(e, f);
    })) !== null && l !== void 0 ? l : [], h.messageSurvivalSeconds = (c = r.message_survival_seconds) !== null && c !== void 0 ? c : -1, r.parent_message_info) {
      var p = r.parent_message_info;
      h.parentMessage = Kn(e, fe(Ae(A(A({}, p), { created_at: p.ts, message_id: h.parentMessageId, channel_url: h.channelUrl, channel_type: h.channelType, file: p.file, url: (u = p.file) === null || u === void 0 ? void 0 : u.url, require_auth: (d = p.file) === null || d === void 0 ? void 0 : d.require_auth }))));
    }
    return h;
  }
  return S(n, t), n.prototype.getThreadedMessagesByTimestamp = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = A(A({}, Uo), r), Z(this.messageId > 0 && O("number", e) && Cc(i)).throw(D.invalidParameters), [4, bn.of(this._iid).getThreadedMessagesByTimestamp(this, e, i)];
          case 1:
            return [2, s.sent()];
        }
      });
    });
  }, n.payloadify = function(e) {
    var r, i, s, a, o, l;
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { file: { name: (i = (r = e.fileInfoList[0]) === null || r === void 0 ? void 0 : r.fileName) !== null && i !== void 0 ? i : "", size: (a = (s = e.fileInfoList[0]) === null || s === void 0 ? void 0 : s.fileSize) !== null && a !== void 0 ? a : 0, type: (l = (o = e.fileInfoList[0]) === null || o === void 0 ? void 0 : o.mimeType) !== null && l !== void 0 ? l : "", data: e.data }, files: Array.isArray(e.fileInfoList) ? e.fileInfoList.map(function(c) {
      return sd.payloadify(c);
    }) : null, message_survival_seconds: e.messageSurvivalSeconds, parent_message_info: e.parentMessage ? t._getParentMessageInfoPayload.call(this, e.parentMessage) : null })));
  }, n._isMultipleFilesMessagePayload = function(e) {
    var r = e.files;
    return Array.isArray(r) && r.length >= 2;
  }, n._isMultipleFilesMessageSerializedData = function(e) {
    var r = e.fileInfoList;
    return Array.isArray(r);
  }, n;
}(en);
(function(t) {
  t.SENT = "SENT", t.READ = "READ";
})(Ls || (Ls = {}));
var _n, Gs = function(t) {
  function n(e, r) {
    var i, s, a = this;
    if ((a = t.call(this, e, r) || this).notificationData = null, a.notificationId = r.notification_message_id, a.messageType = Yt.ADMIN, a.messageStatus = (i = r.message_status) !== null && i !== void 0 ? i : Ls.SENT, a.priority = (s = r.priority) !== null && s !== void 0 ? s : Qu.NORMAL, a.notificationEventDeadline = r.notification_event_deadline, a.extendedMessage.sub_type === 0)
      try {
        var o = JSON.parse(a.extendedMessage.sub_data), l = o.label, c = o.tags, u = c === void 0 ? [] : c, d = o.template_key, h = o.template_variables;
        a.notificationData = { label: l, tags: u, templateKey: d, templateVariables: h };
      } catch {
      }
    return a;
  }
  return S(n, t), n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { notification_message_id: e.notificationId, message_status: e.messageStatus, priority: e.priority, notification_event_deadline: e.notificationEventDeadline })));
  }, n.prototype.isIdentical = function(e) {
    return this.notificationId === e.notificationId;
  }, n;
}(Qm), Op = function(t) {
  if (t.notificationId)
    return Gs.payloadify(t);
  switch (t.messageType) {
    case Yt.USER:
      return Ln.payloadify(t);
    case Yt.FILE:
      return t.fileInfoList ? Sr.payloadify(t) : ln.payloadify(t);
    case Yt.ADMIN:
      return va.payloadify(t);
    default:
      throw D.unknown;
  }
}, Kn = function(t, n) {
  if (n.notification_message_id)
    return new Gs(t, n);
  switch (n.type) {
    case "MESG":
      return new Ln(t, n);
    case "FILE":
      return Sr._isMultipleFilesMessagePayload(n) ? new Sr(t, n) : new ln(t, n);
    case "ADMM":
    case "BRDM":
      return new va(t, n);
    default:
      return null;
  }
}, ln = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d, h, p, f, m, v, E, y = this;
    (y = t.call(this, e, r) || this).messageParams = null, y.plainUrl = "", y.requireAuth = !1, y.thumbnails = [], y.messageSurvivalSeconds = -1, y.messageType = Yt.FILE;
    var b = r.file;
    if (y.plainUrl = ((s = (i = b == null ? void 0 : b.url) !== null && i !== void 0 ? i : r.url) !== null && s !== void 0 ? s : "").split("?auth=")[0], y.name = (o = (a = b == null ? void 0 : b.name) !== null && a !== void 0 ? a : r.name) !== null && o !== void 0 ? o : "File", y.size = (c = (l = b == null ? void 0 : b.size) !== null && l !== void 0 ? l : r.size) !== null && c !== void 0 ? c : 0, y.data = (d = (u = b == null ? void 0 : b.data) !== null && u !== void 0 ? u : r.custom) !== null && d !== void 0 ? d : "", y.type = b ? (h = b.type) !== null && h !== void 0 ? h : "" : (p = r.type) !== null && p !== void 0 ? p : "", y.requireAuth = (f = r.require_auth) !== null && f !== void 0 && f, y.thumbnails = r.thumbnails ? r.thumbnails.map(function(w) {
      var N;
      return new Bi(y._iid, typeof w == "string" ? { url: w, width: 0, height: 0 } : A(A({}, w), { url: ((N = w.url) !== null && N !== void 0 ? N : "").split("auth=")[0] }), y.requireAuth);
    }) : [], y.messageSurvivalSeconds = (m = r.message_survival_seconds) !== null && m !== void 0 ? m : -1, r.parent_message_info) {
      var T = r.parent_message_info;
      y.parentMessage = Kn(e, fe(Ae(A(A({}, T), { created_at: T.ts, message_id: y.parentMessageId, channel_url: y.channelUrl, channel_type: y.channelType, file: T.file, url: (v = T.file) === null || v === void 0 ? void 0 : v.url, require_auth: (E = T.file) === null || E === void 0 ? void 0 : E.require_auth }))));
    }
    return y;
  }
  return S(n, t), n.payloadify = function(e) {
    var r;
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { url: e.plainUrl, require_auth: e.requireAuth, file: { name: e.name, size: e.size, type: e.type, data: e.data }, thumbnails: (r = e.thumbnails) === null || r === void 0 ? void 0 : r.map(function(i) {
      return { url: i.plainUrl, width: i.width, height: i.height, real_width: i.realWidth, real_height: i.realHeight };
    }), message_survival_seconds: e.messageSurvivalSeconds, parent_message_info: e.parentMessage ? t._getParentMessageInfoPayload.call(this, e.parentMessage) : null })));
  }, Object.defineProperty(n.prototype, "url", { get: function() {
    var e = k.of(this._iid).sessionManager;
    return this.requireAuth && e.ekey ? "".concat(this.plainUrl, "?auth=").concat(e.ekey) : this.plainUrl;
  }, enumerable: !1, configurable: !0 }), n.prototype.getThreadedMessagesByTimestamp = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = A(A({}, Uo), r), Z(this.messageId > 0 && O("number", e) && Cc(i)).throw(D.invalidParameters), [4, bn.of(this._iid).getThreadedMessagesByTimestamp(this, e, i)];
          case 1:
            return [2, s.sent()];
        }
      });
    });
  }, n;
}(en), ec = function(t) {
  function n(e, r) {
    var i = r.file, s = r.fileUrl, a = r.fileName, o = r.fileSize, l = r.mimeType, c = r.thumbnailSizes, u = r._uploadedMetaData, d = r._thumbnails, h = t.call(this, e) || this;
    return h._plainUrl = s, h.file = i, h.fileName = a, h.fileSize = o, h.mimeType = l, h.thumbnailSizes = c, h._uploadedMetaData = u, h._thumbnails = d, h;
  }
  return S(n, t), n.getPlainUrl = function(e) {
    return e instanceof n ? e._plainUrl : e.fileUrl;
  }, Object.defineProperty(n.prototype, "fileUrl", { get: function() {
    var e, r = k.of(this._iid).sessionManager;
    return this._plainUrl && (!((e = this._uploadedMetaData) === null || e === void 0) && e.requireAuth) && r.ekey ? "".concat(this._plainUrl, "?auth=").concat(r.ekey) : this._plainUrl;
  }, set: function(e) {
    this._plainUrl = e;
  }, enumerable: !1, configurable: !0 }), n.prototype.toJSON = function() {
    return { file: this.file, fileUrl: this._plainUrl, fileName: this.fileName, fileSize: this.fileSize, mimeType: this.mimeType, thumbnailSizes: this.thumbnailSizes, _thumbnails: this._thumbnails, _uploadedMetaData: this._uploadedMetaData };
  }, n;
}(xn), hb = function(t) {
  function n(e) {
    var r, i, s, a, o = [];
    return e.mentionType === jn.USERS && (e.mentionedUserIds ? o = e.mentionedUserIds : e.mentionedUsers && (o = e.mentionedUsers.map(function(l) {
      return l.userId;
    }))), t.call(this, { code: "FILE", ackRequired: !0, payload: fe(Ae({ channel_url: e.channelUrl, files: e.files ? Jm(e.files) : null, url: e.url, name: (r = e.fileName) !== null && r !== void 0 ? r : "", type: (i = e.mimeType) !== null && i !== void 0 ? i : "", size: (s = e.fileSize) !== null && s !== void 0 ? s : 0, custom: e.data, custom_type: e.customType, thumbnails: (a = e._thumbnails) === null || a === void 0 ? void 0 : a.map(function(l) {
      return Bi.payloadify(l);
    }), require_auth: e.requireAuth, metaarray: e.metaArrays, mention_type: e.mentionType, mentioned_user_ids: o, push_option: e.pushNotificationDeliveryOption && e.pushNotificationDeliveryOption !== Yr.DEFAULT ? e.pushNotificationDeliveryOption : void 0, apple_critical_alert_options: e.appleCriticalAlertOptions ? Fr.payloadify(e.appleCriticalAlertOptions) : null, silent: e.silent, reply_to_channel: e.isReplyToChannel, parent_message_id: e.parentMessageId ? e.parentMessageId : null, req_id: e.reqId, pin_message: e.isPinnedMessage, message: e.message })) }) || this;
  }
  return S(n, t), n;
}(Zn), pb = function(t) {
  function n(e) {
    var r, i, s = this;
    s = t.call(this) || this;
    var a = [];
    return e.mentionType === jn.USERS && (e.mentionedUserIds ? a = e.mentionedUserIds : e.mentionedUsers && (a = e.mentionedUsers.map(function(o) {
      return o.userId;
    }))), s.method = Y.POST, s.path = "".concat(gt(e.channelType), "/").concat(encodeURIComponent(e.channelUrl), "/messages"), s.params = fe(Ae({ message_type: Yt.FILE, user_id: e.userId, files: e.files ? Jm(e.files) : null, url: e.fileUrl, mention_type: e.mentionType, mentioned_user_ids: a, file_name: e.fileName, file_size: e.fileSize, file_type: e.mimeType, data: e.data, custom_type: e.customType, thumbnails: (r = e._thumbnails) === null || r === void 0 ? void 0 : r.map(function(o) {
      return Bi.payloadify(o);
    }), require_auth: e.requireAuth, sorted_metaarray: (i = e.metaArrays) === null || i === void 0 ? void 0 : i.map(function(o) {
      return Yn.payloadify(o);
    }), push_option: e.pushNotificationDeliveryOption, parent_message_id: e.parentMessageId ? e.parentMessageId : null, apple_critical_alert_options: e.appleCriticalAlertOptions ? Fr.payloadify(e.appleCriticalAlertOptions) : null, reply_to_channel: e.isReplyToChannel, req_id: e.reqId, pin_message: e.isPinnedMessage })), s;
  }
  return S(n, t), n;
}($), Xm = function(t) {
  function n(e, r, i) {
    var s, a, o, l, c = this;
    (c = t.call(this, e, "FILE", i) || this).message = i.files && i.files.length >= 2 ? new Sr(e, i) : new ln(e, i);
    var u = k.of(e).sdkState;
    return c.isMentioned = pa(c.message.mentionType, (o = (s = c.message.mentionedUserIds) !== null && s !== void 0 ? s : (a = c.message.mentionedUsers) === null || a === void 0 ? void 0 : a.map(function(d) {
      return d.userId;
    })) !== null && o !== void 0 ? o : [], u.userId), c.forceUpdateLastMessage = (l = i.force_update_last_message) !== null && l !== void 0 && l, c;
  }
  return S(n, t), n;
}(Lt), fb = function(t) {
  function n(e, r) {
    var i, s, a, o, l = this;
    (l = t.call(this, e, r) || this).message = r.files && r.files.length >= 2 ? new Sr(e, r) : new ln(e, r);
    var c = k.of(e).sdkState;
    return l.isMentioned = pa(l.message.mentionType, (a = (i = l.message.mentionedUserIds) !== null && i !== void 0 ? i : (s = l.message.mentionedUsers) === null || s === void 0 ? void 0 : s.map(function(u) {
      return u.userId;
    })) !== null && a !== void 0 ? a : [], c.userId), l.forceUpdateLastMessage = (o = r.force_update_last_message) !== null && o !== void 0 && o, l;
  }
  return S(n, t), n;
}(ne);
function Jm(t) {
  return t.map(function(n) {
    var e, r;
    return fe(Ae({ url: ec.getPlainUrl(n), file_name: n.fileName, file_type: n.mimeType, file_size: n.fileSize, thumbnails: (e = n._thumbnails) === null || e === void 0 ? void 0 : e.map(function(i) {
      return Bi.payloadify(i);
    }), require_auth: (r = n._uploadedMetaData) === null || r === void 0 ? void 0 : r.requireAuth }));
  });
}
(function(t) {
  t[t.PENDING = 0] = "PENDING", t[t.UPLOADING = 1] = "UPLOADING", t[t.UPLOADED = 2] = "UPLOADED", t[t.SENDING = 3] = "SENDING", t[t.FAILED = 4] = "FAILED";
})(_n || (_n = {}));
var ad, mb = function() {
  function t(n, e) {
    var r = e.sdkState, i = e.dispatcher, s = e.requestQueue, a = e.onlineDetector, o = e.cacheContext, l = this;
    this._queueMap = /* @__PURE__ */ new Map(), this._iid = n, this._sdkState = r, this._requestQueue = s, this._cacheContext = o, this._dispatcher = i, this._dispatcher.on(function(c) {
      c instanceof Ar && (l._connectionState = c.stateType);
    }), this._onlineDetector = a;
  }
  return Object.defineProperty(t.prototype, "_shouldSendThroughWebSocket", { get: function() {
    return this._connectionState === bt.CONNECTED || this._connectionState === bt.CONNECTING || this._connectionState === bt.RECONNECTING;
  }, enumerable: !1, configurable: !0 }), t.prototype._sendFileMessage = function(n, e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return r = this._createSendFileMessageRequestParams(n, e), this._shouldSendThroughWebSocket ? (i = new hb(r), [4, this._requestQueue.send(i)]) : [3, 2];
          case 1:
            return [2, s.sent().as(Xm).message];
          case 2:
            return i = new pb(A(A({}, r), { userId: this._sdkState.userId })), [4, this._requestQueue.send(i)];
          case 3:
            return [2, s.sent().as(fb).message];
        }
      });
    });
  }, t.prototype._createSendFileMessageRequestParams = function(n, e) {
    var r = A(A({}, e.params), { channelUrl: n.url, channelType: n.channelType, reqId: e.requestId, url: "" });
    if (e.multipleFileUploadInfo) {
      var i = e.params;
      r.files = i.fileInfoList;
    } else
      i = e.params, r.url = i.fileUrl, r.requireAuth = i.requireAuth;
    return r;
  }, t.prototype._resolveMessageQueue = function(n) {
    var e;
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u, d, h, p, f, m;
      return _(this, function(v) {
        switch (v.label) {
          case 0:
            if (!(r = this._queueMap.get(n.url)))
              return [3, 21];
            if (r.isResolving)
              return [3, 20];
            r.isResolving = !0, i = [], s = !0, v.label = 1;
          case 1:
            v.trys.push([1, 15, 16, 17]), a = de(r.messageQueue), o = a.next(), v.label = 2;
          case 2:
            if (o.done)
              return [3, 14];
            switch ((l = o.value).state) {
              case _n.PENDING:
              case _n.UPLOADING:
                return [3, 3];
              case _n.UPLOADED:
                return [3, 4];
              case _n.FAILED:
                return [3, 12];
            }
            return [3, 13];
          case 3:
            return s = !1, i.push(l), [3, 13];
          case 4:
            if (!s)
              return [3, 10];
            v.label = 5;
          case 5:
            return v.trys.push([5, 8, , 9]), l.state = _n.SENDING, [4, this._sendFileMessage(n, l)];
          case 6:
            return c = v.sent(), l.deferred.resolve(c), [4, er(100)];
          case 7:
            return v.sent(), [3, 9];
          case 8:
            return u = v.sent(), l.deferred.reject(u), [3, 9];
          case 9:
            return [3, 11];
          case 10:
            i.push(l), v.label = 11;
          case 11:
            return [3, 13];
          case 12:
            return d = (e = l.error) !== null && e !== void 0 ? e : D.unknown, l.deferred.reject(d.code === me.REQUEST_CANCELED ? D.fileUploadCanceled : d), [3, 13];
          case 13:
            return o = a.next(), [3, 2];
          case 14:
            return [3, 17];
          case 15:
            return h = v.sent(), f = { error: h }, [3, 17];
          case 16:
            try {
              o && !o.done && (m = a.return) && m.call(a);
            } finally {
              if (f)
                throw f.error;
            }
            return [7];
          case 17:
            return p = r.isResolveRequestPending, r.messageQueue = i, r.isResolving = !1, r.isResolveRequestPending = !1, p ? [4, this._resolveMessageQueue(n)] : [3, 19];
          case 18:
            v.sent(), v.label = 19;
          case 19:
            return [3, 21];
          case 20:
            r.isResolveRequestPending = !0, v.label = 21;
          case 21:
            return [2];
        }
      });
    });
  }, t.prototype._uploadNextPendingItem = function(n) {
    var e;
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u, d, h;
      return _(this, function(p) {
        switch (p.label) {
          case 0:
            return (r = this._queueMap.get(n.url)) && (i = r.messageQueue.find(function(f) {
              return f.state === _n.PENDING;
            })) ? i.multipleFileUploadInfo ? (s = i.multipleFileUploadInfo, a = s.uploadIndex, o = s.uploadCount, l = s.requestHandler, h = i.params, c = h.fileInfoList[a], !qn(c.file) || !((e = c._uploadedMetaData) === null || e === void 0) && e.isUploaded ? [3, 2] : [4, this._tryUploadNextItemAndUpdateItemState(n, r, i)]) : [3, 4] : [3, 9];
          case 1:
            return p.sent(), [3, 3];
          case 2:
            i.state = a < o - 1 ? _n.PENDING : _n.UPLOADED, p.label = 3;
          case 3:
            return u = h.fileInfoList[a], d = i.multipleFileUploadInfo.uploadIndex++, i.multipleFileUploadInfo.isCopy || l == null || l._triggerOnFileUploaded(i.requestId, d, u, i.error), [3, 7];
          case 4:
            return h = i.params, qn(h.file) ? [4, this._tryUploadNextItemAndUpdateItemState(n, r, i)] : [3, 6];
          case 5:
            return p.sent(), [3, 7];
          case 6:
            h.thumbnailSizes = [], i.state = _n.UPLOADED, p.label = 7;
          case 7:
            return this._uploadNextPendingItem(n), [4, this._resolveMessageQueue(n)];
          case 8:
            p.sent(), p.label = 9;
          case 9:
            return [2];
        }
      });
    });
  }, t.prototype._tryUploadNextItemAndUpdateItemState = function(n, e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return [4, this._onlineDetector.isOnline()];
          case 1:
            if (i = u.sent(), !k.of(this._iid).sessionManager.currentUser || !i)
              return r.error = D.connectionRequired, r.state = _n.FAILED, [2];
            if (!(e.uploadQueue.length < 6))
              return [3, 9];
            r.state = _n.UPLOADING, e.uploadQueue.push(r), u.label = 2;
          case 2:
            return u.trys.push([2, 7, , 8]), r.multipleFileUploadInfo ? (s = r.multipleFileUploadInfo, a = s.uploadIndex, o = s.uploadCount, l = r.params, [4, this._uploadNextFileForMultipleFilesItemAndUpdateParams(n, r, l)]) : [3, 4];
          case 3:
            return u.sent(), r.state = a < o - 1 ? _n.PENDING : _n.UPLOADED, [3, 6];
          case 4:
            return l = r.params, [4, this._uploadNextFileForSingleFileItemAndUpdateParams(n, r, l)];
          case 5:
            u.sent(), r.state = _n.UPLOADED, u.label = 6;
          case 6:
            return [3, 8];
          case 7:
            switch ((c = u.sent()).code) {
              case me.REQUEST_FAILED:
                r.error = new D({ code: me.NETWORK_ERROR, message: "Failed to upload a file." });
                break;
              case me.REQUEST_CANCELED:
                r.error = D.fileUploadCanceled;
                break;
              default:
                r.error = c;
            }
            return r.state = _n.FAILED, [3, 8];
          case 8:
            this._dequeueUploadItem(e, r), u.label = 9;
          case 9:
            return [2];
        }
      });
    });
  }, t.prototype._dequeueUploadItem = function(n, e) {
    var r = n.uploadQueue.findIndex(function(i) {
      return i.requestId === e.requestId;
    });
    r >= 0 && n.uploadQueue.splice(r, 1);
  }, t.prototype._uploadNextFileForSingleFileItemAndUpdateParams = function(n, e, r) {
    var i, s, a;
    return g(this, 0, void 0, function() {
      var o, l, c, u, d, h, p, f, m, v;
      return _(this, function(E) {
        switch (E.label) {
          case 0:
            return o = new Zl({ file: r.file, channelUrl: n.url, thumbnailSizes: r.thumbnailSizes, requestId: e.requestId }), [4, this._requestQueue.send(o)];
          case 1:
            return l = E.sent(), c = l.as(Xl), u = c.url, d = c.fileSize, h = d === void 0 ? r.fileSize : d, p = c.thumbnails, f = p === void 0 ? [] : p, m = c.requireAuth, v = m !== void 0 && m, r.fileName = (i = r.fileName) !== null && i !== void 0 ? i : r.file.name, r.mimeType = (s = r.mimeType) !== null && s !== void 0 ? s : r.file.type, r.fileSize = (a = r.fileSize) !== null && a !== void 0 ? a : r.file.size, r.fileUrl = u, r.fileSize = h, r.requireAuth = v, r._thumbnails = f, [2];
        }
      });
    });
  }, t.prototype._uploadNextFileForMultipleFilesItemAndUpdateParams = function(n, e, r) {
    var i, s, a;
    return g(this, 0, void 0, function() {
      var o, l, c, u, d, h, p, f, m, v, E;
      return _(this, function(y) {
        switch (y.label) {
          case 0:
            return o = e.multipleFileUploadInfo.uploadIndex, l = r.fileInfoList[o], c = new Zl({ file: l.file, channelUrl: n.url, thumbnailSizes: l.thumbnailSizes, requestId: e.requestId }), [4, this._requestQueue.send(c)];
          case 1:
            return u = y.sent(), d = u.as(Xl), h = d.url, p = d.fileSize, f = p === void 0 ? l.fileSize : p, m = d.thumbnails, v = d.requireAuth, E = v !== void 0 && v, l.fileName = (i = l.fileName) !== null && i !== void 0 ? i : l.file.name, l.mimeType = (s = l.mimeType) !== null && s !== void 0 ? s : l.file.type, l.fileSize = (a = l.fileSize) !== null && a !== void 0 ? a : l.file.size, l.file = void 0, l.fileUrl = h, l.fileSize = f, l._thumbnails = m, l._uploadedMetaData = A(A({}, l._uploadedMetaData), { requireAuth: E, isUploaded: !0 }), l instanceof ec || (r.fileInfoList[o] = new ec(this._iid, l)), [2];
        }
      });
    });
  }, t.prototype.request = function(n, e, r, i) {
    return i === void 0 && (i = {}), g(this, 0, void 0, function() {
      var s, a, o, l, c;
      return _(this, function(u) {
        return this._queueMap.has(n.url) || (s = { messageQueue: [], uploadQueue: [], isResolving: !1, isResolveRequestPending: !1 }, this._queueMap.set(n.url, s)), a = this._queueMap.get(n.url), o = new $n(), l = { requestId: e, params: r, state: _n.PENDING, deferred: o }, function(d) {
          return "fileInfoList" in d;
        }(r) && (c = A({ uploadIndex: 0, uploadCount: r.fileInfoList.length }, i), l.multipleFileUploadInfo = c), a.messageQueue.push(l), this._uploadNextPendingItem(n), [2, o.promise];
      });
    });
  }, t.prototype.cancel = function(n, e) {
    var r, i, s = this._queueMap.get(n.url);
    if (s) {
      var a = e ? [s.messageQueue.find(function(f) {
        return f.requestId === e;
      })] : Re([], we(s.messageQueue), !1);
      try {
        for (var o = de(a), l = o.next(); !l.done; l = o.next()) {
          var c = l.value;
          if (c)
            switch (c.state) {
              case _n.PENDING:
                if (c.state = _n.FAILED, c.error = D.requestCanceled, c.multipleFileUploadInfo && !c.multipleFileUploadInfo.isCopy) {
                  var u = c.multipleFileUploadInfo, d = u.uploadIndex, h = u.requestHandler, p = c.params.fileInfoList[d];
                  h == null || h._triggerOnFileUploaded(c.requestId, d, p, D.fileUploadCanceled);
                }
                this._resolveMessageQueue(n);
                break;
              case _n.UPLOADING:
                this._requestQueue.cancel(c.requestId), this._dispatcher.dispatch(new Vl({ requestId: c.requestId }));
            }
        }
      } catch (f) {
        r = { error: f };
      } finally {
        try {
          l && !l.done && (i = o.return) && i.call(o);
        } finally {
          if (r)
            throw r.error;
        }
      }
    } else
      e && (this._requestQueue.cancel(e), this._dispatcher.dispatch(new Vl({ requestId: e })));
  }, t;
}(), uo = { prevResultSize: 0, nextResultSize: 0, isInclusive: !1, reverse: !1, messageTypeFilter: Pn.ALL, customTypesFilter: void 0, senderUserIdsFilter: void 0, replyType: Fn.NONE, includeReactions: !1, includeMetaArray: !1, includeParentMessageInfo: !1, includeThreadInfo: !1, showSubchannelMessagesOnly: !1 }, Rp = function(t) {
  return O("number", t.prevResultSize) && O("number", t.nextResultSize) && O("boolean", t.isInclusive) && O("boolean", t.reverse) && O("string", t.messageTypeFilter) && Ze(Pn, t.messageTypeFilter) && tt("string", t.customTypesFilter, !0) && tt("string", t.senderUserIdsFilter, !0) && Ze(Fn, t.replyType) && O("boolean", t.includeMetaArray) && O("boolean", t.includeReactions) && O("boolean", t.includeParentMessageInfo) && O("boolean", t.includeThreadInfo) && O("boolean", t.showSubchannelMessagesOnly);
}, od = { replyType: Fn.NONE, includeReactions: !1, includeThreadInfo: !1, includeMetaArray: !1, includeParentMessageInfo: !1 }, Dp = function(t) {
  return Ze(Fn, t.replyType) && O("boolean", t.includeReactions) && O("boolean", t.includeMetaArray) && O("boolean", t.includeParentMessageInfo) && O("boolean", t.includeThreadInfo);
}, _b = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.messageId, a = e.includeMetaArray, o = e.includeReactions, l = e.includeThreadInfo, c = e.includeParentMessageInfo, u = t.call(this) || this;
    return u.method = Y.GET, u.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages/").concat(encodeURIComponent(s)), u.params = { is_sdk: !0, with_sorted_meta_array: a, include_reactions: o, include_thread_info: l, include_parent_message_info: c, include_poll_details: !0 }, u;
  }
  return S(n, t), n;
}($), gb = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.message = r ? Kn(e, A({}, r)) : null, i;
  }
  return S(n, t), n;
}(ne), rl = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.timestamp, a = e.token, o = e.prevResultSize, l = e.nextResultSize, c = e.isInclusive, u = e.reverse, d = e.messageTypeFilter, h = e.customTypesFilter, p = e.senderUserIdsFilter, f = e.replyType, m = e.includeMetaArray, v = e.includeReactions, E = e.parentMessageId, y = e.includeThreadInfo, b = e.includeParentMessageInfo, T = e.showSubchannelMessagesOnly, w = e.checkingHasNext, N = e.checkingContinuousMessages, M = t.call(this) || this;
    return M.method = Y.GET, M.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages"), M.params = fe(Ae({ is_sdk: !0, prev_limit: o, next_limit: l, include: c, reverse: u, message_ts: s, message_id: a, message_type: d ?? null, custom_types: h, sender_ids: p, include_reply_type: f, with_sorted_meta_array: m, include_reactions: v, parent_message_id: E, include_thread_info: y, include_parent_message_info: b, show_subchannel_message_only: T, include_poll_details: !0, checking_has_next: w, checking_continuous_messages: N })), M;
  }
  return S(n, t), n;
}($), il = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return r.is_continuous_messages !== void 0 && (i.isContinuousMessages = r.is_continuous_messages), r.has_next !== void 0 && (i.hasNext = r.has_next), i.messages = r.messages.map(function(s) {
      return Kn(e, s);
    }), i;
  }
  return S(n, t), n;
}(ne), vb = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.timestamp, a = e.token, o = e.replyType, l = e.includeMetaArray, c = e.includeReactions, u = e.includeThreadInfo, d = e.includeParentMessageInfo, h = t.call(this) || this;
    return h.method = Y.GET, h.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages/changelogs"), h.params = { change_ts: s, token: a, with_sorted_meta_array: l, include_reactions: c, include_thread_info: u, include_reply_type: o, include_parent_message_info: d, include_poll_details: !0 }, h;
  }
  return S(n, t), n;
}($), yb = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.updatedMessages = r.updated.map(function(s) {
      return Kn(e, s);
    }), i.deletedMessagesInfo = r.deleted.map(function(s) {
      return { messageId: s.message_id, deletedAt: s.deleted_at };
    }), i.hasMore = r.has_more, i.nextToken = r.next, i;
  }
  return S(n, t), n;
}(ne), bb = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.scheduledMessageId, s = t.call(this) || this;
    return s.method = Y.GET, s.path = "".concat(Wn, "/").concat(encodeURIComponent(r), "/scheduled_messages/").concat(encodeURIComponent(i)), s.params = {}, s;
  }
  return S(n, t), n;
}($), Eb = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.message = r ? Kn(e, A({}, r)) : null, i;
  }
  return S(n, t), n;
}(ne);
(function(t) {
  t.MUTED = "muted", t.BANNED = "banned";
})(ad || (ad = {}));
var Lp = function() {
  function t(n) {
    var e, r, i, s;
    this.restrictionType = null, Ze(ad, n.restriction_type) && (this.restrictionType = n.restriction_type), this.description = (e = n.description) !== null && e !== void 0 ? e : null, this.endAt = (i = (r = n.end_at) !== null && r !== void 0 ? r : n.muted_end_at) !== null && i !== void 0 ? i : -1, this.remainingDuration = (s = n.remaining_duration) !== null && s !== void 0 ? s : -1;
  }
  return t.payloadify = function(n) {
    return fe(Ae({ restriction_type: n.restrictionType, description: n.description, end_at: n.endAt, remaining_duration: n.remainingDuration }));
  }, t;
}(), Zs = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.restrictionInfo = new Lp(r), i;
  }
  return S(n, t), n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), Lp.payloadify(e.restrictionInfo))));
  }, n;
}(pt);
(function(t) {
  function n(e, r) {
    var i, s = this;
    return (s = t.call(this, e, r) || this).isMuted = !1, s.isMuted = (i = r.is_muted) !== null && i !== void 0 && i, s;
  }
  S(n, t);
})(pt);
var cr = function() {
  function t() {
    this._onPending = rt, this._onFailed = rt, this._onSucceeded = rt;
  }
  return t.prototype._trigger = function(n) {
    switch (n == null ? void 0 : n.sendingStatus) {
      case St.PENDING:
        n.errorCode === 0 && this._onPending(n);
        break;
      case St.SCHEDULED:
      case St.SUCCEEDED:
        this._onSucceeded(n);
    }
  }, t.prototype._triggerFailed = function(n, e) {
    switch (e == null ? void 0 : e.sendingStatus) {
      case St.FAILED:
      case St.CANCELED:
        this._onFailed(n, e.scheduledInfo ? null : e);
    }
  }, t.prototype.onPending = function(n) {
    return this._onPending = n, this;
  }, t.prototype.onFailed = function(n) {
    return this._onFailed = n, this;
  }, t.prototype.onSucceeded = function(n) {
    return this._onSucceeded = n, this;
  }, t;
}(), Tc = { data: void 0, customType: void 0, mentionType: jn.USERS, mentionedUserIds: void 0, mentionedUsers: void 0, mentionedMessageTemplate: void 0, metaArrays: void 0, parentMessageId: void 0, isReplyToChannel: !1, pushNotificationDeliveryOption: void 0, appleCriticalAlertOptions: void 0, isPinnedMessage: !1 }, wc = function(t) {
  return O("string", t.data, !0) && O("string", t.customType, !0) && Ze(jn, t.mentionType) && tt("string", t.mentionedUserIds, !0) && tt(pt, t.mentionedUsers, !0) && O("string", t.mentionedMessageTemplate, !0) && tt(Yn, t.metaArrays, !0) && O("number", t.parentMessageId, !0) && O("boolean", t.isReplyToChannel) && Ze(Yr, t.pushNotificationDeliveryOption, !0) && O(Fr, t.appleCriticalAlertOptions, !0) && O("boolean", t.isPinnedMessage, !0);
}, Up = function(t) {
  return { isReplyToChannel: t.isReplyToChannel, pushNotificationDeliveryOption: t.pushNotificationDeliveryOption, pollId: t.pollId };
}, e_ = A(A({}, Tc), { message: "", translationTargetLanguages: void 0, pollId: void 0, extendedMessagePayload: void 0 });
function t_(t) {
  var n, e, r;
  return (n = t.messageParams) !== null && n !== void 0 ? n : Ae(A(A({}, t), { mentionType: t.mentionType, mentionedUserIds: (e = t.mentionedUserIds) !== null && e !== void 0 ? e : (r = t.mentionedUsers) === null || r === void 0 ? void 0 : r.map(function(i) {
    return i.userId;
  }), translationTargetLanguages: Object.keys(t.translations), pushNotificationDeliveryOption: Yr.DEFAULT, parentMessageId: null, isReplyToChannel: !1, isPinnedMessage: !1 }));
}
var Hs, ld = function(t) {
  var n;
  return fe(Ae({ data: t.data, customType: t.customType, mentionType: t.mentionType, mentionedUsers: t.mentionedUsers, mentionedUserIds: t.mentionedUserIds, mentionedMessageTemplate: t.mentionedMessageTemplate, metaArrays: t.metaArrays, pollId: (n = t.poll) === null || n === void 0 ? void 0 : n.id, parentMessageId: t.parentMessageId, appleCriticalAlertOptions: t.appleCriticalAlertOptions, message: t.message, translationTargetLanguages: Object.keys(t.translations), extendedMessagePayload: t.extendedMessagePayload }));
}, n_ = function(t) {
  return wc(t) && O("string", t.message) && tt("string", t.translationTargetLanguages, !0) && O("number", t.pollId, !0) && O("object", t.extendedMessagePayload, !0);
};
(function(t) {
  t.FILE = "file", t.BLOB = "blob", t.BLOB_LIKE_OBJECT = "blobLikeObject", t.URL = "url";
})(Hs || (Hs = {}));
var Sl = function(t) {
  return typeof window < "u" && "Blob" in window && typeof Blob < "u" && t instanceof Blob;
}, du = function(t) {
  return t === Hs.BLOB || t === Hs.FILE;
}, Pp = function(t) {
  return { file: t.file, fileKey: t.fileKey, fileType: t.fileType, isReplyToChannel: t.isReplyToChannel, pushNotificationDeliveryOption: t.pushNotificationDeliveryOption };
}, Fp = A(A({}, Tc), { file: void 0, fileKey: void 0, fileUrl: void 0, fileName: void 0, fileType: void 0, fileSize: void 0, mimeType: void 0, thumbnailSizes: void 0, requireAuth: !1, message: void 0 });
function r_(t) {
  var n, e, r, i;
  return (n = t.messageParams) !== null && n !== void 0 ? n : Ae(A(A({}, t), { fileUrl: t.plainUrl, fileName: t.name, fileSize: t.size, mimeType: t.type, mentionType: t.mentionType, mentionedUserIds: (e = t.mentionedUserIds) !== null && e !== void 0 ? e : (r = t.mentionedUsers) === null || r === void 0 ? void 0 : r.map(function(s) {
    return s.userId;
  }), pushNotificationDeliveryOption: Yr.DEFAULT, parentMessageId: null, isReplyToChannel: !1, thumbnailSizes: (i = t.thumbnails) === null || i === void 0 ? void 0 : i.map(function(s) {
    return { maxWidth: s.width, maxHeight: s.height };
  }), requireAuth: t.requireAuth, isPinnedMessage: !1, _thumbnails: t.thumbnails, message: t.message }));
}
var ho, cd = function(t, n) {
  var e;
  return t.messageParams ? (!t.url && qn(n) && (t.messageParams.file = n), t.messageParams) : fe(Ae({ data: t.data, customType: t.customType, mentionType: t.mentionType, mentionedUsers: t.mentionedUsers, mentionedUserIds: t.mentionedUserIds, metaArrays: t.metaArrays, parentMessageId: t.parentMessageId, appleCriticalAlertOptions: t.appleCriticalAlertOptions, file: n, fileUrl: t.url, fileName: t.name, fileSize: t.size, mimeType: t.type, thumbnailSizes: (e = t.thumbnails) === null || e === void 0 ? void 0 : e.map(function(r) {
    return { maxWidth: r.width, maxHeight: r.height };
  }), message: t.message }));
}, jp = function(t) {
  return wc(t) && (qn(t.file) || O("string", t.fileUrl)) && O("string", t.fileName, !0) && O("string", t.mimeType, !0) && O("number", t.fileSize, !0) && O("string", t.message, !0) && (t.thumbnailSizes === null || t.thumbnailSizes === void 0 || Array.isArray(t.thumbnailSizes) && t.thumbnailSizes.every(function(n) {
    return O("object", n) && n.maxWidth > 0 && n.maxHeight > 0;
  }));
}, Zd = { data: void 0, customType: void 0, mentionType: jn.USERS, mentionedUserIds: void 0, mentionedUsers: void 0, mentionedMessageTemplate: void 0, metaArrays: void 0, pushNotificationDeliveryOption: void 0, appleCriticalAlertOptions: void 0 }, Xd = function(t) {
  return O("string", t.data, !0) && O("string", t.customType, !0) && Ze(jn, t.mentionType) && tt("string", t.mentionedUserIds, !0) && tt(pt, t.mentionedUsers, !0) && O("string", t.mentionedMessageTemplate, !0) && tt(Yn, t.metaArrays, !0) && Ze(Yr, t.pushNotificationDeliveryOption, !0) && O(Fr, t.appleCriticalAlertOptions, !0);
}, i_ = A(A({}, Zd), { message: void 0, translationTargetLanguages: void 0, pollId: void 0 }), s_ = function(t) {
  return Xd(t) && O("string", t.message, !0) && tt("string", t.translationTargetLanguages, !0) && O("number", t.pollId, !0);
}, Cb = A({}, Zd), Tb = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.channelType, s = e.token, a = e.limit, o = t.call(this) || this;
    return o.method = Y.GET, o.path = "".concat(gt(i), "/").concat(encodeURIComponent(r), "/operators"), o.params = { token: s, limit: a }, o;
  }
  return S(n, t), n;
}($), wb = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.operators = r.operators.map(function(s) {
      return new pt(e, s);
    }), i.token = r.next, i;
  }
  return S(n, t), n;
}(ne), Sb = function(t) {
  function n(e, r, i, s) {
    return t.call(this, e, r, i, s) || this;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this);
  }, n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : (e = [], this._hasNext ? (this._isLoading = !0, r = k.of(this._iid).requestQueue, i = new Tb(A(A({}, this), { channelUrl: this.channelUrl, token: this._token })), [4, r.send(i)]) : [3, 2]) : [3, 5];
          case 1:
            return s = c.sent(), a = s.as(wb), o = a.operators, l = a.token, this._token = l, this._hasNext = !!l, this._isLoading = !1, [2, o];
          case 2:
            return [2, e];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(Hi), Nb = function(t) {
  function n(e, r, i, s) {
    var a, o, l, c, u, d, h, p, f, m, v = this;
    return (v = t.call(this, e, r, i, s) || this).reverse = !1, v.messageTypeFilter = Pn.ALL, v.customTypesFilter = null, v.senderUserIdsFilter = null, v.replyType = Fn.NONE, v.includeMetaArray = !1, v.includeReactions = !1, v.includeParentMessageInfo = !1, v.includeThreadInfo = !1, v.showSubchannelMessagesOnly = !1, v._edge = Number.MAX_SAFE_INTEGER, v.reverse = (a = s.reverse) !== null && a !== void 0 && a, v.messageTypeFilter = (o = s.messageTypeFilter) !== null && o !== void 0 ? o : Pn.ALL, v.customTypesFilter = (l = s.customTypesFilter) !== null && l !== void 0 ? l : null, v.senderUserIdsFilter = (c = s.senderUserIdsFilter) !== null && c !== void 0 ? c : null, v.replyType = (u = s.replyType) !== null && u !== void 0 ? u : Fn.NONE, v.includeMetaArray = (d = s.includeMetaArray) !== null && d !== void 0 && d, v.includeReactions = (h = s.includeReactions) !== null && h !== void 0 && h, v.includeParentMessageInfo = (p = s.includeParentMessageInfo) !== null && p !== void 0 && p, v.includeThreadInfo = (f = s.includeThreadInfo) !== null && f !== void 0 && f, v.showSubchannelMessagesOnly = (m = s.showSubchannelMessagesOnly) !== null && m !== void 0 && m, v;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this) && O("boolean", this.reverse) && Ze(Pn, this.messageTypeFilter) && Ze(Fn, this.replyType) && tt("string", this.customTypesFilter, !0) && tt("string", this.senderUserIdsFilter, !0) && O("boolean", this.includeMetaArray) && O("boolean", this.includeReactions) && O("boolean", this.includeParentMessageInfo) && O("boolean", this.includeThreadInfo) && O("boolean", this.showSubchannelMessagesOnly);
  }, n.prototype.load = function() {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, [4, bn.of(this._iid).getMessagesByTimestamp(this.channelUrl, this.channelType, this._edge, Ae({ prevResultSize: this.limit, nextResultSize: 0, isInclusive: !1, reverse: this.reverse, messageTypeFilter: this.messageTypeFilter, customTypesFilter: this.customTypesFilter, replyType: this.replyType, senderUserIdsFilter: this.senderUserIdsFilter, includeReactions: this.includeReactions, includeMetaArray: this.includeMetaArray, includeParentMessageInfo: this.includeParentMessageInfo, includeThreadInfo: this.includeThreadInfo, showSubchannelMessagesOnly: this.showSubchannelMessagesOnly }))]) : [3, 2] : [3, 5];
          case 1:
            return e = r.sent(), this._edge = Math.min.apply(Math, Re([Number.MAX_SAFE_INTEGER], we(e.map(function(i) {
              return i.createdAt;
            })), !1)), this._hasNext = e.length >= this.limit, this._isLoading = !1, [2, e];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(Hi), Ib = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.limit, o = e.token;
    return (r = t.call(this) || this).method = Y.GET, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/mute"), r.params = { limit: a, token: o }, r;
  }
  return S(n, t), n;
}($), Ab = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    i.mutedUsers = [];
    var s = r.next, a = r.muted_list;
    return i.token = s, a && a.length > 0 && (i.mutedUsers = a.map(function(o) {
      return new Zs(e, o);
    })), i;
  }
  return S(n, t), n;
}(ne), Mb = function(t) {
  function n(e, r, i, s) {
    return t.call(this, e, r, i, s) || this;
  }
  return S(n, t), n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = k.of(this._iid).requestQueue, r = new Ib(A(A({}, this), { token: this._token })), [4, e.send(r)]) : [3, 2] : [3, 5];
          case 1:
            return i = l.sent(), s = i.as(Ab), a = s.mutedUsers, o = s.token, this._token = o, this._hasNext = !!o, this._isLoading = !1, [2, a];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(Hi), xb = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.limit, o = e.token;
    return (r = t.call(this) || this).method = Y.GET, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/ban"), r.params = fe({ limit: a, token: o }), r;
  }
  return S(n, t), n;
}($), kb = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    i.bannedUsers = [];
    var s = r.next, a = r.banned_list;
    return i.token = s, a && a.length > 0 && (i.bannedUsers = a.map(function(o) {
      return new Zs(e, o.user);
    })), i;
  }
  return S(n, t), n;
}(ne), Ob = function(t) {
  function n(e, r, i, s) {
    return t.call(this, e, r, i, s) || this;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this);
  }, n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = k.of(this._iid).requestQueue, r = new xb(A(A({}, this), { token: this._token })), [4, e.send(r)]) : [3, 2] : [3, 5];
          case 1:
            return i = l.sent(), s = i.as(kb), a = s.bannedUsers, o = s.token, this._token = o, this._hasNext = !!o, this._isLoading = !1, [2, a];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(Hi);
(function(t) {
  t.SPAM = "spam", t.HARASSING = "harassing", t.SUSPICIOUS = "suspicious", t.INAPPROPRIATE = "inappropriate";
})(ho || (ho = {}));
var Rb = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.operatorUserIds;
    return (r = t.call(this) || this).method = Y.POST, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/operators"), r.params = { operator_ids: a }, r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var Db = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.operatorUserIds;
    return (r = t.call(this) || this).method = Y.DELETE, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/operators"), r.params = { operator_ids: a }, r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    return t.call(this, n, e) || this;
  }, t);
})(ne);
var Lb = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.userId;
    return (r = t.call(this) || this).method = Y.GET, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/mute/").concat(a), r;
  }
  return S(n, t), n;
}($), Ub = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    i.isMuted = !1, i.startAt = 0, i.endAt = 0;
    var s = r.is_muted, a = r.start_at, o = r.end_at, l = r.remaining_duration, c = r.description;
    return i.isMuted = s, i.startAt = a, i.endAt = o, i.remainingDuration = l, i.description = c, i;
  }
  return S(n, t), n;
}(ne), Hp = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.keys;
    return (r = t.call(this) || this).method = Y.GET, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/metadata"), r.params = { keys: a, include_ts: !0 }, r;
  }
  return S(n, t), n;
}($), Bp = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this, s = r.metadata, a = r.ts;
    return i.metadata = s, i.ts = a, i;
  }
  return S(n, t), n;
}(ne), Pb = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.metadata;
    return (r = t.call(this) || this).method = Y.POST, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/metadata"), r.params = { metadata: a, include_ts: !0 }, r;
  }
  return S(n, t), n;
}($), Fb = function(t) {
  function n(e, r) {
    var i, s, a = this;
    return (a = t.call(this, e, r) || this).metaData = (i = r.metadata) !== null && i !== void 0 ? i : {}, a.ts = (s = r.ts) !== null && s !== void 0 ? s : null, a;
  }
  return S(n, t), n;
}(ne), jb = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.metadata, o = e.upsert;
    return (r = t.call(this) || this).method = Y.PUT, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/metadata"), r.params = { metadata: a, include_ts: !0, upsert: o != null && o }, r;
  }
  return S(n, t), n;
}($), Hb = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this, s = r.metadata, a = r.ts;
    return i.metadata = s, i.ts = a, i;
  }
  return S(n, t), n;
}(ne), Bb = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "SYEV", i) || this;
    return i.data && (s.created = i.data.created, s.updated = i.data.updated, s.deleted = i.data.deleted), s;
  }
  return S(n, t), n;
}(Lt), zb = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.key;
    return (r = t.call(this) || this).method = Y.DELETE, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/metadata/").concat(a), r.params = { include_ts: !0 }, r;
  }
  return S(n, t), n;
}($), Vb = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this, s = r.ts;
    return i.ts = s, i;
  }
  return S(n, t), n;
}(ne), Gb = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType;
    return (r = t.call(this) || this).method = Y.DELETE, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/metadata"), r.params = { include_ts: !0 }, r;
  }
  return S(n, t), n;
}($), qb = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this, s = r.ts;
    return i.ts = s, i;
  }
  return S(n, t), n;
}(ne), zp = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.keys;
    return (r = t.call(this) || this).method = Y.GET, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/metacounter"), r.params = { keys: a }, r;
  }
  return S(n, t), n;
}($), Vp = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.metaCounter = r, i;
  }
  return S(n, t), n;
}(ne), Kb = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.metaCounter;
    return (r = t.call(this) || this).method = Y.POST, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/metacounter"), r.params = { metacounter: a }, r;
  }
  return S(n, t), n;
}($), Wb = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.metaCounter = r, i;
  }
  return S(n, t), n;
}(ne), hu = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.metaCounter, o = e.upsert, l = o !== void 0 && o, c = e.mode, u = c === void 0 ? "set" : c;
    return (r = t.call(this) || this).method = Y.PUT, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/metacounter"), r.params = { metacounter: a, upsert: l, mode: u }, r;
  }
  return S(n, t), n;
}($), pu = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.metaCounter = r, i;
  }
  return S(n, t), n;
}(ne), Qb = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "SYEV", i) || this;
    return i.data && (s.created = i.data.created, s.updated = i.data.updated, s.deleted = i.data.deleted), s;
  }
  return S(n, t), n;
}(Lt), Yb = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.key;
    return (r = t.call(this) || this).method = Y.DELETE, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/metacounter/").concat(a), r.params = {}, r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    return t.call(this, n, e) || this;
  }, t);
})(ne);
var $b = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType;
    return (r = t.call(this) || this).method = Y.DELETE, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/metacounter"), r.params = {}, r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var Zb = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.userId, o = e.seconds, l = e.description;
    return (r = t.call(this) || this).method = Y.POST, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/mute"), r.params = { user_id: a, seconds: o, description: l }, r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    return t.call(this, n, e) || this;
  }, t);
})(ne);
var Xb = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "SYEV", i) || this;
    return s.user = new Zs(e, i.data), s;
  }
  return S(n, t), n;
}(Lt), Jb = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.userId;
    return (r = t.call(this) || this).method = Y.DELETE, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/mute/").concat(encodeURIComponent(a)), r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var eE = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "SYEV", i) || this;
    return s.user = new Zs(e, i.data), s;
  }
  return S(n, t), n;
}(Lt), tE = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.userId, o = e.seconds, l = e.description;
    return (r = t.call(this) || this).method = Y.POST, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/ban"), r.params = fe({ user_id: a, seconds: o, description: l }), r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var nE = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "SYEV", i) || this;
    return s.user = new Zs(e, i.data), i.data.member_count && (s.memberCount = i.data.member_count), i.data.joined_member_count && (s.joinedMemberCount = i.data.joined_member_count), s;
  }
  return S(n, t), n;
}(Lt), rE = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.userId;
    return (r = t.call(this) || this).method = Y.DELETE, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/ban/").concat(encodeURIComponent(a)), r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var iE = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "SYEV", i) || this;
    return s.user = new Zs(e, i.data), s;
  }
  return S(n, t), n;
}(Lt), Gp = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.freezing;
    return (r = t.call(this) || this).method = Y.PUT, r.path = "".concat(gt(s), "/").concat(encodeURIComponent(i), "/freeze"), r.params = { freeze: a }, r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var sE = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "SYEV", i) || this;
    return s.freeze = i.data.freeze, s;
  }
  return S(n, t), n;
}(Lt), aE = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.category, o = e.userId, l = e.description;
    return (r = t.call(this) || this).method = Y.POST, r.path = "".concat(im(s), "/").concat(encodeURIComponent(i)), r.params = { report_category: a, reporting_user_id: o, report_description: l }, r;
  }
  return S(n, t), n;
}($), oE = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.category, o = e.userId, l = e.offendingUserId, c = e.description;
    return (r = t.call(this) || this).method = Y.POST, r.path = "".concat($u, "/users/").concat(l), r.params = { channel_url: i, channel_type: s === yt.OPEN ? "open_channels" : "group_channels", report_category: a, reporting_user_id: o, report_description: c }, r;
  }
  return S(n, t), n;
}($), lE = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.channelType, a = e.category, o = e.userId, l = e.offendingUserId, c = e.messageId, u = e.description, d = e.messageToken;
    return (r = t.call(this) || this).method = Y.POST, r.path = "".concat(im(s), "/").concat(encodeURIComponent(i), "/messages/").concat(c), r.params = fe({ report_category: a, reporting_user_id: o, report_description: u, offending_user_id: l, mesg_token: d }), r;
  }
  return S(n, t), n;
}($), cE = function(t) {
  function n(e) {
    var r = [];
    return e.mentionType === jn.USERS && (e.mentionedUserIds ? r = e.mentionedUserIds : e.mentionedUsers && (r = e.mentionedUsers.map(function(i) {
      return i.userId;
    }))), t.call(this, { code: "MESG", ackRequired: !0, payload: fe(Ae({ channel_url: e.channelUrl, message: e.message, data: e.data, custom_type: e.customType, metaarray: e.metaArrays, mention_type: e.mentionType, mentioned_user_ids: r, mentioned_message_template: e.mentionedMessageTemplate, target_langs: e.translationTargetLanguages, push_option: e.pushNotificationDeliveryOption && e.pushNotificationDeliveryOption !== Yr.DEFAULT ? e.pushNotificationDeliveryOption : void 0, apple_critical_alert_options: e.appleCriticalAlertOptions, silent: e.silent, reply_to_channel: e.isReplyToChannel, parent_message_id: e.parentMessageId ? e.parentMessageId : null, req_id: e.reqId, poll_id: e.pollId, pin_message: e.isPinnedMessage, extended_message_payload: e.extendedMessagePayload })) }) || this;
  }
  return S(n, t), n;
}(Zn), a_ = function(t) {
  function n(e, r, i) {
    var s, a, o, l, c = this;
    (c = t.call(this, e, "MESG", i) || this).message = new Ln(e, i);
    var u = k.of(e).sdkState;
    return c.isMentioned = pa(c.message.mentionType, (o = (s = c.message.mentionedUserIds) !== null && s !== void 0 ? s : (a = c.message.mentionedUsers) === null || a === void 0 ? void 0 : a.map(function(d) {
      return d.userId;
    })) !== null && o !== void 0 ? o : [], u.userId), c.forceUpdateLastMessage = (l = i.force_update_last_message) !== null && l !== void 0 && l, c;
  }
  return S(n, t), n;
}(Lt), qp = function(t) {
  function n(e) {
    var r = null;
    return e.mentionType === jn.USERS && (e.mentionedUserIds ? r = e.mentionedUserIds : e.mentionedUsers && (r = e.mentionedUsers.map(function(i) {
      return i.userId;
    }))), t.call(this, { code: "MEDI", ackRequired: !0, payload: fe(Ae({ channel_url: e.channelUrl, msg_id: e.messageId, message: e.message, data: e.data, custom_type: e.customType, metaarray: e.metaArrayParams, mention_type: e.mentionType, mentioned_user_ids: r, mentioned_message_template: e.mentionedMessageTemplate, apple_critical_alert_options: e.appleCriticalAlertOptions ? Fr.payloadify(e.appleCriticalAlertOptions) : null, poll_id: e.pollId })) }) || this;
  }
  return S(n, t), n;
}(Zn), ud = function(t) {
  function n(e, r, i) {
    var s, a, o, l, c, u = this;
    (u = t.call(this, e, "MEDI", i) || this).message = new Ln(e, i);
    var d = k.of(e).sdkState;
    return u.mentionCountChange = jd({ mentionType: (s = i.old_values) === null || s === void 0 ? void 0 : s.mention_type, mentionedUserIds: (o = (a = i.old_values) === null || a === void 0 ? void 0 : a.mentioned_user_ids) !== null && o !== void 0 ? o : [] }, Ae({ mentionType: u.message.mentionType, mentionedUserIds: (l = u.message.mentionedUserIds) !== null && l !== void 0 ? l : (c = u.message.mentionedUsers) === null || c === void 0 ? void 0 : c.map(function(h) {
      return h.userId;
    }) }), d.userId), u;
  }
  return S(n, t), n;
}(Lt), Kp = function(t) {
  function n(e) {
    var r = null;
    return e.mentionType === jn.USERS && (e.mentionedUserIds ? r = e.mentionedUserIds : e.mentionedUsers && (r = e.mentionedUsers.map(function(i) {
      return i.userId;
    }))), t.call(this, { code: "FEDI", ackRequired: !0, payload: fe(Ae({ channel_url: e.channelUrl, msg_id: e.messageId, data: e.data, custom_type: e.customType, metaarray: e.metaArrayParams, mention_type: e.mentionType, mentioned_user_ids: r, apple_critical_alert_options: e.appleCriticalAlertOptions })) }) || this;
  }
  return S(n, t), n;
}(Zn), dd = function(t) {
  function n(e, r, i) {
    var s, a, o, l, c, u = this;
    (u = t.call(this, e, "FEDI", i) || this).message = new ln(e, i);
    var d = k.of(e).sdkState;
    return u.mentionCountChange = jd({ mentionType: (s = i.old_values) === null || s === void 0 ? void 0 : s.mention_type, mentionedUserIds: (o = (a = i.old_values) === null || a === void 0 ? void 0 : a.mentioned_user_ids) !== null && o !== void 0 ? o : [] }, Ae({ mentionType: u.message.mentionType, mentionedUserIds: (l = u.message.mentionedUserIds) !== null && l !== void 0 ? l : (c = u.message.mentionedUsers) === null || c === void 0 ? void 0 : c.map(function(h) {
      return h.userId;
    }) }), d.userId), u;
  }
  return S(n, t), n;
}(Lt), uE = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.messageId, a = e.reactionKey, o = t.call(this) || this;
    return o.method = Y.POST, o.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages/").concat(s, "/reactions"), o.params = { reaction: a }, o;
  }
  return S(n, t), n;
}($), dE = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.reactionEvent = new $d(r), i;
  }
  return S(n, t), n;
}(ne), hE = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.messageId, a = e.reactionKey, o = t.call(this) || this;
    return o.method = Y.DELETE, o.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages/").concat(s, "/reactions"), o.params = { reaction: a }, o;
  }
  return S(n, t), n;
}($), pE = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.reactionEvent = new $d(A({}, r)), i;
  }
  return S(n, t), n;
}(ne), fE = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.messageId, a = e.translationTargetLanguages, o = t.call(this) || this;
    return o.method = Y.POST, o.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages/").concat(encodeURIComponent(s), "/translation"), o.params = { target_langs: a }, o;
  }
  return S(n, t), n;
}($), mE = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.message = new Ln(e, r), i;
  }
  return S(n, t), n;
}(ne), _E = function(t) {
  function n(e) {
    var r, i = this;
    i = t.call(this) || this;
    var s = [];
    e.mentionType === jn.USERS && (e.mentionedUserIds ? s = e.mentionedUserIds : e.mentionedUsers && (s = e.mentionedUsers.map(function(l) {
      return l.userId;
    })));
    var a = e.channelType, o = e.channelUrl;
    return i.method = Y.POST, i.path = "".concat(gt(a), "/").concat(encodeURIComponent(o), "/scheduled_messages"), i.params = fe(Ae({ req_id: e.reqId, scheduled_at: e.scheduledAt, message_type: ha.USER, message: e.message, custom_type: e.customType, data: e.data, mention_type: e.mentionType, mentioned_user_ids: s, sorted_metaarray: (r = e.metaArrays) === null || r === void 0 ? void 0 : r.map(function(l) {
      return Yn.payloadify(l);
    }), apple_critical_alert_options: e.appleCriticalAlertOptions ? Fr.payloadify(e.appleCriticalAlertOptions) : null, target_langs: e.translationTargetLanguages, push_option: e.pushNotificationDeliveryOption })), i;
  }
  return S(n, t), n;
}($), o_ = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.message = new Ln(e, r), i;
  }
  return S(n, t), n;
}(ne), gE = function(t) {
  function n(e) {
    var r, i, s = this;
    s = t.call(this) || this;
    var a = [];
    e.mentionType === jn.USERS && (e.mentionedUserIds ? a = e.mentionedUserIds : e.mentionedUsers && (a = e.mentionedUsers.map(function(c) {
      return c.userId;
    })));
    var o = e.channelType, l = e.channelUrl;
    return s.method = Y.POST, s.path = "".concat(gt(o), "/").concat(encodeURIComponent(l), "/scheduled_messages"), s.params = Ae({ req_id: e.reqId, scheduled_at: e.scheduledAt, message_type: ha.FILE, url: e.fileUrl, file_name: e.fileName, file_size: e.fileSize, file_type: e.mimeType, thumbnails: (r = e._thumbnails) === null || r === void 0 ? void 0 : r.map(function(c) {
      return Bi.payloadify(c);
    }), custom_type: e.customType, data: e.data, require_auth: e.requireAuth, mention_type: e.mentionType, mentioned_user_ids: a, sorted_metaarray: (i = e.metaArrays) === null || i === void 0 ? void 0 : i.map(function(c) {
      return Yn.payloadify(c);
    }), apple_critical_alert_options: e.appleCriticalAlertOptions ? Fr.payloadify(e.appleCriticalAlertOptions) : null, push_option: e.pushNotificationDeliveryOption }), s;
  }
  return S(n, t), n;
}($), vE = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.message = new ln(e, r), i;
  }
  return S(n, t), n;
}(ne), yE = function(t) {
  function n(e) {
    var r = e.pollId, i = e.title, s = e.data, a = e.allowUserSuggestion, o = e.allowMultipleVotes, l = e.closeAt, c = t.call(this) || this;
    return c.method = Y.PUT, c.path = "".concat(Zr, "/").concat(encodeURIComponent(r)), c.params = { title: i, data: s, allow_user_suggestion: a, allow_multiple_votes: o, close_at: l }, c;
  }
  return S(n, t), n;
}($), bE = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.poll = new Pr(e, r), i;
  }
  return S(n, t), n;
}(ne), EE = function(t) {
  function n(e) {
    var r = e.pollId, i = t.call(this) || this;
    return i.method = Y.DELETE, i.path = "".concat(Zr, "/").concat(encodeURIComponent(r)), i;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var CE = function(t) {
  function n(e) {
    var r = e.pollId, i = t.call(this) || this;
    return i.method = Y.PUT, i.path = "".concat(Zr, "/").concat(encodeURIComponent(r), "/close"), i;
  }
  return S(n, t), n;
}($), TE = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.poll = new Pr(e, r), i;
  }
  return S(n, t), n;
}(ne), wE = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.channelType, s = e.pollId, a = e.optionText, o = t.call(this) || this;
    return o.method = Y.POST, o.path = "".concat(Zr, "/").concat(encodeURIComponent(s), "/options"), o.params = { channel_url: r, channel_type: i, text: a }, o;
  }
  return S(n, t), n;
}($), SE = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.poll = new Pr(e, r), i;
  }
  return S(n, t), n;
}(ne), NE = function(t) {
  function n(e) {
    var r = e.pollId, i = e.pollOptionId, s = e.optionText, a = t.call(this) || this;
    return a.method = Y.PUT, a.path = "".concat(Zr, "/").concat(encodeURIComponent(r), "/options/").concat(encodeURIComponent(i)), a.params = { text: s }, a;
  }
  return S(n, t), n;
}($), IE = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.poll = new Pr(e, r), i;
  }
  return S(n, t), n;
}(ne), AE = function(t) {
  function n(e) {
    var r = e.pollId, i = e.pollOptionId, s = t.call(this) || this;
    return s.method = Y.DELETE, s.path = "".concat(Zr, "/").concat(encodeURIComponent(r), "/options/").concat(encodeURIComponent(i)), s;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var ME = function(t) {
  function n(e) {
    var r = e.reqId, i = e.channelType, s = e.channelUrl, a = e.pollId, o = e.pollOptionIds;
    return t.call(this, { code: "VOTE", ackRequired: !0, payload: fe({ req_id: r, channel_type: i === yt.OPEN ? "open_channels" : "group_channels", channel_url: s, poll_id: a, option_ids: o }) }) || this;
  }
  return S(n, t), n;
}(Zn), l_ = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "VOTE", i) || this;
    return s.event = new B1(i), s.channelUrl = i.channel_url, s.channelType = i.channel_type, s;
  }
  return S(n, t), n;
}(Lt), c_ = "GroupChannel", hd = "Message", u_ = "NotificationMessage", xE = A(A({}, Tc), { fileInfoList: [], message: "" }), Nl = function(t) {
  function n() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e._onFileUploaded = rt, e;
  }
  return S(n, t), n.prototype._triggerOnFileUploaded = function(e, r, i, s) {
    this._onFileUploaded(e, r, i, s);
  }, n.prototype.onFileUploaded = function(e) {
    return this._onFileUploaded = e, this;
  }, n.prototype.onPending = function(e) {
    return t.prototype.onPending.call(this, e), this;
  }, n.prototype.onFailed = function(e) {
    return t.prototype.onFailed.call(this, e), this;
  }, n.prototype.onSucceeded = function(e) {
    return t.prototype.onSucceeded.call(this, e), this;
  }, n;
}(cr), kE = function(t) {
  function n(e, r) {
    var i = t.call(this, e) || this;
    return i.message = null, i.message = Kn(e, r.message), i;
  }
  return S(n, t), n;
}(xn), OE = function(t) {
  function n(e) {
    var r = this, i = e.channelType, s = e.channelUrl, a = e.limit, o = e.token, l = e.includeReactions, c = e.includeMetaArray, u = e.includeParentMessageInfo, d = e.includeThreadInfo, h = e.includePollDetails;
    return (r = t.call(this) || this).method = Y.GET, r.path = "".concat(gt(i), "/").concat(encodeURIComponent(s), "/pinned_messages"), r.params = fe({ limit: a, token: o, include_reactions: l, with_sorted_meta_array: c, include_thread_info: d, include_parent_message_info: u, include_poll_details: h }), r;
  }
  return S(n, t), n;
}($), RE = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this, s = r.pinned_messages, a = r.has_more, o = r.next;
    return i.pinnedMessages = s.map(function(l) {
      return new kE(e, l);
    }), i.hasMore = a, i.token = o, i;
  }
  return S(n, t), n;
}(ne), DE = function(t) {
  function n(e, r, i, s) {
    var a = t.call(this, e, r, i, s) || this;
    return a.includeMetaArray = s.includeMetaArray, a.includeReactions = s.includeReactions, a.includeParentMessageInfo = s.includeParentMessageInfo, a.includeThreadInfo = s.includeThreadInfo, a.includePollDetails = s.includePollDetails, a;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this) && O("boolean", this.includeMetaArray, !0) && O("boolean", this.includeReactions, !0) && O("boolean", this.includeParentMessageInfo, !0) && O("boolean", this.includeThreadInfo, !0) && O("boolean", this.includePollDetails, !0);
  }, n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = k.of(this._iid).requestQueue, r = new OE(A(A({}, this), { token: this._token })), [4, e.send(r)]) : [3, 2] : [3, 5];
          case 1:
            return i = c.sent(), s = i.as(RE), a = s.pinnedMessages, o = s.hasMore, l = s.token, this._token = l, this._hasNext = !!o, this._isLoading = !1, [2, a];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(Hi), LE = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.messageId, a = t.call(this) || this;
    return a.method = Y.POST, a.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages/").concat(s, "/pin"), a;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    return t.call(this, n, e) || this;
  }, t);
})(ne);
var UE = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.messageId, a = t.call(this) || this;
    return a.method = Y.DELETE, a.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages/").concat(s, "/pin"), a;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    return t.call(this, n, e) || this;
  }, t);
})(ne);
var Rn;
(function(t) {
  t.SEND = "send", t.RESEND = "resend", t.COPY = "copy";
})(Rn || (Rn = {}));
var Bt, Wp = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d = this;
    return (d = t.call(this, e) || this)._name = "", d._createdAt = 0, d.pinnedMessageIds = [], d.channelType = yt.BASE, d.coverUrl = "", d.customType = "", d.data = "", d.isFrozen = !1, d.isEphemeral = !1, d.creator = null, d._messageCollectionLastAccessedAt = 0, d._url = r.channel_url, d._name = (i = r.name) !== null && i !== void 0 ? i : "", d._createdAt = 1e3 * r.created_at, d.coverUrl = (s = r.cover_url) !== null && s !== void 0 ? s : "", d.customType = (a = r.custom_type) !== null && a !== void 0 ? a : "", d.data = (o = r.data) !== null && o !== void 0 ? o : "", d.isFrozen = (l = r.freeze) !== null && l !== void 0 && l, d.isEphemeral = (c = r.is_ephemeral) !== null && c !== void 0 && c, d.creator = r.created_by ? new pt(d._iid, r.created_by) : null, r.metadata && Object.keys(r.metadata).length > 0 && r.ts ? (d._cachedMetaData = /* @__PURE__ */ new Map(), Object.keys(r.metadata).forEach(function(h) {
      d._cachedMetaData.set(h, { value: r.metadata[h], isRemoved: !1, updatedAt: r.ts });
    })) : typeof r.metadata == "string" && (d._cachedMetaData = new Map(Object.entries(JSON.parse(r.metadata)))), d.pinnedMessageIds = (u = r.pinned_message_ids) !== null && u !== void 0 ? u : [], d;
  }
  return S(n, t), Object.defineProperty(n.prototype, "url", { get: function() {
    return this._url;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "name", { get: function() {
    return this._name;
  }, set: function(e) {
    this._name = e;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "createdAt", { get: function() {
    return this._createdAt;
  }, enumerable: !1, configurable: !0 }), n.prototype.toJSON = function() {
    return A(A({}, this), { url: this._url, name: this._name, createdAt: this._createdAt });
  }, n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { channel_url: e.url, name: e.name, cover_url: e.coverUrl, custom_type: e.customType, data: e.data, freeze: e.isFrozen, is_ephemeral: e.isEphemeral, created_by: e.creator ? pt.payloadify(e.creator) : null, created_at: e.createdAt / 1e3, metadata: e.cachedMetaData, pinned_message_ids: e.pinnedMessageIds })));
  }, n.prototype.isGroupChannel = function() {
    return this.channelType === yt.GROUP;
  }, n.prototype.isOpenChannel = function() {
    return this.channelType === yt.OPEN;
  }, n.prototype.isFeedChannel = function() {
    return this.channelType === yt.FEED;
  }, Object.defineProperty(n.prototype, "cachedMetaData", { get: function() {
    var e = {};
    return this._cachedMetaData && this._cachedMetaData.forEach(function(r, i) {
      r.isRemoved || (e[i] = r.value);
    }), e;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "messageCollectionLastAccessedAt", { get: function() {
    return this._messageCollectionLastAccessedAt;
  }, enumerable: !1, configurable: !0 }), n.prototype._serializeCachedMetaData = function() {
    return this._cachedMetaData ? { cachedMetaData: JSON.stringify(Object.fromEntries(this._cachedMetaData)) } : {};
  }, n.prototype._updateMessageCollectionLastAccessedAt = function() {
    this._messageCollectionLastAccessedAt = Date.now();
  }, n.prototype._update = function(e) {
    var r = fe(e);
    Object.assign(this, r);
  }, n.prototype._upsertCachedMetaData = function(e, r) {
    var i = this;
    Object.keys(e).forEach(function(s) {
      i._cachedMetaData || (i._cachedMetaData = /* @__PURE__ */ new Map());
      var a = i._cachedMetaData.get(s);
      (!a || a.updatedAt <= r) && i._cachedMetaData.set(s, { value: e[s], isRemoved: !1, updatedAt: r });
    });
  }, n.prototype._updateCachedMetaData = function(e, r) {
    var i = this, s = !1;
    return this._cachedMetaData ? this._cachedMetaData.forEach(function(a, o) {
      var l;
      a.updatedAt <= r && (i._cachedMetaData.set(o, { value: (l = e[o]) !== null && l !== void 0 ? l : a.value, isRemoved: !e[o], updatedAt: r }), s = !0);
    }) : (this._cachedMetaData = /* @__PURE__ */ new Map(), Object.keys(e).forEach(function(a) {
      i._cachedMetaData.set(a, { value: e[a], isRemoved: !1, updatedAt: r });
    }), s = !0), { isUpdated: s };
  }, n.prototype._removeFromCachedMetaData = function(e, r) {
    var i = this;
    this._cachedMetaData && e.forEach(function(s) {
      var a = i._cachedMetaData.get(s);
      a && a.updatedAt < r && (a.isRemoved = !0, a.updatedAt = r);
    });
  }, n.prototype._clearCachedMetaData = function() {
    this._cachedMetaData && this._cachedMetaData.clear();
  }, n.prototype._runIfHandleableWithGroupChannel = function(e) {
    this.isGroupChannel() ? e(this) : this.isFeedChannel() && e(this.groupChannel);
  }, n.prototype._generateRequestId = function() {
    return "rq-".concat(Pi());
  }, n.prototype.isIdentical = function(e) {
    return e && this.url === e.url;
  }, n.prototype.isEqual = function(e) {
    return Z0(this, e);
  }, n.prototype.createOperatorListQuery = function(e) {
    return e === void 0 && (e = {}), new Sb(this._iid, this.url, this.channelType, e);
  }, n.prototype.createMutedUserListQuery = function(e) {
    return e === void 0 && (e = {}), new Mb(this._iid, this.url, this.channelType, e);
  }, n.prototype.createBannedUserListQuery = function(e) {
    return e === void 0 && (e = {}), new Ob(this._iid, this.url, this.channelType, e);
  }, n.prototype.createPreviousMessageListQuery = function(e) {
    return e === void 0 && (e = {}), new Nb(this._iid, this.url, this.channelType, e);
  }, n.prototype.createPinnedMessageListQuery = function(e) {
    return e === void 0 && (e = {}), new DE(this._iid, this.url, this.channelType, e);
  }, n.prototype.addOperators = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return Z(tt("string", e)).throw(D.invalidParameters), r = k.of(this._iid).requestQueue, i = new Rb({ channelUrl: this.url, channelType: this.channelType, operatorUserIds: e }), [4, r.send(i)];
          case 1:
            return s.sent(), [2];
        }
      });
    });
  }, n.prototype.removeOperators = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return Z(tt("string", e)).throw(D.invalidParameters), r = k.of(this._iid).requestQueue, i = new Db({ channelUrl: this.url, channelType: this.channelType, operatorUserIds: e }), [4, r.send(i)];
          case 1:
            return s.sent(), [2];
        }
      });
    });
  }, n.prototype.getMyMutedInfo = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c, u, d, h;
      return _(this, function(p) {
        switch (p.label) {
          case 0:
            return e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new Lb({ channelUrl: this.url, channelType: this.channelType, userId: r.userId }), [4, i.send(s)];
          case 1:
            return a = p.sent(), o = a.as(Ub), l = o.isMuted, c = o.startAt, u = o.endAt, d = o.remainingDuration, h = o.description, [2, { isMuted: l, startAt: c, endAt: u, remainingDuration: d, description: h }];
        }
      });
    });
  }, n.prototype.getMetaData = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return Z(tt("string", e)).throw(D.invalidParameters), r = k.of(this._iid).requestQueue, i = new Hp({ channelUrl: this.url, channelType: this.channelType, keys: e }), [4, r.send(i)];
          case 1:
            return s = c.sent(), a = s.as(Bp), o = a.metadata, l = a.ts, this._upsertCachedMetaData(o, l), [2, o];
        }
      });
    });
  }, n.prototype.getAllMetaData = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return e = k.of(this._iid).requestQueue, r = new Hp({ channelUrl: this.url, channelType: this.channelType, keys: [] }), [4, e.send(r)];
          case 1:
            return i = l.sent(), s = i.as(Bp), a = s.metadata, o = s.ts, this._updateCachedMetaData(a, o), [2, a];
        }
      });
    });
  }, n.prototype.createMetaData = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return r = k.of(this._iid).requestQueue, i = new Pb({ channelUrl: this.url, channelType: this.channelType, metadata: e }), [4, r.send(i)];
          case 1:
            return s = o.sent(), a = s.as(Fb).metaData, this._upsertCachedMetaData(a, 0), [2, a];
        }
      });
    });
  }, n.prototype.updateMetaData = function(e, r) {
    return r === void 0 && (r = !1), g(this, 0, void 0, function() {
      var i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return i = k.of(this._iid).requestQueue, s = new jb({ channelUrl: this.url, channelType: this.channelType, metadata: e, upsert: r }), [4, i.send(s)];
          case 1:
            return a = u.sent(), o = a.as(Hb), l = o.metadata, c = o.ts, this._upsertCachedMetaData(l, c), [2, l];
        }
      });
    });
  }, n.prototype.deleteMetaData = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return Z(O("string", e)).throw(D.invalidParameters), r = k.of(this._iid).requestQueue, i = new zb({ channelUrl: this.url, channelType: this.channelType, key: e }), [4, r.send(i)];
          case 1:
            return s = o.sent(), a = s.as(Vb).ts, this._removeFromCachedMetaData([e], a), [2];
        }
      });
    });
  }, n.prototype.deleteAllMetaData = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return e = k.of(this._iid).requestQueue, r = new Gb({ channelUrl: this.url, channelType: this.channelType }), [4, e.send(r)];
          case 1:
            return i = a.sent(), s = i.as(qb).ts, this._removeFromCachedMetaData(Re([], we(this._cachedMetaData.keys()), !1), s), [2];
        }
      });
    });
  }, n.prototype.getMetaCounters = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return Z(tt("string", e)).throw(D.invalidParameters), r = k.of(this._iid).requestQueue, i = new zp({ channelUrl: this.url, channelType: this.channelType, keys: e }), [4, r.send(i)];
          case 1:
            return [2, s.sent().as(Vp).metaCounter];
        }
      });
    });
  }, n.prototype.getAllMetaCounters = function() {
    return g(this, 0, void 0, function() {
      var e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return e = k.of(this._iid).requestQueue, r = new zp({ channelUrl: this.url, channelType: this.channelType, keys: [] }), [4, e.send(r)];
          case 1:
            return [2, i.sent().as(Vp).metaCounter];
        }
      });
    });
  }, n.prototype.createMetaCounters = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return r = k.of(this._iid).requestQueue, i = new Kb({ channelUrl: this.url, channelType: this.channelType, metaCounter: e }), [4, r.send(i)];
          case 1:
            return [2, s.sent().as(Wb).metaCounter];
        }
      });
    });
  }, n.prototype.updateMetaCounters = function(e, r) {
    return r === void 0 && (r = !1), g(this, 0, void 0, function() {
      var i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return i = k.of(this._iid).requestQueue, s = new hu({ channelUrl: this.url, channelType: this.channelType, metaCounter: e, upsert: r }), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(pu).metaCounter];
        }
      });
    });
  }, n.prototype.increaseMetaCounters = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return r = k.of(this._iid).requestQueue, i = new hu({ channelUrl: this.url, channelType: this.channelType, metaCounter: e, upsert: !1, mode: "increase" }), [4, r.send(i)];
          case 1:
            return [2, s.sent().as(pu).metaCounter];
        }
      });
    });
  }, n.prototype.decreaseMetaCounters = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return r = k.of(this._iid).requestQueue, i = new hu({ channelUrl: this.url, channelType: this.channelType, metaCounter: e, upsert: !1, mode: "decrease" }), [4, r.send(i)];
          case 1:
            return [2, s.sent().as(pu).metaCounter];
        }
      });
    });
  }, n.prototype.deleteMetaCounter = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return Z(O("string", e)).throw(D.invalidParameters), r = k.of(this._iid).requestQueue, i = new Yb({ channelUrl: this.url, channelType: this.channelType, key: e }), [4, r.send(i)];
          case 1:
            return s.sent(), [2];
        }
      });
    });
  }, n.prototype.deleteAllMetaCounters = function() {
    return g(this, 0, void 0, function() {
      var e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return e = k.of(this._iid).requestQueue, r = new $b({ channelUrl: this.url, channelType: this.channelType }), [4, e.send(r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.muteUser = function(e, r, i) {
    return g(this, 0, void 0, function() {
      return _(this, function(s) {
        return [2, this.muteUserWithUserId(e.userId, r, i)];
      });
    });
  }, n.prototype.muteUserWithUserId = function(e, r, i) {
    return g(this, 0, void 0, function() {
      var s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return Z(O("string", e) && O("number", r, !0) && O("string", i, !0)).throw(D.invalidParameters), s = k.of(this._iid).requestQueue, a = new Zb({ channelUrl: this.url, channelType: this.channelType, userId: e, seconds: r, description: i }), [4, s.send(a)];
          case 1:
            return o.sent(), [2];
        }
      });
    });
  }, n.prototype.unmuteUser = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return [2, this.unmuteUserWithUserId(e.userId)];
      });
    });
  }, n.prototype.unmuteUserWithUserId = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return Z(O("string", e)).throw(D.invalidParameters), r = k.of(this._iid).requestQueue, i = new Jb({ channelUrl: this.url, channelType: this.channelType, userId: e }), [4, r.send(i)];
          case 1:
            return s.sent(), [2];
        }
      });
    });
  }, n.prototype.banUser = function(e, r, i) {
    return g(this, 0, void 0, function() {
      return _(this, function(s) {
        return [2, this.banUserWithUserId(e.userId, r, i)];
      });
    });
  }, n.prototype.banUserWithUserId = function(e, r, i) {
    return g(this, 0, void 0, function() {
      var s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return Z(O("string", e) && O("number", r, !0) && O("string", i, !0)).throw(D.invalidParameters), s = k.of(this._iid).requestQueue, a = new tE({ channelUrl: this.url, channelType: this.channelType, userId: e, seconds: r, description: i }), [4, s.send(a)];
          case 1:
            return o.sent(), [2];
        }
      });
    });
  }, n.prototype.unbanUser = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return [2, this.unbanUserWithUserId(e.userId)];
      });
    });
  }, n.prototype.unbanUserWithUserId = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return Z(O("string", e)).throw(D.invalidParameters), r = k.of(this._iid).requestQueue, i = new rE({ channelUrl: this.url, channelType: this.channelType, userId: e }), [4, r.send(i)];
          case 1:
            return s.sent(), [2];
        }
      });
    });
  }, n.prototype.freeze = function() {
    return g(this, 0, void 0, function() {
      var e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return e = k.of(this._iid).requestQueue, r = new Gp({ channelUrl: this.url, channelType: this.channelType, freezing: !0 }), [4, e.send(r)];
          case 1:
            return i.sent(), this.isFrozen = !0, [2];
        }
      });
    });
  }, n.prototype.unfreeze = function() {
    return g(this, 0, void 0, function() {
      var e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return e = k.of(this._iid).requestQueue, r = new Gp({ channelUrl: this.url, channelType: this.channelType, freezing: !1 }), [4, e.send(r)];
          case 1:
            return i.sent(), this.isFrozen = !1, [2];
        }
      });
    });
  }, n.prototype.getMessagesByMessageId = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = A(A({}, uo), r), Z(O("number", e) && Rp(i)).throw(D.invalidParameters), [4, bn.of(this._iid).getMessagesByMessageId(this.url, this.channelType, e, i)];
          case 1:
            return [2, s.sent()];
        }
      });
    });
  }, n.prototype.getMessagesByTimestamp = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = A(A({}, uo), r), Z(O("number", e) && Rp(i)).throw(D.invalidParameters), [4, bn.of(this._iid).getMessagesByTimestamp(this.url, this.channelType, e, i)];
          case 1:
            return [2, s.sent()];
        }
      });
    });
  }, n.prototype.getMessageChangeLogsSinceTimestamp = function(e, r) {
    return r === void 0 && (r = {}), g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = A(A({}, od), r), Z(O("number", e) && Dp(i)).throw(D.invalidParameters), [4, bn.of(this._iid).getMessageChangelogs(this.url, this.channelType, e, i)];
          case 1:
            return [2, s.sent()];
        }
      });
    });
  }, n.prototype.getMessageChangeLogsSinceToken = function(e, r) {
    return r === void 0 && (r = {}), g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = A(A({}, od), r), Z(O("string", e) && Dp(i)).throw(D.invalidParameters), [4, bn.of(this._iid).getMessageChangelogs(this.url, this.channelType, e, i)];
          case 1:
            return [2, s.sent()];
        }
      });
    });
  }, n.prototype._createPendingSendableMessagePayload = function(e, r, i) {
    var s, a = k.of(this._iid).sessionManager;
    return fe(Ae({ channel_url: this.url, channel_type: this.channelType, msg_id: 0, parent_message_id: e.parentMessageId, data: e.data, custom_type: e.customType, mention_type: e.mentionType, sorted_metaarray: e.metaArrays ? e.metaArrays.map(function(o) {
      return Yn.payloadify(o);
    }) : null, apple_critical_alert_options: e.appleCriticalAlertOptions ? Fr.payloadify(e.appleCriticalAlertOptions) : null, created_at: i, user: a.currentUser ? ga.payloadify(a.currentUser) : null, req_id: r, request_state: St.PENDING, mentioned_user_ids: e.mentionedUserIds, mentioned_users: (s = e.mentionedUsers) === null || s === void 0 ? void 0 : s.map(function(o) {
      return pt.payloadify(o);
    }) }));
  }, n.prototype._createPendingUserMessage = function(e, r, i) {
    var s, a, o = {};
    if (e.translationTargetLanguages)
      try {
        for (var l = de(e.translationTargetLanguages), c = l.next(); !c.done; c = l.next())
          o[c.value] = "";
      } catch (h) {
        s = { error: h };
      } finally {
        try {
          c && !c.done && (a = l.return) && a.call(l);
        } finally {
          if (s)
            throw s.error;
        }
      }
    var u = fe(A(A({}, this._createPendingSendableMessagePayload(e, r, i)), { type: Yt.USER, message: e.message, translations: o, extended_message_payload: e.extendedMessagePayload })), d = new Ln(this._iid, u);
    return d.messageParams = e, d;
  }, n.prototype._createPendingScheduledUserMessage = function(e, r, i) {
    var s = this._createPendingUserMessage(e, r, i);
    return s.scheduledInfo = { scheduledMessageId: 0, scheduledAt: e.scheduledAt, scheduledMessageParams: e }, s;
  }, n.prototype._createPendingFileMessage = function(e, r, i) {
    var s, a, o, l, c, u, d, h = fe(A(A({}, this._createPendingSendableMessagePayload(e, r, i)), { type: Yt.FILE, url: e.fileUrl, file: { name: (s = e.fileName) !== null && s !== void 0 ? s : (a = e.file) === null || a === void 0 ? void 0 : a.name, size: (o = e.fileSize) !== null && o !== void 0 ? o : (l = e.file) === null || l === void 0 ? void 0 : l.size, type: (c = e.mimeType) !== null && c !== void 0 ? c : (u = e.file) === null || u === void 0 ? void 0 : u.type, data: e.data }, thumbnails: (d = e._thumbnails) === null || d === void 0 ? void 0 : d.map(function(f) {
      return Bi.payloadify(f);
    }), message: e.message })), p = new ln(this._iid, h);
    return p.messageParams = e, p;
  }, n.prototype._createPendingMultipleFilesMessage = function(e, r, i) {
    var s = fe(A(A({}, this._createPendingSendableMessagePayload(e, r, i)), { type: Yt.FILE, file: e.fileInfoList.length > 0 ? { name: e.fileInfoList[0].fileName, size: e.fileInfoList[0].fileSize, type: e.fileInfoList[0].mimeType, data: e.data } : void 0, message: e.message })), a = new Sr(this._iid, s);
    return a.messageParams = e, a;
  }, n.prototype._validateFailedFileMessageHasFile = function(e, r) {
    var i;
    return !!e.url || qn(r) || qn((i = e.messageParams) === null || i === void 0 ? void 0 : i.file);
  }, n.prototype._createPendingScheduledFileMessage = function(e, r, i) {
    var s = this._createPendingFileMessage(e, r, i);
    return s.scheduledInfo = { scheduledMessageId: 0, scheduledAt: e.scheduledAt, scheduledMessageParams: e }, s;
  }, n.prototype._markMessageAsFailed = function(e, r, i) {
    i === void 0 && (i = !1), e.errorCode = r.code, r.code === me.REQUEST_CANCELED || r.code === me.FILE_UPLOAD_CANCEL_FAILED ? e.sendingStatus = St.CANCELED : i || (e.sendingStatus = St.FAILED);
  }, n.prototype.sendUserMessage = function(e) {
    var r = A(A({}, e_), e);
    return Z(n_(r)).throw(D.invalidParameters), this._sendUserMessage(r);
  }, n.prototype._sendUserMessage = function(e, r, i) {
    var s = this;
    r === void 0 && (r = Rn.SEND);
    var a = k.of(this._iid), o = a.dispatcher, l = a.requestQueue, c = i ?? this._generateRequestId(), u = Date.now(), d = new cr();
    return er(2).then(function() {
      var h = s._createPendingUserMessage(e, c, u);
      o.dispatch(new Pt({ messages: [h], source: r === Rn.RESEND ? B.LOCAL_MESSAGE_RESEND_STARTED : B.EVENT_MESSAGE_SENT_PENDING })), Ue(function() {
        return g(s, 0, void 0, function() {
          return _(this, function(f) {
            return [2, d._trigger(h)];
          });
        });
      });
      var p = new cE(A(A({}, e), { channelUrl: s.url, channelType: s.channelType, reqId: c }));
      l.send(p).then(function(f) {
        var m = f.as(a_).message;
        o.dispatch(new Pt({ messages: [m], source: B.EVENT_MESSAGE_SENT_SUCCESS })), Ue(function() {
          return g(s, 0, void 0, function() {
            return _(this, function(v) {
              return [2, d._trigger(m)];
            });
          });
        });
      }).catch(function(f) {
        if (rr(f))
          throw f;
        er(2).then(function() {
          var m = s._createPendingUserMessage(e, c, u), v = k.of(s._iid).cacheContext, E = v.localCacheEnabled && v.localCacheConfig.enableAutoResend && Hl(f.code);
          s._markMessageAsFailed(m, f, E), o.dispatch(new Pt({ messages: [m], source: m.sendingStatus === St.PENDING ? B.REQUEST_RESEND_MESSAGE : B.EVENT_MESSAGE_SENT_FAILED })), Ue(function() {
            return g(s, 0, void 0, function() {
              return _(this, function(y) {
                return [2, d._triggerFailed(f, m)];
              });
            });
          });
        });
      });
    }), d;
  }, n.prototype._autoResendUserMessage = function(e) {
    return Z(e instanceof Ln && !!e.messageParams).throw(D.invalidParameters), this._sendUserMessage(e.messageParams, Rn.SEND, e.reqId);
  }, n.prototype.resendUserMessage = function(e) {
    var r;
    return g(this, 0, void 0, function() {
      var i, s;
      return _(this, function(a) {
        return Z(e instanceof Ln && !e.scheduledInfo).throw(D.invalidParameters), i = new $n(), s = (r = e.messageParams) !== null && r !== void 0 ? r : ld(e), this._sendUserMessage(s, Rn.RESEND, e.reqId).onFailed(function(o) {
          return i.reject(o);
        }).onSucceeded(function(o) {
          return i.resolve(o);
        }), [2, i.promise];
      });
    });
  }, n.prototype.updateUserMessage = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return i = A(A({}, i_), r), Z(O("number", e) && s_(i)).throw(D.invalidParameters), s = k.of(this._iid).requestQueue, a = new qp(A({ channelType: this.channelType, channelUrl: this.url, messageId: e, metaArrayParams: i.metaArrays ? { array: i.metaArrays, mode: "add", upsert: !0 } : void 0 }, i)), [4, s.send(a)];
          case 1:
            return [2, o.sent().as(ud).message];
        }
      });
    });
  }, n.prototype.copyUserMessage = function(e, r) {
    var i, s, a;
    return g(this, 0, void 0, function() {
      var o, l;
      return _(this, function(c) {
        return Z(e instanceof n && r instanceof Ln && r.sendingStatus === St.SUCCEEDED && this.url === r.channelUrl && !r.scheduledInfo).throw(D.invalidParameters), Z(!r.poll).throw(D.notSupportedError), o = new $n(), l = (i = r.messageParams) !== null && i !== void 0 ? i : Ae(A(A({}, r), { mentionType: r.mentionType, mentionedUserIds: (s = r.mentionedUserIds) !== null && s !== void 0 ? s : (a = r.mentionedUsers) === null || a === void 0 ? void 0 : a.map(function(u) {
          return u.userId;
        }), translationTargetLanguages: Object.keys(r.translations), pushNotificationDeliveryOption: Yr.DEFAULT, parentMessageId: null, isReplyToChannel: !1, isPinnedMessage: !1 })), e._sendUserMessage(l).onSucceeded(function(u) {
          o.resolve(u);
        }).onFailed(function(u) {
          return o.reject(u);
        }), [2, o.promise];
      });
    });
  }, n.prototype.translateUserMessage = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(e instanceof Ln && e.messageId > 0 && tt("string", r)).throw(D.invalidParameters), i = k.of(this._iid).requestQueue, s = new fE({ channelType: this.channelType, channelUrl: this.url, messageId: e.messageId, translationTargetLanguages: r }), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(mE).message];
        }
      });
    });
  }, n.prototype._createScheduledUserMessage = function(e, r) {
    var i = this, s = k.of(this._iid).requestQueue, a = Date.now(), o = this._generateRequestId();
    er(2).then(function() {
      var c = i._createPendingScheduledUserMessage(e, o, a);
      Ue(function() {
        return g(i, 0, void 0, function() {
          return _(this, function(u) {
            return [2, r._trigger(c)];
          });
        });
      });
    });
    var l = new _E(A({ reqId: o, channelType: this.channelType, channelUrl: this.url }, e));
    s.send(l).then(function(c) {
      var u = c.as(o_).message;
      Ue(function() {
        return g(i, 0, void 0, function() {
          return _(this, function(d) {
            return [2, r._trigger(u)];
          });
        });
      });
    }).catch(function(c) {
      if (rr(c))
        throw c;
      er(2).then(function() {
        var u = i._createPendingScheduledUserMessage(e, o, a);
        i._markMessageAsFailed(u, c), Ue(function() {
          return g(i, 0, void 0, function() {
            return _(this, function(d) {
              return [2, r._triggerFailed(c, u)];
            });
          });
        });
      });
    });
  }, n.prototype.sendFileMessage = function(e) {
    var r = A(A({}, Fp), e);
    return Z(jp(r)).throw(D.invalidParameters), this._sendFileMessage(r);
  }, n.prototype.sendMultipleFilesMessage = function(e) {
    var r, i = A(A({}, xE), e), s = k.of(this._iid);
    Z(function(o, l) {
      return l === void 0 && (l = 5), wc(o) && O("string", o.message, !0) && Array.isArray(o.fileInfoList) && o.fileInfoList.length >= 2 && o.fileInfoList.length <= l && o.fileInfoList.every(function(c) {
        return function(u) {
          return (qn(u.file) || O("string", u.fileUrl)) && O("string", u.fileName, !0) && O("string", u.mimeType, !0) && O("number", u.fileSize, !0) && (u.thumbnailSizes === void 0 || Array.isArray(u.thumbnailSizes) && u.thumbnailSizes.every(function(d) {
            return d.maxWidth > 0 && d.maxHeight > 0;
          }));
        }(c);
      });
    }(i, (r = s.appInfo) === null || r === void 0 ? void 0 : r.multipleFilesMessageFileCountLimit)).throw(D.invalidParameters);
    var a = !!e.fileInfoList.find(function(o) {
      var l = s.appInfo.uploadSizeLimit;
      return o.file instanceof Blob && o.file.size > l || o.fileSize > l;
    });
    return Z(!a).throw(D.fileSizeLimitExceededError), this._sendMultipleFilesMessage(i);
  }, n.prototype._sendFileMessage = function(e, r, i) {
    var s = this;
    r === void 0 && (r = Rn.SEND);
    var a = k.of(this._iid).dispatcher, o = bn.of(this._iid).fileMessageQueue, l = i ?? this._generateRequestId(), c = Date.now(), u = new cr();
    return er(2).then(function() {
      var d = s._createPendingFileMessage(e, l, c);
      a.dispatch(new Pt({ messages: [d], source: r === Rn.RESEND ? B.LOCAL_MESSAGE_RESEND_STARTED : B.EVENT_MESSAGE_SENT_PENDING })), Ue(function() {
        return g(s, 0, void 0, function() {
          return _(this, function(h) {
            return [2, u._trigger(d)];
          });
        });
      }), o.request(s, l, e).then(function(h) {
        a.dispatch(new Pt({ messages: [h], source: B.EVENT_MESSAGE_SENT_SUCCESS })), Ue(function() {
          return g(s, 0, void 0, function() {
            return _(this, function(p) {
              return [2, u._trigger(h)];
            });
          });
        });
      }).catch(function(h) {
        if (rr(h))
          throw h;
        er(2).then(function() {
          var p = s._createPendingFileMessage(e, l, c), f = k.of(s._iid).cacheContext, m = f.localCacheEnabled && f.localCacheConfig.enableAutoResend && Hl(h.code);
          s._markMessageAsFailed(p, h, m), a.dispatch(new Pt({ messages: [p], source: p.sendingStatus === St.PENDING ? B.REQUEST_RESEND_MESSAGE : h.code === me.FILE_UPLOAD_CANCEL_FAILED ? B.LOCAL_MESSAGE_CANCELED : B.EVENT_MESSAGE_SENT_FAILED })), Ue(function() {
            return g(s, 0, void 0, function() {
              return _(this, function(v) {
                return [2, u._triggerFailed(h, p)];
              });
            });
          });
        });
      });
    }), u;
  }, n.prototype._autoResendFileMessage = function(e) {
    Z(e instanceof ln && !!e.messageParams).throw(D.invalidParameters);
    var r = k.of(this._iid).logger;
    return r.debug("autoResendFileMessage pending", e), this._sendFileMessage(e.messageParams, Rn.SEND, e.reqId).onFailed(function(i) {
      r.debug("autoResendFileMessage failed", i);
    }).onSucceeded(function(i) {
      r.debug("autoResendFileMessage success", i);
    });
  }, n.prototype._sendMultipleFilesMessage = function(e, r, i) {
    var s = this, a = k.of(this._iid).dispatcher, o = bn.of(this._iid).fileMessageQueue, l = i ?? this._generateRequestId(), c = Date.now(), u = new Nl();
    return er(2).then(function() {
      var d = s._createPendingMultipleFilesMessage(e, l, c);
      a.dispatch(new Pt({ messages: [d], source: r === Rn.RESEND ? B.LOCAL_MESSAGE_RESEND_STARTED : B.EVENT_MESSAGE_SENT_PENDING })), Ue(function() {
        return g(s, 0, void 0, function() {
          return _(this, function(h) {
            return [2, u._trigger(d)];
          });
        });
      }), o.request(s, l, e, { requestHandler: u, isCopy: r === Rn.COPY }).then(function(h) {
        a.dispatch(new Pt({ messages: [h], source: B.EVENT_MESSAGE_SENT_SUCCESS })), Ue(function() {
          return g(s, 0, void 0, function() {
            return _(this, function(p) {
              return [2, u._trigger(h)];
            });
          });
        });
      }).catch(function(h) {
        if (rr(h))
          throw h;
        er(2).then(function() {
          var p = s._createPendingMultipleFilesMessage(e, l, c);
          s._markMessageAsFailed(p, h), a.dispatch(new Pt({ messages: [p], source: B.EVENT_MESSAGE_SENT_FAILED })), Ue(function() {
            return g(s, 0, void 0, function() {
              return _(this, function(f) {
                return [2, u._triggerFailed(h, p)];
              });
            });
          });
        });
      });
    }), u;
  }, n.prototype._createScheduledFileMessage = function(e, r, i, s) {
    var a = this, o = k.of(this._iid).requestQueue, l = new gE(A(A({ reqId: i, channelType: this.channelType, channelUrl: this.url }, e), { fileUrl: e.fileUrl, requireAuth: e.requireAuth }));
    o.send(l).then(function(c) {
      var u = c.as(vE).message;
      Ue(function() {
        return g(a, 0, void 0, function() {
          return _(this, function(d) {
            return [2, r._trigger(u)];
          });
        });
      });
    }).catch(function(c) {
      if (rr(c))
        throw c;
      er(2).then(function() {
        var u = a._createPendingScheduledFileMessage(e, i, s);
        a._markMessageAsFailed(u, c), Ue(function() {
          return g(a, 0, void 0, function() {
            return _(this, function(d) {
              return [2, r._triggerFailed(c, u)];
            });
          });
        });
      });
    });
  }, n.prototype.sendFileMessages = function(e) {
    var r, i;
    Z(e.every(function(c) {
      return jp(A(A({}, Fp), c));
    })).throw(D.invalidParameters);
    var s = new cr();
    try {
      for (var a = de(e), o = a.next(); !o.done; o = a.next()) {
        var l = o.value;
        this.sendFileMessage(l).onPending(function(c) {
          return s._trigger(c);
        }).onFailed(function(c, u) {
          return s._triggerFailed(c, u);
        }).onSucceeded(function(c) {
          return s._trigger(c);
        });
      }
    } catch (c) {
      r = { error: c };
    } finally {
      try {
        o && !o.done && (i = a.return) && i.call(a);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return s;
  }, n.prototype.resendFileMessage = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a;
      return _(this, function(o) {
        return i = this._validateFailedFileMessageHasFile(e, r), Z(e instanceof ln && i && !e.scheduledInfo).throw(D.invalidParameters), s = new $n(), a = cd(e, r), this._sendFileMessage(a, Rn.RESEND, e.reqId).onFailed(function(l) {
          return s.reject(l);
        }).onSucceeded(function(l) {
          return s.resolve(l);
        }), [2, s.promise];
      });
    });
  }, n.prototype.resendMessage = function(e, r) {
    var i, s;
    if (Z(e instanceof en && !e.scheduledInfo && e.isResendable).throw(D.invalidParameters), e.isUserMessage()) {
      var a = (i = e.messageParams) !== null && i !== void 0 ? i : ld(e);
      return this._sendUserMessage(a, Rn.RESEND, e.reqId);
    }
    if (e.isFileMessage()) {
      var o = this._validateFailedFileMessageHasFile(e, r);
      return Z(o).throw(D.invalidParameters), a = (s = e.messageParams) !== null && s !== void 0 ? s : cd(e, r), this._sendFileMessage(a, Rn.RESEND, e.reqId);
    }
    if (e.isMultipleFilesMessage())
      throw D.channelTypeNotSupportedError;
  }, n.prototype.updateFileMessage = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return i = A(A({}, Cb), r), Z(O("number", e) && function(l) {
              return Xd(l);
            }(i)).throw(D.invalidParameters), s = k.of(this._iid).requestQueue, a = new Kp(A({ channelType: this.channelType, channelUrl: this.url, messageId: e, metaArrayParams: i.metaArrays ? { array: i.metaArrays, mode: "add", upsert: !0 } : void 0 }, i)), [4, s.send(a)];
          case 1:
            return [2, o.sent().as(dd).message];
        }
      });
    });
  }, n.prototype.uploadFile = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return r = k.of(this._iid).requestQueue, i = Pi(), (s = new Zl({ file: e.file, channelUrl: this.url, thumbnailSizes: e.thumbnailSizes, requestId: i })).uploadProgressHandler = e.progressHandler, e.uploadStartedHandler && e.uploadStartedHandler(i), [4, r.send(s)];
          case 1:
            return a = u.sent(), o = a.as(Xl), l = o.url, c = o.thumbnails, [2, { requestId: i, url: l, thumbnails: c }];
        }
      });
    });
  }, n.prototype.cancelUploadingFileMessage = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return Z(O("string", e)).throw(D.invalidParameters), bn.of(this._iid).fileMessageQueue.cancel(this, e), [2, !0];
      });
    });
  }, n.prototype.copyFileMessage = function(e, r) {
    var i, s, a;
    return g(this, 0, void 0, function() {
      var o, l;
      return _(this, function(c) {
        return Z(e instanceof n && r instanceof ln && r.sendingStatus === St.SUCCEEDED && this.url === r.channelUrl && !r.scheduledInfo).throw(D.invalidParameters), o = new $n(), l = Ae(A(A({}, r), { fileUrl: r.url, fileName: r.name, fileSize: r.size, mimeType: r.type, mentionType: r.mentionType, mentionedUserIds: (i = r.mentionedUserIds) !== null && i !== void 0 ? i : (s = r.mentionedUsers) === null || s === void 0 ? void 0 : s.map(function(u) {
          return u.userId;
        }), pushNotificationDeliveryOption: Yr.DEFAULT, parentMessageId: null, isReplyToChannel: !1, thumbnailSizes: (a = r.thumbnails) === null || a === void 0 ? void 0 : a.map(function(u) {
          return { maxWidth: u.width, maxHeight: u.height };
        }), requireAuth: r.requireAuth, isPinnedMessage: !1 })), e._sendFileMessage(l).onSucceeded(function(u) {
          return o.resolve(u);
        }).onFailed(function(u) {
          return o.reject(u);
        }), [2, o.promise];
      });
    });
  }, n.prototype.copyMessage = function(e, r) {
    Z(e instanceof n && r instanceof en && r.sendingStatus === St.SUCCEEDED && this.url === r.channelUrl && !r.scheduledInfo).throw(D.invalidParameters);
    var i = r, s = e;
    if (i.isUserMessage()) {
      Z(!i.poll).throw(D.notSupportedError);
      var a = t_(i);
      return s._sendUserMessage(a);
    }
    if (i.isFileMessage())
      return a = r_(i), s._sendFileMessage(a);
    if (r.isMultipleFilesMessage())
      throw D.channelTypeNotSupportedError;
  }, n.prototype.deleteMessage = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return Z(e instanceof Vn).throw(D.invalidParameters), e.messageId > 0 ? (r = k.of(this._iid).requestQueue, i = new om({ channelType: this.channelType, channelUrl: this.url, messageId: e.messageId, messageToken: e instanceof en ? e._messageToken : void 0 }), [4, r.send(i)]) : [3, 2];
          case 1:
            s.sent(), s.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.addReaction = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(e instanceof Vn && e.messageId > 0 && O("string", r)).throw(D.invalidParameters), i = k.of(this._iid).requestQueue, s = new uE({ channelType: this.channelType, channelUrl: this.url, messageId: e.messageId, reactionKey: r }), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(dE).reactionEvent];
        }
      });
    });
  }, n.prototype.deleteReaction = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(e instanceof Vn && e.messageId > 0 && O("string", r)).throw(D.invalidParameters), i = k.of(this._iid).requestQueue, s = new hE({ channelType: this.channelType, channelUrl: this.url, messageId: e.messageId, reactionKey: r }), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(pE).reactionEvent];
        }
      });
    });
  }, n.prototype._updateUserMessageMetaArray = function(e, r, i, s) {
    return g(this, 0, void 0, function() {
      var a, o, l, c, u, d;
      return _(this, function(h) {
        switch (h.label) {
          case 0:
            return a = k.of(this._iid), o = a.dispatcher, l = a.requestQueue, c = new qp({ channelType: this.channelType, channelUrl: this.url, messageId: e, metaArrayParams: { array: r, mode: i, upsert: s } }), [4, l.send(c)];
          case 1:
            return u = h.sent(), d = u.as(ud).message, o.dispatch(new Pt({ messages: [d], source: B.EVENT_MESSAGE_UPDATED })), [2, d];
        }
      });
    });
  }, n.prototype._updateFileMessageMetaArray = function(e, r, i, s) {
    return g(this, 0, void 0, function() {
      var a, o, l, c, u, d;
      return _(this, function(h) {
        switch (h.label) {
          case 0:
            return a = k.of(this._iid), o = a.dispatcher, l = a.requestQueue, c = new Kp({ channelType: this.channelType, channelUrl: this.url, messageId: e, metaArrayParams: { array: r, mode: i, upsert: s } }), [4, l.send(c)];
          case 1:
            return u = h.sent(), d = u.as(dd).message, o.dispatch(new Pt({ messages: [d], source: B.EVENT_MESSAGE_UPDATED })), [2, d];
        }
      });
    });
  }, n.prototype.createMessageMetaArrayKeys = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        return Z(e instanceof Vn && e.messageId > 0 && tt("string", r)).throw(D.invalidParameters), i = r.map(function(a) {
          return new Yn({ key: a });
        }), e instanceof ln ? [2, this._updateFileMessageMetaArray(e.messageId, i, "add", !0)] : [2, this._updateUserMessageMetaArray(e.messageId, i, "add", !0)];
      });
    });
  }, n.prototype.deleteMessageMetaArrayKeys = function(e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        return Z(e instanceof Vn && e.messageId > 0 && tt("string", r)).throw(D.invalidParameters), i = r.map(function(a) {
          return new Yn({ key: a });
        }), e instanceof ln ? [2, this._updateFileMessageMetaArray(e.messageId, i, "remove", !0)] : [2, this._updateUserMessageMetaArray(e.messageId, i, "remove", !0)];
      });
    });
  }, n.prototype.addMessageMetaArrayValues = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        return Z(e instanceof Vn && e.messageId > 0 && r.every(function(s) {
          return s instanceof Yn;
        })).throw(D.invalidParameters), e instanceof ln ? [2, this._updateFileMessageMetaArray(e.messageId, r, "add", !0)] : [2, this._updateUserMessageMetaArray(e.messageId, r, "add", !0)];
      });
    });
  }, n.prototype.removeMessageMetaArrayValues = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        return Z(e instanceof Vn && e.messageId > 0 && r.every(function(s) {
          return s instanceof Yn;
        })).throw(D.invalidParameters), e instanceof ln ? [2, this._updateFileMessageMetaArray(e.messageId, r, "remove", !0)] : [2, this._updateUserMessageMetaArray(e.messageId, r, "remove", !0)];
      });
    });
  }, n.prototype.report = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return Z(Ze(ho, e) && O("string", r)).throw(D.invalidParameters), i = k.of(this._iid), s = i.sdkState, a = i.requestQueue, o = new aE({ channelUrl: this.url, channelType: this.channelType, userId: s.userId, category: e, description: r }), [4, a.send(o)];
          case 1:
            return l.sent(), [2];
        }
      });
    });
  }, n.prototype.reportUser = function(e, r, i) {
    return g(this, 0, void 0, function() {
      var s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return Z(e instanceof pt && Ze(ho, r) && O("string", i)).throw(D.invalidParameters), s = k.of(this._iid), a = s.sdkState, o = s.requestQueue, l = new oE({ channelUrl: this.url, channelType: this.channelType, userId: a.userId, offendingUserId: e.userId, category: r, description: i }), [4, o.send(l)];
          case 1:
            return c.sent(), [2];
        }
      });
    });
  }, n.prototype.reportMessage = function(e, r, i) {
    return g(this, 0, void 0, function() {
      var s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return Z(e instanceof en && Ze(ho, r) && O("string", i)).throw(D.invalidParameters), s = k.of(this._iid), a = s.sdkState, o = s.requestQueue, l = new lE({ channelUrl: this.url, channelType: this.channelType, userId: a.userId, offendingUserId: e.sender.userId, messageId: e.messageId, category: r, description: i, messageToken: e._messageToken }), [4, o.send(l)];
          case 1:
            return c.sent(), [2];
        }
      });
    });
  }, n.prototype.updatePoll = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(O("number", e) && function(o) {
              return O("string", o.title, !0) && Bm(o.data) && O("boolean", o.allowUserSuggestion, !0) && O("boolean", o.allowMultipleVotes, !0) && O("number", o.closeAt, !0);
            }(r)).throw(D.invalidParameters), i = k.of(this._iid).requestQueue, s = new yE(A({ pollId: e }, r)), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(bE).poll];
        }
      });
    });
  }, n.prototype.deletePoll = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return r = O("number", e), Z(r).throw(D.invalidParameters), i = k.of(this._iid).requestQueue, s = new EE({ pollId: e }), [4, i.send(s)];
          case 1:
            return a.sent(), [2];
        }
      });
    });
  }, n.prototype.closePoll = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return r = O("number", e), Z(r).throw(D.invalidParameters), i = k.of(this._iid).requestQueue, s = new CE({ pollId: e }), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(TE).poll];
        }
      });
    });
  }, n.prototype.addPollOption = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return i = O("number", e) && O("string", r) && r.trim() !== "", Z(i).throw(D.invalidParameters), s = k.of(this._iid).requestQueue, a = new wE({ channelUrl: this.url, channelType: this.channelType, pollId: e, optionText: r }), [4, s.send(a)];
          case 1:
            return [2, o.sent().as(SE).poll];
        }
      });
    });
  }, n.prototype.updatePollOption = function(e, r, i) {
    return g(this, 0, void 0, function() {
      var s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return s = O("number", e) && O("number", r) && O("string", i) && i.trim() !== "", Z(s).throw(D.invalidParameters), a = k.of(this._iid).requestQueue, o = new NE({ pollId: e, pollOptionId: r, optionText: i }), [4, a.send(o)];
          case 1:
            return [2, l.sent().as(IE).poll];
        }
      });
    });
  }, n.prototype.deletePollOption = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return i = O("number", e) && O("number", r), Z(i).throw(D.invalidParameters), s = k.of(this._iid).requestQueue, a = new AE({ pollId: e, pollOptionId: r }), [4, s.send(a)];
          case 1:
            return o.sent(), [2];
        }
      });
    });
  }, n.prototype.votePoll = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a, o, l, c, u;
      return _(this, function(d) {
        switch (d.label) {
          case 0:
            return i = O("number", e) && tt("number", r), Z(i).throw(D.invalidParameters), s = k.of(this._iid), a = s.requestQueue, o = s.dispatcher, l = new ME({ reqId: this._generateRequestId(), channelUrl: this.url, channelType: this.channelType, pollId: e, pollOptionIds: r }), [4, a.send(l)];
          case 1:
            return c = d.sent(), u = c.as(l_).event, o.dispatch(new Yd({ event: u, source: B.EVENT_POLL_VOTED })), [2, u];
        }
      });
    });
  }, n.prototype.getPollChangeLogsSinceTimestamp = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return Z(O("number", e)).throw(D.invalidParameters), [4, $l.of(this._iid).getPollChangeLogs(this.url, this.channelType, e)];
          case 1:
            return [2, r.sent()];
        }
      });
    });
  }, n.prototype.getPollChangeLogsSinceToken = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return Z(O("string", e, !0)), [4, $l.of(this._iid).getPollChangeLogs(this.url, this.channelType, e)];
          case 1:
            return [2, r.sent()];
        }
      });
    });
  }, n.prototype.createPollListQuery = function(e) {
    return e === void 0 && (e = 10), new qm(this._iid, { channelUrl: this.url, channelType: this.channelType, limit: e });
  }, n.prototype.createPollVoterListQuery = function(e, r, i) {
    return i === void 0 && (i = 20), new Km(this._iid, { channelUrl: this.url, channelType: this.channelType, pollId: e, pollOptionId: r, limit: i });
  }, n.prototype.pinMessage = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return Z(O("number", e) && e > 0).throw(D.invalidParameters), r = k.of(this._iid).requestQueue, i = new LE({ channelType: this.channelType, channelUrl: this.url, messageId: e }), [4, r.send(i)];
          case 1:
            return s.sent(), [2];
        }
      });
    });
  }, n.prototype.unpinMessage = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return Z(O("number", e) && e > 0).throw(D.invalidParameters), r = k.of(this._iid).requestQueue, i = new UE({ channelType: this.channelType, channelUrl: this.url, messageId: e }), [4, r.send(i)];
          case 1:
            return s.sent(), [2];
        }
      });
    });
  }, n;
}(xn), d_ = function(t) {
  function n(e) {
    e === void 0 && (e = {});
    var r = t.call(this) || this;
    return Object.keys(e).forEach(function(i) {
      r.hasOwnProperty(i) && (r[i] = e[i]);
    }), r;
  }
  return S(n, t), n;
}(function() {
  this.onConnected = rt, this.onReconnectStarted = rt, this.onReconnectSucceeded = rt, this.onReconnectFailed = rt, this.onDisconnected = rt;
}), tc = function(t) {
  function n(e) {
    e === void 0 && (e = {});
    var r = t.call(this) || this;
    return Object.keys(e).forEach(function(i) {
      r.hasOwnProperty(i) && (r[i] = e[i]);
    }), r;
  }
  return S(n, t), n;
}(function() {
  this.onSessionExpired = rt, this.onSessionTokenRequired = function(t) {
    return t(null);
  }, this.onSessionError = rt, this.onSessionRefreshed = rt, this.onSessionClosed = rt;
}), PE = function(t) {
  function n(e) {
    e === void 0 && (e = {});
    var r = t.call(this) || this;
    return Object.keys(e).forEach(function(i) {
      r.hasOwnProperty(i) && (r[i] = e[i]);
    }), r;
  }
  return S(n, t), n;
}(function() {
  this.onFriendsDiscovered = rt, this.onTotalUnreadMessageCountChanged = rt, this.onTotalUnreadMessageCountUpdated = rt;
}), FE = function(t) {
  function n(e) {
    var r = e.limit, i = e.token, s = e.userIdsFilter, a = e.metaDataKeyFilter, o = e.metaDataValuesFilter, l = e.nicknameStartsWithFilter, c = t.call(this) || this;
    return c.method = Y.GET, c.path = vt, c.params = fe({ limit: r, token: i, user_ids: s, metadatakey: a, metadatavalues_in: o, nickname_startswith: l }), c;
  }
  return S(n, t), n;
}($), jE = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.users = r.users.map(function(s) {
      return new pt(e, s);
    }), i.next = r.next, i;
  }
  return S(n, t), n;
}(ne), HE = function(t) {
  function n(e, r) {
    var i, s, a, o = this;
    return (o = t.call(this, e, r) || this).userIdsFilter = null, o.metaDataKeyFilter = null, o.metaDataValuesFilter = null, o.nicknameStartsWithFilter = null, o.userIdsFilter = (i = r.userIdsFilter) !== null && i !== void 0 ? i : null, o.metaDataKeyFilter = (s = r.metaDataKeyFilter) !== null && s !== void 0 ? s : null, o.metaDataValuesFilter = (a = r.metaDataValuesFilter) !== null && a !== void 0 ? a : null, o.nicknameStartsWithFilter = r.nicknameStartsWithFilter || null, o;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this) && tt("string", this.userIdsFilter, !0) && O("string", this.metaDataKeyFilter, !0) && tt("string", this.metaDataValuesFilter, !0) && O("string", this.nicknameStartsWithFilter, !0);
  }, n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = k.of(this._iid).requestQueue, r = new FE(Ae(A(A({}, this), { token: this._token }))), [4, e.send(r)]) : [3, 2] : [3, 5];
          case 1:
            return i = l.sent(), s = i.as(jE), a = s.users, o = s.next, this._token = o, this._hasNext = !!o, this._isLoading = !1, [2, a];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(cs), BE = function(t) {
  function n(e) {
    var r = e.userId, i = e.limit, s = e.token, a = e.userIdsFilter, o = t.call(this) || this;
    return o.method = Y.GET, o.path = "".concat(vt, "/").concat(r, "/block"), o.params = fe({ limit: i, token: s, user_ids: a }), o;
  }
  return S(n, t), n;
}($), zE = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.users = r.users.map(function(s) {
      return new pt(e, s);
    }), i.next = r.next, i;
  }
  return S(n, t), n;
}(ne), VE = function(t) {
  function n(e, r) {
    var i, s = this;
    return (s = t.call(this, e, r) || this).userIdsFilter = null, s.userIdsFilter = (i = r.userIdsFilter) !== null && i !== void 0 ? i : null, s;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this) && tt("string", this.userIdsFilter, !0);
  }, n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new BE(Ae(A(A({}, this), { userId: r.userId, token: this._token }))), [4, i.send(s)]) : [3, 2] : [3, 5];
          case 1:
            return a = u.sent(), o = a.as(zE), l = o.users, c = o.next, this._token = c, this._hasNext = !!c, this._isLoading = !1, [2, l];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(cs), GE = function(t) {
  function n(e) {
    var r = e.userId, i = e.limit, s = e.token, a = t.call(this) || this;
    return a.method = Y.GET, a.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/friends"), a.params = { limit: i, token: s }, a;
  }
  return S(n, t), n;
}($), qE = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.hasMore = r.has_more, i.users = r.users.map(function(s) {
      return new pt(e, s);
    }), i.next = r.next, i;
  }
  return S(n, t), n;
}(ne), KE = function(t) {
  function n() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this);
  }, n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c, u;
      return _(this, function(d) {
        switch (d.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new GE(A(A({}, this), { userId: r.userId, token: this._token })), [4, i.send(s)]) : [3, 2] : [3, 5];
          case 1:
            return a = d.sent(), o = a.as(qE), l = o.users, c = o.hasMore, u = o.next, this._token = u, this._hasNext = c, this._isLoading = !1, [2, l];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(cs), sl = {}, Po = function() {
  function t(n) {
    var e = n.dbname, r = n.itemSizeLimit, i = r === void 0 ? 1048576 : r, s = n.cacheLimit, a = s === void 0 ? 256 : s, o = n.blockHashBase, l = o === void 0 ? 2 : o, c = n.blockHashMultiplier, u = c === void 0 ? 10 : c, d = n.blockHashConstant, h = d === void 0 ? 11 : d, p = n.transactionApplyDelay, f = p === void 0 ? 200 : p, m = n.disableLogger, v = m !== void 0 && m;
    return sl[e] || (this.itemSizeLimit = i, this.cacheLimit = a, this.blockHashBase = l, this.blockHashMultiplier = u, this.blockHashConstant = h, this.transactionApplyDelay = f, this.disableLogger = v, sl[e] = this), sl[e];
  }
  return t.get = function(n) {
    return sl[n];
  }, t;
}();
(function(t) {
  t[t.UNKNOWN_ERROR = 6e7] = "UNKNOWN_ERROR", t[t.STORE_NOT_DEFINED = 61001e3] = "STORE_NOT_DEFINED", t[t.STORE_NOT_AVAILABLE = 61001001] = "STORE_NOT_AVAILABLE", t[t.STORE_NOT_AVAILABLE_IN_PRIVATE_BROWSING = 61001002] = "STORE_NOT_AVAILABLE_IN_PRIVATE_BROWSING", t[t.STORE_IS_FULL = 61001003] = "STORE_IS_FULL", t[t.STORE_NOT_INITIALIZED = 61001004] = "STORE_NOT_INITIALIZED", t[t.STORE_INVALID_KEY_TYPE = 61002e3] = "STORE_INVALID_KEY_TYPE", t[t.STORE_BROKEN_INTEGRITY = 61002001] = "STORE_BROKEN_INTEGRITY", t[t.STORE_BROKEN_BLOB = 61002002] = "STORE_BROKEN_BLOB", t[t.STORE_ENCRYPTION_INVALID = 61002003] = "STORE_ENCRYPTION_INVALID", t[t.STORE_ITEM_SIZE_LIMIT_EXCEEDED = 61017e3] = "STORE_ITEM_SIZE_LIMIT_EXCEEDED", t[t.STORE_READ_FAILED = 61017001] = "STORE_READ_FAILED", t[t.STORE_WRITE_FAILED = 61017002] = "STORE_WRITE_FAILED", t[t.DATABASE_SCHEMA_NOT_ON_UPGRADE = 62002e3] = "DATABASE_SCHEMA_NOT_ON_UPGRADE", t[t.COLLECTION_NOT_READY = 63001e3] = "COLLECTION_NOT_READY", t[t.COLLECTION_KEY_NOT_MATCH = 63002e3] = "COLLECTION_KEY_NOT_MATCH", t[t.COLLECTION_QUERY_NOT_VALID = 63002001] = "COLLECTION_QUERY_NOT_VALID", t[t.COLLECTION_KEY_NOT_FOUND = 63004e3] = "COLLECTION_KEY_NOT_FOUND", t[t.COLLECTION_KEY_NOT_GIVEN = 63004001] = "COLLECTION_KEY_NOT_GIVEN", t[t.COLLECTION_INSERT_DUPLICATE = 63009e3] = "COLLECTION_INSERT_DUPLICATE", t[t.COLLECTION_WRITE_FAILED = 63017e3] = "COLLECTION_WRITE_FAILED", t[t.COLLECTION_ITEM_SIZE_LIMIT_EXCEEDED = 63017001] = "COLLECTION_ITEM_SIZE_LIMIT_EXCEEDED", t[t.INDEX_TABLE_IS_REQUIRED = 65001e3] = "INDEX_TABLE_IS_REQUIRED", t[t.INDEX_TYPE_NOT_MATCH = 65002e3] = "INDEX_TYPE_NOT_MATCH", t[t.COMPARE_TYPE_NOT_MATCH = 69002001] = "COMPARE_TYPE_NOT_MATCH", t[t.CIRCULAR_REFERENCE_FOUND = 69002002] = "CIRCULAR_REFERENCE_FOUND";
})(Bt || (Bt = {}));
var Us, Ct = function(t) {
  function n(e) {
    var r = e.code, i = r === void 0 ? Bt.UNKNOWN_ERROR : r, s = e.message, a = s === void 0 ? "Unknown error occurred." : s, o = t.call(this, a) || this;
    return o.code = i, Object.setPrototypeOf(o, n.prototype), o;
  }
  return S(n, t), Object.defineProperty(n, "storeNotDefined", { get: function() {
    return new n({ code: Bt.STORE_NOT_DEFINED, message: "Store is not defined. Specify the store on NestDB()" });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "storeNotAvailable", { get: function() {
    return new n({ code: Bt.STORE_NOT_AVAILABLE, message: "Store is not available. Check your environment settings." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "storeNotAvailableInPrivateBrowsing", { get: function() {
    return new n({ code: Bt.STORE_NOT_AVAILABLE_IN_PRIVATE_BROWSING, message: "Store is not available because it is in private browsing." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "storeIsFull", { get: function() {
    return new n({ code: Bt.STORE_IS_FULL, message: "Store is full." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "storeNotInitialized", { get: function() {
    return new n({ code: Bt.STORE_NOT_INITIALIZED, message: "Store is not initialized." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "storeKeyTypeIsInvalid", { get: function() {
    return new n({ code: Bt.STORE_INVALID_KEY_TYPE, message: "Store key should be string type." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "storeBrokenIntegrity", { get: function() {
    return new n({ code: Bt.STORE_BROKEN_INTEGRITY, message: "Data should be in a store but it does not. Integrity is broken." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "storeBrokenBlob", { get: function() {
    return new n({ code: Bt.STORE_BROKEN_BLOB, message: "Data should be in a store but it does not. Blob data is broken." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "storeEncryptionInvalid", { get: function() {
    return new n({ code: Bt.STORE_ENCRYPTION_INVALID, message: "Encryption algorithm has changed. All the store should reset." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "storeItemSizeExceeded", { get: function() {
    return new n({ code: Bt.STORE_ITEM_SIZE_LIMIT_EXCEEDED, message: "The size of the item exceeds the limit that the store allows." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "storeReadFailed", { get: function() {
    return new n({ code: Bt.STORE_READ_FAILED, message: "Failed to read from store." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "storeWriteFailed", { get: function() {
    return new n({ code: Bt.STORE_WRITE_FAILED, message: "Failed to write to store." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "databaseSchemaNotOnUpgrade", { get: function() {
    return new n({ code: Bt.DATABASE_SCHEMA_NOT_ON_UPGRADE, message: "Committing schema is not allowed when upgrade is not running." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "collectionNotReady", { get: function() {
    return new n({ code: Bt.COLLECTION_NOT_READY, message: "Collection is not ready due to an error during initialization." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "collectionKeyNotMatch", { get: function() {
    return new n({ code: Bt.COLLECTION_KEY_NOT_MATCH, message: "keyName of collection could not change." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "collectionQueryNotValid", { get: function() {
    return new n({ code: Bt.COLLECTION_QUERY_NOT_VALID, message: "Query parameter is not a valid format." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "collectionInsertDuplicate", { get: function() {
    return new n({ code: Bt.COLLECTION_INSERT_DUPLICATE, message: "The key already exists." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "collectionKeyNotFound", { get: function() {
    return new n({ code: Bt.COLLECTION_KEY_NOT_FOUND, message: "The key is not found." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "collectionKeyNotGiven", { get: function() {
    return new n({ code: Bt.COLLECTION_KEY_NOT_GIVEN, message: "The item should contain [keyName] property." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "collectionWriteFailed", { get: function() {
    return new n({ code: Bt.COLLECTION_WRITE_FAILED, message: "Failed to write an item." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "collectionItemSizeExceeded", { get: function() {
    return new n({ code: Bt.COLLECTION_ITEM_SIZE_LIMIT_EXCEEDED, message: "The size of the item exceeds the limit that a collection allows." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "indexTableIsRequired", { get: function() {
    return new n({ code: Bt.INDEX_TABLE_IS_REQUIRED, message: "Index table is required." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "indexTypesNotMatch", { get: function() {
    return new n({ code: Bt.INDEX_TYPE_NOT_MATCH, message: "Indexed column should have primitive type." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "compareTypesNotMatch", { get: function() {
    return new n({ code: Bt.COMPARE_TYPE_NOT_MATCH, message: "Values to compare have different types." });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n, "circularReferenceFound", { get: function() {
    return new n({ code: Bt.CIRCULAR_REFERENCE_FOUND, message: "Cannot handle circular referenced object." });
  }, enumerable: !1, configurable: !0 }), n;
}(Error);
(function(t) {
  t.INIT = "init", t.READY = "ready", t.CLOSED = "closed";
})(Us || (Us = {}));
var Qp, tr = function(t, n) {
  if (n === void 0 && (n = /* @__PURE__ */ new WeakMap()), typeof t == "object" && t !== null) {
    if (n.has(t))
      throw Ct.circularReferenceFound;
    var e;
    return n.set(t, !0), Array.isArray(t) ? e = t.map(function(r) {
      return tr(r, n);
    }) : t instanceof RegExp || t instanceof Date ? e = t : (e = {}, Object.keys(t).forEach(function(r) {
      e[r] = tr(t[r], n);
    })), n.delete(t), e;
  }
  return t;
}, Oi = function(t, n) {
  if (n == null)
    return 1;
  if (t == null)
    return -1;
  if (typeof t != typeof n)
    throw Ct.compareTypesNotMatch;
  var e = 0;
  switch (typeof t) {
    case "boolean":
    case "number":
      e = t - n;
      break;
    case "string":
      e = t.localeCompare(n);
  }
  return e;
}, Yp = function(t, n) {
  for (var e = 0, r = 0; r < t.length; r++)
    e = t.charCodeAt(r) + (e << 6) + (e << 16) - e;
  return (e >>> 0) % n;
}, al = function(t) {
  return new Promise(function(n) {
    setTimeout(function() {
      return n();
    }, t);
  });
}, Bs = function(t, n) {
  if (!n)
    return !1;
  if (typeof t != "function") {
    for (var e in t)
      if (["/and", "&&"].includes(e)) {
        if (t[e].some(function(l) {
          return !Bs(l, n);
        }))
          return !1;
      } else if (["/or", "||"].includes(e)) {
        if (t[e].every(function(l) {
          return !Bs(l, n);
        }))
          return !1;
      } else if (e === "/where") {
        if (!(0, t[e])(n))
          return !1;
      } else {
        var r = e;
        if (typeof t[r] == "object") {
          var i = t[r];
          for (var s in i)
            switch (s) {
              case "/eq":
              case "=":
                if ((a = n[r]) !== (o = i[s]))
                  return !1;
                break;
              case "/neq":
              case "!=":
                if ((a = n[r]) === (o = i[s]))
                  return !1;
                break;
              case "/gt":
              case ">":
                var a = n[r], o = i[s];
                if (!(Oi(a, o) > 0))
                  return !1;
                break;
              case "/gte":
              case ">=":
                if (a = n[r], o = i[s], !(Oi(a, o) >= 0))
                  return !1;
                break;
              case "/lt":
              case "<":
                if (a = n[r], o = i[s], !(Oi(a, o) < 0))
                  return !1;
                break;
              case "/lte":
              case "<=":
                if (a = n[r], o = i[s], !(Oi(a, o) <= 0))
                  return !1;
                break;
              case "/in":
                if (a = n[r], !(o = i[s]).includes(a))
                  return !1;
                break;
              case "/nin":
                if (a = n[r], (o = i[s]).includes(a))
                  return !1;
                break;
              case "/contain":
                if (a = n[r], o = i[s], !a.includes(o))
                  return !1;
                break;
              case "/regex":
                if (a = n[r], !(o = i[s]).test(a))
                  return !1;
                break;
              case "/where":
                if (a = n[r], !(0, i[s])(a))
                  return !1;
            }
        } else if (typeof t[r] == "function") {
          if (!t[r](n[r]))
            return !1;
        } else if (t[r] !== n[r])
          return !1;
      }
    return !0;
  }
  return t(n);
}, qa = function() {
}, $p = function() {
  return Promise.resolve();
}, WE = function(t) {
  return t;
}, Zp = function(t, n) {
  n();
};
(function(t) {
  t[t.FORWARD = 0] = "FORWARD", t[t.BACKWARD = 1] = "BACKWARD";
})(Qp || (Qp = {}));
var zs, Gn, ii, QE = function() {
  function t(n) {
    var e = n.initialPrevValue, r = e === void 0 ? null : e, i = n.initialNextValue, s = i === void 0 ? null : i, a = n.iterator, o = n.map, l = o === void 0 ? WE : o, c = n.backward, u = c === void 0 ? $p : c, d = n.forward, h = d === void 0 ? $p : d, p = n.complete, f = p === void 0 ? qa : p;
    this._prevValue = r, this._nextValue = s, this._error = null, this._map = l, this._backward = u, this._forward = h, this._iterator = a, this._complete = f;
  }
  return Object.defineProperty(t.prototype, "prevValue", { get: function() {
    return this._map(this._prevValue);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "nextValue", { get: function() {
    return this._map(this._nextValue);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "error", { get: function() {
    return this._error;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "hasPrevious", { get: function() {
    return !!this._prevValue;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "hasNext", { get: function() {
    return !!this._nextValue;
  }, enumerable: !1, configurable: !0 }), t.prototype.prev = function() {
    return g(this, 0, void 0, function() {
      var n, e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            if (!this.hasPrevious)
              return [3, 6];
            i.label = 1;
          case 1:
            return i.trys.push([1, 3, , 4]), n = this._prevValue, e = this, [4, this._backward()];
          case 2:
            return e._prevValue = i.sent() || null, this._nextValue = n, [3, 4];
          case 3:
            return r = i.sent(), this._error = r, [3, 4];
          case 4:
            return [4, this._iterator(this)];
          case 5:
            return [2, i.sent()];
          case 6:
            this._complete(), i.label = 7;
          case 7:
            return [2];
        }
      });
    });
  }, t.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var n, e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            if (!this.hasNext)
              return [3, 6];
            i.label = 1;
          case 1:
            return i.trys.push([1, 3, , 4]), n = this._nextValue, e = this, [4, this._forward()];
          case 2:
            return e._nextValue = i.sent() || null, this._prevValue = n, [3, 4];
          case 3:
            return r = i.sent(), this._error = r, [3, 4];
          case 4:
            return [4, this._iterator(this)];
          case 5:
            return [2, i.sent()];
          case 6:
            this._complete(), i.label = 7;
          case 7:
            return [2];
        }
      });
    });
  }, t.prototype.stop = function() {
    this._prevValue = null, this._nextValue = null, this._complete();
  }, t;
}(), pd = function() {
  function t(n) {
    var e = n.condition, r = e === void 0 ? {} : e, i = n.backward, s = i !== void 0 && i, a = n.blockManager, o = n.indexer;
    this.condition = r, this.backward = s, this._blockManager = a, this._indexer = o;
  }
  return t.prototype.findOptimizedStartPosition = function() {
    var n = this, e = ["=", "/eq", ">", ">=", "/gt", "/gte"], r = ["=", "/eq", "<", "<=", "/lt", "/lte"];
    if (this.backward) {
      var i = this._indexer.origin.length - 1;
      if (typeof this.condition != "function")
        for (p = 0; p < this._indexer.fields.length; p++) {
          var s = this._indexer.fields[p], a = 1;
          if (s[0] === "-" && (s = s.slice(1), a = -1), this.condition[s]) {
            if (typeof this.condition[s] == "object") {
              var o = a > 0 ? r : e;
              for (var l in this.condition[s])
                if (o.includes(l)) {
                  for (var c = i; c >= 0; c--)
                    if (a * Oi(this._indexer.origin[c].columnValues[p], this.condition[s][l]) <= 0) {
                      i = c;
                      break;
                    }
                }
            } else
              for (c = i; c >= 0; c--)
                if (a * Oi(this._indexer.origin[c].columnValues[p], this.condition[s]) <= 0) {
                  i = c;
                  break;
                }
          }
        }
      return Math.min(i + 1, this._indexer.origin.length - 1);
    }
    var u = 0;
    if (typeof this.condition != "function")
      for (var d = function(f) {
        var m = h._indexer.fields[f], v = 1;
        if (m[0] === "-" && (m = m.slice(1), v = -1), h.condition[m]) {
          if (typeof h.condition[m] == "object")
            Object.keys(h.condition[m]).forEach(function(y) {
              if ((v > 0 ? e : r).includes(y)) {
                for (var b = u; b < n._indexer.origin.length; b++)
                  if (v * Oi(n._indexer.origin[b].columnValues[f], n.condition[m][y]) >= 0) {
                    u = b;
                    break;
                  }
              }
            });
          else
            for (var E = u; E < h._indexer.origin.length; E++)
              if (v * Oi(h._indexer.origin[E].columnValues[f], h.condition[m]) >= 0) {
                u = E;
                break;
              }
        }
      }, h = this, p = 0; p < this._indexer.fields.length; p++)
        d(p);
    return Math.max(u - 1, 0);
  }, t.prototype.each = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c = this;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            if (e = this.findOptimizedStartPosition(), r = 0, this.backward && this._indexer.origin[e] && (r = this._indexer.origin[e].keys.length - 1), i = function() {
              if (c._indexer.origin[e]) {
                if (!c._indexer.origin[e].keys[++r]) {
                  if (!c._indexer.origin[++e])
                    return !1;
                  r = 0;
                }
                return !0;
              }
              return !1;
            }, s = function() {
              if (c._indexer.origin[e]) {
                if (!c._indexer.origin[e].keys[--r]) {
                  if (!c._indexer.origin[--e])
                    return !1;
                  r = c._indexer.origin[e].keys.length - 1;
                }
                return !0;
              }
              return !1;
            }, a = null, !this._indexer.origin[e])
              return [3, 4];
            o = this.backward ? s : i, u.label = 1;
          case 1:
            return [4, this._blockManager.getFromBlock(this._indexer.origin[e].keys[r])];
          case 2:
            if ((l = u.sent()) && Bs(this.condition, l))
              return a = l, [3, 4];
            u.label = 3;
          case 3:
            if (o())
              return [3, 1];
            u.label = 4;
          case 4:
            return [4, new Promise(function(d) {
              var h = new QE({ initialNextValue: tr(a), iterator: n, forward: function() {
                return g(c, 0, void 0, function() {
                  var p, f;
                  return _(this, function(m) {
                    switch (m.label) {
                      case 0:
                        p = this.backward ? s : i, m.label = 1;
                      case 1:
                        return p() ? [4, this._blockManager.getFromBlock(this._indexer.origin[e].keys[r])] : [3, 3];
                      case 2:
                        return (f = m.sent()) && Bs(this.condition, f) ? [2, tr(f)] : [3, 1];
                      case 3:
                        return [2, null];
                    }
                  });
                });
              }, backward: function() {
                return g(c, 0, void 0, function() {
                  var p, f;
                  return _(this, function(m) {
                    switch (m.label) {
                      case 0:
                        p = this.backward ? i : s, m.label = 1;
                      case 1:
                        return p() ? [4, this._blockManager.getFromBlock(this._indexer.origin[e].keys[r])] : [3, 3];
                      case 2:
                        return (f = m.sent()) && Bs(this.condition, f) ? [2, tr(f)] : [3, 1];
                      case 3:
                        return [2, null];
                    }
                  });
                });
              }, complete: d });
              n(h);
            })];
          case 5:
            return [2, u.sent()];
        }
      });
    });
  }, t;
}(), YE = function() {
  function t(n) {
    var e = n.condition, r = e === void 0 ? {} : e, i = n.backward, s = i !== void 0 && i, a = n.mutex, o = n.blockManager, l = n.indexer;
    this._mutex = a, this._iterator = new pd({ condition: r, backward: s, blockManager: o, indexer: l });
  }
  return t.prototype.fetch = function(n) {
    return n === void 0 && (n = {}), g(this, 0, void 0, function() {
      var e, r, i, s, a = this;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            if (e = Math.max(n.offset || 0, 0), (r = typeof n.limit == "number" ? n.limit : Number.MAX_SAFE_INTEGER) === 0)
              return [2, []];
            if (r < 0)
              throw Ct.collectionQueryNotValid;
            o.label = 1;
          case 1:
            return o.trys.push([1, 4, , 5]), i = [], [4, this._mutex.lock()];
          case 2:
            return o.sent(), [4, this._iterator.each(function(l) {
              return g(a, 0, void 0, function() {
                return _(this, function(c) {
                  return l.error ? l.stop() : l.hasNext ? e === 0 ? (i.push(l.nextValue), 0 < r && r <= i.length ? l.stop() : l.next()) : (e--, l.next()) : l.stop(), [2];
                });
              });
            })];
          case 3:
            return o.sent(), this._mutex.unlock(), [2, i];
          case 4:
            throw s = o.sent(), this._mutex.unlock(), s;
          case 5:
            return [2];
        }
      });
    });
  }, t.prototype.count = function() {
    return g(this, 0, void 0, function() {
      var n, e, r = this;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return i.trys.push([0, 3, , 4]), n = 0, [4, this._mutex.lock()];
          case 1:
            return i.sent(), [4, this._iterator.each(function(s) {
              return g(r, 0, void 0, function() {
                return _(this, function(a) {
                  return s.error ? s.stop() : s.hasNext ? (n++, s.next()) : s.stop(), [2];
                });
              });
            })];
          case 2:
            return i.sent(), this._mutex.unlock(), [2, n];
          case 3:
            throw e = i.sent(), this._mutex.unlock(), e;
          case 4:
            return [2];
        }
      });
    });
  }, t;
}(), Jd = function(t) {
  return "".concat("nest", "@").concat(t);
}, qs = function(t, n) {
  return "".concat(Jd(t), "/").concat(n);
}, fu = function(t, n) {
  return "".concat(qs(t, n), ".metadata");
}, fd = function(t, n) {
  return "".concat(qs(t, n), "/block.");
}, Xp = function(t, n) {
  return "".concat(qs(t, n), "/blob.");
}, $E = function() {
  function t(n) {
    var e = n.dbname, r = n.collectionName, i = n.store;
    this.dbname = e, this.collectionName = r, this.store = i;
  }
  return t.prototype.get = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c, u;
      return _(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, this.store.get(n)];
          case 1:
            return (e = d.sent()) ? (r = e.data, i = e.type, typeof fetch > "u" ? [3, 4] : [4, fetch(r)]) : [3, 5];
          case 2:
            return [4, d.sent().blob()];
          case 3:
            return [2, d.sent()];
          case 4:
            for (s = [], a = atob(r.split(",")[1]), o = 0; o < a.length; o += 512) {
              for (l = a.slice(o, o + 512), c = new Array(l.length), u = 0; u < l.length; u++)
                c[u] = l.charCodeAt(u);
              s.push(new Uint8Array(c));
            }
            return [2, new Blob(s, { type: i })];
          case 5:
            return [2, null];
        }
      });
    });
  }, t.prototype.save = function(n, e) {
    return e === void 0 && (e = "".concat(Date.now())), g(this, 0, void 0, function() {
      var r, i, s, a, o = this;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, new Promise(function(c) {
              var u = function(h, p, f, m) {
                return m === void 0 && (m = 0), "".concat(Xp(h, p)).concat(f, ".").concat(m);
              }(o.dbname, o.collectionName, e), d = new FileReader();
              d.onload = function() {
                c({ blobId: u, data: d.result, type: n.type });
              }, d.readAsDataURL(n);
            })];
          case 1:
            return r = l.sent(), i = r.blobId, s = r.data, a = r.type, [4, this.store.set({ key: i, value: { data: s, type: a } })];
          case 2:
            return l.sent(), [2, i];
        }
      });
    });
  }, t.prototype.remove = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this.store.remove(n)];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, t.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      var n, e, r = this;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return n = Xp(this.dbname, this.collectionName), [4, this.store.getAllKeys()];
          case 1:
            return e = i.sent(), [4, Promise.all(e.filter(function(s) {
              return s.startsWith(n);
            }).map(function(s) {
              return g(r, 0, void 0, function() {
                return _(this, function(a) {
                  switch (a.label) {
                    case 0:
                      return [4, this.store.remove(s)];
                    case 1:
                      return [2, a.sent()];
                  }
                });
              });
            }))];
          case 2:
            return i.sent(), [2];
        }
      });
    });
  }, t;
}();
(function(t) {
  t[t.COMMIT = 0] = "COMMIT", t[t.WRITE = 1] = "WRITE", t[t.ERROR = 2] = "ERROR";
})(zs || (zs = {})), function(t) {
  t.PENDING = "pending", t.PERSISTENT = "persistent", t.VOLATILE = "volatile";
}(Gn || (Gn = {})), function(t) {
  t[t.NO_CACHE = 0] = "NO_CACHE", t[t.DEFAULT = 1] = "DEFAULT", t[t.PERSISTENT = 2] = "PERSISTENT";
}(ii || (ii = {}));
var po, zn, Jp = [Gn.PENDING, Gn.VOLATILE], ol = {}, ir = function() {
  function t(n) {
    var e = n.dbname, r = n.limit, i = r === void 0 ? 256 : r;
    return ol[e] || (this.dbname = e, this._items = [], this._limit = i, ol[e] = this), ol[e];
  }
  return t.get = function(n) {
    return ol[n];
  }, Object.defineProperty(t.prototype, "items", { get: function() {
    return this._items;
  }, enumerable: !1, configurable: !0 }), t.prototype.find = function(n, e, r) {
    return r === void 0 && (r = ii.DEFAULT), g(this, 0, void 0, function() {
      var i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return (i = this.get(e)) ? [3, 2] : [4, n.get(e)];
          case 1:
            return (s = a.sent()) && (i = { key: e, value: s, state: r === ii.PERSISTENT ? Gn.PERSISTENT : Gn.VOLATILE }, this.put(i)), [3, 3];
          case 2:
            r === ii.PERSISTENT && (i.state = Gn.PERSISTENT), a.label = 3;
          case 3:
            return [2, i];
        }
      });
    });
  }, t.prototype.get = function(n, e) {
    e === void 0 && (e = ii.DEFAULT);
    var r = this._items.map(function(s) {
      return s.key;
    }).indexOf(n);
    if (r > -1) {
      var i = this._items[r];
      return e === ii.PERSISTENT && (i.state = Gn.PERSISTENT), e !== ii.NO_CACHE && this.put(i), i;
    }
    return null;
  }, t.prototype.put = function(n) {
    var e, r;
    if (this._limit > 0) {
      var i = this._items.map(function(d) {
        return d.key;
      }).indexOf(n.key);
      if (i > -1)
        Jp.includes(this._items[i].state) && Jp.includes(n.state) ? (this._items.splice(i, 1), this._items.push(n)) : (this._items[i].state = n.state, this._items[i].value = n.value);
      else {
        this._items.push(n);
        var s = this._items.filter(function(d) {
          return d.state === Gn.VOLATILE;
        }), a = s.length - this._limit;
        if (a > 0) {
          var o = [];
          try {
            for (var l = de(this._items), c = l.next(); !c.done; c = l.next()) {
              var u = c.value;
              u.state === Gn.VOLATILE && a > 0 ? a-- : o.push(u);
            }
          } catch (d) {
            e = { error: d };
          } finally {
            try {
              c && !c.done && (r = l.return) && r.call(l);
            } finally {
              if (e)
                throw e.error;
            }
          }
          this._items = o;
        }
      }
    }
  }, t.prototype.remove = function(n) {
    var e = this._items.map(function(r) {
      return r.key;
    }).indexOf(n);
    e > -1 && this._items.splice(e, 1);
  }, t.prototype.clearByCondition = function(n) {
    this._items = this._items.filter(function(e) {
      return !n(e);
    });
  }, t.prototype.clearForDatabase = function(n) {
    this.clearByCondition(function(e) {
      return e.key.startsWith(Jd(n));
    });
  }, t.prototype.clear = function(n) {
    n === void 0 && (n = !1), this._items = n ? [] : this._items.filter(function(e) {
      return e.state !== Gn.VOLATILE;
    });
  }, t;
}(), ZE = function() {
  function t(n) {
    var e = n.dbname, r = n.collectionName, i = n.store;
    this._requests = [], this._onCommit = /* @__PURE__ */ new Map(), this._onWrite = /* @__PURE__ */ new Map(), this._onError = /* @__PURE__ */ new Map(), this.dbname = e, this.collectionName = r, this.metadataKey = function(s, a) {
      return "".concat(qs(s, a), "/trans.metadata");
    }(e, r), this.recordsetKey = function(s, a) {
      return "".concat(qs(s, a), "/trans.recordset");
    }(e, r), this._store = i;
  }
  return Object.defineProperty(t.prototype, "generation", { get: function() {
    return this._metadata ? this._metadata.generation : 0;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "requestCount", { get: function() {
    return this._requests.length;
  }, enumerable: !1, configurable: !0 }), t.prototype._getReducedRecordset = function(n) {
    return n === void 0 && (n = []), g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._store.get(this.recordsetKey)];
          case 1:
            return (e = r.sent() || []).push.apply(e, Re([], we(n), !1)), [2, this._reduceRecordSet(e)];
        }
      });
    });
  }, t.prototype._reduceRecordSet = function(n) {
    for (var e = [], r = {}, i = n.length - 1; i >= 0; i--) {
      for (var s = n[i], a = [], o = s.requests.length - 1; o >= 0; o--) {
        var l = s.requests[o], c = l.data;
        r[c.key] || (a.unshift(l), r[c.key] = !0);
      }
      a.length > 0 && (s.requests = a, e.unshift(s));
    }
    return e;
  }, t.prototype._applyRecord = function(n, e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u, d;
      return _(this, function(h) {
        switch (h.label) {
          case 0:
            r = ir.get(this.dbname), i = e.generation, s = e.requests, a = null, h.label = 1;
          case 1:
            return h.trys.push([1, 3, , 4]), [4, this._store.setMany(s.map(function(p) {
              return A(A({}, p.data), { generation: i });
            }))];
          case 2:
            for (o = h.sent(), l = 0; l < s.length; l++)
              o[l] instanceof Error && (a || (a = o[l]), c = s[l].data, r.put(A(A({}, c), { state: Gn.PERSISTENT })));
            return [3, 4];
          case 3:
            return u = h.sent(), a = u, [3, 4];
          case 4:
            return a ? [3, 6] : (d = n.filter(function(p) {
              return p.generation !== i;
            }), [4, this._store.set({ key: this.recordsetKey, value: d })]);
          case 5:
            return h.sent(), this._onWrite.forEach(function(p) {
              p(s.map(function(f) {
                return f.data;
              }));
            }), [3, 7];
          case 6:
            this._onError.forEach(function(p) {
              a && p(a);
            }), h.label = 7;
          case 7:
            return [2];
        }
      });
    });
  }, t.prototype.init = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return n = this, [4, this._store.get(this.metadataKey)];
          case 1:
            return n._metadata = c.sent() || { generation: 1 }, [4, this._getReducedRecordset()];
          case 2:
            e = c.sent(), c.label = 3;
          case 3:
            c.trys.push([3, 8, 9, 10]), r = de(e), i = r.next(), c.label = 4;
          case 4:
            return i.done ? [3, 7] : (s = i.value, [4, this._applyRecord(e, s)]);
          case 5:
            c.sent(), c.label = 6;
          case 6:
            return i = r.next(), [3, 4];
          case 7:
            return [3, 10];
          case 8:
            return a = c.sent(), o = { error: a }, [3, 10];
          case 9:
            try {
              i && !i.done && (l = r.return) && l.call(r);
            } finally {
              if (o)
                throw o.error;
            }
            return [7];
          case 10:
            return [2];
        }
      });
    });
  }, t.prototype.on = function(n, e, r) {
    switch (n) {
      case zs.COMMIT:
        this._onCommit.set(e, r);
        break;
      case zs.WRITE:
        this._onWrite.set(e, r);
        break;
      case zs.ERROR:
        this._onError.set(e, r);
    }
  }, t.prototype.requestWrite = function(n, e) {
    this._requests.push({ data: n, options: e }), ir.get(this.dbname).put(A({ state: Gn.PENDING }, n));
  }, t.prototype.requestMultipleWrite = function(n, e) {
    var r, i, s = ir.get(this.dbname);
    try {
      for (var a = de(n), o = a.next(); !o.done; o = a.next()) {
        var l = o.value;
        this._requests.push({ data: l, options: e }), s.put(A({ state: Gn.PENDING }, l));
      }
    } catch (c) {
      r = { error: c };
    } finally {
      try {
        o && !o.done && (i = a.return) && i.call(a);
      } finally {
        if (r)
          throw r.error;
      }
    }
  }, t.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        return ir.get(this.dbname).clearByCondition(function(e) {
          return e.state === Gn.PENDING;
        }), this._requests = [], [2];
      });
    });
  }, t.prototype.commit = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i, s, a, o, l, c, u, d, h, p = this;
      return _(this, function(f) {
        switch (f.label) {
          case 0:
            if (!((n = this._requests).length > 0))
              return [3, 4];
            for (e = [], r = {}, l = n.length - 1; l >= 0; l--)
              i = n[l], u = i.data, r[u.key] || (r[u.key] = !0, e.unshift(i));
            return s = { generation: this.generation, requests: e }, [4, this._getReducedRecordset([s])];
          case 1:
            return a = f.sent(), [4, this._store.set({ key: this.recordsetKey, value: a })];
          case 2:
            return f.sent(), this._metadata.generation++, [4, this._store.set({ key: this.metadataKey, value: this._metadata })];
          case 3:
            for (f.sent(), o = ir.get(this.dbname), l = 0; l < e.length; l++)
              c = e[l], u = c.data, d = c.options, o.put(A(A({}, u), { state: d && d.persistent ? Gn.PERSISTENT : Gn.VOLATILE }));
            this._requests = [], this._onCommit.forEach(function(m) {
              m(n.map(function(v) {
                return v.data;
              }));
            }), h = Po.get(this.dbname), setTimeout(function() {
              try {
                p._applyRecord(a, s);
              } catch (m) {
                p._onError.forEach(function(v) {
                  return v(m);
                });
              }
            }, h.transactionApplyDelay), f.label = 4;
          case 4:
            return [2];
        }
      });
    });
  }, t;
}(), Il = function() {
  function t(n) {
    var e = n.blockId, r = n.keyName, i = n.items, s = i === void 0 ? [] : i, a = n.limit;
    this.blockId = e, this.keyName = r, this.limit = a, this._items = Re([], we(s), !1);
  }
  return t.createFromCacheItem = function(n) {
    return n ? new t(n.value) : null;
  }, Object.defineProperty(t.prototype, "isEmpty", { get: function() {
    return this._items.length === 0;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "items", { get: function() {
    return this._items;
  }, enumerable: !1, configurable: !0 }), t.prototype.serialize = function() {
    return { blockId: this.blockId, keyName: this.keyName, limit: this.limit, items: this._items };
  }, t.prototype.getItemByKey = function(n) {
    var e = this, r = this._items.find(function(i) {
      var s = i[e.keyName];
      return n === s;
    });
    return r ?? null;
  }, t.prototype.has = function(n) {
    var e = this;
    return this._items.map(function(r) {
      return r[e.keyName];
    }).includes(n);
  }, t.prototype.add = function(n) {
    var e = this, r = this._items.map(function(i) {
      return i[e.keyName];
    }).indexOf(n[this.keyName]);
    return r < 0 ? this._items.length < this.limit && (this._items.push(n), !0) : (this._items[r] = n, !0);
  }, t.prototype.remove = function(n) {
    for (var e = 0; e < this._items.length; e++)
      if (this._items[e][this.keyName] === n)
        return this._items.splice(e, 1), !0;
    return !1;
  }, t.prototype.clear = function() {
    this._items = [];
  }, t;
}(), XE = function() {
  function t(n) {
    var e = n.dbname, r = n.collectionName, i = n.metadata, s = n.hashFunction, a = s === void 0 ? Yp : s, o = n.transaction, l = n.store;
    this.dbname = e, this.collectionName = r, this.hashFunction = a, this.metadata = i, this._transaction = o, this._store = l;
  }
  return Object.defineProperty(t.prototype, "keyName", { get: function() {
    return this.metadata.keyName;
  }, enumerable: !1, configurable: !0 }), t.prototype.createBlockId = function(n, e) {
    return e === void 0 && (e = this.metadata.blockLevel), r = this.dbname, i = this.collectionName, s = e, a = "".concat(function(o, l, c) {
      var u = c.base * Math.pow(c.multiplier, l) + c.constant;
      return (c.hashFunction || Yp)(o, u);
    }(n, e, { hashFunction: this.hashFunction, base: this.metadata.blockHashBase, multiplier: this.metadata.blockHashMultiplier, constant: this.metadata.blockHashConstant })), "".concat(fd(r, i)).concat(s, ".").concat(a);
    var r, i, s, a;
  }, t.prototype._findBlock = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            e = ir.get(this.dbname), r = this.metadata.blockLevel, o.label = 1;
          case 1:
            return r > 0 ? (i = this.createBlockId(n, r), [4, e.find(this._store, i)]) : [3, 4];
          case 2:
            if ((s = o.sent()) && ((a = Il.createFromCacheItem(s)) != null && a.getItemByKey(n)))
              return [2, a];
            o.label = 3;
          case 3:
            return r--, [3, 1];
          case 4:
            return [2, null];
        }
      });
    });
  }, t.prototype.getFromBlock = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._findBlock(n)];
          case 1:
            return [2, (e = r.sent()) ? e.getItemByKey(n) : null];
        }
      });
    });
  }, t.prototype.putToBlock = function(n, e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return r = Po.get(this.dbname), i = this.createBlockId(n), s = Math.floor(this._store.itemSizeLimit / r.itemSizeLimit), [4, ir.get(this.dbname).find(this._store, i)];
          case 1:
            return a = l.sent(), (o = a ? Il.createFromCacheItem(a) : new Il({ blockId: i, keyName: this.keyName, items: [], limit: s })) != null && o.add(e) ? (this._transaction.requestWrite({ key: o.blockId, value: o.serialize() }), [2, !0]) : [2, !1];
        }
      });
    });
  }, t.prototype.removeFromBlock = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._findBlock(n)];
          case 1:
            return (e = r.sent()) && e.remove(n) ? (this._transaction.requestWrite({ key: e.blockId, value: e.serialize() }), [2, !0]) : [2, !1];
        }
      });
    });
  }, t.prototype.clearAllBlocks = function() {
    return g(this, 0, void 0, function() {
      var n, e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return n = fd(this.dbname, this.collectionName), [4, this._store.getAllKeys()];
          case 1:
            return e = i.sent(), r = e.filter(function(s) {
              return s.startsWith(n);
            }), [4, this._store.removeMany(r)];
          case 2:
            return i.sent(), [4, this._transaction.clear()];
          case 3:
            return i.sent(), ir.get(this.dbname).clearByCondition(function(s) {
              return s.key.startsWith(n);
            }), [2];
        }
      });
    });
  }, t;
}(), Gi = function() {
  function t(n) {
    var e = n.dbname, r = n.collectionName, i = n.keyName, s = n.fields, a = n.transaction, o = n.store, l = this;
    this._origin = [], this._table = [];
    var c = function(u, d, h) {
      return "".concat(qs(u, d), "/index.").concat(h);
    }(e, r, s.join(">"));
    this.dbname = e, this.collectionName = r, this.keyName = i, this.fields = s, this.indexerKey = c, this._store = o, this._transaction = a, this._transaction.on(zs.COMMIT, this.indexerKey, function() {
      return l.commit();
    }), this._transaction.on(zs.ERROR, this.indexerKey, function() {
      return l.abort();
    });
  }
  return t.createKey = function(n) {
    return n.join(">");
  }, t.parseKey = function(n) {
    return n.split(">");
  }, t.prototype._addItem = function(n) {
    var e = n[this.keyName], r = this.getColumnValues(n), i = we(this.indexOf(r), 2), s = i[0];
    return i[1] ? !this._table[s].keys.includes(e) && (this._table[s].keys.push(e), !0) : (this._table.splice(s, 0, { columnValues: r, keys: [e] }), !0);
  }, t.prototype._removeItem = function(n) {
    var e = n[this.keyName], r = this.getColumnValues(n), i = we(this.indexOf(r), 2), s = i[0];
    if (i[1]) {
      var a = this._table[s].keys.indexOf(e);
      if (a > -1)
        return this._table[s].keys.splice(a, 1), this._table[s].keys.length === 0 && this._table.splice(s, 1), !0;
    }
    return !1;
  }, Object.defineProperty(t.prototype, "origin", { get: function() {
    return this._origin;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "table", { get: function() {
    return this._table;
  }, enumerable: !1, configurable: !0 }), t.prototype.getColumnValues = function(n) {
    var e, r, i, s, a = [];
    try {
      for (var o = de(this.fields), l = o.next(); !l.done; l = o.next()) {
        var c = l.value;
        if (c[0] === "-" && (c = c.slice(1)), i = n[c], s = typeof i, i !== null && s !== "undefined" && s !== "boolean" && s !== "number" && s !== "string")
          throw Ct.indexTypesNotMatch;
        a.push(n[c]);
      }
    } catch (u) {
      e = { error: u };
    } finally {
      try {
        l && !l.done && (r = o.return) && r.call(o);
      } finally {
        if (e)
          throw e.error;
      }
    }
    return a;
  }, t.prototype.diff = function(n, e) {
    for (var r in this.fields) {
      var i = this.fields[r][0] === "-" ? -1 : 1, s = Oi(n[r], e[r]);
      if (s !== 0)
        return i * s;
    }
    return 0;
  }, t.prototype.indexOf = function(n) {
    if (this._table.length > 0) {
      for (var e = 0, r = this._table.length - 1; e <= r; ) {
        var i = Math.floor((e + r) / 2), s = this.diff(n, this._table[i].columnValues);
        if (s > 0)
          e = i + 1;
        else {
          if (!(s < 0))
            return [i, !0];
          r = i - 1;
        }
      }
      return [e, !1];
    }
    return [0, !1];
  }, t.prototype.ensure = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i, s, a, o, l, c, u, d, h, p, f, m, v, E;
      return _(this, function(y) {
        switch (y.label) {
          case 0:
            return [4, (n = ir.get(this.dbname)).find(this._store, this.indexerKey, ii.PERSISTENT)];
          case 1:
            return (e = y.sent()) ? [3, 11] : (r = fd(this.dbname, this.collectionName), [4, this._store.getAllKeys()]);
          case 2:
            i = y.sent(), y.label = 3;
          case 3:
            y.trys.push([3, 8, 9, 10]), s = de(i), a = s.next(), y.label = 4;
          case 4:
            return a.done ? [3, 7] : (o = a.value).startsWith(r) ? [4, n.find(this._store, o, ii.NO_CACHE)] : [3, 6];
          case 5:
            if (l = y.sent(), c = Il.createFromCacheItem(l))
              try {
                for (v = void 0, u = de(c.items), d = u.next(); !d.done; d = u.next())
                  h = d.value, this._addItem(h);
              } catch (b) {
                v = { error: b };
              } finally {
                try {
                  d && !d.done && (E = u.return) && E.call(u);
                } finally {
                  if (v)
                    throw v.error;
                }
              }
            y.label = 6;
          case 6:
            return a = s.next(), [3, 4];
          case 7:
            return [3, 10];
          case 8:
            return p = y.sent(), f = { error: p }, [3, 10];
          case 9:
            try {
              a && !a.done && (m = s.return) && m.call(s);
            } finally {
              if (f)
                throw f.error;
            }
            return [7];
          case 10:
            return this._transaction.requestWrite({ key: this.indexerKey, value: this._table }, { persistent: !0 }), [3, 12];
          case 11:
            this._origin = e.value, this._table = tr(this._origin), y.label = 12;
          case 12:
            return [2];
        }
      });
    });
  }, t.prototype.drop = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return ir.get(this.dbname).remove(this.indexerKey), [4, this._store.remove(this.indexerKey)];
          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, t.prototype.addItem = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        return this._addItem(n) && this._transaction.requestWrite({ key: this.indexerKey, value: this._table }, { persistent: !0 }), [2];
      });
    });
  }, t.prototype.removeItem = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        return this._removeItem(n) && this._transaction.requestWrite({ key: this.indexerKey, value: this._table }, { persistent: !0 }), [2];
      });
    });
  }, t.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        return this._table = [], this._transaction.requestWrite({ key: this.indexerKey, value: this._table }, { persistent: !0 }), [2];
      });
    });
  }, t.prototype.commit = function() {
    this._origin = this._table, this._table = tr(this._origin);
  }, t.prototype.abort = function() {
    this._table = tr(this._origin);
  }, t;
}(), nc = function() {
  return typeof document < "u" && typeof navigator < "u" && navigator.product !== "ReactNative";
}, ef = function() {
  var t = (/* @__PURE__ */ new Date()).getTime();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(n) {
    var e = (t + 16 * Math.random()) % 16 | 0;
    return t = Math.floor(t / 16), (n === "x" ? e : 3 & e | 8).toString(16);
  });
};
(function(t) {
  t[t.PROCESSING = 0] = "PROCESSING", t[t.DONE = 1] = "DONE";
})(po || (po = {})), function(t) {
  t.NEWNODE = "newnode", t.REMOVENODE = "removenode", t.CLAIM_HOST = "claimhost", t.SYNC_HOST = "synchost", t.REQUEST_LOCK = "requestlock", t.ACQUIRE_LOCK = "acquirelock", t.RELEASE_LOCK = "releaselock";
}(zn || (zn = {}));
var qr, mu = {}, eh = function() {
  function t(n, e) {
    e === void 0 && (e = {});
    var r = this;
    return this._state = po.PROCESSING, this._queue = [], this._activationQueue = [], mu[n] && !e.forceCreate || (this.nodeId = ef(), this.key = n, nc() && (e.startAsInvisible ? this.registerNode() : document.visibilityState === "visible" ? this.claimHost() : this.registerNode(), document.addEventListener("visibilitychange", function() {
      document.visibilityState === "visible" && r.claimHost();
    }), window.addEventListener("message", function(i) {
      var s, a, o = i.data;
      if (o != null && o.isNestDbMessage) {
        var l = o.nodeId, c = o.requestId, u = o.key, d = o.op, h = o.data;
        if (l !== r.nodeId && u === r.key)
          switch (d) {
            case zn.NEWNODE:
              r._sendSync();
              break;
            case zn.CLAIM_HOST:
              r._sendSync(), r._hostId = l;
              break;
            case zn.SYNC_HOST:
              if (!r.isInSync) {
                r._activationTimeout && clearTimeout(r._activationTimeout);
                var p = h, f = p.currentItemRequestId, m = p.queue, v = function(T) {
                  r._queue.findIndex(function(w) {
                    return w.requestId === T.requestId;
                  }) < 0 && r._requestLock({ isNestDbMessage: !0, nodeId: T.nodeId, requestId: T.requestId, key: r.key, op: zn.REQUEST_LOCK, ts: T.ts });
                };
                try {
                  for (var E = de(m), y = E.next(); !y.done; y = E.next())
                    v(y.value);
                } catch (T) {
                  s = { error: T };
                } finally {
                  try {
                    y && !y.done && (a = E.return) && a.call(E);
                  } finally {
                    if (s)
                      throw s.error;
                  }
                }
                r._currentItem = r._queue.find(function(T) {
                  return T.requestId === f;
                }), r._completeSync();
              }
              break;
            case zn.REMOVENODE:
              r._queue = r._queue.filter(function(T) {
                return T.nodeId !== o.nodeId;
              }), r._currentItem && r._currentItem.nodeId === o.nodeId && (r._currentItem = void 0, r._acquire(r._queue[0]));
              break;
            case zn.REQUEST_LOCK:
              r._requestLock(o);
              break;
            case zn.ACQUIRE_LOCK:
              var b = r._queue.find(function(T) {
                return T.requestId === c;
              });
              r._acquire(b);
              break;
            case zn.RELEASE_LOCK:
              r._release(c);
          }
      }
    }), window.addEventListener("beforeunload", function() {
      r._send(zn.REMOVENODE);
    })), mu[n] = this), mu[n];
  }
  return Object.defineProperty(t.prototype, "locked", { get: function() {
    return !!this._currentItem;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "isHost", { get: function() {
    return this._hostId === this.nodeId;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "isInSync", { get: function() {
    return this._state == po.DONE;
  }, enumerable: !1, configurable: !0 }), t.prototype._send = function(n, e) {
    var r;
    e === void 0 && (e = {});
    var i = { isNestDbMessage: !0, nodeId: this.nodeId, requestId: (r = e == null ? void 0 : e.requestId) !== null && r !== void 0 ? r : ef(), key: this.key, op: n, data: e.data, ts: Date.now() };
    return nc() && window.postMessage(i, "*"), i;
  }, t.prototype._acquire = function(n) {
    n ? (this._currentItem = n, this._currentItem.onAcquired && this._currentItem.onAcquired(n.requestId)) : this._currentItem = void 0;
  }, t.prototype._release = function(n) {
    if (this._currentItem && this._currentItem.requestId === n) {
      var e = this._currentItem;
      this._currentItem = void 0, e.nodeId === this.nodeId && this._send(zn.RELEASE_LOCK, { requestId: e.requestId });
      var r = this._queue.findIndex(function(i) {
        return i.requestId === n;
      });
      r > -1 && this._queue.splice(r, 1), e.onReleased && e.onReleased(n);
    }
  }, t.prototype._requestLock = function(n) {
    var e = this;
    return new Promise(function(r) {
      for (var i = { nodeId: n.nodeId, requestId: n.requestId, ts: n.ts, onAcquired: function(o) {
        e.isHost && e._send(zn.ACQUIRE_LOCK, { requestId: o }), r();
      }, onReleased: function() {
        e._acquire(e._queue[0]);
      } }, s = !1, a = 0; a < e._queue.length; a++)
        if (e._queue[a].ts > i.ts) {
          e._queue.splice(a, 0, i), s = !0;
          break;
        }
      s || e._queue.push(i), e._currentItem || e._acquire(e._queue[0]);
    });
  }, t.prototype._sendSync = function() {
    var n;
    this.isHost && this._send(zn.SYNC_HOST, { data: { currentItemRequestId: (n = this._currentItem) === null || n === void 0 ? void 0 : n.requestId, queue: this._queue.map(function(e) {
      return { nodeId: e.nodeId, requestId: e.requestId, ts: e.ts };
    }) } });
  }, t.prototype._waitUntilSyncCompleted = function() {
    return g(this, 0, void 0, function() {
      var n = this;
      return _(this, function(e) {
        return this.isHost && !this.isInSync ? [2, new Promise(function(r) {
          n._activationQueue.push(r);
        })] : [2];
      });
    });
  }, t.prototype._waitSync = function() {
    var n = this;
    this.isInSync || (this._activationTimeout = setTimeout(function() {
      n._completeSync();
    }, 8));
  }, t.prototype._completeSync = function() {
    this.isInSync || (this._state = po.DONE, this._activationQueue.forEach(function(n) {
      return n();
    }), this._activationQueue = []);
  }, t.prototype.registerNode = function() {
    this._send(zn.NEWNODE), this._waitSync();
  }, t.prototype.claimHost = function() {
    this._hostId = this.nodeId, this._send(zn.CLAIM_HOST), this._waitSync();
  }, t.prototype.lock = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this._waitUntilSyncCompleted()];
          case 1:
            return e.sent(), n = this._send(zn.REQUEST_LOCK), [4, this._requestLock(n)];
          case 2:
            return e.sent(), [2];
        }
      });
    });
  }, t.prototype.unlock = function() {
    var n;
    !((n = this._currentItem) === null || n === void 0) && n.requestId && this._release(this._currentItem.requestId);
  }, t;
}(), _u = function() {
  function t(n) {
    var e = n.dbname, r = n.collectionName, i = n.keyName, s = n.keyHash, a = n.indexes, o = n.store, l = this;
    this._state = Us.INIT, this._indexers = [], this.dbname = e, this.name = r, this.keyName = i, this.indexes = Re([[i]], we(a.filter(function(c) {
      return Gi.createKey(c) !== l.keyName;
    })), !1), this._keyHash = s, this._store = o, this._mutex = new eh(function(c, u) {
      return "".concat(qs(c, u), ".lock");
    }(e, r)), this._blobContainer = new $E({ dbname: e, collectionName: r, store: o }), this._transaction = new ZE({ dbname: e, collectionName: r, store: o });
  }
  return t.metadataOf = function(n, e, r) {
    return g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = fu(n, e), [4, r.get(i)];
          case 1:
            return [2, s.sent()];
        }
      });
    });
  }, Object.defineProperty(t.prototype, "state", { get: function() {
    return this._state;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "isReady", { get: function() {
    return this._state === Us.READY;
  }, enumerable: !1, configurable: !0 }), t.prototype.init = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i, s, a, o, l, c, u, d, h, p, f, m = this;
      return _(this, function(v) {
        switch (v.label) {
          case 0:
            return [4, this._mutex.lock()];
          case 1:
            v.sent(), v.label = 2;
          case 2:
            return v.trys.push([2, 9, , 10]), n = Po.get(this.dbname), [4, t.metadataOf(this.dbname, this.name, this._store)];
          case 3:
            return e = v.sent(), this._metadata = e || { keyName: this.keyName, blockLevel: 1, blockHashBase: n.blockHashBase, blockHashMultiplier: n.blockHashMultiplier, blockHashConstant: n.blockHashConstant, indexes: this.indexes }, [4, this._transaction.init()];
          case 4:
            v.sent(), this._blockManager = new XE({ dbname: this.dbname, collectionName: this.name, hashFunction: this._keyHash, metadata: this._metadata, transaction: this._transaction, store: this._store }), r = Re([], we(this.indexes), !1), i = [], s = r.map(function(E) {
              return Gi.createKey(E);
            }), a = e ? e.indexes.map(function(E) {
              return Gi.createKey(E);
            }) : [];
            try {
              for (o = de(a), l = o.next(); !l.done; l = o.next())
                c = l.value, s.includes(c) || i.push(Gi.parseKey(c));
            } catch (E) {
              p = { error: E };
            } finally {
              try {
                l && !l.done && (f = o.return) && f.call(o);
              } finally {
                if (p)
                  throw p.error;
              }
            }
            return (u = []).push.apply(u, Re([], we(r.map(function(E) {
              var y = new Gi({ dbname: m.dbname, collectionName: m.name, keyName: m.keyName, fields: E, transaction: m._transaction, store: m._store });
              return m._indexers.push(y), y.ensure();
            })), !1)), u.push.apply(u, Re([], we(i.map(function(E) {
              return new Gi({ dbname: m.dbname, collectionName: m.name, keyName: m.keyName, fields: E, transaction: m._transaction, store: m._store }).drop();
            })), !1)), [4, Promise.all(u)];
          case 5:
            return v.sent(), [4, this._transaction.commit()];
          case 6:
            return v.sent(), s.sort().join(",") === a.sort().join(",") ? [3, 8] : (d = fu(this.dbname, this.name), this._metadata.indexes = r, [4, this._store.set({ key: d, value: this._metadata })]);
          case 7:
            v.sent(), v.label = 8;
          case 8:
            return this._state = Us.READY, this._mutex.unlock(), [3, 10];
          case 9:
            throw h = v.sent(), this._mutex.unlock(), h;
          case 10:
            return [2];
        }
      });
    });
  }, t.prototype.close = function() {
    this._state = Us.CLOSED;
  }, t.prototype._hasPropertyOfKeyName = function(n) {
    var e = n[this.keyName];
    return typeof e == "string" && !!e;
  }, t.prototype._getIndexerBy = function(n) {
    var e, r;
    n === void 0 && (n = null), n || (n = [this.keyName]);
    var i = Gi.createKey(n);
    try {
      for (var s = de(this._indexers), a = s.next(); !a.done; a = s.next()) {
        var o = a.value;
        if (i === Gi.createKey(o.fields))
          return o;
      }
    } catch (l) {
      e = { error: l };
    } finally {
      try {
        a && !a.done && (r = s.return) && r.call(s);
      } finally {
        if (e)
          throw e.error;
      }
    }
    throw Ct.indexTableIsRequired;
  }, t.prototype._upgradeBlockLevel = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return n = fu(this.dbname, this.name), this._metadata.blockLevel++, [4, this._store.set({ key: n, value: this._metadata })];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, t.prototype._requestInsert = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return e = n[this.keyName], [4, this._blockManager.getFromBlock(e)];
          case 1:
            return l.sent() ? [3, 13] : [4, this._blockManager.putToBlock(e, n)];
          case 2:
            return l.sent() ? [3, 5] : [4, this._upgradeBlockLevel()];
          case 3:
            return l.sent(), [4, this._blockManager.putToBlock(e, n)];
          case 4:
            l.sent(), l.label = 5;
          case 5:
            l.trys.push([5, 10, 11, 12]), r = de(this._indexers), i = r.next(), l.label = 6;
          case 6:
            return i.done ? [3, 9] : [4, i.value.addItem(n)];
          case 7:
            l.sent(), l.label = 8;
          case 8:
            return i = r.next(), [3, 6];
          case 9:
            return [3, 12];
          case 10:
            return s = l.sent(), a = { error: s }, [3, 12];
          case 11:
            try {
              i && !i.done && (o = r.return) && o.call(r);
            } finally {
              if (a)
                throw a.error;
            }
            return [7];
          case 12:
            return [3, 14];
          case 13:
            throw Ct.collectionInsertDuplicate;
          case 14:
            return [2];
        }
      });
    });
  }, t.prototype._requestUpsert = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c, u, d, h, p, f;
      return _(this, function(m) {
        switch (m.label) {
          case 0:
            return e = n[this.keyName], [4, this._blockManager.getFromBlock(e)];
          case 1:
            return (r = m.sent()) ? [3, 13] : [4, this._blockManager.putToBlock(e, n)];
          case 2:
            return m.sent() ? [3, 5] : [4, this._upgradeBlockLevel()];
          case 3:
            return m.sent(), [4, this._blockManager.putToBlock(e, n)];
          case 4:
            m.sent(), m.label = 5;
          case 5:
            m.trys.push([5, 10, 11, 12]), i = de(this._indexers), s = i.next(), m.label = 6;
          case 6:
            return s.done ? [3, 9] : [4, (c = s.value).addItem(n)];
          case 7:
            m.sent(), m.label = 8;
          case 8:
            return s = i.next(), [3, 6];
          case 9:
            return [3, 12];
          case 10:
            return a = m.sent(), d = { error: a }, [3, 12];
          case 11:
            try {
              s && !s.done && (h = i.return) && h.call(i);
            } finally {
              if (d)
                throw d.error;
            }
            return [7];
          case 12:
            return [3, 23];
          case 13:
            return [4, this._blockManager.putToBlock(e, n)];
          case 14:
            m.sent(), m.label = 15;
          case 15:
            m.trys.push([15, 21, 22, 23]), o = de(this._indexers), l = o.next(), m.label = 16;
          case 16:
            return l.done ? [3, 20] : (c = l.value).diff(c.getColumnValues(r), c.getColumnValues(n)) === 0 ? [3, 19] : [4, c.removeItem(r)];
          case 17:
            return m.sent(), [4, c.addItem(n)];
          case 18:
            m.sent(), m.label = 19;
          case 19:
            return l = o.next(), [3, 16];
          case 20:
            return [3, 23];
          case 21:
            return u = m.sent(), p = { error: u }, [3, 23];
          case 22:
            try {
              l && !l.done && (f = o.return) && f.call(o);
            } finally {
              if (p)
                throw p.error;
            }
            return [7];
          case 23:
            return [2];
        }
      });
    });
  }, t.prototype._requestUpdate = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return e = n[this.keyName], [4, this._blockManager.getFromBlock(e)];
          case 1:
            return (r = u.sent()) ? [4, this._blockManager.putToBlock(e, n)] : [3, 11];
          case 2:
            u.sent(), u.label = 3;
          case 3:
            u.trys.push([3, 9, 10, 11]), i = de(this._indexers), s = i.next(), u.label = 4;
          case 4:
            return s.done ? [3, 8] : (a = s.value).diff(a.getColumnValues(r), a.getColumnValues(n)) === 0 ? [3, 7] : [4, a.removeItem(r)];
          case 5:
            return u.sent(), [4, a.addItem(n)];
          case 6:
            u.sent(), u.label = 7;
          case 7:
            return s = i.next(), [3, 4];
          case 8:
            return [3, 11];
          case 9:
            return o = u.sent(), l = { error: o }, [3, 11];
          case 10:
            try {
              s && !s.done && (c = i.return) && c.call(i);
            } finally {
              if (l)
                throw l.error;
            }
            return [7];
          case 11:
            return [2];
        }
      });
    });
  }, t.prototype._requestRemove = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, this._blockManager.getFromBlock(n)];
          case 1:
            return (e = l.sent()) ? [4, this._blockManager.removeFromBlock(n)] : [3, 10];
          case 2:
            l.sent(), l.label = 3;
          case 3:
            l.trys.push([3, 8, 9, 10]), r = de(this._indexers), i = r.next(), l.label = 4;
          case 4:
            return i.done ? [3, 7] : [4, i.value.removeItem(e)];
          case 5:
            l.sent(), l.label = 6;
          case 6:
            return i = r.next(), [3, 4];
          case 7:
            return [3, 10];
          case 8:
            return s = l.sent(), a = { error: s }, [3, 10];
          case 9:
            try {
              i && !i.done && (o = r.return) && o.call(r);
            } finally {
              if (a)
                throw a.error;
            }
            return [7];
          case 10:
            return [2];
        }
      });
    });
  }, t.prototype._requestClear = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return [4, this._blockManager.clearAllBlocks()];
          case 1:
            a.sent(), a.label = 2;
          case 2:
            a.trys.push([2, 7, 8, 9]), n = de(this._indexers), e = n.next(), a.label = 3;
          case 3:
            return e.done ? [3, 6] : [4, e.value.clear()];
          case 4:
            a.sent(), a.label = 5;
          case 5:
            return e = n.next(), [3, 3];
          case 6:
            return [3, 9];
          case 7:
            return r = a.sent(), i = { error: r }, [3, 9];
          case 8:
            try {
              e && !e.done && (s = n.return) && s.call(n);
            } finally {
              if (i)
                throw i.error;
            }
            return [7];
          case 9:
            return [2];
        }
      });
    });
  }, t.prototype.getByKey = function(n) {
    return g(this, 0, void 0, function() {
      var e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.isReady ? [4, this._mutex.lock()] : [3, 6];
          case 1:
            i.sent(), i.label = 2;
          case 2:
            return i.trys.push([2, 4, , 5]), [4, this._blockManager.getFromBlock(n)];
          case 3:
            return e = i.sent(), this._mutex.unlock(), [2, tr(e)];
          case 4:
            throw r = i.sent(), this._mutex.unlock(), r;
          case 5:
            return [3, 7];
          case 6:
            throw Ct.collectionNotReady;
          case 7:
            return [2];
        }
      });
    });
  }, t.prototype.query = function(n) {
    if (n === void 0 && (n = {}), this.isReady)
      return new YE({ condition: n.where, mutex: this._mutex, blockManager: this._blockManager, indexer: this._getIndexerBy(n.index), backward: !!n.backward });
    throw Ct.collectionNotReady;
  }, t.prototype.insertOne = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this.isReady ? [4, this._mutex.lock()] : [3, 8];
          case 1:
            r.sent(), r.label = 2;
          case 2:
            if (r.trys.push([2, 5, , 7]), !this._hasPropertyOfKeyName(n))
              throw Ct.collectionKeyNotGiven;
            return [4, this._requestInsert(tr(n))];
          case 3:
            return r.sent(), [4, this._transaction.commit()];
          case 4:
            return r.sent(), this._mutex.unlock(), [2, n];
          case 5:
            return e = r.sent(), [4, this._transaction.clear()];
          case 6:
            throw r.sent(), this._mutex.unlock(), e;
          case 7:
            return [3, 9];
          case 8:
            throw Ct.collectionNotReady;
          case 9:
            return [2];
        }
      });
    });
  }, t.prototype.insertMany = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c = this;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return this.isReady ? [4, this._mutex.lock()] : [3, 15];
          case 1:
            u.sent(), u.label = 2;
          case 2:
            if (u.trys.push([2, 12, , 14]), n.some(function(d) {
              return !c._hasPropertyOfKeyName(d);
            }))
              throw Ct.collectionKeyNotGiven;
            u.label = 3;
          case 3:
            u.trys.push([3, 8, 9, 10]), e = de(n), r = e.next(), u.label = 4;
          case 4:
            return r.done ? [3, 7] : (i = r.value, [4, this._requestInsert(tr(i))]);
          case 5:
            u.sent(), u.label = 6;
          case 6:
            return r = e.next(), [3, 4];
          case 7:
            return [3, 10];
          case 8:
            return s = u.sent(), o = { error: s }, [3, 10];
          case 9:
            try {
              r && !r.done && (l = e.return) && l.call(e);
            } finally {
              if (o)
                throw o.error;
            }
            return [7];
          case 10:
            return [4, this._transaction.commit()];
          case 11:
            return u.sent(), this._mutex.unlock(), [2, n];
          case 12:
            return a = u.sent(), [4, this._transaction.clear()];
          case 13:
            throw u.sent(), this._mutex.unlock(), a;
          case 14:
            return [3, 16];
          case 15:
            throw Ct.collectionNotReady;
          case 16:
            return [2];
        }
      });
    });
  }, t.prototype.upsertOne = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this.isReady ? [4, this._mutex.lock()] : [3, 8];
          case 1:
            r.sent(), r.label = 2;
          case 2:
            if (r.trys.push([2, 5, , 7]), !this._hasPropertyOfKeyName(n))
              throw Ct.collectionKeyNotGiven;
            return [4, this._requestUpsert(tr(n))];
          case 3:
            return r.sent(), [4, this._transaction.commit()];
          case 4:
            return r.sent(), this._mutex.unlock(), [2, n];
          case 5:
            return e = r.sent(), [4, this._transaction.clear()];
          case 6:
            throw r.sent(), this._mutex.unlock(), e;
          case 7:
            return [3, 9];
          case 8:
            throw Ct.collectionNotReady;
          case 9:
            return [2];
        }
      });
    });
  }, t.prototype.upsertMany = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c = this;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return this.isReady ? [4, this._mutex.lock()] : [3, 15];
          case 1:
            u.sent(), u.label = 2;
          case 2:
            if (u.trys.push([2, 12, , 14]), n.some(function(d) {
              return !c._hasPropertyOfKeyName(d);
            }))
              throw Ct.collectionKeyNotGiven;
            u.label = 3;
          case 3:
            u.trys.push([3, 8, 9, 10]), e = de(n), r = e.next(), u.label = 4;
          case 4:
            return r.done ? [3, 7] : (i = r.value, [4, this._requestUpsert(tr(i))]);
          case 5:
            u.sent(), u.label = 6;
          case 6:
            return r = e.next(), [3, 4];
          case 7:
            return [3, 10];
          case 8:
            return s = u.sent(), o = { error: s }, [3, 10];
          case 9:
            try {
              r && !r.done && (l = e.return) && l.call(e);
            } finally {
              if (o)
                throw o.error;
            }
            return [7];
          case 10:
            return [4, this._transaction.commit()];
          case 11:
            return u.sent(), this._mutex.unlock(), [2, n];
          case 12:
            return a = u.sent(), [4, this._transaction.clear()];
          case 13:
            throw u.sent(), this._mutex.unlock(), a;
          case 14:
            return [3, 16];
          case 15:
            throw Ct.collectionNotReady;
          case 16:
            return [2];
        }
      });
    });
  }, t.prototype.update = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this.isReady ? [4, this._mutex.lock()] : [3, 8];
          case 1:
            r.sent(), r.label = 2;
          case 2:
            if (r.trys.push([2, 5, , 7]), !this._hasPropertyOfKeyName(n))
              throw Ct.collectionKeyNotGiven;
            return [4, this._requestUpdate(tr(n))];
          case 3:
            return r.sent(), [4, this._transaction.commit()];
          case 4:
            return r.sent(), this._mutex.unlock(), [2, n];
          case 5:
            return e = r.sent(), [4, this._transaction.clear()];
          case 6:
            throw r.sent(), this._mutex.unlock(), e;
          case 7:
            return [3, 9];
          case 8:
            throw Ct.collectionNotReady;
          case 9:
            return [2];
        }
      });
    });
  }, t.prototype.updateIf = function(n, e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u, d, h, p, f, m, v, E = this;
      return _(this, function(y) {
        switch (y.label) {
          case 0:
            return this.isReady ? [4, this._mutex.lock()] : [3, 16];
          case 1:
            y.sent(), y.label = 2;
          case 2:
            return y.trys.push([2, 13, , 15]), r = n.where, i = r === void 0 ? {} : r, s = n.index, a = s === void 0 ? null : s, o = n.backward, l = o !== void 0 && o, c = [], [4, new pd({ condition: i, blockManager: this._blockManager, backward: l, indexer: this._getIndexerBy(a) }).each(function(b) {
              return g(E, 0, void 0, function() {
                var T;
                return _(this, function(w) {
                  if (b.error)
                    throw b.stop(), b.error;
                  return b.hasNext ? (T = b.nextValue, Bs(i, T) && e.set && (typeof e.set != "function" ? Object.keys(e.set).forEach(function(N) {
                    var M;
                    T[N] = (M = e.set) === null || M === void 0 ? void 0 : M[N];
                  }) : e.set(T), c.push(T)), b.next()) : b.stop(), [2];
                });
              });
            })];
          case 3:
            y.sent(), y.label = 4;
          case 4:
            y.trys.push([4, 9, 10, 11]), u = de(c), d = u.next(), y.label = 5;
          case 5:
            return d.done ? [3, 8] : (h = d.value, [4, this._requestUpdate(tr(h))]);
          case 6:
            y.sent(), y.label = 7;
          case 7:
            return d = u.next(), [3, 5];
          case 8:
            return [3, 11];
          case 9:
            return p = y.sent(), m = { error: p }, [3, 11];
          case 10:
            try {
              d && !d.done && (v = u.return) && v.call(u);
            } finally {
              if (m)
                throw m.error;
            }
            return [7];
          case 11:
            return [4, this._transaction.commit()];
          case 12:
            return y.sent(), this._mutex.unlock(), [2, c];
          case 13:
            return f = y.sent(), [4, this._transaction.clear()];
          case 14:
            throw y.sent(), this._mutex.unlock(), f;
          case 15:
            return [3, 17];
          case 16:
            throw this._transaction.clear(), Ct.collectionNotReady;
          case 17:
            return [2];
        }
      });
    });
  }, t.prototype.remove = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this.isReady ? [4, this._mutex.lock()] : [3, 8];
          case 1:
            r.sent(), r.label = 2;
          case 2:
            return r.trys.push([2, 5, , 7]), [4, this._requestRemove(n)];
          case 3:
            return r.sent(), [4, this._transaction.commit()];
          case 4:
            return r.sent(), this._mutex.unlock(), [3, 7];
          case 5:
            return e = r.sent(), [4, this._transaction.clear()];
          case 6:
            throw r.sent(), this._mutex.unlock(), e;
          case 7:
            return [3, 9];
          case 8:
            throw Ct.collectionNotReady;
          case 9:
            return [2];
        }
      });
    });
  }, t.prototype.removeIf = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c, u, d, h, p, f, m, v = this;
      return _(this, function(E) {
        switch (E.label) {
          case 0:
            return this.isReady ? [4, this._mutex.lock()] : [3, 15];
          case 1:
            E.sent(), E.label = 2;
          case 2:
            return E.trys.push([2, 13, , 14]), e = n.where, r = e === void 0 ? {} : e, i = n.index, s = i === void 0 ? null : i, a = n.backward, o = a !== void 0 && a, l = [], [4, new pd({ condition: r, blockManager: this._blockManager, backward: o, indexer: this._getIndexerBy(s) }).each(function(y) {
              return g(v, 0, void 0, function() {
                var b, T;
                return _(this, function(w) {
                  if (y.error)
                    throw y.stop(), y.error;
                  return y.hasNext ? (b = y.nextValue, Bs(r, b) && (T = b[this.keyName], l.push(T)), y.next()) : y.stop(), [2];
                });
              });
            })];
          case 3:
            E.sent(), E.label = 4;
          case 4:
            E.trys.push([4, 9, 10, 11]), c = de(l), u = c.next(), E.label = 5;
          case 5:
            return u.done ? [3, 8] : (d = u.value, [4, this._requestRemove(d)]);
          case 6:
            E.sent(), E.label = 7;
          case 7:
            return u = c.next(), [3, 5];
          case 8:
            return [3, 11];
          case 9:
            return h = E.sent(), f = { error: h }, [3, 11];
          case 10:
            try {
              u && !u.done && (m = c.return) && m.call(c);
            } finally {
              if (f)
                throw f.error;
            }
            return [7];
          case 11:
            return [4, this._transaction.commit()];
          case 12:
            return E.sent(), this._mutex.unlock(), [2, l];
          case 13:
            throw p = E.sent(), this._mutex.unlock(), p;
          case 14:
            return [3, 16];
          case 15:
            throw this._transaction.clear(), Ct.collectionNotReady;
          case 16:
            return [2];
        }
      });
    });
  }, t.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return this.isReady ? [4, this._mutex.lock()] : [3, 8];
          case 1:
            e.sent(), e.label = 2;
          case 2:
            return e.trys.push([2, 5, , 7]), [4, this._requestClear()];
          case 3:
            return e.sent(), [4, this._transaction.commit()];
          case 4:
            return e.sent(), this._mutex.unlock(), [3, 7];
          case 5:
            return n = e.sent(), [4, this._transaction.clear()];
          case 6:
            throw e.sent(), this._mutex.unlock(), n;
          case 7:
            return [3, 9];
          case 8:
            throw Ct.collectionNotReady;
          case 9:
            return [2];
        }
      });
    });
  }, t.prototype.getBlob = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this._blobContainer.get(n)];
          case 1:
            return [2, e.sent()];
        }
      });
    });
  }, t.prototype.saveBlob = function(n, e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._blobContainer.save(n, e)];
          case 1:
            return [2, r.sent()];
        }
      });
    });
  }, t.prototype.removeBlob = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this._blobContainer.remove(n)];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, t.prototype.removeAllBlobs = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, this._blobContainer.clear()];
          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, t;
}(), gu = "[NESTDB]", ll = !0, bs = function() {
  function t() {
  }
  return t.off = function() {
    ll = !1;
  }, t.log = function() {
    for (var n = [], e = 0; e < arguments.length; e++)
      n[e] = arguments[e];
    ll && console.log.apply(console, Re(["".concat(gu, "[LOG]")], we(n), !1));
  }, t.warning = function() {
    for (var n = [], e = 0; e < arguments.length; e++)
      n[e] = arguments[e];
    ll && console.warn.apply(console, Re(["".concat(gu, "[WARNING]")], we(n), !1));
  }, t.error = function() {
    for (var n = [], e = 0; e < arguments.length; e++)
      n[e] = arguments[e];
    ll && console.error.apply(console, Re(["".concat(gu, "[ERROR]")], we(n), !1));
  }, t;
}(), JE = [{}, { a: 700400, n: "error" }], Sc = function() {
  function t(n) {
    var e, r, i;
    this.encryption = (e = n.encryption) !== null && e !== void 0 ? e : J0, this.itemSizeLimit = (r = n.itemSizeLimit) !== null && r !== void 0 ? r : 4194304, this.metadataBuffer = (i = n.metadataBuffer) !== null && i !== void 0 ? i : 256;
  }
  return Object.defineProperty(t.prototype, "_encryptionCheckKey", { get: function() {
    return "".concat(this.dbname, ".encrypt");
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "_reservedKeys", { get: function() {
    return [this._encryptionCheckKey];
  }, enumerable: !1, configurable: !0 }), t.prototype._getRawKey = function(n, e) {
    return e === void 0 && (e = ""), "".concat(n).concat(e);
  }, t.prototype._generateShardPostfixArray = function(n) {
    return n === void 0 && (n = 1), Re([], we(Array(n).keys()), !1);
  }, t.prototype._shardify = function(n) {
    var e = this, r = n.key, i = n.value, s = JSON.stringify(this.encryption.encrypt(i)), a = Math.ceil(s.length / this.adjustedItemSizeLimit);
    return this._generateShardPostfixArray(a).map(function(o) {
      var l = { key: e._getRawKey(r, ".".concat(o)), data: s.substring(o * e.adjustedItemSizeLimit, (o + 1) * e.adjustedItemSizeLimit) };
      return o === 0 && (l.metadata = { shards: a }), l;
    });
  }, t.prototype._resetIfEncryptionChanged = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i, s, a, o, l, c, u = this;
      return _(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, this.get(this._encryptionCheckKey)];
          case 1:
            if (n = d.sent(), e = { encrypted: JE.map(function(h) {
              var p;
              return (p = u.encryption) === null || p === void 0 ? void 0 : p.encrypt(h);
            }) }, !n)
              return [3, 8];
            if (!n.encrypted || !Array.isArray(n.encrypted))
              return [3, 6];
            for (s in r = n.encrypted, i = [], r)
              i.push(s);
            a = 0, d.label = 2;
          case 2:
            return a < i.length ? (s = i[a]) in r ? (o = s, l = JSON.stringify(n.encrypted[o]), c = JSON.stringify(e.encrypted[o]), l === c ? [3, 4] : (bs.warning("Encryption algorithm has changed. Stored data would be cleared."), [4, this.clear()])) : [3, 4] : [3, 5];
          case 3:
            return d.sent(), [3, 5];
          case 4:
            return a++, [3, 2];
          case 5:
            return [3, 8];
          case 6:
            return [4, this.clear()];
          case 7:
            d.sent(), d.label = 8;
          case 8:
            return [4, this.set({ key: this._encryptionCheckKey, value: e })];
          case 9:
            return d.sent(), [2];
        }
      });
    });
  }, Object.defineProperty(t.prototype, "adjustedItemSizeLimit", { get: function() {
    return Math.max(this.itemSizeLimit - this.metadataBuffer, 4);
  }, enumerable: !1, configurable: !0 }), t.prototype.usage = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return n = 0, [4, this._getAllRawKeys()];
          case 1:
            e = u.sent(), u.label = 2;
          case 2:
            u.trys.push([2, 7, 8, 9]), r = de(e), i = r.next(), u.label = 3;
          case 3:
            return i.done ? [3, 6] : (s = i.value, [4, this._getRaw(s)]);
          case 4:
            (a = u.sent()) && (n += JSON.stringify(a).length), u.label = 5;
          case 5:
            return i = r.next(), [3, 3];
          case 6:
            return [3, 9];
          case 7:
            return o = u.sent(), l = { error: o }, [3, 9];
          case 8:
            try {
              i && !i.done && (c = r.return) && c.call(r);
            } finally {
              if (l)
                throw l.error;
            }
            return [7];
          case 9:
            return [2, n];
        }
      });
    });
  }, t.prototype.getAllKeys = function() {
    return g(this, 0, void 0, function() {
      var n = this;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this._getAllRawKeys()];
          case 1:
            return [2, e.sent().filter(function(r) {
              return r.endsWith(".0");
            }).map(function(r) {
              return r.replace(/\.0$/, "");
            }).filter(function(r) {
              return !n._reservedKeys.includes(r);
            })];
        }
      });
    });
  }, t.prototype.get = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l = this;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return e = this._getRawKey(n, ".0"), [4, this._getRaw(e)];
          case 1:
            if (!(r = c.sent()))
              return [3, 7];
            c.label = 2;
          case 2:
            return c.trys.push([2, 6, , 7]), i = r.data, (s = r.metadata) != null && s.shards && s.shards > 1 ? [4, Promise.all(this._generateShardPostfixArray(s == null ? void 0 : s.shards).map(function(u) {
              return g(l, 0, void 0, function() {
                var d, h;
                return _(this, function(p) {
                  switch (p.label) {
                    case 0:
                      return u > 0 ? (d = this._getRawKey(n, ".".concat(u)), [4, this._getRaw(d)]) : [3, 2];
                    case 1:
                      if (!(h = p.sent()))
                        throw Ct.storeBrokenIntegrity;
                      return [2, h.data];
                    case 2:
                      return [2, i];
                  }
                });
              });
            }))] : [3, 4];
          case 3:
            return o = c.sent(), [3, 5];
          case 4:
            o = [i], c.label = 5;
          case 5:
            return a = o, [2, this.encryption.decrypt(JSON.parse(a.join("")))];
          case 6:
            return c.sent(), [2, null];
          case 7:
            return [2, null];
        }
      });
    });
  }, t.prototype.set = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return e = this._shardify(n), [4, this._setRaw(e)];
          case 1:
            return r.sent(), [2, A({}, n.value)];
        }
      });
    });
  }, t.prototype.setMany = function(n) {
    return g(this, 0, void 0, function() {
      var e, r = this;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return e = [], [4, this._setRaw(e.concat.apply(e, Re([], we(n.map(function(s) {
              return r._shardify(s);
            })), !1)))];
          case 1:
            return i.sent(), [2, n.map(function(s) {
              return s.value;
            })];
        }
      });
    });
  }, t.prototype.remove = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o = this;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return e = this._getRawKey(n, ".0"), [4, this._getRaw(e)];
          case 1:
            return (r = l.sent()) ? (i = r.metadata, s = this._generateShardPostfixArray(i == null ? void 0 : i.shards).map(function(c) {
              return o._getRawKey(n, ".".concat(c));
            }), [4, this._removeRaw(s)]) : [3, 3];
          case 2:
            return l.sent(), (a = ir.get(this.dbname)) == null || a.remove(n), [2, !0];
          case 3:
            return [2, !1];
        }
      });
    });
  }, t.prototype.removeMany = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c, u, d, h = this;
      return _(this, function(p) {
        switch (p.label) {
          case 0:
            e = ir.get(this.dbname), r = [], i = function(f) {
              var m, v, E;
              return _(this, function(y) {
                switch (y.label) {
                  case 0:
                    return m = s._getRawKey(f, ".0"), [4, s._getRaw(m)];
                  case 1:
                    return (v = y.sent()) && (E = v.metadata, r.push.apply(r, Re([], we(s._generateShardPostfixArray(E == null ? void 0 : E.shards).map(function(b) {
                      return h._getRawKey(f, ".".concat(b));
                    })), !1))), e == null || e.remove(f), [2];
                }
              });
            }, s = this, p.label = 1;
          case 1:
            p.trys.push([1, 6, 7, 8]), a = de(n), o = a.next(), p.label = 2;
          case 2:
            return o.done ? [3, 5] : (l = o.value, [5, i(l)]);
          case 3:
            p.sent(), p.label = 4;
          case 4:
            return o = a.next(), [3, 2];
          case 5:
            return [3, 8];
          case 6:
            return c = p.sent(), u = { error: c }, [3, 8];
          case 7:
            try {
              o && !o.done && (d = a.return) && d.call(a);
            } finally {
              if (u)
                throw u.error;
            }
            return [7];
          case 8:
            return r.length > 0 ? [4, this._removeRaw(r)] : [3, 10];
          case 9:
            p.sent(), p.label = 10;
          case 10:
            return [2, n];
        }
      });
    });
  }, t.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        return (n = ir.get(this.dbname)) == null || n.clearForDatabase(this.dbname), [2];
      });
    });
  }, t;
}(), Xn = {}, As = function(t) {
  function n(e) {
    e === void 0 && (e = {});
    var r, i = this;
    i = t.call(this, A(A({}, e), { itemSizeLimit: (r = e.itemSizeLimit) !== null && r !== void 0 ? r : 4194304 })) || this;
    var s = e.delay, a = s === void 0 ? 1 : s;
    return i.delay = a, i.observer = {}, i;
  }
  return S(n, t), Object.defineProperty(n.prototype, "rawData", { get: function() {
    return Xn[this.dbname];
  }, set: function(e) {
    Xn[this.dbname] = e;
  }, enumerable: !1, configurable: !0 }), n.prototype._getAllRawKeys = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        if (Xn[this.dbname])
          return [2, Object.keys(Xn[this.dbname])];
        throw Ct.storeNotAvailable;
      });
    });
  }, n.prototype._getRaw = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return Xn[this.dbname] ? [4, al(this.delay)] : [3, 2];
          case 1:
            return r.sent(), [2, Xn[this.dbname][e] ? A({ key: e }, Xn[this.dbname][e]) : null];
          case 2:
            throw Ct.storeNotAvailable;
        }
      });
    });
  }, n.prototype._setRaw = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u;
      return _(this, function(d) {
        switch (d.label) {
          case 0:
            return Xn[this.dbname] ? [4, al(this.delay)] : [3, 2];
          case 1:
            d.sent();
            try {
              for (r = de(e), i = r.next(); !i.done; i = r.next())
                s = i.value, a = s.key, o = s.data, l = s.metadata, Xn[this.dbname][a] = Object.freeze({ data: o, metadata: l });
            } catch (h) {
              c = { error: h };
            } finally {
              try {
                i && !i.done && (u = r.return) && u.call(r);
              } finally {
                if (c)
                  throw c.error;
              }
            }
            return [3, 3];
          case 2:
            throw Ct.storeNotAvailable;
          case 3:
            return [2];
        }
      });
    });
  }, n.prototype._removeRaw = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return Xn[this.dbname] ? [4, al(this.delay)] : [3, 2];
          case 1:
            l.sent();
            try {
              for (r = de(e), i = r.next(); !i.done; i = r.next())
                s = i.value, Xn[this.dbname][s] && delete Xn[this.dbname][s];
            } catch (c) {
              a = { error: c };
            } finally {
              try {
                i && !i.done && (o = r.return) && o.call(r);
              } finally {
                if (a)
                  throw a.error;
              }
            }
            return [3, 3];
          case 2:
            throw Ct.storeNotAvailable;
          case 3:
            return [2];
        }
      });
    });
  }, n.prototype.observe = function(e, r, i) {
    var s = this;
    this.observer[e] || (this.observer[e] = {}), r.forEach(function(a) {
      return s.observer[e][a] = i;
    });
  }, n.prototype.checkAvailability = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        return [2];
      });
    });
  }, n.prototype.init = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this.dbname = e, Xn[this.dbname] || (Xn[this.dbname] = {}), [4, this._resetIfEncryptionChanged()];
          case 1:
            return r.sent(), [2];
        }
      });
    });
  }, n.prototype.set = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        if ((r = this.observer[e.key]) && typeof r.set == "function" && (i = r.set()))
          throw i;
        return [2, t.prototype.set.call(this, e)];
      });
    });
  }, n.prototype.setMany = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c;
      return _(this, function(u) {
        try {
          for (r = de(e), i = r.next(); !i.done; i = r.next())
            if (s = i.value, (a = this.observer[s.key]) && typeof a.set == "function" && (o = a.set()))
              throw o;
        } catch (d) {
          l = { error: d };
        } finally {
          try {
            i && !i.done && (c = r.return) && c.call(r);
          } finally {
            if (l)
              throw l.error;
          }
        }
        return [2, t.prototype.setMany.call(this, e)];
      });
    });
  }, n.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, t.prototype.clear.call(this)];
          case 1:
            return e.sent(), [4, al(this.delay)];
          case 2:
            return e.sent(), Xn[this.dbname] = {}, [2];
        }
      });
    });
  }, n;
}(Sc), tf = "NestDBStore";
(function(t) {
  t[t.UNINITIALIZED = 0] = "UNINITIALIZED", t[t.OPENING = 1] = "OPENING", t[t.OPEN = 2] = "OPEN", t[t.CLOSED = 3] = "CLOSED";
})(qr || (qr = {}));
var si, eC = function(t) {
  function n(e) {
    e === void 0 && (e = {});
    var r, i = this;
    return (i = t.call(this, A(A({}, e), { itemSizeLimit: (r = e.itemSizeLimit) !== null && r !== void 0 ? r : 104857600 })) || this)._storeName = tf, i._state = qr.UNINITIALIZED, i._openJobQueue = [], i._window = typeof window < "u" ? window : void 0, i._indexedDb = i._window ? i._window.indexedDB || i._window.mozIndexedDB || i._window.webkitIndexedDB || i._window.msIndexedDB : void 0, i;
  }
  return S(n, t), Object.defineProperty(n.prototype, "state", { get: function() {
    return this._state;
  }, enumerable: !1, configurable: !0 }), n.prototype.isTransactionInactiveError = function(e) {
    return e instanceof Error && e.message.includes("The transaction is inactive");
  }, n.prototype._putToObjectStore = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        return [2, new Promise(function(s, a) {
          var o = e.put(r);
          o.addEventListener("success", function(l) {
            s(l.target.result);
          }), o.addEventListener("error", function() {
            a("Failed to write.");
          });
        })];
      });
    });
  }, n.prototype._deleteFromObjectStore = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        return [2, new Promise(function(s, a) {
          var o = e.delete(r);
          o.addEventListener("success", function() {
            return s(r);
          }), o.addEventListener("error", function(l) {
            return a(l.target.error);
          });
        })];
      });
    });
  }, n.prototype._openDatabase = function(e) {
    var r = this;
    return new Promise(function(i, s) {
      if (r._indexedDb) {
        r._state = qr.OPENING;
        var a = r._indexedDb.open(e);
        a.addEventListener("upgradeneeded", function(o) {
          o.target.result.createObjectStore(tf, { keyPath: "key" });
        }), a.addEventListener("success", function(o) {
          r._state = qr.OPEN, r._database = o.target.result, r._openJobQueue.forEach(function(l) {
            return l();
          }), r._openJobQueue = [], r._database.onclose = function() {
            r._database = void 0, r._state = qr.OPENING, setTimeout(function() {
              r._openDatabase(e);
            }, 5);
          }, i(r._database);
        }), a.addEventListener("error", function(o) {
          r._state = qr.UNINITIALIZED, s(o.target.error);
        });
      } else
        s(Ct.storeNotAvailable);
    });
  }, n.prototype._getObjectStore = function(e) {
    return g(this, 0, void 0, function() {
      var r = this;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this._database ? [2, this._database.transaction(this._storeName, e).objectStore(this._storeName)] : [3, 1];
          case 1:
            switch (this._state) {
              case qr.UNINITIALIZED:
              case qr.OPEN:
                return [3, 2];
              case qr.OPENING:
              case qr.CLOSED:
                return [3, 3];
            }
            return [3, 4];
          case 2:
            throw Ct.storeNotInitialized;
          case 3:
            return [2, new Promise(function(s) {
              r._openJobQueue.push(function() {
                return s(r._getObjectStore(e));
              });
            })];
          case 4:
            return [4, this._getObjectStore(e)];
          case 5:
            return [2, i.sent()];
        }
      });
    });
  }, n.prototype._getAllRawKeys = function() {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._getObjectStore("readonly")];
          case 1:
            return e = r.sent(), [4, new Promise(function(i, s) {
              var a = e.getAllKeys();
              a.addEventListener("success", function(o) {
                i(o.target.result);
              }), a.addEventListener("error", function(o) {
                return s(o.target.error);
              });
            })];
          case 2:
            return [2, r.sent()];
        }
      });
    });
  }, n.prototype._getRaw = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this._getObjectStore("readonly")];
          case 1:
            return r = i.sent(), [4, new Promise(function(s, a) {
              var o = r.get(e);
              o.addEventListener("success", function(l) {
                var c;
                s((c = l == null ? void 0 : l.target) === null || c === void 0 ? void 0 : c.result);
              }), o.addEventListener("error", function(l) {
                return a(l.target.error);
              });
            })];
          case 2:
            return [2, i.sent()];
        }
      });
    });
  }, n.prototype._setRaw = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u, d = this;
      return _(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, this._getObjectStore("readwrite")];
          case 1:
            r = h.sent(), h.label = 2;
          case 2:
            return h.trys.push([2, 4, , 15]), [4, Promise.all(e.map(function(p) {
              return d._putToObjectStore(r, p);
            }))];
          case 3:
            return h.sent(), [3, 15];
          case 4:
            if (i = h.sent(), !this.isTransactionInactiveError(i))
              return [3, 13];
            h.label = 5;
          case 5:
            h.trys.push([5, 10, 11, 12]), s = de(e), a = s.next(), h.label = 6;
          case 6:
            return a.done ? [3, 9] : (o = a.value, [4, this._putToObjectStore(r, o)]);
          case 7:
            h.sent(), h.label = 8;
          case 8:
            return a = s.next(), [3, 6];
          case 9:
            return [3, 12];
          case 10:
            return l = h.sent(), c = { error: l }, [3, 12];
          case 11:
            try {
              a && !a.done && (u = s.return) && u.call(s);
            } finally {
              if (c)
                throw c.error;
            }
            return [7];
          case 12:
            return [3, 14];
          case 13:
            throw i;
          case 14:
            return [3, 15];
          case 15:
            return [2];
        }
      });
    });
  }, n.prototype._removeRaw = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u, d = this;
      return _(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, this._getObjectStore("readwrite")];
          case 1:
            r = h.sent(), h.label = 2;
          case 2:
            return h.trys.push([2, 4, , 15]), [4, Promise.all(e.map(function(p) {
              return d._deleteFromObjectStore(r, p);
            }))];
          case 3:
            return h.sent(), [3, 15];
          case 4:
            if (i = h.sent(), !this.isTransactionInactiveError(i))
              return [3, 13];
            h.label = 5;
          case 5:
            h.trys.push([5, 10, 11, 12]), s = de(e), a = s.next(), h.label = 6;
          case 6:
            return a.done ? [3, 9] : (o = a.value, [4, this._deleteFromObjectStore(r, o)]);
          case 7:
            h.sent(), h.label = 8;
          case 8:
            return a = s.next(), [3, 6];
          case 9:
            return [3, 12];
          case 10:
            return l = h.sent(), c = { error: l }, [3, 12];
          case 11:
            try {
              a && !a.done && (u = s.return) && u.call(s);
            } finally {
              if (c)
                throw c.error;
            }
            return [7];
          case 12:
            return [3, 14];
          case 13:
            throw i;
          case 14:
            return [3, 15];
          case 15:
            return [2];
        }
      });
    });
  }, n.prototype._triggerDatabaseClose = function() {
    this._database && this._database.onclose && this._database.onclose(new Event("dummy"));
  }, n.prototype.checkAvailability = function() {
    return g(this, 0, void 0, function() {
      var e, r = this;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            if (!((e = typeof window < "u" ? window : null) != null && e.indexedDB || e != null && e.mozIndexedDB || e != null && e.webkitIndexedDB || e != null && e.msIndexedDB))
              return [3, 6];
            if (this._indexedDb = e.indexedDB || e.mozIndexedDB || e.webkitIndexedDB || e.msIndexedDB, !this._window || !nc())
              return [3, 4];
            if (!(nc() && navigator.userAgent && navigator.userAgent.includes("Edge/")))
              return [3, 1];
            if (!this._window.indexedDB && (e.PointerEvent || e.MSPointerEvent))
              throw Ct.storeNotAvailableInPrivateBrowsing;
            return [3, 3];
          case 1:
            return [4, new Promise(function(s, a) {
              if (r._indexedDb)
                try {
                  var o = r._indexedDb.open("_testMozilla");
                  o.onerror = function() {
                    return a(Ct.storeNotAvailableInPrivateBrowsing);
                  }, o.onsuccess = function(l) {
                    if (l.target.result.close(), r._indexedDb) {
                      var c = r._indexedDb.deleteDatabase("_testMozilla");
                      c.onerror = function() {
                        return s();
                      }, c.onsuccess = function() {
                        return s();
                      };
                    } else
                      a(Ct.storeNotAvailable);
                  };
                } catch {
                  a(Ct.storeNotAvailableInPrivateBrowsing);
                }
              else
                a(Ct.storeNotAvailable);
            })];
          case 2:
            i.sent(), i.label = 3;
          case 3:
            return [3, 5];
          case 4:
            throw Ct.storeNotAvailable;
          case 5:
            return [3, 7];
          case 6:
            throw Ct.storeNotAvailable;
          case 7:
            return [2];
        }
      });
    });
  }, n.prototype.init = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this.dbname = e, [4, this.checkAvailability()];
          case 1:
            return r.sent(), [4, this._openDatabase(e)];
          case 2:
            return r.sent(), [4, this._resetIfEncryptionChanged()];
          case 3:
            return r.sent(), [2];
        }
      });
    });
  }, n.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, t.prototype.clear.call(this)];
          case 1:
            return r.sent(), [4, this._getObjectStore("readwrite")];
          case 2:
            return e = r.sent(), [4, new Promise(function(i, s) {
              var a = e.clear();
              a.addEventListener("success", function() {
                return i();
              }), a.addEventListener("error", function(o) {
                return s(o.target.error);
              });
            })];
          case 3:
            return [2, r.sent()];
        }
      });
    });
  }, n;
}(Sc), tC = function(t) {
  function n(e) {
    var r = this, i = e.AsyncStorage, s = e.itemSizeLimit, a = s === void 0 ? 2097152 : s, o = function(l, c) {
      var u = {};
      for (var d in l)
        Object.prototype.hasOwnProperty.call(l, d) && c.indexOf(d) < 0 && (u[d] = l[d]);
      if (l != null && typeof Object.getOwnPropertySymbols == "function") {
        var h = 0;
        for (d = Object.getOwnPropertySymbols(l); h < d.length; h++)
          c.indexOf(d[h]) < 0 && Object.prototype.propertyIsEnumerable.call(l, d[h]) && (u[d[h]] = l[d[h]]);
      }
      return u;
    }(e, ["AsyncStorage", "itemSizeLimit"]);
    return (r = t.call(this, A(A({}, o), { itemSizeLimit: a })) || this)._asyncStorage = i, r;
  }
  return S(n, t), n.prototype._isBelonging = function(e) {
    return e.startsWith("".concat(this.dbname, "/"));
  }, n.prototype._getActualKey = function(e) {
    return "".concat(this.dbname, "/").concat(e);
  }, n.prototype._getAllRawKeys = function() {
    return g(this, 0, void 0, function() {
      var e = this;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._asyncStorage.getAllKeys()];
          case 1:
            return [2, r.sent().filter(function(i) {
              return e._isBelonging(i);
            }).map(function(i) {
              return i.substring("".concat(e.dbname, "/").length);
            })];
        }
      });
    });
  }, n.prototype._getRaw = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this._asyncStorage.getItem(this._getActualKey(e))];
          case 1:
            return [2, (r = i.sent()) ? JSON.parse(r) : null];
        }
      });
    });
  }, n.prototype._setRaw = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            r = [];
            try {
              for (i = de(e), s = i.next(); !s.done; s = i.next())
                a = s.value, o = a.key, a.data.length <= this.adjustedItemSizeLimit && r.push([this._getActualKey(o), JSON.stringify(a)]);
            } catch (d) {
              l = { error: d };
            } finally {
              try {
                s && !s.done && (c = i.return) && c.call(i);
              } finally {
                if (l)
                  throw l.error;
              }
            }
            return [4, this._asyncStorage.multiSet(r)];
          case 1:
            return u.sent(), [2];
        }
      });
    });
  }, n.prototype._removeRaw = function(e) {
    return g(this, 0, void 0, function() {
      var r = this;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this._asyncStorage.multiRemove(e.map(function(s) {
              return r._getActualKey(s);
            }))];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.checkAvailability = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        if (!this._asyncStorage)
          throw Ct.storeNotAvailable;
        return [2];
      });
    });
  }, n.prototype.init = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this.dbname = e, [4, this._resetIfEncryptionChanged()];
          case 1:
            return r.sent(), [2];
        }
      });
    });
  }, n.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, t.prototype.clear.call(this)];
          case 1:
            return r.sent(), [4, this.getAllKeys()];
          case 2:
            return e = r.sent(), [4, this.removeMany(e)];
          case 3:
            return r.sent(), [2];
        }
      });
    });
  }, n;
}(Sc), nC = function(t) {
  function n(e) {
    var r, i = this;
    return (i = t.call(this, A(A({}, e), { itemSizeLimit: (r = e.itemSizeLimit) !== null && r !== void 0 ? r : 6291456 })) || this)._mmkv = e.MMKV, i;
  }
  return S(n, t), n.prototype._isBelonging = function(e) {
    return e.startsWith("".concat(this.dbname, "/"));
  }, n.prototype._getActualKey = function(e) {
    return "".concat(this.dbname, "/").concat(e);
  }, n.prototype._getAllRawKeys = function() {
    return g(this, 0, void 0, function() {
      var e = this;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._mmkv.getAllKeys()];
          case 1:
            return [2, r.sent().filter(function(i) {
              return e._isBelonging(i);
            }).map(function(i) {
              return i.substring("".concat(e.dbname, "/").length);
            })];
        }
      });
    });
  }, n.prototype._getRaw = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this._mmkv.getString(this._getActualKey(e))];
          case 1:
            return [2, (r = i.sent()) ? JSON.parse(r) : null];
        }
      });
    });
  }, n.prototype._setRaw = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l;
      return _(this, function(c) {
        try {
          for (r = de(e), i = r.next(); !i.done; i = r.next())
            s = i.value, a = s.key, s.data.length <= this.adjustedItemSizeLimit && this._mmkv.set(this._getActualKey(a), JSON.stringify(s));
        } catch (u) {
          o = { error: u };
        } finally {
          try {
            i && !i.done && (l = r.return) && l.call(r);
          } finally {
            if (o)
              throw o.error;
          }
        }
        return [2];
      });
    });
  }, n.prototype._removeRaw = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o;
      return _(this, function(l) {
        try {
          for (r = de(e), i = r.next(); !i.done; i = r.next())
            s = i.value, this._mmkv.delete(this._getActualKey(s));
        } catch (c) {
          a = { error: c };
        } finally {
          try {
            i && !i.done && (o = r.return) && o.call(r);
          } finally {
            if (a)
              throw a.error;
          }
        }
        return [2];
      });
    });
  }, n.prototype.checkAvailability = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        if (!this._mmkv)
          throw Ct.storeNotAvailable;
        return [2];
      });
    });
  }, n.prototype.init = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this.dbname = e, [4, this._resetIfEncryptionChanged()];
          case 1:
            return r.sent(), [2];
        }
      });
    });
  }, n.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, t.prototype.clear.call(this)];
          case 1:
            return r.sent(), [4, this.getAllKeys()];
          case 2:
            return e = r.sent(), [4, this.removeMany(e)];
          case 3:
            return r.sent(), [2];
        }
      });
    });
  }, n;
}(Sc);
(function(t) {
  t.INIT = "INIT", t.OPENING = "OPENING", t.OPENED = "OPENED", t.CLOSED = "CLOSED";
})(si || (si = {}));
var Mi, rC = function() {
  function t(n) {
    var e = n.name, r = n.version, i = n.store, s = n.config;
    this.name = e, this._version = r, this._state = si.INIT, this._config = s || new Po({ dbname: e }), this._store = i, this._event = { success: qa, error: qa, storeReplaced: qa, upgrade: Zp }, this._collections = /* @__PURE__ */ new Map(), this._globalMutex = new eh("".concat(this.name, ".lock")), this._config.disableLogger && bs.off(), new ir({ dbname: e, limit: this._config.cacheLimit });
  }
  return Object.defineProperty(t.prototype, "version", { get: function() {
    return this._version;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "state", { get: function() {
    return this._state;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "store", { get: function() {
    return this._store;
  }, enumerable: !1, configurable: !0 }), t.prototype.estimateUsage = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, (e = this._store, g(void 0, 0, void 0, function() {
              return _(this, function(r) {
                switch (r.label) {
                  case 0:
                    return [4, e.usage()];
                  case 1:
                    return [2, r.sent()];
                }
              });
            }))];
          case 1:
            return [2, n.sent()];
        }
        var e;
      });
    });
  }, t.prototype.commitSchema = function(n) {
    return g(this, 0, void 0, function() {
      var e = this;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this._state !== si.OPENING ? [3, 2] : [4, Promise.all(n.map(function(i) {
              return g(e, 0, void 0, function() {
                var s, a, o, l, c;
                return _(this, function(u) {
                  switch (u.label) {
                    case 0:
                      return s = i.collectionName, a = i.keyName, o = i.index, l = o === void 0 ? [] : o, this._collections.has(s) || this._collections.set(s, new _u({ dbname: this.name, collectionName: s, keyName: a, indexes: l, store: this._store })), (c = this._collections.get(s)) ? [4, c.init()] : [3, 2];
                    case 1:
                      u.sent(), u.label = 2;
                    case 2:
                      return [2];
                  }
                });
              });
            }))];
          case 1:
            return r.sent(), [3, 3];
          case 2:
            throw Ct.databaseSchemaNotOnUpgrade;
          case 3:
            return [2];
        }
      });
    });
  }, t.prototype.open = function() {
    var n;
    return g(this, 0, void 0, function() {
      var e, r, i, s, a = this;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return [4, this._globalMutex.lock()];
          case 1:
            if (o.sent(), this._state === si.OPENED)
              return [3, 12];
            this._state = si.OPENING, o.label = 2;
          case 2:
            return o.trys.push([2, 5, , 12]), [4, this._store.init(this.name)];
          case 3:
            return o.sent(), l = this.name, e = "".concat(Jd(l), ".metadata"), r = { version: 0, collectionNames: [] }, [4, this._store.get(e)];
          case 4:
            return i = (n = o.sent()) !== null && n !== void 0 ? n : r, [2, new Promise(function(c, u) {
              var d = function(p) {
                i.version < a._version ? a._event.upgrade(i.version, function(f) {
                  return g(a, 0, void 0, function() {
                    var m;
                    return _(this, function(v) {
                      switch (v.label) {
                        case 0:
                          if (f)
                            return [3, 5];
                          i.version++, i.collectionNames = Array.from(this._collections.keys()), v.label = 1;
                        case 1:
                          return v.trys.push([1, 3, , 4]), [4, this._store.set({ key: e, value: i })];
                        case 2:
                          return v.sent(), p({ continued: !0 }), [3, 4];
                        case 3:
                          return m = v.sent(), p({ continued: !1, err: m }), [3, 4];
                        case 4:
                          return [3, 6];
                        case 5:
                          p({ continued: !1, err: f }), v.label = 6;
                        case 6:
                          return [2];
                      }
                    });
                  });
                }) : p({ continued: !1 });
              }, h = function(p) {
                var f = p.continued, m = f !== void 0 && f, v = p.err, E = v === void 0 ? null : v;
                if (m)
                  setTimeout(function() {
                    return d(h);
                  }, 10);
                else if (E)
                  bs.error(E.message), a._globalMutex.unlock(), a._event.error(E), u(E);
                else {
                  var y = [];
                  i.collectionNames.forEach(function(b) {
                    var T = a._collections.get(b);
                    T && T.state === Us.READY || y.push(g(a, 0, void 0, function() {
                      var w, N;
                      return _(this, function(M) {
                        switch (M.label) {
                          case 0:
                            return [4, _u.metadataOf(this.name, b, this._store)];
                          case 1:
                            return (w = M.sent()) ? (N = new _u({ dbname: this.name, collectionName: b, keyName: w.keyName, indexes: w.indexes, store: this._store }), this._collections.set(b, N), [4, N.init()]) : [3, 3];
                          case 2:
                            M.sent(), M.label = 3;
                          case 3:
                            return [2];
                        }
                      });
                    }));
                  }), Promise.all(y).then(function() {
                    a._state = si.OPENED, a._globalMutex.unlock(), a._event.success(), c();
                  }).catch(function(b) {
                    bs.error(b.message), a._globalMutex.unlock(), a._event.error(b), u(b);
                  });
                }
              };
              d(h);
            })];
          case 5:
            switch ((s = o.sent()).code) {
              case Bt.STORE_NOT_AVAILABLE_IN_PRIVATE_BROWSING:
                return [3, 6];
              case Bt.STORE_NOT_AVAILABLE:
                return [3, 8];
            }
            return [3, 10];
          case 6:
            return bs.warning("Access to the local storage is not allowed. Switched to MemoryStore automatically."), this._store = new As({}), this._globalMutex.unlock(), this._event.error(s), this._event.storeReplaced(this._store), [4, this.open()];
          case 7:
            return o.sent(), [3, 11];
          case 8:
            return bs.warning("IndexedDB is not available in this environment. Switched to MemoryStore automatically. Consider using other store to save data persistently (e.g. AsyncStorage)."), this._store = new As({}), this._globalMutex.unlock(), this._event.error(s), this._event.storeReplaced(this._store), [4, this.open()];
          case 9:
            return o.sent(), [3, 11];
          case 10:
            throw bs.error(s.message), this._globalMutex.unlock(), this._event.error(s), s;
          case 11:
            return [3, 12];
          case 12:
            return [2];
        }
        var l;
      });
    });
  }, t.prototype.close = function() {
    this._collections.forEach(function(n) {
      return n.close();
    }), this._state = si.CLOSED;
  }, t.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, Promise.all(Array.from(this._collections.values()).map(function(e) {
              return e.clear();
            }))];
          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, t.prototype.reset = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return (n = ir.get(this.name)) && n.clearForDatabase(this.name), [4, this._store.clear()];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, t.prototype.on = function(n, e) {
    this._event[n] = e;
  }, t.prototype.off = function(n) {
    typeof this._event[n] == "function" && (this._event[n] = n === "upgrade" ? Zp : qa);
  }, t.prototype.collection = function(n) {
    var e = this._collections.get(n);
    if (e)
      return e;
    throw Ct.collectionNotReady;
  }, t;
}();
(function(t) {
  t[t.VERBOSE = 0] = "VERBOSE", t[t.DEBUG = 1] = "DEBUG", t[t.INFO = 2] = "INFO", t[t.WARN = 3] = "WARN", t[t.ERROR = 4] = "ERROR", t[t.NONE = 5] = "NONE";
})(Mi || (Mi = {}));
var An, iC = function() {
  function t() {
    this.level = Mi.WARN;
  }
  return t.prototype.verbose = function() {
    for (var n = [], e = 0; e < arguments.length; e++)
      n[e] = arguments[e];
    this.level <= Mi.VERBOSE && console.log.apply(console, Re(["[verbose]"], we(n), !1));
  }, t.prototype.debug = function() {
    for (var n = [], e = 0; e < arguments.length; e++)
      n[e] = arguments[e];
    this.level <= Mi.DEBUG && console.log.apply(console, Re(["[debug]"], we(n), !1));
  }, t.prototype.info = function() {
    for (var n = [], e = 0; e < arguments.length; e++)
      n[e] = arguments[e];
    this.level <= Mi.INFO && console.log.apply(console, Re(["[info]"], we(n), !1));
  }, t.prototype.warn = function() {
    for (var n = [], e = 0; e < arguments.length; e++)
      n[e] = arguments[e];
    this.level <= Mi.WARN && console.warn.apply(console, Re(["[warn]"], we(n), !1));
  }, t.prototype.error = function() {
    for (var n = [], e = 0; e < arguments.length; e++)
      n[e] = arguments[e];
    this.level <= Mi.ERROR && console.error.apply(console, Re(["[error]"], we(n), !1));
  }, t;
}(), Fi = function() {
  function t(n) {
    var e, r, i, s;
    this.messageTypeFilter = (e = n == null ? void 0 : n.messageTypeFilter) !== null && e !== void 0 ? e : Pn.ALL, this.customTypesFilter = (r = n == null ? void 0 : n.customTypesFilter) !== null && r !== void 0 ? r : null, this.senderUserIdsFilter = (i = n == null ? void 0 : n.senderUserIdsFilter) !== null && i !== void 0 ? i : null, this.replyType = (s = n == null ? void 0 : n.replyType) !== null && s !== void 0 ? s : Fn.NONE;
  }
  return t.prototype.clone = function() {
    var n = new t(), e = JSON.parse(JSON.stringify(this));
    return Object.keys(e).forEach(function(r) {
      n[r] = e[r];
    }), n;
  }, t.prototype.match = function(n) {
    switch (this.messageTypeFilter) {
      case Pn.USER:
        if (n.messageType !== Yt.USER)
          return !1;
        break;
      case Pn.FILE:
        if (n.messageType !== Yt.FILE)
          return !1;
        break;
      case Pn.ADMIN:
        if (n.messageType !== Yt.ADMIN)
          return !1;
    }
    if (this.customTypesFilter && this.customTypesFilter.length > 0 && !this.customTypesFilter.includes("*") && !this.customTypesFilter.includes(n.customType) || this.senderUserIdsFilter && this.senderUserIdsFilter.length > 0 && (!(n instanceof en) || !this.senderUserIdsFilter.includes(n.sender.userId)))
      return !1;
    if (n instanceof Vn)
      switch (this.replyType) {
        case Fn.NONE:
          if (n.parentMessageId > 0)
            return !1;
          break;
        case Fn.ONLY_REPLY_TO_CHANNEL:
          if (n instanceof en && n.parentMessageId > 0 && !n.replyToChannel)
            return !1;
      }
    return !0;
  }, t;
}();
(function(t) {
  t.CHANNEL_LATEST = "channel_latest", t.NEWEST_CHILD_MESSAGE = "newest_child_message";
})(An || (An = {}));
var fo, di = function(t) {
  switch (t) {
    case An.CHANNEL_LATEST:
      return ["channelUrl", "-createdAt", "-messageId"];
    case An.NEWEST_CHILD_MESSAGE:
      return ["channelUrl", "-parentMessageId", "-createdAt", "-messageId"];
  }
}, sC = A(A({}, e_), { scheduledAt: void 0 }), aC = A(A({}, Tc), { scheduledAt: 0, file: void 0, fileUrl: void 0, fileName: void 0, mimeType: void 0, fileSize: void 0, thumbnailSizes: void 0, requireAuth: !1 }), h_ = "UnsentMessage", cl = {}, Ks = function(t) {
  function n(e) {
    var r = t.call(this, e) || this;
    return r._mutex = new eh("unsendmessagecache.lock"), cl[e] = r, r;
  }
  return S(n, t), Object.defineProperty(n.prototype, "_cacheContext", { get: function() {
    return k.of(this._iid).cacheContext;
  }, enumerable: !1, configurable: !0 }), n.of = function(e, r) {
    return r === void 0 && (r = !1), cl[e] && !r || (cl[e] = new n(e)), cl[e];
  }, Object.defineProperty(n.prototype, "collection", { get: function() {
    var e = this._cacheContext.nestdb, r = e == null ? void 0 : e.collection(h_);
    if (!r)
      throw D.databaseError;
    return r;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "localCacheEnabled", { get: function() {
    return this._cacheContext.localCacheEnabled && !!this.collection;
  }, enumerable: !1, configurable: !0 }), n.prototype._serialize = function(e) {
    if (e.messageId > 0)
      throw D.invalidParameters;
    var r, i = A({}, e.serialize());
    return e instanceof Ln ? (e.messageParams && (i.messageParams = Up(e.messageParams)), e.scheduledInfo && e.scheduledInfo.scheduledMessageParams && (i.scheduledInfo.scheduledMessageParams = (r = e.scheduledInfo.scheduledMessageParams, A(A({}, Up(r)), { scheduledAt: r.scheduledAt })))) : e instanceof ln ? (e.messageParams && (i.messageParams = Pp(e.messageParams)), e.scheduledInfo && e.scheduledInfo.scheduledMessageParams && (i.scheduledInfo.scheduledMessageParams = function(s) {
      return A(A({}, Pp(s)), { scheduledAt: s.scheduledAt });
    }(e.scheduledInfo.scheduledMessageParams))) : e instanceof Sr && e.messageParams && (i.messageParams = function(s) {
      return fe({ fileInfoList: s.fileInfoList, isReplyToChannel: s.isReplyToChannel, pushNotificationDeliveryOption: s.pushNotificationDeliveryOption });
    }(e.messageParams)), i;
  }, n.prototype._deserialize = function(e) {
    return e = A(A({}, e), { messageId: parseInt(e.messageId) }), bn.of(this._iid).buildMessageFromSerializedData(e);
  }, n.prototype._deserializeWithMessageCreateParams = function(e) {
    var r, i, s;
    return g(this, 0, void 0, function() {
      var a, o, l, c, u, d, h = this;
      return _(this, function(p) {
        switch (p.label) {
          case 0:
            return a = bn.of(this._iid), o = this._deserialize(e), e.messageParams ? o instanceof Ln ? (c = e.messageParams, o.messageParams = a.buildUserMessageCreateParamsFromSerializedData(c, o), [3, 6]) : [3, 1] : [3, 6];
          case 1:
            return o instanceof ln ? (c = e.messageParams).fileKey && typeof c.fileKey == "string" && du((r = c.fileType) !== null && r !== void 0 ? r : "") ? (l = c, [4, this.collection.getBlob(c.fileKey)]) : [3, 3] : [3, 4];
          case 2:
            l.file = (i = p.sent()) !== null && i !== void 0 ? i : void 0, p.label = 3;
          case 3:
            return o.messageParams = a.buildFileMessageCreateParamsFromSerializedData(c, o), [3, 6];
          case 4:
            return o instanceof Sr && (c = e.messageParams) && c.fileInfoList ? (o.messageParams = a.buildMultipleFilesMessageCreateParamsFromSerializedData(c, o), [4, Promise.all(o.messageParams.fileInfoList.map(function(f) {
              return g(h, 0, void 0, function() {
                var m, v, E, y, b;
                return _(this, function(T) {
                  switch (T.label) {
                    case 0:
                      return typeof ((v = f._uploadedMetaData) === null || v === void 0 ? void 0 : v.fileKey) == "string" && du((y = (E = f._uploadedMetaData) === null || E === void 0 ? void 0 : E.fileType) !== null && y !== void 0 ? y : "") ? (m = f, [4, this.collection.getBlob(f._uploadedMetaData.fileKey)]) : [3, 2];
                    case 1:
                      m.file = (b = T.sent()) !== null && b !== void 0 ? b : void 0, T.label = 2;
                    case 2:
                      return [2];
                  }
                });
              });
            }))]) : [3, 6];
          case 5:
            p.sent(), p.label = 6;
          case 6:
            return o.scheduledInfo && e.scheduledInfo && e.scheduledInfo.scheduledMessageParams ? o instanceof Ln ? (u = e.scheduledInfo.scheduledMessageParams, o.scheduledInfo.scheduledMessageParams = a.buildScheduledUserMessageCreateParamsFromSerializedData(u, o), [3, 10]) : [3, 7] : [3, 10];
          case 7:
            return o instanceof ln ? (u = e.scheduledInfo.scheduledMessageParams).fileKey && typeof u.fileKey == "string" && typeof u.fileType == "string" && du(u.fileType) ? (d = u, [4, this.collection.getBlob(u.fileKey)]) : [3, 9] : [3, 10];
          case 8:
            d.file = (s = p.sent()) !== null && s !== void 0 ? s : void 0, p.label = 9;
          case 9:
            o.scheduledInfo.scheduledMessageParams = a.buildScheduledFileMessageCreateParamsFromSerializedData(u, o), p.label = 10;
          case 10:
            return [2, o];
        }
      });
    });
  }, n.prototype._getFileInfoBlobKey = function(e, r) {
    return "".concat(e, ".").concat(r);
  }, n.prototype.get = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.getByKey("".concat(e))] : [3, 2];
          case 1:
            if (r = i.sent())
              return [2, this._deserializeWithMessageCreateParams(r)];
            i.label = 2;
          case 2:
            return [2, void 0];
        }
      });
    });
  }, n.prototype.fetch = function(e) {
    var r = e.channelUrl, i = e.filter, s = i === void 0 ? new Fi() : i, a = e.order, o = a === void 0 ? An.CHANNEL_LATEST : a, l = e.sendingStatus, c = e.backward, u = c !== void 0 && c, d = e.parentMessageId;
    return g(this, 0, void 0, function() {
      var h, p, f, m, v = this;
      return _(this, function(E) {
        switch (E.label) {
          case 0:
            return this.localCacheEnabled ? (h = di(o), p = { "/where": function(y) {
              return !!(o !== An.NEWEST_CHILD_MESSAGE || d && y.parentMessageId !== 0 && y.parentMessageId === d) && s.match(v._deserialize(y));
            } }, r && (p.channelUrl = r), l && (p.sendingStatus = l), f = { where: p, index: h, backward: u }, [4, this.collection.query(f)]) : [3, 3];
          case 1:
            return [4, E.sent().fetch({})];
          case 2:
            return m = E.sent(), [2, Promise.all(m.map(function(y) {
              return g(v, 0, void 0, function() {
                return _(this, function(b) {
                  switch (b.label) {
                    case 0:
                      return [4, this._deserializeWithMessageCreateParams(y)];
                    case 1:
                      return [2, b.sent()];
                  }
                });
              });
            }))];
          case 3:
            return [2, []];
        }
      });
    });
  }, n.prototype.getAllChildMessages = function(e, r) {
    return r === void 0 && (r = new Fi()), g(this, 0, void 0, function() {
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this.fetch({ filter: r, order: An.NEWEST_CHILD_MESSAGE, channelUrl: e.channelUrl, backward: !1, parentMessageId: e.messageId })];
          case 1:
            return [2, i.sent()];
        }
      });
    });
  }, n.prototype.upsert = function(e) {
    return g(this, 0, void 0, function() {
      var r = this;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.localCacheEnabled ? [4, Promise.all(e.map(function(s) {
              return g(r, 0, void 0, function() {
                var a;
                return _(this, function(o) {
                  switch (o.label) {
                    case 0:
                      return s instanceof ln || s instanceof Sr ? [4, this._mutex.lock()] : [3, 4];
                    case 1:
                      return o.sent(), [4, this.saveBlob(s)];
                    case 2:
                      return o.sent(), [4, this._mutex.unlock()];
                    case 3:
                      o.sent(), o.label = 4;
                    case 4:
                      return a = this._serialize(s), [4, this.collection.upsertOne(a)];
                    case 5:
                      return o.sent(), [2];
                  }
                });
              });
            }))] : [3, 2];
          case 1:
            i.sent(), i.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.upsertChildMessages = function(e) {
    return g(this, 0, void 0, function() {
      var r = this;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.localCacheEnabled ? [4, Promise.all(e.map(function(s) {
              return g(r, 0, void 0, function() {
                var a;
                return _(this, function(o) {
                  switch (o.label) {
                    case 0:
                      return a = [], s.threadInfo && s.threadInfo.replyCount > 0 ? [4, this.getAllChildMessages(s)] : [3, 2];
                    case 1:
                      a = o.sent(), o.label = 2;
                    case 2:
                      return a.length > 0 ? (a.forEach(function(l) {
                        return l.applyParentMessage(s);
                      }), [4, this.upsert(a)]) : [3, 4];
                    case 3:
                      o.sent(), o.label = 4;
                    case 4:
                      return [2];
                  }
                });
              });
            }))] : [3, 2];
          case 1:
            i.sent(), i.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.remove = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            if (!this.localCacheEnabled)
              return [3, 8];
            c.label = 1;
          case 1:
            c.trys.push([1, 6, 7, 8]), r = de(e), i = r.next(), c.label = 2;
          case 2:
            return i.done ? [3, 5] : (s = i.value, [4, this.collection.remove(s)]);
          case 3:
            c.sent(), c.label = 4;
          case 4:
            return i = r.next(), [3, 2];
          case 5:
            return [3, 8];
          case 6:
            return a = c.sent(), o = { error: a }, [3, 8];
          case 7:
            try {
              i && !i.done && (l = r.return) && l.call(r);
            } finally {
              if (o)
                throw o.error;
            }
            return [7];
          case 8:
            return [2];
        }
      });
    });
  }, n.prototype.removeMessagesOfChannel = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.removeIf({ where: { channelUrl: e } })] : [3, 2];
          case 1:
            r.sent(), r.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.clear()] : [3, 2];
          case 1:
            e.sent(), e.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.saveBlob = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a = this;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return e instanceof ln ? e.messageParams && (s = e.messageParams).file && Sl(s.file) ? [4, this.collection.saveBlob(s.file, e.reqId)] : [3, 2] : [3, 5];
          case 1:
            i = o.sent(), s.fileKey = i, s.fileType = Hs.BLOB, o.label = 2;
          case 2:
            return e.scheduledInfo && e.scheduledInfo.scheduledMessageParams && (r = e.scheduledInfo.scheduledMessageParams).file && Sl(r.file) ? [4, this.collection.saveBlob(r.file, e.reqId)] : [3, 4];
          case 3:
            i = o.sent(), r.fileKey = i, r.fileType = Hs.BLOB, o.label = 4;
          case 4:
            return [3, 7];
          case 5:
            return e instanceof Sr && (s = e.messageParams) && s.fileInfoList && Array.isArray(s.fileInfoList) ? [4, Promise.all(s.fileInfoList.map(function(l, c) {
              return g(a, 0, void 0, function() {
                var u;
                return _(this, function(d) {
                  switch (d.label) {
                    case 0:
                      return l.file && Sl(l.file) ? [4, this.collection.saveBlob(l.file, this._getFileInfoBlobKey(e.reqId, c))] : [3, 2];
                    case 1:
                      u = d.sent(), l._uploadedMetaData || (l._uploadedMetaData = {}), l._uploadedMetaData.fileKey = u, l._uploadedMetaData.fileType = Hs.BLOB, d.label = 2;
                    case 2:
                      return [2];
                  }
                });
              });
            }))] : [3, 7];
          case 6:
            o.sent(), o.label = 7;
          case 7:
            return [2];
        }
      });
    });
  }, n;
}(xn), ul = {}, oa = function(t) {
  function n(e) {
    var r = t.call(this, e) || this;
    return ul[e] = r, r;
  }
  return S(n, t), Object.defineProperty(n.prototype, "_sdkState", { get: function() {
    return k.of(this._iid).sdkState;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "_cacheContext", { get: function() {
    return k.of(this._iid).cacheContext;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "_unsentMessageCache", { get: function() {
    return Ks.of(this._iid);
  }, enumerable: !1, configurable: !0 }), n.of = function(e, r) {
    return r === void 0 && (r = !1), ul[e] && !r || (ul[e] = new n(e)), ul[e];
  }, Object.defineProperty(n.prototype, "collection", { get: function() {
    var e = this._cacheContext.nestdb;
    return Z(!!e).throw(D.databaseError), e.collection(hd);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "localCacheEnabled", { get: function() {
    return this._cacheContext.localCacheEnabled && !!this.collection;
  }, enumerable: !1, configurable: !0 }), n.prototype._serialize = function(e) {
    return A(A({}, e.serialize()), { messageId: "".concat(e.messageId) });
  }, n.prototype._deserialize = function(e) {
    return e = A(A({}, e), { messageId: parseInt(e.messageId) }), bn.of(this._iid).buildMessageFromSerializedData(e);
  }, n.prototype.get = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.getByKey("".concat(e))] : [3, 2];
          case 1:
            if (r = i.sent())
              return [2, this._deserialize(r)];
            i.label = 2;
          case 2:
            return [2, void 0];
        }
      });
    });
  }, n.prototype.fetch = function(e) {
    var r = e.channelUrl, i = e.token, s = e.limit, a = s === void 0 ? 100 : s, o = e.filter, l = o === void 0 ? new Fi() : o, c = e.order, u = c === void 0 ? An.CHANNEL_LATEST : c, d = e.backward, h = d !== void 0 && d, p = e.parentMessageId, f = e.isPollOnly, m = f !== void 0 && f, v = e.exactMatch, E = v !== void 0 && v, y = e.inclusive, b = y === void 0 || y;
    return g(this, 0, void 0, function() {
      var T, w, N, M = this;
      return _(this, function(I) {
        switch (I.label) {
          case 0:
            return this.localCacheEnabled ? (T = di(u), w = { where: { channelUrl: r, "/where": function(x) {
              if (i != null && i !== "")
                switch (u) {
                  case An.CHANNEL_LATEST:
                    if (E && x.createdAt !== i)
                      return !1;
                    if (h) {
                      if (b && x.createdAt < i || !b && x.createdAt <= i)
                        return !1;
                    } else if (b && x.createdAt > i || !b && x.createdAt >= i)
                      return !1;
                    break;
                  case An.NEWEST_CHILD_MESSAGE:
                    if (!p || x.parentMessageId === 0 || x.parentMessageId !== p)
                      return !1;
                }
              return !(m && !x._poll) && l.match(M._deserialize(x));
            } }, index: T, backward: h }, [4, this.collection.query(w)]) : [3, 3];
          case 1:
            return [4, I.sent().fetch({ limit: a ?? void 0 })];
          case 2:
            return N = I.sent(), [2, Promise.all(N.map(function(x) {
              return g(M, 0, void 0, function() {
                return _(this, function(R) {
                  return [2, this._deserialize(x)];
                });
              });
            }))];
          case 3:
            return [2, []];
        }
      });
    });
  }, n.prototype.getAllChildMessages = function(e, r) {
    return r === void 0 && (r = new Fi()), g(this, 0, void 0, function() {
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this.fetch({ channelUrl: e.channelUrl, token: Date.now(), limit: null, backward: !1, filter: r, order: An.NEWEST_CHILD_MESSAGE, parentMessageId: e.messageId })];
          case 1:
            return [2, i.sent()];
        }
      });
    });
  }, n.prototype.upsert = function(e) {
    var r;
    return g(this, 0, void 0, function() {
      var i, s, a, o, l, c, u, d, h = this;
      return _(this, function(p) {
        switch (p.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.saveBlobs(e)] : [3, 13];
          case 1:
            p.sent(), p.label = 2;
          case 2:
            p.trys.push([2, 7, 8, 9]), i = de(e), s = i.next(), p.label = 3;
          case 3:
            return s.done ? [3, 6] : (a = s.value, !((r = a.threadInfo) === null || r === void 0) && r._isUpdateRequired ? [4, this.get(a.messageId)] : [3, 5]);
          case 4:
            (o = p.sent()) != null && o.threadInfo && a.threadInfo._updateFrom(o.threadInfo), p.label = 5;
          case 5:
            return s = i.next(), [3, 3];
          case 6:
            return [3, 9];
          case 7:
            return l = p.sent(), u = { error: l }, [3, 9];
          case 8:
            try {
              s && !s.done && (d = i.return) && d.call(i);
            } finally {
              if (u)
                throw u.error;
            }
            return [7];
          case 9:
            return c = e.map(function(f) {
              return h._serialize(f);
            }), [4, this.collection.upsertMany(c)];
          case 10:
            return p.sent(), [4, this.upsertChildMessages(e)];
          case 11:
            return p.sent(), [4, this._unsentMessageCache.upsertChildMessages(e)];
          case 12:
            p.sent(), p.label = 13;
          case 13:
            return [2];
        }
      });
    });
  }, n.prototype.upsertChildMessages = function(e) {
    return g(this, 0, void 0, function() {
      var r = this;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.localCacheEnabled ? [4, Promise.all(e.map(function(s) {
              return g(r, 0, void 0, function() {
                var a, o;
                return _(this, function(l) {
                  switch (l.label) {
                    case 0:
                      return a = [], !((o = s.threadInfo) === null || o === void 0) && o.replyCount && s.threadInfo.replyCount > 0 ? [4, this.getAllChildMessages(s)] : [3, 2];
                    case 1:
                      a = l.sent(), l.label = 2;
                    case 2:
                      return a.length > 0 ? (a.forEach(function(c) {
                        return c.applyParentMessage(s);
                      }), [4, this.upsert(a)]) : [3, 4];
                    case 3:
                      l.sent(), l.label = 4;
                    case 4:
                      return [2];
                  }
                });
              });
            }))] : [3, 2];
          case 1:
            i.sent(), i.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.remove = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            if (!this.localCacheEnabled)
              return [3, 8];
            c.label = 1;
          case 1:
            c.trys.push([1, 6, 7, 8]), r = de(e), i = r.next(), c.label = 2;
          case 2:
            return i.done ? [3, 5] : (s = i.value, [4, this.collection.remove("".concat(s))]);
          case 3:
            c.sent(), c.label = 4;
          case 4:
            return i = r.next(), [3, 2];
          case 5:
            return [3, 8];
          case 6:
            return a = c.sent(), o = { error: a }, [3, 8];
          case 7:
            try {
              i && !i.done && (l = r.return) && l.call(r);
            } finally {
              if (o)
                throw o.error;
            }
            return [7];
          case 8:
            return [2];
        }
      });
    });
  }, n.prototype.removeMessagesOfChannel = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.removeIf({ where: { channelUrl: e }, index: di(An.CHANNEL_LATEST) })] : [3, 6];
          case 1:
            return i.sent(), [4, (r = this._cacheContext.preference).remove("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/sync"))];
          case 2:
            return i.sent(), [4, r.remove("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/sync.meta"))];
          case 3:
            return i.sent(), [4, r.remove("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/changelogs"))];
          case 4:
            return i.sent(), [4, r.remove("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/changelogs.meta"))];
          case 5:
            i.sent(), i.label = 6;
          case 6:
            return [2];
        }
      });
    });
  }, n.prototype.removeUnderOffset = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.removeIf({ where: { channelUrl: e, createdAt: { "<": r } }, index: di(An.CHANNEL_LATEST) })] : [3, 2];
          case 1:
            i.sent(), i.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.clear()] : [3, 2];
          case 1:
            e.sent(), e.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.countBetween = function(e, r, i) {
    return g(this, 0, void 0, function() {
      var s, a = this;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return this.localCacheEnabled ? (s = di(An.CHANNEL_LATEST), [4, this.collection.query({ where: { channelUrl: e, "/where": function(l) {
              var c = a._deserialize(l);
              return i.includes(c.createdAt) && r.match(c);
            } }, index: s }).count()]) : [3, 2];
          case 1:
            return [2, o.sent()];
          case 2:
            return [2, 0];
        }
      });
    });
  }, n.prototype.saveBlobs = function(e) {
    return g(this, 0, void 0, function() {
      var r = this;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, Promise.all(e.map(function(s) {
              return g(r, 0, void 0, function() {
                var a, o;
                return _(this, function(l) {
                  switch (l.label) {
                    case 0:
                      return s instanceof ln && s.messageParams && (a = s.messageParams).file && Sl(a.file) ? [4, this.collection.saveBlob(a.file, s.reqId)] : [3, 2];
                    case 1:
                      o = l.sent(), a.fileKey = o, l.label = 2;
                    case 2:
                      return [2];
                  }
                });
              });
            }))];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype._getGroupChannelPreferenceSize = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return r = 0, [4, (i = this._cacheContext.preference).get("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/sync"))];
          case 1:
            return s = c.sent(), [4, i.get("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/sync.meta"))];
          case 2:
            return a = c.sent(), [4, i.get("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/changelogs"))];
          case 3:
            return o = c.sent(), [4, i.get("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/changelogs.meta"))];
          case 4:
            return l = c.sent(), s && (r += JSON.stringify(s).length), a && (r += JSON.stringify(a).length), o && (r += JSON.stringify(o).length), l && (r += JSON.stringify(l).length), [2, r];
        }
      });
    });
  }, n;
}(xn), dl = {}, oC = function(t) {
  function n(e) {
    var r = t.call(this, e) || this;
    return dl[e] = r, r;
  }
  return S(n, t), Object.defineProperty(n.prototype, "_sdkState", { get: function() {
    return k.of(this._iid).sdkState;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "_cacheContext", { get: function() {
    return k.of(this._iid).cacheContext;
  }, enumerable: !1, configurable: !0 }), n.of = function(e, r) {
    return r === void 0 && (r = !1), dl[e] && !r || (dl[e] = new n(e)), dl[e];
  }, Object.defineProperty(n.prototype, "collection", { get: function() {
    var e = this._cacheContext.nestdb;
    return Z(!!e).throw(D.databaseError), e.collection(u_);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "localCacheEnabled", { get: function() {
    return this._cacheContext.localCacheEnabled && !!this.collection;
  }, enumerable: !1, configurable: !0 }), n.prototype._serialize = function(e) {
    return A({}, e.serialize());
  }, n.prototype._deserialize = function(e) {
    return bn.of(this._iid).buildMessageFromSerializedData(e);
  }, n.prototype.get = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.getByKey(e)] : [3, 2];
          case 1:
            if (r = i.sent())
              return [2, this._deserialize(r)];
            i.label = 2;
          case 2:
            return [2, void 0];
        }
      });
    });
  }, n.prototype.fetch = function(e) {
    var r = e.channelUrl, i = e.token, s = e.limit, a = s === void 0 ? 100 : s, o = e.filter, l = o === void 0 ? new Fi() : o, c = e.backward, u = c !== void 0 && c, d = e.exactMatch, h = d !== void 0 && d, p = e.inclusive, f = p === void 0 || p;
    return g(this, 0, void 0, function() {
      var m, v = this;
      return _(this, function(E) {
        switch (E.label) {
          case 0:
            return this.localCacheEnabled ? (m = { where: { channelUrl: r, "/where": function(y) {
              if (i) {
                if (h && y.createdAt !== i)
                  return !1;
                if (u) {
                  if (f && y.createdAt < i || !f && y.createdAt <= i)
                    return !1;
                } else if (f && y.createdAt > i || !f && y.createdAt >= i)
                  return !1;
              }
              return l.match(v._deserialize(y));
            } }, index: ["channelUrl", "-createdAt", "-notificationId"], backward: u }, [4, this.collection.query(m)]) : [3, 3];
          case 1:
            return [4, E.sent().fetch({ limit: a ?? void 0 })];
          case 2:
            return [2, E.sent().map(function(y) {
              return v._deserialize(y);
            })];
          case 3:
            return [2, []];
        }
      });
    });
  }, n.prototype.upsert = function(e) {
    return g(this, 0, void 0, function() {
      var r, i = this;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return this.localCacheEnabled ? (r = e.map(function(a) {
              return i._serialize(a);
            }), [4, this.collection.upsertMany(r)]) : [3, 2];
          case 1:
            s.sent(), s.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.remove = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            if (!this.localCacheEnabled)
              return [3, 8];
            c.label = 1;
          case 1:
            c.trys.push([1, 6, 7, 8]), r = de(e), i = r.next(), c.label = 2;
          case 2:
            return i.done ? [3, 5] : (s = i.value, [4, this.collection.remove(s)]);
          case 3:
            c.sent(), c.label = 4;
          case 4:
            return i = r.next(), [3, 2];
          case 5:
            return [3, 8];
          case 6:
            return a = c.sent(), o = { error: a }, [3, 8];
          case 7:
            try {
              i && !i.done && (l = r.return) && l.call(r);
            } finally {
              if (o)
                throw o.error;
            }
            return [7];
          case 8:
            return [2];
        }
      });
    });
  }, n.prototype.markAsReadByTimestamp = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.updateIf({ where: { channelUrl: e, messageStatus: Ls.SENT, createdAt: { "<": r } } }, { set: { messageStatus: Ls.READ } })] : [3, 2];
          case 1:
            i.sent(), i.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.markAsReadByMessageIds = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.updateIf({ where: { channelUrl: e, notificationId: { "/in": r }, messageStatus: Ls.SENT } }, { set: { messageStatus: Ls.READ } })] : [3, 2];
          case 1:
            return [2, i.sent().length];
          case 2:
            return [2, 0];
        }
      });
    });
  }, n.prototype.removeMessagesOfChannel = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.removeIf({ where: { channelUrl: e }, index: ["channelUrl", "-createdAt", "-notificationId"] })] : [3, 6];
          case 1:
            return i.sent(), [4, (r = this._cacheContext.preference).remove("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/sync"))];
          case 2:
            return i.sent(), [4, r.remove("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/sync.meta"))];
          case 3:
            return i.sent(), [4, r.remove("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/changelogs"))];
          case 4:
            return i.sent(), [4, r.remove("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/changelogs.meta"))];
          case 5:
            i.sent(), i.label = 6;
          case 6:
            return [2];
        }
      });
    });
  }, n.prototype.removeUnderOffset = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.removeIf({ where: { channelUrl: e, createdAt: { "<": r } }, index: di(An.CHANNEL_LATEST) })] : [3, 2];
          case 1:
            i.sent(), i.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return this.localCacheEnabled ? [4, this.collection.clear()] : [3, 2];
          case 1:
            e.sent(), e.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.countBetween = function(e, r, i) {
    return g(this, 0, void 0, function() {
      var s, a = this;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return this.localCacheEnabled ? (s = ["channelUrl", "-createdAt", "-notificationId"], [4, this.collection.query({ where: { channelUrl: e, "/where": function(l) {
              var c = a._deserialize(l);
              return i.includes(c.createdAt) && r.match(c);
            } }, index: s }).count()]) : [3, 2];
          case 1:
            return [2, o.sent()];
          case 2:
            return [2, 0];
        }
      });
    });
  }, n;
}(xn), xa = {}, p_ = function(t) {
  function n(e) {
    var r = t.call(this, e) || this;
    return r._observers = /* @__PURE__ */ new Map(), r._dispatcherContext = r._dispatcher.on(function(i) {
      return g(r, 0, void 0, function() {
        var s, a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M, I = this;
        return _(this, function(x) {
          switch (x.label) {
            case 0:
              return i instanceof Pt ? (s = i.messages, M = i.source, u = i.isWebSocketEventComing, a = s.filter(function(R) {
                return R instanceof Vn && R.channelType !== yt.OPEN && R.messageId > 0;
              }), o = s.filter(function(R) {
                return R instanceof Vn && R.channelType !== yt.OPEN && R.messageId === 0;
              }), l = s.filter(function(R) {
                return R instanceof Gs;
              }), a.length > 0 ? [4, tn(function() {
                return g(I, 0, void 0, function() {
                  return _(this, function(R) {
                    switch (R.label) {
                      case 0:
                        return [4, this._messageCache.upsert(a)];
                      case 1:
                        return R.sent(), [4, this._unsentMessageCache.remove(a.map(function(L) {
                          return L instanceof en ? L.reqId : null;
                        }).filter(function(L) {
                          return L !== null;
                        }))];
                      case 2:
                        return R.sent(), [2];
                    }
                  });
                });
              })] : [3, 2]) : [3, 7];
            case 1:
              x.sent(), u || this._broadcastUpdateEvent(a, M), x.label = 2;
            case 2:
              return o.length > 0 ? [4, tn(function() {
                return g(I, 0, void 0, function() {
                  return _(this, function(R) {
                    switch (R.label) {
                      case 0:
                        return [4, this._unsentMessageCache.upsert(o)];
                      case 1:
                        return R.sent(), [2];
                    }
                  });
                });
              })] : [3, 4];
            case 3:
              x.sent(), u || this._broadcastUpdateEvent(o, M), x.label = 4;
            case 4:
              return l.length > 0 ? [4, tn(function() {
                return g(I, 0, void 0, function() {
                  return _(this, function(R) {
                    switch (R.label) {
                      case 0:
                        return [4, this._notificationCache.upsert(l)];
                      case 1:
                        return R.sent(), [2];
                    }
                  });
                });
              })] : [3, 6];
            case 5:
              x.sent(), u || this._broadcastUpdateEvent(l, M), x.label = 6;
            case 6:
              return [3, 24];
            case 7:
              return i instanceof Qd ? (c = i.messageIds, M = i.source, u = i.isWebSocketEventComing, d = c.filter(function(R) {
                return typeof R == "number";
              }), h = c.filter(function(R) {
                return typeof R == "string";
              }), [4, tn(function() {
                return g(I, 0, void 0, function() {
                  return _(this, function(R) {
                    switch (R.label) {
                      case 0:
                        return d.length > 0 ? [4, this._messageCache.remove(d)] : [3, 2];
                      case 1:
                        R.sent(), R.label = 2;
                      case 2:
                        return h.length > 0 ? [4, this._notificationCache.remove(h)] : [3, 4];
                      case 3:
                        R.sent(), R.label = 4;
                      case 4:
                        return [2];
                    }
                  });
                });
              })]) : [3, 9];
            case 8:
              return x.sent(), u || this._broadcastRemoveEvent(c, M), [3, 24];
            case 9:
              return i instanceof Fm ? (p = i.reqId, M = i.source, [4, tn(function() {
                return g(I, 0, void 0, function() {
                  return _(this, function(R) {
                    switch (R.label) {
                      case 0:
                        return [4, this._unsentMessageCache.remove([p])];
                      case 1:
                        return R.sent(), [2];
                    }
                  });
                });
              })]) : [3, 11];
            case 10:
              return x.sent(), this._broadcastRemoveUnsentEvent(p, M), [3, 24];
            case 11:
              return i instanceof jm ? (f = i.polls, M = i.source, this._cacheContext.localCacheEnabled ? (m = f.map(function(R) {
                return R.messageId;
              }), [4, Promise.all(m.map(function(R) {
                return I._messageCache.get(R);
              }))]) : [3, 14]) : [3, 15];
            case 12:
              return (v = x.sent().filter(function(R) {
                return R;
              })).length > 0 && f.forEach(function(R) {
                var L = v.find(function(j) {
                  return j.messageId === R.messageId;
                });
                L && L.applyPoll(R);
              }), [4, tn(function() {
                return g(I, 0, void 0, function() {
                  return _(this, function(R) {
                    switch (R.label) {
                      case 0:
                        return [4, this._messageCache.upsert(v)];
                      case 1:
                        return [2, R.sent()];
                    }
                  });
                });
              })];
            case 13:
              x.sent(), x.label = 14;
            case 14:
              return this._broadcastPollChangeLogEvent(f, M), [3, 24];
            case 15:
              return i instanceof Hm ? (E = i.event, M = i.source, [4, this._messageCache.get(E.messageId)]) : [3, 19];
            case 16:
              return (y = x.sent()) && y.isUserMessage() && y.poll && y.poll.applyPollUpdateEvent(E) ? [4, tn(function() {
                return g(I, 0, void 0, function() {
                  return _(this, function(R) {
                    switch (R.label) {
                      case 0:
                        return [4, this._messageCache.upsert([y])];
                      case 1:
                        return [2, R.sent()];
                    }
                  });
                });
              })] : [3, 18];
            case 17:
              x.sent(), x.label = 18;
            case 18:
              return this._broadcastPollUpdateEvent(E, M), [3, 24];
            case 19:
              return i instanceof Yd ? (b = i.event, M = i.source, [4, this._messageCache.get(b.messageId)]) : [3, 23];
            case 20:
              return (T = x.sent()) && T.isUserMessage() && T.poll && T.poll.applyPollVoteEvent(b) ? [4, tn(function() {
                return g(I, 0, void 0, function() {
                  return _(this, function(R) {
                    switch (R.label) {
                      case 0:
                        return [4, this._messageCache.upsert([T])];
                      case 1:
                        return [2, R.sent()];
                    }
                  });
                });
              })] : [3, 22];
            case 21:
              x.sent(), x.label = 22;
            case 22:
              return this._broadcastPollVoteEvent(b, M), [3, 24];
            case 23:
              i instanceof Um ? (w = i.event, M = i.source, w.messageId > 0 && this._broadcastReactionUpdateEvent(w, M)) : i instanceof Pm && (N = i.event, M = i.source, this._broadcastThreadUpdateEvent(N, M)), x.label = 24;
            case 24:
              return [2];
          }
        });
      });
    }), r;
  }
  return S(n, t), Object.defineProperty(n.prototype, "_cacheContext", { get: function() {
    return k.of(this._iid).cacheContext;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "_dispatcher", { get: function() {
    return k.of(this._iid).dispatcher;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "_messageCache", { get: function() {
    return oa.of(this._iid);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "_unsentMessageCache", { get: function() {
    return Ks.of(this._iid);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "_notificationCache", { get: function() {
    return oC.of(this._iid);
  }, enumerable: !1, configurable: !0 }), n.of = function(e, r) {
    var i;
    return r === void 0 && (r = !1), xa[e] && !r || (xa[e] && ((i = xa[e]._dispatcherContext) === null || i === void 0 || i.close()), xa[e] = new n(e)), xa[e];
  }, n.prototype._broadcastUpdateEvent = function(e, r) {
    var i, s;
    try {
      for (var a = de(this._observers.values()), o = a.next(); !o.done; o = a.next()) {
        var l = o.value;
        l.onUpdate && l.onUpdate(e, r);
      }
    } catch (c) {
      i = { error: c };
    } finally {
      try {
        o && !o.done && (s = a.return) && s.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, n.prototype._broadcastPollChangeLogEvent = function(e, r) {
    var i, s;
    try {
      for (var a = de(this._observers.values()), o = a.next(); !o.done; o = a.next()) {
        var l = o.value;
        l.onPollChangeLogUpdate && l.onPollChangeLogUpdate(e, r);
      }
    } catch (c) {
      i = { error: c };
    } finally {
      try {
        o && !o.done && (s = a.return) && s.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, n.prototype._broadcastPollUpdateEvent = function(e, r) {
    var i, s;
    try {
      for (var a = de(this._observers.values()), o = a.next(); !o.done; o = a.next()) {
        var l = o.value;
        l.onPollUpdate && l.onPollUpdate(e, r);
      }
    } catch (c) {
      i = { error: c };
    } finally {
      try {
        o && !o.done && (s = a.return) && s.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, n.prototype._broadcastPollVoteEvent = function(e, r) {
    var i, s;
    try {
      for (var a = de(this._observers.values()), o = a.next(); !o.done; o = a.next()) {
        var l = o.value;
        l.onPollVote && l.onPollVote(e, r);
      }
    } catch (c) {
      i = { error: c };
    } finally {
      try {
        o && !o.done && (s = a.return) && s.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, n.prototype._broadcastRemoveEvent = function(e, r) {
    var i, s;
    try {
      for (var a = de(this._observers.values()), o = a.next(); !o.done; o = a.next()) {
        var l = o.value;
        l.onRemove && l.onRemove(e, r);
      }
    } catch (c) {
      i = { error: c };
    } finally {
      try {
        o && !o.done && (s = a.return) && s.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, n.prototype._broadcastRemoveUnsentEvent = function(e, r) {
    var i, s;
    try {
      for (var a = de(this._observers.values()), o = a.next(); !o.done; o = a.next()) {
        var l = o.value;
        l.onRemoveUnsent && l.onRemoveUnsent(e, r);
      }
    } catch (c) {
      i = { error: c };
    } finally {
      try {
        o && !o.done && (s = a.return) && s.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, n.prototype._broadcastReactionUpdateEvent = function(e, r) {
    var i, s;
    try {
      for (var a = de(this._observers.values()), o = a.next(); !o.done; o = a.next()) {
        var l = o.value;
        l.onReactionUpdate && l.onReactionUpdate(e, r);
      }
    } catch (c) {
      i = { error: c };
    } finally {
      try {
        o && !o.done && (s = a.return) && s.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, n.prototype._broadcastThreadUpdateEvent = function(e, r) {
    var i, s;
    try {
      for (var a = de(this._observers.values()), o = a.next(); !o.done; o = a.next()) {
        var l = o.value;
        l.onThreadInfoUpdate && l.onThreadInfoUpdate(e, r);
      }
    } catch (c) {
      i = { error: c };
    } finally {
      try {
        o && !o.done && (s = a.return) && s.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, n.prototype.subscribe = function(e, r) {
    this._observers.set(e, r);
  }, n.prototype.unsubscribe = function(e) {
    this._observers.delete(e);
  }, n.prototype.unsubscribeAll = function() {
    this._observers.clear();
  }, n;
}(xn), lC = function(t) {
  function n(e) {
    var r = this, i = e.reverse, s = i !== void 0 && i, a = e.limit, o = a === void 0 ? 20 : a, l = e.keys, c = e.token;
    return (r = t.call(this) || this).method = Y.GET, r.path = "".concat(rm), r.params = fe({ token: c, limit: o, reverse: s, order: Yu.UPDATED_AT, show_ui_template: !0, show_color_variables: !0, keys: l }), r;
  }
  return S(n, t), n;
}($), cC = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this, s = r.next, a = r.has_more, o = a !== void 0 && a, l = r.templates;
    return i.nextToken = s, i.hasMore = o, i.templates = l.map(function(c) {
      return { template: JSON.stringify(c) };
    }), i;
  }
  return S(n, t), n;
}(ne), uC = function(t) {
  function n(e) {
    var r = this, i = e.key;
    return (r = t.call(this) || this).method = Y.GET, r.path = "".concat(rm, "/").concat(i), r;
  }
  return S(n, t), n;
}($), dC = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.template = JSON.stringify(r), i;
  }
  return S(n, t), n;
}(ne), nf = {}, bn = function() {
  function t(n, e) {
    var r = e.sdkState, i = e.dispatcher, s = e.requestQueue, a = e.onlineDetector, o = e.cacheContext;
    this._iid = n, this._sdkState = r, this._requestQueue = s, this._dispatcher = i, this._cacheContext = o, oa.of(n), Ks.of(n), p_.of(n), this.fileMessageQueue = new mb(n, { sdkState: r, dispatcher: i, requestQueue: s, onlineDetector: a, cacheContext: o }), nf[n] = this;
  }
  return t.of = function(n) {
    return nf[n];
  }, t.prototype.buildMessageFromSerializedData = function(n) {
    var e = js(n);
    if (e.notificationId)
      return new Gs(this._iid, Gs.payloadify(e));
    switch (e.messageType) {
      case Yt.USER:
        return new Ln(this._iid, Ln.payloadify(e));
      case Yt.FILE:
        return Sr._isMultipleFilesMessageSerializedData(e) ? new Sr(this._iid, Sr.payloadify(e)) : new ln(this._iid, ln.payloadify(e));
      case Yt.ADMIN:
        return new va(this._iid, va.payloadify(e));
    }
    throw D.invalidParameters;
  }, t.prototype.buildUserMessageCreateParamsFromSerializedData = function(n, e) {
    return fe(Ae({ data: e.data, customType: e.customType, mentionType: e.mentionType, mentionedUserIds: e.mentionedUserIds, mentionedUsers: e.mentionedUsers, mentionedMessageTemplate: e.mentionedMessageTemplate, metaArrays: e.metaArrays, parentMessageId: e.parentMessageId, isReplyToChannel: n.isReplyToChannel, pushNotificationDeliveryOption: n.pushNotificationDeliveryOption, appleCriticalAlertOptions: e.appleCriticalAlertOptions, reqId: e.reqId, message: e.message, translationTargetLanguages: Object.keys(e.translations), pollId: n.pollId }));
  }, t.prototype.buildFileMessageCreateParamsFromSerializedData = function(n, e) {
    var r;
    return fe(Ae({ data: e.data, customType: e.customType, mentionType: e.mentionType, mentionedUserIds: e.mentionedUserIds, mentionedUsers: e.mentionedUsers, mentionedMessageTemplate: e.mentionedMessageTemplate, metaArrays: e.metaArrays, parentMessageId: e.parentMessageId, isReplyToChannel: n.isReplyToChannel, pushNotificationDeliveryOption: n.pushNotificationDeliveryOption, appleCriticalAlertOptions: e.appleCriticalAlertOptions, reqId: e.reqId, file: n.file, fileKey: n.fileKey, fileUrl: e.plainUrl, fileName: e.name, fileSize: e.size, mimeType: e.type, thumbnailSizes: (r = e.thumbnails) === null || r === void 0 ? void 0 : r.map(function(i) {
      return { maxWidth: i.width, maxHeight: i.height };
    }), fileType: n.fileType, requireAuth: e.requireAuth }));
  }, t.prototype.buildMultipleFilesMessageCreateParamsFromSerializedData = function(n, e) {
    var r = this;
    return fe({ data: e.data, customType: e.customType, mentionType: e.mentionType, mentionedUserIds: e.mentionedUserIds, mentionedUsers: e.mentionedUsers, mentionedMessageTemplate: e.mentionedMessageTemplate, metaArrays: e.metaArrays, parentMessageId: e.parentMessageId, isReplyToChannel: n.isReplyToChannel, pushNotificationDeliveryOption: n.pushNotificationDeliveryOption, appleCriticalAlertOptions: e.appleCriticalAlertOptions, reqId: e.reqId, fileInfoList: n.fileInfoList.map(function(i) {
      return new ec(r._iid, i);
    }) });
  }, t.prototype.buildScheduledUserMessageCreateParamsFromSerializedData = function(n, e) {
    return A(A({}, this.buildUserMessageCreateParamsFromSerializedData(n, e)), { scheduledAt: n.scheduledAt });
  }, t.prototype.buildScheduledFileMessageCreateParamsFromSerializedData = function(n, e) {
    return A(A({}, this.buildFileMessageCreateParamsFromSerializedData(n, e)), { scheduledAt: n.scheduledAt });
  }, t.prototype.buildSenderFromSerializedData = function(n) {
    var e = js(n);
    return new ga(this._iid, ga.payloadify(e));
  }, t.prototype.getMessage = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return e = new _b(n), [4, this._requestQueue.send(e)];
          case 1:
            return [2, r.sent().as(gb).message];
        }
      });
    });
  }, t.prototype.getScheduledMessage = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return e = new bb(n), [4, this._requestQueue.send(e)];
          case 1:
            return [2, r.sent().as(Eb).message];
        }
      });
    });
  }, t.prototype.getMessagesByMessageId = function(n, e, r, i, s) {
    return s === void 0 && (s = B.REQUEST_MESSAGE), g(this, 0, void 0, function() {
      var a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return a = new rl(A(A({ channelType: e, channelUrl: n, token: String(r) }, uo), i)), [4, this._requestQueue.send(a)];
          case 1:
            return o = c.sent(), l = o.as(il).messages, this._dispatcher.dispatch(new Pt({ messages: l, source: s })), [2, l];
        }
      });
    });
  }, t.prototype.getMessagesByTimestamp = function(n, e, r, i, s) {
    return s === void 0 && (s = B.REQUEST_MESSAGE), g(this, 0, void 0, function() {
      var a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return a = new rl(A(A({ channelType: e, channelUrl: n, timestamp: r }, uo), i)), [4, this._requestQueue.send(a)];
          case 1:
            return o = c.sent(), l = o.as(il).messages, this._dispatcher.dispatch(new Pt({ messages: l, source: s })), [2, l];
        }
      });
    });
  }, t.prototype._getMessagesByTimestampForCollection = function(n, e, r, i, s, a, o) {
    return s === void 0 && (s = B.REQUEST_MESSAGE), g(this, 0, void 0, function() {
      var l, c, u, d, h, p;
      return _(this, function(f) {
        switch (f.label) {
          case 0:
            return l = new rl(A(A(A({ channelType: e, channelUrl: n, timestamp: r }, uo), i), { checkingHasNext: a, checkingContinuousMessages: o })), [4, this._requestQueue.send(l)];
          case 1:
            return c = f.sent(), u = c.as(il), d = u.messages, h = u.isContinuousMessages, p = u.hasNext, this._dispatcher.dispatch(new Pt({ messages: d, source: s })), [2, { messages: d, isContinuousMessages: h, hasNext: p }];
        }
      });
    });
  }, t.prototype.getThreadedMessagesByTimestamp = function(n, e, r, i) {
    return i === void 0 && (i = B.REQUEST_THREADED_MESSAGE), g(this, 0, void 0, function() {
      var s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new rl(A(A(A({ channelUrl: n.channelUrl, channelType: n.channelType, timestamp: e }, Uo), r), { replyType: Fn.ALL, parentMessageId: n.messageId, includeThreadInfo: !0 })), [4, this._requestQueue.send(s)];
          case 1:
            return a = c.sent(), o = a.as(il).messages, (l = o.slice(1)).forEach(function(u) {
              u.parentMessage = n;
            }), this._dispatcher.dispatch(new Pt({ messages: l, source: i })), [2, { parentMessage: o[0], threadedMessages: l }];
        }
      });
    });
  }, t.prototype.getMessageTemplatesByToken = function(n, e) {
    return e === void 0 && (e = {}), g(this, 0, void 0, function() {
      var r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new lC(A({ token: n }, e)), [4, this._requestQueue.send(r)];
          case 1:
            return i = c.sent(), s = i.as(cC), a = s.hasMore, o = s.nextToken, l = s.templates, [2, { hasMore: a, token: o, templates: l }];
        }
      });
    });
  }, t.prototype.getMessageTemplate = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return e = new uC({ key: n }), [4, this._requestQueue.send(e)];
          case 1:
            return [2, { template: r.sent().as(dC).template }];
        }
      });
    });
  }, t.prototype.getMessageChangelogs = function(n, e, r, i, s) {
    return s === void 0 && (s = B.REQUEST_MESSAGE_CHANGELOGS), g(this, 0, void 0, function() {
      var a, o, l, c, u, d, h, p;
      return _(this, function(f) {
        switch (f.label) {
          case 0:
            return a = new vb(fe(Ae(A(A({ channelType: e, channelUrl: n, timestamp: typeof r == "number" ? r : null, token: typeof r == "string" ? r : null }, od), i)))), [4, this._requestQueue.send(a)];
          case 1:
            return o = f.sent(), l = o.as(yb), c = l.updatedMessages, u = l.deletedMessagesInfo, d = l.hasMore, h = l.nextToken, p = u.map(function(m) {
              return m.messageId;
            }), c.length > 0 && this._dispatcher.dispatch(new Pt({ messages: c, source: s })), p.length > 0 && this._dispatcher.dispatch(new Qd({ messageIds: p, source: s })), [2, { updatedMessages: c, deletedMessageIds: p, hasMore: d, token: h }];
        }
      });
    });
  }, t;
}(), f_ = function(t) {
  function n(e, r) {
    var i = t.call(this, e) || this;
    i.targetMessageId = 0;
    var s = r.thread_info, a = r.parent_message_id, o = r.channel_url, l = r.channel_type;
    return s && O("object", s) && O("number", a) && O("string", o) && O("string", l) && (i.threadInfo = new Jl(e, s), i.targetMessageId = a, i.channelUrl = o, i.channelType = l), i;
  }
  return S(n, t), n;
}(xn), hC = { channelUrl: "", channelType: yt.BASE, messageId: 0, includeReactions: !1, includeMetaArray: !1, includeParentMessageInfo: !1, includeThreadInfo: !1 }, pC = function(t) {
  function n(e) {
    var r = e.channelCustomType, i = e.keyword, s = e.limit, a = e.reverse, o = e.exactMatch, l = e.channelUrl, c = e.order, u = e.messageTimestampFrom, d = e.messageTimestampTo, h = e.advancedQuery, p = e.targetFields, f = e.nextToken, m = t.call(this) || this;
    return m.method = Y.GET, m.path = "".concat(iy, "/messages"), m.params = { custom_type: r, query: i, limit: s, reverse: a, exact_match: o, channel_url: l, message_ts_from: u, message_ts_to: d, sort_field: c, advanced_query: h, target_fields: p, after: f }, m;
  }
  return S(n, t), n;
}($), fC = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.messages = r.results.map(function(s) {
      return Kn(e, s);
    }), i.hasNext = r.has_next, i.nextToken = r.end_cursor, i.totalCount = r.total_count, i;
  }
  return S(n, t), n;
}(ne);
(function(t) {
  t.SCORE = "score", t.TIMESTAMP = "ts";
})(fo || (fo = {}));
var nn, mo, md, mC = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d, h, p = this;
    return (p = t.call(this, e, r) || this).keyword = "", p.reverse = !1, p.exactMatch = !1, p.channelUrl = "", p.channelCustomType = "", p.messageTimestampFrom = null, p.messageTimestampTo = null, p.order = fo.SCORE, p.advancedQuery = !1, p.targetFields = null, p._nextToken = "", p.totalCount = -1, p.keyword = r.keyword, p.reverse = (i = r.reverse) !== null && i !== void 0 && i, p.exactMatch = (s = r.exactMatch) !== null && s !== void 0 && s, p.channelUrl = (a = r.channelUrl) !== null && a !== void 0 ? a : "", p.channelCustomType = (o = r.channelCustomType) !== null && o !== void 0 ? o : "", p.messageTimestampFrom = (l = r.messageTimestampFrom) !== null && l !== void 0 ? l : null, p.messageTimestampTo = (c = r.messageTimestampTo) !== null && c !== void 0 ? c : null, p.order = (u = r.order) !== null && u !== void 0 ? u : fo.SCORE, p.advancedQuery = (d = r.advancedQuery) !== null && d !== void 0 && d, p.targetFields = (h = r.targetFields) !== null && h !== void 0 ? h : null, p;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this) && O("string", this.keyword) && this.keyword.length > 0 && O("boolean", this.reverse) && O("boolean", this.exactMatch) && O("string", this.channelUrl) && O("string", this.channelCustomType) && (O("number", this.messageTimestampFrom) || this.messageTimestampFrom === null) && (O("number", this.messageTimestampTo) || this.messageTimestampTo === null) && Ze(fo, this.order) && O("boolean", this.advancedQuery) && tt("string", this.targetFields, !0);
  }, n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = k.of(this._iid).requestQueue, r = new pC(Ae(A(A({}, this), { nextToken: this._nextToken ? this._nextToken : null }))), [4, e.send(r)]) : [3, 2] : [3, 5];
          case 1:
            return i = u.sent(), s = i.as(fC), a = s.messages, o = s.hasNext, l = s.nextToken, c = s.totalCount, this._nextToken = l, this._hasNext = o, this._isLoading = !1, this.totalCount = c, [2, a];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(cs), _C = function(t) {
  function n(e) {
    var r = e.channelType, i = e.channelUrl, s = e.limit, a = e.token, o = t.call(this) || this;
    return o.method = Y.GET, o.path = "".concat(gt(r), "/").concat(encodeURIComponent(i), "/messages/parent_thread_message"), o.params = fe(Ae({ limit: s, token: a })), o;
  }
  return S(n, t), n;
}($), gC = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.token = r.next, i.messages = r.messages.map(function(s) {
      return Kn(e, s);
    }), i;
  }
  return S(n, t), n;
}(ne), vC = function(t) {
  function n(e, r, i, s) {
    var a = t.call(this, e, r, i, s) || this;
    return a._edge = "", a;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this);
  }, n.prototype.load = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = k.of(this._iid).requestQueue, r = new _C({ channelType: this.channelType, channelUrl: this.channelUrl, token: this._edge, limit: this.limit }), [4, e.send(r)]) : [3, 2] : [3, 5];
          case 1:
            return i = l.sent(), s = i.as(gC), a = s.messages, o = s.token, this._edge = o, this._hasNext = !!o, this._isLoading = !1, [2, a];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(Hi), yC = { channelUrl: "", scheduledMessageId: 0 }, bC = { reverse: !1, limit: 20 }, EC = function(t) {
  function n() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e.name = "message", e;
  }
  return S(n, t), n.prototype.init = function(e, r) {
    var i = r.sdkState, s = r.dispatcher, a = r.sessionManager, o = r.requestQueue, l = r.logger, c = r.onlineDetector, u = r.cacheContext;
    t.prototype.init.call(this, e, { sdkState: i, dispatcher: s, sessionManager: a, requestQueue: o, logger: l, onlineDetector: c, cacheContext: u }), this._manager = new bn(e, { sdkState: i, dispatcher: s, requestQueue: o, onlineDetector: c, cacheContext: u });
  }, n.prototype.buildMessageFromSerializedData = function(e) {
    return this._manager.buildMessageFromSerializedData(e);
  }, n.prototype.buildSenderFromSerializedData = function(e) {
    return this._manager.buildSenderFromSerializedData(e);
  }, n.prototype.getMessage = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return r = A(A({}, hC), e), Z(function(a) {
              return O("string", a.channelUrl) && Ze(yt, a.channelType) && O("number", a.messageId) && O("boolean", a.includeReactions, !0) && O("boolean", a.includeMetaArray, !0) && O("boolean", a.includeParentMessageInfo, !0) && O("boolean", a.includeThreadInfo, !0);
            }(r)).throw(D.invalidParameters), [4, this._manager.getMessage(r)];
          case 1:
            if ((i = s.sent()) instanceof Vn || i instanceof Gs || i === null)
              return [2, i];
            throw "Unknown message type is given.";
        }
      });
    });
  }, n.prototype.getScheduledMessage = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        return r = A(A({}, yC), e), Z(function(s) {
          return O("string", s.channelUrl) && s.channelUrl !== "" && O("number", s.scheduledMessageId) && s.scheduledMessageId > 0;
        }(r)).throw(D.invalidParameters), [2, this._manager.getScheduledMessage(r)];
      });
    });
  }, n.prototype.getMessageTemplatesByToken = function(e, r) {
    return r === void 0 && (r = {}), g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        return i = A(A({}, bC), r), Z(O("string", e, !0) && function(a) {
          return O("boolean", a.reverse, !0) && O("number", a.limit, !0) && tt("string", a.keys, !0);
        }(i)).throw(D.invalidParameters), [2, this._manager.getMessageTemplatesByToken(e, i)];
      });
    });
  }, n.prototype.getMessageTemplate = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return Z(O("string", e)).throw(D.invalidParameters), [2, this._manager.getMessageTemplate(e)];
      });
    });
  }, n;
}(Wd), CC = function(t, n) {
  this.pollId = 0, this.messageId = 0, this.pollId = n.poll.id, this.messageId = n.poll.message_id, this._iid = t, this._payload = n;
}, TC = function(t) {
  function n() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e.name = "poll", e;
  }
  return S(n, t), n.prototype.init = function(e, r) {
    var i = r.sdkState, s = r.dispatcher, a = r.sessionManager, o = r.requestQueue, l = r.logger, c = r.onlineDetector, u = r.cacheContext;
    t.prototype.init.call(this, e, { sdkState: i, dispatcher: s, sessionManager: a, requestQueue: o, logger: l, onlineDetector: c, cacheContext: u }), this._manager = new $l(e, { sdkState: i, dispatcher: s, sessionManager: a, requestQueue: o, logger: l, onlineDetector: c, cacheContext: u });
  }, n.prototype.create = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        return r = A(A({}, $1), e), Z(zm(r)).throw(D.invalidParameters), [2, this._manager.create(r)];
      });
    });
  }, n.prototype.get = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        return r = A(A({}, X1), e), Z(Gm(r)).throw(D.invalidParameters), [2, this._manager.get(r)];
      });
    });
  }, n.prototype.getOption = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        return r = A(A({}, Z1), e), Z(Vm(r)).throw(D.invalidParameters), [2, this._manager.getOption(r)];
      });
    });
  }, n.prototype.buildPollFromSerializedData = function(e) {
    return this._manager.buildPollFromSerializedData(e);
  }, n;
}(Wd);
(function(t) {
  t.LATEST_LAST_MESSAGE = "latest_last_message", t.CHRONOLOGICAL = "chronological", t.CHANNEL_NAME_ALPHABETICAL = "channel_name_alphabetical", t.METADATA_VALUE_ALPHABETICAL = "metadata_value_alphabetical";
})(nn || (nn = {})), function(t) {
  t.CHRONOLOGICAL = "chronological", t.CHANNEL_NAME_ALPHABETICAL = "channel_name_alphabetical", t.METADATA_VALUE_ALPHABETICAL = "metadata_value_alphabetical";
}(mo || (mo = {})), function(t) {
  t.CREATED_AT = "created_at", t.SCHEDULED_AT = "scheduled_at";
}(md || (md = {}));
var Ao, Al = function(t) {
  switch (t) {
    case nn.LATEST_LAST_MESSAGE:
      return ["-lastMessageUpdatedAt", "-createdAt", "syncIndex"];
    case nn.CHRONOLOGICAL:
      return ["-createdAt", "syncIndex"];
    case nn.CHANNEL_NAME_ALPHABETICAL:
      return ["name"];
    default:
      return ["-lastMessageUpdatedAt", "-createdAt", "syncIndex"];
  }
}, m_ = function(t) {
  function n(e) {
    var r = e.message, i = t.call(this) || this;
    return i.message = r, i;
  }
  return S(n, t), n;
}(Vt), rf = {}, Ka = function() {
  function t(n, e) {
    var r = e.localCacheEnabled, i = e.enableAutoResend, s = e.dispatcher, a = e.sdkState, o = e.logger, l = this;
    this._iid = n, rf[n] = this, this._localCacheEnabled = r, this._enableAutoResend = i, this._isProcessingAutoResend = !1, this._autoResendQueue = [], this._dispatcher = s, this._logger = o, this._sdkState = a, this._localCacheEnabled && s.on(function(c) {
      if (c instanceof Ar)
        switch (c.stateType) {
          case bt.CONNECTED:
            l._isProcessingAutoResend || l.processAutoResendRegisteredPendingMessages().then(function() {
              return l._processNextAutoResend();
            });
            break;
          case bt.INTERNAL_DISCONNECTED:
          case bt.EXTERNAL_DISCONNECTED:
            l._isProcessingAutoResend = !1;
        }
    });
  }
  return t.of = function(n) {
    return rf[n];
  }, t.prototype.processNonAutoResendRegisteredPendingMessages = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return this._enableAutoResend ? [4, this._fetchAllCachedPendingMessages()] : [2];
          case 1:
            n = o.sent();
            try {
              for (e = de(n), r = e.next(); !r.done; r = e.next())
                (i = r.value).errorCode === 0 && (this._logger.debug("cached pending message is not auto-resend registered. changing its sending status to failed: ", i.reqId), i.sendingStatus = St.FAILED, i.errorCode = me.ACK_TIMEOUT, this._dispatcher.dispatch(new Pt({ messages: [i], source: B.LOCAL_MESSAGE_FAILED })));
            } catch (l) {
              s = { error: l };
            } finally {
              try {
                r && !r.done && (a = e.return) && a.call(e);
              } finally {
                if (s)
                  throw s.error;
              }
            }
            return [2];
        }
      });
    });
  }, t.prototype.processAutoResendRegisteredPendingMessages = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, this._fetchAllCachedPendingMessages()];
          case 1:
            n = c.sent();
            try {
              for (e = de(n), r = e.next(); !r.done; r = e.next())
                i = r.value, this._enableAutoResend && i.errorCode && Hl(i.errorCode) && (s = (/* @__PURE__ */ new Date()).getTime(), a = i.createdAt + 2592e5, this._enableAutoResend && s <= a ? this._autoResendQueue.map(function(u) {
                  return u.reqId;
                }).indexOf(i.reqId) < 0 && this._autoResendQueue.push(i) : (this._logger.debug("auto-resend registered pending messaged expired. expiration date: ", new Date(a).toLocaleString()), i.sendingStatus = St.FAILED, this._dispatcher.dispatch(new Pt({ messages: [i], source: B.LOCAL_MESSAGE_FAILED }))));
            } catch (u) {
              o = { error: u };
            } finally {
              try {
                r && !r.done && (l = e.return) && l.call(e);
              } finally {
                if (o)
                  throw o.error;
              }
            }
            return [2];
        }
      });
    });
  }, t.prototype.completeCurrentAndProcessNextAutoResend = function(n) {
    if (this._localCacheEnabled && this._enableAutoResend && (n.sendingStatus === St.SUCCEEDED || n.sendingStatus === St.FAILED && !Hl(n.errorCode))) {
      var e = this.indexOf(n);
      e >= 0 && this._autoResendQueue.splice(e, 1), e === 0 && this._processNextAutoResend();
    }
  }, t.prototype._fetchAllCachedPendingMessages = function() {
    return g(this, 0, void 0, function() {
      var n, e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return n = Ks.of(this._iid), (e = new Fi()).replyType = Fn.ALL, [4, n.fetch({ sendingStatus: St.PENDING, backward: !0, filter: e })];
          case 1:
            return [2, r.sent()];
        }
      });
    });
  }, t.prototype.indexOf = function(n) {
    return this._autoResendQueue.length > 0 ? this._autoResendQueue.map(function(e) {
      return e.reqId;
    }).indexOf(n.reqId) : -1;
  }, t.prototype._isNotInQueue = function(n) {
    return this._autoResendQueue.map(function(e) {
      return e.reqId;
    }).indexOf(n.reqId) === -1;
  }, t.prototype._processNextAutoResend = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        if (this._localCacheEnabled && this._enableAutoResend && this._sdkState.appState === "foreground")
          try {
            this._autoResendQueue.length > 0 ? (this._isProcessingAutoResend || (this._logger.debug("auto-resend queue started."), this._isProcessingAutoResend = !0), n = this._autoResendQueue[0], this._dispatcher.dispatch(new m_({ message: n })), this._logger.debug("processing auto-resend for message request id: ", n.reqId)) : (this._logger.debug("auto-resend queue finished."), this._isProcessingAutoResend = !1);
          } catch (r) {
            this._logger.warn("process auto-resend error: ", r), this._isProcessingAutoResend = !1;
          }
        return [2];
      });
    });
  }, t;
}();
(function(t) {
  t[t.USER_BLOCK = 20001] = "USER_BLOCK", t[t.USER_UNBLOCK = 2e4] = "USER_UNBLOCK", t[t.FRIEND_DISCOVERED = 20900] = "FRIEND_DISCOVERED";
})(Ao || (Ao = {}));
var rc = function() {
  function t(n) {
    this.category = n.cat, this.data = n.data;
  }
  return t.getDataAsUserBlockEvent = function(n, e) {
    var r = e.data, i = r.blocker, s = r.blockee;
    return { blocker: new pt(n, i), blockee: new pt(n, s) };
  }, t.getDataAsFriendDiscoveredEvent = function(n, e) {
    var r = e.data.friend_discoveries;
    return { friendDiscoveries: Array.isArray(r) ? r.map(function(i) {
      return new pt(n, i);
    }) : [] };
  }, t;
}(), __ = function(t) {
  function n(e, r) {
    var i = r.userId, s = t.call(this) || this;
    return s._iid = e, s.userId = i, s;
  }
  return S(n, t), n;
}(Vt), g_ = function(t) {
  function n() {
    return t.call(this) || this;
  }
  return S(n, t), n;
}(Vt), v_ = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "USEV", i) || this;
    return s.event = new rc(i), s;
  }
  return S(n, t), n;
}(Lt), sf = function(t) {
  function n() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return S(n, t), n;
}(Vt), y_ = function(t) {
  this.key = t.key, this.url = t.url;
}, b_ = function(t) {
  this.id = t.id, this.name = t.name, this.url = t.url, this.emojis = t.emojis ? t.emojis.map(function(n) {
    return new y_(n);
  }) : [];
}, wC = function(t) {
  this.emojiHash = t.emoji_hash || "", this.emojiCategories = t.emoji_categories ? t.emoji_categories.map(function(n) {
    return new b_(n);
  }) : [];
}, SC = { profileImage: void 0, profileUrl: void 0, nickname: void 0 }, af = function(t) {
  return function(n, e) {
    return g(void 0, 0, void 0, function() {
      var r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            switch (n) {
              case 1:
              case 2:
              case 3:
              case 4:
                return [3, 1];
              case 5:
                return [3, 2];
              case 6:
                return [3, 4];
            }
            return [3, 11];
          case 1:
            return e(), [3, 12];
          case 2:
            return [4, t.reset()];
          case 3:
            return o.sent(), e(), [3, 12];
          case 4:
            return o.trys.push([4, 9, , 10]), r = /* @__PURE__ */ function(l) {
              return { v2: function() {
                return g(void 0, 0, void 0, function() {
                  return _(this, function(c) {
                    switch (c.label) {
                      case 0:
                        return [4, l.commitSchema([{ collectionName: c_, keyName: "url", index: [Al(nn.LATEST_LAST_MESSAGE), Al(nn.CHRONOLOGICAL), Al(nn.CHANNEL_NAME_ALPHABETICAL)] }, { collectionName: hd, keyName: "messageId", index: [di(An.CHANNEL_LATEST), di(An.NEWEST_CHILD_MESSAGE)] }, { collectionName: h_, keyName: "reqId", index: [di(An.CHANNEL_LATEST), di(An.NEWEST_CHILD_MESSAGE)] }, { collectionName: "Poll", keyName: "pollId" }])];
                      case 1:
                        return [2, c.sent()];
                    }
                  });
                });
              }, v3: function() {
                return g(void 0, 0, void 0, function() {
                  return _(this, function(c) {
                    switch (c.label) {
                      case 0:
                        return [4, l.commitSchema([{ collectionName: "FeedChannel", keyName: "url", index: [["-lastMessageUpdatedAt", "-createdAt", "syncIndex"]] }])];
                      case 1:
                        return [2, c.sent()];
                    }
                  });
                });
              }, v4: function() {
                return g(void 0, 0, void 0, function() {
                  return _(this, function(c) {
                    switch (c.label) {
                      case 0:
                        return [4, l.commitSchema([{ collectionName: u_, keyName: "notificationId", index: [["channelUrl", "-createdAt", "-notificationId"]] }])];
                      case 1:
                        return [2, c.sent()];
                    }
                  });
                });
              } };
            }(t), i = r.v2, s = r.v3, a = r.v4, [4, i()];
          case 5:
            return o.sent(), [4, s()];
          case 6:
            return o.sent(), [4, a()];
          case 7:
            return o.sent(), [4, t.collection(hd).removeIf({ where: { channelType: yt.OPEN } })];
          case 8:
          case 9:
            return o.sent(), [3, 10];
          case 10:
            return e(), [3, 12];
          case 11:
            e(), o.label = 12;
          case 12:
            return [2];
        }
      });
    });
  };
}, NC = function() {
  return typeof document < "u" ? document.visibilityState : "visible";
}, IC = function(t) {
  function n(e) {
    var r = e.getVisibilityState, i = r === void 0 ? NC : r, s = e.initialState, a = s === void 0 ? "visible" : s, o = e.isEnabled, l = o === void 0 || o, c = e.pauseCheckDelay, u = c === void 0 ? 3e4 : c, d = t.call(this) || this;
    return d._pauseCheckDelay = 3e4, d._currentState = "visible", d._getVisibilityState = i, d._pauseCheckDelay = u, d._currentState = a, d._isEnabled = l, d._boundToggleState = d._toggleState.bind(d), d;
  }
  return S(n, t), Object.defineProperty(n.prototype, "currentState", { get: function() {
    return this._currentState;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isAvailable", { get: function() {
    return typeof window < "u" && !!window.addEventListener && !!window.removeEventListener;
  }, enumerable: !1, configurable: !0 }), n.prototype._toggleState = function() {
    var e = this, r = this._getVisibilityState();
    r !== "hidden" ? this._currentState === "hidden" && (this._pauseDelayTimer && (clearTimeout(this._pauseDelayTimer), this._pauseDelayTimer = void 0), this.dispatch("resume")) : this._currentState !== "hidden" && (this._pauseDelayTimer = setTimeout(function() {
      e._pauseDelayTimer = void 0, e.dispatch("pause");
    }, this._pauseCheckDelay)), this._currentState = r;
  }, n.prototype.start = function() {
    this._isEnabled && this.isAvailable && (this._boundToggleState = this._toggleState.bind(this), window.addEventListener("visibilitychange", this._boundToggleState, { capture: !0 }));
  }, n.prototype.stop = function() {
    this._isEnabled && this.isAvailable && this._boundToggleState && window.removeEventListener("visibilitychange", this._boundToggleState, { capture: !0 });
  }, n;
}(Qs), AC = function() {
  function t(n) {
    var e = n.logger, r = n.connectionDelegate, i = r === void 0 ? null : r, s = this;
    this._onlineWorker = function() {
      var a;
      return (a = s.connectionDelegate) === null || a === void 0 ? void 0 : a.reconnect();
    }, this._offlineWorker = function() {
      var a;
      return (a = s.connectionDelegate) === null || a === void 0 ? void 0 : a.disconnect();
    }, this.unsubscribes = [], this._onlineListener = function(a) {
      if (s.isAvailableOnWeb)
        return window.addEventListener("online", a), function() {
          return window.removeEventListener("online", a, !1);
        };
    }, this._offlineListener = function(a) {
      if (s.isAvailableOnWeb)
        return window.addEventListener("offline", a), function() {
          return window.removeEventListener("offline", a, !1);
        };
    }, this.logger = e, i && (this.connectionDelegate = i);
  }
  return Object.defineProperty(t.prototype, "isAvailableOnWeb", { get: function() {
    return typeof window < "u" && !!window.addEventListener && "ononline" in window && "onoffline" in window && typeof navigator < "u" && navigator.onLine !== void 0;
  }, enumerable: !1, configurable: !0 }), t.prototype.setOnlineListener = function(n) {
    n && typeof n == "function" && (this._onlineListener = n);
  }, t.prototype.setOfflineListener = function(n) {
    n && typeof n == "function" && (this._offlineListener = n);
  }, t.prototype.start = function() {
    this.unsubscribes = [this._onlineListener(this._onlineWorker), this._offlineListener(this._offlineWorker)];
  }, t.prototype.stop = function() {
    var n = this;
    this.unsubscribes.forEach(function(e) {
      try {
        e == null || e();
      } catch (r) {
        n.logger.warn(r.message);
      }
    }), this.unsubscribes = [];
  }, t.prototype.isOnline = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        return this.isAvailableOnWeb ? [2, navigator.onLine] : [2, new Promise(function(e) {
          fetch("https://www.google.com", { method: Y.GET, mode: "no-cors" }).then(function() {
            return e(!0);
          }).catch(function() {
            return e(!1);
          });
        })];
      });
    });
  }, t;
}(), of = function(t) {
  function n(e) {
    var r = e.userId, i = e.nickname, s = e.profileUrl, a = e.profileImage, o = e.preferredLanguages, l = t.call(this) || this;
    return l.method = Y.PUT, l.path = "".concat(vt, "/").concat(encodeURIComponent(r)), l.params = fe(Ae({ nickname: i, profile_url: s, profile_file: a, preferred_languages: o })), l;
  }
  return S(n, t), n;
}($), lf = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.user = new pt(e, A({}, r)), i;
  }
  return S(n, t), n;
}(ne), MC = function(t) {
  function n(e) {
    var r = e.userId, i = e.token, s = e.deviceOS, a = e.deviceManufacturer, o = e.systemPushEnabled, l = t.call(this) || this;
    return l.method = Y.POST, l.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push/apns"), l.params = fe({ apns_device_token: i, always_push: !0, device_os: s, device_manufacturer: a, system_push_enabled: o }), l;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    var r = t.call(this, n, e) || this;
    return r.token = e.token, r.type = e.type ? yn[e.type.toLowerCase()] : yn.UNKNOWN, r.user = new pt(n, e.user), r;
  }, t);
})(ne);
var xC = function(t) {
  function n(e) {
    var r = e.userId, i = e.token, s = e.deviceOS, a = e.deviceManufacturer, o = e.systemPushEnabled, l = t.call(this) || this;
    return l.method = Y.POST, l.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push/gcm"), l.params = fe({ gcm_reg_token: i, always_push: !0, device_os: s, device_manufacturer: a, system_push_enabled: o }), l;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    var r = t.call(this, n, e) || this;
    return r.token = e.token, r.type = e.type ? yn[e.type.toLowerCase()] : yn.UNKNOWN, r.user = new pt(n, e.user), r;
  }, t);
})(ne);
var kC = function(t) {
  function n(e) {
    var r = e.userId, i = e.token, s = t.call(this) || this;
    return s.method = Y.DELETE, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push/apns/").concat(encodeURIComponent(i)), s;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    var r = t.call(this, n, e) || this;
    return r.token = e.token, r.user = new pt(n, e.user), r.lastDeletedAt = e.device_token_last_deleted_at, r;
  }, t);
})(ne);
var OC = function(t) {
  function n(e) {
    var r = e.userId, i = e.token, s = t.call(this) || this;
    return s.method = Y.DELETE, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push/gcm/").concat(encodeURIComponent(i)), s;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    var r = t.call(this, n, e) || this;
    return r.token = e.token, r.user = new pt(n, e.user), r.lastDeletedAt = e.device_token_last_deleted_at, r;
  }, t);
})(ne);
var RC = function(t) {
  function n(e) {
    var r = e.userId, i = t.call(this) || this;
    return i.method = Y.DELETE, i.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push/apns"), i;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    var r = t.call(this, n, e) || this;
    return r.type = e.type ? yn[e.type.toLowerCase()] : yn.UNKNOWN, r.user = new pt(n, e.user), r.lastDeletedAt = e.device_token_last_deleted_at, r;
  }, t);
})(ne);
var DC = function(t) {
  function n(e) {
    var r = e.userId, i = t.call(this) || this;
    return i.method = Y.DELETE, i.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push/gcm"), i;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    var r = t.call(this, n, e) || this;
    return r.type = e.type ? yn[e.type.toLowerCase()] : yn.UNKNOWN, r.user = new pt(n, e.user), r.lastDeletedAt = e.device_token_last_deleted_at, r;
  }, t);
})(ne);
var LC = function(t) {
  function n(e) {
    var r = e.userId, i = e.type, s = e.token, a = e.ts, o = t.call(this) || this;
    return o.method = Y.GET, o.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push/").concat(encodeURIComponent(i), "/device_tokens"), o.params = { created_ts: a, token: s }, o;
  }
  return S(n, t), n;
}($), UC = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.pushTokens = { type: r.type ? yn[r.type.toLowerCase()] : yn.UNKNOWN, deviceTokens: r.device_tokens, hasMore: r.has_more, token: r.token }, i;
  }
  return S(n, t), n;
}(ne), PC = function(t) {
  function n(e) {
    var r = e.userId, i = t.call(this) || this;
    return i.method = Y.GET, i.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/channel_invitation_preference"), i;
  }
  return S(n, t), n;
}($), FC = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.autoAccept = r.auto_accept, i;
  }
  return S(n, t), n;
}(ne), jC = function(t) {
  function n(e) {
    var r = e.userId, i = e.willAutoAccept, s = t.call(this) || this;
    return s.method = Y.PUT, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/channel_invitation_preference"), s.params = { auto_accept: i }, s;
  }
  return S(n, t), n;
}($), HC = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.autoAccept = r.auto_accept, i;
  }
  return S(n, t), n;
}(ne), BC = function(t) {
  function n(e) {
    var r = e.userId, i = t.call(this) || this;
    return i.method = Y.GET, i.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push_preference"), i;
  }
  return S(n, t), n;
}($), zC = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.preference = { doNotDisturbOn: r.do_not_disturb, startHour: r.start_hour, startMin: r.start_min, endHour: r.end_hour, endMin: r.end_min, timezone: r.timezone }, i;
  }
  return S(n, t), n;
}(ne), VC = function(t) {
  function n(e) {
    var r = e.userId, i = e.doNotDisturbOn, s = e.startHour, a = e.startMin, o = e.endHour, l = e.endMin, c = e.timezone, u = t.call(this) || this;
    return u.method = Y.PUT, u.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push_preference"), u.params = { do_not_disturb: i, start_hour: s, start_min: a, end_hour: o, end_min: l, timezone: c }, u;
  }
  return S(n, t), n;
}($), GC = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.preference = { doNotDisturbOn: r.do_not_disturb, startHour: r.start_hour, startMin: r.start_min, endHour: r.end_hour, endMin: r.end_min, timezone: r.timezone }, i;
  }
  return S(n, t), n;
}(ne), qC = function(t) {
  function n(e) {
    var r = e.userId, i = t.call(this) || this;
    return i.method = Y.GET, i.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push_preference"), i;
  }
  return S(n, t), n;
}($), KC = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.snoozePeriod = { isSnoozeOn: r.snooze_enabled }, typeof r.snooze_start_ts == "number" && (i.snoozePeriod.startTs = r.snooze_start_ts), typeof r.snooze_end_ts == "number" && (i.snoozePeriod.endTs = r.snooze_end_ts), i;
  }
  return S(n, t), n;
}(ne), WC = function(t) {
  function n(e) {
    var r = e.userId, i = e.snoozeOn, s = e.startTs, a = e.endTs, o = t.call(this) || this;
    return o.method = Y.PUT, o.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push_preference"), o.params = { snooze_enabled: i, snooze_start_ts: s, snooze_end_ts: a }, o;
  }
  return S(n, t), n;
}($), QC = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.snoozePeriod = { isSnoozeOn: r.snooze_enabled }, typeof r.snooze_start_ts == "number" && (i.snoozePeriod.startTs = r.snooze_start_ts), typeof r.snooze_end_ts == "number" && (i.snoozePeriod.endTs = r.snooze_end_ts), i;
  }
  return S(n, t), n;
}(ne), YC = function(t) {
  function n(e) {
    var r = e.userId, i = e.blockedUserId, s = t.call(this) || this;
    return s.method = Y.POST, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/block"), s.params = { target_id: i }, s;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    var r = t.call(this, n, e) || this;
    return r.user = new pt(n, e), r;
  }, t);
})(ne);
var $C = function(t) {
  function n(e) {
    var r = e.userId, i = e.unblockedUserId, s = t.call(this) || this;
    return s.method = Y.DELETE, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/block/").concat(encodeURIComponent(i)), s;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var ZC = function(t) {
  function n(e) {
    var r = e.userId, i = t.call(this) || this;
    return i.method = Y.GET, i.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push_preference"), i;
  }
  return S(n, t), n;
}($), XC = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.pushTriggerOption = r.push_trigger_option, i;
  }
  return S(n, t), n;
}(ne), JC = function(t) {
  function n(e) {
    var r = e.userId, i = e.pushTriggerOption, s = t.call(this) || this;
    return s.method = Y.PUT, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push_preference"), s.params = { push_trigger_option: i }, s;
  }
  return S(n, t), n;
}($), e2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.pushTriggerOption = r.push_trigger_option, i;
  }
  return S(n, t), n;
}(ne), t2 = function(t) {
  function n(e) {
    var r = e.userId, i = t.call(this) || this;
    return i.method = Y.GET, i.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push/template"), i;
  }
  return S(n, t), n;
}($), n2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.name = r.name, i;
  }
  return S(n, t), n;
}(ne), r2 = function(t) {
  function n(e) {
    var r = e.userId, i = e.templateName, s = t.call(this) || this;
    return s.method = Y.PUT, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push/template"), s.params = { name: i }, s;
  }
  return S(n, t), n;
}($), i2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.name = r.name, i;
  }
  return S(n, t), n;
}(ne), s2 = function(t) {
  function n(e) {
    var r = e.userId, i = e.token, s = t.call(this) || this;
    return s.method = Y.GET, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/friends/changelogs"), s.params = { token: i }, s;
  }
  return S(n, t), n;
}($), a2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.changelogs = { addedUsers: r.added.map(function(s) {
      return new pt(e, s);
    }), updatedUsers: r.updated.map(function(s) {
      return new pt(e, s);
    }), deletedUserIds: r.deleted, hasMore: r.has_more, token: r.next }, i;
  }
  return S(n, t), n;
}(ne), o2 = function(t) {
  function n(e) {
    var r = e.userId, i = e.discoveries, s = t.call(this) || this;
    return s.method = Y.PUT, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/friend_discoveries"), s.params = { friend_discoveries: i.map(function(a) {
      return { friend_discovery_key: a.friendDiscoveryKey, friend_name: a.friendName };
    }) }, s;
  }
  return S(n, t), n;
}($), l2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.friendDiscoveryRequestId = r.friend_discovery_request_id, i;
  }
  return S(n, t), n;
}(ne), c2 = function(t) {
  function n(e) {
    var r = e.userId, i = e.discoveryKeys, s = t.call(this) || this;
    return s.method = Y.DELETE, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/friend_discoveries"), s.params = { friend_discovery_keys: i }, s;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var u2 = function(t) {
  function n(e) {
    var r = e.userId, i = e.userIds, s = t.call(this) || this;
    return s.method = Y.POST, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/friends"), s.params = { user_ids: i }, s;
  }
  return S(n, t), n;
}($), d2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.users = r.users.map(function(s) {
      return new pt(e, s);
    }), i;
  }
  return S(n, t), n;
}(ne), h2 = function(t) {
  function n(e) {
    var r = e.userId, i = e.userIds, s = t.call(this) || this;
    return s.method = Y.DELETE, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/friends"), s.params = { user_ids: i }, s;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var p2 = function(t) {
  function n(e) {
    var r = e.userId, i = t.call(this) || this;
    return i.method = Y.GET, i.path = "".concat(vt, "/").concat(r, "/allow_friend_discovery"), i.params = {}, i;
  }
  return S(n, t), n;
}($), f2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.allowFriendDiscovery = r.allow_friend_discovery, i;
  }
  return S(n, t), n;
}(ne), m2 = function(t) {
  function n(e) {
    var r = e.userId, i = e.allowFriendDiscovery, s = t.call(this) || this;
    return s.method = Y.PUT, s.path = "".concat(vt, "/").concat(r, "/allow_friend_discovery"), s.params = { allow_friend_discovery: i }, s;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var ic, _2 = function(t) {
  function n() {
    var e = t.call(this) || this;
    return e.method = Y.GET, e.path = tm, e;
  }
  return S(n, t), n;
}($), g2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.emojiContainer = new wC(r), i;
  }
  return S(n, t), n;
}(ne), v2 = function(t) {
  function n(e) {
    var r = e.categoryId, i = t.call(this) || this;
    return i.method = Y.GET, i.path = "".concat(tm, "/").concat(r), i;
  }
  return S(n, t), n;
}($), y2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.emojiCategory = new b_(r), i;
  }
  return S(n, t), n;
}(ne), b2 = function(t) {
  function n(e) {
    var r = e.key, i = t.call(this) || this;
    return i.method = Y.GET, i.path = "".concat(sy, "/").concat(r), i;
  }
  return S(n, t), n;
}($), E2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.emoji = new y_(r), i;
  }
  return S(n, t), n;
}(ne), C2 = function(t) {
  function n() {
    var e = t.call(this) || this;
    return e.method = Y.GET, e.path = "".concat(ay), e;
  }
  return S(n, t), n;
}($), T2 = function(t) {
  function n(e, r) {
    var i, s = this, a = r ?? {};
    return (s = t.call(this, e, r) || this).uikitConfiguration = { string: JSON.stringify(a), json: a }, s.updatedAt = (i = r == null ? void 0 : r.updated_at) !== null && i !== void 0 ? i : 0, s;
  }
  return S(n, t), n;
}(ne);
(function(t) {
  t.DELIVERED = "DELIVERED", t.CLICKED = "CLICKED";
})(ic || (ic = {}));
var ka, cf = function(t) {
  function n(e) {
    var r = e.deviceToken, i = e.pushTrackingId, s = e.messageId, a = e.allowedPushNotification, o = e.channelKey, l = e.templateKey, c = e.eventType, u = e.notificationEventDeadline, d = t.call(this) || this;
    return d.method = Y.POST, d.path = cy, d.params = fe({ device_token: r, push_tracking_id: i, message_id: s, allowed_push_notification: a, channel_key: o, template_key: l, event_type: c, notification_event_deadline: u }), d;
  }
  return S(n, t), n;
}($), w2 = function() {
  function t(n, e, r) {
    var i = this;
    this._storeInitialized = !1, this._iid = n, this.options = e;
    var s = k.of(n), a = s.sdkState, o = s.cacheContext, l = s.dispatcher, c = s.sessionManager, u = s.requestQueue, d = s.logger, h = s.userEventHandlers, p = s.appStateToggleEnabled;
    this._onlineDetector = new AC({ logger: d, connectionDelegate: { reconnect: function() {
      return g(i, 0, void 0, function() {
        var m, v, E, y, b, T;
        return _(this, function(w) {
          switch (w.label) {
            case 0:
              if (m = k.of(n), v = m.sdkState, E = m.connectionManager, (y = m.sessionManager).session.hasSession)
                return [3, 5];
              w.label = 1;
            case 1:
              return w.trys.push([1, 3, , 4]), [4, E.connect(y.session.authToken)];
            case 2:
              return w.sent(), [3, 4];
            case 3:
              if (b = w.sent(), rr(b))
                throw b;
              return d.debug("connect failed by reconnect event = ", b), [3, 4];
            case 4:
              return [3, 9];
            case 5:
              if (v.appState !== "foreground")
                return [3, 9];
              w.label = 6;
            case 6:
              return w.trys.push([6, 8, , 9]), [4, E.resetAndReconnect()];
            case 7:
              return w.sent(), [3, 9];
            case 8:
              if (T = w.sent(), rr(T))
                throw T;
              return d.debug("resetAndReconnect failed by reconnect event = ", T), [3, 9];
            case 9:
              return l.dispatch(new sf()), [2];
          }
        });
      });
    }, disconnect: function() {
      tn(function() {
        return g(i, 0, void 0, function() {
          return _(this, function(m) {
            switch (m.label) {
              case 0:
                return [4, k.of(n).connectionManager.disconnect()];
              case 1:
                return m.sent(), [2];
            }
          });
        });
      });
    } } });
    var f = new Ka(n, { localCacheEnabled: o.localCacheEnabled, enableAutoResend: o.localCacheConfig.enableAutoResend, dispatcher: l, sdkState: a, logger: d });
    r.forEach(function(m) {
      m.init(n, { sdkState: a, cacheContext: o, dispatcher: l, sessionManager: c, requestQueue: u, logger: d, onlineDetector: i._onlineDetector }), i[m.name] = m;
    }), this._appStateChangeDetector = new IC({ isEnabled: p }), this._appStateChangeDetector.on("resume", function() {
      d.debug("the page resumes from freeze"), i.setForegroundState();
    }).on("pause", function() {
      d.debug("the page freezes"), i.setBackgroundState();
    }), l.on(function(m) {
      var v;
      if (m instanceof Ar)
        m.stateType === bt.CONNECTED && f.processNonAutoResendRegisteredPendingMessages();
      else if (m instanceof Lt) {
        if (m.code === "USEV") {
          var E = m.as(v_).event;
          if (E.category === Ao.FRIEND_DISCOVERED) {
            var y = rc.getDataAsFriendDiscoveredEvent(n, E).friendDiscoveries;
            Ue(function() {
              return g(i, 0, void 0, function() {
                return _(this, function(N) {
                  return [2, h.forEach(function(M) {
                    M.onFriendsDiscovered && M.onFriendsDiscovered(y);
                  })];
                });
              });
            });
          }
        }
      } else if (m instanceof Sm) {
        var b = k.of(i._iid).subscribedUnreadMessageCount, T = !1, w = m.ts;
        typeof w == "number" && w > b.ts && (b.all !== m.all && (T = !0), b.all = m.all >= 0 ? m.all : 0, m.customTypes && Object.keys(m.customTypes).forEach(function(N) {
          b.customTypes[N] !== m.customTypes[N] && (T = !0), b.customTypes[N] = m.customTypes[N];
        }), T = T && b.ts > 0, b.ts = w), T && Ue(function() {
          return g(i, 0, void 0, function() {
            return _(this, function(N) {
              return [2, h.forEach(function(M) {
                M.onTotalUnreadMessageCountChanged && M.onTotalUnreadMessageCountChanged({ groupChannelCount: b.all, feedChannelCount: b.feed, customTypeUnreadCount: b.customTypes }), M.onTotalUnreadMessageCountUpdated && M.onTotalUnreadMessageCountUpdated(b.all, b.customTypes);
              })];
            });
          });
        });
      } else
        m instanceof Am ? (o.preference.set(i._getUserProfileCacheKey(a.userId), rd.payloadify(m.userProfile)), !((v = m.userProfile.appInfo.notificationInfo) === null || v === void 0) && v.isEnabled && o.preference.set(Gd(i.appId), { value: !0 })) : m instanceof fa && m.error && m.error.isSessionInvalidatedError && (d.debug("session revoked."), i._internalDisconnect(m.error));
    });
  }
  return t.init = function(n) {
    var e = n.appId, r = n.appVersion, i = n.modules, s = i === void 0 ? [] : i, a = n.options, o = a === void 0 ? new X0() : a, l = n.debugMode, c = l !== void 0 && l, u = n.customApiHost, d = n.customWebSocketHost, h = n.newInstance, p = h !== void 0 && h, f = n.logLevel, m = n.localCacheEnabled, v = m !== void 0 && m, E = n.localCacheConfig, y = E === void 0 ? new em() : E, b = n.localCacheEncryption, T = n.useAsyncStorageStore, w = T === void 0 ? null : T, N = n.useMMKVStorageStore, M = N === void 0 ? null : N, I = n.appStateToggleEnabled, x = I === void 0 || I;
    if (!ka || p) {
      var R = "su-".concat(Pi()), L = b ?? { encrypt: function(X) {
        return X;
      }, decrypt: function(X) {
        return X;
      } }, j = new iC();
      j.level = f ?? Mi.WARN;
      var P = new As({ encryption: L });
      c || (Xu() ? M ? P = new nC({ MMKV: M, encryption: L }) : w && (P = new tC({ AsyncStorage: w, encryption: L }), j.warn("AsyncStorage store is deprecated due to the small size limit. Please use MMKVStorage store instead.")) : P = new eC({ encryption: L })), new k(R, { appId: e, appVersion: r, options: o, apiHost: u ?? "https://api-".concat(e, ".sendbird.com"), websocketHost: d ?? "wss://ws-".concat(e, ".sendbird.com"), store: P, encryption: L, logger: j, localCacheEnabled: v, localCacheConfig: y, debugMode: c, appStateToggleEnabled: x });
      var q = [new EC(), new TC()], G = new t(R, o, Re(Re([], we(s), !1), we(q), !1));
      return ka || (ka = G), G;
    }
    return ka;
  }, Object.defineProperty(t, "instance", { get: function() {
    return ka;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t, "version", { get: function() {
    return $0;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "appId", { get: function() {
    return k.of(this._iid).sdkState.appId;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "appInfo", { get: function() {
    var n = k.of(this._iid).appInfo;
    return n ?? null;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "appVersion", { get: function() {
    var n;
    return (n = k.of(this._iid).sdkState.appVersion) !== null && n !== void 0 ? n : "";
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "debugMode", { get: function() {
    return !!k.of(this._iid).debugMode;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "logLevel", { get: function() {
    return k.of(this._iid).logger.level;
  }, set: function(n) {
    k.of(this._iid).logger.level = n;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "isCacheEnabled", { get: function() {
    return k.of(this._iid).cacheContext.localCacheEnabled;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "localCacheConfig", { get: function() {
    var n = k.of(this._iid).cacheContext;
    return n.localCacheEnabled ? n.localCacheConfig : null;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "ekey", { get: function() {
    return k.of(this._iid).sessionManager.ekey;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "currentUser", { get: function() {
    var n;
    return (n = k.of(this._iid).sessionManager.currentUser) !== null && n !== void 0 ? n : null;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "connectionState", { get: function() {
    var n = k.of(this._iid).connectionManager;
    return n.isConnected ? li.OPEN : n.isConnecting ? li.CONNECTING : li.CLOSED;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "lastConnectedAt", { get: function() {
    var n = k.of(this._iid), e = n.connectedAt;
    return n.connectionManager.isConnected ? e : 0;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "fcmPushToken", { get: function() {
    var n;
    return (n = this._fcmPushToken) !== null && n !== void 0 ? n : null;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "apnsPushToken", { get: function() {
    var n;
    return (n = this._apnsPushToken) !== null && n !== void 0 ? n : null;
  }, enumerable: !1, configurable: !0 }), t.prototype._getNestDBVersion = function() {
    return 7;
  }, t.prototype._getPreferenceCacheKey = function(n) {
    return "sendbird@".concat(this.appId, "/").concat(n, ".pref");
  }, t.prototype._getUserProfileCacheKey = function(n) {
    return "sendbird@".concat(this.appId, "/").concat(n, ".profile");
  }, t.prototype._internalDisconnect = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return e = k.of(this._iid), r = e.connectionManager, i = e.sdkState, s = e.requestQueue, this._appStateChangeDetector.stop(), this._onlineDetector.stop(), s.cancelAll(), [4, r.logout(n)];
          case 1:
            return a.sent(), [4, this.clearCachedData()];
          case 2:
            return a.sent(), i.appState = "foreground", [2];
        }
      });
    });
  }, t.prototype.getMemoryStoreForDebugging = function() {
    var n = k.of(this._iid), e = n.debugMode, r = n.cacheContext;
    if (e)
      return r.store instanceof As ? r.store : null;
    throw D.debugModeRequired;
  }, t.prototype.addExtension = function(n, e) {
    var r = k.of(this._iid).sdkState;
    ["sb_uikit", "sb_syncmanager", "device-os-platform"].indexOf(n) > -1 && r.extensions && (r.extensions[n] = e);
  }, t.prototype.addSendbirdExtensions = function(n, e, r) {
    var i, s, a = k.of(this._iid), o = a.logger, l = a.sdkState, c = new RegExp("^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)(?:-((?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\\+([0-9a-zA-Z-]+(?:\\.[0-9a-zA-Z-]+)*))?$");
    if (n.length === 0)
      return o.debug("sb.addSendbirdExtensions() has failed because the given sendbirdExtensions is empty."), !1;
    if (n.find(function(m) {
      return !c.test(m.version);
    }))
      return o.debug("sb.addSendbirdExtensions() has failed because the given version did not satisfy the SemVer specification."), !1;
    if (r)
      try {
        for (var u = de(Object.entries(r)), d = u.next(); !d.done; d = u.next()) {
          var h = we(d.value, 2), p = h[0], f = h[1];
          if (/&|=/.test(p) || /&|=/.test(f))
            return o.debug("sb.addSendbirdExtensions() has failed because the given customData includes at least one invalid character: = or &."), !1;
        }
      } catch (m) {
        i = { error: m };
      } finally {
        try {
          d && !d.done && (s = u.return) && s.call(u);
        } finally {
          if (i)
            throw i.error;
        }
      }
    return l.sendbirdRuntimeEnvironment = { sendbirdExtensions: n, deviceOS: e, customData: r }, !0;
  }, t.prototype.setOnlineListener = function(n) {
    this._onlineDetector.setOnlineListener(n);
  }, t.prototype.setOfflineListener = function(n) {
    this._onlineDetector.setOfflineListener(n);
  }, t.prototype._safeInitializeStore = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            e = k.of(this._iid).cacheContext, r.label = 1;
          case 1:
            return r.trys.push([1, 3, , 5]), [4, e.store.init(n)];
          case 2:
            return r.sent(), this._storeInitialized = !0, [3, 5];
          case 3:
            return r.sent(), e.replaceStore(new As()), [4, this._safeInitializeStore(n)];
          case 4:
            return r.sent(), [3, 5];
          case 5:
            return [2];
        }
      });
    });
  }, t.prototype.setLocaleForChatbot = function(n) {
    var e = k.of(this._iid).sdkState, r = function(i) {
      return i.replace(/[^a-zA-Z-_.]/g, "");
    }(n.trim());
    r && (e.localeForChatbot = r);
  }, t.prototype.initializeCache = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c, u;
      return _(this, function(d) {
        switch (d.label) {
          case 0:
            if (e = k.of(this._iid), r = e.sdkState, i = e.cacheContext, s = e.dispatcher, a = e.logger, r.userId && r.userId === n)
              return [3, 13];
            o = "sendbird@".concat(r.appId, "/").concat(n, ".db"), d.label = 1;
          case 1:
            return d.trys.push([1, 9, 11, 13]), i.localCacheEnabled ? i.nestdb && i.nestdb.state !== si.CLOSED && i.nestdb.name === o ? [3, 3] : (l = "sendbird@".concat(r.appId, "/").concat(n, ".db"), (c = i.nestdb = new rC({ name: l, version: this._getNestDBVersion(), store: i.store, config: new Po({ dbname: l, itemSizeLimit: 61440 }) })).on("upgrade", af(c)), c.on("storeReplaced", function(h) {
              i.replaceStore(h), i.localCacheEnabled = !1, c.on("upgrade", af(c));
            }), [4, c.open()]) : [3, 6];
          case 2:
            return d.sent(), this._storeInitialized = !0, s.dispatch(new __(this._iid, { userId: n })), [3, 5];
          case 3:
            return [4, this._safeInitializeStore(o)];
          case 4:
            d.sent(), d.label = 5;
          case 5:
            return r.userId = n, [3, 8];
          case 6:
            return [4, this._safeInitializeStore(o)];
          case 7:
            d.sent(), r.userId = n, d.label = 8;
          case 8:
            return [3, 13];
          case 9:
            return u = d.sent(), a.warn("Nest DB Open Failed. ", u), i.store instanceof As || (i.replaceStore(new As()), i.localCacheEnabled = !1), [4, this._safeInitializeStore(o)];
          case 10:
            throw d.sent(), r.userId = n, D.databaseError;
          case 11:
            return [4, this._setupPreference(n)];
          case 12:
            return d.sent(), [7];
          case 13:
            return [2];
        }
      });
    });
  }, t.prototype.getCacheDataSize = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return (n = k.of(this._iid).cacheContext).localCacheEnabled && n.nestdb ? [4, n.nestdb.estimateUsage()] : [3, 2];
          case 1:
            return [2, e.sent()];
          case 2:
            return [2, 0];
        }
      });
    });
  }, t.prototype.clearCachedData = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return (n = k.of(this._iid).cacheContext).localCacheEnabled && n.nestdb ? [4, n.nestdb.clear()] : [3, 2];
          case 1:
            e.sent(), e.label = 2;
          case 2:
            return this._storeInitialized ? [4, n.preference.clear()] : [3, 4];
          case 3:
            e.sent(), e.label = 4;
          case 4:
            return [2];
        }
      });
    });
  }, t.prototype.clearCachedMessages = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i = this;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return Z(tt("string", n)).throw(D.invalidParameters), e = oa.of(this._iid), r = Ks.of(this._iid), e && r ? [4, Promise.all(n.map(function(a) {
              return g(i, 0, void 0, function() {
                return _(this, function(o) {
                  switch (o.label) {
                    case 0:
                      return [4, e.removeMessagesOfChannel(a)];
                    case 1:
                      return o.sent(), [4, r.removeMessagesOfChannel(a)];
                    case 2:
                      return o.sent(), [2];
                  }
                });
              });
            }))] : [3, 2];
          case 1:
            s.sent(), s.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, t.prototype._setupPreference = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return e = k.of(this._iid), r = e.sdkState, i = e.cacheContext, s = e.statManager, [4, i.preference.init(this._getPreferenceCacheKey(n), this._getNestDBVersion())];
          case 1:
            return o.sent(), [4, i.preference.get(this._getUserProfileCacheKey(n))];
          case 2:
            return (a = o.sent()) && new rd(this._iid, a).apply(), [4, s.init("sendbird@".concat(r.appId, "/").concat(n, ".statlog"))];
          case 3:
            return o.sent(), [2];
        }
      });
    });
  }, t.prototype._ready = function(n, e, r) {
    return r === void 0 && (r = {}), g(this, 0, void 0, function() {
      var i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return Z(O("string", n) && O("string", e, !0)).throw(D.invalidParameters), i = k.of(this._iid), s = i.sdkState, a = i.cacheContext, o = i.connectionManager, l = r.errorForOtherUser, s.userId && s.userId !== n ? l ? [3, 2] : [4, o.logout()] : [3, 3];
          case 1:
            return u.sent(), [3, 3];
          case 2:
            throw l;
          case 3:
            return u.trys.push([3, 5, , 6]), [4, this.initializeCache(n)];
          case 4:
            return u.sent(), k.of(this._iid).dispatcher.dispatch(new g_()), [3, 6];
          case 5:
            return u.sent(), c = k.of(this._iid).logger, a.localCacheEnabled = !1, c.warn("Cache initialization failed - cache is not available."), [3, 6];
          case 6:
            return [2];
        }
      });
    });
  }, t.prototype.authenticateFeed = function(n, e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this.authenticate(n, e)];
          case 1:
            return [2, r.sent()];
        }
      });
    });
  }, t.prototype.authenticate = function(n, e) {
    var r;
    return g(this, 0, void 0, function() {
      var i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return i = k.of(this._iid), s = i.sessionManager, a = i.connectionManager, [4, this._ready(n, e, { errorForOtherUser: a.isConnected ? D.alreadyConnectedAsAnotherUser : void 0 })];
          case 1:
            return l.sent(), !((r = s.session.services) === null || r === void 0) && r.includes(Bl.CHAT) ? [3, 3] : (e || s.handler || (o = new tc(), this.setSessionHandler(o)), [4, s.authenticate(n, e)]);
          case 2:
            l.sent(), l.label = 3;
          case 3:
            return [2, this.currentUser];
        }
      });
    });
  }, t.prototype.connect = function(n, e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._ready(n, e)];
          case 1:
            r.sent(), r.label = 2;
          case 2:
            return r.trys.push([2, , 4, 5]), [4, k.of(this._iid).connectionManager.connect(e)];
          case 3:
            return r.sent(), [3, 5];
          case 4:
            return this._onlineDetector.start(), this._appStateChangeDetector.start(), [7];
          case 5:
            return [2, this.currentUser];
        }
      });
    });
  }, t.prototype.reconnect = function() {
    var n = k.of(this._iid), e = n.connectionManager, r = n.sdkState, i = n.sessionManager.session.hasSession;
    return i && (this._appStateChangeDetector.start(), this._onlineDetector.start(), e.resetAndReconnect().then(function() {
      r.appState = "foreground";
    }).catch(function() {
    })), i;
  }, t.prototype.disconnect = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, this._internalDisconnect()];
          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, t.prototype.disconnectWebSocket = function() {
    return g(this, 0, void 0, function() {
      var n, e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return n = k.of(this._iid), e = n.connectionManager, r = n.requestQueue, this._appStateChangeDetector.stop(), this._onlineDetector.stop(), r.cancelAll(), [4, e.disconnectWebSocket(!0)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, t.prototype.setBackgroundState = function() {
    var n = k.of(this._iid), e = n.connectionManager, r = n.sdkState, i = n.logger;
    r.appState === "foreground" && (r.appState = "background", i.debug("going background state"), e.background().catch(function(s) {
      i.debug("setBackgroundState error = ", s);
    }));
  }, t.prototype.setForegroundState = function() {
    var n = k.of(this._iid), e = n.connectionManager, r = n.sdkState, i = n.dispatcher, s = n.logger;
    r.appState === "background" && (r.appState = "foreground", s.debug("going foreground state"), e.resetAndReconnect().catch(function(a) {
      s.debug("setForgroundState error = ", a);
    }), i.dispatch(new sf()));
  }, t.prototype.setSessionHandler = function(n) {
    Z(n instanceof tc).throw(D.invalidParameters), k.of(this._iid).sessionManager.handler = n;
  }, t.prototype.addUserEventHandler = function(n, e) {
    Z(O("string", n) && e instanceof PE).throw(D.invalidParameters), k.of(this._iid).userEventHandlers.set(n, e);
  }, t.prototype.removeUserEventHandler = function(n) {
    k.of(this._iid).userEventHandlers.delete(n);
  }, t.prototype.removeAllUserEventHandler = function() {
    k.of(this._iid).userEventHandlers.clear();
  }, t.prototype.addConnectionHandler = function(n, e) {
    Z(O("string", n) && e instanceof d_).throw(D.invalidParameters), k.of(this._iid).connectionHandlers.set(n, e);
  }, t.prototype.removeConnectionHandler = function(n) {
    k.of(this._iid).connectionHandlers.delete(n);
  }, t.prototype.removeAllConnectionHandler = function() {
    k.of(this._iid).connectionHandlers.clear();
  }, t.prototype.createApplicationUserListQuery = function(n) {
    return n === void 0 && (n = {}), new HE(this._iid, n);
  }, t.prototype.createBlockedUserListQuery = function(n) {
    return n === void 0 && (n = {}), new VE(this._iid, n);
  }, t.prototype.createFriendListQuery = function(n) {
    return n === void 0 && (n = {}), new KE(this._iid, n);
  }, t.prototype.createMessageSearchQuery = function(n) {
    return new mC(this._iid, n);
  }, t.prototype.createPollListQuery = function(n) {
    return new qm(this._iid, A({}, n));
  }, t.prototype.createPollVoterListQuery = function(n) {
    return new Km(this._iid, A({}, n));
  }, t.prototype.buildUserFromSerializedData = function(n) {
    var e = js(n);
    return new pt(this._iid, pt.payloadify(e));
  }, t.prototype.updateCurrentUserInfo = function(n) {
    return n === void 0 && (n = {}), g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return e = A(A({}, SC), n), Z(function(u) {
              return qn(u.profileImage, !0) && O("string", u.profileUrl, !0) && O("string", u.nickname, !0);
            }(e)).throw(D.invalidParameters), this.currentUser ? (r = k.of(this._iid), i = r.sdkState, s = r.requestQueue, a = new of(A({ userId: i.userId }, e)), [4, s.send(a)]) : [3, 2];
          case 1:
            return o = c.sent(), l = o.as(lf).user, this.currentUser && (e.nickname && (this.currentUser.nickname = l.nickname), (e.profileUrl || e.profileImage) && (this.currentUser.plainProfileUrl = l.profileUrl)), [2, l];
          case 2:
            throw D.connectionRequired;
        }
      });
    });
  }, t.prototype.updateCurrentUserInfoWithPreferredLanguages = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return Z(tt("string", n)).throw(D.invalidParameters), this.currentUser ? (e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new of({ userId: r.userId, preferredLanguages: n }), [4, i.send(s)]) : [3, 2];
          case 1:
            return a = l.sent(), o = a.as(lf).user, this.currentUser && (this.currentUser.preferredLanguages = o.preferredLanguages), [2, o];
          case 2:
            throw D.connectionRequired;
        }
      });
    });
  }, t.prototype.registerFCMPushTokenForCurrentUser = function(n, e) {
    var r, i;
    return g(this, 0, void 0, function() {
      var s, a, o, l, c, u, d = this;
      return _(this, function(h) {
        switch (h.label) {
          case 0:
            if (Z(O("string", n) && O("string", e == null ? void 0 : e.deviceManufacturer, !0)).throw(D.invalidParameters), e != null && e.deviceOS && Z(Ze(Ji, e.deviceOS.platform, !0) && O("string", e.deviceOS.version, !0)).throw(D.invalidParameters), !this.currentUser)
              return [3, 6];
            s = { deviceOS: "".concat(((r = e == null ? void 0 : e.deviceOS) === null || r === void 0 ? void 0 : r.platform) || Ji.ANDROID, "-").concat(((i = e == null ? void 0 : e.deviceOS) === null || i === void 0 ? void 0 : i.version) || "unknown"), deviceManufacturer: e == null ? void 0 : e.deviceManufacturer, systemPushEnabled: e == null ? void 0 : e.systemPushEnabled }, h.label = 1;
          case 1:
            return h.trys.push([1, 4, , 5]), a = k.of(this._iid), o = a.sessionManager, l = a.sdkState, c = a.requestQueue, o.hasDeviceToken(yn.FCM, n) ? [2, Qn.SUCCESS] : (u = new xC({ userId: l.userId, token: n, deviceOS: s.deviceOS, deviceManufacturer: s.deviceManufacturer, systemPushEnabled: s.systemPushEnabled }), [4, c.send(u)]);
          case 2:
            return h.sent(), [4, tn(function() {
              return g(d, 0, void 0, function() {
                return _(this, function(p) {
                  switch (p.label) {
                    case 0:
                      return o.setDeviceToken(yn.FCM, n, s), [4, o.saveDeviceToken()];
                    case 1:
                      return p.sent(), [2];
                  }
                });
              });
            })];
          case 3:
            return h.sent(), this._fcmPushToken = "", [2, Qn.SUCCESS];
          case 4:
            return h.sent(), [2, Qn.ERROR];
          case 5:
            return [3, 7];
          case 6:
            return this._fcmPushToken = n, [2, Qn.PENDING];
          case 7:
            return [2];
        }
      });
    });
  }, t.prototype.unregisterFCMPushTokenForCurrentUser = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l = this;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            if (Z(O("string", n)).throw(D.invalidParameters), !this.currentUser)
              return [3, 6];
            c.label = 1;
          case 1:
            return c.trys.push([1, 4, , 5]), e = k.of(this._iid), r = e.sessionManager, i = e.sdkState, s = e.requestQueue, a = new OC({ userId: i.userId, token: n }), [4, s.send(a)];
          case 2:
            return o = c.sent().lastDeletedAt, [4, tn(function() {
              return g(l, 0, void 0, function() {
                return _(this, function(u) {
                  switch (u.label) {
                    case 0:
                      return r.unsetDeviceToken(yn.FCM, n), r.setDeviceTokenDeletedAt(o), [4, r.saveDeviceToken()];
                    case 1:
                      return u.sent(), [2];
                  }
                });
              });
            })];
          case 3:
            return c.sent(), this._fcmPushToken = "", [2, Qn.SUCCESS];
          case 4:
            return c.sent(), [2, Qn.ERROR];
          case 5:
            return [3, 7];
          case 6:
            return this._fcmPushToken = n, [2, Qn.PENDING];
          case 7:
            return [2];
        }
      });
    });
  }, t.prototype.unregisterFCMPushTokenAllForCurrentUser = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i, s, a, o = this;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this.currentUser ? (n = k.of(this._iid), e = n.sessionManager, r = n.sdkState, i = n.requestQueue, s = new DC({ userId: r.userId }), [4, i.send(s)]) : [3, 3];
          case 1:
            return a = l.sent().lastDeletedAt, [4, tn(function() {
              return g(o, 0, void 0, function() {
                return _(this, function(c) {
                  switch (c.label) {
                    case 0:
                      return e.unsetDeviceTokens(yn.FCM), e.setDeviceTokenDeletedAt(a), [4, e.saveDeviceToken()];
                    case 1:
                      return c.sent(), [2];
                  }
                });
              });
            })];
          case 2:
            l.sent(), l.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, t.prototype.registerAPNSPushTokenForCurrentUser = function(n, e) {
    var r, i;
    return g(this, 0, void 0, function() {
      var s, a, o, l, c, u, d = this;
      return _(this, function(h) {
        switch (h.label) {
          case 0:
            if (Z(O("string", n) && O("string", e == null ? void 0 : e.deviceManufacturer, !0)).throw(D.invalidParameters), e != null && e.deviceOS && Z(Ze(Ji, e.deviceOS.platform, !0) && O("string", e.deviceOS.version, !0)).throw(D.invalidParameters), !this.currentUser)
              return [3, 6];
            s = { deviceOS: "".concat(((r = e == null ? void 0 : e.deviceOS) === null || r === void 0 ? void 0 : r.platform) || Ji.IOS, "-").concat(((i = e == null ? void 0 : e.deviceOS) === null || i === void 0 ? void 0 : i.version) || "unknown"), deviceManufacturer: e == null ? void 0 : e.deviceManufacturer, systemPushEnabled: e == null ? void 0 : e.systemPushEnabled }, h.label = 1;
          case 1:
            return h.trys.push([1, 4, , 5]), a = k.of(this._iid), o = a.sessionManager, l = a.sdkState, c = a.requestQueue, o.hasDeviceToken(yn.APNS, n) ? [2, Qn.SUCCESS] : (u = new MC({ userId: l.userId, token: n, deviceOS: s.deviceOS, deviceManufacturer: s.deviceManufacturer, systemPushEnabled: s.systemPushEnabled }), [4, c.send(u)]);
          case 2:
            return h.sent(), [4, tn(function() {
              return g(d, 0, void 0, function() {
                return _(this, function(p) {
                  switch (p.label) {
                    case 0:
                      return o.setDeviceToken(yn.APNS, n, s), [4, o.saveDeviceToken()];
                    case 1:
                      return p.sent(), [2];
                  }
                });
              });
            })];
          case 3:
            return h.sent(), this._apnsPushToken = "", [2, Qn.SUCCESS];
          case 4:
            return h.sent(), [2, Qn.ERROR];
          case 5:
            return [3, 7];
          case 6:
            return this._apnsPushToken = n, [2, Qn.PENDING];
          case 7:
            return [2];
        }
      });
    });
  }, t.prototype.unregisterAPNSPushTokenForCurrentUser = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l = this;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            if (Z(O("string", n)).throw(D.invalidParameters), !this.currentUser)
              return [3, 6];
            c.label = 1;
          case 1:
            return c.trys.push([1, 4, , 5]), e = k.of(this._iid), r = e.sessionManager, i = e.sdkState, s = e.requestQueue, a = new kC({ userId: i.userId, token: n }), [4, s.send(a)];
          case 2:
            return o = c.sent().lastDeletedAt, [4, tn(function() {
              return g(l, 0, void 0, function() {
                return _(this, function(u) {
                  switch (u.label) {
                    case 0:
                      return r.unsetDeviceToken(yn.APNS, n), r.setDeviceTokenDeletedAt(o), [4, r.saveDeviceToken()];
                    case 1:
                      return u.sent(), [2];
                  }
                });
              });
            })];
          case 3:
            return c.sent(), this._apnsPushToken = "", [2, Qn.SUCCESS];
          case 4:
            return c.sent(), [2, Qn.ERROR];
          case 5:
            return [3, 7];
          case 6:
            return this._apnsPushToken = n, [2, Qn.PENDING];
          case 7:
            return [2];
        }
      });
    });
  }, t.prototype.unregisterAPNSPushTokenAllForCurrentUser = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i, s, a, o = this;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this.currentUser ? (n = k.of(this._iid), e = n.sessionManager, r = n.sdkState, i = n.requestQueue, s = new RC({ userId: r.userId }), [4, i.send(s)]) : [3, 3];
          case 1:
            return a = l.sent().lastDeletedAt, [4, tn(function() {
              return g(o, 0, void 0, function() {
                return _(this, function(c) {
                  switch (c.label) {
                    case 0:
                      return e.unsetDeviceTokens(yn.APNS), e.setDeviceTokenDeletedAt(a), [4, e.saveDeviceToken()];
                    case 1:
                      return c.sent(), [2];
                  }
                });
              });
            })];
          case 2:
            l.sent(), l.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, t.prototype.markPushNotificationAsDelivered = function(n, e) {
    var r;
    return e === void 0 && (e = !0), g(this, 0, void 0, function() {
      var i, s, a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N;
      return _(this, function(M) {
        switch (M.label) {
          case 0:
            if (i = k.of(this._iid), s = i.logger, a = i.sessionManager, o = i.requestQueue, l = i.pushNotificationAckManager, s.debug("markPushNotificationAsDelivered:", n), c = ic.DELIVERED, u = l.parseData(n), d = u.pushTrackingId, h = u.sessionTopics, p = u.sessionKey, f = u.messageId, m = u.channelKey, v = u.templateKey, E = u.notificationEventDeadline, !p || !h.includes(Yl.PUSH_ACKNOWLEDGEMENT))
              throw s.info("Can't use markPushNotificationAsDelivered() feature."), D.malformedDataError;
            if (l.isAcked(d, c))
              return s.info("already delivered push notification:", d), [2];
            y = !!m, b = e && y, T = (r = a.deviceTokens[0]) === null || r === void 0 ? void 0 : r.token, w = new cf({ deviceToken: T ?? "", pushTrackingId: d, eventType: c, messageId: f, channelKey: m, templateKey: v, notificationEventDeadline: E, allowedPushNotification: b }), p && (w.headers["Session-Key"] = p), M.label = 1;
          case 1:
            return M.trys.push([1, 3, , 4]), [4, o.send(w)];
          case 2:
            return M.sent(), l.markAsAcked(d, c), [3, 4];
          case 3:
            throw N = M.sent(), s.debug("failed to mark push notification as delivered. push tracking id: ".concat(d, ". error: ").concat(N)), N;
          case 4:
            return [2];
        }
      });
    });
  }, t.prototype.markPushNotificationAsClicked = function(n) {
    var e;
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u, d, h, p, f, m, v, E, y, b;
      return _(this, function(T) {
        switch (T.label) {
          case 0:
            if (r = k.of(this._iid), i = r.logger, s = r.sessionManager, a = r.requestQueue, o = r.pushNotificationAckManager, i.debug("markPushNotificationAsClicked:", n), l = ic.CLICKED, c = o.parseData(n), u = c.pushTrackingId, d = c.sessionTopics, h = c.sessionKey, p = c.messageId, f = c.channelKey, m = c.templateKey, v = c.notificationEventDeadline, !h || !d.includes(Yl.PUSH_ACKNOWLEDGEMENT))
              throw i.info("Can't use markPushNotificationAsDelivered() feature."), D.malformedDataError;
            if (o.isAcked(u, l))
              return i.info("already clicked push notification:", u), [2];
            E = (e = s.deviceTokens[0]) === null || e === void 0 ? void 0 : e.token, y = new cf({ deviceToken: E ?? "", pushTrackingId: u, eventType: l, messageId: p, channelKey: f, templateKey: m, notificationEventDeadline: v }), h && (y.headers["Session-Key"] = h), T.label = 1;
          case 1:
            return T.trys.push([1, 3, , 4]), [4, a.send(y)];
          case 2:
            return T.sent(), o.markAsAcked(u, l), [3, 4];
          case 3:
            throw b = T.sent(), i.debug("failed to mark push notification as clicked. push tracking id: ".concat(u, ". error: ").concat(b)), b;
          case 4:
            return [2];
        }
      });
    });
  }, t.prototype.getChannelInvitationPreference = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return n = k.of(this._iid), e = n.sdkState, r = n.requestQueue, i = new PC({ userId: e.userId }), [4, r.send(i)];
          case 1:
            return [2, { autoAccept: s.sent().as(FC).autoAccept }];
        }
      });
    });
  }, t.prototype.setChannelInvitationPreference = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(O("boolean", n)).throw(D.invalidParameters), e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new jC({ userId: r.userId, willAutoAccept: n }), [4, i.send(s)];
          case 1:
            return [2, { autoAccept: a.sent().as(HC).autoAccept }];
        }
      });
    });
  }, t.prototype.getDoNotDisturb = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return n = k.of(this._iid), e = n.sdkState, r = n.requestQueue, i = new BC({ userId: e.userId }), [4, r.send(i)];
          case 1:
            return [2, s.sent().as(zC).preference];
        }
      });
    });
  }, t.prototype.setDoNotDisturb = function(n, e, r, i, s, a) {
    return e === void 0 && (e = 0), r === void 0 && (r = 0), i === void 0 && (i = 0), s === void 0 && (s = 0), a === void 0 && (a = ""), g(this, 0, void 0, function() {
      var o, l, c, u;
      return _(this, function(d) {
        switch (d.label) {
          case 0:
            return Z(O("boolean", n) && O("number", e) && O("number", r) && O("number", i) && O("number", s) && O("string", a)).throw(D.invalidParameters), o = k.of(this._iid), l = o.sdkState, c = o.requestQueue, u = new VC({ userId: l.userId, doNotDisturbOn: n, startHour: e, startMin: r, endHour: i, endMin: s, timezone: a }), [4, c.send(u)];
          case 1:
            return [2, d.sent().as(GC).preference];
        }
      });
    });
  }, t.prototype.getSnoozePeriod = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return n = k.of(this._iid), e = n.sdkState, r = n.requestQueue, i = new qC({ userId: e.userId }), [4, r.send(i)];
          case 1:
            return [2, s.sent().as(KC).snoozePeriod];
        }
      });
    });
  }, t.prototype.setSnoozePeriod = function(n, e, r) {
    return e === void 0 && (e = 0), r === void 0 && (r = 0), g(this, 0, void 0, function() {
      var i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return Z(O("boolean", n) && O("number", e) && O("number", r)).throw(D.invalidParameters), i = k.of(this._iid), s = i.sdkState, a = i.requestQueue, o = new WC({ userId: s.userId, snoozeOn: n, startTs: e, endTs: r }), [4, a.send(o)];
          case 1:
            return [2, l.sent().as(QC).snoozePeriod];
        }
      });
    });
  }, t.prototype.getMyPushTokensByToken = function(n, e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u, d, h, p, f;
      return _(this, function(m) {
        switch (m.label) {
          case 0:
            return Z(O("string", n) && Ze(yn, e)).throw(D.invalidParameters), r = k.of(this._iid), i = r.sdkState, s = r.requestQueue, a = r.sessionManager, o = new LC({ userId: i.userId, type: e, token: n }), [4, s.send(o)];
          case 1:
            l = m.sent(), c = l.as(UC).pushTokens;
            try {
              for (u = de(c.deviceTokens), d = u.next(); !d.done; d = u.next())
                h = d.value, a.setDeviceToken(c.type, h);
            } catch (v) {
              p = { error: v };
            } finally {
              try {
                d && !d.done && (f = u.return) && f.call(u);
              } finally {
                if (p)
                  throw p.error;
              }
            }
            return [4, a.saveDeviceToken()];
          case 2:
            return m.sent(), [2, c];
        }
      });
    });
  }, t.prototype.getPushTriggerOption = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return n = k.of(this._iid), e = n.sdkState, r = n.requestQueue, i = new ZC({ userId: e.userId }), [4, r.send(i)];
          case 1:
            return [2, s.sent().as(XC).pushTriggerOption];
        }
      });
    });
  }, t.prototype.setPushTriggerOption = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(Ze(xs, n)).throw(D.invalidParameters), e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new JC({ userId: r.userId, pushTriggerOption: n }), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(e2).pushTriggerOption];
        }
      });
    });
  }, t.prototype.getPushTemplate = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return n = k.of(this._iid), e = n.sdkState, r = n.requestQueue, i = new t2({ userId: e.userId }), [4, r.send(i)];
          case 1:
            return [2, s.sent().as(n2).name];
        }
      });
    });
  }, t.prototype.setPushTemplate = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(Ze(Wu, n)).throw(D.invalidParameters), e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new r2({ userId: r.userId, templateName: n }), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(i2).name];
        }
      });
    });
  }, t.prototype.blockUser = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(n instanceof pt || O("string", n)).throw(D.invalidParameters), e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new YC({ userId: r.userId, blockedUserId: n instanceof pt ? n.userId : n }), [4, i.send(s)];
          case 1:
            return a.sent(), [2];
        }
      });
    });
  }, t.prototype.blockUserWithUserId = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        return [2, this.blockUser(n)];
      });
    });
  }, t.prototype.unblockUser = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(n instanceof pt || O("string", n)).throw(D.invalidParameters), e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new $C({ userId: r.userId, unblockedUserId: n instanceof pt ? n.userId : n }), [4, i.send(s)];
          case 1:
            return a.sent(), [2];
        }
      });
    });
  }, t.prototype.unblockUserWithUserId = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        return [2, this.unblockUser(n)];
      });
    });
  }, t.prototype.getFriendChangeLogsByToken = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(O("string", n)).throw(D.invalidParameters), e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new s2({ userId: r.userId, token: n }), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(a2).changelogs];
        }
      });
    });
  }, t.prototype.getAllowFriendDiscovery = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return n = k.of(this._iid), e = n.sdkState, r = n.requestQueue, i = new p2({ userId: e.userId }), [4, r.send(i)];
          case 1:
            return [2, s.sent().as(f2).allowFriendDiscovery];
        }
      });
    });
  }, t.prototype.setAllowFriendDiscovery = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(O("boolean", n)).throw(D.invalidParameters), e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new m2({ userId: r.userId, allowFriendDiscovery: n }), [4, i.send(s)];
          case 1:
            return a.sent(), [2, n];
        }
      });
    });
  }, t.prototype.uploadFriendDiscoveries = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new o2({ userId: r.userId, discoveries: n }), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(l2).friendDiscoveryRequestId];
        }
      });
    });
  }, t.prototype.deleteFriendDiscovery = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        return [2, this.deleteFriendDiscoveries([n])];
      });
    });
  }, t.prototype.deleteFriendDiscoveries = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(tt("string", n)).throw(D.invalidParameters), e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new c2({ userId: r.userId, discoveryKeys: n }), [4, i.send(s)];
          case 1:
            return a.sent(), [2];
        }
      });
    });
  }, t.prototype.addFriends = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(tt("string", n)).throw(D.invalidParameters), e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new u2({ userId: r.userId, userIds: n }), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(d2).users];
        }
      });
    });
  }, t.prototype.deleteFriend = function(n) {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        return [2, this.deleteFriends([n])];
      });
    });
  }, t.prototype.deleteFriends = function(n) {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return Z(tt("string", n)).throw(D.invalidParameters), e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new h2({ userId: r.userId, userIds: n }), [4, i.send(s)];
          case 1:
            return a.sent(), [2];
        }
      });
    });
  }, t.prototype.getAllEmoji = function() {
    return g(this, 0, void 0, function() {
      var n, e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return n = k.of(this._iid).requestQueue, e = new _2(), [4, n.send(e)];
          case 1:
            return [2, r.sent().as(g2).emojiContainer];
        }
      });
    });
  }, t.prototype.getEmojiCategory = function(n) {
    return g(this, 0, void 0, function() {
      var e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return e = k.of(this._iid).requestQueue, r = new v2({ categoryId: n }), [4, e.send(r)];
          case 1:
            return [2, i.sent().as(y2).emojiCategory];
        }
      });
    });
  }, t.prototype.getEmoji = function(n) {
    return g(this, 0, void 0, function() {
      var e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return e = k.of(this._iid).requestQueue, r = new b2({ key: n }), [4, e.send(r)];
          case 1:
            return [2, i.sent().as(E2).emoji];
        }
      });
    });
  }, t.prototype.getUIKitConfiguration = function() {
    return g(this, 0, void 0, function() {
      var n, e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return n = k.of(this._iid), Z(n.hasExtension("sb_uikit")).throw(D.notSupportedError), e = n.requestQueue, r = new C2(), [4, e.send(r)];
          case 1:
            return [2, i.sent().as(T2).uikitConfiguration];
        }
      });
    });
  }, t;
}();
const uf = "reactions", S2 = "message_search_v3", df = "enable_og_tag";
var on;
(function(t) {
  t[t.NONE = 0] = "NONE", t[t.CHANNEL_ENTER = 10102] = "CHANNEL_ENTER", t[t.CHANNEL_EXIT = 10103] = "CHANNEL_EXIT", t[t.USER_CHANNEL_MUTE = 10201] = "USER_CHANNEL_MUTE", t[t.USER_CHANNEL_UNMUTE = 10200] = "USER_CHANNEL_UNMUTE", t[t.USER_CHANNEL_BAN = 10601] = "USER_CHANNEL_BAN", t[t.USER_CHANNEL_UNBAN = 10600] = "USER_CHANNEL_UNBAN", t[t.CHANNEL_FREEZE = 10701] = "CHANNEL_FREEZE", t[t.CHANNEL_UNFREEZE = 10700] = "CHANNEL_UNFREEZE", t[t.TYPING_START = 10900] = "TYPING_START", t[t.TYPING_END = 10901] = "TYPING_END", t[t.CHANNEL_JOIN = 1e4] = "CHANNEL_JOIN", t[t.CHANNEL_LEAVE = 10001] = "CHANNEL_LEAVE", t[t.CHANNEL_OPERATOR_UPDATE = 10002] = "CHANNEL_OPERATOR_UPDATE", t[t.CHANNEL_INVITE = 10020] = "CHANNEL_INVITE", t[t.CHANNEL_ACCEPT_INVITE = 10021] = "CHANNEL_ACCEPT_INVITE", t[t.CHANNEL_DECLINE_INVITE = 10022] = "CHANNEL_DECLINE_INVITE", t[t.CHANNEL_PROP_CHANGED = 11e3] = "CHANNEL_PROP_CHANGED", t[t.CHANNEL_DELETED = 12e3] = "CHANNEL_DELETED", t[t.CHANNEL_META_DATA_CHANGED = 11100] = "CHANNEL_META_DATA_CHANGED", t[t.CHANNEL_META_COUNTERS_CHANGED = 11200] = "CHANNEL_META_COUNTERS_CHANGED", t[t.CHANNEL_HIDE = 13e3] = "CHANNEL_HIDE", t[t.CHANNEL_UNHIDE = 13001] = "CHANNEL_UNHIDE", t[t.PINNED_MESSAGE_CHANGED = 11300] = "PINNED_MESSAGE_CHANGED";
})(on || (on = {}));
var sn, N2 = function() {
  function t(n) {
    var e;
    this.channelUrl = n.channel_url, this.channelType = n.channel_type, this.category = n.cat, this.data = (e = n.data) !== null && e !== void 0 ? e : {}, this.ts = n.ts;
  }
  return Object.defineProperty(t.prototype, "isGroupChannelEvent", { get: function() {
    return this.channelType === yt.GROUP;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "isOpenChannelEvent", { get: function() {
    return this.channelType === yt.OPEN;
  }, enumerable: !1, configurable: !0 }), t;
}(), Ca = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "SYEV", i) || this;
    return s.event = new N2(i), s;
  }
  return S(n, t), n;
}(Lt), I2 = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, r, i) || this, a = i.data.operators, o = a === void 0 ? [] : a;
    return s.operators = o.map(function(l) {
      return new pt(s._iid, l);
    }), s;
  }
  return S(n, t), n;
}(Ca), A2 = function(t) {
  function n(e, r, i) {
    var s, a = this;
    return (a = t.call(this, e, "SYEV", i) || this).pinnedMessageIds = [], a.latestPinnedMessage = null, a.ts = 0, i.data && (a.pinnedMessageIds = (s = i.data.pinned_message_ids) !== null && s !== void 0 ? s : [], a.latestPinnedMessage = i.data.latest_pinned_message ? Kn(e, A({}, i.data.latest_pinned_message)) : null), a.ts = i.ts, a;
  }
  return S(n, t), n;
}(Lt), M2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e) || this;
    return i._logger = r.logger, i._sdkState = r.sdkState, i._sessionManager = r.sessionManager, i._requestQueue = r.requestQueue, i._dispatcher = r.dispatcher, i._cacheContext = r.cacheContext, i._channelType = r.channelType, i;
  }
  return S(n, t), Object.defineProperty(n.prototype, "_messageBroadcast", { get: function() {
    return p_.of(this._iid);
  }, enumerable: !1, configurable: !0 }), n.prototype.subscribeMessageEvent = function(e, r) {
    this._messageBroadcast.subscribe(e, r);
  }, n.prototype.unsubscribeMessageEvent = function(e) {
    this._messageBroadcast.unsubscribe(e);
  }, n.prototype.getMessageFromCache = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return [2, null];
      });
    });
  }, n.prototype.getExactlyMatchingMessagesForTokenFromCache = function(e, r, i) {
    return g(this, 0, void 0, function() {
      return _(this, function(s) {
        return [2, []];
      });
    });
  }, n.prototype.getMessagesFromCache = function(e, r, i, s, a, o) {
    return g(this, 0, void 0, function() {
      return _(this, function(l) {
        return [2, []];
      });
    });
  }, n.prototype.getPollMessagesFromCache = function(e, r, i, s) {
    return g(this, 0, void 0, function() {
      return _(this, function(a) {
        return [2, []];
      });
    });
  }, n.prototype.getCachedMessageCountBetween = function(e, r, i, s) {
    return g(this, 0, void 0, function() {
      return _(this, function(a) {
        return [2, 0];
      });
    });
  }, n.prototype.getUnsentMessagesFromCache = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        return [2, []];
      });
    });
  }, n.prototype.removeFailedMessageFromCache = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return [2];
      });
    });
  }, n;
}(xn), x2 = function(t) {
  function n(e, r, i) {
    var s, a, o, l, c = this;
    (c = t.call(this, e, "ADMM", i) || this).message = new va(e, i);
    var u = k.of(e).sdkState;
    return c.isMentioned = pa(c.message.mentionType, (o = (s = c.message.mentionedUserIds) !== null && s !== void 0 ? s : (a = c.message.mentionedUsers) === null || a === void 0 ? void 0 : a.map(function(d) {
      return d.userId;
    })) !== null && o !== void 0 ? o : [], u.userId), c.forceUpdateLastMessage = (l = i.force_update_last_message) !== null && l !== void 0 && l, c;
  }
  return S(n, t), n;
}(Lt), k2 = function(t) {
  function n(e, r, i) {
    var s, a, o, l, c, u = this;
    (u = t.call(this, e, "AEDI", i) || this).message = new va(e, i);
    var d = k.of(e).sdkState;
    return u.mentionCountChange = jd({ mentionType: (s = i.old_values) === null || s === void 0 ? void 0 : s.mention_type, mentionedUserIds: (o = (a = i.old_values) === null || a === void 0 ? void 0 : a.mentioned_user_ids) !== null && o !== void 0 ? o : [] }, Ae({ mentionType: u.message.mentionType, mentionedUserIds: (l = u.message.mentionedUserIds) !== null && l !== void 0 ? l : (c = u.message.mentionedUsers) === null || c === void 0 ? void 0 : c.map(function(h) {
      return h.userId;
    }) }), d.userId), u;
  }
  return S(n, t), n;
}(Lt), O2 = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "MRCT", i) || this;
    return s.channelUrl = i.channel_url, s.channelType = i.channel_type, s.event = new $d(i), s;
  }
  return S(n, t), n;
}(Lt), R2 = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "MTHD", i) || this;
    return s.event = new f_(e, i), s;
  }
  return S(n, t), n;
}(Lt), D2 = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "MCNT", i) || this;
    return s.groupChannelMemberCounts = i.group_channels.map(function(a) {
      return { channelUrl: a.channel_url, memberCount: a.member_count, joinedMemberCount: a.joined_member_count, updatedAt: a.ts };
    }), s.openChannelMemberCounts = i.open_channels.map(function(a) {
      return { channelUrl: a.channel_url, participantCount: a.participant_count, updatedAt: a.ts };
    }), s;
  }
  return S(n, t), n;
}(Lt), L2 = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "PEDI", i) || this;
    return s.event = new CC(e, i), s.status = id(i.poll.status) || i.poll.status, s.channelUrl = i.channel_url, s.channelType = i.channel_type, s;
  }
  return S(n, t), n;
}(Lt);
(function(t) {
  t.NONE = "none", t.JOINED = "joined", t.INVITED = "invited", t.LEFT = "left";
})(sn || (sn = {}));
var pi, nr, ar, as, Wr, sc, Di, Mo, wr = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.state = null, i.role = null, i.isMuted = !1, i.isBlockedByMe = !1, i.isBlockingMe = !1, i.state = Ze(sn, r.state) ? r.state : null, i.role = Ze(Lr, r.role) ? r.role : null, typeof r.is_muted == "boolean" && (i.isMuted = r.is_muted), typeof r.is_blocked_by_me == "boolean" && (i.isBlockedByMe = r.is_blocked_by_me), typeof r.is_blocking_me == "boolean" && (i.isBlockingMe = r.is_blocking_me), i;
  }
  return S(n, t), n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { state: e.state, role: e.role, is_muted: e.isMuted, is_blocked_by_me: e.isBlockedByMe, is_blocking_me: e.isBlockingMe })));
  }, n;
}(Zs), U2 = function(t) {
  function n(e, r) {
    var i, s, a = this;
    return (a = t.call(this, e) || this).channelUrl = (i = r.channel_url) !== null && i !== void 0 ? i : "", a.channelType = (s = r.channel_type) !== null && s !== void 0 ? s : yt.GROUP, a.member = new pt(a._iid, r.user), a.deliveryAt = r.ts, a;
  }
  return S(n, t), n;
}(xn);
(function(t) {
  t.ALL = "all", t.PUBLIC = "public", t.PRIVATE = "private";
})(pi || (pi = {})), function(t) {
  t.ALL = "all", t.JOINED = "joined_only", t.INVITED = "invited_only", t.INVITED_BY_FRIEND = "invited_by_friend", t.INVITED_BY_NON_FRIEND = "invited_by_non_friend";
}(nr || (nr = {})), function(t) {
  t.ALL = "all", t.SUPER = "super", t.NON_SUPER = "nonsuper", t.BROADCAST_ONLY = "broadcast_only", t.EXCLUSIVE_ONLY = "exclusive_only";
}(ar || (ar = {})), function(t) {
  t.ALL = "all", t.UNREAD_MESSAGE = "unread_message";
}(as || (as = {})), function(t) {
  t.ALL = "all", t.UNHIDDEN = "unhidden_only", t.HIDDEN = "hidden_only", t.HIDDEN_ALLOW_AUTO_UNHIDE = "hidden_allow_auto_unhide", t.HIDDEN_PREVENT_AUTO_UNHIDE = "hidden_prevent_auto_unhide";
}(Wr || (Wr = {})), function(t) {
  t.ALL = "all", t.OPERATOR = "operator", t.NONOPERATOR = "nonoperator";
}(sc || (sc = {})), function(t) {
  t.AND = "AND", t.OR = "OR";
}(Di || (Di = {})), function(t) {
  t.MEMBER_NICKNAME = "member_nickname", t.CHANNEL_NAME = "channel_name";
}(Mo || (Mo = {}));
var zt, E_ = function() {
  function t(n) {
    var e, r, i, s, a, o, l, c, u, d, h, p, f, m, v;
    this._searchFilter = null, this._userIdsFilter = null, this.includeEmpty = (e = n == null ? void 0 : n.includeEmpty) !== null && e !== void 0 && e, this.nicknameContainsFilter = (r = n == null ? void 0 : n.nicknameContainsFilter) !== null && r !== void 0 ? r : null, this.nicknameStartsWithFilter = (i = n == null ? void 0 : n.nicknameStartsWithFilter) !== null && i !== void 0 ? i : null, this.nicknameExactMatchFilter = (s = n == null ? void 0 : n.nicknameExactMatchFilter) !== null && s !== void 0 ? s : null, this.channelNameContainsFilter = (a = n == null ? void 0 : n.channelNameContainsFilter) !== null && a !== void 0 ? a : "", this.myMemberStateFilter = (o = n == null ? void 0 : n.myMemberStateFilter) !== null && o !== void 0 ? o : nr.ALL, this.customTypesFilter = (l = n == null ? void 0 : n.customTypesFilter) !== null && l !== void 0 ? l : null, this.channelUrlsFilter = (c = n == null ? void 0 : n.channelUrlsFilter) !== null && c !== void 0 ? c : null, this.superChannelFilter = (u = n == null ? void 0 : n.superChannelFilter) !== null && u !== void 0 ? u : ar.ALL, this.publicChannelFilter = (d = n == null ? void 0 : n.publicChannelFilter) !== null && d !== void 0 ? d : pi.ALL, this.customTypeStartsWithFilter = (h = n == null ? void 0 : n.customTypeStartsWithFilter) !== null && h !== void 0 ? h : null, this.unreadChannelFilter = (p = n == null ? void 0 : n.unreadChannelFilter) !== null && p !== void 0 ? p : as.ALL, this.hiddenChannelFilter = (f = n == null ? void 0 : n.hiddenChannelFilter) !== null && f !== void 0 ? f : Wr.UNHIDDEN, this.includeFrozen = (m = n == null ? void 0 : n.includeFrozen) === null || m === void 0 || m, n != null && n.createdAfter && (this.createdAfter = n.createdAfter), n != null && n.createdBefore && (this.createdBefore = n.createdBefore), this.includeMetaData = (v = n == null ? void 0 : n.includeMetaData) === null || v === void 0 || v;
  }
  return t.prototype._isFriend = function(n) {
    return !(!n || !n.friendDiscoveryKey && !n.friendName);
  }, Object.defineProperty(t.prototype, "searchFilter", { get: function() {
    return this._searchFilter;
  }, enumerable: !1, configurable: !0 }), t.prototype.setSearchFilter = function(n, e) {
    Array.isArray(n) && n.length !== 0 && typeof e == "string" && e && (this._searchFilter = { query: e, fields: n });
  }, Object.defineProperty(t.prototype, "userIdsFilter", { get: function() {
    return this._userIdsFilter;
  }, enumerable: !1, configurable: !0 }), t.prototype.setUserIdsFilter = function(n, e, r) {
    r === void 0 && (r = Di.AND), this._userIdsFilter = { userIds: n, includeMode: e, queryType: r };
  }, t.prototype.clone = function() {
    var n, e = new t();
    this.searchFilter && e.setSearchFilter(this.searchFilter.fields, (n = this.searchFilter.query) !== null && n !== void 0 ? n : void 0), this.userIdsFilter && e.setUserIdsFilter(this.userIdsFilter.userIds, this.userIdsFilter.includeMode, this.userIdsFilter.queryType);
    var r = JSON.parse(JSON.stringify(this));
    return Object.keys(r).forEach(function(i) {
      e[i] = r[i];
    }), e;
  }, t.prototype.match = function(n, e) {
    if (this._searchFilter) {
      var r = this._searchFilter, i = r.query, s = r.fields;
      if (i && s && s.length > 0 && !s.some(function(f) {
        switch (f) {
          case Mo.CHANNEL_NAME:
            return n.name.toLowerCase().includes(i.toLowerCase());
          case Mo.MEMBER_NICKNAME:
            return n.members.some(function(m) {
              return m.nickname.toLowerCase().includes(i.toLowerCase());
            });
          default:
            return !0;
        }
      }))
        return !1;
    }
    if (this._userIdsFilter) {
      var a = this._userIdsFilter, o = a.userIds, l = a.includeMode, c = a.queryType, u = n.members.map(function(f) {
        return f.userId;
      });
      if (l) {
        if (o.length > 0)
          switch (c) {
            case Di.AND:
              if (o.some(function(f) {
                return !u.includes(f);
              }))
                return !1;
              break;
            case Di.OR:
              if (o.every(function(f) {
                return !u.includes(f);
              }))
                return !1;
          }
      } else if (o.includes(e) || o.push(e), n.members.length > o.length || !Yv(o, u))
        return !1;
    }
    if (!this.includeEmpty && !n.lastMessage || !this.includeFrozen && n.isFrozen || this.customTypesFilter && this.customTypesFilter.length > 0 && !this.customTypesFilter.includes("*") && !this.customTypesFilter.includes(n.customType) || this.customTypeStartsWithFilter && !new RegExp("^".concat(this.customTypeStartsWithFilter)).test(n.customType) || this.channelNameContainsFilter && !n.name.toLowerCase().includes(this.channelNameContainsFilter.toLowerCase()))
      return !1;
    if (this.nicknameContainsFilter) {
      var d = this.nicknameContainsFilter.toLowerCase();
      if (!n.members.some(function(f) {
        return f.userId !== e && f.nickname.toLowerCase().includes(d);
      }))
        return !1;
    }
    if (this.nicknameStartsWithFilter) {
      var h = this.nicknameStartsWithFilter.toLowerCase();
      if (!n.members.some(function(f) {
        return f.userId !== e && f.nickname.toLowerCase().startsWith(h);
      }))
        return !1;
    }
    if (this.nicknameExactMatchFilter) {
      var p = this.nicknameExactMatchFilter.toLowerCase();
      if (!n.members.some(function(f) {
        return f.userId !== e && f.nickname.toLowerCase() != p;
      }))
        return !1;
    }
    if (this.channelUrlsFilter && this.channelUrlsFilter.length > 0 && !this.channelUrlsFilter.includes(n.url))
      return !1;
    if (this.myMemberStateFilter)
      switch (this.myMemberStateFilter) {
        case nr.ALL:
          if (n.myMemberState === "none")
            return !1;
          break;
        case nr.JOINED:
          if (n.myMemberState !== "joined")
            return !1;
          break;
        case nr.INVITED:
          if (n.myMemberState !== "invited")
            return !1;
          break;
        case nr.INVITED_BY_FRIEND:
          if (n.myMemberState !== "invited" || !this._isFriend(n.inviter))
            return !1;
          break;
        case nr.INVITED_BY_NON_FRIEND:
          if (n.myMemberState !== "invited" || this._isFriend(n.inviter))
            return !1;
      }
    if (this.hiddenChannelFilter)
      switch (this.hiddenChannelFilter) {
        case Wr.UNHIDDEN:
          if (n.isHidden || n.hiddenState !== "unhidden")
            return !1;
          break;
        case Wr.HIDDEN:
          if (!n.isHidden)
            return !1;
          break;
        case Wr.HIDDEN_ALLOW_AUTO_UNHIDE:
          if (!n.isHidden || n.hiddenState !== "hidden_allow_auto_unhide")
            return !1;
          break;
        case Wr.HIDDEN_PREVENT_AUTO_UNHIDE:
          if (!n.isHidden || n.hiddenState !== "hidden_prevent_auto_unhide")
            return !1;
      }
    if (this.unreadChannelFilter && this.unreadChannelFilter === as.UNREAD_MESSAGE && n.unreadMessageCount === 0)
      return !1;
    if (this.publicChannelFilter)
      switch (this.publicChannelFilter) {
        case pi.PUBLIC:
          if (!n.isPublic)
            return !1;
          break;
        case pi.PRIVATE:
          if (n.isPublic)
            return !1;
      }
    if (this.superChannelFilter)
      switch (this.superChannelFilter) {
        case ar.SUPER:
          if (!n.isSuper)
            return !1;
          break;
        case ar.NON_SUPER:
          if (n.isSuper)
            return !1;
      }
    return !(this.createdAfter && n.createdAt < this.createdAfter || this.createdBefore && n.createdAt > this.createdBefore);
  }, t;
}(), P2 = function(t) {
  function n(e, r) {
    var i = r.sdkState, s = r.cacheContext, a = t.call(this, e) || this;
    return a._channels = /* @__PURE__ */ new Map(), a._sdkState = i, a._cacheContext = s, a;
  }
  return S(n, t), Object.defineProperty(n.prototype, "collection", { get: function() {
    var e = this._cacheContext.nestdb;
    return Z(!!e).throw(D.databaseError), e.collection(c_);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "localCacheEnabled", { get: function() {
    return this._cacheContext.localCacheEnabled && !!this.collection;
  }, enumerable: !1, configurable: !0 }), n.prototype._serialize = function(e, r) {
    return r === void 0 && (r = 0), A(A({}, e.serialize()), { lastMessageUpdatedAt: e.lastMessage ? e.lastMessage.createdAt : 0, syncIndex: r });
  }, n.prototype._deserialize = function(e) {
    return vn.of(this._iid).buildGroupChannelFromSerializedData(e);
  }, Object.defineProperty(n.prototype, "channels", { get: function() {
    return Re([], we(this._channels.values()), !1);
  }, enumerable: !1, configurable: !0 }), n.prototype.isCachedInMemory = function(e) {
    return this._channels.has(e);
  }, n.prototype.filterOffsetChanged = function(e) {
    var r = this;
    return e.filter(function(i) {
      if (r._channels.has(i.url))
        return r._channels.get(i.url).messageOffsetTimestamp < i.messageOffsetTimestamp;
    });
  }, n.prototype.get = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return this._channels.has(e) ? [3, 3] : this.localCacheEnabled ? [4, this.collection.getByKey(e)] : [3, 2];
          case 1:
            if (r = s.sent())
              return i = this._deserialize(r), this._channels.set(e, i), [2, i];
            s.label = 2;
          case 2:
            return [2, void 0];
          case 3:
            return [2, this._channels.get(e)];
        }
      });
    });
  }, n.prototype.fetch = function(e) {
    var r = e.token, i = e.limit, s = i === void 0 ? 100 : i, a = e.backward, o = a !== void 0 && a, l = e.filter, c = l === void 0 ? new E_() : l, u = e.order, d = u === void 0 ? nn.LATEST_LAST_MESSAGE : u, h = e.borderlineChannelUrl;
    return g(this, 0, void 0, function() {
      var p, f, m, v, E, y = this;
      return _(this, function(b) {
        switch (b.label) {
          case 0:
            return this.localCacheEnabled ? (p = !!h, f = Al(d), m = { where: function(T) {
              if (r)
                switch (d) {
                  case nn.CHANNEL_NAME_ALPHABETICAL:
                    if (!o && T.name.localeCompare(r) < 0 || o && T.name.localeCompare(r) > 0)
                      return !1;
                    break;
                  case nn.CHRONOLOGICAL:
                    if (!o && T.createdAt > r || o && T.createdAt < r)
                      return !1;
                    break;
                  case nn.LATEST_LAST_MESSAGE:
                    if (!o && T.lastMessageUpdatedAt > r || o && T.lastMessageUpdatedAt < r)
                      return !1;
                }
              return p && h && h === T.url ? (p = !1, !1) : !p && c.match(y._deserialize(T), y._sdkState.userId);
            }, index: f, backward: o }, [4, this.collection.query(m)]) : [3, 3];
          case 1:
            return [4, b.sent().fetch({ limit: s })];
          case 2:
            return v = b.sent(), (E = v.map(function(T) {
              return y._deserialize(T);
            })).forEach(function(T) {
              !c.includeMetaData && T.cachedMetaData && T._clearCachedMetaData(), y._channels.has(T.url) || y._channels.set(T.url, T);
            }), [2, E];
          case 3:
            return [2, []];
        }
      });
    });
  }, n.prototype.upsert = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a, o = this;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            if (i = [], e.forEach(function(c) {
              if (o._channels.has(c.url)) {
                var u = o._channels.get(c.url);
                u._pinnedMessagesUpdatedAt < c._pinnedMessagesUpdatedAt && (u._pinnedMessagesUpdatedAt = c._pinnedMessagesUpdatedAt), u._messageCollectionLastAccessedAt > c._messageCollectionLastAccessedAt && Object.assign(c, { _messageCollectionLastAccessedAt: void 0 }), c.cachedMetaData && r && (u._updateCachedMetaData(c.cachedMetaData, r).isUpdated || Object.assign(c, { _cachedMetaData: void 0 })), u._update(c), i.push(u);
              } else
                o._channels.set(c.url, c), i.push(c);
            }), !this.localCacheEnabled)
              return [3, 2];
            for (s = [], a = 0; a < i.length; a++)
              s.push(this._serialize(i[a], a));
            return [4, this.collection.upsertMany(s)];
          case 1:
            l.sent(), l.label = 2;
          case 2:
            return [2, i];
        }
      });
    });
  }, n.prototype.remove = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            c.trys.push([0, 5, 6, 7]), r = de(e), i = r.next(), c.label = 1;
          case 1:
            return i.done ? [3, 4] : (s = i.value, this._channels.delete(s), this.localCacheEnabled ? [4, this.collection.remove(s)] : [3, 3]);
          case 2:
            c.sent(), c.label = 3;
          case 3:
            return i = r.next(), [3, 1];
          case 4:
            return [3, 7];
          case 5:
            return a = c.sent(), o = { error: a }, [3, 7];
          case 6:
            try {
              i && !i.done && (l = r.return) && l.call(r);
            } finally {
              if (o)
                throw o.error;
            }
            return [7];
          case 7:
            return [2];
        }
      });
    });
  }, n.prototype.clear = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return this.clearMemoryCache(), this.localCacheEnabled ? [4, this.collection.clear()] : [3, 2];
          case 1:
            e.sent(), e.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.clearMemoryCache = function() {
    this._channels.clear();
  }, n.prototype._setBlockStateOfAllChannels = function(e, r, i) {
    return g(this, 0, void 0, function() {
      var s, a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M;
      return _(this, function(I) {
        switch (I.label) {
          case 0:
            if (s = [], e === this._sdkState.userId)
              try {
                for (a = de(this._channels.values()), o = a.next(); !o.done; o = a.next()) {
                  h = o.value;
                  try {
                    for (y = void 0, l = de(h.members), c = l.next(); !c.done; c = l.next())
                      if ((m = c.value).userId === r) {
                        m.isBlockedByMe = i, s.push(h);
                        break;
                      }
                  } catch (x) {
                    y = { error: x };
                  } finally {
                    try {
                      c && !c.done && (b = l.return) && b.call(l);
                    } finally {
                      if (y)
                        throw y.error;
                    }
                  }
                }
              } catch (x) {
                v = { error: x };
              } finally {
                try {
                  o && !o.done && (E = a.return) && E.call(a);
                } finally {
                  if (v)
                    throw v.error;
                }
              }
            else if (r === this._sdkState.userId)
              try {
                for (u = de(this._channels.values()), d = u.next(); !d.done; d = u.next()) {
                  h = d.value;
                  try {
                    for (N = void 0, p = de(h.members), f = p.next(); !f.done; f = p.next())
                      if ((m = f.value).userId === e) {
                        m.isBlockingMe = i, s.push(h);
                        break;
                      }
                  } catch (x) {
                    N = { error: x };
                  } finally {
                    try {
                      f && !f.done && (M = p.return) && M.call(p);
                    } finally {
                      if (N)
                        throw N.error;
                    }
                  }
                }
              } catch (x) {
                T = { error: x };
              } finally {
                try {
                  d && !d.done && (w = u.return) && w.call(u);
                } finally {
                  if (T)
                    throw T.error;
                }
              }
            return s.length > 0 ? [4, this.upsert(s)] : [3, 2];
          case 1:
            I.sent(), I.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.block = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this._setBlockStateOfAllChannels(e, r, !0)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.unblock = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this._setBlockStateOfAllChannels(e, r, !1)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.markAsRead = function(e, r) {
    return r === void 0 && (r = Re([], we(this._channels.keys()), !1)), g(this, 0, void 0, function() {
      var i, s, a, o, l, c, u, d;
      return _(this, function(h) {
        switch (h.label) {
          case 0:
            i = [], h.label = 1;
          case 1:
            h.trys.push([1, 6, 7, 8]), s = de(r), a = s.next(), h.label = 2;
          case 2:
            return a.done ? [3, 5] : (o = a.value, [4, this.get(o)]);
          case 3:
            (l = h.sent()) != null && l._updateUnreadMemberState(this._sdkState.userId, e) && (l._updateUnreadCount(0, 0), i.push(l)), h.label = 4;
          case 4:
            return a = s.next(), [3, 2];
          case 5:
            return [3, 8];
          case 6:
            return c = h.sent(), u = { error: c }, [3, 8];
          case 7:
            try {
              a && !a.done && (d = s.return) && d.call(s);
            } finally {
              if (u)
                throw u.error;
            }
            return [7];
          case 8:
            return i.length > 0 ? [4, this.upsert(i)] : [3, 10];
          case 9:
            h.sent(), h.label = 10;
          case 10:
            return [2];
        }
      });
    });
  }, n;
}(xn), Ml = { invitedUserIds: void 0, channelUrl: void 0, coverUrl: void 0, coverImage: void 0, isDistinct: void 0, isSuper: void 0, isBroadcast: void 0, isExclusive: void 0, isPublic: void 0, isDiscoverable: void 0, isStrict: void 0, isEphemeral: void 0, accessCode: void 0, name: void 0, data: void 0, customType: void 0, operatorUserIds: void 0, messageSurvivalSeconds: void 0 }, _d = function(t) {
  return tt("string", t.invitedUserIds, !0) && O("string", t.channelUrl, !0) && O("string", t.coverUrl, !0) && (qn(t.coverImage) || O("string", t.coverImage, !0)) && O("boolean", t.isDistinct, !0) && O("boolean", t.isSuper, !0) && O("boolean", t.isBroadcast, !0) && O("boolean", t.isExclusive, !0) && O("boolean", t.isPublic, !0) && O("boolean", t.isStrict, !0) && O("boolean", t.isDiscoverable, !0) && O("boolean", t.isEphemeral, !0) && O("string", t.accessCode, !0) && O("string", t.name, !0) && O("string", t.data, !0) && O("string", t.customType, !0) && tt("string", t.operatorUserIds, !0) && O("number", t.messageSurvivalSeconds, !0);
}, ac = { customTypes: void 0, includeEmpty: !1, includeFrozen: !0, includeMetaData: !0, includeChatNotification: !1 }, gd = function(t) {
  return tt("string", t.customTypes, !0) && O("boolean", t.includeEmpty, !0) && O("boolean", t.includeFrozen, !0) && O("boolean", t.includeMetaData, !0) && O("boolean", t.includeChatNotification, !0);
}, C_ = { myMemberStateFilter: nr.ALL }, T_ = function(t) {
  return Ze(nr, t.myMemberStateFilter);
};
(function(t) {
  t.GROUP_CHANNEL_UNREAD_MENTION_COUNT = "group_channel_unread_mention_count", t.NONSUPER_UNREAD_MENTION_COUNT = "non_super_group_channel_unread_mention_count", t.SUPER_UNREAD_MENTION_COUNT = "super_group_channel_unread_mention_count", t.GROUP_CHANNEL_UNREAD_MESSAGE_COUNT = "group_channel_unread_message_count", t.NONSUPER_UNREAD_MESSAGE_COUNT = "non_super_group_channel_unread_message_count", t.SUPER_UNREAD_MESSAGE_COUNT = "super_group_channel_unread_message_count", t.GROUP_CHANNEL_INVITATION_COUNT = "group_channel_invitation_count", t.NONSUPER_INVITATION_COUNT = "non_super_group_channel_invitation_count", t.SUPER_INVITATION_COUNT = "super_group_channel_invitation_count";
})(zt || (zt = {}));
var F2 = { keys: [zt.GROUP_CHANNEL_UNREAD_MENTION_COUNT, zt.NONSUPER_UNREAD_MENTION_COUNT, zt.SUPER_UNREAD_MENTION_COUNT, zt.GROUP_CHANNEL_UNREAD_MESSAGE_COUNT, zt.NONSUPER_UNREAD_MESSAGE_COUNT, zt.SUPER_UNREAD_MESSAGE_COUNT, zt.GROUP_CHANNEL_INVITATION_COUNT, zt.NONSUPER_INVITATION_COUNT, zt.SUPER_INVITATION_COUNT], customTypeFilters: void 0, customTypesFilter: void 0 }, j2 = { channelCustomTypesFilter: void 0, superChannelFilter: ar.ALL }, H2 = { channelUrl: void 0, scheduledStatus: void 0, messageTypeFilter: Pn.ALL };
A({}, B);
var xl = function(t) {
  return t.startsWith("EVENT_") || t === B.SYNC_CHANNEL_CHANGELOGS || t === B.REFRESH_CHANNEL;
}, it = function(t) {
  function n(e) {
    var r = e.channels, i = e.context, s = e.isWebSocketEventComing, a = s !== void 0 && s, o = e.ts, l = t.call(this) || this;
    return l.channels = r, l.context = i, l.isWebSocketEventComing = a, l.ts = o, l;
  }
  return S(n, t), n;
}(Vt), wi = function(t) {
  function n(e) {
    var r = e.channelUrls, i = e.context, s = e.isWebSocketEventComing, a = s !== void 0 && s, o = t.call(this) || this;
    return o.channelUrls = r, o.context = i, o.isWebSocketEventComing = a, o;
  }
  return S(n, t), n;
}(Vt), B2 = function() {
  function t(n) {
    var e = n.groupChannelCache, r = n.messageCache, i = n.unsentMessageCache, s = n.dispatcher, a = this;
    this._observers = /* @__PURE__ */ new Map(), s.on(function(o) {
      return g(a, 0, void 0, function() {
        var l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M, I, x, R = this;
        return _(this, function(L) {
          switch (L.label) {
            case 0:
              if (!(o instanceof it))
                return [3, 19];
              if (l = o.channels, T = o.context, w = o.isWebSocketEventComing, c = l.filter(function(j) {
                return j instanceof Ir;
              }), T.source !== B.EVENT_CHANNEL_RESET_HISTORY && T.source !== B.EVENT_CHANNEL_HIDDEN)
                return [3, 9];
              L.label = 1;
            case 1:
              L.trys.push([1, 6, 7, 8]), u = de(c), d = u.next(), L.label = 2;
            case 2:
              return d.done ? [3, 5] : (v = d.value, [4, r.removeUnderOffset(v.url, v.messageOffsetTimestamp)]);
            case 3:
              L.sent(), L.label = 4;
            case 4:
              return d = u.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return h = L.sent(), N = { error: h }, [3, 8];
            case 7:
              try {
                d && !d.done && (M = u.return) && M.call(u);
              } finally {
                if (N)
                  throw N.error;
              }
              return [7];
            case 8:
              return [3, 17];
            case 9:
              p = e.filterOffsetChanged(c), L.label = 10;
            case 10:
              L.trys.push([10, 15, 16, 17]), f = de(p), m = f.next(), L.label = 11;
            case 11:
              return m.done ? [3, 14] : (v = m.value, [4, r.removeUnderOffset(v.url, v.messageOffsetTimestamp)]);
            case 12:
              L.sent(), L.label = 13;
            case 13:
              return m = f.next(), [3, 11];
            case 14:
              return [3, 17];
            case 15:
              return E = L.sent(), I = { error: E }, [3, 17];
            case 16:
              try {
                m && !m.done && (x = f.return) && x.call(f);
              } finally {
                if (I)
                  throw I.error;
              }
              return [7];
            case 17:
              return [4, e.upsert(c, o.ts)];
            case 18:
              return y = L.sent(), w || this._broadcastUpdateEvent(y, T), [3, 24];
            case 19:
              return o instanceof wi ? (b = o.channelUrls, T = o.context, w = o.isWebSocketEventComing, [4, e.remove(b)]) : [3, 22];
            case 20:
              return L.sent(), [4, tn(function() {
                return g(R, 0, void 0, function() {
                  var j, P, q, G, X, Ce;
                  return _(this, function(Be) {
                    switch (Be.label) {
                      case 0:
                        Be.trys.push([0, 6, 7, 8]), j = de(b), P = j.next(), Be.label = 1;
                      case 1:
                        return P.done ? [3, 5] : (q = P.value, [4, r.removeMessagesOfChannel(q)]);
                      case 2:
                        return Be.sent(), [4, i.removeMessagesOfChannel(q)];
                      case 3:
                        Be.sent(), Be.label = 4;
                      case 4:
                        return P = j.next(), [3, 1];
                      case 5:
                        return [3, 8];
                      case 6:
                        return G = Be.sent(), X = { error: G }, [3, 8];
                      case 7:
                        try {
                          P && !P.done && (Ce = j.return) && Ce.call(j);
                        } finally {
                          if (X)
                            throw X.error;
                        }
                        return [7];
                      case 8:
                        return [2];
                    }
                  });
                });
              })];
            case 21:
              return L.sent(), w || this._broadcastRemoveEvent(b, T), [3, 24];
            case 22:
              return o instanceof __ ? [4, e.fetch({ token: Number.MAX_SAFE_INTEGER, limit: Number.MAX_SAFE_INTEGER })] : [3, 24];
            case 23:
              L.sent(), L.label = 24;
            case 24:
              return [2];
          }
        });
      });
    });
  }
  return t.prototype._broadcastUpdateEvent = function(n, e) {
    var r, i;
    try {
      for (var s = de(this._observers.values()), a = s.next(); !a.done; a = s.next()) {
        var o = a.value;
        o.onUpdate && o.onUpdate(n, e);
      }
    } catch (l) {
      r = { error: l };
    } finally {
      try {
        a && !a.done && (i = s.return) && i.call(s);
      } finally {
        if (r)
          throw r.error;
      }
    }
  }, t.prototype._broadcastRemoveEvent = function(n, e) {
    var r, i;
    try {
      for (var s = de(this._observers.values()), a = s.next(); !a.done; a = s.next()) {
        var o = a.value;
        o.onRemove && o.onRemove(n, e);
      }
    } catch (l) {
      r = { error: l };
    } finally {
      try {
        a && !a.done && (i = s.return) && i.call(s);
      } finally {
        if (r)
          throw r.error;
      }
    }
  }, t.prototype.subscribe = function(n, e) {
    this._observers.set(n, e);
  }, t.prototype.unsubscribe = function(n) {
    this._observers.delete(n);
  }, t.prototype.unsubscribeAll = function() {
    this._observers.clear();
  }, t;
}(), z2 = function(t) {
  function n(e) {
    var r = e.userId, i = e.ts, s = e.token, a = e.filter, o = e.includeChatNotification, l = o !== void 0 && o, c = t.call(this) || this, u = A(A({}, ac), a), d = u.customTypes, h = u.includeEmpty, p = u.includeFrozen;
    return c.method = Y.GET, c.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/my_group_channels/changelogs"), c.params = fe(Ae({ show_delivery_receipt: !0, show_member: !0, show_read_receipt: !0, change_ts: i || null, token: s, custom_types: d, show_empty: h, show_frozen: p, include_chat_notification: l })), c;
  }
  return S(n, t), n;
}($), V2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.updatedChannels = r.updated.map(function(s) {
      return new Ir(e, Object.assign(s, { ts: r.ts }));
    }), i.deletedChannelUrls = r.deleted, i.hasMore = r.has_more, i.token = r.next, i.ts = r.ts, i;
  }
  return S(n, t), n;
}(ne), vd = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.isInternalCall, s = e.showLatestMessage, a = t.call(this) || this;
    return a.method = Y.GET, a.path = "".concat(i ? ny : Wn, "/").concat(encodeURIComponent(r)), a.params = { show_member: !0, show_read_receipt: !0, show_delivery_receipt: !0, show_latest_message: s != null && s }, a;
  }
  return S(n, t), n;
}($), yd = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.channel = new Ir(e, r), i;
  }
  return S(n, t), n;
}(ne), ea = { includeEmpty: !1, includeFrozen: !0, includeMetaData: !0, includeChatNotification: !1, channelUrlsFilter: void 0, customTypesFilter: void 0, customTypeStartsWithFilter: void 0, nicknameContainsFilter: void 0, nicknameStartsWithFilter: void 0, nicknameExactMatchFilter: void 0, channelNameContainsFilter: void 0, myMemberStateFilter: nr.ALL, unreadChannelFilter: as.ALL, superChannelFilter: ar.ALL, publicChannelFilter: pi.ALL, hiddenChannelFilter: Wr.ALL, userIdsFilter: { userIds: [], includeMode: !0, queryType: Di.AND }, searchFilter: { query: void 0, fields: [] }, metadataKey: void 0, metadataValues: void 0, metadataOrderKeyFilter: void 0, metadataValueStartsWith: void 0, order: nn.LATEST_LAST_MESSAGE, createdAfter: void 0, createdBefore: void 0 }, G2 = function(t) {
  function n(e) {
    var r = this, i = e.userId, s = e.token, a = e.limit, o = e.order, l = e.includeEmpty, c = e.myMemberStateFilter, u = e.superChannelFilter, d = e.publicChannelFilter, h = e.unreadChannelFilter, p = e.nicknameContainsFilter, f = e.nicknameStartsWithFilter, m = e.nicknameExactMatchFilter, v = e.channelNameContainsFilter, E = e.channelUrlsFilter, y = e.customTypesFilter, b = e.customTypeStartsWithFilter, T = e.hiddenChannelFilter, w = e.metadataOrderKeyFilter, N = e.metadataKey, M = e.metadataValues, I = e.metadataValueStartsWith, x = e.includeFrozen, R = e.includeMetaData, L = e.searchFilter, j = e.userIdsFilter, P = e.includeChatNotification, q = P !== void 0 && P, G = e.includeLeftChannel, X = G !== void 0 && G, Ce = e.createdAfter, Be = e.createdBefore;
    return (r = t.call(this) || this).method = Y.GET, r.path = "".concat(vt, "/").concat(encodeURIComponent(i), "/my_group_channels"), r.params = fe({ token: s, limit: a, order: o ?? ea.order, show_member: !0, show_read_receipt: !0, show_delivery_receipt: !0, show_empty: l ?? ea.includeEmpty, member_state_filter: c ?? ea.myMemberStateFilter, super_mode: u ?? ea.superChannelFilter, public_mode: d ?? ea.publicChannelFilter, unread_filter: h ?? ea.unreadChannelFilter, members_nickname_contains: p, members_nickname_startswith: f, members_nickname: m, name_contains: v, channel_urls: E, custom_types: y, custom_type_startswith: b, hidden_mode: T, metadata_order_key: w, metadata_key: N, metadata_values: M, metadata_value_startswith: I, show_frozen: x, show_metadata: R, include_chat_notification: q, include_left_channel: X, created_after: Ce, created_before: Be }), L && L.query && L.fields && (r.params.search_query = L.query, r.params.search_fields = L.fields), j && j.userIds && j.userIds.length > 0 && (j.includeMode ? (r.params.members_include_in = j.userIds, r.params.query_type = j.queryType.toUpperCase()) : r.params.members_exactly_in = j.userIds), r;
  }
  return S(n, t), n;
}($), q2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    i.channels = [];
    var s = r.next, a = r.channels, o = r.ts;
    return i.token = s, a && a.length > 0 && (i.channels = a.map(function(l) {
      return l.ts = o, new Ir(e, l);
    })), i.ts = o ?? 0, i;
  }
  return S(n, t), n;
}(ne), K2 = function(t) {
  function n(e) {
    var r = e.userId, i = e.filter, s = t.call(this) || this, a = i.myMemberStateFilter;
    return s.method = Y.GET, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/group_channel_count"), s.params = { state: a ?? nr.ALL }, s;
  }
  return S(n, t), n;
}($), W2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.groupChannelCount = r.group_channel_count, i;
  }
  return S(n, t), n;
}(ne), Q2 = function(t) {
  function n(e) {
    var r = e.userId, i = e.filter, s = t.call(this) || this, a = i.keys, o = i.customTypeFilters, l = i.customTypesFilter;
    return s.method = Y.GET, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/unread_item_count"), s.params = fe({ item_keys: a, custom_types: l ?? o }), s;
  }
  return S(n, t), n;
}($), Y2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return typeof r[zt.GROUP_CHANNEL_UNREAD_MENTION_COUNT] == "number" && (i.groupChannelUnreadMentionCount = r[zt.GROUP_CHANNEL_UNREAD_MENTION_COUNT]), typeof r[zt.GROUP_CHANNEL_UNREAD_MESSAGE_COUNT] == "number" && (i.groupChannelUnreadMessageCount = r[zt.GROUP_CHANNEL_UNREAD_MESSAGE_COUNT]), typeof r[zt.GROUP_CHANNEL_INVITATION_COUNT] == "number" && (i.groupChannelInvitationCount = r[zt.GROUP_CHANNEL_INVITATION_COUNT]), typeof r[zt.SUPER_UNREAD_MENTION_COUNT] == "number" && (i.superGroupChannelUnreadMentionCount = r[zt.SUPER_UNREAD_MENTION_COUNT]), typeof r[zt.SUPER_UNREAD_MESSAGE_COUNT] == "number" && (i.superGroupChannelUnreadMessageCount = r[zt.SUPER_UNREAD_MESSAGE_COUNT]), typeof r[zt.SUPER_INVITATION_COUNT] == "number" && (i.superGroupChannelInvitationCount = r[zt.SUPER_INVITATION_COUNT]), typeof r[zt.NONSUPER_UNREAD_MENTION_COUNT] == "number" && (i.nonSuperGroupChannelUnreadMentionCount = r[zt.NONSUPER_UNREAD_MENTION_COUNT]), typeof r[zt.NONSUPER_UNREAD_MESSAGE_COUNT] == "number" && (i.nonSuperGroupChannelUnreadMessageCount = r[zt.NONSUPER_UNREAD_MESSAGE_COUNT]), typeof r[zt.NONSUPER_INVITATION_COUNT] == "number" && (i.nonSuperGroupChannelInvitationCount = r[zt.NONSUPER_INVITATION_COUNT]), i;
  }
  return S(n, t), n;
}(ne), $2 = function(t) {
  function n(e) {
    var r = e.userId, i = t.call(this) || this;
    return i.method = Y.GET, i.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/unread_channel_count"), i;
  }
  return S(n, t), n;
}($), Z2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.unreadCount = r.unread_count, i;
  }
  return S(n, t), n;
}(ne), X2 = function(t) {
  function n(e) {
    var r = e.userId, i = e.filter, s = e.includeFeedChannel, a = s !== void 0 && s, o = t.call(this) || this, l = i.channelCustomTypesFilter, c = i.superChannelFilter;
    return o.method = Y.GET, o.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/unread_message_count"), o.params = { super_mode: c ?? ar.ALL, custom_types: l, include_feed_channel: a }, o;
  }
  return S(n, t), n;
}($), J2 = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.unreadCount = r.unread_count, i.unreadFeedCount = r.unread_feed_count, i;
  }
  return S(n, t), n;
}(ne), eT = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.scheduledStatus, s = e.messageTypeFilter, a = t.call(this) || this;
    return a.method = Y.GET, a.path = "".concat(nm, "/count"), a.params = { channel_url: r, status: nT(i) }, s && (a.params.message_type = s), a;
  }
  return S(n, t), n;
}($), tT = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.count = r.count, i;
  }
  return S(n, t), n;
}(ne), nT = function(t) {
  if (!t)
    return [];
  var n = [];
  return t.forEach(function(e) {
    switch (e) {
      case es.PENDING:
        n.push(Tr.PENDING);
        break;
      case es.SENT:
        n.push(Tr.IN_QUEUE), n.push(Tr.SENT);
        break;
      case es.CANCELED:
        n.push(Tr.CANCELED);
        break;
      case es.FAILED:
        n.push(Tr.FAILED);
    }
  }), n;
}, rT = function(t) {
  function n(e) {
    var r = this, i = e.userId, s = e.channelUrl, a = e.coverUrl, o = e.coverImage, l = e.isDistinct, c = e.isSuper, u = e.isBroadcast, d = e.isPublic, h = e.isExclusive, p = e.isDiscoverable, f = e.isStrict, m = e.isEphemeral, v = e.accessCode, E = e.name, y = e.data, b = e.customType, T = e.messageSurvivalSeconds, w = e.invitedUserIds, N = e.operatorUserIds;
    return (r = t.call(this) || this).method = Y.POST, r.path = Wn, r.params = fe({ user_ids: Re([i], we(w ?? []), !1).filter(function(M, I, x) {
      return I === x.indexOf(M);
    }), channel_url: s, cover_url: a, cover_file: o, is_distinct: l, is_super: c, is_broadcast: u, is_exclusive: h, is_public: d, is_discoverable: p, strict: f, is_ephemeral: m, access_code: v, name: E, data: y, custom_type: b, operator_ids: N, message_survival_seconds: T }), r;
  }
  return S(n, t), n;
}($), iT = function(t) {
  function n(e, r) {
    var i, s = this;
    return (s = t.call(this, e, r) || this).channel = new Ir(e, r), s.isCreated = (i = r.is_created) === null || i === void 0 || i, s;
  }
  return S(n, t), n;
}(ne), hf = function(t) {
  function n(e) {
    var r = e.userId, i = e.channelUrls, s = t.call(this) || this;
    return s.method = Y.PUT, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/mark_as_read_all"), s.params = { channel_urls: i }, s;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var sT = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.userId, a = e.accessCode;
    return (r = t.call(this) || this).method = Y.PUT, r.path = "".concat(Wn, "/").concat(encodeURIComponent(i), "/join"), r.params = { user_id: s, access_code: a }, r;
  }
  return S(n, t), n;
}($), aT = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.channel = new Ir(e, r), i;
  }
  return S(n, t), n;
}(ne), oT = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, r, i) || this, a = i.data, o = a.member_count, l = o === void 0 ? 0 : o, c = a.joined_member_count, u = c === void 0 ? 0 : c, d = a.users, h = d === void 0 ? null : d;
    return s.memberCount = l, s.joinedMemberCount = u, s.members = Array.isArray(h) ? h.map(function(p) {
      return new wr(e, p);
    }) : [new wr(e, i.data)], s;
  }
  return S(n, t), n;
}(Ca), lT = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.userId, a = e.shouldRemoveOperatorStatus;
    return (r = t.call(this) || this).method = Y.PUT, r.path = "".concat(Wn, "/").concat(encodeURIComponent(i), "/leave"), r.params = { user_id: s, should_remove_operator_status: a }, r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    return t.call(this, n, e) || this;
  }, t);
})(ne);
var cT = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, r, i) || this, a = i.data, o = a.member_count, l = o === void 0 ? 0 : o, c = a.joined_member_count, u = c === void 0 ? 0 : c;
    return s.memberCount = l, s.joinedMemberCount = u, s.member = new wr(s._iid, i.data), s;
  }
  return S(n, t), n;
}(Ca), uT = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.userIds;
    return (r = t.call(this) || this).method = Y.POST, r.path = "".concat(Wn, "/").concat(encodeURIComponent(i), "/invite"), r.params = { user_ids: s }, r;
  }
  return S(n, t), n;
}($), dT = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.channel = new Ir(e, r), i;
  }
  return S(n, t), n;
}(ne), hT = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, r, i) || this;
    s.inviter = null;
    var a = i.data, o = a.member_count, l = o === void 0 ? 0 : o, c = a.joined_member_count, u = c === void 0 ? 0 : c, d = a.inviter, h = a.invitees, p = h === void 0 ? [] : h;
    return s.memberCount = l, s.joinedMemberCount = u, d && Object.keys(d).length > 0 && (s.inviter = new pt(e, d)), s.invitees = p.map(function(f) {
      return new wr(e, f);
    }), s;
  }
  return S(n, t), n;
}(Ca), pT = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.userId;
    return (r = t.call(this) || this).method = Y.PUT, r.path = "".concat(Wn, "/").concat(encodeURIComponent(i), "/decline"), r.params = { user_id: s }, r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    var r = t.call(this, n, e) || this;
    return r.channel = new Ir(n, e), r.channel.myMemberState = sn.NONE, r;
  }, t);
})(ne);
var fT = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, r, i) || this, a = i.data, o = a.member_count, l = a.joined_member_count, c = a.inviter, u = a.invitee;
    return s.memberCount = o ?? 0, s.joinedMemberCount = l ?? 0, s.inviter = new pt(e, c), s.invitee = new wr(e, u), s;
  }
  return S(n, t), n;
}(Ca), bd = { hidePreviousMessages: !1, allowAutoUnhide: !0 }, mT = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.userId, a = e.hidePreviousMessages, o = e.allowAutoUnhide;
    return (r = t.call(this) || this).method = Y.PUT, r.path = "".concat(Wn, "/").concat(encodeURIComponent(i), "/hide"), r.params = { user_id: s, hide_previous_messages: a ?? bd.hidePreviousMessages, allow_auto_unhide: o ?? bd.allowAutoUnhide }, r;
  }
  return S(n, t), n;
}($), _T = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this, s = r.ts_message_offset;
    return i.messageOffsetTimestamp = s, i;
  }
  return S(n, t), n;
}(ne), gT = function(t) {
  function n(e, r, i) {
    var s, a, o, l = this;
    return (l = t.call(this, e, "SYEV", i) || this).allowAutoUnhide = null, l.hidePreviousMessages = null, l.messageOffsetTimestamp = null, i.data && (l.allowAutoUnhide = (s = i.data.allow_auto_unhide) !== null && s !== void 0 ? s : null, l.hidePreviousMessages = (a = i.data.hide_previous_messages) !== null && a !== void 0 ? a : null), l.messageOffsetTimestamp = (o = i.ts_message_offset) !== null && o !== void 0 ? o : null, l;
  }
  return S(n, t), n;
}(Lt), vT = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.time;
    return t.call(this, { code: "TPST", ackRequired: !1, payload: { channel_url: r, time: i } }) || this;
  }
  return S(n, t), n;
}(Zn), yT = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "SYEV", i) || this;
    return s.user = new pt(e, i.data), s;
  }
  return S(n, t), n;
}(Lt), bT = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.time;
    return t.call(this, { code: "TPEN", ackRequired: !1, payload: { channel_url: r, time: i } }) || this;
  }
  return S(n, t), n;
}(Zn), ET = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "SYEV", i) || this;
    return s.user = new pt(e, i.data), s;
  }
  return S(n, t), n;
}(Lt), CT = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.messageId;
    return t.call(this, { code: "MACK", ackRequired: !1, payload: { channel_url: r, msg_id: i } }) || this;
  }
  return S(n, t), n;
}(Zn), w_ = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M, I, x, R, L = this;
    return (L = t.call(this, e, r) || this).includeEmpty = !1, L.includeFrozen = !0, L.includeMetaData = !0, L.includeChatNotification = !1, L.channelUrlsFilter = null, L.customTypesFilter = null, L.customTypeStartsWithFilter = null, L.nicknameContainsFilter = null, L.nicknameStartsWithFilter = null, L.nicknameExactMatchFilter = null, L.channelNameContainsFilter = "", L.myMemberStateFilter = nr.ALL, L.unreadChannelFilter = as.ALL, L.superChannelFilter = ar.ALL, L.publicChannelFilter = pi.ALL, L.hiddenChannelFilter = Wr.UNHIDDEN, L.searchFilter = { fields: [], query: null }, L.userIdsFilter = { userIds: [], includeMode: !0, queryType: Di.AND }, L.metadataKey = null, L.metadataValues = null, L.metadataOrderKeyFilter = null, L.metadataValueStartsWith = null, L.order = nn.LATEST_LAST_MESSAGE, L.includeEmpty = (i = r.includeEmpty) !== null && i !== void 0 && i, L.includeFrozen = (s = r.includeFrozen) === null || s === void 0 || s, L.includeMetaData = (a = r.includeMetaData) === null || a === void 0 || a, L.includeChatNotification = (o = r.includeChatNotification) !== null && o !== void 0 && o, L.channelUrlsFilter = (l = r.channelUrlsFilter) !== null && l !== void 0 ? l : null, L.customTypesFilter = (c = r.customTypesFilter) !== null && c !== void 0 ? c : null, L.customTypeStartsWithFilter = (u = r.customTypeStartsWithFilter) !== null && u !== void 0 ? u : "", L.nicknameContainsFilter = (d = r.nicknameContainsFilter) !== null && d !== void 0 ? d : null, L.nicknameStartsWithFilter = (h = r.nicknameStartsWithFilter) !== null && h !== void 0 ? h : null, L.nicknameExactMatchFilter = (p = r.nicknameExactMatchFilter) !== null && p !== void 0 ? p : null, L.channelNameContainsFilter = (f = r.channelNameContainsFilter) !== null && f !== void 0 ? f : "", L.myMemberStateFilter = (m = r.myMemberStateFilter) !== null && m !== void 0 ? m : nr.ALL, L.unreadChannelFilter = (v = r.unreadChannelFilter) !== null && v !== void 0 ? v : as.ALL, L.superChannelFilter = (E = r.superChannelFilter) !== null && E !== void 0 ? E : ar.ALL, L.publicChannelFilter = (y = r.publicChannelFilter) !== null && y !== void 0 ? y : pi.ALL, L.hiddenChannelFilter = (b = r.hiddenChannelFilter) !== null && b !== void 0 ? b : Wr.UNHIDDEN, L.searchFilter = (T = r.searchFilter) !== null && T !== void 0 ? T : { fields: [], query: null }, L.userIdsFilter = (w = r.userIdsFilter) !== null && w !== void 0 ? w : { userIds: [], includeMode: !0, queryType: Di.AND }, L.metadataKey = (N = r.metadataKey) !== null && N !== void 0 ? N : null, L.metadataValues = (M = r.metadataValues) !== null && M !== void 0 ? M : null, L.metadataOrderKeyFilter = (I = r.metadataOrderKeyFilter) !== null && I !== void 0 ? I : null, L.metadataValueStartsWith = (x = r.metadataValueStartsWith) !== null && x !== void 0 ? x : null, L.order = (R = r.order) !== null && R !== void 0 ? R : nn.LATEST_LAST_MESSAGE, r.createdAfter && (L.createdAfter = r.createdAfter), r.createdBefore && (L.createdBefore = r.createdBefore), L;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this) && O("boolean", this.includeEmpty) && O("boolean", this.includeFrozen) && O("boolean", this.includeMetaData) && O("string", this.channelNameContainsFilter) && tt("string", this.channelUrlsFilter, !0) && tt("string", this.customTypesFilter, !0) && O("string", this.customTypeStartsWithFilter) && O("string", this.nicknameContainsFilter, !0) && O("string", this.nicknameStartsWithFilter, !0) && O("string", this.nicknameExactMatchFilter, !0) && Ze(nr, this.myMemberStateFilter) && Ze(ar, this.superChannelFilter) && Ze(pi, this.publicChannelFilter) && Ze(as, this.unreadChannelFilter) && Ze(Wr, this.hiddenChannelFilter) && tt(Mo, this.searchFilter.fields) && O("string", this.searchFilter.query, !0) && tt("string", this.userIdsFilter.userIds) && O("boolean", this.userIdsFilter.includeMode) && Ze(Di, this.userIdsFilter.queryType) && Ze(nn, this.order) && O("string", this.metadataOrderKeyFilter, !0) && O("string", this.metadataKey, !0) && tt("string", this.metadataValues, !0) && O("string", this.metadataValueStartsWith, !0) && zh(this.createdAfter, !0) && zh(this.createdBefore, !0);
  }, n.prototype.serialize = function() {
    return Lo(this);
  }, n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, [4, vn.of(this._iid).getMyGroupChannels(this._token, Ae(A({}, this)), this.limit, B.REQUEST_CHANNEL, !0)]) : [3, 2] : [3, 5];
          case 1:
            return e = s.sent(), r = e.channels, i = e.token, this._token = i, this._hasNext = !!i, this._isLoading = !1, [2, r];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(cs), TT = function(t) {
  function n(e) {
    var r = e.channelUrl, i = e.userId, s = t.call(this) || this;
    return s.method = Y.PUT, s.path = "".concat(Wn, "/").concat(encodeURIComponent(r), "/messages/mark_as_delivered"), s.params = fe({ userId: i }), s;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var Ni, wT = function(t) {
  function n(e, r, i) {
    var s = t.call(this, e, "DLVR", i) || this;
    return s.channelUrl = i.channel_url, s.deliveredStateUpdate = i.updated, s;
  }
  return S(n, t), n;
}(Lt), ci = function() {
  function t(n) {
    var e = n.top, r = e === void 0 ? Number.MAX_SAFE_INTEGER : e, i = n.bottom, s = i === void 0 ? 0 : i;
    this.top = r, this.bottom = s;
  }
  return t.prototype.includes = function() {
    for (var n = this, e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    return e.every(function(i) {
      return n.top <= i && i <= n.bottom;
    });
  }, t.prototype.overlap = function(n) {
    return this.includes(n.top) || this.includes(n.bottom);
  }, t.prototype.intersect = function() {
    for (var n = this, e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    return e.some(function(i) {
      return n.top <= i && i <= n.bottom;
    });
  }, t.prototype.extends = function() {
    for (var n = [], e = 0; e < arguments.length; e++)
      n[e] = arguments[e];
    this.top = Math.min.apply(Math, Re([this.top], we(n), !1)), this.bottom = Math.max.apply(Math, Re([this.bottom], we(n), !1));
  }, t;
}(), gs = {}, vn = function(t) {
  function n(e, r) {
    var i, s = this;
    return (s = t.call(this, e, A(A({}, r), { channelType: yt.GROUP })) || this)._leftChannels = /* @__PURE__ */ new Map(), s._disableMack = !1, s._markAsReadAllLastSentAt = 0, s._disableMack = (i = r.disableMack) !== null && i !== void 0 && i, s._groupChannelHandlers = /* @__PURE__ */ new Map(), s._groupChannelCache = new P2(s._iid, { sdkState: r.sdkState, cacheContext: r.cacheContext }), s._groupChannelBroadcast = new B2({ dispatcher: r.dispatcher, groupChannelCache: s._groupChannelCache, messageCache: oa.of(s._iid), unsentMessageCache: Ks.of(s._iid) }), setInterval(function() {
      var a, o, l = function(d) {
        d.invalidateTypingStatus() && (s._dispatcher.dispatch(new it({ channels: [d], context: { source: B.EVENT_CHANNEL_TYPING_STATUS_UPDATE } })), s._groupChannelHandlers.forEach(function(h) {
          h.onTypingStatusUpdated && h.onTypingStatusUpdated(d);
        }));
      };
      try {
        for (var c = de(s._groupChannelCache.channels), u = c.next(); !u.done; u = c.next())
          l(u.value);
      } catch (d) {
        a = { error: d };
      } finally {
        try {
          u && !u.done && (o = c.return) && o.call(c);
        } finally {
          if (a)
            throw a.error;
        }
      }
    }, 1e3), s._dispatcher.on(function(a) {
      a instanceof Lt ? s._handleEvent(a).catch(function(o) {
        if (rr(o) && s._sdkState.appState === "foreground")
          throw o;
      }) : a instanceof m_ ? g(s, 0, void 0, function() {
        var o, l;
        return _(this, function(c) {
          switch (c.label) {
            case 0:
              return o = a.message, [4, this.getChannel(o.channelUrl, !0)];
            case 1:
              return (l = c.sent()).isFrozen || (o instanceof Ln ? l._autoResendUserMessage(o) : o instanceof ln && l._autoResendFileMessage(o)), [2];
          }
        });
      }) : a instanceof g_ ? s.reduceDBSize() : a instanceof Zm && g(s, 0, void 0, function() {
        var o, l, c, u, d, h = this;
        return _(this, function(p) {
          switch (p.label) {
            case 0:
              return o = a.channelUrl, l = a.channelType, c = a.parentMessage, u = new f_(this._iid, { channel_type: yt.GROUP, channel_url: o, parent_message_id: c.messageId, thread_info: Jl.payloadify(c.threadInfo) }), l !== yt.GROUP ? [3, 2] : [4, this.getChannel(o, !0)];
            case 1:
              d = p.sent(), Ue(function() {
                return g(h, 0, void 0, function() {
                  var f, m, v, E, y;
                  return _(this, function(b) {
                    try {
                      for (f = de(this._groupChannelHandlers.values()), m = f.next(); !m.done; m = f.next())
                        (v = m.value).onThreadInfoUpdated && v.onThreadInfoUpdated(d, u);
                    } catch (T) {
                      E = { error: T };
                    } finally {
                      try {
                        m && !m.done && (y = f.return) && y.call(f);
                      } finally {
                        if (E)
                          throw E.error;
                      }
                    }
                    return [2];
                  });
                });
              }), p.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }), gs[e] || (gs[e] = s), s;
  }
  return S(n, t), Object.defineProperty(n.prototype, "_messageCache", { get: function() {
    return oa.of(this._iid);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "_unsentMessageCache", { get: function() {
    return Ks.of(this._iid);
  }, enumerable: !1, configurable: !0 }), n.of = function(e) {
    return gs[e] || (gs[e] = new n(e, k.of(e))), gs[e];
  }, n.clear = function(e) {
    gs[e] && delete gs[e];
  }, Object.defineProperty(n.prototype, "handlers", { get: function() {
    return Re([], we(this._groupChannelHandlers.values()), !1);
  }, enumerable: !1, configurable: !0 }), n.prototype.buildGroupChannelFromSerializedData = function(e) {
    var r = js(e);
    return new Ir(this._iid, Ir.payloadify(r));
  }, n.prototype.buildGroupChannelListQueryFromSerializedData = function(e) {
    var r = js(e);
    return new w_(this._iid, r);
  }, n.prototype.buildMemberFromSerializedData = function(e) {
    var r = js(e);
    return new wr(this._iid, wr.payloadify(r));
  }, n.prototype.getChannelFromCache = function(e) {
    var r;
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this._groupChannelCache.get(e)];
          case 1:
            return [2, (r = i.sent()) !== null && r !== void 0 ? r : null];
        }
      });
    });
  }, n.prototype.getChannelsFromCache = function(e, r, i, s, a) {
    return g(this, 0, void 0, function() {
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return [4, this._groupChannelCache.fetch({ token: e, filter: r, order: i, limit: s, borderlineChannelUrl: a })];
          case 1:
            return [2, o.sent()];
        }
      });
    });
  }, n.prototype.upsertChannelsToCache = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._groupChannelCache.upsert(e)];
          case 1:
            return [2, r.sent()];
        }
      });
    });
  }, n.prototype.removeChannelsFromCache = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._groupChannelCache.remove(e)];
          case 1:
            return r.sent(), [2];
        }
      });
    });
  }, n.prototype.clearChannelsFromCache = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this._groupChannelCache.clear()];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, n.prototype.reduceDBSize = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c, u, d, h, p, f, m, v;
      return _(this, function(E) {
        switch (E.label) {
          case 0:
            return e = oa.of(this._iid), r = k.of(this._iid).cacheContext, i = r.localCacheConfig, s = r.nestdb, r.localCacheEnabled && s && s.state == si.OPENED ? (a = 1024 * i.maxSize * 1024, [4, s.estimateUsage()]) : [2];
          case 1:
            if ((o = E.sent()) < a)
              return [2];
            l = [], c = this._groupChannelCache.channels, u = {}, f = 0, E.label = 2;
          case 2:
            return f < c.length ? [4, this.getMessagesFromCache(c[f].url, 0, "prev", new Fi())] : [3, 5];
          case 3:
            d = E.sent(), u[c[f].url] = JSON.stringify(d).length, h = new Zv({ channel: c[f], cachedMessageCount: d.length }), l.push(h), E.label = 4;
          case 4:
            return f++, [3, 2];
          case 5:
            p = l.sort(i.clearOrderComparator), f = 0, E.label = 6;
          case 6:
            return f < p.length ? [4, e.removeMessagesOfChannel(p[f].channel.url)] : [3, 10];
          case 7:
            return E.sent(), [4, e._getGroupChannelPreferenceSize(p[f].channel.url)];
          case 8:
            if (m = E.sent(), v = u[p[f].channel.url] + m, (o -= v) < a)
              return [3, 10];
            E.label = 9;
          case 9:
            return f++, [3, 6];
          case 10:
            return [2];
        }
      });
    });
  }, n.prototype._handleEvent = function(e) {
    var r, i;
    return g(this, 0, void 0, function() {
      var s, a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M, I, x, R, L, j, P, q, G, X, Ce, Be, se, Ee, ee, ge, ve, H, oe, J, Me, V, ie, ae, ce, le, re, te, Te, ke, he, ye, ze, ot, W, xe, be, ue, Se, Fe, et, je, Xe, Et, $e, Rt, xt, Gt, qt, Xt, z, Ne, Oe, De, Ge, st, Je, He, lt, dt, qe, Ke, ct, nt, ut, ft, un, dn, hn, Kt, pn, fn, Tn, mn, cn, U, Le, _e, ht, Ve, at, Nt, rn, kt, Dt, kn, On, ds, hs, ps, fs, lr, zi, ei, yi, Xs, ms, Bo, Sa, Na, Ia, Vi, zo, Rc, Eh, Ch, Dc, Lc, Uc, Vo, Go, Pc, Fc, Th, jc, wh, Hc, Sh, Bc, Nh, zc, Ih, wt = this;
      return _(this, function(mt) {
        switch (mt.label) {
          case 0:
            switch (mt.trys.push([0, 80, , 81]), e.code) {
              case "MESG":
              case "FILE":
              case "ADMM":
              case "BRDM":
                return [3, 1];
              case "MEDI":
              case "FEDI":
              case "AEDI":
                return [3, 4];
              case "DELM":
                return [3, 7];
              case "READ":
                return [3, 10];
              case "DLVR":
                return [3, 13];
              case "MRCT":
                return [3, 15];
              case "MTHD":
                return [3, 19];
              case "MCNT":
                return [3, 23];
              case "PEDI":
                return [3, 32];
              case "VOTE":
                return [3, 35];
              case "SYEV":
                return [3, 38];
              case "USEV":
                return [3, 78];
            }
            return [3, 79];
          case 1:
            return h = null, e.code === "MESG" ? h = e.as(a_) : e.code === "FILE" ? h = e.as(Xm) : e.code !== "ADMM" && e.code != "BRDM" || (h = e.as(x2)), h ? (s = h.message, a = h.isMentioned, o = h.forceUpdateLastMessage, s.channelType !== yt.GROUP ? [3, 3] : (this._disableMack || tn(function() {
              return g(wt, 0, void 0, function() {
                var K;
                return _(this, function(F) {
                  return K = new CT(s), this._requestQueue.send(K), [2];
                });
              });
            }), X = this._groupChannelCache.isCachedInMemory(s.channelUrl), R = s instanceof en && s.sender.userId === this._sdkState.userId, [4, this.getChannel(s.channelUrl, !0)])) : [3, 3];
          case 2:
            if (l = mt.sent(), c = k.of(this._iid).useMemberInfoInMessage, s instanceof en) {
              try {
                for (u = de(l.members), d = u.next(); !d.done; d = u.next())
                  if ((cn = d.value).userId === s.sender.userId) {
                    c || (s.sender.nickname = cn.nickname, s.sender.plainProfileUrl = cn.plainProfileUrl, s.sender.metaData = cn.metaData, s.sender.isBlockedByMe = cn.isBlockedByMe);
                    break;
                  }
              } catch (K) {
                Fc = { error: K };
              } finally {
                try {
                  d && !d.done && (Th = u.return) && Th.call(u);
                } finally {
                  if (Fc)
                    throw Fc.error;
                }
              }
              !c && a && ((r = s.mentionedUsers) === null || r === void 0 || r.forEach(function(K) {
                var F, We;
                try {
                  for (var Pe = de(l.members), Qe = Pe.next(); !Qe.done; Qe = Pe.next()) {
                    var Jt = Qe.value;
                    if (K.userId === Jt.userId) {
                      K.nickname = Jt.nickname, K.plainProfileUrl = Jt.plainProfileUrl, K.metaData = Jt.metaData;
                      break;
                    }
                  }
                } catch (It) {
                  F = { error: It };
                } finally {
                  try {
                    Qe && !Qe.done && (We = Pe.return) && We.call(Pe);
                  } finally {
                    if (F)
                      throw F.error;
                  }
                }
              })), R && (y = this._sessionManager.currentUser) && (y.nickname = s.sender.nickname, y.plainProfileUrl = s.sender.plainProfileUrl, y.metaData = s.sender.metaData);
            }
            s.silent && !R || (l.isEphemeral || X) && (l._updateLastMessage(s), R || l._shouldUpdateUnreadCountWith(s) && l._updateUnreadCount(l.unreadMessageCount + 1, l.unreadMentionCount + (a ? 1 : 0))), o && l._updateLastMessage(s), this._dispatcher.dispatch(new it({ channels: [l], context: { source: B.EVENT_MESSAGE_RECEIVED } })), s.silent && !R || Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onChannelChanged && We.onChannelChanged(l);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            }), this._dispatcher.dispatch(new Pt({ messages: [s], source: B.EVENT_MESSAGE_RECEIVED })), Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onMessageReceived && We.onMessageReceived(l, s), a && We.onMentionReceived && We.onMentionReceived(l, s);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            }), mt.label = 3;
          case 3:
            return [3, 79];
          case 4:
            return h = null, e.code === "MEDI" ? h = e.as(ud) : e.code === "FEDI" ? h = e.as(dd) : e.code === "AEDI" && (h = e.as(k2)), h ? (p = h.message, f = h.mentionCountChange, p.threadInfo && (p.threadInfo.unreadReplyCount = void 0), p.channelType !== yt.GROUP ? [3, 6] : (X = this._groupChannelCache.isCachedInMemory(p.channelUrl), [4, this.getChannel(p.channelUrl, !0)])) : [3, 6];
          case 5:
            m = mt.sent(), R = p instanceof en && p.sender.userId === this._sdkState.userId, v = !1, R ? (E = p.sender, (y = this._sessionManager.currentUser) && (y.nickname = E.nickname, y.plainProfileUrl = E.plainProfileUrl, y.metaData = E.metaData)) : m.isReadMessage(p) || f !== 0 && !p.silent && X && (m._updateUnreadCount(m.unreadMessageCount, m.unreadMentionCount + f), v = !0), m._updateLastMessage(p) ? v = !0 : !((i = m.lastMessage) === null || i === void 0) && i.isIdentical(p) && (X ? m._updateLastMessage(p) && (v = !0) : v = !0), b = !1, m.lastPinnedMessage && m.lastPinnedMessage.messageId === p.messageId && (m.lastPinnedMessage = p, v = !0, b = !0), v && (this._dispatcher.dispatch(new it({ channels: [m], context: { source: b ? B.EVENT_PINNED_MESSAGE_UPDATED : B.EVENT_MESSAGE_UPDATED } })), p.silent && !R || Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onChannelChanged && We.onChannelChanged(m);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            }), b && Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onPinnedMessageUpdated && We.onPinnedMessageUpdated(m);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            })), this._dispatcher.dispatch(new Pt({ messages: [p], source: B.EVENT_MESSAGE_UPDATED })), Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onMessageUpdated && We.onMessageUpdated(m, p), f > 0 && We.onMentionReceived && We.onMentionReceived(m, p);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            }), mt.label = 6;
          case 6:
            return [3, 79];
          case 7:
            return T = e.as(my), ye = T.channelUrl, ze = T.channelType, w = T.messageId, N = T.silent, M = T.messageCreatedAt, I = T.senderId, ze !== yt.GROUP ? [3, 9] : [4, this.getChannel(ye, !0)];
          case 8:
            x = mt.sent(), R = I === this._sdkState.userId, N || R || M > 0 && x.myLastRead < M && x.unreadMessageCount > 0 && x._updateUnreadCount(x.unreadMessageCount - 1, 0), this._dispatcher.dispatch(new Qd({ messageIds: [w], source: B.EVENT_MESSAGE_DELETED })), Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onMessageDeleted && We.onMessageDeleted(x, w);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            }), mt.label = 9;
          case 9:
            return [3, 79];
          case 10:
            return (L = e.as($m).readStatus).channelType !== yt.GROUP ? [3, 12] : (X = this._groupChannelCache.isCachedInMemory(L.channelUrl), [4, this.getChannel(L.channelUrl, !0)]);
          case 11:
            j = mt.sent(), X && j._updateUnreadMemberState(L.reader.userId, L.readAt), L.reader.userId === this._sdkState.userId ? X ? (j.unreadMessageCount > 0 || j.unreadMentionCount > 0) && (j._updateUnreadCount(0, 0), this._dispatcher.dispatch(new it({ channels: [j], context: { source: B.EVENT_CHANNEL_READ } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onChannelChanged && We.onChannelChanged(j);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            })) : j.unreadMessageCount !== 0 && j.unreadMentionCount !== 0 || (this._dispatcher.dispatch(new it({ channels: [j], context: { source: B.EVENT_CHANNEL_READ } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onChannelChanged && We.onChannelChanged(j);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            })) : (this._dispatcher.dispatch(new it({ channels: [j], context: { source: B.EVENT_CHANNEL_READ } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onUnreadMemberStatusUpdated && We.onUnreadMemberStatusUpdated(j);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            })), mt.label = 12;
          case 12:
            return [3, 79];
          case 13:
            return P = e.as(wT), ye = P.channelUrl, q = P.deliveredStateUpdate, G = q === void 0 ? {} : q, X = this._groupChannelCache.isCachedInMemory(ye), [4, this.getChannel(ye, !0)];
          case 14:
            return Ce = mt.sent(), X && Object.keys(G).forEach(function(K) {
              Ce._updateUndeliveredMemberState(K, G[K]);
            }), Object.keys(G).some(function(K) {
              return K !== wt._sdkState.userId;
            }) && (this._dispatcher.dispatch(new it({ channels: [Ce], context: { source: B.EVENT_CHANNEL_DELIVERED } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onUndeliveredMemberStatusUpdated && We.onUndeliveredMemberStatusUpdated(Ce);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            })), [3, 79];
          case 15:
            return Be = e.as(O2), ye = Be.channelUrl, ze = Be.channelType, se = Be.event, ze !== yt.GROUP ? [3, 18] : [4, this.getChannel(ye, !0)];
          case 16:
            return Ee = mt.sent(), [4, this.getMessageFromCache(se.messageId)];
          case 17:
            (ve = mt.sent()) ? ve instanceof Vn && (ve.applyReactionEvent(se), this._dispatcher.dispatch(new Pt({ messages: [ve], source: B.EVENT_MESSAGE_REACTION_UPDATED }))) : this._dispatcher.dispatch(new Um({ event: se, source: B.EVENT_MESSAGE_REACTION_UPDATED })), Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onReactionUpdated && We.onReactionUpdated(Ee, se);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            }), mt.label = 18;
          case 18:
            return [3, 79];
          case 19:
            return (ee = e.as(R2).event).channelType !== yt.GROUP ? [3, 22] : [4, this.getChannel(ee.channelUrl, !0)];
          case 20:
            return ge = mt.sent(), [4, this.getMessageFromCache(ee.targetMessageId)];
          case 21:
            (ve = mt.sent()) ? ve instanceof Vn && (ve.applyThreadInfoUpdateEvent(ee), this._dispatcher.dispatch(new Pt({ messages: [ve], source: B.EVENT_MESSAGE_THREADINFO_UPDATED }))) : this._dispatcher.dispatch(new Pm({ event: ee, source: B.EVENT_MESSAGE_THREADINFO_UPDATED })), Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onThreadInfoUpdated && We.onThreadInfoUpdated(ge, ee);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            }), mt.label = 22;
          case 22:
            return [3, 79];
          case 23:
            H = e.as(D2).groupChannelMemberCounts, oe = [], mt.label = 24;
          case 24:
            mt.trys.push([24, 29, 30, 31]), J = de(H), Me = J.next(), mt.label = 25;
          case 25:
            return Me.done ? [3, 28] : (V = Me.value, ye = V.channelUrl, ct = V.memberCount, nt = V.joinedMemberCount, ie = V.updatedAt, [4, this.getChannelFromCache(ye)]);
          case 26:
            (ae = mt.sent()) && ae._setLatestMemberCount(ct, nt, ie) && oe.push(ae), mt.label = 27;
          case 27:
            return Me = J.next(), [3, 25];
          case 28:
            return [3, 31];
          case 29:
            return ce = mt.sent(), jc = { error: ce }, [3, 31];
          case 30:
            try {
              Me && !Me.done && (wh = J.return) && wh.call(J);
            } finally {
              if (jc)
                throw jc.error;
            }
            return [7];
          case 31:
            return oe.length > 0 && (this._dispatcher.dispatch(new it({ channels: oe, context: { source: B.EVENT_CHANNEL_MEMBER_COUNT_UPDATED } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onChannelMemberCountChanged && We.onChannelMemberCountChanged(oe);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            })), [3, 79];
          case 32:
            return le = e.as(L2), re = le.event, te = le.status, ye = le.channelUrl, ze = le.channelType, ye && ze === yt.GROUP ? [4, this.getChannel(ye, !0)] : [3, 34];
          case 33:
            Te = mt.sent(), this._dispatcher.dispatch(new Hm({ event: re, source: B.EVENT_POLL_UPDATED })), Ue(te === "removed" ? function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onPollDeleted && We.onPollDeleted(Te, re.pollId);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            } : function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onPollUpdated && We.onPollUpdated(Te, re);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            }), mt.label = 34;
          case 34:
            return [3, 79];
          case 35:
            return ke = e.as(l_), he = ke.event, ye = ke.channelUrl, ze = ke.channelType, ye && ze === yt.GROUP ? [4, this.getChannel(ye, !0)] : [3, 37];
          case 36:
            ot = mt.sent(), this._dispatcher.dispatch(new Yd({ event: he, source: B.EVENT_POLL_VOTED })), Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onPollVoted && We.onPollVoted(ot, he);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            }), mt.label = 37;
          case 37:
            return [3, 79];
          case 38:
            if (!(W = e.as(Ca).event).isGroupChannelEvent)
              return [3, 77];
            switch (W.category) {
              case on.CHANNEL_JOIN:
                return [3, 39];
              case on.CHANNEL_LEAVE:
                return [3, 41];
              case on.CHANNEL_OPERATOR_UPDATE:
                return [3, 45];
              case on.CHANNEL_INVITE:
                return [3, 47];
              case on.CHANNEL_DECLINE_INVITE:
                return [3, 49];
              case on.TYPING_START:
              case on.TYPING_END:
                return [3, 51];
              case on.USER_CHANNEL_MUTE:
              case on.USER_CHANNEL_UNMUTE:
                return [3, 53];
              case on.USER_CHANNEL_BAN:
                return [3, 55];
              case on.USER_CHANNEL_UNBAN:
                return [3, 59];
              case on.CHANNEL_FREEZE:
              case on.CHANNEL_UNFREEZE:
                return [3, 61];
              case on.CHANNEL_HIDE:
                return [3, 63];
              case on.CHANNEL_UNHIDE:
                return [3, 65];
              case on.CHANNEL_DELETED:
                return [3, 67];
              case on.CHANNEL_PROP_CHANGED:
                return [3, 69];
              case on.CHANNEL_META_DATA_CHANGED:
                return [3, 71];
              case on.CHANNEL_META_COUNTERS_CHANGED:
                return [3, 73];
              case on.PINNED_MESSAGE_CHANGED:
                return [3, 75];
            }
            return [3, 77];
          case 39:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 40:
            return xe = mt.sent(), be = e.as(oT), ue = be.memberCount, Se = be.joinedMemberCount, Fe = be.members, et = !1, Fe.forEach(function(K) {
              xe.isExclusive || xe.isSuper || xe.isBroadcast ? et = et || xe._setLatestMemberCount(ue, Se, W.ts) : (K.state = sn.JOINED, xe.addMember(K, W.ts), wt._updateJoinedMemberCount(xe)), K.userId === wt._sdkState.userId && (xe.myMemberState = sn.JOINED);
            }), this._dispatcher.dispatch(new it({ channels: [xe], context: { source: B.EVENT_CHANNEL_JOINED, users: Fe } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    var We, Pe;
                    try {
                      for (var Qe = de(Fe), Jt = Qe.next(); !Jt.done; Jt = Qe.next()) {
                        var It = Jt.value;
                        F.onUserJoined && F.onUserJoined(xe, It);
                      }
                    } catch (Jg) {
                      We = { error: Jg };
                    } finally {
                      try {
                        Jt && !Jt.done && (Pe = Qe.return) && Pe.call(Qe);
                      } finally {
                        if (We)
                          throw We.error;
                      }
                    }
                    xe.isBroadcast && et && F.onChannelMemberCountChanged && F.onChannelMemberCountChanged([xe]);
                  }), [2];
                });
              });
            }), [3, 77];
          case 41:
            return (U = this._leftChannels.get(W.channelUrl)) ? (Xe = U.channel, [3, 44]) : [3, 42];
          case 42:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 43:
            Xe = mt.sent(), mt.label = 44;
          case 44:
            return je = Xe, Et = e.as(cT), ct = Et.memberCount, nt = Et.joinedMemberCount, $e = Et.member, Rt = !1, xt = k.of(this._iid).appInfo, je.isExclusive || je.isSuper || je.isBroadcast ? Rt = je._setLatestMemberCount(ct, nt, W.ts) : (xt != null && xt.enabledChannelMemberShipHistory ? ((Gt = je.members.find(function(K) {
              return K.userId === $e.userId;
            })) && (Gt.state = sn.LEFT), je.memberCount = ct) : je.removeMember($e), this._updateJoinedMemberCount(je)), $e.userId === this._sdkState.userId ? (je.myMemberState = sn.NONE, je.invitedAt = 0, je.joinedAt = 0, je._updateUnreadCount(0, 0), je.isPublic ? this._dispatcher.dispatch(new it({ channels: [je], context: { source: B.EVENT_CHANNEL_LEFT, user: $e } })) : (this._markAsLeave(je), this._dispatcher.dispatch(new wi({ channelUrls: [je.url], context: { source: B.EVENT_CHANNEL_LEFT, user: $e } })))) : this._dispatcher.dispatch(new it({ channels: [je], context: { source: B.EVENT_CHANNEL_LEFT, user: $e } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    F.onUserLeft && F.onUserLeft(je, $e), je.isBroadcast && Rt && F.onChannelMemberCountChanged && F.onChannelMemberCountChanged([je]);
                  }), [2];
                });
              });
            }), [3, 77];
          case 45:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 46:
            qt = mt.sent(), Xt = e.as(I2).operators, z = Xt.map(function(K) {
              return K.userId;
            });
            try {
              for (Ne = de(qt.members), Oe = Ne.next(); !Oe.done; Oe = Ne.next())
                (cn = Oe.value).role = z.includes(cn.userId) ? Lr.OPERATOR : Lr.NONE;
            } catch (K) {
              Hc = { error: K };
            } finally {
              try {
                Oe && !Oe.done && (Sh = Ne.return) && Sh.call(Ne);
              } finally {
                if (Hc)
                  throw Hc.error;
              }
            }
            return qt.myRole = z.includes(this._sdkState.userId) ? Lr.OPERATOR : Lr.NONE, this._dispatcher.dispatch(new it({ channels: [qt], context: { source: B.EVENT_CHANNEL_OPERATOR_UPDATED, operators: Xt } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    F.onOperatorUpdated && F.onOperatorUpdated(qt, Xt);
                  }), [2];
                });
              });
            }), [3, 77];
          case 47:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 48:
            De = mt.sent(), Ge = e.as(hT), ct = Ge.memberCount, nt = Ge.joinedMemberCount, st = Ge.inviter, (Je = Ge.invitees).forEach(function(K) {
              return K.state = sn.INVITED;
            });
            try {
              for (He = de(Je), lt = He.next(); !lt.done; lt = He.next())
                dt = lt.value, De.isExclusive || De.isSuper || De.isBroadcast ? De._setLatestMemberCount(ct, nt, W.ts) : De.addMember(dt, W.ts), this._sdkState.userId === dt.userId && (De.hiddenState = br.UNHIDDEN, De.myMemberState !== sn.JOINED && (De.myMemberState = sn.INVITED), De.invitedAt = W.ts);
            } catch (K) {
              Bc = { error: K };
            } finally {
              try {
                lt && !lt.done && (Nh = He.return) && Nh.call(He);
              } finally {
                if (Bc)
                  throw Bc.error;
              }
            }
            return this._dispatcher.dispatch(new it({ channels: [De], context: { source: B.EVENT_CHANNEL_INVITED, inviter: st, invitees: Je } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    F.onUserReceivedInvitation && F.onUserReceivedInvitation(De, st, Je);
                  }), [2];
                });
              });
            }), [3, 77];
          case 49:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 50:
            return qe = mt.sent(), Ke = e.as(fT), ct = Ke.memberCount, nt = Ke.joinedMemberCount, ut = Ke.inviter, ft = Ke.invitee, qe.isExclusive || qe.isSuper || qe.isBroadcast ? qe._setLatestMemberCount(ct, nt, W.ts) : qe.removeMember(ft), this._sdkState.userId === ft.userId ? (qe.invitedAt = 0, qe.myMemberState = sn.NONE, qe.isPublic ? this._dispatcher.dispatch(new it({ channels: [qe], context: { source: B.EVENT_CHANNEL_DECLINED_INVITE, inviter: ut, invitee: ft } })) : this._dispatcher.dispatch(new wi({ channelUrls: [qe.url], context: { source: B.EVENT_CHANNEL_DECLINED_INVITE, inviter: ut, invitee: ft } }))) : this._dispatcher.dispatch(new it({ channels: [qe], context: { source: B.EVENT_CHANNEL_DECLINED_INVITE, inviter: ut, invitee: ft } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    F.onUserDeclinedInvitation && F.onUserDeclinedInvitation(qe, ut, ft);
                  }), [2];
                });
              });
            }), [3, 77];
          case 51:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 52:
            return un = mt.sent(), dn = W.category === on.TYPING_START, hn = e.as(dn ? yT : ET).user, un._updateTypingStatus(hn, dn ? W.ts : 0), this._dispatcher.dispatch(new it({ channels: [un], context: { source: B.EVENT_CHANNEL_TYPING_STATUS_UPDATE } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    F.onTypingStatusUpdated && F.onTypingStatusUpdated(un);
                  }), [2];
                });
              });
            }), [3, 77];
          case 53:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 54:
            Kt = mt.sent(), pn = W.category === on.USER_CHANNEL_MUTE, (fn = e.as(pn ? Xb : eE).user).userId === this._sdkState.userId && (Kt.myMutedState = pn ? ai.MUTED : ai.UNMUTED, Kt._myMutedRemainingTime = fn.restrictionInfo.remainingDuration);
            try {
              for (Tn = de(Kt.members), mn = Tn.next(); !mn.done; mn = Tn.next())
                if ((cn = mn.value).userId === fn.userId) {
                  cn.isMuted = pn;
                  break;
                }
            } catch (K) {
              zc = { error: K };
            } finally {
              try {
                mn && !mn.done && (Ih = Tn.return) && Ih.call(Tn);
              } finally {
                if (zc)
                  throw zc.error;
              }
            }
            return this._dispatcher.dispatch(new it({ channels: [Kt], context: { source: pn ? B.EVENT_CHANNEL_MUTED : B.EVENT_CHANNEL_UNMUTED, user: fn } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    pn ? F.onUserMuted && F.onUserMuted(Kt, fn) : F.onUserUnmuted && F.onUserUnmuted(Kt, fn);
                  }), [2];
                });
              });
            }), [3, 77];
          case 55:
            return (U = this._leftChannels.get(W.channelUrl)) ? (_e = U.channel, [3, 58]) : [3, 56];
          case 56:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 57:
            _e = mt.sent(), mt.label = 58;
          case 58:
            return Le = _e, this._markAsLeave(Le), (ht = e.as(nE).user).userId === this._sdkState.userId && this._dispatcher.dispatch(new wi({ channelUrls: [Le.url], context: { source: B.EVENT_CHANNEL_BANNED, user: ht } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    F.onUserBanned && F.onUserBanned(Le, ht);
                  }), [2];
                });
              });
            }), [3, 77];
          case 59:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 60:
            return Ve = mt.sent(), (at = e.as(iE).user).userId === this._sdkState.userId && this._dispatcher.dispatch(new wi({ channelUrls: [Ve.url], context: { source: B.EVENT_CHANNEL_UNBANNED, user: at } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    F.onUserUnbanned && F.onUserUnbanned(Ve, at);
                  }), [2];
                });
              });
            }), [3, 77];
          case 61:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 62:
            return Nt = mt.sent(), rn = e.as(sE).freeze, Nt.isFrozen = rn, this._dispatcher.dispatch(new it({ channels: [Nt], context: { source: rn ? B.EVENT_CHANNEL_FROZEN : B.EVENT_CHANNEL_UNFROZEN } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    rn ? F.onChannelFrozen && F.onChannelFrozen(Nt) : F.onChannelUnfrozen && F.onChannelUnfrozen(Nt);
                  }), [2];
                });
              });
            }), [3, 77];
          case 63:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 64:
            return kt = mt.sent(), Dt = e.as(gT), kn = Dt.allowAutoUnhide, On = Dt.hidePreviousMessages, ds = Dt.messageOffsetTimestamp, kn !== null && (kt.hiddenState = kn ? br.HIDDEN_ALLOW_AUTO_UNHIDE : br.HIDDEN_PREVENT_AUTO_UNHIDE), On !== null && On && kt._updateUnreadCount(0, 0), ds !== null && (kt.messageOffsetTimestamp = ds), this._dispatcher.dispatch(new it({ channels: [kt], context: { source: B.EVENT_CHANNEL_HIDDEN } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    F.onChannelHidden && F.onChannelHidden(kt);
                  }), [2];
                });
              });
            }), [3, 77];
          case 65:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 66:
            return (hs = mt.sent()).hiddenState = br.UNHIDDEN, this._dispatcher.dispatch(new it({ channels: [hs], context: { source: B.EVENT_CHANNEL_UNHIDDEN } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    F.onChannelChanged && F.onChannelChanged(hs);
                  }), [2];
                });
              });
            }), [3, 77];
          case 67:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 68:
            return ps = mt.sent(), this._dispatcher.dispatch(new wi({ channelUrls: [W.channelUrl], context: { source: B.EVENT_CHANNEL_DELETED } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    F.onChannelDeleted && F.onChannelDeleted(ps.url, ps.channelType);
                  }), [2];
                });
              });
            }), [3, 77];
          case 69:
            return [4, this.getChannelWithoutCache(W.channelUrl, !0)];
          case 70:
            return fs = mt.sent(), this._dispatcher.dispatch(new it({ channels: [fs], context: { source: B.EVENT_CHANNEL_UPDATED } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    F.onChannelChanged && F.onChannelChanged(fs);
                  }), [2];
                });
              });
            }), [3, 77];
          case 71:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 72:
            return lr = mt.sent(), zi = e.as(Bb), ei = zi.created, yi = zi.updated, Xs = zi.deleted, ei && (lr._upsertCachedMetaData(ei, W.ts), this._dispatcher.dispatch(new it({ channels: [lr], context: { source: B.EVENT_CHANNEL_METADATA_CREATED, metaData: ei }, ts: W.ts }))), yi && (lr._upsertCachedMetaData(yi, W.ts), this._dispatcher.dispatch(new it({ channels: [lr], context: { source: B.EVENT_CHANNEL_METADATA_UPDATED, metaData: yi }, ts: W.ts }))), Xs && (lr._removeFromCachedMetaData(Xs, W.ts), this._dispatcher.dispatch(new it({ channels: [lr], context: { source: B.EVENT_CHANNEL_METADATA_DELETED, metaDataKeys: Xs }, ts: W.ts }))), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    ei && F.onMetaDataCreated && F.onMetaDataCreated(lr, ei), yi && F.onMetaDataUpdated && F.onMetaDataUpdated(lr, yi), Xs && F.onMetaDataDeleted && F.onMetaDataDeleted(lr, Xs);
                  }), [2];
                });
              });
            }), [3, 77];
          case 73:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 74:
            return ms = mt.sent(), Bo = e.as(Qb), Sa = Bo.created, Na = Bo.updated, Ia = Bo.deleted, Sa && this._dispatcher.dispatch(new it({ channels: [ms], context: { source: B.EVENT_CHANNEL_METACOUNTER_CREATED, metaCounters: Sa } })), Na && this._dispatcher.dispatch(new it({ channels: [ms], context: { source: B.EVENT_CHANNEL_METACOUNTER_UPDATED, metaCounters: Na } })), Ia && this._dispatcher.dispatch(new it({ channels: [ms], context: { source: B.EVENT_CHANNEL_METACOUNTER_DELETED, metaCounterKeys: Ia } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    Sa && F.onMetaCounterCreated && F.onMetaCounterCreated(ms, Sa), Na && F.onMetaCounterUpdated && F.onMetaCounterUpdated(ms, Na), Ia && F.onMetaCounterDeleted && F.onMetaCounterDeleted(ms, Ia);
                  }), [2];
                });
              });
            }), [3, 77];
          case 75:
            return [4, this.getChannel(W.channelUrl, !0)];
          case 76:
            return Vi = mt.sent(), zo = e.as(A2), Rc = zo.pinnedMessageIds, Eh = zo.latestPinnedMessage, (Ch = zo.ts) > Vi._pinnedMessagesUpdatedAt && (Vi.pinnedMessageIds = Rc ?? [], Vi.lastPinnedMessage = Eh, Vi._pinnedMessagesUpdatedAt = Ch, this._dispatcher.dispatch(new it({ channels: [Vi], context: { source: B.EVENT_PINNED_MESSAGE_UPDATED } })), Ue(function() {
              return g(wt, 0, void 0, function() {
                var K, F, We, Pe, Qe;
                return _(this, function(Jt) {
                  try {
                    for (K = de(this._groupChannelHandlers.values()), F = K.next(); !F.done; F = K.next())
                      (We = F.value).onChannelChanged && We.onChannelChanged(Vi);
                  } catch (It) {
                    Pe = { error: It };
                  } finally {
                    try {
                      F && !F.done && (Qe = K.return) && Qe.call(K);
                    } finally {
                      if (Pe)
                        throw Pe.error;
                    }
                  }
                  return [2];
                });
              });
            }), Ue(function() {
              return g(wt, 0, void 0, function() {
                return _(this, function(K) {
                  return this._groupChannelHandlers.forEach(function(F) {
                    F.onPinnedMessageUpdated && F.onPinnedMessageUpdated(Vi);
                  }), [2];
                });
              });
            })), [3, 77];
          case 77:
            return [3, 79];
          case 78:
            switch ((Dc = e.as(v_).event).category) {
              case Ao.USER_BLOCK:
                Lc = rc.getDataAsUserBlockEvent(this._iid, Dc), Vo = Lc.blocker, Go = Lc.blockee, this._groupChannelCache.block(Vo.userId, Go.userId);
                break;
              case Ao.USER_UNBLOCK:
                Uc = rc.getDataAsUserBlockEvent(this._iid, Dc), Vo = Uc.blocker, Go = Uc.blockee, this._groupChannelCache.unblock(Vo.userId, Go.userId);
            }
            return [3, 79];
          case 79:
            return [3, 81];
          case 80:
            if (Pc = mt.sent(), rr(Pc))
              throw Pc;
            return [3, 81];
          case 81:
            return [2];
        }
      });
    });
  }, n.prototype._markAsLeave = function(e) {
    var r, i = this, s = (r = this._leftChannels.get(e.url)) !== null && r !== void 0 ? r : { channel: e, ref: 0 };
    s.ref++, this._leftChannels.set(e.url, s), setTimeout(function() {
      s.ref--, s.ref === 0 && i._leftChannels.delete(e.url);
    }, 1e4);
  }, n.prototype.addHandler = function(e, r) {
    this._groupChannelHandlers.set(e, r);
  }, n.prototype.removeHandler = function(e) {
    this._groupChannelHandlers.delete(e);
  }, n.prototype.clearHandler = function() {
    this._groupChannelHandlers.clear();
  }, n.prototype.subscribeChannelEvent = function(e, r) {
    this._groupChannelBroadcast.subscribe(e, r);
  }, n.prototype.unsubscribeChannelEvent = function(e) {
    this._groupChannelBroadcast.unsubscribe(e);
  }, n.prototype._updateJoinedMemberCount = function(e) {
    e.joinedMemberCount = e.members.filter(function(r) {
      return r.state === sn.JOINED;
    }).length;
  }, n.prototype.getChannel = function(e, r) {
    return r === void 0 && (r = !1), g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            Z(O("string", e)).throw(D.invalidParameters), s.label = 1;
          case 1:
            return s.trys.push([1, 3, , 4]), [4, this.getChannelFromCache(e)];
          case 2:
            return (i = s.sent()) ? [2, i] : [3, 4];
          case 3:
            return s.sent(), [3, 4];
          case 4:
            return [4, this.getChannelWithoutCache(e, r)];
          case 5:
            return [2, s.sent()];
        }
      });
    });
  }, n.prototype.getChannelWithoutCache = function(e, r) {
    return r === void 0 && (r = !1), g(this, 0, void 0, function() {
      var i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return Z(O("string", e)).throw(D.invalidParameters), i = new vd({ channelUrl: e, isInternalCall: r }), [4, this._requestQueue.send(i)];
          case 1:
            switch (s = c.sent(), a = s.as(yd).channel, o = a.unreadMessageCount, l = a.unreadMentionCount, a.myCountPreference) {
              case yr.UNREAD_MESSAGE_COUNT_ONLY:
                l = 0;
                break;
              case yr.UNREAD_MENTION_COUNT_ONLY:
                o = 0;
                break;
              case yr.OFF:
                o = 0, l = 0;
            }
            return a._updateUnreadCount(o, l), [4, this.upsertChannelsToCache([a])];
          case 2:
            return [2, c.sent()[0]];
        }
      });
    });
  }, n.prototype.refreshChannel = function(e, r, i, s) {
    return r === void 0 && (r = !0), i === void 0 && (i = B.REFRESH_CHANNEL), s === void 0 && (s = !1), g(this, 0, void 0, function() {
      var a, o, l, c, u;
      return _(this, function(d) {
        switch (d.label) {
          case 0:
            return d.trys.push([0, 5, , 6]), a = new vd({ channelUrl: e, isInternalCall: r, showLatestMessage: s }), [4, this._requestQueue.send(a)];
          case 1:
            return o = d.sent(), (l = o.as(yd).channel).myMemberState !== sn.NONE ? [3, 2] : (this._dispatcher.dispatch(new wi({ channelUrls: [l.url], context: { source: i } })), [3, 4]);
          case 2:
            return [4, this.upsertChannelsToCache([l])];
          case 3:
            c = d.sent(), this._dispatcher.dispatch(new it({ channels: c, context: { source: i } })), d.label = 4;
          case 4:
            return [3, 6];
          case 5:
            return (u = d.sent()).code !== me.NON_AUTHORIZED && u.code !== me.NOT_FOUND_IN_DATABASE || this._dispatcher.dispatch(new wi({ channelUrls: [e], context: { source: i } })), [3, 6];
          case 6:
            return [2];
        }
      });
    });
  }, n.prototype.getMyGroupChannels = function(e, r, i, s, a) {
    return s === void 0 && (s = B.REQUEST_CHANNEL), a === void 0 && (a = !1), g(this, 0, void 0, function() {
      var o, l, c, u, d, h, p, f, m;
      return _(this, function(v) {
        switch (v.label) {
          case 0:
            return r.createdAfter && (r.createdAfter = Math.floor(r.createdAfter / 1e3)), r.createdBefore && (r.createdBefore = Math.floor(r.createdBefore / 1e3)), o = !1, a && (l = k.of(this._iid), c = l.appInfo, (u = l.cacheContext) && !u.localCacheEnabled && (c != null && c.enabledChannelMemberShipHistory) && (c != null && c.applicationAttributes.includes("left_user_view_support")) && (o = !0)), d = new G2(A(A({}, r), { userId: this._sdkState.userId, token: e, limit: i, includeLeftChannel: a && o })), [4, this._requestQueue.send(d)];
          case 1:
            return h = v.sent(), p = h.as(q2), f = p.channels, m = p.token, this._dispatcher.dispatch(new it({ channels: f, context: { source: s } })), [2, { channels: f, token: m }];
        }
      });
    });
  }, n.prototype.getMyGroupChannelChangeLogs = function(e, r, i) {
    return i === void 0 && (i = B.REQUEST_CHANNEL_CHANGELOGS), g(this, 0, void 0, function() {
      var s, a, o, l, c, u, d, h;
      return _(this, function(p) {
        switch (p.label) {
          case 0:
            return s = A(A({}, ac), r), Z((O("string", e) || O("number", e)) && gd(s)).throw(D.invalidParameters), a = new z2(Ae({ userId: this._sdkState.userId, ts: typeof e == "number" ? e : null, token: typeof e == "string" ? e : null, filter: s })), [4, this._requestQueue.send(a)];
          case 1:
            return o = p.sent(), l = o.as(V2), c = l.updatedChannels, u = l.deletedChannelUrls, d = l.hasMore, h = l.ts, c.length > 0 && this._dispatcher.dispatch(new it({ channels: c, context: { source: i }, ts: h })), u.length > 0 && this._dispatcher.dispatch(new wi({ channelUrls: u, context: { source: i } })), [2, { updatedChannels: c, deletedChannelUrls: u, hasMore: d, token: l.token }];
        }
      });
    });
  }, n.prototype.getGroupChannelCount = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return r = A(A({}, C_), e), Z(T_(r)).throw(D.invalidParameters), i = new K2({ userId: this._sdkState.userId, filter: r }), [4, this._requestQueue.send(i)];
          case 1:
            return [2, s.sent().as(W2).groupChannelCount];
        }
      });
    });
  }, n.prototype.getUnreadItemCount = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u, d, h, p, f, m, v, E, y;
      return _(this, function(b) {
        switch (b.label) {
          case 0:
            return r = A(A({}, F2), e), Z(function(T) {
              return tt(zt, T.keys) && tt("string", T.customTypeFilters, !0) && tt("string", T.customTypesFilter, !0);
            }(r)).throw(D.invalidParameters), i = k.of(this._iid), s = i.sdkState, a = i.requestQueue, o = new Q2({ userId: s.userId, filter: r }), [4, a.send(o)];
          case 1:
            return l = b.sent(), c = l.as(Y2), u = c.groupChannelUnreadMentionCount, d = c.groupChannelUnreadMessageCount, h = c.groupChannelInvitationCount, p = c.superGroupChannelUnreadMentionCount, f = c.superGroupChannelUnreadMessageCount, m = c.superGroupChannelInvitationCount, v = c.nonSuperGroupChannelUnreadMentionCount, E = c.nonSuperGroupChannelUnreadMessageCount, y = c.nonSuperGroupChannelInvitationCount, [2, fe({ groupChannelUnreadMentionCount: u, groupChannelUnreadMessageCount: d, groupChannelInvitationCount: h, superGroupChannelUnreadMentionCount: p, superGroupChannelUnreadMessageCount: f, superGroupChannelInvitationCount: m, nonSuperGroupChannelUnreadMentionCount: v, nonSuperGroupChannelUnreadMessageCount: E, nonSuperGroupChannelInvitationCount: y })];
        }
      });
    });
  }, n.prototype.getTotalUnreadChannelCount = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new $2({ userId: r.userId }), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(Z2).unreadCount];
        }
      });
    });
  }, n.prototype.getTotalUnreadMessageCount = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return r = A(A({}, j2), e), Z(function(c) {
              return tt("string", c.channelCustomTypesFilter, !0) && Ze(ar, c.superChannelFilter);
            }(r)).throw(D.invalidParameters), i = k.of(this._iid), s = i.sdkState, a = i.requestQueue, o = new X2({ userId: s.userId, filter: r }), [4, a.send(o)];
          case 1:
            return [2, l.sent().as(J2).unreadCount];
        }
      });
    });
  }, n.prototype.getTotalScheduledMessageCount = function(e) {
    return e === void 0 && (e = {}), g(this, 0, void 0, function() {
      var r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return r = A(A({}, H2), e), Z(function(o) {
              return O("string", o.channelUrl, !0) && tt(es, o.scheduledStatus, !0) && Ze(Pn, o.messageTypeFilter);
            }(r)).throw(D.invalidParameters), i = k.of(this._iid).requestQueue, s = new eT(r), [4, i.send(s)];
          case 1:
            return [2, a.sent().as(tT).count];
        }
      });
    });
  }, n.prototype.getSubscribedTotalUnreadMessageCount = function() {
    var e = k.of(this._iid).subscribedUnreadMessageCount;
    return e.all >= 0 ? e.all : 0;
  }, n.prototype.getSubscribedCustomTypeTotalUnreadMessageCount = function() {
    var e = 0, r = k.of(this._iid).subscribedUnreadMessageCount;
    return Object.keys(r.customTypes).forEach(function(i) {
      e += r.customTypes[i];
    }), e;
  }, n.prototype.getSubscribedCustomTypeUnreadMessageCount = function(e) {
    var r;
    return (r = k.of(this._iid).subscribedUnreadMessageCount.customTypes[e]) !== null && r !== void 0 ? r : 0;
  }, n.prototype.createChannel = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return r = A(A({}, Ml), e), Z(_d(r)).throw(D.invalidParameters), r.isPublic || (r.accessCode = void 0), i = new rT(A({ userId: this._sdkState.userId }, r)), [4, this._requestQueue.send(i)];
          case 1:
            return s = o.sent(), a = s.as(iT).channel, [4, this.upsertChannelsToCache([a])];
          case 2:
            return o.sent(), [2, a];
        }
      });
    });
  }, n.prototype.markAsReadAll = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return e = Date.now(), Z(e - this._markAsReadAllLastSentAt >= 1e3).throw(D.markAsReadAllRateLimitExceeded), this._markAsReadAllLastSentAt = e, r = new hf({ userId: this._sdkState.userId }), [4, this._requestQueue.send(r)];
          case 1:
            u.sent(), i = this._groupChannelCache.channels;
            try {
              for (s = de(i), a = s.next(); !a.done; a = s.next())
                (o = a.value)._updateUnreadMemberState(this._sdkState.userId, e), o._updateUnreadCount(0, 0);
            } catch (d) {
              l = { error: d };
            } finally {
              try {
                a && !a.done && (c = s.return) && c.call(s);
              } finally {
                if (l)
                  throw l.error;
              }
            }
            return i.length > 0 ? [4, this.upsertChannelsToCache(i)] : [3, 3];
          case 2:
            u.sent(), u.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, n.prototype.markAsReadWithChannelUrls = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u, d;
      return _(this, function(h) {
        switch (h.label) {
          case 0:
            return r = Date.now(), Z(tt("string", e) && r - this._markAsReadAllLastSentAt >= 1e3).throw(D.markAsReadAllRateLimitExceeded), this._markAsReadAllLastSentAt = r, i = new hf({ userId: this._sdkState.userId, channelUrls: e }), [4, this._requestQueue.send(i)];
          case 1:
            h.sent(), s = this._groupChannelCache.channels, a = [];
            try {
              for (o = de(s), l = o.next(); !l.done; l = o.next())
                c = l.value, e.includes(c.url) && (c._updateUnreadMemberState(this._sdkState.userId, r), c._updateUnreadCount(0, 0), a.push(c));
            } catch (p) {
              u = { error: p };
            } finally {
              try {
                l && !l.done && (d = o.return) && d.call(o);
              } finally {
                if (u)
                  throw u.error;
              }
            }
            return a.length > 0 ? [4, this.upsertChannelsToCache(a)] : [3, 3];
          case 2:
            h.sent(), h.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, n.prototype.markAsDelivered = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this.getChannel(e)];
          case 1:
            return [4, r.sent().markAsDelivered()];
          case 2:
            return r.sent(), [2];
        }
      });
    });
  }, n.prototype.getMessageFromCache = function(e) {
    var r;
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this._messageCache.get(e)];
          case 1:
            return [2, (r = i.sent()) !== null && r !== void 0 ? r : null];
        }
      });
    });
  }, n.prototype.getExactlyMatchingMessagesForTokenFromCache = function(e, r, i) {
    return g(this, 0, void 0, function() {
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return [4, this._messageCache.fetch({ channelUrl: e, token: r, filter: i, exactMatch: !0 })];
          case 1:
            return [2, s.sent()];
        }
      });
    });
  }, n.prototype.getMessagesFromCache = function(e, r, i, s, a, o) {
    return a === void 0 && (a = 100), o === void 0 && (o = !0), g(this, 0, void 0, function() {
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, this._messageCache.fetch({ channelUrl: e, token: r, limit: a, filter: s, backward: i === "next", inclusive: o })];
          case 1:
            return [2, l.sent()];
        }
      });
    });
  }, n.prototype.getPollMessagesFromCache = function(e, r, i, s) {
    return g(this, 0, void 0, function() {
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return [4, this._messageCache.fetch({ channelUrl: e, token: r, limit: s, filter: i, backward: !1, isPollOnly: !0 })];
          case 1:
            return [2, a.sent()];
        }
      });
    });
  }, n.prototype.getCachedMessageCountBetween = function(e, r, i, s) {
    return g(this, 0, void 0, function() {
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return [4, this._messageCache.countBetween(e, r, new ci({ top: i, bottom: s }))];
          case 1:
            return [2, a.sent()];
        }
      });
    });
  }, n.prototype.getUnsentMessagesFromCache = function(e, r) {
    return g(this, 0, void 0, function() {
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this._unsentMessageCache.fetch({ channelUrl: e, filter: r })];
          case 1:
            return [2, i.sent()];
        }
      });
    });
  }, n.prototype.removeFailedMessageFromCache = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._unsentMessageCache.remove([e])];
          case 1:
            return r.sent(), [2];
        }
      });
    });
  }, n;
}(M2), _r = function(t, n) {
  return n instanceof en ? t.findIndex(function(e) {
    return e instanceof en && n.isIdentical(e);
  }) : t.findIndex(function(e) {
    return e.isIdentical(n);
  });
}, Oa = function(t, n) {
  return t.findIndex(function(e) {
    return e instanceof Vn ? e.messageId === n : e instanceof Gs ? e.notificationId === n : void 0;
  });
}, vu = function(t, n) {
  if (t.length > 0) {
    for (var e = 0, r = t.length - 1, i = Math.floor((e + r) / 2); e < r; ) {
      var s = t[i].createdAt - n.createdAt;
      if (s > 0)
        r = i, i = Math.floor((e + r) / 2);
      else {
        if (!(s < 0))
          return i;
        e = i + 1, i = Math.floor((e + r) / 2);
      }
    }
    return t[i].createdAt > n.createdAt ? i : i + 1;
  }
  return t.length;
};
(function(t) {
  t[t.IDLE = 0] = "IDLE", t[t.RUNNING = 1] = "RUNNING", t[t.END = 2] = "END";
})(Ni || (Ni = {}));
var oc, os = function(t) {
  function n(e, r, i, s) {
    var a = t.call(this) || this;
    return a._state = Ni.IDLE, a._retryCount = 0, a._retryLimit = 3, a.priority = 0, a._worker = r, a;
  }
  return S(n, t), Object.defineProperty(n.prototype, "isIdle", { get: function() {
    return this._state === Ni.IDLE;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isRunning", { get: function() {
    return this._state === Ni.RUNNING;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isDone", { get: function() {
    return this._state === Ni.END;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "retryCount", { get: function() {
    return this._retryCount;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "retryLimit", { get: function() {
    return this._retryLimit;
  }, enumerable: !1, configurable: !0 }), n.prototype._run = function(e) {
    return g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            if (!this.isRunning)
              return [3, 4];
            s.label = 1;
          case 1:
            return s.trys.push([1, 3, , 4]), [4, this._worker(e)];
          case 2:
            return r = s.sent(), this._retryCount = 0, this.dispatch("progress", r), r.hasNext ? this._run(r.nextToken) : this.end(), [3, 4];
          case 3:
            return i = s.sent(), this.dispatch("error", i), this._retryCount < this._retryLimit ? (this._retryCount++, this._run(e)) : this.stop(), [3, 4];
          case 4:
            return [2];
        }
      });
    });
  }, n.prototype.start = function(e) {
    this.isIdle && (this._state = Ni.RUNNING, this._run(e));
  }, n.prototype.stop = function() {
    this._state = Ni.IDLE, this.dispatch("stop");
  }, n.prototype.end = function() {
    this._state = Ni.END, this.dispatch("end");
  }, n;
}(Qs), zr = {}, ST = function() {
  function t(n) {
    var e = n._iid, r = n.channel, i = n.limit, s = i === void 0 ? 100 : i, a = this;
    this.ref = 0, this._iid = e, this._channel = r, this._limit = s, this._prevSyncLoopCount = 0;
    var o, l, c = k.of(this._iid), u = c.sdkState, d = c.cacheContext, h = c.dispatcher, p = c.logger, f = c.statManager, m = c.messageBackgroundSyncThrottleController;
    this._metadataKey = (o = u.userId, l = r.url, "sendbird:".concat(o, "@groupchannel/").concat(l, "/message/sync.meta"));
    var v = function(E, y) {
      return "sendbird:".concat(E, "@groupchannel/").concat(y, "/message/sync");
    }(u.userId, r.url);
    this._prevSync = new os(v, function(E) {
      return g(a, 0, void 0, function() {
        var y = this;
        return _(this, function(b) {
          switch (b.label) {
            case 0:
              return [4, m.run("message-background-sync-".concat(r.url, "-prev"), function() {
                return g(y, 0, void 0, function() {
                  var T, w, N, M, I, x, R, L, j, P, q, G;
                  return _(this, function(X) {
                    switch (X.label) {
                      case 0:
                        return T = { hasNext: !0, nextToken: 0 }, this._prevSyncLoopCount++, [4, this.loadMetadata()];
                      case 1:
                        if (X.sent(), p.debug("message background prev sync from", (x = this._metadata) === null || x === void 0 ? void 0 : x.range.top), (R = this._metadata) === null || R === void 0 ? void 0 : R.previousComplete)
                          return [3, 10];
                        X.label = 2;
                      case 2:
                        return X.trys.push([2, 5, 8, 9]), [4, bn.of(this._iid).getMessagesByTimestamp(this._channel.url, this._channel.channelType, !((j = (L = this._metadata) === null || L === void 0 ? void 0 : L.range) === null || j === void 0) && j.top ? this._metadata.range.top : E, { prevResultSize: this._limit, nextResultSize: 0, replyType: Fn.ALL, includeReactions: !0, includeMetaArray: !0, includeParentMessageInfo: !0, includeThreadInfo: !0, isInclusive: !0 }, B.SYNC_MESSAGE_BACKGROUND)];
                      case 3:
                        return (w = X.sent()).length > 0 && (N = w.map(function(Ce) {
                          return Ce.createdAt;
                        }), !((P = this._metadata) === null || P === void 0) && (I = P.range).intersect.apply(I, Re([], we(N), !1)) ? this.extendRange(w) : this._metadata = { range: new ci({ top: Math.min.apply(Math, Re([], we(N), !1)), bottom: Math.max.apply(Math, Re([], we(N), !1)) }), previousComplete: !1 }), T.hasNext = w.length >= this._limit && this._prevSyncLoopCount < 1, this._metadata && (T.nextToken = this._metadata.range.top, this._metadata.previousComplete = w.length < this._limit), p.debug("message background prev sync progress", T), [4, this.saveMetadata()];
                      case 4:
                        return X.sent(), [3, 9];
                      case 5:
                        return M = X.sent(), p.debug("message background prev sync error", M), M instanceof D && M.isInvalidTokenError ? [4, this.clearMetadata()] : [3, 7];
                      case 6:
                        X.sent(), X.label = 7;
                      case 7:
                        throw M;
                      case 8:
                        return f.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: r.url, measured_on: "back_sync", event: "cache_fetch", max_db_size: (G = (q = d.localCacheConfig) === null || q === void 0 ? void 0 : q.maxSize) !== null && G !== void 0 ? G : 0, use_local_cache: d.localCacheEnabled, starting_point: 0, message_init_policy: "" } })), [7];
                      case 9:
                        return [3, 11];
                      case 10:
                        T.hasNext = !1, X.label = 11;
                      case 11:
                        return [2, T];
                    }
                  });
                });
              })];
            case 1:
              return [2, b.sent()];
          }
        });
      });
    }), this._nextSync = new os(v, function(E) {
      return g(a, 0, void 0, function() {
        var y = this;
        return _(this, function(b) {
          switch (b.label) {
            case 0:
              return [4, m.run("message-background-sync-".concat(r.url, "-next"), function() {
                return g(y, 0, void 0, function() {
                  var T, w, N, M, I, x, R, L, j, P, q;
                  return _(this, function(G) {
                    switch (G.label) {
                      case 0:
                        return T = { hasNext: !0, nextToken: 0 }, [4, this.loadMetadata()];
                      case 1:
                        G.sent(), p.debug("message background next sync from", (x = this._metadata) === null || x === void 0 ? void 0 : x.range.bottom), G.label = 2;
                      case 2:
                        return G.trys.push([2, 5, 6, 7]), [4, bn.of(this._iid).getMessagesByTimestamp(this._channel.url, this._channel.channelType, !((L = (R = this._metadata) === null || R === void 0 ? void 0 : R.range) === null || L === void 0) && L.bottom ? this._metadata.range.bottom : E, { prevResultSize: 0, nextResultSize: this._limit, replyType: Fn.ALL, includeReactions: !0, includeMetaArray: !0, includeParentMessageInfo: !0, includeThreadInfo: !0, isInclusive: !0 }, B.SYNC_MESSAGE_BACKGROUND)];
                      case 3:
                        return (w = G.sent()).length > 0 && (N = w.map(function(X) {
                          return X.createdAt;
                        }), !((j = this._metadata) === null || j === void 0) && (I = j.range).intersect.apply(I, Re([], we(N), !1)) ? this.extendRange(w) : this._metadata = { range: new ci({ top: Math.min.apply(Math, Re([], we(N), !1)), bottom: Math.max.apply(Math, Re([], we(N), !1)) }), previousComplete: !1 }), T.hasNext = w.length >= this._limit, this._metadata && (T.nextToken = this._metadata.range.bottom), p.debug("message background next sync progress", T), [4, this.saveMetadata()];
                      case 4:
                        return G.sent(), [3, 7];
                      case 5:
                        throw M = G.sent(), p.debug("message background next sync error", M), M;
                      case 6:
                        return f.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: r.url, measured_on: "back_sync", event: "cache_fetch", max_db_size: (q = (P = d.localCacheConfig) === null || P === void 0 ? void 0 : P.maxSize) !== null && q !== void 0 ? q : 0, use_local_cache: d.localCacheEnabled, starting_point: 0, message_init_policy: "" } })), [7];
                      case 7:
                        return [2, T];
                    }
                  });
                });
              })];
            case 1:
              return [2, b.sent()];
          }
        });
      });
    }), this._connectionEventContext = h.on(function(E) {
      E instanceof Ar && (E.stateType === bt.CONNECTED ? a.resume() : a.pause());
    });
  }
  return t.of = function(n, e) {
    return zr[n] || (zr[n] = {}), zr[n][e.url] || (zr[n][e.url] = new t({ _iid: n, channel: e })), zr[n][e.url].ref++, zr[n][e.url];
  }, t.clear = function(n, e) {
    zr[n] && zr[n][e] && (zr[n][e].close(), delete zr[n]);
  }, Object.defineProperty(t.prototype, "range", { get: function() {
    var n, e;
    return (e = (n = this._metadata) === null || n === void 0 ? void 0 : n.range) !== null && e !== void 0 ? e : new ci({});
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "previousComplete", { get: function() {
    var n;
    return !!(!((n = this._metadata) === null || n === void 0) && n.previousComplete);
  }, enumerable: !1, configurable: !0 }), t.prototype.isWrappingMessages = function(n) {
    var e;
    return (e = this.range) === null || e === void 0 ? void 0 : e.includes.apply(e, Re([], we(n.map(function(r) {
      return r.createdAt;
    })), !1));
  }, t.prototype.extendRange = function(n) {
    var e;
    this._metadata && (e = this._metadata.range).extends.apply(e, Re([], we(n.map(function(r) {
      return r.createdAt;
    })), !1));
  }, t.prototype.loadMetadata = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return this._metadata ? [3, 2] : [4, k.of(this._iid).cacheContext.preference.get(this._metadataKey)];
          case 1:
            n = e.sent(), this._metadata = n ? { range: new ci(n.range), previousComplete: n.previousComplete } : { range: new ci({}), previousComplete: !1 }, e.label = 2;
          case 2:
            return [2, this._metadata];
        }
      });
    });
  }, t.prototype.saveMetadata = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return this._metadata ? [4, k.of(this._iid).cacheContext.preference.set(this._metadataKey, this._metadata)] : [3, 2];
          case 1:
            return n.sent(), [2, !0];
          case 2:
            return [2, !1];
        }
      });
    });
  }, t.prototype.clearMetadata = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, k.of(this._iid).cacheContext.preference.remove(this._metadataKey)];
          case 1:
            return n.sent(), this._metadata = void 0, [2];
        }
      });
    });
  }, t.prototype.resume = function(n) {
    var e, r, i, s;
    n === void 0 && (n = Date.now());
    var a = k.of(this._iid), o = a.logger, l = a.sessionManager;
    a.cacheContext.localCacheEnabled && l.session.hasSession && (o.debug("message background sync resume()"), this._prevSyncLoopCount = 0, this._metadata && this._metadata.previousComplete || this._prevSync.start((r = (e = this._metadata) === null || e === void 0 ? void 0 : e.range.top) !== null && r !== void 0 ? r : n), this._nextSync.start((s = (i = this._metadata) === null || i === void 0 ? void 0 : i.range.bottom) !== null && s !== void 0 ? s : n));
  }, t.prototype.pause = function() {
    k.of(this._iid).logger.debug("message background sync stop()"), this._prevSync.stop(), this._nextSync.stop();
  }, t.prototype.close = function() {
    this.ref--, this.ref <= 0 && (this.ref = 0, this.pause(), this._connectionEventContext.close(), delete zr[this._iid][this._channel.url]);
  }, t;
}(), Vr = {}, NT = function() {
  function t(n) {
    var e = n._iid, r = n.channel, i = n.includeParams, s = this;
    this.ref = 0, this._iid = e, this._channel = r, this._includeParams = i;
    var a, o, l = k.of(this._iid), c = l.logger, u = l.sdkState, d = l.dispatcher;
    this._metadataKey = (a = u.userId, o = r.url, "sendbird:".concat(a, "@groupchannel/").concat(o, "/message/changelogs.meta"));
    var h = function(p, f) {
      return "sendbird:".concat(p, "@groupchannel/").concat(f, "/message/changelogs");
    }(u.userId, this._channel.url);
    this._sync = new os(h, function() {
      return g(s, 0, void 0, function() {
        var p, f, m, v, E, y, b, T;
        return _(this, function(w) {
          switch (w.label) {
            case 0:
              return p = { hasNext: !0, nextToken: 0 }, [4, this.loadMetadata()];
            case 1:
              w.sent(), c.debug("message changelog sync from", (T = this._metadata) === null || T === void 0 ? void 0 : T.token), w.label = 2;
            case 2:
              return w.trys.push([2, 5, , 8]), [4, bn.of(this._iid).getMessageChangelogs(this._channel.url, this._channel.channelType, this._metadata.token, A({ replyType: Fn.ALL }, this._includeParams), B.SYNC_MESSAGE_CHANGELOGS)];
            case 3:
              return f = w.sent(), m = f.updatedMessages, v = f.deletedMessageIds, E = f.hasMore, y = f.token, p.hasNext = E, p.nextToken = y, (m.length > 0 || v.length > 0) && this._metadata && (this._metadata.token = y), c.debug("message changelog sync progress", p), [4, this.saveMetadata()];
            case 4:
              return w.sent(), [3, 8];
            case 5:
              return b = w.sent(), c.debug("message changelog sync error", b), b instanceof D && b.isInvalidTokenError ? [4, this.clearMetadata()] : [3, 7];
            case 6:
              w.sent(), w.label = 7;
            case 7:
              throw b;
            case 8:
              return [2, p];
          }
        });
      });
    }), this._connectionEventContext = d.on(function(p) {
      p instanceof Ar && (p.stateType === bt.CONNECTED ? s.resume() : s.pause());
    });
  }
  return t.of = function(n, e, r) {
    return Vr[n] || (Vr[n] = {}), Vr[n][e.url] || (Vr[n][e.url] = new t({ _iid: n, channel: e, includeParams: r })), Vr[n][e.url].ref++, Vr[n][e.url];
  }, t.clear = function(n, e) {
    Vr[n] && Vr[n][e] && (Vr[n][e].close(), delete Vr[n]);
  }, t.prototype.loadMetadata = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return this._metadata ? [3, 2] : (n = k.of(this._iid), e = n.cacheContext, r = n.firstConnectedAt, [4, e.preference.get(this._metadataKey)]);
          case 1:
            i = s.sent(), this._metadata = { token: i ? i.token : r }, s.label = 2;
          case 2:
            return [2, this._metadata];
        }
      });
    });
  }, t.prototype.saveMetadata = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return this._metadata ? [4, k.of(this._iid).cacheContext.preference.set(this._metadataKey, this._metadata)] : [3, 2];
          case 1:
            return n.sent(), [2, !0];
          case 2:
            return [2, !1];
        }
      });
    });
  }, t.prototype.clearMetadata = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, k.of(this._iid).cacheContext.preference.remove(this._metadataKey)];
          case 1:
            return n.sent(), this._metadata = void 0, [2];
        }
      });
    });
  }, t.prototype.resume = function() {
    var n = k.of(this._iid), e = n.logger;
    n.sessionManager.session.hasSession && (e.debug("message changelog sync resume()"), this._sync.start(0));
  }, t.prototype.pause = function() {
    k.of(this._iid).logger.debug("message changelog sync pause()"), this._sync.stop();
  }, t.prototype.close = function() {
    this.ref--, this.ref <= 0 && (this.ref = 0, this.pause(), this._connectionEventContext.close(), delete Vr[this._iid][this._channel.url]);
  }, t;
}(), vs = {}, IT = function() {
  function t(n) {
    var e = n._iid, r = n.channel, i = n.hasPollMessage, s = this;
    this.ref = 0, this._iid = e, this._channel = r;
    var a, o, l = k.of(this._iid), c = l.logger, u = l.sdkState, d = l.dispatcher;
    this._metadataKey = (a = u.userId, o = r.url, "sendbird:".concat(a, "@groupchannel/").concat(o, "/poll/changelogs.meta"));
    var h = function(p, f) {
      return "sendbird:".concat(p, "@groupchannel/").concat(f, "/poll/changelogs");
    }(u.userId, this._channel.url);
    this._sync = new os(h, function() {
      return g(s, 0, void 0, function() {
        var p, f, m, v, E, y, b, T;
        return _(this, function(w) {
          switch (w.label) {
            case 0:
              return p = { hasNext: !0, nextToken: 0 }, [4, this.loadMetadata()];
            case 1:
              return w.sent(), c.debug("poll changelog sync from", (T = this._metadata) === null || T === void 0 ? void 0 : T.token), (f = !this._metadata || !this._metadata.token) ? [4, i()] : [3, 3];
            case 2:
              f = !w.sent(), w.label = 3;
            case 3:
              if (f)
                return [2, { hasNext: !1, nextToken: 0 }];
              this._metadata || (m = k.of(this._iid).firstConnectedAt, this._metadata = { token: m }), w.label = 4;
            case 4:
              return w.trys.push([4, 7, , 10]), [4, $l.of(this._iid).getPollChangeLogs(this._channel.url, this._channel.channelType, this._metadata.token)];
            case 5:
              return v = w.sent(), E = v.hasMore, y = v.token, p.hasNext = E, p.nextToken = y, this._metadata.token = y, c.debug("poll changelog sync progress", p), [4, this.saveMetadata()];
            case 6:
              return w.sent(), [3, 10];
            case 7:
              return b = w.sent(), c.debug("poll changelog sync error", b), b instanceof D && b.isInvalidTokenError ? [4, this.clearMetadata()] : [3, 9];
            case 8:
              w.sent(), w.label = 9;
            case 9:
              throw b;
            case 10:
              return [2, p];
          }
        });
      });
    }), this._connectionEventContext = d.on(function(p) {
      p instanceof Ar && (p.stateType === bt.CONNECTED ? s.resume() : s.pause());
    });
  }
  return t.of = function(n, e, r) {
    return vs[n] || (vs[n] = {}), vs[n][e.url] || (vs[n][e.url] = new t({ _iid: n, channel: e, hasPollMessage: r })), vs[n][e.url].ref++, vs[n][e.url];
  }, t.prototype.loadMetadata = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return this._metadata ? [3, 2] : [4, k.of(this._iid).cacheContext.preference.get(this._metadataKey)];
          case 1:
            n = e.sent(), this._metadata = n ? { token: n.token } : void 0, e.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, t.prototype.saveMetadata = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return this._metadata ? [4, k.of(this._iid).cacheContext.preference.set(this._metadataKey, this._metadata)] : [3, 2];
          case 1:
            n.sent(), n.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, t.prototype.clearMetadata = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, k.of(this._iid).cacheContext.preference.remove(this._metadataKey)];
          case 1:
            return n.sent(), this._metadata = void 0, [2];
        }
      });
    });
  }, t.prototype.resume = function() {
    k.of(this._iid).logger.debug("poll changelog sync resume()"), this._sync.start(0);
  }, t.prototype.pause = function() {
    k.of(this._iid).logger.debug("poll changelog sync pause()"), this._sync.stop();
  }, t.prototype.close = function() {
    this.ref--, this.ref <= 0 && (this.ref = 0, this.pause(), this._connectionEventContext.close(), delete vs[this._iid][this._channel.url]);
  }, t;
}(), AT = function(t) {
  function n(e) {
    var r, i, s, a, o, l, c, u, d, h, p = this;
    return (p = t.call(this) || this).method = Y.GET, p.path = "".concat(gt(e.channelType), "/").concat(e.channelUrl, "/messages_gap"), p.params = fe({ prev_start_ts: e.prevStart, prev_end_ts: e.prevEnd, prev_cache_count: e.prevCount, next_start_ts: e.nextStart, next_end_ts: e.nextEnd, next_cache_count: e.nextCount, huge_gap_threshold: (r = e.threshold) !== null && r !== void 0 ? r : null, reverse: !0, custom_types: (i = e.customTypes) !== null && i !== void 0 ? i : ["*"], message_type: (s = e.messageType) !== null && s !== void 0 ? s : null, include_reply_type: (a = e.replyType) !== null && a !== void 0 ? a : Fn.NONE, include_reactions: (o = e.includeReactions) === null || o === void 0 || o, include_meta_array: (l = e.includeMetaArray) === null || l === void 0 || l, include_thread_info: (c = e.includeThreadInfo) === null || c === void 0 || c, include_parent_message_info: (u = e.includeParentMessageInfo) === null || u === void 0 || u, with_sorted_meta_array: (d = e.includeMetaArray) === null || d === void 0 || d, show_subchannel_messages_only: (h = e.showSubchannelMessagesOnly) !== null && h !== void 0 && h, include_poll_details: !0, checking_continuous_messages: e.checkingContinuousMessages }), p;
  }
  return S(n, t), n;
}($), MT = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u = this;
    return (u = t.call(this, e, r) || this).isHugeGap = r.is_huge_gap, u.prevMessages = ((i = r.prev_messages) !== null && i !== void 0 ? i : []).map(function(d) {
      return Kn(e, d);
    }), u.prevHasMore = (s = r.prev_hasmore) !== null && s !== void 0 && s, u.isContinuousPrevMessages = (a = r.is_continuous_prev_messages) !== null && a !== void 0 && a, u.nextMessages = ((o = r.next_messages) !== null && o !== void 0 ? o : []).map(function(d) {
      return Kn(e, d);
    }), u.nextHasmore = (l = r.next_hasmore) !== null && l !== void 0 && l, u.isContinuousNextMessages = (c = r.is_continuous_next_messages) !== null && c !== void 0 && c, u;
  }
  return S(n, t), n;
}(ne), pf = { includeMetaArray: !0, includeReactions: !0, includeThreadInfo: !0, includeParentMessageInfo: !0 };
(oc || (oc = {})).CACHE_AND_REPLACE_BY_API = "cache_and_replace_by_api";
var _o, go, vo, xT = function() {
  function t() {
    this._onCacheResult = rt, this._onApiResult = rt;
  }
  return t.prototype._invokeResponse = function(n, e, r) {
    var i = this;
    Ue(function() {
      return g(i, 0, void 0, function() {
        return _(this, function(s) {
          switch (n) {
            case "local":
              this._onCacheResult(e, r);
              break;
            case "remote":
              this._onApiResult(e, r);
          }
          return [2];
        });
      });
    });
  }, t.prototype.onCacheResult = function(n) {
    return this._onCacheResult = n, this;
  }, t.prototype.onApiResult = function(n) {
    return this._onApiResult = n, this;
  }, t;
}(), kT = function() {
  function t(n, e) {
    var r = e.filter, i = e.startingPoint, s = e.limit, a = e.prevResultLimit, o = e.nextResultLimit, l = e.channel, c = e.channelManager, u = e.disableBackgroundSync, d = u !== void 0 && u, h = this;
    this._messages = [], this._unsentMessages = [], this._isLoadingPrevious = !1, this._isLoadingNext = !1, this._iid = n, this._key = "mc-".concat(Pi()), this._isDisposed = !1, this.filter = r ?? new Fi(), this._channel = l, this._syncRange = new ci({}), this._hasPrevious = !0, this._hasNext = !0, this._startingPoint = typeof i == "number" && Number.isFinite(i) ? i : Number.MAX_SAFE_INTEGER, this._limit = s || 100, this._prevResultLimit = a ?? Math.floor(this._limit / 2), this._nextResultLimit = o ?? Math.floor(this._limit / 2), this._channelManager = c;
    var p = k.of(this._iid).statManager;
    this._channelManager.subscribeChannelEvent(this._key, { onUpdate: function(y, b) {
      var T = b.source, w = y.findIndex(function(N) {
        return N.isIdentical(h.channel);
      });
      w >= 0 && (h._replaceChannelOfCollection(y[w]), h.channel._runIfHandleableWithGroupChannel(function(N) {
        switch (T) {
          case B.EVENT_CHANNEL_UPDATED:
            for (var M = !1, I = 0; I < h._messages.length; I++)
              if (h._messages[I].createdAt >= N.messageOffsetTimestamp) {
                M = !0;
                var x = I;
                if (x > 0) {
                  var R = h._messages.splice(0, x);
                  h._removeMessagesFromView(R.map(function(P) {
                    return h.keyOf(P);
                  }), B.EVENT_MESSAGE_OFFSET_UPDATED);
                }
                break;
              }
            !M && h._messages.length > 0 && h._removeMessagesFromView(h._messages.map(function(P) {
              return h.keyOf(P);
            }), B.EVENT_MESSAGE_OFFSET_UPDATED);
            break;
          case B.EVENT_CHANNEL_UNMUTED:
            var L = k.of(h._iid).sdkState, j = b.user;
            L.userId === j.userId && h._clearCheckMyMutedTimer();
            break;
          case B.EVENT_CHANNEL_MUTED:
            L = k.of(h._iid).sdkState, j = b.user, L.userId === j.userId && N._myMutedRemainingTime !== -1 && h._startCheckMyMutedTimer(N._myMutedRemainingTime);
            break;
          case B.EVENT_CHANNEL_LEFT:
            N.isPublic && h._clearCheckMyMutedTimer();
        }
        Ue(function() {
          return g(h, 0, void 0, function() {
            var P;
            return _(this, function(q) {
              return xl(T) && (!((P = this._handler) === null || P === void 0) && P.onChannelUpdated) && this._handler.onChannelUpdated(b, this.channel), [2];
            });
          });
        });
      }), h._postprocessChannelUpdateEvent(y[w], T));
    }, onRemove: function(y, b) {
      var T = y.indexOf(h.channel.url);
      T >= 0 && (h._clearCheckMyMutedTimer(), Ue(function() {
        return g(h, 0, void 0, function() {
          var w;
          return _(this, function(N) {
            return !((w = this._handler) === null || w === void 0) && w.onChannelDeleted && this._handler.onChannelDeleted(b, this.channel.url), [2];
          });
        });
      }), h._postprocessChannelRemoveEvent(y[T]));
    } }), this._channelManager.subscribeMessageEvent(this._key, { onUpdate: function(y, b) {
      var T, w, N = [], M = [];
      try {
        for (var I = de(y), x = I.next(); !x.done; x = I.next()) {
          var R = x.value;
          R.channelUrl === h._channel.url && (h.filter.match(R) ? N.push(R) : M.push(h.keyOf(R)));
        }
      } catch (L) {
        T = { error: L };
      } finally {
        try {
          x && !x.done && (w = I.return) && w.call(I);
        } finally {
          if (T)
            throw T.error;
        }
      }
      if (Si(b)) {
        if (N.length > 0)
          switch (b) {
            case B.LOCAL_MESSAGE_CANCELED:
            case B.LOCAL_MESSAGE_RESEND_STARTED:
            case B.EVENT_MESSAGE_SENT_FAILED:
            case B.EVENT_MESSAGE_SENT_SUCCESS:
            case B.EVENT_MESSAGE_UPDATED:
            case B.EVENT_MESSAGE_THREADINFO_UPDATED:
            case B.EVENT_MESSAGE_REACTION_UPDATED:
            case B.EVENT_MESSAGE_FEEDBACK_ADDED:
            case B.EVENT_MESSAGE_FEEDBACK_UPDATED:
            case B.EVENT_MESSAGE_FEEDBACK_DELETED:
            case B.SYNC_MESSAGE_CHANGELOGS:
              h._updateMessagesToView(N, b);
              break;
            case B.EVENT_MESSAGE_SENT_PENDING:
              h._addMessagesToView(N, b);
              break;
            case B.EVENT_MESSAGE_RECEIVED:
              h.hasNext || h._addMessagesToView(N, b);
              break;
            case B.SYNC_MESSAGE_FILL:
              h._addMessagesToView(N, b);
          }
        M.length > 0 && h._removeMessagesFromView(M, b);
      }
      h._postprocessMessageUpdateEvent(y, b);
    }, onRemove: function(y, b) {
      h._removeMessagesFromView(y, b), h._postprocessMessageRemoveEvent(y);
    }, onRemoveUnsent: function(y, b) {
      h._removeUnsentMessageFromView(y, b);
    }, onPollChangeLogUpdate: function(y, b) {
      h._updatePollsToView(y, b);
    }, onPollUpdate: function(y, b) {
      h._applyPollUpdateEventToView(y, b);
    }, onPollVote: function(y, b) {
      h._applyPollVoteEventToView(y, b);
    }, onReactionUpdate: function(y, b) {
      h._applyReactionEventToView(y, b);
    }, onThreadInfoUpdate: function(y, b) {
      h._applyThreadInfoEventToView(y, b);
    } });
    var f = k.of(this._iid), m = f.cacheContext, v = f.dispatcher, E = f.messageBackgroundSyncThrottleController;
    this._channel._updateMessageCollectionLastAccessedAt(), v.dispatch(new it({ channels: [this._channel], context: { source: B.CHANNEL_LASTACCESSEDAT_UPDATED } })), this._backgroundSync = ST.of(this._iid, this._channel), !d && this._shouldStartBackgroundSync() && this._backgroundSync.resume(this._startingPoint), this._changelogSync = NT.of(this._iid, this._channel, this.changelogIncludeParams), this._changelogSync.resume(), this._pollChangelogSync = IT.of(this._iid, this._channel, this._hasPollMessage.bind(this)), this._pollChangelogSync.resume(), this._prevFill = new os(this._key, function(y) {
      return g(h, 0, void 0, function() {
        var b = this;
        return _(this, function(T) {
          switch (T.label) {
            case 0:
              return [4, E.run("message-fill-sync-".concat(l.url, "-prev"), function() {
                return g(b, 0, void 0, function() {
                  var w, N, M, I, x, R, L;
                  return _(this, function(j) {
                    switch (j.label) {
                      case 0:
                        return [4, this._getRemoteMessages(y, { prevLimit: this._prevResultLimit, source: B.SYNC_MESSAGE_FILL, checkingContinuousMessages: m.localCacheEnabled })];
                      case 1:
                        return w = j.sent(), N = w.messages, M = w.isContinuousMessages, N.length > 0 ? (I = Math.min.apply(Math, Re([], we(N.map(function(P) {
                          return P.createdAt;
                        })), !1)), this._syncRange.extends(I), M && ((x = this._backgroundSync) === null || x === void 0 || x.range.extends(I)), [2, { hasNext: N.length >= this._prevResultLimit && this.viewTop < I, nextToken: this._syncRange.top }]) : (m.localCacheEnabled && p.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: this.channel.url, measured_on: "gap_check", event: "cache_fetch", max_db_size: (L = (R = m.localCacheConfig) === null || R === void 0 ? void 0 : R.maxSize) !== null && L !== void 0 ? L : 0, use_local_cache: m.localCacheEnabled, starting_point: 0, message_init_policy: "" } })), [2, { hasNext: !1, nextToken: 0 }]);
                    }
                  });
                });
              })];
            case 1:
              return [2, T.sent()];
          }
        });
      });
    }), this._nextFill = new os(this._key, function(y) {
      return g(h, 0, void 0, function() {
        var b = this;
        return _(this, function(T) {
          switch (T.label) {
            case 0:
              return [4, E.run("message-fill-sync-".concat(l.url, "-next"), function() {
                return g(b, 0, void 0, function() {
                  var w, N, M, I, x, R, L;
                  return _(this, function(j) {
                    switch (j.label) {
                      case 0:
                        return [4, this._getRemoteMessages(y, { nextLimit: this._nextResultLimit, source: B.SYNC_MESSAGE_FILL, checkingContinuousMessages: m.localCacheEnabled })];
                      case 1:
                        return w = j.sent(), N = w.messages, M = w.isContinuousMessages, N.length > 0 ? (I = Math.max.apply(Math, Re([], we(N.map(function(P) {
                          return P.createdAt;
                        })), !1)), this._syncRange.extends(I), M && ((x = this._backgroundSync) === null || x === void 0 || x.range.extends(I)), [2, { hasNext: !(N.length >= this._nextResultLimit && this._hasNext) || this.viewBottom > I, nextToken: this._syncRange.bottom }]) : (m.localCacheEnabled && p.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: this.channel.url, measured_on: "gap_check", event: "cache_fetch", max_db_size: (L = (R = m.localCacheConfig) === null || R === void 0 ? void 0 : R.maxSize) !== null && L !== void 0 ? L : 0, use_local_cache: m.localCacheEnabled, starting_point: 0, message_init_policy: "" } })), [2, { hasNext: !1, nextToken: 0 }]);
                    }
                  });
                });
              })];
            case 1:
              return [2, T.sent()];
          }
        });
      });
    }), this._connectionEventContext = v.on(function(y) {
      if (y instanceof Ar)
        switch (y.stateType) {
          case bt.CONNECTED:
            tn(function() {
              return g(h, 0, void 0, function() {
                return _(this, function(b) {
                  return this._activate(), [2];
                });
              });
            });
            break;
          case bt.LOGOUT:
            h.dispose();
            break;
          default:
            h._clearCheckMyMutedTimer(), h._prevFill.stop(), h._nextFill.stop();
        }
    });
  }
  return t.prototype.keyOf = function(n) {
    return 0;
  }, Object.defineProperty(t.prototype, "changelogIncludeParams", { get: function() {
    return { includeReactions: !0, includeThreadInfo: !0, includeMetaArray: !0, includeParentMessageInfo: !0 };
  }, enumerable: !1, configurable: !0 }), t.prototype._postprocessChannelUpdateEvent = function(n, e) {
  }, t.prototype._postprocessChannelRemoveEvent = function(n) {
  }, t.prototype._postprocessMessageUpdateEvent = function(n, e) {
  }, t.prototype._postprocessMessageRemoveEvent = function(n) {
  }, Object.defineProperty(t.prototype, "channel", { get: function() {
    return this._channel;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "succeededMessages", { get: function() {
    return Re([], we(this._messages), !1);
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "failedMessages", { get: function() {
    return this._unsentMessages.filter(function(n) {
      return n.sendingStatus === St.FAILED;
    });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "pendingMessages", { get: function() {
    return this._unsentMessages.filter(function(n) {
      return n.sendingStatus === St.PENDING;
    });
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "hasPrevious", { get: function() {
    return this._hasPrevious;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "hasNext", { get: function() {
    return this._hasNext;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "viewTop", { get: function() {
    return Math.min.apply(Math, Re(Re([], we(this._messages.map(function(n) {
      return n.createdAt;
    })), !1), [Number.MAX_SAFE_INTEGER], !1));
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "viewBottom", { get: function() {
    return Math.max.apply(Math, Re(Re([], we(this._messages.map(function(n) {
      return n.createdAt;
    })), !1), [0], !1));
  }, enumerable: !1, configurable: !0 }), t.prototype._activate = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return k.of(this._iid).logger.debug("check huge gap"), this._checkHugeGap(), [4, this._refreshChannel(B.SYNC_CHANNEL_CHANGELOGS)];
          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, t.prototype._replaceChannelOfCollection = function(n) {
    this._channel.isGroupChannel() ? this._channel = n : this._channel.isFeedChannel() && (this._channel._groupChannel = n._groupChannel);
  }, t.prototype._shouldStartBackgroundSync = function() {
    var n = k.of(this._iid).cacheContext;
    return this.channel.isGroupChannel() ? n.localCacheEnabled && !this.channel.isSuper : n.localCacheEnabled;
  }, t.prototype._setBaseMessageCollectionHandler = function(n) {
    this._handler = n;
  }, t.prototype._filterUnderOffsetMessage = function(n) {
    return n;
  }, t.prototype._updateChildMessagesInView = function(n) {
    var e = [];
    return this._messages.forEach(function(r) {
      r instanceof Vn && r.parentMessageId === n.messageId && r.applyParentMessage(n) && e.push(r);
    }), e;
  }, t.prototype._updatePollsToView = function(n, e) {
    var r, i, s = this, a = [];
    try {
      for (var o = de(n), l = o.next(); !l.done; l = o.next()) {
        var c = l.value, u = Oa(this._messages, c.messageId);
        if (u >= 0) {
          var d = this._messages[u];
          d.isUserMessage() && d.applyPoll(c), a.push(d);
        }
      }
    } catch (h) {
      r = { error: h };
    } finally {
      try {
        l && !l.done && (i = o.return) && i.call(o);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return a.length > 0 && Si(e) && Ue(function() {
      return g(s, 0, void 0, function() {
        var h, p, f;
        return _(this, function(m) {
          return h = { source: e }, a.length > 0 && ((f = (p = this._handler).onMessagesUpdated) === null || f === void 0 || f.call(p, h, this.channel, a)), [2];
        });
      });
    }), a;
  }, t.prototype._applyPollUpdateEventToView = function(n, e) {
    var r = this, i = Oa(this._messages, n.messageId);
    if (i >= 0) {
      var s = this._messages[i];
      s && s.isUserMessage() && s.poll && s.poll.applyPollUpdateEvent(n) && Si(e) && Ue(function() {
        return g(r, 0, void 0, function() {
          var a, o, l;
          return _(this, function(c) {
            return a = { source: e }, (l = (o = this._handler) === null || o === void 0 ? void 0 : o.onMessagesUpdated) === null || l === void 0 || l.call(o, a, this.channel, [s]), [2];
          });
        });
      });
    }
  }, t.prototype._applyPollVoteEventToView = function(n, e) {
    var r = this, i = Oa(this._messages, n.messageId);
    if (i >= 0) {
      var s = this._messages[i];
      s && s.isUserMessage() && s.poll && s.poll.applyPollVoteEvent(n) && Si(e) && Ue(function() {
        return g(r, 0, void 0, function() {
          var a, o, l;
          return _(this, function(c) {
            return a = { source: e }, (l = (o = this._handler) === null || o === void 0 ? void 0 : o.onMessagesUpdated) === null || l === void 0 || l.call(o, a, this.channel, [s]), [2];
          });
        });
      });
    }
  }, t.prototype._applyReactionEventToView = function(n, e) {
    var r = this, i = Oa(this._messages, n.messageId);
    if (i >= 0) {
      var s = this._messages[i];
      s && (s.isUserMessage() || s.isFileMessage() || s.isMultipleFilesMessage()) && Si(e) && (s.applyReactionEvent(n), Ue(function() {
        return g(r, 0, void 0, function() {
          var a, o, l;
          return _(this, function(c) {
            return a = { source: e }, (l = (o = this._handler) === null || o === void 0 ? void 0 : o.onMessagesUpdated) === null || l === void 0 || l.call(o, a, this.channel, [s]), [2];
          });
        });
      }));
    }
  }, t.prototype._applyThreadInfoEventToView = function(n, e) {
    var r = this, i = Oa(this._messages, n.targetMessageId);
    if (i >= 0) {
      var s = this._messages[i];
      s && (s.isUserMessage() || s.isFileMessage() || s.isMultipleFilesMessage()) && Si(e) && (s.applyThreadInfoUpdateEvent(n), Ue(function() {
        return g(r, 0, void 0, function() {
          var a, o, l;
          return _(this, function(c) {
            return a = { source: e }, (l = (o = this._handler) === null || o === void 0 ? void 0 : o.onMessagesUpdated) === null || l === void 0 || l.call(o, a, this.channel, [s]), [2];
          });
        });
      }));
    }
  }, t.prototype._removeMessagesFromView = function(n, e) {
    var r, i, s = this, a = [], o = [], l = function(h) {
      var p = c._messages.findIndex(function(m) {
        return s.keyOf(m) === h;
      });
      if (p >= 0) {
        var f = c._messages[p];
        a.push(c.keyOf(f)), o.push(f), c._messages.splice(p, 1);
      }
    }, c = this;
    try {
      for (var u = de(n), d = u.next(); !d.done; d = u.next())
        l(d.value);
    } catch (h) {
      r = { error: h };
    } finally {
      try {
        d && !d.done && (i = u.return) && i.call(u);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return Si(e) && o.length > 0 && Ue(function() {
      return g(s, 0, void 0, function() {
        var h, p, f;
        return _(this, function(m) {
          return h = { source: e }, (f = (p = this._handler) === null || p === void 0 ? void 0 : p.onMessagesDeleted) === null || f === void 0 || f.call(p, h, this.channel, a, o), [2];
        });
      });
    }), a;
  }, t.prototype._removeUnsentMessageFromView = function(n, e) {
    var r = this._unsentMessages.findIndex(function(i) {
      return i.reqId === n;
    });
    r >= 0 && this._unsentMessages.splice(r, 1);
  }, t.prototype._getLocalMessages = function(n, e) {
    var r = e.prevLimit, i = r === void 0 ? 0 : r, s = e.nextLimit, a = s === void 0 ? 0 : s, o = e.inclusive, l = o === void 0 || o;
    return g(this, 0, void 0, function() {
      var c, u, d, h, p;
      return _(this, function(f) {
        switch (f.label) {
          case 0:
            return c = [], l ? [4, this._channelManager.getExactlyMatchingMessagesForTokenFromCache(this._channel.url, n, this.filter)] : [3, 2];
          case 1:
            c = f.sent(), f.label = 2;
          case 2:
            return i > 0 ? [4, this._channelManager.getMessagesFromCache(this._channel.url, n, "prev", this.filter, i, !1)] : [3, 4];
          case 3:
            return d = f.sent(), [3, 5];
          case 4:
            d = [], f.label = 5;
          case 5:
            return u = d, a > 0 ? [4, this._channelManager.getMessagesFromCache(this._channel.url, n, "next", this.filter, a, !1)] : [3, 7];
          case 6:
            return p = f.sent(), [3, 8];
          case 7:
            p = [], f.label = 8;
          case 8:
            return h = p, [2, { messages: Re(Re(Re([], we(c), !1), we(u), !1), we(h), !1).sort(function(m, v) {
              return v.createdAt - m.createdAt;
            }), prevMessagesCount: u.length, nextMessagesCount: h.length }];
        }
      });
    });
  }, t.prototype._getRemoteMessages = function(n, e) {
    var r = e.prevLimit, i = r === void 0 ? 0 : r, s = e.nextLimit, a = s === void 0 ? 0 : s, o = e.source, l = o === void 0 ? B.REQUEST_MESSAGE : o, c = e.reverse, u = c !== void 0 && c, d = e.checkingHasNext, h = d !== void 0 && d, p = e.checkingContinuousMessages, f = p !== void 0 && p;
    return g(this, 0, void 0, function() {
      var m, v;
      return _(this, function(E) {
        switch (E.label) {
          case 0:
            return m = bn.of(this._iid), i > 0 || a > 0 ? [4, m._getMessagesByTimestampForCollection(this._channel.url, this._channel.channelType, n, Ae(A(A(A({}, this.filter), pf), { isInclusive: !0, reverse: u, prevResultSize: i, nextResultSize: a })), l, h, f)] : [3, 2];
          case 1:
            return v = E.sent(), [3, 3];
          case 2:
            v = { messages: [], isContinuousMessages: !1 }, E.label = 3;
          case 3:
            return [2, v];
        }
      });
    });
  }, t.prototype._checkHugeGap = function() {
    var n, e, r, i, s;
    return g(this, 0, void 0, function() {
      var a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M, I, x, R, L, j, P, q, G = this;
      return _(this, function(X) {
        switch (X.label) {
          case 0:
            return a = k.of(this._iid), o = a.dispatcher, l = a.requestQueue, c = a.cacheContext, u = a.statManager, d = a.logger, this._messages.length > 0 ? (h = this._syncRange.top, p = this.viewTop, f = this._syncRange.bottom, m = this.hasNext ? this.viewBottom : Number.MAX_SAFE_INTEGER, [4, this._channelManager.getCachedMessageCountBetween(this._channel.url, this.filter, p, h)]) : [3, 8];
          case 1:
            return v = X.sent(), [4, this._channelManager.getCachedMessageCountBetween(this._channel.url, this.filter, f, m)];
          case 2:
            E = X.sent(), X.label = 3;
          case 3:
            return X.trys.push([3, 5, 6, 7]), [4, yc(function() {
              return g(G, 0, void 0, function() {
                var Ce, Be, se, Ee, ee, ge, ve, H, oe, J, Me, V, ie, ae, ce, le, re, te = this;
                return _(this, function(Te) {
                  switch (Te.label) {
                    case 0:
                      return Ce = new AT(A(A({ channelUrl: this._channel.url, channelType: this._channel.channelType, prevStart: p, prevEnd: h, prevCount: v, nextStart: f, nextEnd: m, nextCount: E, checkingContinuousMessages: c.localCacheEnabled }, this.filter), pf)), [4, l.send(Ce)];
                    case 1:
                      return Be = Te.sent(), se = Be.as(MT), Ee = se.isHugeGap, ee = se.prevMessages, ge = ee === void 0 ? [] : ee, ve = se.prevHasMore, H = se.isContinuousPrevMessages, oe = se.nextMessages, J = oe === void 0 ? [] : oe, Me = se.nextHasmore, V = se.isContinuousNextMessages, Ee ? Ue(function() {
                        return g(te, 0, void 0, function() {
                          var ke;
                          return _(this, function(he) {
                            return !((ke = this._handler) === null || ke === void 0) && ke.onHugeGapDetected && this._handler.onHugeGapDetected(), [2];
                          });
                        });
                      }) : (ie = this.viewTop, ae = this.viewBottom, ce = Math.min.apply(Math, Re([Number.MAX_SAFE_INTEGER, ie], we(ge.map(function(ke) {
                        return ke.createdAt;
                      })), !1)), le = Math.max.apply(Math, Re([0, ae], we(J.map(function(ke) {
                        return ke.createdAt;
                      })), !1)), o.dispatch(new Pt({ messages: ge, source: B.SYNC_MESSAGE_FILL })), o.dispatch(new Pt({ messages: J, source: B.SYNC_MESSAGE_FILL })), this._syncRange.extends(ce, le), (H || V) && ((re = this._backgroundSync) === null || re === void 0 || re.range.extends(ce, le)), ve && this._prevFill.start(ce), Me && this._nextFill.start(le)), [2];
                  }
                });
              });
            }, 1)];
          case 4:
            return X.sent(), [3, 7];
          case 5:
            return y = X.sent(), d.debug("Failed HugeGap Check ", y), [3, 7];
          case 6:
            return c.localCacheEnabled && u.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: this.channel.url, measured_on: "gap_check", event: "cache_fetch", max_db_size: (e = (n = c.localCacheConfig) === null || n === void 0 ? void 0 : n.maxSize) !== null && e !== void 0 ? e : 0, use_local_cache: c.localCacheEnabled, starting_point: 0, message_init_policy: "" } })), [7];
          case 7:
            return [3, 13];
          case 8:
            b = Date.now(), X.label = 9;
          case 9:
            return X.trys.push([9, 11, 12, 13]), [4, this._getRemoteMessages(b, { prevLimit: this._prevResultLimit, nextLimit: this._nextResultLimit, source: B.SYNC_MESSAGE_FILL, checkingHasNext: !0, checkingContinuousMessages: c.localCacheEnabled })];
          case 10:
            if (T = X.sent(), w = T.messages, N = T.isContinuousMessages, M = T.hasNext, w.length > 0) {
              for (I = w.map(function(Ce) {
                return Ce.createdAt;
              }), x = 0, R = 0, L = 0; L < I.length; L++)
                (j = I[L]) <= b ? x++ : j >= b && R++;
              this._hasPrevious = x >= this._prevResultLimit, this._hasNext = M ?? R >= this._nextResultLimit, (q = this._syncRange).extends.apply(q, Re([], we(I), !1)), N && ((r = this._backgroundSync) === null || r === void 0 || r.range.extends(this._syncRange.top, this._syncRange.bottom)), this._addMessagesToView(w, B.SYNC_MESSAGE_FILL);
            } else
              this._hasPrevious = !1, this._hasNext = !1;
            return [3, 13];
          case 11:
            return (P = X.sent()) instanceof D && P.code === me.NOT_FOUND_IN_DATABASE && (this._hasPrevious = !1, this._hasNext = !1), [3, 13];
          case 12:
            return c.localCacheEnabled && u.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: this.channel.url, measured_on: "gap_check", event: "cache_fetch", max_db_size: (s = (i = c.localCacheConfig) === null || i === void 0 ? void 0 : i.maxSize) !== null && s !== void 0 ? s : 0, use_local_cache: c.localCacheEnabled, starting_point: 0, message_init_policy: "" } })), [7];
          case 13:
            return [2];
        }
      });
    });
  }, t.prototype._loadUnsentMessages = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return n = this, [4, this._channelManager.getUnsentMessagesFromCache(this._channel.url, this.filter)];
          case 1:
            return n._unsentMessages = e.sent(), [2];
        }
      });
    });
  }, t.prototype._hasPollMessage = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, this._channelManager.getPollMessagesFromCache(this._channel.url, Date.now() + 6e5, this.filter, 1)];
          case 1:
            return n.sent().length > 0 ? [2, !0] : [2, !1];
        }
      });
    });
  }, t.prototype._refreshChannel = function(n, e) {
    return e === void 0 && (e = !1), g(this, 0, void 0, function() {
      var r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            r = k.of(this._iid).logger, s.label = 1;
          case 1:
            return s.trys.push([1, 3, , 4]), [4, this._channelManager.refreshChannel(this.channel.url, !0, n, e)];
          case 2:
            return s.sent(), [3, 4];
          case 3:
            return i = s.sent(), r.warn("Failed to refresh channel", i), [3, 4];
          case 4:
            return [2];
        }
      });
    });
  }, t.prototype._startCheckMyMutedTimer = function(n) {
    var e = this;
    this._clearCheckMyMutedTimer(), this._checkMyMutedStateTimer = setTimeout(function() {
      return g(e, 0, void 0, function() {
        var r, i, s, a = this;
        return _(this, function(o) {
          switch (o.label) {
            case 0:
              this._checkMyMutedStateTimer = void 0, r = !0, o.label = 1;
            case 1:
              return o.trys.push([1, 3, 4, 5]), [4, this._channel.getMyMutedInfo()];
            case 2:
              return i = o.sent(), r = !i.isMuted, [3, 5];
            case 3:
              return o.sent(), r = !0, [3, 5];
            case 4:
              return r && (s = k.of(this._iid).sessionManager, this.channel._runIfHandleableWithGroupChannel(function(l) {
                var c, u;
                l.myMutedState = ai.UNMUTED;
                var d = { source: B.EVENT_CHANNEL_UNMUTED, user: s.currentUser };
                (u = (c = a._handler) === null || c === void 0 ? void 0 : c.onChannelUpdated) === null || u === void 0 || u.call(c, d, a.channel);
              })), [7];
            case 5:
              return [2];
          }
        });
      });
    }, n + 1e3);
  }, t.prototype._clearCheckMyMutedTimer = function() {
    this._checkMyMutedStateTimer && (clearTimeout(this._checkMyMutedStateTimer), this._checkMyMutedStateTimer = void 0);
  }, t.prototype._setHasNextAndHasPrevious = function(n, e) {
    for (var r = n.map(function(l) {
      return l.createdAt;
    }), i = 0, s = 0, a = 0; a < r.length; a++) {
      var o = r[a];
      o < this._startingPoint ? i++ : o > this._startingPoint && s++;
    }
    this._hasPrevious = i >= this._prevResultLimit, this._hasNext = e ?? s >= this._nextResultLimit;
  }, t.prototype.initialize = function(n) {
    var e = this, r = new xT();
    this._messages = [], this._unsentMessages = [], this._syncRange = new ci({}), this._hasNext = !0, this._hasPrevious = !0;
    var i = [], s = { messages: [], prevMessagesCount: 0, nextMessagesCount: 0 };
    return Ue(function() {
      return g(e, 0, void 0, function() {
        var a, o, l, c, u, d = this;
        return _(this, function(h) {
          switch (h.label) {
            case 0:
              return [4, (u = this._backgroundSync) === null || u === void 0 ? void 0 : u.loadMetadata()];
            case 1:
              return a = h.sent(), o = k.of(this._iid), l = o.cacheContext, c = o.statManager, n === oc.CACHE_AND_REPLACE_BY_API && this._getLocalMessages(this._startingPoint, { prevLimit: this._prevResultLimit, nextLimit: this._nextResultLimit }).then(function(p) {
                return g(d, 0, void 0, function() {
                  return _(this, function(f) {
                    switch (f.label) {
                      case 0:
                        return s = p, i = this._filterUnderOffsetMessage(s.messages), this._addMessagesToView(i, B.REQUEST_MESSAGE), [4, this._loadUnsentMessages()];
                      case 1:
                        return f.sent(), r._invokeResponse("local", null, i), [2];
                    }
                  });
                });
              }).catch(function(p) {
                if (rr(p))
                  throw p;
                r._invokeResponse("local", p, null);
              }).finally(function() {
                return g(d, 0, void 0, function() {
                  var p, f, m, v, E, y, b, T = this;
                  return _(this, function(w) {
                    switch (w.label) {
                      case 0:
                        return p = k.of(this._iid).cacheContext, f = !0, m = !0, v = !1, p.localCacheEnabled && i.length > 0 && (E = a.range).includes.apply(E, Re([], we(i.map(function(N) {
                          return N.createdAt;
                        })), !1)) && (!a.previousComplete && s.prevMessagesCount < this._prevResultLimit ? m = !0 : this._startingPoint > a.range.bottom || s.nextMessagesCount < this._nextResultLimit ? v = !0 : m = !1), [4, this._refreshChannel(B.REFRESH_CHANNEL, v)];
                      case 1:
                        return w.sent(), v && this._channel._runIfHandleableWithGroupChannel(function(N) {
                          var M = Math.max.apply(Math, Re([], we(i.map(function(I) {
                            return I.createdAt;
                          })), !1));
                          N._latestMessageInfo && M >= N._latestMessageInfo.createdAt && (m = !1);
                        }), m ? (f = !1, this._getRemoteMessages(this._startingPoint, { prevLimit: this._prevResultLimit, nextLimit: this._nextResultLimit, reverse: !0, checkingHasNext: !0, checkingContinuousMessages: p.localCacheEnabled }).then(function(N) {
                          var M, I, x, R = N.messages, L = N.isContinuousMessages, j = N.hasNext, P = T._filterUnderOffsetMessage(R);
                          T._messages = [], P.length > 0 ? (T._setHasNextAndHasPrevious(P, j), (M = T._syncRange).extends.apply(M, Re([], we(P.map(function(q) {
                            return q.createdAt;
                          })), !1)), L && (!((I = T._backgroundSync) === null || I === void 0) && I.range.overlap(T._syncRange)) && ((x = T._backgroundSync) === null || x === void 0 || x.range.extends(T._syncRange.top, T._syncRange.bottom)), T._addMessagesToView(P, B.REQUEST_MESSAGE)) : (T._hasPrevious = !1, T._hasNext = !1), r._invokeResponse("remote", null, P);
                        }).catch(function(N) {
                          if (rr(N))
                            throw N;
                          r._invokeResponse("remote", N, null);
                        })) : (this._setHasNextAndHasPrevious(i), r._invokeResponse("remote", null, i)), p.localCacheEnabled && c.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: this.channel.url, starting_point: this._startingPoint, measured_on: "initial_load", event: f ? "cache_hit" : "cache_miss", max_db_size: (b = (y = p.localCacheConfig) === null || y === void 0 ? void 0 : y.maxSize) !== null && b !== void 0 ? b : 0, message_init_policy: n, use_local_cache: p.localCacheEnabled, collection_id: this._key } })), [2];
                    }
                  });
                });
              }), c.put(new No({ type: Ft.FEATURE_LOCALCACHE, data: { use_local_cache: l.localCacheEnabled, collection_interface: { message_init_policy: n, message: !0 } } })), [2];
          }
        });
      });
    }), r;
  }, t.prototype.loadPrevious = function() {
    var n, e, r;
    return g(this, 0, void 0, function() {
      var i, s, a, o, l, c, u, d, h = this;
      return _(this, function(p) {
        switch (p.label) {
          case 0:
            if (this._isDisposed)
              throw new D({ code: me.COLLECTION_DISPOSED, message: "Collection has been disposed." });
            return i = k.of(this._iid), s = i.cacheContext, a = i.statManager, o = i.logger, this._hasPrevious ? this._isLoadingPrevious ? (o.warn("Messages are already fetching."), [2, []]) : (this._isLoadingPrevious = !0, l = this.viewTop, c = [], [4, tn(function() {
              return g(h, 0, void 0, function() {
                var f;
                return _(this, function(m) {
                  switch (m.label) {
                    case 0:
                      return [4, this._getLocalMessages(l, { prevLimit: this._prevResultLimit, inclusive: !1 })];
                    case 1:
                      return f = m.sent(), c = this._filterUnderOffsetMessage(f.messages), [2];
                  }
                });
              });
            })]) : [2, []];
          case 1:
            return p.sent(), u = c.length >= this._prevResultLimit, s.localCacheEnabled && a.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: this.channel.url, starting_point: this._startingPoint, measured_on: "load_prev", event: u ? "cache_hit" : "cache_miss", max_db_size: (e = (n = s.localCacheConfig) === null || n === void 0 ? void 0 : n.maxSize) !== null && e !== void 0 ? e : 0, use_local_cache: s.localCacheEnabled, collection_id: this._key, message_init_policy: "" } })), u && (!((r = this._backgroundSync) === null || r === void 0) && r.isWrappingMessages(c)) ? [3, 3] : (d = !1, [4, tn(function() {
              return g(h, 0, void 0, function() {
                var f, m, v, E, y, b, T, w = this;
                return _(this, function(N) {
                  switch (N.label) {
                    case 0:
                      return f = k.of(this._iid).cacheContext, [4, this._getRemoteMessages(l, { prevLimit: this._prevResultLimit, reverse: !0, checkingContinuousMessages: f.localCacheEnabled })];
                    case 1:
                      return m = N.sent(), (c = this._filterUnderOffsetMessage(m.messages)).length > 0 && ((v = this._syncRange).extends.apply(v, Re([], we(c.map(function(M) {
                        return M.createdAt;
                      })), !1)), !((E = this._backgroundSync) === null || E === void 0) && E.range.overlap(this._syncRange) && m.isContinuousMessages && (d = !0, (y = this._backgroundSync) === null || y === void 0 || y.range.extends(this._syncRange.top))), c = c.filter(function(M) {
                        return _r(w._messages, M) < 0;
                      }), this._hasPrevious = c.length >= this._prevResultLimit, d && a.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: this.channel.url, starting_point: this._startingPoint, measured_on: "load_prev", event: "cache_fetch", max_db_size: (T = (b = f.localCacheConfig) === null || b === void 0 ? void 0 : b.maxSize) !== null && T !== void 0 ? T : 0, use_local_cache: f.localCacheEnabled, collection_id: this._key, message_init_policy: "" } })), [2];
                  }
                });
              });
            })]);
          case 2:
            return p.sent(), this._addMessagesToView(c, B.REQUEST_MESSAGE), [3, 4];
          case 3:
            this._hasPrevious = c.length >= this._prevResultLimit, c.length > 0 && this._addMessagesToView(c, B.REQUEST_MESSAGE), p.label = 4;
          case 4:
            return this._isLoadingPrevious = !1, [2, c];
        }
      });
    });
  }, t.prototype.loadNext = function() {
    var n, e, r;
    return g(this, 0, void 0, function() {
      var i, s, a, o, l, c, u, d, h = this;
      return _(this, function(p) {
        switch (p.label) {
          case 0:
            if (this._isDisposed)
              throw new D({ code: me.COLLECTION_DISPOSED, message: "Collection has been disposed." });
            return i = k.of(this._iid), s = i.cacheContext, a = i.statManager, o = i.logger, this._hasNext ? this._isLoadingNext ? (o.warn("Messages are already fetching."), [2, []]) : (this._isLoadingNext = !0, l = this.viewBottom, c = [], [4, tn(function() {
              return g(h, 0, void 0, function() {
                var f;
                return _(this, function(m) {
                  switch (m.label) {
                    case 0:
                      return [4, this._getLocalMessages(l, { nextLimit: this._nextResultLimit, inclusive: !1 })];
                    case 1:
                      return f = m.sent(), c = this._filterUnderOffsetMessage(f.messages), [2];
                  }
                });
              });
            })]) : [2, []];
          case 1:
            return p.sent(), u = c.length >= this._nextResultLimit, s.localCacheEnabled && a.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: this.channel.url, starting_point: this._startingPoint, measured_on: "load_next", event: u ? "cache_hit" : "cache_miss", max_db_size: (e = (n = s.localCacheConfig) === null || n === void 0 ? void 0 : n.maxSize) !== null && e !== void 0 ? e : 0, use_local_cache: s.localCacheEnabled, collection_id: this._key, message_init_policy: "" } })), u && (!((r = this._backgroundSync) === null || r === void 0) && r.isWrappingMessages(c)) ? [3, 3] : (d = !1, [4, tn(function() {
              return g(h, 0, void 0, function() {
                var f, m, v, E, y, b, T, w, N = this;
                return _(this, function(M) {
                  switch (M.label) {
                    case 0:
                      return f = k.of(this._iid).cacheContext, [4, this._getRemoteMessages(l, { nextLimit: this._nextResultLimit, reverse: !0, checkingHasNext: !0, checkingContinuousMessages: f.localCacheEnabled })];
                    case 1:
                      return m = M.sent(), (c = this._filterUnderOffsetMessage(m.messages)).length > 0 && ((v = this._syncRange).extends.apply(v, Re([], we(c.map(function(I) {
                        return I.createdAt;
                      })), !1)), !((E = this._backgroundSync) === null || E === void 0) && E.range.overlap(this._syncRange) && m.isContinuousMessages && (d = !0, (y = this._backgroundSync) === null || y === void 0 || y.range.extends(this._syncRange.bottom))), c = c.filter(function(I) {
                        return _r(N._messages, I) < 0;
                      }), this._hasNext = (b = m.hasNext) !== null && b !== void 0 ? b : c.length >= this._nextResultLimit, d && a.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: this.channel.url, starting_point: this._startingPoint, measured_on: "load_next", event: "cache_fetch", max_db_size: (w = (T = f.localCacheConfig) === null || T === void 0 ? void 0 : T.maxSize) !== null && w !== void 0 ? w : 0, use_local_cache: f.localCacheEnabled, collection_id: this._key, message_init_policy: "" } })), [2];
                  }
                });
              });
            })]);
          case 2:
            return p.sent(), this._addMessagesToView(c, B.REQUEST_MESSAGE), [3, 4];
          case 3:
            this._hasNext = c.length >= this._nextResultLimit, c.length > 0 && this._addMessagesToView(c, B.REQUEST_MESSAGE), p.label = 4;
          case 4:
            return this._isLoadingNext = !1, [2, c];
        }
      });
    });
  }, t.prototype.removeFailedMessage = function(n) {
    return g(this, 0, void 0, function() {
      var e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            if (this._isDisposed)
              throw new D({ code: me.COLLECTION_DISPOSED, message: "Collection has been disposed." });
            return [4, this._channelManager.removeFailedMessageFromCache(n)];
          case 1:
            return r.sent(), (e = this._unsentMessages.findIndex(function(i) {
              return i.reqId === n;
            })) > -1 && this._unsentMessages.splice(e, 1), [2];
        }
      });
    });
  }, t.prototype.dispose = function() {
    var n, e, r, i = this;
    if (!this._isDisposed) {
      this._isDisposed = !0;
      var s = k.of(this._iid), a = s.cacheContext, o = s.dispatcher;
      this._messages = [], this._clearCheckMyMutedTimer(), this._channel._runIfHandleableWithGroupChannel(function(l) {
        l.myMemberState !== sn.NONE && (i._channel._updateMessageCollectionLastAccessedAt(), o.dispatch(new it({ channels: [i._channel], context: { source: B.CHANNEL_LASTACCESSEDAT_UPDATED } })));
      }), a.localCacheEnabled && (this._prevFill.stop(), this._nextFill.stop()), (n = this._backgroundSync) === null || n === void 0 || n.close(), (e = this._changelogSync) === null || e === void 0 || e.close(), (r = this._pollChangelogSync) === null || r === void 0 || r.close(), this._channelManager.unsubscribeChannelEvent(this._key), this._channelManager.unsubscribeMessageEvent(this._key), this._connectionEventContext && this._connectionEventContext.close();
    }
  }, t;
}(), OT = function(t) {
  function n(e, r) {
    return t.call(this, e, A(A({}, r), { channelManager: vn.of(e) })) || this;
  }
  return S(n, t), n.prototype.keyOf = function(e) {
    return e.messageId;
  }, n.prototype.initialize = function(e) {
    var r = this;
    return tn(function() {
      return g(r, 0, void 0, function() {
        var i;
        return _(this, function(s) {
          switch (s.label) {
            case 0:
              return [4, this.channel.getMyMutedInfo()];
            case 1:
              return (i = s.sent()).isMuted && i.remainingDuration !== -1 && this._startCheckMyMutedTimer(i.remainingDuration), [2];
          }
        });
      });
    }), t.prototype.initialize.call(this, e);
  }, n.prototype.setMessageCollectionHandler = function(e) {
    this._setBaseMessageCollectionHandler(e);
  }, n.prototype._activate = function() {
    return g(this, 0, void 0, function() {
      var e = this;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, t.prototype._activate.call(this)];
          case 1:
            return r.sent(), [4, tn(function() {
              return g(e, 0, void 0, function() {
                var i;
                return _(this, function(s) {
                  switch (s.label) {
                    case 0:
                      return [4, this.channel.getMyMutedInfo()];
                    case 1:
                      return (i = s.sent()).isMuted && i.remainingDuration !== -1 && this._startCheckMyMutedTimer(i.remainingDuration), [2];
                  }
                });
              });
            })];
          case 2:
            return r.sent(), [2];
        }
      });
    });
  }, n.prototype._addMessagesToView = function(e, r) {
    var i, s, a = this, o = this._filterUnderOffsetMessage(e), l = [], c = [];
    try {
      for (var u = de(o), d = u.next(); !d.done; d = u.next()) {
        var h = d.value;
        if (r === B.SYNC_MESSAGE_FILL)
          if (h.messageId > 0) {
            if ((v = _r(this._messages, h)) < 0) {
              _r(this._unsentMessages, h) < 0 && l.push(h);
              var p = vu(this._messages, h);
              this._messages.splice(p, 0, h);
            }
          } else
            h instanceof en && (v = _r(this._unsentMessages, h)) < 0 && _r(this._messages, h) < 0 && (this._unsentMessages.push(h), l.push(h));
        else if (h.messageId > 0) {
          if ((v = _r(this._messages, h)) < 0) {
            var f = _r(this._unsentMessages, h);
            f < 0 ? l.push(h) : (this._unsentMessages.splice(f, 1), c.push(h)), p = vu(this._messages, h), this._messages.splice(p, 0, h);
          } else
            c.push(h), this._messages[v] = h;
          if (h.updatedAt > 0) {
            var m = this._updateChildMessagesInView(h);
            c.push.apply(c, Re([], we(m), !1));
          }
        } else if (h instanceof en) {
          var v;
          (v = _r(this._unsentMessages, h)) < 0 ? _r(this._messages, h) < 0 && (this._unsentMessages.push(h), l.push(h)) : (c.push(h), this._unsentMessages[v] = h);
        }
      }
    } catch (E) {
      i = { error: E };
    } finally {
      try {
        d && !d.done && (s = u.return) && s.call(u);
      } finally {
        if (i)
          throw i.error;
      }
    }
    Si(r) && Ue(function() {
      return g(a, 0, void 0, function() {
        var E, y, b, T, w;
        return _(this, function(N) {
          return E = { source: r }, l.length > 0 && ((b = (y = this._handler) === null || y === void 0 ? void 0 : y.onMessagesAdded) === null || b === void 0 || b.call(y, E, this.channel, l)), c.length > 0 && ((w = (T = this._handler) === null || T === void 0 ? void 0 : T.onMessagesUpdated) === null || w === void 0 || w.call(T, E, this.channel, c)), [2];
        });
      });
    });
  }, n.prototype._updateMessagesToView = function(e, r) {
    var i, s, a = this, o = [], l = [], c = [];
    try {
      for (var u = de(e), d = u.next(); !d.done; d = u.next()) {
        var h, p = d.value;
        if (p.messageId > 0)
          if ((h = _r(this._messages, p)) >= 0)
            l.push(p), this._messages[h] = p;
          else {
            var f = _r(this._unsentMessages, p);
            if (f >= 0) {
              var m = we(this._unsentMessages.splice(f, 1), 1)[0];
              if (this.hasNext && m)
                c.push(m);
              else {
                l.push(p);
                var v = vu(this._messages, p);
                this._messages.splice(v, 0, p);
              }
            } else {
              var E = this._messages.map(function(y) {
                return y.createdAt;
              });
              (p.createdAt < Math.min.apply(Math, Re([], we(E), !1)) && !this._hasPrevious || p.createdAt > Math.max.apply(Math, Re([], we(E), !1)) && !this._hasNext) && o.push(p);
            }
          }
        else
          p instanceof en && (h = _r(this._unsentMessages, p)) >= 0 && (l.push(p), this._unsentMessages[h] = p);
      }
    } catch (y) {
      i = { error: y };
    } finally {
      try {
        d && !d.done && (s = u.return) && s.call(u);
      } finally {
        if (i)
          throw i.error;
      }
    }
    return Si(r) && Ue(function() {
      return g(a, 0, void 0, function() {
        var y, b, T, w, N;
        return _(this, function(M) {
          return y = { source: r }, l.length > 0 ? (T = (b = this._handler) === null || b === void 0 ? void 0 : b.onMessagesUpdated) === null || T === void 0 || T.call(b, y, this.channel, l) : c.length > 0 ? (N = (w = this._handler) === null || w === void 0 ? void 0 : w.onMessagesDeleted) === null || N === void 0 || N.call(w, y, this.channel, [], c) : o.length > 0 && this._addMessagesToView(o, r), [2];
        });
      });
    }), l;
  }, n;
}(kT), RT = { coverUrl: void 0, coverImage: void 0, isDistinct: void 0, isPublic: void 0, isDiscoverable: void 0, accessCode: void 0, name: void 0, data: void 0, customType: void 0, operatorUserIds: void 0, messageSurvivalSeconds: void 0 }, DT = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.token, a = e.limit, o = e.order, l = e.mutedMemberFilter, c = e.memberStateFilter, u = e.nicknameStartsWithFilter, d = e.operatorFilter;
    return (r = t.call(this) || this).method = Y.GET, r.path = "".concat(Wn, "/").concat(encodeURIComponent(i), "/members"), r.params = { token: s, limit: a, order: o, muted_member_filter: l, member_state_filter: c, nickname_startswith: u, operator_filter: d, show_member_is_muted: !0, show_read_receipt: !0, show_delivery_receipt: !0 }, r;
  }
  return S(n, t), n;
}($), LT = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    i.members = [];
    var s = r.next, a = r.members;
    return i.token = s, a && a.length > 0 && (i.members = a.map(function(o) {
      return new wr(e, o);
    })), i;
  }
  return S(n, t), n;
}(ne);
(function(t) {
  t.ALL = "all", t.MUTED = "muted", t.UNMUTED = "unmuted";
})(_o || (_o = {})), function(t) {
  t.MEMBER_NICKNAME_ALPHABETICAL = "member_nickname_alphabetical", t.OPERATOR_THEN_MEMBER_ALPHABETICAL = "operator_then_member_alphabetical";
}(go || (go = {})), function(t) {
  t.ALL = "all", t.JOINED = "joined_only", t.INVITED = "invited_only", t.INVITED_BY_FRIEND = "invited_by_friend", t.INVITED_BY_NON_FRIEND = "invited_by_non_friend";
}(vo || (vo = {}));
var UT = function(t) {
  function n(e, r, i) {
    var s, a, o, l, c = this;
    return (c = t.call(this, e, r, yt.GROUP, i) || this).mutedMemberFilter = _o.ALL, c.memberStateFilter = vo.ALL, c.nicknameStartsWithFilter = null, c.operatorFilter = sc.ALL, c.order = go.MEMBER_NICKNAME_ALPHABETICAL, c.mutedMemberFilter = (s = i.mutedMemberFilter) !== null && s !== void 0 ? s : _o.ALL, c.memberStateFilter = (a = i.memberStateFilter) !== null && a !== void 0 ? a : vo.ALL, c.nicknameStartsWithFilter = (o = i.nicknameStartsWithFilter) !== null && o !== void 0 ? o : null, c.order = (l = i.order) !== null && l !== void 0 ? l : go.MEMBER_NICKNAME_ALPHABETICAL, c;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this) && Ze(_o, this.mutedMemberFilter) && Ze(vo, this.memberStateFilter) && (O("string", this.nicknameStartsWithFilter) || this.nicknameStartsWithFilter === null) && Ze(sc, this.operatorFilter) && Ze(go, this.order);
  }, n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = k.of(this._iid).requestQueue, r = new DT(Ae(A(A({}, this), { token: this._token }))), [4, e.send(r)]) : [3, 2] : [3, 5];
          case 1:
            return i = l.sent(), s = i.as(LT), a = s.members, o = s.token, this._token = o, this._hasNext = !!o, this._isLoading = !1, [2, a];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(Hi), PT = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.userId, a = e.accessCode;
    return (r = t.call(this) || this).method = Y.PUT, r.path = "".concat(Wn, "/").concat(encodeURIComponent(i), "/accept"), r.params = { user_id: s, access_code: a }, r;
  }
  return S(n, t), n;
}($), FT = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.channel = new Ir(e, r), i.channel.myMemberState = sn.JOINED, i;
  }
  return S(n, t), n;
}(ne), jT = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.isDistinct, a = e.isPublic, o = e.isDiscoverable, l = e.coverUrl, c = e.coverImage, u = e.accessCode, d = e.name, h = e.data, p = e.customType, f = e.operatorUserIds, m = e.messageSurvivalSeconds;
    return (r = t.call(this) || this).method = Y.PUT, r.path = "".concat(Wn, "/").concat(encodeURIComponent(i)), r.params = fe({ is_distinct: s, is_public: a, is_discoverable: o, name: d, data: h, custom_type: p, cover_url: l, cover_file: c, access_code: u, operator_ids: f, message_survival_seconds: m }), r;
  }
  return S(n, t), n;
}($), HT = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.channel = new Ir(e, r), i;
  }
  return S(n, t), n;
}(ne), BT = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl;
    return (r = t.call(this) || this).method = Y.DELETE, r.path = "".concat(Wn, "/").concat(encodeURIComponent(i)), r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    return t.call(this, n, e) || this;
  }, t);
})(ne);
var zT = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl;
    return (r = t.call(this) || this).method = Y.DELETE, r.path = "".concat(Wn, "/").concat(encodeURIComponent(i), "/hide"), r;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function() {
    return t !== null && t.apply(this, arguments) || this;
  }, t);
})(ne);
var VT = function(t) {
  function n(e) {
    var r = e.userId, i = e.channelUrl, s = e.countPreference, a = t.call(this) || this;
    return a.method = Y.PUT, a.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/count_preference/").concat(encodeURIComponent(i)), a.params = { count_preference: s }, a;
  }
  return S(n, t), n;
}($), GT = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.countPreference = r.count_preference, i;
  }
  return S(n, t), n;
}(ne), qT = function(t) {
  function n(e) {
    var r = this, i = e.channelUrl, s = e.locale;
    return (r = t.call(this) || this).method = Y.PUT, r.path = "".concat(Wn, "/").concat(encodeURIComponent(i), "/reset_user_history"), r.params = fe({ locale: s }), r;
  }
  return S(n, t), n;
}($), KT = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this, s = r.ts_message_offset;
    return i.messageOffsetTimestamp = s, i;
  }
  return S(n, t), n;
}(ne), WT = A(A({}, Zd), { scheduledAt: void 0, file: void 0, fileUrl: void 0, fileName: void 0, mimeType: void 0, fileSize: void 0, thumbnailSizes: void 0, requireAuth: !1 }), QT = A(A({}, i_), { scheduledAt: void 0 }), YT = function(t) {
  function n(e) {
    var r, i, s = this;
    s = t.call(this) || this;
    var a = [];
    e.mentionType === jn.USERS && (e.mentionedUserIds ? a = e.mentionedUserIds : e.mentionedUsers && (a = e.mentionedUsers.map(function(u) {
      return u.userId;
    })));
    var o = e.channelType, l = e.channelUrl, c = e.scheduledMessageId;
    return s.method = Y.PUT, s.path = "".concat(gt(o), "/").concat(encodeURIComponent(l), "/scheduled_messages/").concat(encodeURIComponent(c)), s.params = fe(Ae({ req_id: e.reqId, scheduled_at: e.scheduledAt, message_type: ha.FILE, url: e.fileUrl, file_name: e.fileName, file_size: e.fileSize, file_type: e.mimeType, thumbnails: (r = e._thumbnails) === null || r === void 0 ? void 0 : r.map(function(u) {
      return Bi.payloadify(u);
    }), custom_type: e.customType, data: e.data, require_auth: e.requireAuth, mention_type: e.mentionType, mentioned_user_ids: a, sorted_metaarray: (i = e.metaArrays) === null || i === void 0 ? void 0 : i.map(function(u) {
      return Yn.payloadify(u);
    }), apple_critical_alert_options: e.appleCriticalAlertOptions ? Fr.payloadify(e.appleCriticalAlertOptions) : null, push_option: e.pushNotificationDeliveryOption })), s;
  }
  return S(n, t), n;
}($), $T = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.message = new ln(e, r), i;
  }
  return S(n, t), n;
}(ne), ZT = function(t) {
  function n(e) {
    var r, i = this;
    i = t.call(this) || this;
    var s = [];
    e.mentionType === jn.USERS && (e.mentionedUserIds ? s = e.mentionedUserIds : e.mentionedUsers && (s = e.mentionedUsers.map(function(c) {
      return c.userId;
    })));
    var a = e.channelType, o = e.channelUrl, l = e.scheduledMessageId;
    return i.method = Y.PUT, i.path = "".concat(gt(a), "/").concat(encodeURIComponent(o), "/scheduled_messages/").concat(encodeURIComponent(l)), i.params = fe(Ae({ req_id: e.reqId, scheduled_at: e.scheduledAt, message_type: ha.USER, message: e.message, custom_type: e.customType, data: e.data, mention_type: e.mentionType, mentioned_user_ids: s, sorted_metaarray: (r = e.metaArrays) === null || r === void 0 ? void 0 : r.map(function(c) {
      return Yn.payloadify(c);
    }), apple_critical_alert_options: e.appleCriticalAlertOptions ? Fr.payloadify(e.appleCriticalAlertOptions) : null, target_langs: e.translationTargetLanguages, push_option: e.pushNotificationDeliveryOption })), i;
  }
  return S(n, t), n;
}($);
(function(t) {
  S(function(n, e) {
    var r = t.call(this, n, e) || this;
    return r.message = new Ln(n, e), r;
  }, t);
})(ne);
var yr, br, XT = function(t) {
  function n(e) {
    var r = t.call(this) || this, i = e.channelType, s = e.channelUrl, a = e.scheduledMessageId;
    return r.method = Y.DELETE, r.path = "".concat(gt(i), "/").concat(encodeURIComponent(s), "/scheduled_messages/").concat(encodeURIComponent(a)), r;
  }
  return S(n, t), n;
}($), JT = function(t) {
  function n(e) {
    var r = t.call(this) || this, i = e.channelType, s = e.channelUrl, a = e.scheduledMessageId;
    return r.method = Y.POST, r.path = "".concat(gt(i), "/").concat(encodeURIComponent(s), "/scheduled_messages/").concat(encodeURIComponent(a), "/send_now"), r;
  }
  return S(n, t), n;
}($), ew = function(t) {
  function n(e) {
    var r = e.userId, i = e.channelUrl, s = e.pushTriggerOption, a = t.call(this) || this;
    return a.method = Y.PUT, a.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push_preference/").concat(encodeURIComponent(i)), a.params = { push_trigger_option: s }, a;
  }
  return S(n, t), n;
}($), tw = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.pushTriggerOption = r.push_trigger_option, i.enabled = r.enable, i;
  }
  return S(n, t), n;
}(ne), nw = function(t) {
  function n(e) {
    var r = e.userId, i = e.channelUrl, s = t.call(this) || this;
    return s.method = Y.GET, s.path = "".concat(vt, "/").concat(encodeURIComponent(r), "/push_preference/").concat(encodeURIComponent(i)), s;
  }
  return S(n, t), n;
}($), rw = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    return i.pushTriggerOption = r.push_trigger_option, i.enabled = r.enable, i;
  }
  return S(n, t), n;
}(ne);
(function(t) {
  t.ALL = "all", t.UNREAD_MESSAGE_COUNT_ONLY = "unread_message_count_only", t.UNREAD_MENTION_COUNT_ONLY = "unread_mention_count_only", t.OFF = "off";
})(yr || (yr = {})), function(t) {
  t.UNHIDDEN = "unhidden", t.HIDDEN_ALLOW_AUTO_UNHIDE = "hidden_allow_auto_unhide", t.HIDDEN_PREVENT_AUTO_UNHIDE = "hidden_prevent_auto_unhide";
}(br || (br = {}));
var yo, Ir = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M, I = this;
    return (I = t.call(this, e, r) || this)._unreadMemberStateMap = /* @__PURE__ */ new Map(), I._undeliveredMemberStateMap = /* @__PURE__ */ new Map(), I._typingStatus = /* @__PURE__ */ new Map(), I._lastMemberCountUpdated = 0, I._typingStarted = 0, I._typingEnded = 0, I._hasBotInfo = { general: !1, ai: !1 }, I.isDistinct = !1, I.isSuper = !1, I.isBroadcast = !1, I.isExclusive = !1, I.isPublic = !1, I.isDiscoverable = !0, I.isChatNotification = !1, I.isAccessCodeRequired = !1, I.isPushEnabled = !1, I.unreadMessageCount = 0, I.unreadMentionCount = 0, I.totalUnreadReplyCount = 0, I.members = [], I.memberCount = 0, I.joinedMemberCount = 0, I.hiddenState = br.UNHIDDEN, I.lastMessage = null, I.messageOffsetTimestamp = 0, I.messageSurvivalSeconds = -1, I.myMemberState = sn.NONE, I.myRole = Lr.NONE, I.myMutedState = ai.UNMUTED, I.myLastRead = 0, I.myCountPreference = yr.ALL, I.myPushTriggerOption = xs.DEFAULT, I.inviter = null, I.invitedAt = 0, I.joinedAt = 0, I.lastPinnedMessage = null, I._latestMessageInfo = null, I._pinnedMessagesUpdatedAt = 0, I._myMutedRemainingTime = -1, I.channelType = yt.GROUP, I.isDistinct = (s = r.is_distinct) !== null && s !== void 0 && s, I.isSuper = (a = r.is_super) !== null && a !== void 0 && a, I.isBroadcast = (o = r.is_broadcast) !== null && o !== void 0 && o, I.isExclusive = (l = r.is_exclusive) !== null && l !== void 0 && l, I.isPublic = (c = r.is_public) !== null && c !== void 0 && c, I.isDiscoverable = (u = r.is_discoverable) !== null && u !== void 0 ? u : I.isPublic, I.isChatNotification = (d = r.is_chat_notification) !== null && d !== void 0 && d, I.isAccessCodeRequired = (h = r.is_access_code_required) !== null && h !== void 0 && h, I.isPushEnabled = (p = r.is_push_enabled) !== null && p !== void 0 && p, Array.isArray(r.members) && (i = I.members).push.apply(i, Re([], we(r.members.map(function(x) {
      return new wr(I._iid, x);
    })), !1)), I.memberCount = (f = r.member_count) !== null && f !== void 0 ? f : 0, I.joinedMemberCount = (m = r.joined_member_count) !== null && m !== void 0 ? m : 0, I.hiddenState = Ze(br, r.hidden_state) ? r.hidden_state : br.UNHIDDEN, I.messageOffsetTimestamp = (v = r.ts_message_offset) !== null && v !== void 0 ? v : 0, I.messageSurvivalSeconds = (E = r.message_survival_seconds) !== null && E !== void 0 ? E : -1, I.lastMessage = r.last_message ? Kn(I._iid, A({ channel_type: I.channelType }, r.last_message)) : null, r.read_receipt && Object.keys(r.read_receipt).forEach(function(x) {
      O("number", r.read_receipt[x]) && I._updateUnreadMemberState(x, r.read_receipt[x]);
    }), r.delivery_receipt && Object.keys(r.delivery_receipt).forEach(function(x) {
      O("number", r.delivery_receipt[x]) && I._updateUndeliveredMemberState(x, r.delivery_receipt[x]);
    }), I.myMemberState = Ze(sn, r.member_state) ? r.member_state : sn.NONE, I.myRole = Ze(Lr, r.my_role) ? r.my_role : Lr.NONE, Ze(ai, r.is_muted) ? I.myMutedState = r.is_muted : O("boolean", r.is_muted) ? I.myMutedState = r.is_muted ? ai.MUTED : ai.UNMUTED : I.myMutedState = ai.UNMUTED, I.myCountPreference = Ze(yr, r.count_preference) ? r.count_preference : yr.ALL, I.myPushTriggerOption = Ze(xs, r.push_trigger_option) ? r.push_trigger_option : xs.ALL, I.myLastRead = (y = r.user_last_read) !== null && y !== void 0 ? y : 0, I.inviter = r.inviter ? new pt(I._iid, r.inviter) : null, I.invitedAt = (b = r.invited_at) !== null && b !== void 0 ? b : 0, I.joinedAt = (T = r.joined_ts) !== null && T !== void 0 ? T : 0, I._updateUnreadCount((w = r.unread_message_count) !== null && w !== void 0 ? w : 0, (N = r.unread_mention_count) !== null && N !== void 0 ? N : 0), I.totalUnreadReplyCount = (M = r.total_unread_thread_message_count) !== null && M !== void 0 ? M : 0, I.lastPinnedMessage = r.latest_pinned_message ? Kn(I._iid, A({ channel_type: I.channelType }, r.latest_pinned_message)) : null, r.latest_message && (I._latestMessageInfo = { messageId: r.latest_message.message_id, createdAt: r.latest_message.created_at }), I._hasBotInfo = { general: !!r.has_bot, ai: !!r.has_ai_bot }, I;
  }
  return S(n, t), Object.defineProperty(n.prototype, "isHidden", { get: function() {
    return this.hiddenState !== br.UNHIDDEN;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "isTyping", { get: function() {
    return this._typingStatus.size > 0;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "cachedUnreadMemberState", { get: function() {
    var e, r, i = {};
    try {
      for (var s = de(this._unreadMemberStateMap), a = s.next(); !a.done; a = s.next()) {
        var o = we(a.value, 2), l = o[0], c = o[1];
        i[l] = c;
      }
    } catch (u) {
      e = { error: u };
    } finally {
      try {
        a && !a.done && (r = s.return) && r.call(s);
      } finally {
        if (e)
          throw e.error;
      }
    }
    return i;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "cachedUndeliveredMemberState", { get: function() {
    var e, r, i = {};
    try {
      for (var s = de(this._undeliveredMemberStateMap), a = s.next(); !a.done; a = s.next()) {
        var o = we(a.value, 2), l = o[0], c = o[1];
        i[l] = c;
      }
    } catch (u) {
      e = { error: u };
    } finally {
      try {
        a && !a.done && (r = s.return) && r.call(s);
      } finally {
        if (e)
          throw e.error;
      }
    }
    return i;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "hasBot", { get: function() {
    return this._hasBotInfo.general;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(n.prototype, "hasAiBot", { get: function() {
    return this._hasBotInfo.ai;
  }, enumerable: !1, configurable: !0 }), n.payloadify = function(e) {
    return fe(Ae(A(A({}, t.payloadify.call(this, e)), { is_access_code_required: e.isAccessCodeRequired, is_distinct: e.isDistinct, is_super: e.isSuper, is_broadcast: e.isBroadcast, is_exclusive: e.isExclusive, is_public: e.isPublic, is_discoverable: e.isDiscoverable, is_muted: e.myMutedState, is_push_enabled: e.isPushEnabled, unread_message_count: e.unreadMessageCount, unread_mention_count: e.unreadMentionCount, total_unread_thread_message_count: e.totalUnreadReplyCount, push_trigger_option: e.myPushTriggerOption, count_preference: e.myCountPreference, hidden_state: e.hiddenState, member_count: e.memberCount, joined_member_count: e.joinedMemberCount, member_state: e.myMemberState, my_role: e.myRole, user_last_read: e.myLastRead, ts_message_offset: e.messageOffsetTimestamp, message_survival_seconds: e.messageSurvivalSeconds, read_receipt: e.cachedUnreadMemberState, delivery_receipt: e.cachedUndeliveredMemberState, members: e.members.map(function(r) {
      return wr.payloadify(r);
    }), last_message: e.lastMessage ? Op(e.lastMessage) : null, inviter: e.inviter ? pt.payloadify(e.inviter) : null, invited_at: e.invitedAt, joined_ts: e.joinedAt, latest_pinned_message: e.lastPinnedMessage ? Op(e.lastPinnedMessage) : null, latest_message: e._latestMessageInfo ? { message_id: e._latestMessageInfo.messageId, created_at: e._latestMessageInfo.createdAt } : null, has_bot: e.hasBot, has_ai_bot: e.hasAiBot })));
  }, n.prototype._shouldUpdateLastMessageWith = function(e) {
    if (e.silent)
      return !1;
    var r = k.of(this._iid).appInfo;
    switch (r == null ? void 0 : r.lastMessageThreadingPolicy) {
      case Ds.NONE:
      case Ds.INCLUDE_REPLY:
        break;
      case Ds.EXCLUDE_REPLY:
        if (e.parentMessageId > 0)
          return !1;
        break;
      case Ds.INCLUDE_REPLY_TO_CHANNEL:
        if (e instanceof en && e.parentMessageId > 0 && !e.replyToChannel)
          return !1;
    }
    return !this.lastMessage || this.lastMessage.createdAt < e.createdAt || this.lastMessage.createdAt === e.createdAt && this.lastMessage.messageId === e.messageId && this.lastMessage.updatedAt < e.updatedAt;
  }, n.prototype._tryUpdateLastMessageAndCallEvents = function(e, r) {
    var i = k.of(this._iid).dispatcher, s = vn.of(this._iid);
    this._updateLastMessage(r), s.handlers.map(function(a) {
      a.onChannelChanged && a.onChannelChanged(e);
    }), i.dispatch(new it({ channels: [e], context: { source: B.EVENT_MESSAGE_SENT } }));
  }, n.prototype._shouldUpdateUnreadCountWith = function(e) {
    var r = k.of(this._iid).appInfo;
    switch (r == null ? void 0 : r.unreadCountThreadingPolicy) {
      case Rs.NONE:
      case Rs.INCLUDE_REPLY:
        break;
      case Rs.EXCLUDE_REPLY:
        if (e.parentMessageId > 0)
          return !1;
        break;
      case Rs.INCLUDE_REPLY_TO_CHANNEL:
        if (e instanceof en && e.parentMessageId > 0 && !e.replyToChannel)
          return !1;
    }
    return !0;
  }, n.prototype._updateLastMessage = function(e) {
    return !!this._shouldUpdateLastMessageWith(e) && (this.lastMessage = e, !0);
  }, n.prototype._updateUnreadCount = function(e, r) {
    if (typeof e == "number" && e >= 0)
      if (this.myCountPreference === yr.ALL || this.myCountPreference === yr.UNREAD_MESSAGE_COUNT_ONLY)
        if (this.isExclusive || this.isSuper || this.isBroadcast) {
          var i = k.of(this._iid).maxSuperGroupChannelUnreadCount;
          this.unreadMessageCount = i && e >= i ? i : e;
        } else
          this.unreadMessageCount = e;
      else
        this.unreadMessageCount = 0;
    else
      this.unreadMessageCount = 0;
    typeof r == "number" && r >= 0 && (this.myCountPreference === yr.ALL || this.myCountPreference === yr.UNREAD_MENTION_COUNT_ONLY) ? this.unreadMentionCount = r : this.unreadMentionCount = 0;
  }, n.prototype._updateUnreadMemberState = function(e, r) {
    var i = this._unreadMemberStateMap.get(e);
    return (!i || i < r) && (this._unreadMemberStateMap.set(e, r), k.of(this._iid).sdkState.userId === e && (this.myLastRead = r), !0);
  }, n.prototype._updateUndeliveredMemberState = function(e, r) {
    var i = this._undeliveredMemberStateMap.get(e);
    return (!i || i < r) && (this._undeliveredMemberStateMap.set(e, r), !0);
  }, n.prototype._updateTypingStatus = function(e, r) {
    r === void 0 && (r = (/* @__PURE__ */ new Date()).getTime()), r > 0 ? this._typingStatus.set(e.userId, { user: e, ts: r }) : this._typingStatus.delete(e.userId);
  }, n.prototype._clearTypingStatus = function() {
    this._typingStatus.clear(), this._typingStarted = 0, this._typingEnded = 0;
  }, n.prototype._setLatestMemberCount = function(e, r, i) {
    var s = !1;
    return i >= this._lastMemberCountUpdated && (this._lastMemberCountUpdated = i, s = e !== this.memberCount || r !== this.joinedMemberCount, this.memberCount = e, this.joinedMemberCount = r), s;
  }, n.prototype.isReadMessage = function(e) {
    var r = k.of(this._iid).sdkState, i = this._unreadMemberStateMap.get(r.userId);
    return !!i && i >= e.createdAt;
  }, n.prototype.serialize = function() {
    var e = this;
    return Lo(this, function(r) {
      r.cachedUnreadMemberState = e.cachedUnreadMemberState, r.cachedUndeliveredMemberState = e.cachedUndeliveredMemberState, Object.assign(r, e._serializeCachedMetaData());
    });
  }, n.prototype.createMessageCollection = function(e) {
    return e === void 0 && (e = {}), new OT(this._iid, A(A({}, e), { channel: this }));
  }, n.prototype.createMemberListQuery = function(e) {
    return e === void 0 && (e = {}), new UT(this._iid, this.url, e);
  }, n.prototype.createThreadedParentMessageListQuery = function(e) {
    return e === void 0 && (e = {}), new vC(this._iid, this.url, this.channelType, e);
  }, n.prototype.addMember = function(e, r) {
    if (r === void 0 && (r = 0), !this.isExclusive && !this.isSuper && !this.isBroadcast) {
      var i = this.members.findIndex(function(a) {
        return a.userId === e.userId;
      });
      if (i > -1) {
        var s = this.members[i];
        s.state === sn.JOINED && (e.state = s.state), this.members.splice(i, 1), this.memberCount--;
      }
      this.members.push(e), this.memberCount++, this._updateUnreadMemberState(e.userId, r), this._updateUndeliveredMemberState(e.userId, r);
    }
  }, n.prototype.removeMember = function(e) {
    if (!this.isExclusive && !this.isSuper && !this.isBroadcast) {
      var r = e instanceof wr ? e.userId : e, i = this.members.findIndex(function(s) {
        return s.userId === r;
      });
      if (i > -1)
        return this.members.splice(i, 1), this.memberCount--, !0;
    }
    return !1;
  }, n.prototype.getUnreadMemberCount = function(e) {
    var r, i;
    if (e instanceof en && !this.isExclusive && !this.isSuper && !this.isBroadcast) {
      var s = k.of(this._iid).sdkState, a = e.createdAt, o = 0;
      try {
        for (var l = de(this.members), c = l.next(); !c.done; c = l.next()) {
          var u = c.value;
          s.userId !== u.userId && u.state === sn.JOINED && e.sender.userId !== u.userId && (this.cachedUnreadMemberState[u.userId] || 0) < a && o++;
        }
      } catch (d) {
        r = { error: d };
      } finally {
        try {
          c && !c.done && (i = l.return) && i.call(l);
        } finally {
          if (r)
            throw r.error;
        }
      }
      return o;
    }
    return 0;
  }, n.prototype.getUndeliveredMemberCount = function(e) {
    var r, i;
    if (e instanceof en && !this.isExclusive && !this.isSuper && !this.isBroadcast) {
      var s = k.of(this._iid).sdkState, a = e.createdAt, o = 0;
      try {
        for (var l = de(this.members), c = l.next(); !c.done; c = l.next()) {
          var u = c.value;
          s.userId !== u.userId && u.state === sn.JOINED && e.sender.userId !== u.userId && (this.cachedUndeliveredMemberState[u.userId] || 0) < a && o++;
        }
      } catch (d) {
        r = { error: d };
      } finally {
        try {
          c && !c.done && (i = l.return) && i.call(l);
        } finally {
          if (r)
            throw r.error;
        }
      }
      return o;
    }
    return 0;
  }, n.prototype.getReadMembers = function(e, r) {
    var i = this;
    r === void 0 && (r = !1);
    var s = k.of(this._iid).sdkState;
    if (!s.userId || this.isExclusive || this.isSuper || this.isBroadcast)
      return [];
    var a = e instanceof en ? e.sender : null, o = [];
    return this.members.forEach(function(l) {
      if (r || l.userId !== s.userId && l.userId !== (a == null ? void 0 : a.userId)) {
        var c = i._unreadMemberStateMap.get(l.userId);
        c && c >= e.createdAt && o.push(l);
      }
    }), o;
  }, n.prototype.getUnreadMembers = function(e, r) {
    var i = this;
    r === void 0 && (r = !1);
    var s = k.of(this._iid).sdkState;
    if (!s.userId || this.isExclusive || this.isSuper || this.isBroadcast)
      return [];
    var a = e instanceof en ? e.sender : null, o = [];
    return this.members.forEach(function(l) {
      if (r || l.userId !== s.userId && l.userId !== (a == null ? void 0 : a.userId)) {
        var c = i._unreadMemberStateMap.get(l.userId);
        c && c < e.createdAt && o.push(l);
      }
    }), o;
  }, n.prototype.getReadStatus = function(e) {
    var r = this;
    e === void 0 && (e = !1);
    var i = k.of(this._iid).sdkState;
    if (!i.userId || this.isExclusive || this.isSuper || this.isBroadcast)
      return null;
    var s = {};
    return this.members.forEach(function(a) {
      if (e || a.userId !== i.userId) {
        var o = r._unreadMemberStateMap.get(a.userId);
        s[a.userId] = new Ym(r._iid, { channel_url: r.url, channel_type: r.channelType, user: wr.payloadify(a), ts: o ?? 0 });
      }
    }), s;
  }, n.prototype.getDeliveryStatus = function(e) {
    var r = this;
    e === void 0 && (e = !0);
    var i = k.of(this._iid).sdkState;
    if (!i.userId || this.isExclusive || this.isSuper || this.isBroadcast)
      return null;
    var s = {};
    return this.members.forEach(function(a) {
      if (e || a.userId !== i.userId) {
        var o = r._undeliveredMemberStateMap.get(a.userId);
        s[a.userId] = new U2(r._iid, { channel_url: r.url, channel_type: r.channelType, user: wr.payloadify(a), ts: o ?? 0 });
      }
    }), s;
  }, n.prototype.getTypingUsers = function() {
    var e = [];
    return this._typingStatus.forEach(function(r) {
      var i = r.user;
      e.push(i);
    }), e;
  }, n.prototype.invalidateTypingStatus = function() {
    var e = this, r = k.of(this._iid).typingIndicatorInvalidateTime, i = Date.now(), s = !1;
    return this._typingStatus.forEach(function(a, o) {
      var l = a.ts;
      i - l >= r && (e._typingStatus.delete(o), s = !0);
    }), s;
  }, n.prototype.refresh = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        return [2, this._refresh()];
      });
    });
  }, n.prototype._refresh = function(e) {
    return e === void 0 && (e = !1), g(this, 0, void 0, function() {
      var r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return r = k.of(this._iid), i = r.requestQueue, s = r.dispatcher, a = new vd({ channelUrl: this.url }), [4, i.send(a)];
          case 1:
            return o = c.sent(), l = o.as(yd).channel, this._update(l), e || s.dispatch(new it({ channels: [l], context: { source: B.REFRESH_CHANNEL } })), [2, this];
        }
      });
    });
  }, n.prototype.freeze = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, t.prototype.freeze.call(this)];
          case 1:
            return e.sent(), k.of(this._iid).dispatcher.dispatch(new it({ channels: [this], context: { source: B.EVENT_CHANNEL_FROZEN }, isWebSocketEventComing: !0 })), [2];
        }
      });
    });
  }, n.prototype.unfreeze = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, t.prototype.unfreeze.call(this)];
          case 1:
            return e.sent(), k.of(this._iid).dispatcher.dispatch(new it({ channels: [this], context: { source: B.EVENT_CHANNEL_UNFROZEN }, isWebSocketEventComing: !0 })), [2];
        }
      });
    });
  }, n.prototype.updateChannel = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return r = A(A({}, RT), e), Z(function(d) {
              return O("string", d.coverUrl, !0) && (qn(d.coverImage) || O("string", d.coverImage, !0)) && O("boolean", d.isDistinct, !0) && O("boolean", d.isPublic, !0) && O("boolean", d.isDiscoverable, !0) && O("string", d.accessCode, !0) && O("string", d.name, !0) && O("string", d.data, !0) && O("string", d.customType, !0) && tt("string", d.operatorUserIds, !0) && O("number", d.messageSurvivalSeconds, !0);
            }(r)).throw(D.invalidParameters), i = k.of(this._iid), s = i.dispatcher, a = i.requestQueue, o = new jT(A({ channelUrl: this.url }, r)), [4, a.send(o)];
          case 1:
            return l = u.sent(), c = l.as(HT).channel, this._update(c), s.dispatch(new it({ channels: [c], context: { source: B.EVENT_CHANNEL_UPDATED }, isWebSocketEventComing: !0 })), [2, this];
        }
      });
    });
  }, n.prototype.invite = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return Z(e.every(function(i) {
          return i instanceof pt;
        })).throw(D.invalidParameters), [2, this.inviteWithUserIds(e.map(function(i) {
          return i.userId;
        }))];
      });
    });
  }, n.prototype.inviteWithUserIds = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return Z(tt("string", e)).throw(D.invalidParameters), r = k.of(this._iid), i = r.dispatcher, s = r.requestQueue, a = r.sessionManager, o = new uT({ channelUrl: this.url, userIds: e }), [4, s.send(o)];
          case 1:
            return l = u.sent(), c = l.as(dT).channel, this._update(c), i.dispatch(new it({ channels: [c], context: { source: B.EVENT_CHANNEL_INVITED, inviter: a.currentUser, invitees: [] }, isWebSocketEventComing: !0 })), [2, this];
        }
      });
    });
  }, n.prototype.join = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return Z(O("string", e, !0)).throw(D.invalidParameters), r = k.of(this._iid), i = r.dispatcher, s = r.sdkState, a = r.requestQueue, o = new sT({ channelUrl: this.url, userId: s.userId, accessCode: e }), [4, a.send(o)];
          case 1:
            return l = u.sent(), (c = l.as(aT).channel).myMemberState = this.myMemberState = sn.JOINED, this._update(c), i.dispatch(new it({ channels: [c], context: { source: B.EVENT_CHANNEL_JOINED, users: [] }, isWebSocketEventComing: !0 })), [2, this];
        }
      });
    });
  }, n.prototype.leave = function(e) {
    return e === void 0 && (e = !1), g(this, 0, void 0, function() {
      var r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return r = k.of(this._iid), i = r.sdkState, s = r.requestQueue, a = new lT({ channelUrl: this.url, userId: i.userId, shouldRemoveOperatorStatus: e }), [4, s.send(a)];
          case 1:
            return o.sent(), this.myMemberState = sn.NONE, [2];
        }
      });
    });
  }, n.prototype.acceptInvitation = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return Z(O("string", e, !0)).throw(D.invalidParameters), r = k.of(this._iid), i = r.dispatcher, s = r.sdkState, a = r.requestQueue, o = new PT({ channelUrl: this.url, userId: s.userId, accessCode: e }), [4, a.send(o)];
          case 1:
            return l = u.sent(), (c = l.as(FT).channel).myMemberState = this.myMemberState = sn.JOINED, this._update(c), i.dispatch(new it({ channels: [c], context: { source: B.EVENT_CHANNEL_ACCEPTED_INVITE }, isWebSocketEventComing: !0 })), [2, this];
        }
      });
    });
  }, n.prototype.declineInvitation = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new pT({ channelUrl: this.url, userId: r.userId }), [4, i.send(s)];
          case 1:
            return a.sent(), this.myMemberState = sn.NONE, [2, this];
        }
      });
    });
  }, n.prototype.sendUserMessage = function(e) {
    var r = this, i = new cr(), s = k.of(this._iid).dispatcher, a = Ka.of(this._iid);
    return t.prototype.sendUserMessage.call(this, e).onPending(function(o) {
      a.completeCurrentAndProcessNextAutoResend(o), i._trigger(o);
    }).onFailed(function(o, l) {
      l && a.completeCurrentAndProcessNextAutoResend(l), i._triggerFailed(o, l);
    }).onSucceeded(function(o) {
      a.completeCurrentAndProcessNextAutoResend(o), r._updateLastMessage(o), vn.of(r._iid).handlers.map(function(l) {
        l.onChannelChanged && l.onChannelChanged(r);
      }), s.dispatch(new it({ channels: [r], context: { source: B.EVENT_MESSAGE_SENT } })), i._trigger(o);
    }), i;
  }, n.prototype.updateUserMessage = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a, o, l = this;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return i = k.of(this._iid).dispatcher, [4, t.prototype.updateUserMessage.call(this, e, r)];
          case 1:
            return s = c.sent(), a = this._updateLastMessage(s), o = !1, this.lastPinnedMessage && this.lastPinnedMessage.messageId === s.messageId && (this.lastPinnedMessage = s, a = !0, o = !0), a && (vn.of(this._iid).handlers.map(function(u) {
              u.onChannelChanged && u.onChannelChanged(l);
            }), i.dispatch(new it({ channels: [this], context: { source: o ? B.EVENT_PINNED_MESSAGE_UPDATED : B.EVENT_MESSAGE_UPDATED } }))), o && vn.of(this._iid).handlers.map(function(u) {
              u.onPinnedMessageUpdated && u.onPinnedMessageUpdated(l);
            }), i.dispatch(new Pt({ messages: [s], source: B.EVENT_MESSAGE_UPDATED })), [2, s];
        }
      });
    });
  }, n.prototype._autoResendUserMessage = function(e) {
    var r = this, i = new cr(), s = k.of(this._iid).dispatcher, a = Ka.of(this._iid);
    return t.prototype._autoResendUserMessage.call(this, e).onPending(function(o) {
      a.completeCurrentAndProcessNextAutoResend(o), i._trigger(o);
    }).onFailed(function(o, l) {
      a.completeCurrentAndProcessNextAutoResend(l), i._triggerFailed(o, l);
    }).onSucceeded(function(o) {
      var l = vn.of(r._iid);
      a.completeCurrentAndProcessNextAutoResend(o), r._updateLastMessage(o), l.handlers.map(function(c) {
        c.onChannelChanged && c.onChannelChanged(r);
      }), s.dispatch(new it({ channels: [r], context: { source: B.EVENT_MESSAGE_SENT } })), i._trigger(o);
    }), i;
  }, n.prototype.sendFileMessage = function(e) {
    var r = this, i = new cr(), s = k.of(this._iid).dispatcher, a = Ka.of(this._iid);
    return t.prototype.sendFileMessage.call(this, e).onPending(function(o) {
      a.completeCurrentAndProcessNextAutoResend(o), i._trigger(o);
    }).onFailed(function(o, l) {
      l && a.completeCurrentAndProcessNextAutoResend(l), i._triggerFailed(o, l);
    }).onSucceeded(function(o) {
      var l = vn.of(r._iid);
      a.completeCurrentAndProcessNextAutoResend(o), r._updateLastMessage(o), l.handlers.map(function(c) {
        c.onChannelChanged && c.onChannelChanged(r);
      }), s.dispatch(new it({ channels: [r], context: { source: B.EVENT_MESSAGE_SENT } })), i._trigger(o);
    }), i;
  }, n.prototype.sendMultipleFilesMessage = function(e) {
    var r = this, i = new Nl(), s = k.of(this._iid).dispatcher;
    return t.prototype.sendMultipleFilesMessage.call(this, e).onPending(function(a) {
      i._trigger(a);
    }).onFailed(function(a, o) {
      i._triggerFailed(a, o);
    }).onSucceeded(function(a) {
      var o = vn.of(r._iid);
      r._updateLastMessage(a), o.handlers.map(function(l) {
        l.onChannelChanged && l.onChannelChanged(r);
      }), s.dispatch(new it({ channels: [r], context: { source: B.EVENT_MESSAGE_SENT } })), i._trigger(a);
    }).onFileUploaded(function(a, o, l, c) {
      i._triggerOnFileUploaded(a, o, l, c);
    }), i;
  }, n.prototype.updateFileMessage = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a, o, l = this;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return i = k.of(this._iid).dispatcher, [4, t.prototype.updateFileMessage.call(this, e, r)];
          case 1:
            return s = c.sent(), a = this._updateLastMessage(s), o = !1, this.lastPinnedMessage && this.lastPinnedMessage.messageId === s.messageId && (this.lastPinnedMessage = s, a = !0, o = !0), a && (vn.of(this._iid).handlers.map(function(u) {
              u.onChannelChanged && u.onChannelChanged(l);
            }), i.dispatch(new it({ channels: [this], context: { source: o ? B.EVENT_PINNED_MESSAGE_UPDATED : B.EVENT_MESSAGE_UPDATED } }))), o && vn.of(this._iid).handlers.map(function(u) {
              u.onPinnedMessageUpdated && u.onPinnedMessageUpdated(l);
            }), i.dispatch(new Pt({ messages: [s], source: B.EVENT_MESSAGE_UPDATED })), [2, s];
        }
      });
    });
  }, n.prototype._autoResendFileMessage = function(e) {
    var r = this, i = new cr(), s = k.of(this._iid).dispatcher, a = Ka.of(this._iid);
    return t.prototype._autoResendFileMessage.call(this, e).onPending(function(o) {
      a.completeCurrentAndProcessNextAutoResend(o), i._trigger(o);
    }).onFailed(function(o, l) {
      a.completeCurrentAndProcessNextAutoResend(l), i._triggerFailed(o, l);
    }).onSucceeded(function(o) {
      var l = vn.of(r._iid);
      a.completeCurrentAndProcessNextAutoResend(o), r._updateLastMessage(o), l.handlers.map(function(c) {
        c.onChannelChanged && c.onChannelChanged(r);
      }), s.dispatch(new it({ channels: [r], context: { source: B.EVENT_MESSAGE_SENT } })), i._trigger(o);
    }), i;
  }, n.prototype.deleteMessage = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, t.prototype.deleteMessage.call(this, e)];
          case 1:
            return r.sent(), e.messageId === 0 && e instanceof en && k.of(this._iid).dispatcher.dispatch(new Fm({ reqId: e.reqId, source: B.EVENT_MESSAGE_DELETED })), [2];
        }
      });
    });
  }, n.prototype.hide = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u;
      return _(this, function(d) {
        switch (d.label) {
          case 0:
            return r = A(A({}, bd), e), Z(function(h) {
              return O("boolean", h.hidePreviousMessages, !0) && O("boolean", h.allowAutoUnhide, !0);
            }(r)).throw(D.invalidParameters), i = k.of(this._iid), s = i.dispatcher, a = i.sdkState, o = i.requestQueue, l = new mT(A({ channelUrl: this.url, userId: a.userId }, r)), [4, o.send(l)];
          case 1:
            return c = d.sent(), u = c.as(_T).messageOffsetTimestamp, this.hiddenState = r.allowAutoUnhide ? br.HIDDEN_ALLOW_AUTO_UNHIDE : br.HIDDEN_PREVENT_AUTO_UNHIDE, r.hidePreviousMessages && this._updateUnreadCount(0, 0), u && (this.messageOffsetTimestamp = u), s.dispatch(new it({ channels: [this], context: { source: B.EVENT_CHANNEL_HIDDEN }, isWebSocketEventComing: !0 })), [2, this];
        }
      });
    });
  }, n.prototype.unhide = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return e = k.of(this._iid), r = e.dispatcher, i = e.requestQueue, s = new zT({ channelUrl: this.url }), [4, i.send(s)];
          case 1:
            return a.sent(), this.hiddenState = br.UNHIDDEN, r.dispatch(new it({ channels: [this], context: { source: B.EVENT_CHANNEL_UNHIDDEN }, isWebSocketEventComing: !0 })), [2, this];
        }
      });
    });
  }, n.prototype.delete = function() {
    return g(this, 0, void 0, function() {
      var e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return e = k.of(this._iid).requestQueue, r = new BT({ channelUrl: this.url }), [4, e.send(r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.markAsRead = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c = this;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return e = k.of(this._iid), r = e.sdkState, i = e.dispatcher, s = e.requestQueue, a = new rb({ channelUrl: this.url }), [4, s.send(a)];
          case 1:
            return o = u.sent(), l = o.as($m).readStatus, this._updateUnreadMemberState(r.userId, l.readAt), (this.unreadMessageCount > 0 || this.unreadMentionCount > 0) && (this._updateUnreadCount(0, 0), vn.of(this._iid).handlers.map(function(d) {
              d.onChannelChanged && d.onChannelChanged(c);
            })), i.dispatch(new it({ channels: [this], context: { source: B.EVENT_CHANNEL_READ } })), [2];
        }
      });
    });
  }, n.prototype.markAsDelivered = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new TT({ channelUrl: this.url, userId: r.userId }), [4, i.send(s)];
          case 1:
            return a.sent(), [2];
        }
      });
    });
  }, n.prototype.startTyping = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return e = k.of(this._iid), r = e.requestQueue, i = e.typingIndicatorThrottle, (s = (/* @__PURE__ */ new Date()).getTime()) - this._typingStarted >= i ? (this._typingStarted = s, this._typingEnded = 0, a = new vT({ channelUrl: this.url, time: this._typingStarted }), [4, r.send(a)]) : [3, 2];
          case 1:
            o.sent(), o.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.endTyping = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return e = k.of(this._iid), r = e.requestQueue, i = e.typingIndicatorThrottle, (s = (/* @__PURE__ */ new Date()).getTime()) - this._typingEnded >= i ? (this._typingStarted = 0, this._typingEnded = s, a = new bT({ channelUrl: this.url, time: this._typingStarted }), [4, r.send(a)]) : [3, 2];
          case 1:
            o.sent(), o.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.createScheduledUserMessage = function(e) {
    e = A(A({}, sC), e), Z(function(i) {
      return n_(i) && O("number", i.scheduledAt, !0);
    }(e)).throw(D.invalidParameters);
    var r = new cr();
    return this._createScheduledUserMessage(e, r), r;
  }, n.prototype.updateScheduledUserMessage = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s, a;
      return _(this, function(o) {
        switch (o.label) {
          case 0:
            return i = A(A({}, QT), r), Z(function(l) {
              return s_(l) && O("number", l.scheduledAt, !0);
            }(i)).throw(D.invalidParameters), s = k.of(this._iid).requestQueue, a = new ZT(A({ reqId: this._generateRequestId(), scheduledMessageId: e, channelType: this.channelType, channelUrl: this.url }, i)), [4, s.send(a)];
          case 1:
            return [2, o.sent().as(o_).message];
        }
      });
    });
  }, n.prototype.createScheduledFileMessage = function(e) {
    var r = this;
    e = A(A({}, aC), e), Z(function(o) {
      return wc(o) && O("number", o.scheduledAt) && (qn(o.file) || O("string", o.fileUrl)) && O("string", o.fileName, !0) && O("string", o.mimeType, !0) && O("number", o.fileSize, !0) && (o.thumbnailSizes === null || o.thumbnailSizes === void 0 || o.thumbnailSizes.every(function(l) {
        return O("object", l) && l.maxWidth > 0 && l.maxHeight > 0;
      }));
    }(e)).throw(D.invalidParameters);
    var i = Date.now(), s = this._generateRequestId(), a = new cr();
    return er(2).then(function() {
      var o = r._createPendingScheduledFileMessage(e, s, i);
      Ue(function() {
        return g(r, 0, void 0, function() {
          return _(this, function(l) {
            return [2, a._trigger(o)];
          });
        });
      });
    }), qn(e.file) ? this._uploadFileAndUpdateParams(e).then(function() {
      return r._createScheduledFileMessage(e, a, s, i);
    }) : this._createScheduledFileMessage(e, a, s, i), a;
  }, n.prototype.updateScheduledFileMessage = function(e, r) {
    return g(this, 0, void 0, function() {
      var i, s;
      return _(this, function(a) {
        switch (a.label) {
          case 0:
            return i = A(A({}, WT), r), Z(function(o) {
              return Xd(o) && O("number", o.scheduledAt, !0) && (qn(o.file) || O("string", o.fileUrl)) && O("string", o.fileName, !0) && O("string", o.mimeType, !0) && O("number", o.fileSize, !0) && (o.thumbnailSizes === null || o.thumbnailSizes === void 0 || o.thumbnailSizes.every(function(l) {
                return O("object", l) && l.maxWidth > 0 && l.maxHeight > 0;
              }));
            }(i)).throw(D.invalidParameters), qn(i.file) ? [4, this._uploadFileAndUpdateParams(i)] : [3, 2];
          case 1:
            a.sent(), a.label = 2;
          case 2:
            return s = new YT(A({ reqId: this._generateRequestId(), scheduledMessageId: e, channelType: this.channelType, channelUrl: this.url }, i)), [4, k.of(this._iid).requestQueue.send(s)];
          case 3:
            return [2, a.sent().as($T).message];
        }
      });
    });
  }, n.prototype.cancelScheduledMessage = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = new XT({ scheduledMessageId: e, channelType: this.channelType, channelUrl: this.url }), [4, k.of(this._iid).requestQueue.send(r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.sendScheduledMessageNow = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return r = new JT({ scheduledMessageId: e, channelType: this.channelType, channelUrl: this.url }), [4, k.of(this._iid).requestQueue.send(r)];
          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, n.prototype.getMyPushTriggerOption = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return e = k.of(this._iid), r = e.sdkState, i = e.requestQueue, s = new nw({ userId: r.userId, channelUrl: this.url }), [4, i.send(s)];
          case 1:
            return a = l.sent(), o = a.as(rw).pushTriggerOption, this.myPushTriggerOption = o, [2, o];
        }
      });
    });
  }, n.prototype.setMyPushTriggerOption = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return Z(Ze(xs, e)).throw(D.invalidParameters), r = k.of(this._iid), i = r.dispatcher, s = r.sdkState, a = r.requestQueue, o = new ew({ userId: s.userId, channelUrl: this.url, pushTriggerOption: e }), [4, a.send(o)];
          case 1:
            return l = u.sent(), c = l.as(tw).pushTriggerOption, this.myPushTriggerOption = c, i.dispatch(new it({ channels: [this], context: { source: B.EVENT_CHANNEL_UPDATED }, isWebSocketEventComing: !0 })), [2, c];
        }
      });
    });
  }, n.prototype.setMyCountPreference = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c;
      return _(this, function(u) {
        switch (u.label) {
          case 0:
            return Z(Ze(yr, e)).throw(D.invalidParameters), r = k.of(this._iid), i = r.dispatcher, s = r.sdkState, a = r.requestQueue, o = new VT({ channelUrl: this.url, userId: s.userId, countPreference: e }), [4, a.send(o)];
          case 1:
            return l = u.sent(), c = l.as(GT).countPreference, this.myCountPreference = c, this._updateUnreadCount(this.unreadMessageCount, this.unreadMentionCount), i.dispatch(new it({ channels: [this], context: { source: B.EVENT_CHANNEL_UPDATED }, isWebSocketEventComing: !0 })), [2, c];
        }
      });
    });
  }, n.prototype.resetMyHistory = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return e = k.of(this._iid), r = e.dispatcher, i = e.requestQueue, s = e.sdkState, a = new qT({ channelUrl: this.url, locale: s.localeForChatbot }), [4, i.send(a)];
          case 1:
            return o = c.sent(), l = o.as(KT).messageOffsetTimestamp, this.messageOffsetTimestamp = l, this.lastMessage && this.lastMessage.createdAt < l && (this.lastMessage = null), this._updateUnreadCount(0, 0), this.totalUnreadReplyCount = 0, r.dispatch(new it({ channels: [this], context: { source: B.EVENT_CHANNEL_RESET_HISTORY }, isWebSocketEventComing: !0 })), [2, this];
        }
      });
    });
  }, n.prototype._uploadFileAndUpdateParams = function(e) {
    return g(this, 0, void 0, function() {
      var r, i, s, a, o, l, c, u, d, h;
      return _(this, function(p) {
        switch (p.label) {
          case 0:
            return qn(e.file) ? (r = k.of(this._iid).requestQueue, i = new Zl({ file: e.file, channelUrl: this.url, thumbnailSizes: e.thumbnailSizes, requestId: this._generateRequestId() }), [4, r.send(i)]) : [3, 2];
          case 1:
            s = p.sent(), a = s.as(Xl), o = a.url, l = a.fileSize, c = l === void 0 ? e.fileSize : l, u = a.thumbnails, d = a.requireAuth, h = d !== void 0 && d, e.fileUrl = o, e.fileSize = c, e.requireAuth = h, e._thumbnails = u, p.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, n.prototype.resendMessage = function(e, r) {
    var i, s = this;
    if (Z(e instanceof en && !e.scheduledInfo && e.isResendable).throw(D.invalidParameters), e.isUserMessage()) {
      var a = (i = e.messageParams) !== null && i !== void 0 ? i : ld(e), o = new cr();
      return this._sendUserMessage(a, Rn.RESEND, e.reqId).onPending(function(d) {
        o._trigger(d);
      }).onFailed(function(d, h) {
        o._triggerFailed(d, h);
      }).onSucceeded(function(d) {
        s._tryUpdateLastMessageAndCallEvents(s, d), o._trigger(d);
      }), o;
    }
    if (e.isFileMessage()) {
      var l = this._validateFailedFileMessageHasFile(e, r);
      Z(l).throw(D.invalidParameters), a = cd(e, r);
      var c = new cr();
      return this._sendFileMessage(a, Rn.RESEND, e.reqId).onPending(function(d) {
        c._trigger(d);
      }).onFailed(function(d, h) {
        c._triggerFailed(d, h);
      }).onSucceeded(function(d) {
        s._tryUpdateLastMessageAndCallEvents(s, d), c._trigger(d);
      }), c;
    }
    if (e.isMultipleFilesMessage()) {
      a = e.messageParams;
      var u = new Nl();
      return this._sendMultipleFilesMessage(a, Rn.RESEND, e.reqId).onPending(function(d) {
        u._trigger(d);
      }).onFailed(function(d, h) {
        u._triggerFailed(d, h);
      }).onSucceeded(function(d) {
        s._tryUpdateLastMessageAndCallEvents(s, d), u._trigger(d);
      }).onFileUploaded(function(d, h, p, f) {
        u._triggerOnFileUploaded(d, h, p, f);
      }), u;
    }
  }, n.prototype.copyMessage = function(e, r) {
    var i = this;
    if (Z(e instanceof Wp && r instanceof en && r.sendingStatus === St.SUCCEEDED && this.url === r.channelUrl && !r.scheduledInfo).throw(D.invalidParameters), r.isUserMessage()) {
      Z(!r.poll).throw(D.notSupportedError);
      var s = t_(r), a = new cr();
      return e._sendUserMessage(s).onPending(function(c) {
        a._trigger(c);
      }).onFailed(function(c, u) {
        a._triggerFailed(c, u);
      }).onSucceeded(function(c) {
        e.isGroupChannel() && i._tryUpdateLastMessageAndCallEvents(e, c), a._trigger(c);
      }), a;
    }
    if (r.isFileMessage()) {
      s = r_(r);
      var o = new cr();
      return e._sendFileMessage(s).onPending(function(c) {
        o._trigger(c);
      }).onFailed(function(c, u) {
        o._triggerFailed(c, u);
      }).onSucceeded(function(c) {
        e.isGroupChannel() && i._tryUpdateLastMessageAndCallEvents(e, c), o._trigger(c);
      }), o;
    }
    if (r.isMultipleFilesMessage()) {
      if (e.isGroupChannel()) {
        s = function(c) {
          var u, d, h;
          return (u = c.messageParams) !== null && u !== void 0 ? u : Ae(A(A({}, c), { isReplyToChannel: !1, mentionedUserIds: (d = c.mentionedUserIds) !== null && d !== void 0 ? d : (h = c.mentionedUsers) === null || h === void 0 ? void 0 : h.map(function(p) {
            return p.userId;
          }), pushNotificationDeliveryOption: Yr.DEFAULT, isPinnedMessage: !1, fileInfoList: c.fileInfoList.map(function(p) {
            var f;
            return { fileUrl: p.plainUrl, fileName: p.fileName, fileSize: p.fileSize, mimeType: p.mimeType, thumbnailSizes: (f = p.thumbnails) === null || f === void 0 ? void 0 : f.map(function(m) {
              return { maxWidth: m.width, maxHeight: m.height };
            }), _thumbnails: p.thumbnails, _uploadedMetaData: { requireAuth: p._requireAuth, isUploaded: !0 } };
          }) }));
        }(r);
        var l = new Nl();
        return e._sendMultipleFilesMessage(s, Rn.COPY).onPending(function(c) {
          l._trigger(c);
        }).onFailed(function(c, u) {
          l._triggerFailed(c, u);
        }).onSucceeded(function(c) {
          i._tryUpdateLastMessageAndCallEvents(e, c), l._trigger(c);
        }).onFileUploaded(function(c, u, d, h) {
          l._triggerOnFileUploaded(c, u, d, h);
        }), l;
      }
      throw D.channelTypeNotSupportedError;
    }
  }, n;
}(Wp), qi = {}, iw = function() {
  function t(n) {
    var e = n._iid, r = n.limit, i = r === void 0 ? 100 : r, s = this;
    this.ref = 0, this._iid = e, this._limit = i;
    var a, o = k.of(this._iid), l = o.sdkState, c = o.dispatcher, u = o.logger, d = o.cacheContext, h = o.statManager;
    this._metadataKey = (a = l.userId, "sendbird:".concat(a, "@groupchannel/sync.meta"));
    var p = function(f) {
      return "sendbird:".concat(f, "@groupchannel/sync");
    }(l.userId);
    this._sync = new os(p, function() {
      return g(s, 0, void 0, function() {
        var f, m, v, E, y, b, T, w, N, M, I, x, R, L, j, P;
        return _(this, function(q) {
          switch (q.label) {
            case 0:
              return f = { hasNext: !0, nextToken: "" }, [4, this.loadMetadata()];
            case 1:
              if (q.sent(), u.debug("channel background sync from", (N = this._metadata) === null || N === void 0 ? void 0 : N.token), (M = this._metadata) === null || M === void 0 ? void 0 : M.completed)
                return [3, 14];
              m = { includeEmpty: !0, includeMetaData: !0, order: nn.CHRONOLOGICAL }, q.label = 2;
            case 2:
              if (q.trys.push([2, 9, 12, 13]), m.order !== nn.LATEST_LAST_MESSAGE)
                return [3, 6];
              q.label = 3;
            case 3:
              return q.trys.push([3, 5, , 6]), [4, d.preference.get(Gd(l.appId))];
            case 4:
              return v = q.sent(), m.includeChatNotification = !!v, [3, 6];
            case 5:
              return q.sent(), m.includeChatNotification = !1, [3, 6];
            case 6:
              return [4, vn.of(this._iid).getMyGroupChannels((x = (I = this._metadata) === null || I === void 0 ? void 0 : I.token) !== null && x !== void 0 ? x : "", m, this._limit, B.SYNC_CHANNEL_BACKGROUND)];
            case 7:
              return E = q.sent(), y = E.channels, b = E.token, f.hasNext = y.length >= this._limit && !!b, f.nextToken = b, this._metadata && (this._metadata.token = b, (w = this._metadata.range).extends.apply(w, Re([], we(y.map(function(G) {
                return G.createdAt;
              })), !1)), this._metadata.completed = !f.hasNext), u.debug("channel background sync progress", f), [4, this.saveMetadata()];
            case 8:
              return q.sent(), [3, 13];
            case 9:
              return T = q.sent(), u.debug("channel background sync error", T), T instanceof D && T.isInvalidTokenError ? [4, this.clearMetaData()] : [3, 11];
            case 10:
              q.sent(), q.label = 11;
            case 11:
              throw T;
            case 12:
              return h.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: "", measured_on: "channel_back_sync", event: "cache_fetch", max_db_size: (L = (R = d.localCacheConfig) === null || R === void 0 ? void 0 : R.maxSize) !== null && L !== void 0 ? L : 0, use_local_cache: d.localCacheEnabled, starting_point: 0, message_init_policy: (P = (j = m.order) === null || j === void 0 ? void 0 : j.toString()) !== null && P !== void 0 ? P : "", collection_id: l.userId } })), [7];
            case 13:
              return [3, 15];
            case 14:
              f.hasNext = !1, f.nextToken = "", q.label = 15;
            case 15:
              return [2, f];
          }
        });
      });
    }), this._connectionEventContext = c.on(function(f) {
      f instanceof Ar && (f.stateType === bt.CONNECTED ? s.resume() : s.pause());
    });
  }
  return t.of = function(n) {
    return qi[n] || (qi[n] = new t({ _iid: n })), qi[n].ref++, qi[n];
  }, t.clear = function(n) {
    qi[n] && (qi[n].close(), delete qi[n]);
  }, Object.defineProperty(t.prototype, "range", { get: function() {
    var n, e;
    return (e = (n = this._metadata) === null || n === void 0 ? void 0 : n.range) !== null && e !== void 0 ? e : new ci({});
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "completed", { get: function() {
    var n;
    return !!(!((n = this._metadata) === null || n === void 0) && n.completed);
  }, enumerable: !1, configurable: !0 }), t.prototype.loadMetadata = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return this._metadata ? [3, 2] : [4, k.of(this._iid).cacheContext.preference.get(this._metadataKey)];
          case 1:
            n = e.sent(), this._metadata = { token: n ? n.token : "", range: new ci(n ? n.range : { top: Number.MAX_SAFE_INTEGER, bottom: 0 }), completed: !!n && n.completed }, e.label = 2;
          case 2:
            return [2, this._metadata];
        }
      });
    });
  }, t.prototype.saveMetadata = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return this._metadata ? [4, k.of(this._iid).cacheContext.preference.set(this._metadataKey, this._metadata)] : [3, 2];
          case 1:
            return n.sent(), [2, !0];
          case 2:
            return [2, !1];
        }
      });
    });
  }, t.prototype.clearMetaData = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, k.of(this._iid).cacheContext.preference.remove(this._metadataKey)];
          case 1:
            return n.sent(), this._metadata = void 0, [2];
        }
      });
    });
  }, t.prototype.resume = function() {
    var n, e, r = k.of(this._iid), i = r.logger;
    r.sessionManager.session.hasSession && (i.debug("channel background sync resume()"), this._sync.start((e = (n = this._metadata) === null || n === void 0 ? void 0 : n.token) !== null && e !== void 0 ? e : ""));
  }, t.prototype.pause = function() {
    k.of(this._iid).logger.debug("channel background sync stop()"), this._sync.stop();
  }, t.prototype.close = function() {
    this.ref--, this.ref <= 0 && (this.ref = 0, this.pause(), this._connectionEventContext.close(), delete qi[this._iid]);
  }, t;
}(), Ki = {}, sw = function() {
  function t(n) {
    var e = n._iid, r = this;
    this.ref = 0, this._iid = e;
    var i, s = k.of(this._iid), a = s.logger, o = s.sdkState, l = s.dispatcher, c = s.cacheContext, u = s.statManager;
    this._metadataKey = (i = o.userId, "sendbird:".concat(i, "@groupchannel/changelogs.meta")), this._subscribers = new Qs();
    var d = function(h) {
      return "sendbird:".concat(h, "@groupchannel/changelogs");
    }(o.userId);
    this._sync = new os(d, function() {
      return g(r, 0, void 0, function() {
        var h, p, f, m, v, E, y, b, T, w, N, M;
        return _(this, function(I) {
          switch (I.label) {
            case 0:
              return h = { hasNext: !0, nextToken: 0 }, [4, this.loadMetadata()];
            case 1:
              I.sent(), a.debug("channel changelog sync from", (w = this._metadata) === null || w === void 0 ? void 0 : w.token), I.label = 2;
            case 2:
              I.trys.push([2, 9, , 12]), p = { includeEmpty: !0, includeMetaData: !0 }, I.label = 3;
            case 3:
              return I.trys.push([3, 5, , 6]), [4, c.preference.get(Gd(o.appId))];
            case 4:
              return f = I.sent(), p.includeChatNotification = !!f, [3, 6];
            case 5:
              return I.sent(), p.includeChatNotification = !1, [3, 6];
            case 6:
              return [4, vn.of(this._iid).getMyGroupChannelChangeLogs((M = (N = this._metadata) === null || N === void 0 ? void 0 : N.token) !== null && M !== void 0 ? M : "", p, B.SYNC_CHANNEL_CHANGELOGS)];
            case 7:
              return m = I.sent(), v = m.updatedChannels, E = m.deletedChannelUrls, y = m.hasMore, b = m.token, this._subscribers.dispatch("progress", { updatedChannels: v, deletedChannelUrls: E, hasMore: y, token: b }), h.hasNext = y, h.nextToken = b, this._metadata && (this._metadata.token = b), a.debug("channel changelog sync progress", h), [4, this.saveMetadata()];
            case 8:
              return I.sent(), c.localCacheEnabled && u.put(new Zt({ type: Ft.FEATURE_LOCALCACHE_EVENT, ts: Date.now(), data: { channel_url: "", measured_on: "channel_change_log_sync", event: v.length > 0 || E.length > 0 ? "cache_miss" : "cache_hit", max_db_size: v.length, use_local_cache: c.localCacheEnabled, starting_point: 0, message_init_policy: E.length.toString(), collection_id: o.userId } })), [3, 12];
            case 9:
              return T = I.sent(), a.debug("channel changelog sync error", T), T instanceof D && T.isInvalidTokenError ? [4, this.clearMetadata()] : [3, 11];
            case 10:
              I.sent(), I.label = 11;
            case 11:
              throw T;
            case 12:
              return [2, h];
          }
        });
      });
    }), this._sync.on("stop", function() {
      r._subscribers.dispatch("pause");
    }), this._connectionEventContext = l.on(function(h) {
      h instanceof Ar && (h.stateType === bt.CONNECTED ? r.resume() : r.pause());
    });
  }
  return t.of = function(n) {
    return Ki[n] || (Ki[n] = new t({ _iid: n })), Ki[n].ref++, Ki[n];
  }, t.clear = function(n) {
    Ki[n] && (Ki[n].close(), delete Ki[n]);
  }, Object.defineProperty(t.prototype, "isRunning", { get: function() {
    return this._sync.isRunning;
  }, enumerable: !1, configurable: !0 }), t.prototype.loadMetadata = function() {
    return g(this, 0, void 0, function() {
      var n, e, r, i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return this._metadata ? [3, 2] : (n = k.of(this._iid), e = n.cacheContext, r = n.firstConnectedAt, [4, e.preference.get(this._metadataKey)]);
          case 1:
            i = s.sent(), this._metadata = { token: i ? i.token : r }, s.label = 2;
          case 2:
            return [2, this._metadata];
        }
      });
    });
  }, t.prototype.saveMetadata = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return this._metadata ? [4, k.of(this._iid).cacheContext.preference.set(this._metadataKey, this._metadata)] : [3, 2];
          case 1:
            return n.sent(), [2, !0];
          case 2:
            return [2, !1];
        }
      });
    });
  }, t.prototype.clearMetadata = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, k.of(this._iid).cacheContext.preference.remove(this._metadataKey)];
          case 1:
            return n.sent(), this._metadata = void 0, [2];
        }
      });
    });
  }, t.prototype.on = function(n, e) {
    return this._subscribers.on(n, e);
  }, t.prototype.resume = function() {
    k.of(this._iid).sessionManager.session.hasSession && this._sync.start(0);
  }, t.prototype.pause = function() {
    this._sync.stop();
  }, t.prototype.close = function() {
    this.ref--, this.ref <= 0 && (this.ref = 0, this.pause(), this._connectionEventContext.close(), delete Ki[this._iid]);
  }, t;
}(), kl = function(t, n) {
  return t.findIndex(function(e) {
    return e.isIdentical(n);
  });
}, ff = function(t, n, e) {
  if (t.length > 0) {
    for (var r = kl(t, n), i = 0, s = t.length - 1, a = Math.floor((i + s) / 2); i < s; ) {
      var o = mf(t[a], n, e);
      if (o > 0)
        s = a, a = Math.floor((i + s) / 2);
      else {
        if (!(o < 0))
          return { place: a, oldPosition: r };
        i = a + 1, a = Math.floor((i + s) / 2);
      }
    }
    return { place: mf(t[a], n, e) >= 0 ? a : a + 1, oldPosition: r };
  }
  return { place: t.length, oldPosition: -1 };
}, mf = function(t, n, e) {
  switch (e) {
    case nn.LATEST_LAST_MESSAGE:
      return t.lastMessage && n.lastMessage ? (r = n.lastMessage.createdAt - t.lastMessage.createdAt) == 0 ? n.createdAt - t.createdAt : r : t.lastMessage ? -1 : n.lastMessage ? 1 : n.createdAt - t.createdAt;
    case nn.CHRONOLOGICAL:
      return n.createdAt - t.createdAt;
    case nn.CHANNEL_NAME_ALPHABETICAL:
      var r;
      return (r = t.name.localeCompare(n.name)) === 0 ? t.createdAt - n.createdAt : r;
    default:
      return 0;
  }
}, aw = function() {
  function t(n, e) {
    var r = e.filter, i = r === void 0 ? new E_() : r, s = e.order, a = s === void 0 ? nn.LATEST_LAST_MESSAGE : s, o = e.limit, l = o === void 0 ? 100 : o, c = e.includeChangesOnInitialLoad, u = c !== void 0 && c, d = this;
    this.channels = [], this._isInitialized = !1, this._iid = n, this._key = "gcc-".concat(Pi()), this._isDisposed = !1, this._isGetRemoteChannelsSucceeded = !0, this._includeChangesOnInitialLoad = u, this.filter = i, this.order = a, this._hasMore = !0, this._token = "", this._limit = l;
    var h = k.of(this._iid), p = h.sdkState, f = h.cacheContext, m = h.dispatcher;
    f.localCacheEnabled && (this._backgroundSync = iw.of(n), this._backgroundSync.resume()), this._changelogSync = sw.of(n), this._changelogSync.resume(), vn.of(this._iid).subscribeChannelEvent(this._key, { onUpdate: function(v, E) {
      var y = E.source;
      if (xl(y)) {
        var b = v.filter(function(w) {
          return d.filter.match(w, p.userId);
        }), T = v.filter(function(w) {
          return !d.filter.match(w, p.userId);
        }).map(function(w) {
          return w.url;
        });
        b.length > 0 && d._addChannelsToView(b, E), T.length > 0 && d._removeChannelsFromView(T, E);
      }
    }, onRemove: function(v, E) {
      d._removeChannelsFromView(v, E);
    } }), m.on(function(v) {
      v instanceof Ar && (v.stateType === bt.CONNECTED ? d._isGetRemoteChannelsSucceeded || g(d, 0, void 0, function() {
        return _(this, function(E) {
          switch (E.label) {
            case 0:
              return [4, this._revokeLoadMore()];
            case 1:
              return E.sent(), [2];
          }
        });
      }) : v.stateType === bt.LOGOUT && d.dispose());
    });
  }
  return Object.defineProperty(t.prototype, "hasMore", { get: function() {
    return !this._isDisposed && this._hasMore;
  }, enumerable: !1, configurable: !0 }), t.prototype.setGroupChannelCollectionHandler = function(n) {
    this._handler = n;
  }, t.prototype._addChannelsToView = function(n, e, r) {
    var i, s, a, o, l = this;
    r === void 0 && (r = !1);
    var c = [], u = [], d = [];
    try {
      for (var h = de(n), p = h.next(); !p.done; p = h.next()) {
        var f = p.value, m = kl(this.channels, f);
        m >= 0 && this.channels.splice(m, 1);
        var v = ff(this.channels, f, this.order).place;
        if (m < 0)
          v === this.channels.length ? !r && this._hasMore || (c.push(f), this.channels.push(f)) : (c.push(f), this.channels.splice(v, 0, f));
        else
          switch (e.source) {
            case B.EVENT_CHANNEL_UPDATED:
            case B.EVENT_MESSAGE_RECEIVED:
            case B.SYNC_CHANNEL_CHANGELOGS:
            case B.EVENT_MESSAGE_SENT:
              this.order === nn.CHANNEL_NAME_ALPHABETICAL && this._hasMore && v === this.channels.length ? d.push(f) : (this.channels.splice(v, 0, f), u.push(f));
              break;
            default:
              this.channels.splice(v, 0, f), u.push(f);
          }
      }
    } catch (T) {
      i = { error: T };
    } finally {
      try {
        p && !p.done && (s = h.return) && s.call(h);
      } finally {
        if (i)
          throw i.error;
      }
    }
    if (d.length > 0)
      try {
        for (var E = de(d), y = E.next(); !y.done; y = E.next()) {
          f = y.value;
          var b = kl(this.channels, f);
          b !== -1 && this.channels.splice(b, 1);
        }
      } catch (T) {
        a = { error: T };
      } finally {
        try {
          y && !y.done && (o = E.return) && o.call(E);
        } finally {
          if (a)
            throw a.error;
        }
      }
    xl(e.source) && Ue(function() {
      return g(l, 0, void 0, function() {
        var T, w, N;
        return _(this, function(M) {
          return c.length > 0 && (!((T = this._handler) === null || T === void 0) && T.onChannelsAdded) && this._handler.onChannelsAdded(e, c), u.length > 0 && (!((w = this._handler) === null || w === void 0) && w.onChannelsUpdated) && this._handler.onChannelsUpdated(e, u), d.length > 0 && (!((N = this._handler) === null || N === void 0) && N.onChannelsDeleted) && this._handler.onChannelsDeleted(e, d.map(function(I) {
            return I.url;
          })), [2];
        });
      });
    });
  }, t.prototype._removeChannelsFromView = function(n, e) {
    var r, i, s = this, a = [], o = function(d) {
      var h = l.channels.findIndex(function(p) {
        return p.url === d;
      });
      h >= 0 && (a.push(l.channels[h].url), l.channels.splice(h, 1));
    }, l = this;
    try {
      for (var c = de(n), u = c.next(); !u.done; u = c.next())
        o(u.value);
    } catch (d) {
      r = { error: d };
    } finally {
      try {
        u && !u.done && (i = c.return) && i.call(c);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return xl(e.source) && a.length > 0 && Ue(function() {
      return g(s, 0, void 0, function() {
        var d;
        return _(this, function(h) {
          return !((d = this._handler) === null || d === void 0) && d.onChannelsDeleted && this._handler.onChannelsDeleted(e, a), [2];
        });
      });
    }), a;
  }, t.prototype._getLocalChannels = function() {
    return g(this, 0, void 0, function() {
      var n, e;
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return n = vn.of(this._iid), e = this.channels.length > 0 ? function(i, s) {
              var a, o, l, c;
              switch (s) {
                case nn.LATEST_LAST_MESSAGE:
                  return (o = (a = i.lastMessage) === null || a === void 0 ? void 0 : a.createdAt) !== null && o !== void 0 ? o : i.createdAt;
                case nn.CHRONOLOGICAL:
                  return i.createdAt;
                case nn.CHANNEL_NAME_ALPHABETICAL:
                  return i.name;
                default:
                  return (c = (l = i.lastMessage) === null || l === void 0 ? void 0 : l.createdAt) !== null && c !== void 0 ? c : i.createdAt;
              }
            }(this.channels[this.channels.length - 1], this.order) : null, [4, n.getChannelsFromCache(e, this.filter, this.order, this._limit, e ? this.channels[this.channels.length - 1].url : void 0)];
          case 1:
            return [2, r.sent()];
        }
      });
    });
  }, t.prototype._getRemoteChannels = function() {
    return g(this, 0, void 0, function() {
      var n, e, r;
      return _(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, vn.of(this._iid).getMyGroupChannels(this._token, Ae(A(A({}, this.filter), { userIdsFilter: this.filter.userIdsFilter, searchFilter: this.filter.searchFilter, order: this.order })), this._limit)];
          case 1:
            return n = i.sent(), e = n.channels, r = n.token, this._token = r, this._hasMore = !!r, [2, e];
        }
      });
    });
  }, t.prototype._revokeLoadMore = function() {
    return g(this, 0, void 0, function() {
      var n;
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            if (this._isDisposed)
              return [2];
            e.label = 1;
          case 1:
            return e.trys.push([1, 3, , 4]), [4, this._getRemoteChannels()];
          case 2:
            return n = e.sent(), this._isGetRemoteChannelsSucceeded = !0, this._addChannelsToView(n, { source: B.REQUEST_CHANNEL }, !0), [3, 4];
          case 3:
            return e.sent(), this._isGetRemoteChannelsSucceeded = !1, [3, 4];
          case 4:
            return [2];
        }
      });
    });
  }, t.prototype.loadMore = function() {
    var n;
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w = this;
      return _(this, function(N) {
        switch (N.label) {
          case 0:
            if (this._isDisposed)
              throw new D({ code: me.COLLECTION_DISPOSED, message: "Collection has been disposed." });
            return e = null, this._includeChangesOnInitialLoad && this.channels.length === 0 && this._changelogSync.isRunning ? [4, new Promise(function(M) {
              w._changelogSyncSubscriberContext = w._changelogSync.on("progress", function(I) {
                return M(I);
              }).on("pause", function() {
                return M(null);
              });
            })] : [3, 2];
          case 1:
            e = N.sent(), (n = this._changelogSyncSubscriberContext) === null || n === void 0 || n.close(), N.label = 2;
          case 2:
            return r = k.of(this._iid), i = r.cacheContext, s = r.connectionManager, a = r.statManager, this._isInitialized ? [3, 5] : (this._isInitialized = !0, i.localCacheEnabled ? [4, this._backgroundSync.loadMetadata()] : [3, 4]);
          case 3:
            N.sent(), N.label = 4;
          case 4:
            a.put(new No({ type: Ft.FEATURE_LOCALCACHE, data: { use_local_cache: i.localCacheEnabled, collection_interface: { group_channel: !0 } } })), N.label = 5;
          case 5:
            return o = [], this._hasMore ? !i.localCacheEnabled || s.isConnected && !this._backgroundSync.completed ? [3, 7] : [4, tn(function() {
              return g(w, 0, void 0, function() {
                return _(this, function(M) {
                  switch (M.label) {
                    case 0:
                      return [4, this._getLocalChannels()];
                    case 1:
                      return o = M.sent(), [2];
                  }
                });
              });
            })] : [3, 11];
          case 6:
            return N.sent(), this._hasMore = o.length >= this._limit, [3, 10];
          case 7:
            return N.trys.push([7, 9, , 10]), [4, this._getRemoteChannels()];
          case 8:
            return o = N.sent(), this._isGetRemoteChannelsSucceeded = !0, [3, 10];
          case 9:
            return N.sent(), this._isGetRemoteChannelsSucceeded = !1, [3, 10];
          case 10:
            this._addChannelsToView(o, { source: B.REQUEST_CHANNEL }, !0), N.label = 11;
          case 11:
            if (e) {
              try {
                for (l = de(e.updatedChannels), c = l.next(); !c.done; c = l.next())
                  u = c.value, (v = kl(o, u)) >= 0 ? o[v] = u : (d = ff(o, u, this.order).place, o.splice(d, 0, u));
              } catch (M) {
                E = { error: M };
              } finally {
                try {
                  c && !c.done && (y = l.return) && y.call(l);
                } finally {
                  if (E)
                    throw E.error;
                }
              }
              h = o.map(function(M) {
                return M.url;
              });
              try {
                for (p = de(e.deletedChannelUrls), f = p.next(); !f.done; f = p.next())
                  m = f.value, (v = h.indexOf(m)) >= 0 && (o.splice(v, 1), h.splice(v, 1));
              } catch (M) {
                b = { error: M };
              } finally {
                try {
                  f && !f.done && (T = p.return) && T.call(p);
                } finally {
                  if (b)
                    throw b.error;
                }
              }
            }
            return [2, o];
        }
      });
    });
  }, t.prototype.dispose = function() {
    var n, e, r;
    this._isDisposed || (this._isDisposed = !0, this.channels.length > 0 && this.channels.splice(0, this.channels.length), (n = this._backgroundSync) === null || n === void 0 || n.close(), (e = this._changelogSync) === null || e === void 0 || e.close(), (r = this._changelogSyncSubscriberContext) === null || r === void 0 || r.close(), vn.of(this._iid).unsubscribeChannelEvent(this._key));
  }, t;
}(), ow = function(t) {
  function n(e) {
    var r = this, i = e.token, s = e.limit, a = e.order, o = e.includeEmpty, l = e.membershipFilter, c = e.channelNameContainsFilter, u = e.channelUrlsFilter, d = e.customTypesFilter, h = e.customTypeStartsWithFilter, p = e.superChannelFilter, f = e.metadataOrderKeyFilter, m = e.metadataKey, v = e.metadataValues, E = e.metadataValueStartsWith, y = e.includeFrozen, b = e.includeMetaData;
    return (r = t.call(this) || this).method = Y.GET, r.path = Wn, r.params = fe(Ae({ token: i, limit: s, order: a, show_member: !0, show_read_receipt: !0, show_delivery_receipt: !0, show_empty: o, public_mode: pi.PUBLIC, public_membership_mode: l, name_contains: c, channel_urls: u, custom_types: d, custom_type_startswith: h, super_mode: p, metadata_order_key: f, metadata_key: m, metadata_values: v, metadata_value_startswith: E, show_frozen: y, show_metadata: b })), r;
  }
  return S(n, t), n;
}($), lw = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    i.channels = [];
    var s = r.next, a = r.channels, o = r.ts;
    return i.token = s, a && a.length > 0 && (i.channels = a.map(function(l) {
      return l.ts = o, new Ir(e, l);
    })), i.ts = typeof o == "number" ? o : 0, i;
  }
  return S(n, t), n;
}(ne);
(function(t) {
  t.ALL = "all", t.JOINED = "joined";
})(yo || (yo = {}));
var cw = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c, u, d, h, p, f, m, v, E, y = this;
    return (y = t.call(this, e, r) || this).includeEmpty = !1, y.includeFrozen = !0, y.includeMetaData = !0, y.channelUrlsFilter = null, y.customTypesFilter = null, y.customTypeStartsWithFilter = null, y.channelNameContainsFilter = null, y.membershipFilter = yo.ALL, y.superChannelFilter = ar.ALL, y.metadataKey = null, y.metadataValues = null, y.metadataOrderKeyFilter = null, y.metadataValueStartsWith = null, y.order = mo.CHRONOLOGICAL, y.includeEmpty = (i = r.includeEmpty) !== null && i !== void 0 && i, y.includeFrozen = (s = r.includeFrozen) === null || s === void 0 || s, y.includeMetaData = (a = r.includeMetaData) === null || a === void 0 || a, y.channelUrlsFilter = (o = r.channelUrlsFilter) !== null && o !== void 0 ? o : null, y.customTypesFilter = (l = r.customTypesFilter) !== null && l !== void 0 ? l : null, y.customTypeStartsWithFilter = (c = r.customTypeStartsWithFilter) !== null && c !== void 0 ? c : null, y.channelNameContainsFilter = (u = r.channelNameContainsFilter) !== null && u !== void 0 ? u : null, y.membershipFilter = (d = r.membershipFilter) !== null && d !== void 0 ? d : yo.ALL, y.superChannelFilter = (h = r.superChannelFilter) !== null && h !== void 0 ? h : ar.ALL, y.metadataKey = (p = r.metadataKey) !== null && p !== void 0 ? p : null, y.metadataValues = (f = r.metadataValues) !== null && f !== void 0 ? f : null, y.metadataOrderKeyFilter = (m = r.metadataOrderKeyFilter) !== null && m !== void 0 ? m : null, y.metadataValueStartsWith = (v = r.metadataValueStartsWith) !== null && v !== void 0 ? v : null, y.order = (E = r.order) !== null && E !== void 0 ? E : mo.CHRONOLOGICAL, y;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this) && O("boolean", this.includeEmpty) && O("boolean", this.includeFrozen) && O("boolean", this.includeMetaData) && O("string", this.channelNameContainsFilter, !0) && tt("string", this.channelUrlsFilter, !0) && tt("string", this.customTypesFilter, !0) && O("string", this.customTypeStartsWithFilter, !0) && Ze(yo, this.membershipFilter) && Ze(ar, this.superChannelFilter) && Ze(mo, this.order) && O("string", this.metadataOrderKeyFilter, !0) && O("string", this.metadataKey, !0) && tt("string", this.metadataValues, !0) && O("string", this.metadataValueStartsWith, !0);
  }, n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o, l;
      return _(this, function(c) {
        switch (c.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : (e = [], this._hasNext ? (this._isLoading = !0, r = k.of(this._iid).requestQueue, i = new ow(Ae(A(A({}, this), { token: this._token }))), [4, r.send(i)]) : [3, 2]) : [3, 5];
          case 1:
            return s = c.sent(), a = s.as(lw), o = a.channels, l = a.token, this._token = l, this._hasNext = !!l, this._isLoading = !1, [2, o];
          case 2:
            return [2, e];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(cs), S_ = function(t) {
  function n(e) {
    e === void 0 && (e = {});
    var r = t.call(this) || this;
    return Object.keys(e).forEach(function(i) {
      r.hasOwnProperty(i) && (r[i] = e[i]);
    }), r;
  }
  return S(n, t), n;
}(function(t) {
  function n() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e.onUserJoined = rt, e.onUserLeft = rt, e.onUserReceivedInvitation = rt, e.onUserDeclinedInvitation = rt, e.onChannelHidden = rt, e.onUnreadMemberStatusUpdated = rt, e.onUndeliveredMemberStatusUpdated = rt, e.onTypingStatusUpdated = rt, e.onPollUpdated = rt, e.onPollVoted = rt, e.onPollDeleted = rt, e.onPinnedMessageUpdated = rt, e;
  }
  return S(n, t), n;
}(function() {
  this.onUserMuted = rt, this.onUserUnmuted = rt, this.onUserBanned = rt, this.onUserUnbanned = rt, this.onChannelChanged = rt, this.onChannelDeleted = rt, this.onChannelFrozen = rt, this.onChannelUnfrozen = rt, this.onOperatorUpdated = rt, this.onChannelMemberCountChanged = rt, this.onMetaDataCreated = rt, this.onMetaDataUpdated = rt, this.onMetaDataDeleted = rt, this.onMetaCounterCreated = rt, this.onMetaCounterUpdated = rt, this.onMetaCounterDeleted = rt, this.onMessageReceived = rt, this.onMessageUpdated = rt, this.onMessageDeleted = rt, this.onMentionReceived = rt, this.onReactionUpdated = rt, this.onThreadInfoUpdated = rt;
})), uw = function(t) {
  function n(e) {
    var r = this, i = e.token, s = e.limit, a = e.order, o = e.reverse, l = e.channelUrl, c = e.messageTypeFilter, u = e.scheduledStatus;
    return (r = t.call(this) || this).method = Y.GET, r.path = "".concat(nm), r.params = fe(Ae({ token: i, limit: s, reverse: o, channel_url: l, order: a, message_type: c, status: u })), r;
  }
  return S(n, t), n;
}($), dw = function(t) {
  function n(e, r) {
    var i = t.call(this, e, r) || this;
    i.scheduledMessages = [];
    var s = r.next, a = r.scheduled_messages;
    return i.token = s, i.scheduledMessages = a.map(function(o) {
      return Kn(e, o);
    }), i;
  }
  return S(n, t), n;
}(ne), hw = function(t) {
  function n(e, r) {
    var i, s, a, o, l, c = this;
    return (c = t.call(this, e, r) || this).channelUrl = null, c.order = null, c.reverse = !1, c.scheduledStatus = null, c.messageTypeFilter = Pn.ALL, c.channelUrl = (i = r.channelUrl) !== null && i !== void 0 ? i : null, c.order = (s = r.order) !== null && s !== void 0 ? s : null, c.reverse = (a = r.reverse) !== null && a !== void 0 && a, c.scheduledStatus = (o = r.scheduledStatus) !== null && o !== void 0 ? o : null, c.messageTypeFilter = (l = r.messageTypeFilter) !== null && l !== void 0 ? l : Pn.ALL, c;
  }
  return S(n, t), n.prototype._validate = function() {
    return t.prototype._validate.call(this) && O("string", this.channelUrl, !0) && (Ze(md, this.order) || this.order === null) && O("boolean", this.reverse) && (tt(es, this.scheduledStatus) || this.scheduledStatus === null) && Ze(Pn, this.messageTypeFilter);
  }, n.prototype.next = function() {
    return g(this, 0, void 0, function() {
      var e, r, i, s, a, o;
      return _(this, function(l) {
        switch (l.label) {
          case 0:
            return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = k.of(this._iid).requestQueue, r = new uw(Ae(A(A({}, this), { token: this._token }))), [4, e.send(r)]) : [3, 2] : [3, 5];
          case 1:
            return i = l.sent(), s = i.as(dw), a = s.scheduledMessages, o = s.token, this._token = o, this._hasNext = !!o, this._isLoading = !1, [2, a];
          case 2:
            return [2, []];
          case 3:
            throw D.queryInProgress;
          case 4:
            return [3, 6];
          case 5:
            throw D.invalidParameters;
          case 6:
            return [2];
        }
      });
    });
  }, n;
}(cs), pw = function(t) {
  function n() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e.name = "groupChannel", e;
  }
  return S(n, t), n.prototype.init = function(e, r) {
    var i = r.sdkState, s = r.dispatcher, a = r.sessionManager, o = r.requestQueue, l = r.logger, c = r.onlineDetector, u = r.cacheContext;
    t.prototype.init.call(this, e, { sdkState: i, dispatcher: s, sessionManager: a, requestQueue: o, logger: l, onlineDetector: c, cacheContext: u }), this._manager = new vn(e, { sdkState: i, cacheContext: u, dispatcher: s, sessionManager: a, requestQueue: o, logger: l });
  }, n.prototype.createGroupChannelCollection = function(e) {
    return e === void 0 && (e = {}), new aw(this._iid, e);
  }, n.prototype.createMyGroupChannelListQuery = function(e) {
    return e === void 0 && (e = {}), new w_(this._iid, e);
  }, n.prototype.createPublicGroupChannelListQuery = function(e) {
    return e === void 0 && (e = {}), new cw(this._iid, e);
  }, n.prototype.createScheduledMessageListQuery = function(e) {
    return e === void 0 && (e = {}), new hw(this._iid, e);
  }, n.prototype.addGroupChannelHandler = function(e, r) {
    Z(O("string", e) && r instanceof S_).throw(D.invalidParameters), this._manager.addHandler(e, r);
  }, n.prototype.removeGroupChannelHandler = function(e) {
    Z(O("string", e)).throw(D.invalidParameters), this._manager.removeHandler(e);
  }, n.prototype.removeAllGroupChannelHandlers = function() {
    this._manager.clearHandler();
  }, n.prototype.buildGroupChannelFromSerializedData = function(e) {
    return this._manager.buildGroupChannelFromSerializedData(e);
  }, n.prototype.buildGroupChannelListQueryFromSerializedData = function(e) {
    return this._manager.buildGroupChannelListQueryFromSerializedData(e);
  }, n.prototype.buildMemberFromSerializedData = function(e) {
    return this._manager.buildMemberFromSerializedData(e);
  }, n.prototype.getChannel = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return Z(O("string", e)).throw(D.invalidParameters), [2, this._manager.getChannel(e)];
      });
    });
  }, n.prototype.getChannelWithoutCache = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return Z(O("string", e)).throw(D.invalidParameters), [2, this._manager.getChannelWithoutCache(e)];
      });
    });
  }, n.prototype.getMyGroupChannelChangeLogsByToken = function(e, r) {
    return r === void 0 && (r = {}), g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = A(A({}, ac), r), Z(O("string", e) && gd(i)).throw(D.invalidParameters), [4, this._manager.getMyGroupChannelChangeLogs(e, i)];
          case 1:
            return [2, s.sent()];
        }
      });
    });
  }, n.prototype.getMyGroupChannelChangeLogsByTimestamp = function(e, r) {
    return r === void 0 && (r = {}), g(this, 0, void 0, function() {
      var i;
      return _(this, function(s) {
        switch (s.label) {
          case 0:
            return i = A(A({}, ac), r), Z(O("number", e) && gd(i)).throw(D.invalidParameters), [4, this._manager.getMyGroupChannelChangeLogs(e, i)];
          case 1:
            return [2, s.sent()];
        }
      });
    });
  }, n.prototype.getGroupChannelCount = function(e) {
    return g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        return r = A(A({}, C_), e), Z(T_(r)).throw(D.invalidParameters), [2, this._manager.getGroupChannelCount(r)];
      });
    });
  }, n.prototype.getUnreadItemCount = function(e) {
    return e === void 0 && (e = {}), g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._manager.getUnreadItemCount(e)];
          case 1:
            return [2, r.sent()];
        }
      });
    });
  }, n.prototype.getTotalUnreadChannelCount = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this._manager.getTotalUnreadChannelCount()];
          case 1:
            return [2, e.sent()];
        }
      });
    });
  }, n.prototype.getTotalUnreadMessageCount = function(e) {
    return e === void 0 && (e = {}), g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._manager.getTotalUnreadMessageCount(e)];
          case 1:
            return [2, r.sent()];
        }
      });
    });
  }, n.prototype.getTotalScheduledMessageCount = function(e) {
    return e === void 0 && (e = {}), g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this._manager.getTotalScheduledMessageCount(e)];
          case 1:
            return [2, r.sent()];
        }
      });
    });
  }, n.prototype.getSubscribedTotalUnreadMessageCount = function() {
    return this._manager.getSubscribedTotalUnreadMessageCount();
  }, n.prototype.getSubscribedCustomTypeTotalUnreadMessageCount = function() {
    return this._manager.getSubscribedCustomTypeTotalUnreadMessageCount();
  }, n.prototype.getSubscribedCustomTypeUnreadMessageCount = function(e) {
    return this._manager.getSubscribedCustomTypeUnreadMessageCount(e);
  }, n.prototype.createChannel = function(e) {
    return e === void 0 && (e = {}), g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        return r = A(A({}, Ml), e), Z(_d(r)).throw(D.invalidParameters), [2, this._manager.createChannel(r)];
      });
    });
  }, n.prototype.createDistinctChannelIfNotExist = function(e) {
    return e === void 0 && (e = {}), g(this, 0, void 0, function() {
      var r;
      return _(this, function(i) {
        return r = A(A({}, Ml), e), Z(_d(r)).throw(D.invalidParameters), r && (r.isDistinct = !0), [2, this.createChannel(r)];
      });
    });
  }, n.prototype.createChannelWithUserIds = function(e, r, i, s, a, o) {
    return r === void 0 && (r = !1), a === void 0 && (a = ""), o === void 0 && (o = ""), g(this, 0, void 0, function() {
      var l;
      return _(this, function(c) {
        return l = A(A({}, Ml), { invitedUserIds: e, isDistinct: r, name: i, data: a, customType: o }), typeof s == "string" ? l.coverUrl = s : l.coverImage = s, [2, this.createChannel(l)];
      });
    });
  }, n.prototype.markAsReadAll = function() {
    return g(this, 0, void 0, function() {
      return _(this, function(e) {
        return this._manager.markAsReadAll(), [2];
      });
    });
  }, n.prototype.markAsReadWithChannelUrls = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        return Z(tt("string", e)).throw(D.invalidParameters), this._manager.markAsReadWithChannelUrls(e), [2];
      });
    });
  }, n.prototype.markAsDelivered = function(e) {
    return g(this, 0, void 0, function() {
      return _(this, function(r) {
        switch (r.label) {
          case 0:
            return Z(O("string", e)).throw(D.invalidParameters), [4, this.getChannel(e)];
          case 1:
            return [4, r.sent().markAsDelivered()];
          case 2:
            return r.sent(), [2];
        }
      });
    });
  }, n;
}(Wd);
const lc = { collection: { groupChannel: { defaultLimit: 20, defaultOrder: nn.LATEST_LAST_MESSAGE, defaultIncludeEmpty: !1 }, message: { defaultLimit: { next: 25, prev: 25 }, searchLimit: { next: 10, prev: 10 } } } };
let fw = 0;
function wn(t) {
  const n = Mt(t);
  return n.current = t, Nr((...e) => n.current(...e), [n]);
}
function Dr(t) {
  return t != null && "sendingStatus" in t;
}
function N_(t, n = "##__USER_ID_IS_NOT_PROVIDED__##") {
  var e;
  return !!Dr(t) && ((e = t.sender) === null || e === void 0 ? void 0 : e.userId) === n;
}
function _f(t) {
  return "sendingStatus" in t ? t.sendingStatus === "succeeded" ? String(t.messageId) : t.reqId : String(t.messageId);
}
function _t(t) {
  return typeof t == "boolean";
}
function ta(t, n) {
  return n.includes(t);
}
function gf(t) {
  return !(!t || !Array.isArray(t)) && t.length !== 0;
}
function Ed(t) {
  if (typeof t != "object" || t === null)
    return t;
  if (Array.isArray(t))
    return t.map((e) => Ed(e));
  const n = {};
  return Object.keys(t).forEach((e) => {
    const r = e.replace(/_\w/g, (i) => i[1].toUpperCase());
    n[r] = Ed(t[e]);
  }), n;
}
function vf(t, n) {
  return t.reduce((e, r) => (e[n(r)] = r, e), {});
}
var mw = function(t, n) {
  var e = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && n.indexOf(r) < 0 && (e[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") {
    var i = 0;
    for (r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      n.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (e[r[i]] = t[r[i]]);
  }
  return e;
};
const _w = (t, n) => {
  var e = mw(t, []);
  switch (n.type) {
    case "update_initialized":
      return e.initialized = n.value.status, e;
    case "update_refreshing":
      return e.refreshing = n.value.status, e;
    case "update_loading":
      return e.loading = n.value.status, e;
    case "update_messages":
      if (n.value.clearBeforeAction)
        e.messageMap = gw(n.value.messages);
      else {
        const r = Object.assign({}, e.messageMap), i = [], s = [];
        n.value.messages.forEach((a) => {
          [Dr(a) ? a.reqId : void 0, a.messageId || void 0].forEach((o) => {
            if (!o)
              return;
            const l = r[o];
            vw(l, a) && (l && i.push(l), s.push(a));
          });
        }), i.forEach((a) => {
          Dr(a) && delete r[a.reqId], delete r[a.messageId];
        }), s.forEach((a) => {
          Dr(a) && (r[a.reqId] = a), r[a.messageId] = a;
        }), e.messageMap = r;
      }
      return e;
    case "update_new_messages": {
      const r = n.value.currentUserId, i = n.value.messages.filter((s) => {
        return !N_(a = s, r) && !a.isAdminMessage() && a.updatedAt === 0;
        var a;
      });
      return n.value.clearBeforeAction ? e.newMessageMap = vf(i, _f) : (i.map((a) => a.messageId).forEach((a) => delete e.newMessageMap[a]), e.newMessageMap = Object.assign(Object.assign({}, e.newMessageMap), vf(i, _f))), e;
    }
    case "delete_messages":
    case "delete_new_messages": {
      const r = n.type === "delete_messages" ? "messageMap" : "newMessageMap";
      return e[r] = Object.assign({}, e[r]), n.value.messageIds.forEach((i) => {
        const s = e[r][i];
        s && (Dr(s) && delete e[r][s.reqId], delete e[r][s.messageId]);
      }), n.value.reqIds.forEach((i) => {
        const s = e[r][i];
        s && (Dr(s) && delete e[r][s.reqId], delete e[r][s.messageId]);
      }), e;
    }
  }
}, gw = (t) => t.reduce((n, e) => (Dr(e) ? (n[e.reqId] = e, e.sendingStatus === St.SUCCEEDED && (n[e.messageId] = e)) : n[e.messageId] = e, n), {}), vw = (t, n) => !Dr(t) || !Dr(n) || (t.sendingStatus === St.SUCCEEDED ? n.sendingStatus === St.SUCCEEDED : t.sendingStatus !== n.sendingStatus), yw = (t = bw) => {
  const [{ initialized: n, loading: e, refreshing: r, messageMap: i, newMessageMap: s }, a] = Ja(_w, { initialized: !1, loading: !0, refreshing: !1, messageMap: {}, newMessageMap: {} }), o = Object.values(s);
  return { updateInitialized: (l) => {
    a({ type: "update_initialized", value: { status: l } });
  }, updateLoading: (l) => {
    a({ type: "update_loading", value: { status: l } });
  }, updateRefreshing: (l) => {
    a({ type: "update_refreshing", value: { status: l } });
  }, updateMessages: (l, c, u) => {
    a({ type: "update_messages", value: { messages: l, clearBeforeAction: c, currentUserId: u } });
  }, deleteMessages: (l, c) => {
    a({ type: "delete_messages", value: { messageIds: l, reqIds: c } });
  }, initialized: n, loading: e, refreshing: r, messages: sr(() => Array.from(new Set(Object.values(i))).sort(t), [i]), newMessages: o, updateNewMessages: (l, c, u) => {
    a({ type: "update_new_messages", value: { messages: l, clearBeforeAction: c, currentUserId: u } });
  }, deleteNewMessages: (l, c) => {
    a({ type: "delete_new_messages", value: { messageIds: l, reqIds: c } });
  } };
}, yf = Math.floor(Number.MAX_SAFE_INTEGER / 10);
function bw(t, n) {
  let e = 0, r = 0;
  return Dr(t) && t.sendingStatus !== "succeeded" && (e = yf), Dr(n) && n.sendingStatus !== "succeeded" && (r = yf), t.createdAt + e - (n.createdAt + r);
}
var Gr = function(t, n, e, r) {
  return new (e || (e = Promise))(function(i, s) {
    function a(c) {
      try {
        l(r.next(c));
      } catch (u) {
        s(u);
      }
    }
    function o(c) {
      try {
        l(r.throw(c));
      } catch (u) {
        s(u);
      }
    }
    function l(c) {
      var u;
      c.done ? i(c.value) : (u = c.value, u instanceof e ? u : new e(function(d) {
        d(u);
      })).then(a, o);
    }
    l((r = r.apply(t, n || [])).next());
  });
};
function bf(t) {
  return t < Date.now() ? lc.collection.message.searchLimit : lc.collection.message.defaultLimit;
}
const Ew = (t, n, e = {}) => {
  var r, i, s;
  const a = Mt(e);
  a.current = e;
  const o = Mt(n);
  o.current = n;
  const l = a.current.logger, c = (r = a.current.startingPoint) !== null && r !== void 0 ? r : Number.MAX_SAFE_INTEGER, u = bf(c), d = Mt({ prev: !1, next: !1 }), h = (() => {
    const [, V] = Ye(0);
    return Nr(() => V((ie) => ie + 1), []);
  })(), p = Mt({ initialized: !1, apiInitialized: !1, instance: null }), { initialized: f, loading: m, refreshing: v, messages: E, newMessages: y, updateMessages: b, updateNewMessages: T, deleteNewMessages: w, deleteMessages: N, updateInitialized: M, updateLoading: I, updateRefreshing: x } = yw(e == null ? void 0 : e.sortComparator), R = wn((V) => {
    var ie, ae, ce, le;
    if (!o.current || !o.current.url)
      return (ie = l == null ? void 0 : l.error) === null || ie === void 0 ? void 0 : ie.call(l, "[useGroupChannelMessages] channel is required");
    try {
      switch (V) {
        case B.EVENT_MESSAGE_RECEIVED:
        case B.EVENT_MESSAGE_SENT_SUCCESS:
        case B.SYNC_MESSAGE_FILL:
        case void 0:
          (ce = (ae = a.current).markAsRead) === null || ce === void 0 || ce.call(ae, [o.current]);
      }
    } catch (re) {
      (le = l == null ? void 0 : l.warn) === null || le === void 0 || le.call(l, "[useGroupChannelMessages/markAsReadBySource]", re);
    }
  }), L = wn((V, ie) => {
    var ae, ce, le, re, te;
    const Te = ie.filter((ke) => {
      var he;
      return !N_(ke, (he = t.currentUser) === null || he === void 0 ? void 0 : he.userId);
    });
    if (Te.length > 0)
      switch (V) {
        case B.EVENT_MESSAGE_RECEIVED:
        case B.SYNC_MESSAGE_FILL:
          !((ce = (ae = a.current).shouldCountNewMessages) === null || ce === void 0) && ce.call(ae) && T(Te, !1, (le = t.currentUser) === null || le === void 0 ? void 0 : le.userId), (te = (re = a.current).onMessagesReceived) === null || te === void 0 || te.call(re, Te);
      }
  }), j = wn((V, ie) => Gr(void 0, void 0, void 0, function* () {
    return new Promise((ae) => {
      var ce, le;
      if (!o.current || !o.current.url)
        return (ce = l == null ? void 0 : l.error) === null || ce === void 0 ? void 0 : ce.call(l, "[useGroupChannelMessages] channel is required");
      p.current.instance && p.current.instance.dispose(), R(), T([], !0, (le = t.currentUser) === null || le === void 0 ? void 0 : le.userId);
      const re = () => {
        var Te, ke, he;
        const { pendingMessages: ye, failedMessages: ze } = (Te = p.current.instance) !== null && Te !== void 0 ? Te : {};
        gf(ye) && b(ye, !1, (ke = t.currentUser) === null || ke === void 0 ? void 0 : ke.userId), gf(ze) && b(ze, !1, (he = t.currentUser) === null || he === void 0 ? void 0 : he.userId);
      }, te = ((Te, ke, he) => {
        var ye;
        const ze = { prevResultLimit: ke.prev, nextResultLimit: ke.next, startingPoint: he == null ? void 0 : he.startingPoint, replyType: he == null ? void 0 : he.replyType };
        return ((ye = he == null ? void 0 : he.collectionCreator) === null || ye === void 0 ? void 0 : ye.call(he, ze)) || Te.createMessageCollection(Object.assign(Object.assign({}, ze), { filter: new Fi(ze) }));
      })(o.current, ie, Object.assign(Object.assign({}, a.current), { startingPoint: V }));
      p.current = { apiInitialized: !1, initialized: !1, instance: te }, te.setMessageCollectionHandler({ onMessagesAdded: (Te, ke, he) => {
        var ye;
        R(Te.source), L(Te.source, he), b(he, !1, (ye = t.currentUser) === null || ye === void 0 ? void 0 : ye.userId);
      }, onMessagesUpdated: (Te, ke, he) => {
        var ye, ze, ot;
        R(Te.source), L(Te.source, he), b(he, !1, (ye = t.currentUser) === null || ye === void 0 ? void 0 : ye.userId), Te.source === B.EVENT_MESSAGE_UPDATED && ((ot = (ze = a.current).onMessagesUpdated) === null || ot === void 0 || ot.call(ze, he));
      }, onMessagesDeleted: (Te, ke, he, ye) => {
        const ze = ye.map((W) => W.messageId), ot = ye.filter(Dr).map((W) => W.reqId);
        N(ze, ot), w(ze, ot);
      }, onChannelDeleted: (Te, ke) => {
        var he, ye;
        (ye = (he = a.current).onChannelDeleted) === null || ye === void 0 || ye.call(he, ke);
      }, onChannelUpdated: (Te, ke) => {
        var he, ye;
        h(), (ye = (he = a.current).onChannelUpdated) === null || ye === void 0 || ye.call(he, ke);
      }, onHugeGapDetected: () => {
        j(Number.MAX_SAFE_INTEGER, lc.collection.message.defaultLimit);
      } }), te.initialize(oc.CACHE_AND_REPLACE_BY_API).onCacheResult((Te, ke) => {
        var he, ye, ze;
        Te ? t.isCacheEnabled && ((he = l == null ? void 0 : l.error) === null || he === void 0 || he.call(l, "[useGroupChannelMessages/onCacheResult]", Te)) : ke && ((ye = l == null ? void 0 : l.debug) === null || ye === void 0 || ye.call(l, "[useGroupChannelMessages/onCacheResult]", "message length:", ke.length), b(ke, !0, (ze = t.currentUser) === null || ze === void 0 ? void 0 : ze.userId), re(), ke.length > 0 && (p.current.initialized = !0, ae()));
      }).onApiResult((Te, ke) => {
        var he, ye, ze, ot, W;
        Te ? (he = l == null ? void 0 : l.warn) === null || he === void 0 || he.call(l, "[useGroupChannelMessages/onApiResult]", Te) : ke && ((ye = l == null ? void 0 : l.debug) === null || ye === void 0 || ye.call(l, "[useGroupChannelMessages/onApiResult]", "message length:", ke.length), b(ke, !0, (ze = t.currentUser) === null || ze === void 0 ? void 0 : ze.userId), a.current.startingPoint || (W = (ot = a.current).onMessagesReceived) === null || W === void 0 || W.call(ot, ke), t.isCacheEnabled && re()), p.current.initialized = !0, p.current.apiInitialized = !0, ae();
      });
    });
  }));
  ((V, ie, ae) => {
    const ce = Mt(ie), le = Ye(() => "" + fw++)[0];
    ce.current = ie, Tt(() => {
      var re, te;
      return (re = V == null ? void 0 : V.groupChannel) === null || re === void 0 || re.addGroupChannelHandler(le, (te = new S_(), Object.keys(te).forEach((Te) => {
        te[Te] = (...ke) => {
          var he, ye;
          return (ye = (he = ce.current) === null || he === void 0 ? void 0 : he[Te]) === null || ye === void 0 ? void 0 : ye.call(he, ...ke);
        };
      }), te)), () => {
        var Te;
        (Te = V == null ? void 0 : V.groupChannel) === null || Te === void 0 || Te.removeGroupChannelHandler(le);
      };
    }, [V == null ? void 0 : V.groupChannel, le]);
  })(t, { onUserBanned(V, ie) {
    var ae, ce, le;
    V.isGroupChannel() && !function(re, te) {
      return !re || !te || re.url !== te.url;
    }(V, o.current) && (ie.userId === ((ae = t.currentUser) === null || ae === void 0 ? void 0 : ae.userId) ? (le = (ce = a.current).onCurrentUserBanned) === null || le === void 0 || le.call(ce) : h());
  } }), hr(() => {
    const V = setTimeout(() => Gr(void 0, void 0, void 0, function* () {
      t.currentUser && o.current && (M(!1), I(!0), yield j(c, u), I(!1), M(!0));
    }));
    return () => clearTimeout(V);
  }, [t, (i = t.currentUser) === null || i === void 0 ? void 0 : i.userId, (s = o.current) === null || s === void 0 ? void 0 : s.url, a.current.replyType]), Tt(() => () => {
    p.current.instance && p.current.instance.dispose();
  }, []);
  const P = wn(() => Gr(void 0, void 0, void 0, function* () {
    t.currentUser && o.current && (x(!0), yield j(Number.MAX_SAFE_INTEGER, lc.collection.message.defaultLimit), x(!1));
  })), q = wn(() => Gr(void 0, void 0, void 0, function* () {
    var V;
    const ie = p.current.instance;
    if (ie != null && ie.hasPrevious && !d.current.prev)
      try {
        d.current.prev = !0;
        const ae = yield ie.loadPrevious();
        b(ae, !1, (V = t.currentUser) === null || V === void 0 ? void 0 : V.userId);
      } catch {
      } finally {
        d.current.prev = !1;
      }
  })), G = wn(() => {
    const { initialized: V, instance: ie } = p.current;
    return !(!V || !ie) && ie.hasPrevious;
  }), X = wn(() => Gr(void 0, void 0, void 0, function* () {
    var V;
    const ie = p.current.instance;
    if (ie != null && ie.hasNext && !d.current.next)
      try {
        d.current.next = !0;
        const ae = yield ie.loadNext();
        b(ae, !1, (V = t.currentUser) === null || V === void 0 ? void 0 : V.userId);
      } catch {
      } finally {
        d.current.next = !1;
      }
  })), Ce = wn(() => {
    const { initialized: V, apiInitialized: ie, instance: ae } = p.current;
    return !!(ie && V && ae) && ae.hasNext;
  }), Be = wn((V, ie) => {
    var ae;
    if (!o.current || !o.current.url)
      throw (ae = l == null ? void 0 : l.error) === null || ae === void 0 || ae.call(l, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
    return new Promise((ce, le) => {
      o.current.sendUserMessage(V).onPending((re) => {
        var te;
        re.channelUrl === o.current.url && b([re], !1, (te = t.currentUser) === null || te === void 0 ? void 0 : te.userId), ie == null || ie(re);
      }).onSucceeded((re) => {
        var te;
        re.channelUrl === o.current.url && b([re], !1, (te = t.currentUser) === null || te === void 0 ? void 0 : te.userId), ce(re);
      }).onFailed((re, te) => {
        var Te;
        te && te.channelUrl === o.current.url && b([te], !1, (Te = t.currentUser) === null || Te === void 0 ? void 0 : Te.userId), le(re);
      });
    });
  }), se = wn((V, ie) => {
    var ae;
    if (!o.current || !o.current.url)
      throw (ae = l == null ? void 0 : l.error) === null || ae === void 0 || ae.call(l, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
    return new Promise((ce, le) => {
      o.current.sendFileMessage(V).onPending((re) => {
        var te;
        re.channelUrl === o.current.url && b([re], !1, (te = t.currentUser) === null || te === void 0 ? void 0 : te.userId), ie == null || ie(re);
      }).onSucceeded((re) => {
        var te;
        re.channelUrl === o.current.url && b([re], !1, (te = t.currentUser) === null || te === void 0 ? void 0 : te.userId), ce(re);
      }).onFailed((re, te) => {
        var Te;
        te && te.channelUrl === o.current.url && b([te], !1, (Te = t.currentUser) === null || Te === void 0 ? void 0 : Te.userId), le(re);
      });
    });
  }), Ee = wn((V, ie) => Gr(void 0, void 0, void 0, function* () {
    var ae;
    if (!o.current || !o.current.url)
      throw (ae = l == null ? void 0 : l.error) === null || ae === void 0 || ae.call(l, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
    return new Promise((ce) => {
      const le = [];
      o.current.sendFileMessages(V).onPending((re) => {
        var te;
        re.channelUrl === o.current.url && b([re], !1, (te = t.currentUser) === null || te === void 0 ? void 0 : te.userId), ie == null || ie(re);
      }).onSucceeded((re) => {
        var te;
        re.isFileMessage() && re.channelUrl === o.current.url && (b([re], !1, (te = t.currentUser) === null || te === void 0 ? void 0 : te.userId), le.push(re)), le.length === V.length && ce(le);
      }).onFailed((re, te) => {
        var Te;
        te && te.channelUrl === o.current.url ? (b([te], !1, (Te = t.currentUser) === null || Te === void 0 ? void 0 : Te.userId), le.push(te)) : le.push(null), le.length === V.length && ce(le);
      });
    });
  })), ee = wn((V, ie) => {
    var ae;
    if (!o.current || !o.current.url)
      throw (ae = l == null ? void 0 : l.error) === null || ae === void 0 || ae.call(l, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
    return new Promise((ce, le) => {
      o.current.sendMultipleFilesMessage(V).onPending((re) => {
        var te;
        re.channelUrl === o.current.url && b([re], !1, (te = t.currentUser) === null || te === void 0 ? void 0 : te.userId), ie == null || ie(re);
      }).onFileUploaded(() => {
        h();
      }).onSucceeded((re) => {
        var te;
        re.channelUrl === o.current.url && b([re], !1, (te = t.currentUser) === null || te === void 0 ? void 0 : te.userId), ce(re);
      }).onFailed((re, te) => {
        var Te;
        te && te.channelUrl === o.current.url && b([te], !1, (Te = t.currentUser) === null || Te === void 0 ? void 0 : Te.userId), le(re);
      });
    });
  }), ge = wn((V, ie) => Gr(void 0, void 0, void 0, function* () {
    var ae, ce;
    if (!o.current || !o.current.url)
      throw (ae = l == null ? void 0 : l.error) === null || ae === void 0 || ae.call(l, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
    const le = yield o.current.updateUserMessage(V, ie);
    return le.channelUrl === o.current.url && b([le], !1, (ce = t.currentUser) === null || ce === void 0 ? void 0 : ce.userId), le;
  })), ve = wn((V, ie) => Gr(void 0, void 0, void 0, function* () {
    var ae, ce;
    if (!o.current || !o.current.url)
      throw (ae = l == null ? void 0 : l.error) === null || ae === void 0 || ae.call(l, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
    const le = yield o.current.updateFileMessage(V, ie);
    return le.channelUrl === o.current.url && b([le], !1, (ce = t.currentUser) === null || ce === void 0 ? void 0 : ce.userId), le;
  })), H = wn((V) => Gr(void 0, void 0, void 0, function* () {
    var ie;
    if (!o.current || !o.current.url)
      throw (ie = l == null ? void 0 : l.error) === null || ie === void 0 || ie.call(l, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
    return new Promise((ae, ce) => {
      let le;
      V.isUserMessage() && (le = o.current.resendMessage(V)), V.isFileMessage() && (le = o.current.resendMessage(V)), V.isMultipleFilesMessage() && (le = o.current.resendMessage(V)), le && ("onPending" in le && le.onPending((re) => {
        var te;
        re.channelUrl === o.current.url && b([re], !1, (te = t.currentUser) === null || te === void 0 ? void 0 : te.userId);
      }), "onFileUploaded" in le && le.onFileUploaded(() => {
        h();
      }), "onSucceeded" in le && le.onSucceeded((re) => {
        var te;
        re.channelUrl === o.current.url && b([re], !1, (te = t.currentUser) === null || te === void 0 ? void 0 : te.userId), ae(re);
      }), "onFailed" in le && le.onFailed((re, te) => {
        var Te;
        te && te.channelUrl === o.current.url && b([te], !1, (Te = t.currentUser) === null || Te === void 0 ? void 0 : Te.userId), ce(re);
      }));
    });
  })), oe = wn((V) => Gr(void 0, void 0, void 0, function* () {
    var ie, ae;
    if (!o.current || !o.current.url)
      throw (ie = l == null ? void 0 : l.error) === null || ie === void 0 || ie.call(l, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
    if (V.sendingStatus === "succeeded")
      V.isUserMessage() && (yield o.current.deleteMessage(V)), V.isFileMessage() && (yield o.current.deleteMessage(V)), V.isMultipleFilesMessage() && (yield o.current.deleteMessage(V));
    else
      try {
        yield (ae = p.current.instance) === null || ae === void 0 ? void 0 : ae.removeFailedMessage(V.reqId);
      } finally {
        N([V.messageId], [V.reqId]);
      }
  })), J = wn(() => {
    var V;
    T([], !0, (V = t.currentUser) === null || V === void 0 ? void 0 : V.userId);
  }), Me = wn((V) => Gr(void 0, void 0, void 0, function* () {
    var ie;
    if (t.currentUser && o.current) {
      const ae = bf(V);
      I(!0), b([], !0, (ie = t.currentUser) === null || ie === void 0 ? void 0 : ie.userId), yield j(V, ae), I(!1);
    }
  }));
  return { initialized: f, loading: m, refreshing: v, messages: E, newMessages: y, resetNewMessages: J, refresh: P, loadPrevious: q, hasPrevious: G, loadNext: X, hasNext: Ce, sendUserMessage: Be, sendFileMessage: se, sendFileMessages: Ee, sendMultipleFilesMessage: ee, updateUserMessage: ge, updateFileMessage: ve, resendMessage: H, deleteMessage: oe, resetWithStartingPoint: Me, _dangerous_reducer_updateMessages: b, _dangerous_reducer_deleteMessages: N };
};
function I_(t, n) {
  const e = Object.assign({}, t);
  return Object.keys(n).forEach((r) => {
    Object.prototype.hasOwnProperty.call(e, r) && function(i, s) {
      return Object.prototype.toString.call(i) === Object.prototype.toString.call(s);
    }(e[r], n[r]) && (typeof n[r] != "object" || Array.isArray(n[r]) ? e[r] = n[r] : e[r] = I_(e[r], n[r]));
  }), e;
}
const th = () => ({ common: { enableUsingDefaultUserProfile: !1 }, groupChannel: { channel: { enableMention: !1, enableOgtag: !0, enableReactions: !0, enableReactionsSupergroup: !1, enableTypingIndicator: !0, enableVoiceMessage: !1, input: { camera: { enablePhoto: !0, enableVideo: !0 }, enableDocument: !0, gallery: { enablePhoto: !0, enableVideo: !0 } }, replyType: "quote_reply", threadReplySelectType: "thread", typingIndicatorTypes: /* @__PURE__ */ new Set(["text"]), enableFeedback: !1, enableSuggestedReplies: !1, showSuggestedRepliesFor: "last_message_only", suggestedRepliesDirection: "vertical", enableMarkdownForUserMessage: !1, enableFormTypeMessage: !1 }, channelList: { enableMessageReceiptStatus: !1, enableTypingIndicator: !1 }, setting: { enableMessageSearch: !1 } }, openChannel: { channel: { enableOgtag: !0, input: { camera: { enablePhoto: !0, enableVideo: !0 }, enableDocument: !0, gallery: { enablePhoto: !0, enableVideo: !0 } } } } }), A_ = () => function(t) {
  return delete t.groupChannel.channel.typingIndicatorTypes, delete t.groupChannel.channel.enableFeedback, delete t.groupChannel.channel.enableSuggestedReplies, delete t.groupChannel.channel.showSuggestedRepliesFor, delete t.groupChannel.channel.suggestedRepliesDirection, delete t.groupChannel.channel.enableMarkdownForUserMessage, delete t.groupChannel.channel.enableFormTypeMessage, t;
}(th()), Ef = th(), Cw = A_();
var cc = function(t, n, e, r) {
  return new (e || (e = Promise))(function(i, s) {
    function a(c) {
      try {
        l(r.next(c));
      } catch (u) {
        s(u);
      }
    }
    function o(c) {
      try {
        l(r.throw(c));
      } catch (u) {
        s(u);
      }
    }
    function l(c) {
      var u;
      c.done ? i(c.value) : (u = c.value, u instanceof e ? u : new e(function(d) {
        d(u);
      })).then(a, o);
    }
    l((r = r.apply(t, n || [])).next());
  });
};
const Cd = { items: {}, getItem(t) {
  var n;
  return cc(this, void 0, void 0, function* () {
    return (n = Cd.items[t]) !== null && n !== void 0 ? n : null;
  });
}, setItem(t, n) {
  return cc(this, void 0, void 0, function* () {
    Cd.items[t] = n;
  });
} };
class Tw {
  constructor(n) {
    this.storage = n ?? Cd;
  }
  init(n) {
    return this.key = `sbu@${n}.uikitConfiguration`, this.get();
  }
  get safeKey() {
    if (!this.key)
      throw new Error("Please UIKitConfigManager.init() first");
    return this.key;
  }
  update(n) {
    return cc(this, void 0, void 0, function* () {
      const e = yield this.get(), r = { updatedAt: n.updatedAt, configuration: I_(e.configuration, n.configuration) };
      return yield this.storage.setItem(this.safeKey, JSON.stringify(r)), r;
    });
  }
  get() {
    return cc(this, void 0, void 0, function* () {
      const n = { updatedAt: 0, configuration: Cw };
      try {
        const e = yield this.storage.getItem(this.safeKey);
        return e ? JSON.parse(e) : n;
      } catch {
        return n;
      }
    });
  }
}
function ww(t, n, e) {
  (function(r, i, s) {
    var a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M, I, x, R, L, j, P, q, G, X, Ce, Be, se, Ee, ee, ge, ve, H, oe, J, Me, V, ie, ae, ce, le, re, te, Te, ke, he, ye, ze, ot, W, xe, be, ue, Se, Fe, et, je, Xe, Et, $e, Rt, xt, Gt, qt, Xt, z, Ne, Oe, De, Ge, st, Je, He, lt, dt, qe, Ke, ct, nt, ut, ft, un, dn, hn, Kt, pn, fn, Tn, mn, cn, U, Le, _e, ht, Ve, at, Nt, rn, kt, Dt, kn, On, ds, hs, ps, fs, lr, zi, ei;
    !((a = s.groupChannel) === null || a === void 0) && a.channel && _t((l = (o = s.groupChannel) === null || o === void 0 ? void 0 : o.channel) === null || l === void 0 ? void 0 : l.enableOgtag) && (r.channel.enableOgtag = s.groupChannel.channel.enableOgtag), !((c = i.groupChannel) === null || c === void 0) && c.channel && _t((d = (u = i.groupChannel) === null || u === void 0 ? void 0 : u.channel) === null || d === void 0 ? void 0 : d.enableOgtag) && (r.channel.enableOgtag = (p = (h = i.groupChannel) === null || h === void 0 ? void 0 : h.channel) === null || p === void 0 ? void 0 : p.enableOgtag), !((f = s.groupChannel) === null || f === void 0) && f.channel && _t((v = (m = s.groupChannel) === null || m === void 0 ? void 0 : m.channel) === null || v === void 0 ? void 0 : v.enableTypingIndicator) && (r.channel.enableTypingIndicator = (y = (E = s.groupChannel) === null || E === void 0 ? void 0 : E.channel) === null || y === void 0 ? void 0 : y.enableTypingIndicator), !((b = i.groupChannel) === null || b === void 0) && b.channel && _t((w = (T = i.groupChannel) === null || T === void 0 ? void 0 : T.channel) === null || w === void 0 ? void 0 : w.enableTypingIndicator) && (r.channel.enableTypingIndicator = (M = (N = i.groupChannel) === null || N === void 0 ? void 0 : N.channel) === null || M === void 0 ? void 0 : M.enableTypingIndicator), !((I = s.groupChannel) === null || I === void 0) && I.channel && _t((R = (x = s.groupChannel) === null || x === void 0 ? void 0 : x.channel) === null || R === void 0 ? void 0 : R.enableReactions) && (r.channel.enableReactions = (j = (L = s.groupChannel) === null || L === void 0 ? void 0 : L.channel) === null || j === void 0 ? void 0 : j.enableReactions), !((P = i.groupChannel) === null || P === void 0) && P.channel && _t((G = (q = i.groupChannel) === null || q === void 0 ? void 0 : q.channel) === null || G === void 0 ? void 0 : G.enableReactions) && (r.channel.enableReactions = (Ce = (X = i.groupChannel) === null || X === void 0 ? void 0 : X.channel) === null || Ce === void 0 ? void 0 : Ce.enableReactions), !((Be = s.groupChannel) === null || Be === void 0) && Be.channel && _t((Ee = (se = s.groupChannel) === null || se === void 0 ? void 0 : se.channel) === null || Ee === void 0 ? void 0 : Ee.enableReactionsSupergroup) && (r.channel.enableReactionsSupergroup = (ge = (ee = s.groupChannel) === null || ee === void 0 ? void 0 : ee.channel) === null || ge === void 0 ? void 0 : ge.enableReactionsSupergroup), !((ve = i.groupChannel) === null || ve === void 0) && ve.channel && _t((oe = (H = i.groupChannel) === null || H === void 0 ? void 0 : H.channel) === null || oe === void 0 ? void 0 : oe.enableReactionsSupergroup) && console.warn("Currently, EnableReactionsSupergroup feature is turned off by default. If you wish to use this feature, contact us: https://dashboard.sendbird.com/settings/contact_us?category=feedback_and_feature_requests&product=UIKit"), !((J = s.groupChannel) === null || J === void 0) && J.channel && _t((V = (Me = s.groupChannel) === null || Me === void 0 ? void 0 : Me.channel) === null || V === void 0 ? void 0 : V.enableMention) && (r.channel.enableMention = (ae = (ie = s.groupChannel) === null || ie === void 0 ? void 0 : ie.channel) === null || ae === void 0 ? void 0 : ae.enableMention), !((ce = i.groupChannel) === null || ce === void 0) && ce.channel && _t((re = (le = i.groupChannel) === null || le === void 0 ? void 0 : le.channel) === null || re === void 0 ? void 0 : re.enableMention) && (r.channel.enableMention = (Te = (te = i.groupChannel) === null || te === void 0 ? void 0 : te.channel) === null || Te === void 0 ? void 0 : Te.enableMention), !((ke = s.groupChannel) === null || ke === void 0) && ke.channel && ta((ye = (he = s.groupChannel) === null || he === void 0 ? void 0 : he.channel) === null || ye === void 0 ? void 0 : ye.replyType, ["none", "quote_reply", "thread"]) && (r.channel.replyType = (ot = (ze = s.groupChannel) === null || ze === void 0 ? void 0 : ze.channel) === null || ot === void 0 ? void 0 : ot.replyType), !((W = i.groupChannel) === null || W === void 0) && W.channel && ta((be = (xe = i.groupChannel) === null || xe === void 0 ? void 0 : xe.channel) === null || be === void 0 ? void 0 : be.replyType, ["none", "quote_reply", "thread"]) && (r.channel.replyType = (Se = (ue = i.groupChannel) === null || ue === void 0 ? void 0 : ue.channel) === null || Se === void 0 ? void 0 : Se.replyType), !((Fe = s.groupChannel) === null || Fe === void 0) && Fe.channel && ta((je = (et = s.groupChannel) === null || et === void 0 ? void 0 : et.channel) === null || je === void 0 ? void 0 : je.threadReplySelectType, ["thread", "parent"]) && (r.channel.threadReplySelectType = (Et = (Xe = s.groupChannel) === null || Xe === void 0 ? void 0 : Xe.channel) === null || Et === void 0 ? void 0 : Et.threadReplySelectType), !(($e = i.groupChannel) === null || $e === void 0) && $e.channel && ta((xt = (Rt = i.groupChannel) === null || Rt === void 0 ? void 0 : Rt.channel) === null || xt === void 0 ? void 0 : xt.threadReplySelectType, ["thread", "parent"]) && (r.channel.threadReplySelectType = (qt = (Gt = i.groupChannel) === null || Gt === void 0 ? void 0 : Gt.channel) === null || qt === void 0 ? void 0 : qt.threadReplySelectType), !((Xt = s.groupChannel) === null || Xt === void 0) && Xt.channel && _t((Ne = (z = s.groupChannel) === null || z === void 0 ? void 0 : z.channel) === null || Ne === void 0 ? void 0 : Ne.enableVoiceMessage) && (r.channel.enableVoiceMessage = (De = (Oe = s.groupChannel) === null || Oe === void 0 ? void 0 : Oe.channel) === null || De === void 0 ? void 0 : De.enableVoiceMessage), !((Ge = i.groupChannel) === null || Ge === void 0) && Ge.channel && _t((Je = (st = i.groupChannel) === null || st === void 0 ? void 0 : st.channel) === null || Je === void 0 ? void 0 : Je.enableVoiceMessage) && (r.channel.enableVoiceMessage = (lt = (He = i.groupChannel) === null || He === void 0 ? void 0 : He.channel) === null || lt === void 0 ? void 0 : lt.enableVoiceMessage), !((dt = i.groupChannel) === null || dt === void 0) && dt.channel && (yi = (Ke = (qe = i.groupChannel) === null || qe === void 0 ? void 0 : qe.channel) === null || Ke === void 0 ? void 0 : Ke.typingIndicatorTypes, yi instanceof Set) && (r.channel.typingIndicatorTypes = (nt = (ct = i.groupChannel) === null || ct === void 0 ? void 0 : ct.channel) === null || nt === void 0 ? void 0 : nt.typingIndicatorTypes);
    var yi;
    !((ut = i.groupChannel) === null || ut === void 0) && ut.channel && _t((un = (ft = i.groupChannel) === null || ft === void 0 ? void 0 : ft.channel) === null || un === void 0 ? void 0 : un.enableFeedback) && (r.channel.enableFeedback = (hn = (dn = i.groupChannel) === null || dn === void 0 ? void 0 : dn.channel) === null || hn === void 0 ? void 0 : hn.enableFeedback), !((Kt = i.groupChannel) === null || Kt === void 0) && Kt.channel && _t((fn = (pn = i.groupChannel) === null || pn === void 0 ? void 0 : pn.channel) === null || fn === void 0 ? void 0 : fn.enableSuggestedReplies) && (r.channel.enableSuggestedReplies = (mn = (Tn = i.groupChannel) === null || Tn === void 0 ? void 0 : Tn.channel) === null || mn === void 0 ? void 0 : mn.enableSuggestedReplies), !((cn = i.groupChannel) === null || cn === void 0) && cn.channel && ta((Le = (U = i.groupChannel) === null || U === void 0 ? void 0 : U.channel) === null || Le === void 0 ? void 0 : Le.showSuggestedRepliesFor, ["all_messages", "last_message_only"]) && (r.channel.showSuggestedRepliesFor = (ht = (_e = i.groupChannel) === null || _e === void 0 ? void 0 : _e.channel) === null || ht === void 0 ? void 0 : ht.showSuggestedRepliesFor), !((Ve = i.groupChannel) === null || Ve === void 0) && Ve.channel && ta((Nt = (at = i.groupChannel) === null || at === void 0 ? void 0 : at.channel) === null || Nt === void 0 ? void 0 : Nt.suggestedRepliesDirection, ["vertical", "horizontal"]) && (r.channel.suggestedRepliesDirection = (kt = (rn = i.groupChannel) === null || rn === void 0 ? void 0 : rn.channel) === null || kt === void 0 ? void 0 : kt.suggestedRepliesDirection), !((Dt = i.groupChannel) === null || Dt === void 0) && Dt.channel && _t((On = (kn = i.groupChannel) === null || kn === void 0 ? void 0 : kn.channel) === null || On === void 0 ? void 0 : On.enableMarkdownForUserMessage) && (r.channel.enableMarkdownForUserMessage = (hs = (ds = i.groupChannel) === null || ds === void 0 ? void 0 : ds.channel) === null || hs === void 0 ? void 0 : hs.enableMarkdownForUserMessage), !((ps = i.groupChannel) === null || ps === void 0) && ps.channel && _t((lr = (fs = i.groupChannel) === null || fs === void 0 ? void 0 : fs.channel) === null || lr === void 0 ? void 0 : lr.enableFormTypeMessage) && (r.channel.enableFormTypeMessage = (ei = (zi = i.groupChannel) === null || zi === void 0 ? void 0 : zi.channel) === null || ei === void 0 ? void 0 : ei.enableFormTypeMessage);
  })(t, n, e), function(r, i, s) {
    var a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M, I, x, R, L, j, P, q, G, X, Ce, Be, se, Ee, ee, ge, ve, H, oe, J, Me, V, ie, ae, ce, le, re, te, Te, ke, he, ye, ze, ot, W, xe, be, ue, Se, Fe, et, je, Xe, Et, $e, Rt, xt, Gt, qt, Xt, z, Ne, Oe, De, Ge, st, Je, He, lt, dt, qe, Ke, ct, nt, ut, ft, un, dn, hn, Kt, pn, fn, Tn, mn, cn, U, Le, _e, ht, Ve, at, Nt, rn, kt, Dt, kn, On;
    !((o = (a = s.groupChannel) === null || a === void 0 ? void 0 : a.channel) === null || o === void 0) && o.input && _t((u = (c = (l = s.groupChannel) === null || l === void 0 ? void 0 : l.channel) === null || c === void 0 ? void 0 : c.input) === null || u === void 0 ? void 0 : u.enableDocument) && (r.channel.input.enableDocument = (p = (h = (d = s.groupChannel) === null || d === void 0 ? void 0 : d.channel) === null || h === void 0 ? void 0 : h.input) === null || p === void 0 ? void 0 : p.enableDocument), !((m = (f = i.groupChannel) === null || f === void 0 ? void 0 : f.channel) === null || m === void 0) && m.input && _t((y = (E = (v = i.groupChannel) === null || v === void 0 ? void 0 : v.channel) === null || E === void 0 ? void 0 : E.input) === null || y === void 0 ? void 0 : y.enableDocument) && (r.channel.input.enableDocument = (w = (T = (b = i.groupChannel) === null || b === void 0 ? void 0 : b.channel) === null || T === void 0 ? void 0 : T.input) === null || w === void 0 ? void 0 : w.enableDocument), !((I = (M = (N = s.groupChannel) === null || N === void 0 ? void 0 : N.channel) === null || M === void 0 ? void 0 : M.input) === null || I === void 0) && I.camera && _t((j = (L = (R = (x = s.groupChannel) === null || x === void 0 ? void 0 : x.channel) === null || R === void 0 ? void 0 : R.input) === null || L === void 0 ? void 0 : L.camera) === null || j === void 0 ? void 0 : j.enablePhoto) && (r.channel.input.camera.enablePhoto = (X = (G = (q = (P = s.groupChannel) === null || P === void 0 ? void 0 : P.channel) === null || q === void 0 ? void 0 : q.input) === null || G === void 0 ? void 0 : G.camera) === null || X === void 0 ? void 0 : X.enablePhoto), !((se = (Be = (Ce = i.groupChannel) === null || Ce === void 0 ? void 0 : Ce.channel) === null || Be === void 0 ? void 0 : Be.input) === null || se === void 0) && se.camera && _t((ve = (ge = (ee = (Ee = i.groupChannel) === null || Ee === void 0 ? void 0 : Ee.channel) === null || ee === void 0 ? void 0 : ee.input) === null || ge === void 0 ? void 0 : ge.camera) === null || ve === void 0 ? void 0 : ve.enablePhoto) && (r.channel.input.camera.enablePhoto = (Me = (J = (oe = (H = i.groupChannel) === null || H === void 0 ? void 0 : H.channel) === null || oe === void 0 ? void 0 : oe.input) === null || J === void 0 ? void 0 : J.camera) === null || Me === void 0 ? void 0 : Me.enablePhoto), !((ae = (ie = (V = s.groupChannel) === null || V === void 0 ? void 0 : V.channel) === null || ie === void 0 ? void 0 : ie.input) === null || ae === void 0) && ae.camera && _t((te = (re = (le = (ce = s.groupChannel) === null || ce === void 0 ? void 0 : ce.channel) === null || le === void 0 ? void 0 : le.input) === null || re === void 0 ? void 0 : re.camera) === null || te === void 0 ? void 0 : te.enableVideo) && (r.channel.input.camera.enableVideo = (ye = (he = (ke = (Te = s.groupChannel) === null || Te === void 0 ? void 0 : Te.channel) === null || ke === void 0 ? void 0 : ke.input) === null || he === void 0 ? void 0 : he.camera) === null || ye === void 0 ? void 0 : ye.enableVideo), !((W = (ot = (ze = i.groupChannel) === null || ze === void 0 ? void 0 : ze.channel) === null || ot === void 0 ? void 0 : ot.input) === null || W === void 0) && W.camera && _t((Se = (ue = (be = (xe = i.groupChannel) === null || xe === void 0 ? void 0 : xe.channel) === null || be === void 0 ? void 0 : be.input) === null || ue === void 0 ? void 0 : ue.camera) === null || Se === void 0 ? void 0 : Se.enableVideo) && (r.channel.input.camera.enableVideo = (Xe = (je = (et = (Fe = i.groupChannel) === null || Fe === void 0 ? void 0 : Fe.channel) === null || et === void 0 ? void 0 : et.input) === null || je === void 0 ? void 0 : je.camera) === null || Xe === void 0 ? void 0 : Xe.enableVideo), !((Rt = ($e = (Et = s.groupChannel) === null || Et === void 0 ? void 0 : Et.channel) === null || $e === void 0 ? void 0 : $e.input) === null || Rt === void 0) && Rt.gallery && _t((Xt = (qt = (Gt = (xt = s.groupChannel) === null || xt === void 0 ? void 0 : xt.channel) === null || Gt === void 0 ? void 0 : Gt.input) === null || qt === void 0 ? void 0 : qt.gallery) === null || Xt === void 0 ? void 0 : Xt.enablePhoto) && (r.channel.input.gallery.enablePhoto = (De = (Oe = (Ne = (z = s.groupChannel) === null || z === void 0 ? void 0 : z.channel) === null || Ne === void 0 ? void 0 : Ne.input) === null || Oe === void 0 ? void 0 : Oe.gallery) === null || De === void 0 ? void 0 : De.enablePhoto), !((Je = (st = (Ge = i.groupChannel) === null || Ge === void 0 ? void 0 : Ge.channel) === null || st === void 0 ? void 0 : st.input) === null || Je === void 0) && Je.gallery && _t((qe = (dt = (lt = (He = i.groupChannel) === null || He === void 0 ? void 0 : He.channel) === null || lt === void 0 ? void 0 : lt.input) === null || dt === void 0 ? void 0 : dt.gallery) === null || qe === void 0 ? void 0 : qe.enablePhoto) && (r.channel.input.gallery.enablePhoto = (ut = (nt = (ct = (Ke = i.groupChannel) === null || Ke === void 0 ? void 0 : Ke.channel) === null || ct === void 0 ? void 0 : ct.input) === null || nt === void 0 ? void 0 : nt.gallery) === null || ut === void 0 ? void 0 : ut.enablePhoto), !((dn = (un = (ft = s.groupChannel) === null || ft === void 0 ? void 0 : ft.channel) === null || un === void 0 ? void 0 : un.input) === null || dn === void 0) && dn.gallery && _t((fn = (pn = (Kt = (hn = s.groupChannel) === null || hn === void 0 ? void 0 : hn.channel) === null || Kt === void 0 ? void 0 : Kt.input) === null || pn === void 0 ? void 0 : pn.gallery) === null || fn === void 0 ? void 0 : fn.enableVideo) && (r.channel.input.gallery.enableVideo = (U = (cn = (mn = (Tn = s.groupChannel) === null || Tn === void 0 ? void 0 : Tn.channel) === null || mn === void 0 ? void 0 : mn.input) === null || cn === void 0 ? void 0 : cn.gallery) === null || U === void 0 ? void 0 : U.enableVideo), !((ht = (_e = (Le = i.groupChannel) === null || Le === void 0 ? void 0 : Le.channel) === null || _e === void 0 ? void 0 : _e.input) === null || ht === void 0) && ht.gallery && _t((rn = (Nt = (at = (Ve = i.groupChannel) === null || Ve === void 0 ? void 0 : Ve.channel) === null || at === void 0 ? void 0 : at.input) === null || Nt === void 0 ? void 0 : Nt.gallery) === null || rn === void 0 ? void 0 : rn.enableVideo) && (r.channel.input.gallery.enableVideo = (On = (kn = (Dt = (kt = i.groupChannel) === null || kt === void 0 ? void 0 : kt.channel) === null || Dt === void 0 ? void 0 : Dt.input) === null || kn === void 0 ? void 0 : kn.gallery) === null || On === void 0 ? void 0 : On.enableVideo);
  }(t, n, e), function(r, i, s) {
    var a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M;
    !((a = s.groupChannel) === null || a === void 0) && a.channelList && _t((l = (o = s.groupChannel) === null || o === void 0 ? void 0 : o.channelList) === null || l === void 0 ? void 0 : l.enableTypingIndicator) && (r.channelList.enableTypingIndicator = s.groupChannel.channelList.enableTypingIndicator), !((c = i.groupChannel) === null || c === void 0) && c.channelList && _t((d = (u = i.groupChannel) === null || u === void 0 ? void 0 : u.channelList) === null || d === void 0 ? void 0 : d.enableTypingIndicator) && (r.channelList.enableTypingIndicator = (p = (h = i.groupChannel) === null || h === void 0 ? void 0 : h.channelList) === null || p === void 0 ? void 0 : p.enableTypingIndicator), !((f = s.groupChannel) === null || f === void 0) && f.channelList && _t((v = (m = s.groupChannel) === null || m === void 0 ? void 0 : m.channelList) === null || v === void 0 ? void 0 : v.enableMessageReceiptStatus) && (r.channelList.enableMessageReceiptStatus = (y = (E = s.groupChannel) === null || E === void 0 ? void 0 : E.channelList) === null || y === void 0 ? void 0 : y.enableMessageReceiptStatus), !((b = i.groupChannel) === null || b === void 0) && b.channelList && _t((w = (T = i.groupChannel) === null || T === void 0 ? void 0 : T.channelList) === null || w === void 0 ? void 0 : w.enableMessageReceiptStatus) && (r.channelList.enableMessageReceiptStatus = (M = (N = i.groupChannel) === null || N === void 0 ? void 0 : N.channelList) === null || M === void 0 ? void 0 : M.enableMessageReceiptStatus);
  }(t, n, e), function(r, i, s) {
    var a, o, l, c, u, d, h, p;
    !((a = s.groupChannel) === null || a === void 0) && a.setting && _t((l = (o = s.groupChannel) === null || o === void 0 ? void 0 : o.setting) === null || l === void 0 ? void 0 : l.enableMessageSearch) && (r.setting.enableMessageSearch = s.groupChannel.setting.enableMessageSearch), !((c = i.groupChannel) === null || c === void 0) && c.setting && _t((d = (u = i.groupChannel) === null || u === void 0 ? void 0 : u.setting) === null || d === void 0 ? void 0 : d.enableMessageSearch) && (r.setting.enableMessageSearch = (p = (h = i.groupChannel) === null || h === void 0 ? void 0 : h.setting) === null || p === void 0 ? void 0 : p.enableMessageSearch);
  }(t, n, e);
}
function Sw(t, n, e) {
  (function(r, i, s) {
    var a, o, l, c, u, d, h, p;
    !((a = s.openChannel) === null || a === void 0) && a.channel && _t((l = (o = s.openChannel) === null || o === void 0 ? void 0 : o.channel) === null || l === void 0 ? void 0 : l.enableOgtag) && (r.channel.enableOgtag = s.openChannel.channel.enableOgtag), !((c = i.openChannel) === null || c === void 0) && c.channel && _t((d = (u = i.openChannel) === null || u === void 0 ? void 0 : u.channel) === null || d === void 0 ? void 0 : d.enableOgtag) && (r.channel.enableOgtag = (p = (h = i.openChannel) === null || h === void 0 ? void 0 : h.channel) === null || p === void 0 ? void 0 : p.enableOgtag);
  })(t, n, e), function(r, i, s) {
    var a, o, l, c, u, d, h, p, f, m, v, E, y, b, T, w, N, M, I, x, R, L, j, P, q, G, X, Ce, Be, se, Ee, ee, ge, ve, H, oe, J, Me, V, ie, ae, ce, le, re, te, Te, ke, he, ye, ze, ot, W, xe, be, ue, Se, Fe, et, je, Xe, Et, $e, Rt, xt, Gt, qt, Xt, z, Ne, Oe, De, Ge, st, Je, He, lt, dt, qe, Ke, ct, nt, ut, ft, un, dn, hn, Kt, pn, fn, Tn, mn, cn, U, Le, _e, ht, Ve, at, Nt, rn, kt, Dt, kn, On;
    !((o = (a = s.openChannel) === null || a === void 0 ? void 0 : a.channel) === null || o === void 0) && o.input && _t((u = (c = (l = s.openChannel) === null || l === void 0 ? void 0 : l.channel) === null || c === void 0 ? void 0 : c.input) === null || u === void 0 ? void 0 : u.enableDocument) && (r.channel.input.enableDocument = (p = (h = (d = s.openChannel) === null || d === void 0 ? void 0 : d.channel) === null || h === void 0 ? void 0 : h.input) === null || p === void 0 ? void 0 : p.enableDocument), !((m = (f = i.openChannel) === null || f === void 0 ? void 0 : f.channel) === null || m === void 0) && m.input && _t((y = (E = (v = i.openChannel) === null || v === void 0 ? void 0 : v.channel) === null || E === void 0 ? void 0 : E.input) === null || y === void 0 ? void 0 : y.enableDocument) && (r.channel.input.enableDocument = (w = (T = (b = i.openChannel) === null || b === void 0 ? void 0 : b.channel) === null || T === void 0 ? void 0 : T.input) === null || w === void 0 ? void 0 : w.enableDocument), !((I = (M = (N = s.openChannel) === null || N === void 0 ? void 0 : N.channel) === null || M === void 0 ? void 0 : M.input) === null || I === void 0) && I.camera && _t((j = (L = (R = (x = s.openChannel) === null || x === void 0 ? void 0 : x.channel) === null || R === void 0 ? void 0 : R.input) === null || L === void 0 ? void 0 : L.camera) === null || j === void 0 ? void 0 : j.enablePhoto) && (r.channel.input.camera.enablePhoto = (X = (G = (q = (P = s.openChannel) === null || P === void 0 ? void 0 : P.channel) === null || q === void 0 ? void 0 : q.input) === null || G === void 0 ? void 0 : G.camera) === null || X === void 0 ? void 0 : X.enablePhoto), !((se = (Be = (Ce = i.openChannel) === null || Ce === void 0 ? void 0 : Ce.channel) === null || Be === void 0 ? void 0 : Be.input) === null || se === void 0) && se.camera && _t((ve = (ge = (ee = (Ee = i.openChannel) === null || Ee === void 0 ? void 0 : Ee.channel) === null || ee === void 0 ? void 0 : ee.input) === null || ge === void 0 ? void 0 : ge.camera) === null || ve === void 0 ? void 0 : ve.enablePhoto) && (r.channel.input.camera.enablePhoto = (Me = (J = (oe = (H = i.openChannel) === null || H === void 0 ? void 0 : H.channel) === null || oe === void 0 ? void 0 : oe.input) === null || J === void 0 ? void 0 : J.camera) === null || Me === void 0 ? void 0 : Me.enablePhoto), !((ae = (ie = (V = s.openChannel) === null || V === void 0 ? void 0 : V.channel) === null || ie === void 0 ? void 0 : ie.input) === null || ae === void 0) && ae.camera && _t((te = (re = (le = (ce = s.openChannel) === null || ce === void 0 ? void 0 : ce.channel) === null || le === void 0 ? void 0 : le.input) === null || re === void 0 ? void 0 : re.camera) === null || te === void 0 ? void 0 : te.enableVideo) && (r.channel.input.camera.enableVideo = (ye = (he = (ke = (Te = s.openChannel) === null || Te === void 0 ? void 0 : Te.channel) === null || ke === void 0 ? void 0 : ke.input) === null || he === void 0 ? void 0 : he.camera) === null || ye === void 0 ? void 0 : ye.enableVideo), !((W = (ot = (ze = i.openChannel) === null || ze === void 0 ? void 0 : ze.channel) === null || ot === void 0 ? void 0 : ot.input) === null || W === void 0) && W.camera && _t((Se = (ue = (be = (xe = i.openChannel) === null || xe === void 0 ? void 0 : xe.channel) === null || be === void 0 ? void 0 : be.input) === null || ue === void 0 ? void 0 : ue.camera) === null || Se === void 0 ? void 0 : Se.enableVideo) && (r.channel.input.camera.enableVideo = (Xe = (je = (et = (Fe = i.openChannel) === null || Fe === void 0 ? void 0 : Fe.channel) === null || et === void 0 ? void 0 : et.input) === null || je === void 0 ? void 0 : je.camera) === null || Xe === void 0 ? void 0 : Xe.enableVideo), !((Rt = ($e = (Et = s.openChannel) === null || Et === void 0 ? void 0 : Et.channel) === null || $e === void 0 ? void 0 : $e.input) === null || Rt === void 0) && Rt.gallery && _t((Xt = (qt = (Gt = (xt = s.openChannel) === null || xt === void 0 ? void 0 : xt.channel) === null || Gt === void 0 ? void 0 : Gt.input) === null || qt === void 0 ? void 0 : qt.gallery) === null || Xt === void 0 ? void 0 : Xt.enablePhoto) && (r.channel.input.gallery.enablePhoto = (De = (Oe = (Ne = (z = s.openChannel) === null || z === void 0 ? void 0 : z.channel) === null || Ne === void 0 ? void 0 : Ne.input) === null || Oe === void 0 ? void 0 : Oe.gallery) === null || De === void 0 ? void 0 : De.enablePhoto), !((Je = (st = (Ge = i.openChannel) === null || Ge === void 0 ? void 0 : Ge.channel) === null || st === void 0 ? void 0 : st.input) === null || Je === void 0) && Je.gallery && _t((qe = (dt = (lt = (He = i.openChannel) === null || He === void 0 ? void 0 : He.channel) === null || lt === void 0 ? void 0 : lt.input) === null || dt === void 0 ? void 0 : dt.gallery) === null || qe === void 0 ? void 0 : qe.enablePhoto) && (r.channel.input.gallery.enablePhoto = (ut = (nt = (ct = (Ke = i.openChannel) === null || Ke === void 0 ? void 0 : Ke.channel) === null || ct === void 0 ? void 0 : ct.input) === null || nt === void 0 ? void 0 : nt.gallery) === null || ut === void 0 ? void 0 : ut.enablePhoto), !((dn = (un = (ft = s.openChannel) === null || ft === void 0 ? void 0 : ft.channel) === null || un === void 0 ? void 0 : un.input) === null || dn === void 0) && dn.gallery && _t((fn = (pn = (Kt = (hn = s.openChannel) === null || hn === void 0 ? void 0 : hn.channel) === null || Kt === void 0 ? void 0 : Kt.input) === null || pn === void 0 ? void 0 : pn.gallery) === null || fn === void 0 ? void 0 : fn.enableVideo) && (r.channel.input.gallery.enableVideo = (U = (cn = (mn = (Tn = s.openChannel) === null || Tn === void 0 ? void 0 : Tn.channel) === null || mn === void 0 ? void 0 : mn.input) === null || cn === void 0 ? void 0 : cn.gallery) === null || U === void 0 ? void 0 : U.enableVideo), !((ht = (_e = (Le = i.openChannel) === null || Le === void 0 ? void 0 : Le.channel) === null || _e === void 0 ? void 0 : _e.input) === null || ht === void 0) && ht.gallery && _t((rn = (Nt = (at = (Ve = i.openChannel) === null || Ve === void 0 ? void 0 : Ve.channel) === null || at === void 0 ? void 0 : at.input) === null || Nt === void 0 ? void 0 : Nt.gallery) === null || rn === void 0 ? void 0 : rn.enableVideo) && (r.channel.input.gallery.enableVideo = (On = (kn = (Dt = (kt = i.openChannel) === null || kt === void 0 ? void 0 : kt.channel) === null || Dt === void 0 ? void 0 : Dt.input) === null || kn === void 0 ? void 0 : kn.gallery) === null || On === void 0 ? void 0 : On.enableVideo);
  }(t, n, e);
}
function Nw(t, n) {
  const e = th();
  var r, i, s, a, o;
  return r = e.common, i = t, (s = n).common && _t((a = s.common) === null || a === void 0 ? void 0 : a.enableUsingDefaultUserProfile) && (r.enableUsingDefaultUserProfile = s.common.enableUsingDefaultUserProfile), i.common && _t((o = i.common) === null || o === void 0 ? void 0 : o.enableUsingDefaultUserProfile) && (r.enableUsingDefaultUserProfile = i.common.enableUsingDefaultUserProfile), ww(e.groupChannel, t, n), Sw(e.openChannel, t, n), e;
}
var Iw = function(t, n, e, r) {
  return new (e || (e = Promise))(function(i, s) {
    function a(c) {
      try {
        l(r.next(c));
      } catch (u) {
        s(u);
      }
    }
    function o(c) {
      try {
        l(r.throw(c));
      } catch (u) {
        s(u);
      }
    }
    function l(c) {
      var u;
      c.done ? i(c.value) : (u = c.value, u instanceof e ? u : new e(function(d) {
        d(u);
      })).then(a, o);
    }
    l((r = r.apply(t, n || [])).next());
  });
};
function Ra(t) {
  var n, e;
  return (e = (n = t.appInfo) === null || n === void 0 ? void 0 : n.applicationAttributes) !== null && e !== void 0 ? e : [];
}
const M_ = ls({ initDashboardConfigs: () => Promise.resolve(), configs: Ef, configsWithAppAttr: () => Ef }), Aw = ({ storage: t, children: n, localConfigs: e = {} }) => {
  const [r, i] = Ye(A_), [s] = Ye(() => new Tw(t)), a = Nr((c) => Iw(void 0, void 0, void 0, function* () {
    const u = yield s.init(c.appId);
    if (c.appInfo && c.appInfo.uikitConfigInfo.lastUpdatedAt === u.updatedAt)
      i(u.configuration);
    else
      try {
        const h = yield c.getUIKitConfiguration();
        if (typeof (d = h.json) == "object" && "configuration" in d && "updated_at" in d) {
          const p = Ed(h.json), f = yield s.update(p);
          i(f.configuration);
        }
      } catch {
        i(u.configuration);
      }
    var d;
  }), [s]), o = Nw(e, r), l = wn((c) => ({ groupChannel: { channel: { get enableReactions() {
    return o.groupChannel.channel.enableReactions && Ra(c).includes(uf);
  }, get enableReactionsSupergroup() {
    return o.groupChannel.channel.enableReactionsSupergroup && Ra(c).includes(uf);
  }, get enableOgtag() {
    return o.groupChannel.channel.enableOgtag && Ra(c).includes(df);
  } }, setting: { get enableMessageSearch() {
    return o.groupChannel.setting.enableMessageSearch && Ra(c).includes(S2);
  } } }, openChannel: { channel: { get enableOgtag() {
    return o.openChannel.channel.enableOgtag && Ra(c).includes(df);
  } } } }));
  return Ot.createElement(M_.Provider, { value: { initDashboardConfigs: a, configs: o, configsWithAppAttr: l } }, n);
}, x_ = Ot.createContext(null), k_ = { 100: "extra-light", 200: "light", 300: "main", 400: "dark", 500: "extra-dark", "overlay-01": "overlay-dark", "overlay-02": "overlay-light", "onlight-01": "onlight-text-high-emphasis", "onlight-02": "onlight-text-mid-emphasis", "onlight-03": "onlight-text-low-emphasis", "onlight-04": "onlight-text-disabled", "ondark-01": "ondark-text-high-emphasis", "ondark-02": "ondark-text-mid-emphasis", "ondark-03": "ondark-text-low-emphasis", "ondark-04": "ondark-text-disabled" }, Mw = Object.values(k_).sort((t, n) => n.length - t.length), xw = new Map(Object.entries(k_).map(([t, n]) => [n, t])), kw = (t) => {
  const n = {};
  return Object.entries(t).forEach(([e, r]) => {
    let i = e;
    for (const s of Mw) {
      const a = new RegExp(`-${s}$`);
      if (a.test(e)) {
        const o = xw.get(s);
        if (o) {
          i = e.replace(a, `-${o}`);
          break;
        }
      }
    }
    n[i] = r;
  }), n;
};
/*!
 * css-vars-ponyfill
 * v2.4.9
 * https://jhildenbiddle.github.io/css-vars-ponyfill/
 * (c) 2018-2024 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */
function ur() {
  return ur = Object.assign ? Object.assign.bind() : function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }
    return t;
  }, ur.apply(this, arguments);
}
/*!
 * get-css-data
 * v2.1.0
 * https://github.com/jhildenbiddle/get-css-data
 * (c) 2018-2022 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */
function Cf(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = { mimeType: n.mimeType || null, onBeforeSend: n.onBeforeSend || Function.prototype, onSuccess: n.onSuccess || Function.prototype, onError: n.onError || Function.prototype, onComplete: n.onComplete || Function.prototype }, r = Array.isArray(t) ? t : [t], i = Array.apply(null, Array(r.length)).map(function(c) {
    return null;
  });
  function s(c) {
    var u = typeof c == "string", d = u && c.trim().charAt(0) === "<";
    return u && !d;
  }
  function a(c, u) {
    e.onError(c, r[u], u);
  }
  function o(c, u) {
    var d = e.onSuccess(c, r[u], u);
    c = d === !1 ? "" : d || c, i[u] = c, i.indexOf(null) === -1 && e.onComplete(i);
  }
  var l = document.createElement("a");
  r.forEach(function(c, u) {
    if (l.setAttribute("href", c), l.href = String(l.href), !!(document.all && !window.atob) && l.host.split(":")[0] !== location.host.split(":")[0])
      if (l.protocol === location.protocol) {
        var d = new XDomainRequest();
        d.open("GET", c), d.timeout = 0, d.onprogress = Function.prototype, d.ontimeout = Function.prototype, d.onload = function() {
          var p = d.responseText;
          s(p) ? o(p, u) : a(d, u);
        }, d.onerror = function(p) {
          a(d, u);
        }, setTimeout(function() {
          d.send();
        }, 0);
      } else
        console.warn("Internet Explorer 9 Cross-Origin (CORS) requests must use the same protocol (".concat(c, ")")), a(null, u);
    else {
      var h = new XMLHttpRequest();
      h.open("GET", c), e.mimeType && h.overrideMimeType && h.overrideMimeType(e.mimeType), e.onBeforeSend(h, c, u), h.onreadystatechange = function() {
        if (h.readyState === 4) {
          var p = h.responseText;
          h.status < 400 && s(p) || h.status === 0 && s(p) ? o(p, u) : a(h, u);
        }
      }, h.send();
    }
  });
}
/**
 * Gets CSS data from <style> and <link> nodes (including @imports), then
 * returns data in order processed by DOM. Allows specifying nodes to
 * include/exclude and filtering CSS data using RegEx.
 *
 * @preserve
 * @param {object}   [options] The options object
 * @param {object}   [options.rootElement=document] Root element to traverse for
 *                   <link> and <style> nodes.
 * @param {string}   [options.include] CSS selector matching <link> and <style>
 *                   nodes to include
 * @param {string}   [options.exclude] CSS selector matching <link> and <style>
 *                   nodes to exclude
 * @param {object}   [options.filter] Regular expression used to filter node CSS
 *                   data. Each block of CSS data is tested against the filter,
 *                   and only matching data is included.
 * @param {boolean}  [options.skipDisabled=true] Determines if disabled
 *                   stylesheets will be skipped while collecting CSS data.
 * @param {boolean}  [options.useCSSOM=false] Determines if CSS data will be
 *                   collected from a stylesheet's runtime values instead of its
 *                   text content. This is required to get accurate CSS data
 *                   when a stylesheet has been modified using the deleteRule()
 *                   or insertRule() methods because these modifications will
 *                   not be reflected in the stylesheet's text content.
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments.
 * @param {function} [options.onSuccess] Callback on each CSS node read. Passes
 *                   1) CSS text, 2) source node reference, and 3) the source
 *                   URL as arguments.
 * @param {function} [options.onError] Callback on each error. Passes 1) the XHR
 *                   object for inspection, 2) soure node reference, and 3) the
 *                   source URL that failed (either a <link> href or an @import)
 *                   as arguments
 * @param {function} [options.onComplete] Callback after all nodes have been
 *                   processed. Passes 1) concatenated CSS text, 2) an array of
 *                   CSS text in DOM order, and 3) an array of nodes in DOM
 *                   order as arguments.
 *
 * @example
 *
 *   getCssData({
 *     rootElement : document,
 *     include     : 'style,link[rel="stylesheet"]',
 *     exclude     : '[href="skip.css"]',
 *     filter      : /red/,
 *     skipDisabled: true,
 *     useCSSOM    : false,
 *     onBeforeSend(xhr, node, url) {
 *       // ...
 *     }
 *     onSuccess(cssText, node, url) {
 *       // ...
 *     }
 *     onError(xhr, node, url) {
 *       // ...
 *     },
 *     onComplete(cssText, cssArray, nodeArray) {
 *       // ...
 *     }
 *   });
 */
function Tf(t) {
  var n = { cssComments: /\/\*[\s\S]+?\*\//g, cssImports: /(?:@import\s*)(?:url\(\s*)?(?:['"])([^'"]*)(?:['"])(?:\s*\))?(?:[^;]*;)/g }, e = { rootElement: t.rootElement || document, include: t.include || 'style,link[rel="stylesheet"]', exclude: t.exclude || null, filter: t.filter || null, skipDisabled: t.skipDisabled !== !1, useCSSOM: t.useCSSOM || !1, onBeforeSend: t.onBeforeSend || Function.prototype, onSuccess: t.onSuccess || Function.prototype, onError: t.onError || Function.prototype, onComplete: t.onComplete || Function.prototype }, r = Array.apply(null, e.rootElement.querySelectorAll(e.include)).filter(function(c) {
    return u = c, d = e.exclude, !(u.matches || u.matchesSelector || u.webkitMatchesSelector || u.mozMatchesSelector || u.msMatchesSelector || u.oMatchesSelector).call(u, d);
    var u, d;
  }), i = Array.apply(null, Array(r.length)).map(function(c) {
    return null;
  });
  function s() {
    if (i.indexOf(null) === -1) {
      i.reduce(function(u, d, h) {
        return d === "" && u.push(h), u;
      }, []).reverse().forEach(function(u) {
        return [r, i].forEach(function(d) {
          return d.splice(u, 1);
        });
      });
      var c = i.join("");
      e.onComplete(c, i, r);
    }
  }
  function a(c, u, d, h) {
    var p = e.onSuccess(c, d, h);
    l(c = p !== void 0 && !p ? "" : p || c, d, h, function(f, m) {
      i[u] === null && (m.forEach(function(v) {
        return e.onError(v.xhr, d, v.url);
      }), !e.filter || e.filter.test(f) ? i[u] = f : i[u] = "", s());
    });
  }
  function o(c, u) {
    var d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], h = {};
    return h.rules = (c.replace(n.cssComments, "").match(n.cssImports) || []).filter(function(p) {
      return d.indexOf(p) === -1;
    }), h.urls = h.rules.map(function(p) {
      return p.replace(n.cssImports, "$1");
    }), h.absoluteUrls = h.urls.map(function(p) {
      return yu(p, u);
    }), h.absoluteRules = h.rules.map(function(p, f) {
      var m = h.urls[f], v = yu(h.absoluteUrls[f], u);
      return p.replace(m, v);
    }), h;
  }
  function l(c, u, d, h) {
    var p = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], f = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [], m = o(c, d, f);
    m.rules.length ? Cf(m.absoluteUrls, { onBeforeSend: function(v, E, y) {
      e.onBeforeSend(v, u, E);
    }, onSuccess: function(v, E, y) {
      var b = e.onSuccess(v, u, E), T = o(v = b === !1 ? "" : b || v, E, f);
      return T.rules.forEach(function(w, N) {
        v = v.replace(w, T.absoluteRules[N]);
      }), v;
    }, onError: function(v, E, y) {
      p.push({ xhr: v, url: E }), f.push(m.rules[y]), l(c, u, d, h, p, f);
    }, onComplete: function(v) {
      v.forEach(function(E, y) {
        c = c.replace(m.rules[y], E);
      }), l(c, u, d, h, p, f);
    } }) : h(c, p);
  }
  r.length ? r.forEach(function(c, u) {
    var d = c.getAttribute("href"), h = c.getAttribute("rel"), p = c.nodeName.toLowerCase() === "link" && d && h && h.toLowerCase().indexOf("stylesheet") !== -1, f = e.skipDisabled !== !1 && c.disabled, m = c.nodeName.toLowerCase() === "style";
    if (p && !f)
      if (d.indexOf("data:text/css") !== -1) {
        var v = decodeURIComponent(d.substring(d.indexOf(",") + 1));
        e.useCSSOM && (v = Array.apply(null, c.sheet.cssRules).map(function(y) {
          return y.cssText;
        }).join("")), a(v, u, c, location.href);
      } else
        Cf(d, { mimeType: "text/css", onBeforeSend: function(y, b, T) {
          e.onBeforeSend(y, c, b);
        }, onSuccess: function(y, b, T) {
          var w = yu(d);
          a(y, u, c, w);
        }, onError: function(y, b, T) {
          i[u] = "", e.onError(y, c, b), s();
        } });
    else if (m && !f) {
      var E = c.textContent;
      e.useCSSOM && (E = Array.apply(null, c.sheet.cssRules).map(function(y) {
        return y.cssText;
      }).join("")), a(E, u, c, location.href);
    } else
      i[u] = "", s();
  }) : e.onComplete("", []);
}
function yu(t, n) {
  var e = document.implementation.createHTMLDocument(""), r = e.createElement("base"), i = e.createElement("a");
  return e.head.appendChild(r), e.body.appendChild(i), r.href = n || document.baseURI || (document.querySelector("base") || {}).href || location.href, i.href = t, i.href;
}
var O_ = R_;
function R_(t, n, e) {
  t instanceof RegExp && (t = wf(t, e)), n instanceof RegExp && (n = wf(n, e));
  var r = D_(t, n, e);
  return r && { start: r[0], end: r[1], pre: e.slice(0, r[0]), body: e.slice(r[0] + t.length, r[1]), post: e.slice(r[1] + n.length) };
}
function wf(t, n) {
  var e = n.match(t);
  return e ? e[0] : null;
}
function D_(t, n, e) {
  var r, i, s, a, o, l = e.indexOf(t), c = e.indexOf(n, l + 1), u = l;
  if (l >= 0 && c > 0) {
    if (t === n)
      return [l, c];
    for (r = [], s = e.length; u >= 0 && !o; )
      u == l ? (r.push(u), l = e.indexOf(t, u + 1)) : r.length == 1 ? o = [r.pop(), c] : ((i = r.pop()) < s && (s = i, a = c), c = e.indexOf(n, u + 1)), u = l < c && l >= 0 ? l : c;
    r.length && (o = [s, a]);
  }
  return o;
}
function nh(t) {
  var n = ur({}, { preserveStatic: !0, removeComments: !1 }, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {});
  function e(v) {
    throw new Error("CSS parse error: ".concat(v));
  }
  function r(v) {
    var E = v.exec(t);
    if (E)
      return t = t.slice(E[0].length), E;
  }
  function i() {
    return r(/^{\s*/);
  }
  function s() {
    return r(/^}/);
  }
  function a() {
    r(/^\s*/);
  }
  function o() {
    if (a(), t[0] === "/" && t[1] === "*") {
      for (var v = 2; t[v] && (t[v] !== "*" || t[v + 1] !== "/"); )
        v++;
      if (!t[v])
        return e("end of comment is missing");
      var E = t.slice(2, v);
      return t = t.slice(v + 2), { type: "comment", comment: E };
    }
  }
  function l() {
    for (var v, E = []; v = o(); )
      E.push(v);
    return n.removeComments ? [] : E;
  }
  function c() {
    for (a(); t[0] === "}"; )
      e("extra closing bracket");
    var v = r(/^(("(?:\\"|[^"])*"|'(?:\\'|[^'])*'|[^{])+)/);
    if (v) {
      var E, y = v[0].trim();
      /\/\*/.test(y) && (y = y.replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, ""));
      var b = /["']\w*,\w*["']/.test(y);
      return b && (y = y.replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(T) {
        return T.replace(/,/g, "‌");
      })), E = /,/.test(y) ? y.split(/\s*(?![^(]*\)),\s*/) : [y], b && (E = E.map(function(T) {
        return T.replace(/\u200C/g, ",");
      })), E;
    }
  }
  function u() {
    if (t[0] === "@")
      return p();
    r(/^([;\s]*)+/);
    var v = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, E = r(/^(\*?[-#/*\\\w.]+(\[[0-9a-z_-]+\])?)\s*/);
    if (E) {
      if (E = E[0].trim(), !r(/^:\s*/))
        return e("property missing ':'");
      var y = r(/^((?:\/\*.*?\*\/|'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((\s*'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)]*?)\s*\)|[^};])+)/), b = { type: "declaration", property: E.replace(v, ""), value: y ? y[0].replace(v, "").trim() : "" };
      return r(/^[;\s]*/), b;
    }
  }
  function d() {
    if (!i())
      return e("missing '{'");
    for (var v, E = l(); v = u(); )
      E.push(v), E = E.concat(l());
    return s() ? E : e("missing '}'");
  }
  function h() {
    a();
    for (var v, E = []; v = r(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/); )
      E.push(v[1]), r(/^,\s*/);
    if (E.length)
      return { type: "keyframe", values: E, declarations: d() };
  }
  function p() {
    if (a(), t[0] === "@") {
      var v = function() {
        var y = r(/^@(import|charset|namespace)\s*([^;]+);/);
        if (y)
          return { type: y[1], name: y[2].trim() };
      }() || function() {
        if (r(/^@font-face\s*/))
          return { type: "font-face", declarations: d() };
      }() || function() {
        var y = r(/^@media([^{]+)*/);
        if (y)
          return { type: "media", media: (y[1] || "").trim(), rules: m() };
      }() || function() {
        var y = r(/^@([-\w]+)?keyframes\s*/);
        if (y) {
          var b = y[1];
          if (!(y = r(/^([-\w]+)\s*/)))
            return e("@keyframes missing name");
          var T, w = y[1];
          if (!i())
            return e("@keyframes missing '{'");
          for (var N = l(); T = h(); )
            N.push(T), N = N.concat(l());
          return s() ? { type: "keyframes", name: w, vendor: b, keyframes: N } : e("@keyframes missing '}'");
        }
      }() || function() {
        var y = r(/^@supports *([^{]+)/);
        if (y)
          return { type: "supports", supports: y[1].trim(), rules: m() };
      }() || function() {
        var y = r(/^@([-\w]+)?document *([^{]+)/);
        if (y)
          return { type: "document", document: y[2].trim(), vendor: y[1] ? y[1].trim() : null, rules: m() };
      }() || function() {
        var y = r(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
        if (y)
          return { type: "custom-media", name: y[1].trim(), media: y[2].trim() };
      }() || function() {
        if (r(/^@host\s*/))
          return { type: "host", rules: m() };
      }() || function() {
        if (r(/^@page */))
          return { type: "page", selectors: c() || [], declarations: d() };
      }() || function() {
        var y = r(/@(top|bottom|left|right)-(left|center|right|top|middle|bottom)-?(corner)?\s*/);
        if (y)
          return { type: "page-margin-box", name: "".concat(y[1], "-").concat(y[2]) + (y[3] ? "-".concat(y[3]) : ""), declarations: d() };
      }();
      if (v && !n.preserveStatic) {
        var E = !1;
        return v.declarations ? E = v.declarations.some(function(y) {
          return /var\(/.test(y.value);
        }) : E = (v.keyframes || v.rules || []).some(function(y) {
          return (y.declarations || []).some(function(b) {
            return /var\(/.test(b.value);
          });
        }), E ? v : {};
      }
      return v;
    }
  }
  function f() {
    if (!n.preserveStatic) {
      var v = O_("{", "}", t);
      if (v) {
        var E = /:(?:root|host)(?![.:#(])/.test(v.pre) && /--\S*\s*:/.test(v.body), y = /var\(/.test(v.body);
        if (!E && !y)
          return t = t.slice(v.end + 1), {};
      }
    }
    var b = c() || [], T = n.preserveStatic ? d() : d().filter(function(w) {
      var N = b.some(function(I) {
        return /:(?:root|host)(?![.:#(])/.test(I);
      }) && /^--\S/.test(w.property), M = /var\(/.test(w.value);
      return N || M;
    });
    return b.length || e("selector missing"), { type: "rule", selectors: b, declarations: T };
  }
  function m(v) {
    if (!v && !i())
      return e("missing '{'");
    for (var E, y = l(); t.length && (v || t[0] !== "}") && (E = p() || f()); )
      E.type && y.push(E), y = y.concat(l());
    return v || s() ? y : e("missing '}'");
  }
  return { type: "stylesheet", stylesheet: { rules: m(!0), errors: [] } };
}
function Sf(t) {
  var n = ur({}, { parseHost: !1, store: {}, onWarning: function() {
  } }, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}), e = new RegExp(":".concat(n.parseHost ? "host" : "root", "$"));
  return typeof t == "string" && (t = nh(t, n)), t.stylesheet.rules.forEach(function(r) {
    r.type === "rule" && r.selectors.some(function(i) {
      return e.test(i);
    }) && r.declarations.forEach(function(i, s) {
      var a = i.property, o = i.value;
      a && a.indexOf("--") === 0 && (n.store[a] = o);
    });
  }), n.store;
}
function L_(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", e = arguments.length > 2 ? arguments[2] : void 0, r = { charset: function(s) {
    return "@charset " + s.name + ";";
  }, comment: function(s) {
    return s.comment.indexOf("__CSSVARSPONYFILL") === 0 ? "/*" + s.comment + "*/" : "";
  }, "custom-media": function(s) {
    return "@custom-media " + s.name + " " + s.media + ";";
  }, declaration: function(s) {
    return s.property + ":" + s.value + ";";
  }, document: function(s) {
    return "@" + (s.vendor || "") + "document " + s.document + "{" + i(s.rules) + "}";
  }, "font-face": function(s) {
    return "@font-face{" + i(s.declarations) + "}";
  }, host: function(s) {
    return "@host{" + i(s.rules) + "}";
  }, import: function(s) {
    return "@import " + s.name + ";";
  }, keyframe: function(s) {
    return s.values.join(",") + "{" + i(s.declarations) + "}";
  }, keyframes: function(s) {
    return "@" + (s.vendor || "") + "keyframes " + s.name + "{" + i(s.keyframes) + "}";
  }, media: function(s) {
    return "@media " + s.media + "{" + i(s.rules) + "}";
  }, namespace: function(s) {
    return "@namespace " + s.name + ";";
  }, page: function(s) {
    return "@page " + (s.selectors.length ? s.selectors.join(", ") : "") + "{" + i(s.declarations) + "}";
  }, "page-margin-box": function(s) {
    return "@" + s.name + "{" + i(s.declarations) + "}";
  }, rule: function(s) {
    var a = s.declarations;
    if (a.length)
      return s.selectors.join(",") + "{" + i(a) + "}";
  }, supports: function(s) {
    return "@supports " + s.supports + "{" + i(s.rules) + "}";
  } };
  function i(s) {
    for (var a = "", o = 0; o < s.length; o++) {
      var l = s[o];
      e && e(l);
      var c = r[l.type](l);
      c && (a += c, c.length && l.selectors && (a += n));
    }
    return a;
  }
  return i(t.stylesheet.rules);
}
function U_(t, n) {
  t.rules.forEach(function(e) {
    e.rules ? U_(e, n) : e.keyframes ? e.keyframes.forEach(function(r) {
      r.type === "keyframe" && n(r.declarations, e);
    }) : e.declarations && n(e.declarations, t);
  });
}
R_.range = D_;
var Ow = "--", Rw = "var";
function Dw(t) {
  var n = ur({}, { preserveStatic: !0, preserveVars: !1, variables: {}, onWarning: function() {
  } }, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {});
  return typeof t == "string" && (t = nh(t, n)), U_(t.stylesheet, function(e, r) {
    for (var i = 0; i < e.length; i++) {
      var s = e[i], a = s.type, o = s.property, l = s.value;
      if (a === "declaration")
        if (n.preserveVars || !o || o.indexOf(Ow) !== 0) {
          if (l.indexOf(Rw + "(") !== -1) {
            var c = Wa(l, n);
            c !== s.value && (c = Lw(c), n.preserveVars ? (e.splice(i, 0, { type: a, property: o, value: c }), i++) : s.value = c);
          }
        } else
          e.splice(i, 1), i--;
    }
  }), L_(t);
}
function Lw(t) {
  return (t.match(/calc\(([^)]+)\)/g) || []).forEach(function(n) {
    var e = "calc".concat(n.split("calc").join(""));
    t = t.replace(n, e);
  }), t;
}
function Wa(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = arguments.length > 2 ? arguments[2] : void 0;
  if (t.indexOf("var(") === -1)
    return t;
  var r = O_("(", ")", t);
  return r ? r.pre.slice(-3) === "var" ? r.body.trim().length === 0 ? (n.onWarning("var() must contain a non-whitespace string"), t) : r.pre.slice(0, -3) + function(i) {
    var s = i.split(",")[0].replace(/[\s\n\t]/g, ""), a = (i.match(/(?:\s*,\s*){1}(.*)?/) || [])[1], o = Object.prototype.hasOwnProperty.call(n.variables, s) ? String(n.variables[s]) : void 0, l = o || (a ? String(a) : void 0), c = e || i;
    return o || n.onWarning('variable "'.concat(s, '" is undefined')), l && l !== "undefined" && l.length > 0 ? Wa(l, n, c) : "var(".concat(c, ")");
  }(r.body) + Wa(r.post, n) : r.pre + "(".concat(Wa(r.body, n), ")") + Wa(r.post, n) : (t.indexOf("var(") !== -1 && n.onWarning('missing closing ")" in the value "'.concat(t, '"')), t);
}
var Nc = typeof window < "u", Nf = Nc && window.CSS && window.CSS.supports && window.CSS.supports("(--a: 0)"), Ms = { group: 0, job: 0 }, hl = { rootElement: Nc ? document : null, shadowDOM: !1, include: "style,link[rel=stylesheet]", exclude: "", variables: {}, onlyLegacy: !0, preserveStatic: !0, preserveVars: !1, silent: !1, updateDOM: !0, updateURLs: !0, watch: null, onBeforeSend: function() {
}, onError: function() {
}, onWarning: function() {
}, onSuccess: function() {
}, onComplete: function() {
}, onFinally: function() {
} }, ni = { cssComments: /\/\*[\s\S]+?\*\//g, cssKeyframes: /@(?:-\w*-)?keyframes/, cssMediaQueries: /@media[^{]+\{([\s\S]+?})\s*}/g, cssUrls: /url\((?!['"]?(?:data|http|\/\/):)['"]?([^'")]*)['"]?\)/g, cssVarDeclRules: /(?::(?:root|host)(?![.:#(])[\s,]*[^{]*{\s*[^}]*})/g, cssVarDecls: /(?:[\s;]*)(-{2}\w[\w-]*)(?:\s*:\s*)([^;]*);/g, cssVarFunc: /var\(\s*--[\w-]/, cssVars: /(?:(?::(?:root|host)(?![.:#(])[\s,]*[^{]*{\s*[^;]*;*\s*)|(?:var\(\s*))(--[^:)]+)(?:\s*[:)])/ }, gn = { dom: {}, job: {}, user: {} }, Ol = !1, vr = null, Qa = 0, Td = null, wd = !1;
/**
 * Fetches, parses, and transforms CSS custom properties from specified
 * <style> and <link> elements into static values, then appends a new <style>
 * element with static values to the DOM to provide CSS custom property
 * compatibility for legacy browsers. Also provides a single interface for
 * live updates of runtime values in both modern and legacy browsers.
 *
 * @preserve
 * @param {object}   [options] Options object
 * @param {object}   [options.rootElement=document] Root element to traverse for
 *                   <link> and <style> nodes
 * @param {boolean}  [options.shadowDOM=false] Determines if shadow DOM <link>
 *                   and <style> nodes will be processed.
 * @param {string}   [options.include="style,link[rel=stylesheet]"] CSS selector
 *                   matching <link re="stylesheet"> and <style> nodes to
 *                   process
 * @param {string}   [options.exclude] CSS selector matching <link
 *                   rel="stylehseet"> and <style> nodes to exclude from those
 *                   matches by options.include
 * @param {object}   [options.variables] A map of custom property name/value
 *                   pairs. Property names can omit or include the leading
 *                   double-hyphen (—), and values specified will override
 *                   previous values
 * @param {boolean}  [options.onlyLegacy=true] Determines if the ponyfill will
 *                   only generate legacy-compatible CSS in browsers that lack
 *                   native support (i.e., legacy browsers)
 * @param {boolean}  [options.preserveStatic=true] Determines if CSS
 *                   declarations that do not reference a custom property will
 *                   be preserved in the transformed CSS
 * @param {boolean}  [options.preserveVars=false] Determines if CSS custom
 *                   property declarations will be preserved in the transformed
 *                   CSS
 * @param {boolean}  [options.silent=false] Determines if warning and error
 *                   messages will be displayed on the console
 * @param {boolean}  [options.updateDOM=true] Determines if the ponyfill will
 *                   update the DOM after processing CSS custom properties
 * @param {boolean}  [options.updateURLs=true] Determines if relative url()
 *                   paths will be converted to absolute urls in external CSS
 * @param {boolean}  [options.watch=false] Determines if a MutationObserver will
 *                   be created that will execute the ponyfill when a <link> or
 *                   <style> DOM mutation is observed
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments
 * @param {function} [options.onError] Callback after a CSS parsing error has
 *                   occurred or an XHR request has failed. Passes 1) an error
 *                   message, and 2) source node reference, 3) xhr, and 4 url as
 *                   arguments.
 * @param {function} [options.onWarning] Callback after each CSS parsing warning
 *                   has occurred. Passes 1) a warning message as an argument.
 * @param {function} [options.onSuccess] Callback after CSS data has been
 *                   collected from each node and before CSS custom properties
 *                   have been transformed. Allows modifying the CSS data before
 *                   it is transformed by returning any string value (or false
 *                   to skip). Passes 1) CSS text, 2) source node reference, and
 *                   3) the source URL as arguments.
 * @param {function} [options.onComplete] Callback after all CSS has been
 *                   processed, legacy-compatible CSS has been generated, and
 *                   (optionally) the DOM has been updated. Passes 1) a CSS
 *                   string with CSS variable values resolved, 2) an array of
 *                   output <style> node references that have been appended to
 *                   the DOM, 3) an object containing all custom properies names
 *                   and values, and 4) the ponyfill execution time in
 *                   milliseconds.
 * @param {function} [options.onFinally] Callback in modern and legacy browsers
 *                   after the ponyfill has finished all tasks. Passes 1) a
 *                   boolean indicating if the last ponyfill call resulted in a
 *                   style change, 2) a boolean indicating if the current
 *                   browser provides native support for CSS custom properties,
 *                   and 3) the ponyfill execution time in milliseconds.
 * @example
 *
 *   cssVars({
 *     rootElement   : document,
 *     shadowDOM     : false,
 *     include       : 'style,link[rel="stylesheet"]',
 *     exclude       : '',
 *     variables     : {},
 *     onlyLegacy    : true,
 *     preserveStatic: true,
 *     preserveVars  : false,
 *     silent        : false,
 *     updateDOM     : true,
 *     updateURLs    : true,
 *     watch         : false,
 *     onBeforeSend(xhr, node, url) {},
 *     onError(message, node, xhr, url) {},
 *     onWarning(message) {},
 *     onSuccess(cssText, node, url) {},
 *     onComplete(cssText, styleNode, cssVariables, benchmark) {},
 *     onFinally(hasChanged, hasNativeSupport, benchmark)
 *   });
 */
function Ii() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = "cssVars(): ", e = ur({}, hl, t);
  function r(c, u, d, h) {
    !e.silent && window.console && console.error("".concat(n).concat(c, `
`), u), e.onError(c, u, d, h);
  }
  function i(c) {
    !e.silent && window.console && console.warn("".concat(n).concat(c)), e.onWarning(c);
  }
  function s(c) {
    e.onFinally(!!c, Nf, bu() - e.__benchmark);
  }
  if (Nc) {
    if (e.watch)
      return e.watch = hl.watch, function(c) {
        function u(E) {
          var y = d(E) && E.hasAttribute("disabled"), b = (E.sheet || {}).disabled;
          return y || b;
        }
        function d(E) {
          return E.nodeName.toLowerCase() === "link" && (E.getAttribute("rel") || "").indexOf("stylesheet") !== -1;
        }
        function h(E) {
          return E.nodeName.toLowerCase() === "style";
        }
        function p(E) {
          var y = !1;
          if (E.type === "attributes" && d(E.target) && !u(E.target)) {
            var b = E.attributeName === "disabled", T = E.attributeName === "href", w = E.target.getAttribute("data-cssvars") === "skip", N = E.target.getAttribute("data-cssvars") === "src";
            b ? y = !w && !N : T && (w ? E.target.setAttribute("data-cssvars", "") : N && Eu(c.rootElement, !0), y = !0);
          }
          return y;
        }
        function f(E) {
          var y = !1;
          if (E.type === "childList") {
            var b = h(E.target), T = E.target.getAttribute("data-cssvars") === "out";
            y = b && !T;
          }
          return y;
        }
        function m(E) {
          var y = !1;
          return E.type === "childList" && (y = [].slice.call(E.addedNodes).some(function(b) {
            var T = b.nodeType === 1 && b.hasAttribute("data-cssvars"), w = h(b) && ni.cssVars.test(b.textContent);
            return !T && (d(b) || w) && !u(b);
          })), y;
        }
        function v(E) {
          var y = !1;
          return E.type === "childList" && (y = [].slice.call(E.removedNodes).some(function(b) {
            var T = b.nodeType === 1, w = T && b.getAttribute("data-cssvars") === "out", N = T && b.getAttribute("data-cssvars") === "src", M = N;
            if (N || w) {
              var I = b.getAttribute("data-cssvars-group"), x = c.rootElement.querySelector('[data-cssvars-group="'.concat(I, '"]'));
              N && Eu(c.rootElement, !0), x && x.parentNode.removeChild(x);
            }
            return M;
          })), y;
        }
        window.MutationObserver && (vr && (vr.disconnect(), vr = null), vr = new MutationObserver(function(E) {
          E.some(function(y) {
            return p(y) || f(y) || m(y) || v(y);
          }) && Ii(c);
        }), vr.observe(document.documentElement, { attributes: !0, attributeFilter: ["disabled", "href"], childList: !0, subtree: !0 }));
      }(e), void Ii(e);
    if (e.watch === !1 && vr && (vr.disconnect(), vr = null), !e.__benchmark) {
      if (Ol === e.rootElement)
        return void function(c) {
          var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
          clearTimeout(Td), Td = setTimeout(function() {
            c.__benchmark = null, Ii(c);
          }, u);
        }(t);
      var a = [].slice.call(e.rootElement.querySelectorAll('[data-cssvars]:not([data-cssvars="out"])'));
      e.__benchmark = bu(), e.exclude = [vr ? '[data-cssvars]:not([data-cssvars=""])' : '[data-cssvars="out"]', "link[disabled]:not([data-cssvars])", e.exclude].filter(function(c) {
        return c;
      }).join(","), e.variables = function() {
        var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = /^-{2}/;
        return Object.keys(c).reduce(function(d, h) {
          return d[u.test(h) ? h : "--".concat(h.replace(/^-+/, ""))] = c[h], d;
        }, {});
      }(e.variables), a.forEach(function(c) {
        var u = c.nodeName.toLowerCase() === "style" && c.__cssVars.text, d = u && c.textContent !== c.__cssVars.text;
        u && d && (c.sheet && (c.sheet.disabled = !1), c.setAttribute("data-cssvars", ""));
      }), !vr && ([].slice.call(e.rootElement.querySelectorAll('[data-cssvars="out"]')).forEach(function(c) {
        var u = c.getAttribute("data-cssvars-group");
        u && e.rootElement.querySelector('[data-cssvars="src"][data-cssvars-group="'.concat(u, '"]')) || c.parentNode.removeChild(c);
      }), Qa && a.length < Qa && (Qa = a.length, gn.dom = {}));
    }
    if (document.readyState !== "loading")
      if (Nf && e.onlyLegacy) {
        var o = !1;
        if (e.updateDOM) {
          var l = e.rootElement.host || (e.rootElement === document ? document.documentElement : e.rootElement);
          Object.keys(e.variables).forEach(function(c) {
            var u = e.variables[c];
            o = o || u !== getComputedStyle(l).getPropertyValue(c), l.style.setProperty(c, u);
          });
        }
        s(o);
      } else
        !wd && (e.shadowDOM || e.rootElement.shadowRoot || e.rootElement.host) ? Tf({ rootElement: hl.rootElement, include: hl.include, exclude: e.exclude, skipDisabled: !1, onSuccess: function(c, u, d) {
          return !((u.sheet || {}).disabled && !u.__cssVars) && ((c = ((c = c.replace(ni.cssComments, "").replace(ni.cssMediaQueries, "")).match(ni.cssVarDeclRules) || []).join("")) || !1);
        }, onComplete: function(c, u, d) {
          Sf(c, { store: gn.dom, onWarning: i }), wd = !0, Ii(e);
        } }) : (Ol = e.rootElement, Tf({ rootElement: e.rootElement, include: e.include, exclude: e.exclude, skipDisabled: !1, onBeforeSend: e.onBeforeSend, onError: function(c, u, d) {
          var h = c.responseURL || If(d, location.href), p = c.statusText ? "(".concat(c.statusText, ")") : "Unspecified Error" + (c.status === 0 ? " (possibly CORS related)" : "");
          r("CSS XHR Error: ".concat(h, " ").concat(c.status, " ").concat(p), u, c, h);
        }, onSuccess: function(c, u, d) {
          if ((u.sheet || {}).disabled && !u.__cssVars)
            return !1;
          var h = u.nodeName.toLowerCase() === "link", p = u.nodeName.toLowerCase() === "style" && c !== u.textContent, f = e.onSuccess(c, u, d);
          return c = f !== void 0 && !f ? "" : f || c, e.updateURLs && (h || p) && (c = function(m, v) {
            var E = m.replace(ni.cssComments, "").match(ni.cssUrls) || [];
            return E.forEach(function(y) {
              var b = y.replace(ni.cssUrls, "$1"), T = If(b, v);
              m = m.replace(y, y.replace(b, T));
            }), m;
          }(c, d)), c;
        }, onComplete: function(c, u) {
          var d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], h = ur({}, gn.dom, gn.user);
          if (gn.job = {}, d.forEach(function(b, T) {
            var w = u[T];
            if (b.__cssVars = b.__cssVars || {}, b.__cssVars.text = w, ni.cssVars.test(w))
              try {
                var N = nh(w, { preserveStatic: e.preserveStatic, removeComments: !0 });
                Sf(N, { parseHost: !!e.rootElement.host, store: gn.dom, onWarning: i }), b.__cssVars.tree = N;
              } catch (M) {
                r(M.message, b);
              }
          }), ur(gn.job, gn.dom), e.updateDOM ? (ur(gn.user, e.variables), ur(gn.job, gn.user)) : (ur(gn.job, gn.user, e.variables), ur(h, e.variables)), Ms.job > 0 && !!(Object.keys(gn.job).length > Object.keys(h).length || Object.keys(h).length && Object.keys(gn.job).some(function(b) {
            return gn.job[b] !== h[b];
          })))
            Eu(e.rootElement), Ii(e);
          else {
            var p = [], f = [], m = !1;
            if (e.updateDOM && Ms.job++, d.forEach(function(b, T) {
              var w = !b.__cssVars.tree;
              if (b.__cssVars.tree)
                try {
                  Dw(b.__cssVars.tree, ur({}, e, { variables: gn.job, onWarning: i }));
                  var N = L_(b.__cssVars.tree);
                  if (e.updateDOM) {
                    var M = u[T], I = ni.cssVarFunc.test(M);
                    if (b.getAttribute("data-cssvars") || b.setAttribute("data-cssvars", "src"), N.length && I) {
                      var x = b.getAttribute("data-cssvars-group") || ++Ms.group, R = N.replace(/\s/g, ""), L = e.rootElement.querySelector('[data-cssvars="out"][data-cssvars-group="'.concat(x, '"]')) || document.createElement("style");
                      m = m || ni.cssKeyframes.test(N), e.preserveStatic && b.sheet && (b.sheet.disabled = !0), L.hasAttribute("data-cssvars") || L.setAttribute("data-cssvars", "out"), R === b.textContent.replace(/\s/g, "") ? (w = !0, L && L.parentNode && (b.removeAttribute("data-cssvars-group"), L.parentNode.removeChild(L))) : R !== L.textContent.replace(/\s/g, "") && ([b, L].forEach(function(j) {
                        j.setAttribute("data-cssvars-job", Ms.job), j.setAttribute("data-cssvars-group", x);
                      }), L.textContent = N, p.push(N), f.push(L), L.parentNode || b.parentNode.insertBefore(L, b.nextSibling));
                    }
                  } else
                    b.textContent.replace(/\s/g, "") !== N && p.push(N);
                } catch (j) {
                  r(j.message, b);
                }
              w && b.setAttribute("data-cssvars", "skip"), b.hasAttribute("data-cssvars-job") || b.setAttribute("data-cssvars-job", Ms.job);
            }), Qa = e.rootElement.querySelectorAll('[data-cssvars]:not([data-cssvars="out"])').length, e.shadowDOM)
              for (var v, E = [].concat(e.rootElement).concat([].slice.call(e.rootElement.querySelectorAll("*"))), y = 0; v = E[y]; ++y)
                v.shadowRoot && v.shadowRoot.querySelector("style") && Ii(ur({}, e, { rootElement: v.shadowRoot }));
            e.updateDOM && m && function(b) {
              var T = ["animation-name", "-moz-animation-name", "-webkit-animation-name"].filter(function(q) {
                return getComputedStyle(document.body)[q];
              })[0];
              if (T) {
                for (var w = [].slice.call(b.querySelectorAll("*")), N = [], M = "__CSSVARSPONYFILL-KEYFRAMES__", I = 0, x = w.length; I < x; I++) {
                  var R = w[I];
                  getComputedStyle(R)[T] !== "none" && (R.style[T] += M, N.push(R));
                }
                document.body.offsetHeight;
                for (var L = 0, j = N.length; L < j; L++) {
                  var P = N[L].style;
                  P[T] = P[T].replace(M, "");
                }
              }
            }(e.rootElement), Ol = !1, e.onComplete(p.join(""), f, JSON.parse(JSON.stringify(gn.job)), bu() - e.__benchmark), s(f.length);
          }
        } }));
    else
      document.addEventListener("DOMContentLoaded", function c(u) {
        Ii(t), document.removeEventListener("DOMContentLoaded", c);
      });
  }
}
function If(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : location.href, e = document.implementation.createHTMLDocument(""), r = e.createElement("base"), i = e.createElement("a");
  return e.head.appendChild(r), e.body.appendChild(i), r.href = n, i.href = t, i.href;
}
function bu() {
  return Nc && (window.performance || {}).now ? window.performance.now() : (/* @__PURE__ */ new Date()).getTime();
}
function Eu(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
  [].slice.call(t.querySelectorAll('[data-cssvars="skip"],[data-cssvars="src"]')).forEach(function(e) {
    return e.setAttribute("data-cssvars", "");
  }), n && (gn.dom = {});
}
Ii.reset = function() {
  for (var t in Ms.job = 0, Ms.group = 0, Ol = !1, vr && (vr.disconnect(), vr = null), Qa = 0, Td = null, wd = !1, gn)
    gn[t] = {};
};
const Uw = { "--sendbird-dark-primary-500": "#491389", "--sendbird-dark-primary-400": "#6211c8", "--sendbird-dark-primary-300": "#742ddd", "--sendbird-dark-primary-200": "#c2a9fa", "--sendbird-dark-primary-100": "#dbd1ff", "--sendbird-dark-secondary-500": "#007A7A", "--sendbird-dark-secondary-400": "#189A8D", "--sendbird-dark-secondary-300": "#2EBA9F", "--sendbird-dark-secondary-200": "#6FD6BE", "--sendbird-dark-secondary-100": "#AEF2DC", "--sendbird-dark-information-100": "#b2d9ff", "--sendbird-dark-error-500": "#9d091e", "--sendbird-dark-error-400": "#bf0711", "--sendbird-dark-error-300": "#de360b", "--sendbird-dark-error-200": "#f66161", "--sendbird-dark-error-100": "#fdaaaa", "--sendbird-dark-background-700": "#000000", "--sendbird-dark-background-600": "#161616", "--sendbird-dark-background-500": "#2C2C2C", "--sendbird-dark-background-400": "#393939", "--sendbird-dark-background-300": "#A8A8A8", "--sendbird-dark-background-200": "#D9D9D9", "--sendbird-dark-background-100": "#F0F0F0", "--sendbird-dark-background-50": "#FFFFFF", "--sendbird-dark-overlay": "rgba(0, 0, 0, 0.32)", "--sendbird-dark-onlight-01": "rgba(0, 0, 0, 0.88)", "--sendbird-dark-onlight-02": "rgba(0, 0, 0, 0.50)", "--sendbird-dark-onlight-03": "rgba(0, 0, 0, 0.38)", "--sendbird-dark-onlight-04": "rgba(0, 0, 0, 0.12)", "--sendbird-dark-ondark-01": "rgba(255, 255, 255, 0.88)", "--sendbird-dark-ondark-02": "rgba(255, 255, 255, 0.50)", "--sendbird-dark-ondark-03": "rgba(255, 255, 255, 0.38)", "--sendbird-dark-ondark-04": "rgba(255, 255, 255, 0.12)", "--sendbird-dark-shadow-01": "0 1px 5px 0 rgba(33, 34, 66, 0.04), 0 0 3px 0 rgba(0, 0, 0, 0.08), 0 2px 1px 0 rgba(0, 0, 0, 0.12)", "--sendbird-dark-shadow-02": "0 3px 5px -3px rgba(33, 34, 66, 0.04), 0 3px 14px 2px rgba(0, 0, 0, 0.08), 0 8px 10px 1px rgba(0, 0, 0, 0.12)", "--sendbird-dark-shadow-03": "0 6px 10px -5px rgba(0, 0, 0, 0.04), 0 6px 30px 5px rgba(0, 0, 0, 0.08), 0 16px 24px 2px rgba(0, 0, 0, 0.12)", "--sendbird-dark-shadow-04": "0 9px 15px -7px rgba(0, 0, 0, 0.04), 0 9px 46px 8px rgba(0, 0, 0, 0.08), 0 24px 38px 3px rgba(0, 0, 0, 0.12)", "--sendbird-dark-shadow-message-input": "0 1px 5px 0 rgba(33, 34, 66, 0.12), 0 0 1px 0 rgba(33, 34, 66, 0.16), 0 2px 1px 0 rgba(33, 34, 66, 0.08), 0 1px 5px 0 rgba(0, 0, 0, 0.12)", "--sendbird-light-primary-500": "#491389", "--sendbird-light-primary-400": "#6211c8", "--sendbird-light-primary-300": "#742ddd", "--sendbird-light-primary-200": "#c2a9fa", "--sendbird-light-primary-100": "#dbd1ff", "--sendbird-light-secondary-500": "#007A7A", "--sendbird-light-secondary-400": "#189A8D", "--sendbird-light-secondary-300": "#2EBA9F", "--sendbird-light-secondary-200": "#6FD6BE", "--sendbird-light-secondary-100": "#AEF2DC", "--sendbird-light-information-100": "#b2d9ff", "--sendbird-light-error-500": "#9d091e", "--sendbird-light-error-400": "#bf0711", "--sendbird-light-error-300": "#de360b", "--sendbird-light-error-200": "#f66161", "--sendbird-light-error-100": "#fdaaaa", "--sendbird-light-background-700": "#000000", "--sendbird-light-background-600": "#161616", "--sendbird-light-background-500": "#2C2C2C", "--sendbird-light-background-400": "#393939", "--sendbird-light-background-300": "#A8A8A8", "--sendbird-light-background-200": "#D9D9D9", "--sendbird-light-background-100": "#F0F0F0", "--sendbird-light-background-50": " #FFFFFF", "--sendbird-light-overlay": "rgba(0, 0, 0, 0.32)", "--sendbird-light-onlight-01": "rgba(0, 0, 0, 0.88)", "--sendbird-light-onlight-02": "rgba(0, 0, 0, 0.50)", "--sendbird-light-onlight-03": "rgba(0, 0, 0, 0.38)", "--sendbird-light-onlight-04": "rgba(0, 0, 0, 0.12)", "--sendbird-light-ondark-01": "rgba(255, 255, 255, 0.88)", "--sendbird-light-ondark-02": "rgba(255, 255, 255, 0.50)", "--sendbird-light-ondark-03": "rgba(255, 255, 255, 0.38)", "--sendbird-light-ondark-04": "rgba(255, 255, 255, 0.12)", "--sendbird-light-shadow-01": "0 1px 5px 0 rgba(33, 34, 66, 0.04), 0 0 3px 0 rgba(0, 0, 0, 0.08), 0 2px 1px 0 rgba(0, 0, 0, 0.12)", "--sendbird-light-shadow-02": "0 3px 5px -3px rgba(33, 34, 66, 0.04), 0 3px 14px 2px rgba(0, 0, 0, 0.08), 0 8px 10px 1px rgba(0, 0, 0, 0.12)", "--sendbird-light-shadow-03": "0 6px 10px -5px rgba(0, 0, 0, 0.04), 0 6px 30px 5px rgba(0, 0, 0, 0.08), 0 16px 24px 2px rgba(0, 0, 0, 0.12)", "--sendbird-light-shadow-04": "0 9px 15px -7px rgba(0, 0, 0, 0.04), 0 9px 46px 8px rgba(0, 0, 0, 0.08), 0 24px 38px 3px rgba(0, 0, 0, 0.12)", "--sendbird-light-shadow-message-input": "0 1px 5px 0 rgba(33, 34, 66, 0.12), 0 0 1px 0 rgba(33, 34, 66, 0.16), 0 2px 1px 0 rgba(33, 34, 66, 0.08), 0 1px 5px 0 rgba(0, 0, 0, 0.12)" }, Pw = (t) => {
  hr(() => {
    ((n) => {
      if (n == null)
        return !0;
      for (const e in n)
        if (n.hasOwnProperty(e))
          return !1;
      return JSON.stringify(n) === JSON.stringify({});
    })(t) || Ii({ variables: { ...Uw, ...kw(t) } });
  }, [t]);
};
var uc = Symbol("@ts-pattern/matcher"), Af = "@ts-pattern/anonymous-select-key", Mf = function(t) {
  return !!(t && typeof t == "object");
}, Cu = function(t) {
  return t && !!t[uc];
}, Fw = function t(n, e, r) {
  if (Mf(n)) {
    if (Cu(n)) {
      var i = n[uc]().match(e), s = i.matched, a = i.selections;
      return s && a && Object.keys(a).forEach(function(l) {
        return r(l, a[l]);
      }), s;
    }
    if (!Mf(e))
      return !1;
    if (Array.isArray(n))
      return !!Array.isArray(e) && n.length === e.length && n.every(function(l, c) {
        return t(l, e[c], r);
      });
    if (n instanceof Map)
      return e instanceof Map && Array.from(n.keys()).every(function(l) {
        return t(n.get(l), e.get(l), r);
      });
    if (n instanceof Set) {
      if (!(e instanceof Set))
        return !1;
      if (n.size === 0)
        return e.size === 0;
      if (n.size === 1) {
        var o = Array.from(n.values())[0];
        return Cu(o) ? Array.from(e.values()).every(function(l) {
          return t(o, l, r);
        }) : e.has(o);
      }
      return Array.from(n.values()).every(function(l) {
        return e.has(l);
      });
    }
    return Object.keys(n).every(function(l) {
      var c, u = n[l];
      return (l in e || Cu(c = u) && c[uc]().matcherType === "optional") && t(u, e[l], r);
    });
  }
  return Object.is(e, n);
};
function ys(t) {
  var n;
  return (n = {})[uc] = function() {
    return { match: function(e) {
      return { matched: !!t(e) };
    } };
  }, n;
}
function Fo(t) {
  return new jw(t, []);
}
ys(function(t) {
  return !0;
}), ys(function(t) {
  return typeof t == "string";
}), ys(function(t) {
  return typeof t == "number";
}), ys(function(t) {
  return typeof t == "boolean";
}), ys(function(t) {
  return typeof t == "bigint";
}), ys(function(t) {
  return typeof t == "symbol";
}), ys(function(t) {
  return t == null;
});
var jw = function() {
  function t(e, r) {
    this.value = void 0, this.cases = void 0, this.value = e, this.cases = r;
  }
  var n = t.prototype;
  return n.with = function() {
    var e = [].slice.call(arguments), r = e[e.length - 1], i = [e[0]], s = [];
    return e.length === 3 && typeof e[1] == "function" ? (i.push(e[0]), s.push(e[1])) : e.length > 2 && i.push.apply(i, e.slice(1, e.length - 1)), new t(this.value, this.cases.concat([{ match: function(a) {
      var o = {}, l = !!(i.some(function(c) {
        return Fw(c, a, function(u, d) {
          o[u] = d;
        });
      }) && s.every(function(c) {
        return c(a);
      }));
      return { matched: l, value: l && Object.keys(o).length ? Af in o ? o[Af] : o : a };
    }, handler: r }]));
  }, n.when = function(e, r) {
    return new t(this.value, this.cases.concat([{ match: function(i) {
      return { matched: !!e(i), value: i };
    }, handler: r }]));
  }, n.otherwise = function(e) {
    return new t(this.value, this.cases.concat([{ match: function(r) {
      return { matched: !0, value: r };
    }, handler: e }])).run();
  }, n.exhaustive = function() {
    return this.run();
  }, n.run = function() {
    for (var e = this.value, r = void 0, i = 0; i < this.cases.length; i++) {
      var s = this.cases[i], a = s.match(this.value);
      if (a.matched) {
        e = a.value, r = s.handler;
        break;
      }
    }
    if (!r) {
      var o;
      try {
        o = JSON.stringify(this.value);
      } catch {
        o = this.value;
      }
      throw new Error("Pattern matching error: no pattern matches value " + o);
    }
    return r(e, this.value);
  }, t;
}();
const Ps = { INIT_SDK: "INIT_SDK", SET_SDK_LOADING: "SET_SDK_LOADING", RESET_SDK: "RESET_SDK", SDK_ERROR: "SDK_ERROR" }, P_ = { initialized: !1, loading: !1, sdk: {}, error: !1 };
function Hw(t, n) {
  return Fo(n).with({ type: Ps.SET_SDK_LOADING }, ({ payload: e }) => ({ ...t, initialized: !1, loading: e })).with({ type: Ps.SDK_ERROR }, () => ({ ...t, initialized: !1, loading: !1, error: !0 })).with({ type: Ps.INIT_SDK }, ({ payload: e }) => ({ sdk: e, initialized: !0, loading: !1, error: !1 })).with({ type: Ps.RESET_SDK }, () => P_).otherwise(() => t);
}
const bo = { INIT_USER: "INIT_USER", RESET_USER: "RESET_USER", UPDATE_USER_INFO: "UPDATE_USER_INFO" }, F_ = { initialized: !1, loading: !1, user: {} };
function Bw(t, n) {
  return Fo(n).with({ type: bo.INIT_USER }, ({ payload: e }) => ({ initialized: !0, loading: !1, user: e })).with({ type: bo.RESET_USER }, () => F_).with({ type: bo.UPDATE_USER_INFO }, ({ payload: e }) => ({ ...t, user: e })).otherwise(() => t);
}
const Ya = { INITIALIZE_MESSAGE_TEMPLATES_INFO: "INITIALIZE_MESSAGE_TEMPLATES_INFO", UPSERT_MESSAGE_TEMPLATES: "UPSERT_MESSAGE_TEMPLATES", UPSERT_WAITING_TEMPLATE_KEYS: "UPSERT_WAITING_TEMPLATE_KEYS", MARK_ERROR_WAITING_TEMPLATE_KEYS: "MARK_ERROR_WAITING_TEMPLATE_KEYS" };
function zw(t, n) {
  return Fo(n).with({ type: Ya.INITIALIZE_MESSAGE_TEMPLATES_INFO }, ({ payload: e }) => ({ messageTemplatesInfo: e, waitingTemplateKeysMap: {} })).with({ type: Ya.UPSERT_MESSAGE_TEMPLATES }, ({ payload: e }) => {
    const r = t.messageTemplatesInfo;
    if (!r)
      return t;
    const i = { ...t.waitingTemplateKeysMap };
    return e.forEach((s) => {
      const { key: a, template: o } = s;
      r.templatesMap[a] = o, delete i[a];
    }), { ...t, waitingTemplateKeysMap: i, messageTemplatesInfo: r };
  }).with({ type: Ya.UPSERT_WAITING_TEMPLATE_KEYS }, ({ payload: e }) => {
    const { keys: r, requestedAt: i } = e, s = { ...t.waitingTemplateKeysMap };
    return r.forEach((a) => {
      var o;
      s[a] = { erroredMessageIds: ((o = s[a]) == null ? void 0 : o.erroredMessageIds) ?? [], requestedAt: i };
    }), { ...t, waitingTemplateKeysMap: s };
  }).with({ type: Ya.MARK_ERROR_WAITING_TEMPLATE_KEYS }, ({ payload: e }) => {
    const { keys: r, messageId: i } = e, s = { ...t.waitingTemplateKeysMap };
    return r.forEach((a) => {
      const o = s[a];
      o && o.erroredMessageIds.indexOf(i) === -1 && o.erroredMessageIds.push(i);
    }), { ...t, waitingTemplateKeysMap: s };
  }).otherwise(() => t);
}
const Vw = { waitingTemplateKeysMap: {} }, xo = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
  const n = 16 * Math.random() | 0;
  return (t === "x" ? n : 3 & n | 8).toString(16);
});
async function j_({ sdkDispatcher: t, userDispatcher: n, sdk: e }) {
  return new Promise((r) => {
    t({ type: Ps.SET_SDK_LOADING, payload: !0 }), e != null && e.disconnectWebSocket ? e.disconnectWebSocket().then(() => {
      t({ type: Ps.RESET_SDK }), n({ type: bo.RESET_USER });
    }).finally(() => {
      r(!0);
    }) : r(!0);
  });
}
const H_ = (t) => !((n) => /Chrome/i.test(n))(t) && /Safari/i.test(t), xf = (t) => ((n) => /iPhone|iPad|iPod/i.test(n))(t) && (((n) => /WebKit/i.test(n))(t) || H_(t));
function jr(t) {
  const n = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && n === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || n === "[object Number]" || typeof t == "string" || n === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
const sa = { IMAGE: ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/svg+xml", "image/webp"], VIDEO: ["video/mpeg", "video/ogg", "video/webm", "video/mp4"], AUDIO: ["audio/aac", "audio/midi", "audio/x-midi", "audio/mpeg", "audio/ogg", "audio/opus", "audio/wav", "audio/webm", "audio/3gpp", "audio/3gpp2", "audio/mp3"], DOCUMENT: ["text/plain", "text/css", "text/csv", "text/html", "text/calendar", "text/javascript", "text/xml", "video/quicktime"], APPLICATION: ["application/x-abiword", "application/x-freearc", "application/vnd.amazon.ebook", "application/octet-stream", "application/x-bzip", "application/x-bzip2", "application/x-cdf", "application/x-csh", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.ms-fontobject", "application/epub+zip", "application/gzip", "application/java-archive", "application/json", "application/ld+json", "application/vnd.apple.installer+xml", "application/vnd.oasis.opendocument.presentation", "application/vnd.oasis.opendocument.spreadsheet", "application/vnd.oasis.opendocument.text", "application/ogg", "application/pdf", "application/x-httpd-php", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.rar", "application/rtf", "application/x-sh", "application/x-tar", "application/vnd.visio", "application/xhtml+xml", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/xml", "application/vnd.mozilla.xul+xml", "application/zip", "application/x-7z-compressed"] }, Gw = (t) => Array.isArray(t) && t.length > 0 ? t.reduce((n, e) => {
  switch (e) {
    case "image":
      n.push(...sa.IMAGE);
      break;
    case "video":
      n.push(...sa.VIDEO);
      break;
    case "audio":
      n.push(...sa.AUDIO);
      break;
    default:
      n.push(e);
  }
  return n;
}, []).join() : Object.values(sa).reduce((n, e) => n.concat(e), []).join(), kf = (t) => t === "" || t === null, Ic = (t) => sa.IMAGE.indexOf(t) >= 0, rh = (t) => sa.VIDEO.indexOf(t) >= 0 || ((n) => H_(navigator.userAgent) && /* @__PURE__ */ ((e) => e === "video/quicktime")(n))(t), Sd = (t) => Ic(t) || rh(t), ih = (t) => !!t && (t.isFileMessage && typeof t.isFileMessage == "function" ? t.isFileMessage() : (t == null ? void 0 : t.messageType) === "file"), B_ = (t) => !(!t || !ih(t)) && Sd(t.type), qw = (t) => !(!t || !ih(t)) && B_(t) && Ic(t.type), z_ = (t) => !(!t || !ih(t)) && B_(t) && rh(t.type), Tu = "3.14.10", { INIT_SDK: Kw, SET_SDK_LOADING: Ww, RESET_SDK: Qw, SDK_ERROR: Of } = Ps, { INIT_USER: Yw, UPDATE_USER_INFO: $w, RESET_USER: Zw } = bo;
async function Xw({ logger: t, sdkDispatcher: n, userDispatcher: e, initDashboardConfigs: r, userId: i, appId: s, isNewApp: a, customApiHost: o, customWebSocketHost: l, configureSession: c, nickname: u, profileUrl: d, accessToken: h, isUserIdUsedForNickname: p, sdkInitParams: f, customExtensionParams: m, isMobile: v = !1, eventHandlers: E, initializeMessageTemplatesInfo: y }) {
  var b, T;
  if ((b = t.info) == null || b.call(t, "SendbirdProvider | useConnect/setupConnection/init", { userId: i, appId: s }), n({ type: Ww, payload: !0 }), !i || !s) {
    const w = function({ userId: N, appId: M }) {
      return `SendbirdProvider | useConnect/setupConnection/Connection failed UserId: ${N} or appId: ${M} missing`;
    }({ userId: i, appId: s });
    return (T = t.error) == null || T.call(t, w), n({ type: Of }), Promise.reject(w);
  }
  return new Promise((w, N) => {
    var L;
    (L = t.info) == null || L.call(t, `SendbirdProvider | useConnect/setupConnection/connect connecting using ${h ?? i}`);
    const M = function({ appId: j, isNewApp: P = !1, customApiHost: q, customWebSocketHost: G, sdkInitParams: X = {} }) {
      const Ce = Object.assign(X, { appId: j, modules: [new pw()], newInstance: P, localCacheEnabled: X.localCacheEnabled ?? !0 });
      return q && (Ce.customApiHost = q), G && (Ce.customWebSocketHost = G), w2.init(Ce);
    }({ appId: s, customApiHost: o, customWebSocketHost: l, isNewApp: a, sdkInitParams: f }), I = typeof c == "function" ? c(M) : void 0;
    (function(j, P) {
      var Be, se;
      const { logger: q, sessionHandler: G, isMobile: X, customExtensionParams: Ce } = P;
      (Be = q.info) == null || Be.call(q, "SendbirdProvider | useConnect/setupConnection/setVersion", { version: Tu }), j.addExtension("sb_uikit", Tu), j.addSendbirdExtensions([{ product: Zu.UIKIT_CHAT, version: Tu, platform: Fs == null ? void 0 : Fs.JS }], { platform: X ? Ji.MOBILE_WEB : Ji.WEB }, Ce), G && ((se = q.info) == null || se.call(q, "SendbirdProvider | useConnect/setupConnection/configureSession", G), j.setSessionHandler(G));
    })(M, { logger: t, sessionHandler: I, customExtensionParams: m, isMobile: v }), M.connect(i, h).then((j) => x(j)).catch(async (j) => {
      var P;
      if (function(q) {
        return q instanceof D && [me.SESSION_TOKEN_EXPIRED, me.INVALID_TOKEN].includes(q.code);
      }(j) && I)
        try {
          const q = await new Promise(I.onSessionTokenRequired);
          if (q) {
            (P = t.info) == null || P.call(t, "SendbirdProvider | useConnect/setupConnection/connect retry connect with valid session token: " + (q.slice(0, 10) + "..."));
            const G = await M.connect(i, q);
            return x(G);
          }
        } catch (q) {
          if (q instanceof D)
            return R(q);
        }
      return R(j);
    });
    const x = async (j) => {
      var P, q, G, X, Ce, Be, se, Ee;
      (P = t.info) == null || P.call(t, "SendbirdProvider | useConnect/setupConnection/onConnected", j), n({ type: Kw, payload: M }), e({ type: Yw, payload: j });
      try {
        await y(M);
      } catch (ee) {
        (q = t.error) == null || q.call(t, "SendbirdProvider | useConnect/setupConnection/upsertMessageTemplateListInLocalStorage failed", { error: ee });
      }
      try {
        await r(M), (G = t.info) == null || G.call(t, "SendbirdProvider | useConnect/setupConnection/getUIKitConfiguration success");
      } catch (ee) {
        (X = t.error) == null || X.call(t, "SendbirdProvider | useConnect/setupConnection/getUIKitConfiguration failed", { error: ee });
      }
      try {
        if (!(u === j.nickname && d === j.profileUrl || kf(u) && kf(d))) {
          (Ce = t.info) == null || Ce.call(t, "SendbirdProvider | useConnect/setupConnection/updateCurrentUserInfo", { nickname: u, profileUrl: d });
          const ee = { nickname: u || j.nickname || (p ? j.userId : ""), profileUrl: d || j.profileUrl }, ge = await M.updateCurrentUserInfo(ee);
          (Be = t.info) == null || Be.call(t, "SendbirdProvider | useConnect/setupConnection/updateCurrentUserInfo success", ee), e({ type: $w, payload: ge });
        }
      } catch {
      }
      w(), (Ee = (se = E == null ? void 0 : E.connection) == null ? void 0 : se.onConnected) == null || Ee.call(se, j);
    }, R = async (j) => {
      var G, X, Ce, Be;
      var P;
      M.isCacheEnabled && (P = j) instanceof D && [me.USER_AUTH_DEACTIVATED, me.USER_AUTH_DELETED_OR_NOT_FOUND, me.SESSION_TOKEN_EXPIRED, me.SESSION_REVOKED].includes(P.code) && ((G = t.error) == null || G.call(t, `SendbirdProvider | useConnect/setupConnection/connect clear cache [${j.code}/${j.message}]`), await M.clearCachedData());
      const q = function(se) {
        return `SendbirdProvider | useConnect/setupConnection/Connection failed. ${(se == null ? void 0 : se.code) || ""} ${(se == null ? void 0 : se.message) || ""}`;
      }(j);
      (X = t.error) == null || X.call(t, q, { e: j, appId: s, userId: i }), e({ type: Zw }), n({ type: Qw }), n({ type: Of }), N(q), (Be = (Ce = E == null ? void 0 : E.connection) == null ? void 0 : Ce.onFailed) == null || Be.call(Ce, j);
    };
  });
}
async function Rf({ logger: t, sdkDispatcher: n, userDispatcher: e, appInfoDispatcher: r, initDashboardConfigs: i, userId: s, appId: a, isNewApp: o = !1, customApiHost: l, customWebSocketHost: c, configureSession: u, nickname: d, profileUrl: h, accessToken: p, sdk: f, sdkInitParams: m, customExtensionParams: v, isMobile: E, eventHandlers: y, isUserIdUsedForNickname: b, initializeMessageTemplatesInfo: T }) {
  await j_({ logger: t, sdkDispatcher: n, userDispatcher: e, sdk: f }), await Xw({ logger: t, sdkDispatcher: n, userDispatcher: e, appInfoDispatcher: r, initDashboardConfigs: i, userId: s, appId: a, isNewApp: o, customApiHost: l, customWebSocketHost: c, configureSession: u, nickname: d, profileUrl: h, accessToken: p, sdkInitParams: m, customExtensionParams: v, isMobile: E, eventHandlers: y, isUserIdUsedForNickname: b, initializeMessageTemplatesInfo: T });
}
const Ur = () => {
};
function Li(...t) {
  return t.filter(Boolean).join(" ");
}
const Jw = "debug", Rl = "warning", Dl = "error", wu = "info", e3 = "all", t3 = ({ level: t, title: n, description: e = "", payload: r = [] }) => {
  console.log(`%c SendbirdUIKit | ${t} | ${(/* @__PURE__ */ new Date()).toISOString()} | ${n} ${e && "|"}`, ((i) => {
    switch (i) {
      case Rl:
        return "color: Orange";
      case Dl:
        return "color: Red";
      default:
        return "color: Gray";
    }
  })(t), e, ...r);
}, Df = (t, n) => {
  const e = t3, r = Array.isArray(t) ? t : [t], i = (s) => (a, o, ...l) => e({ level: s, title: a, description: o, payload: l });
  return r.reduce((s, a) => a === Jw || a === e3 ? { ...s, info: i(wu), error: i(Dl), warning: i(Rl) } : a === wu ? { ...s, info: i(wu) } : a === Dl ? { ...s, error: i(Dl) } : a === Rl ? { ...s, warning: i(Rl) } : { ...s }, { info: Ur, error: Ur, warning: Ur });
}, V_ = (t) => {
  const n = {};
  return { __getTopics: () => n, subscribe: (e, r) => (n[e] ?? (n[e] = /* @__PURE__ */ new Set()), n[e].add(r), { remove: () => {
    n[e].delete(r);
  } }), publish: (e, r) => {
    n[e] && n[e].forEach((i) => {
      t != null && t.publishSynchronous ? i(r !== void 0 ? r : {}) : setTimeout(() => i(r !== void 0 ? r : {}), 0);
    });
  } };
}, n3 = { en: { MESSAGE_STATUS__YESTERDAY: "Yesterday", CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: "new message(s) since", CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: "on", CHANNEL_PREVIEW_MOBILE_LEAVE: "Leave channel", CHANNEL_SETTING__HEADER__TITLE: "Channel information", CHANNEL_SETTING__PROFILE__EDIT: "Edit", CHANNEL_SETTING__MEMBERS__TITLE: "Members", CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: "All members", CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: "Invite users", CHANNEL_SETTING__MEMBERS__YOU: " (You)", CHANNEL_SETTING__MEMBERS__SELECT_TITLE: "Select members", CHANNEL_SETTING__MEMBERS__OPERATOR: "Operator", CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: "Leave channel", CHANNEL_SETTING__OPERATORS__TITLE: "Operators", CHANNEL_SETTING__OPERATORS__TITLE_ALL: "All operators", CHANNEL_SETTING__OPERATORS__TITLE_ADD: "Add operator", CHANNEL_SETTING__OPERATORS__ADD_BUTTON: "Add", CHANNEL_SETTING__MUTED_MEMBERS__TITLE: "Muted members", CHANNEL_SETTING__MUTED_MEMBERS__TITLE_ALL: "All muted members", CHANNEL_SETTING__NO_UNMUTED: "No muted members yet", CHANNEL_SETTING__BANNED_MEMBERS__TITLE: "Banned users", CHANNEL_SETTING__FREEZE_CHANNEL: "Freeze Channel", CHANNEL_SETTING__MODERATION__REGISTER_AS_OPERATOR: "Register as operator", CHANNEL_SETTING__MODERATION__UNREGISTER_OPERATOR: "Unregister operator", CHANNEL_SETTING__MODERATION__MUTE: "Mute", CHANNEL_SETTING__MODERATION__UNMUTE: "Unmute", CHANNEL_SETTING__MODERATION__BAN: "Ban", CHANNEL_SETTING__MODERATION__UNBAN: "Unban", CHANNEL_SETTING__MODERATION__EMPTY_BAN: "No banned members yet", CHANNEL_SETTING__MODERATION__ALL_BAN: "All banned members", OPEN_CHANNEL_CONVERSATION__TITLE_PARTICIPANTS: "participants", OPEN_CHANNEL_CONVERSATION__SELECT_PARTICIPANTS: "Select participants", OPEN_CHANNEL_LIST__TITLE: "Channels", CREATE_OPEN_CHANNEL_LIST__TITLE: "New channel profile", CREATE_OPEN_CHANNEL_LIST__SUBTITLE__IMG_SECTION: "Channel image", CREATE_OPEN_CHANNEL_LIST__SUBTITLE__IMG_UPLOAD: "Upload", CREATE_OPEN_CHANNEL_LIST__SUBTITLE__TEXT_SECTION: "Channel name", CREATE_OPEN_CHANNEL_LIST__SUBTITLE__TEXT_PLACE_HOLDER: "Enter channel name", CREATE_OPEN_CHANNEL_LIST__SUBMIT: "Create", OPEN_CHANNEL_SETTINGS__OPERATOR_TITLE: "Channel Information", OPEN_CHANNEL_SETTINGS__OPERATOR_URL: "URL", OPEN_CHANNEL_SETTINGS__PARTICIPANTS_ACCORDION_TITLE: "Participants", OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_PANEL: "Delete channel", OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_TITLE: "Delete channel?", OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_CONTEXT: "Once deleted, this channel can't be restored.", OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_SUBMIT: "Delete", OPEN_CHANNEL_SETTINGS__OPERATORS_TITLE: "Operators", OPEN_CHANNEL_SETTINGS__OPERATORS__TITLE_ADD: "Add operator", OPEN_CHANNEL_SETTINGS__OPERATORS__TITLE_ALL: "All operators", OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__TITLE: "Muted participants", OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__TITLE_ALL: "All muted participants", OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__NO_ONE: "No muted participants yet", OPEN_CHANNEL_SETTINGS__BANNED_MEMBERS__TITLE: "Banned users", OPEN_CHANNEL_SETTINGS__BANNED_MEMBERS__TITLE_ALL: "All banned users", OPEN_CHANNEL_SETTINGS__BANNED_MEMBERS__NO_ONE: "No banned users yet", OPEN_CHANNEL_SETTINGS__MEMBERS__YOU: " (You)", OPEN_CHANNEL_SETTINGS__MEMBERS__OPERATOR: "Operator", OPEN_CHANNEL_SETTINGS__PARTICIPANTS_TITLE: "Participants", OPEN_CHANNEL_SETTINGS__EMPTY_LIST: "No participants yet", OPEN_CHANNEL_SETTINGS__SEE_ALL: "See all participants", OPEN_CHANNEL_SETTINGS__ALL_PARTICIPANTS_TITLE: "All participants", OPEN_CHANNEL_SETTINGS__NO_TITLE: "(No title)", OPEN_CHANNEL_SETTING__MODERATION__REGISTER_AS_OPERATOR: "Register as operator", OPEN_CHANNEL_SETTING__MODERATION__UNREGISTER_OPERATOR: "Unregister operator", OPEN_CHANNEL_SETTING__MODERATION__MUTE: "Mute", OPEN_CHANNEL_SETTING__MODERATION__UNMUTE: "Unmute", OPEN_CHANNEL_SETTING__MODERATION__BAN: "Ban", OPEN_CHANNEL_SETTING__MODERATION__UNBAN: "Unban", TRYING_TO_CONNECT: "Trying to connect…", TYPING_INDICATOR__IS_TYPING: "is typing...", TYPING_INDICATOR__AND: "and", TYPING_INDICATOR__ARE_TYPING: "are typing...", TYPING_INDICATOR__MULTIPLE_TYPING: "Several people are typing...", CHANNEL_FROZEN: "Channel frozen", PLACE_HOLDER__NO_CHANNEL: "No channels", PLACE_HOLDER__WRONG: "Something went wrong", PLACE_HOLDER__RETRY_TO_CONNECT: "Retry", PLACE_HOLDER__NO_MESSAGES: "No messages", TOOLTIP__AND_YOU: ", and you", TOOLTIP__YOU: "you", TOOLTIP__UNKNOWN_USER: "(no name)", UNKNOWN__UNKNOWN_MESSAGE_TYPE: "(Unknown message type)", UNKNOWN__CANNOT_READ_MESSAGE: "Cannot read this message.", UNKNOWN__TEMPLATE_ERROR: "(Template error)", UNKNOWN__CANNOT_READ_TEMPLATE: "Cannot read this template.", MESSAGE_EDITED: "(edited)", MODAL__DELETE_MESSAGE__TITLE: "Delete this message?", MODAL__CHANNEL_INFORMATION__TITLE: "Edit channel information", MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: "Channel image", MODAL__CHANNEL_INFORMATION__UPLOAD: "Upload", MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: "Channel name", MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: "Enter name", MODAL__INVITE_MEMBER__TITLE: "Invite member", MODAL__INVITE_MEMBER__SELECTED: "selected", MODAL__CHOOSE_CHANNEL_TYPE__TITLE: "New channel", MODAL__CHOOSE_CHANNEL_TYPE__GROUP: "Group", MODAL__CHOOSE_CHANNEL_TYPE__SUPER_GROUP: "Super group", MODAL__CHOOSE_CHANNEL_TYPE__BROADCAST: "Broadcast", MODAL__CREATE_CHANNEL__TITLE: "New channel", MODAL__CREATE_CHANNEL__GROUP: "Group", MODAL__CREATE_CHANNEL__SUPER: "Super group", MODAL__CREATE_CHANNEL__BROADCAST: "Broadcast", MODAL__CREATE_CHANNEL__SELECTED: "selected", MODAL__LEAVE_CHANNEL__TITLE: "Leave this channel?", MODAL__LEAVE_CHANNEL__FOOTER: "Leave", MODAL__VOICE_MESSAGE_INPUT_DISABLED__TITLE_MUTED: "You're muted by the operator.", MODAL__VOICE_MESSAGE_INPUT_DISABLED__TITLE_FROZEN: "Channel is frozen.", USER_PROFILE__MESSAGE: "Message", USER_PROFILE__USER_ID: "User ID", EDIT_PROFILE__TITLE: "My profile", EDIT_PROFILE__IMAGE_LABEL: "Profile image", EDIT_PROFILE__IMAGE_UPLOAD: "Upload", EDIT_PROFILE__NICKNAME_LABEL: "Nickname", EDIT_PROFILE__NICKNAME_PLACEHOLDER: "Enter your nickname", EDIT_PROFILE__USERID_LABEL: "User ID", EDIT_PROFILE__THEME_LABEL: "Dark theme", MESSAGE_INPUT__PLACE_HOLDER: "Enter message", MESSAGE_INPUT__PLACE_HOLDER__DISABLED: "Chat is unavailable in this channel", MESSAGE_INPUT__PLACE_HOLDER__DISABLED_FOR_OFFLINE: "Check your network to send messages", MESSAGE_INPUT__PLACE_HOLDER__SUGGESTED_REPLIES: "Please choose one from above", MESSAGE_INPUT__PLACE_HOLDER__MESSAGE_FORM: "Please fill out the message form.", MESSAGE_INPUT__PLACE_HOLDER__FROZEN: "Chat is unavailable in this channel", MESSAGE_INPUT__PLACE_HOLDER__MUTED: "Chat is unavailable because you're muted", MESSAGE_INPUT__PLACE_HOLDER__MUTED_SHORT: "You're muted", MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: "Reply to message", BUTTON__SUBMIT: "Submit", BUTTON__CANCEL: "Cancel", BUTTON__DELETE: "Delete", BUTTON__SAVE: "Save", BUTTON__CREATE: "Create", BUTTON__INVITE: "Invite", BUTTON__OK: "OK", BADGE__OVER: "+", NO_TITLE: "No title", NO_NAME: "(No name)", NO_MEMBERS: "(No members)", LABEL__OPERATOR: "Operator", MESSAGE_MENU__COPY: "Copy", MESSAGE_MENU__REPLY: "Reply", MESSAGE_MENU__THREAD: "Reply in thread", MESSAGE_MENU__OPEN_IN_CHANNEL: "Open in channel", MESSAGE_MENU__EDIT: "Edit", MESSAGE_MENU__RESEND: "Resend", MESSAGE_MENU__DELETE: "Delete", MESSAGE_MENU__SAVE: "Save", CONTEXT_MENU_DROPDOWN__COPY: "Copy", CONTEXT_MENU_DROPDOWN__EDIT: "Edit", CONTEXT_MENU_DROPDOWN__RESEND: "Resend", CONTEXT_MENU_DROPDOWN__DELETE: "Delete", CONTEXT_MENU_DROPDOWN__SAVE: "Save", SEARCH: "Search", SEARCH_IN_CHANNEL: "Search in channel", SEARCH_IN: "Search in", SEARCHING: "Searching for messages...", NO_SEARCHED_MESSAGE: "No results found.", QUOTE_MESSAGE_INPUT__REPLY_TO: "Reply to", QUOTE_MESSAGE_INPUT__FILE_TYPE_IMAGE: "Photo", QUOTE_MESSAGE_INPUT__FILE_TYPE_GIF: "GIF", QUOTE_MESSAGE_INPUT__FILE_TYPE__VIDEO: "Video", QUOTED_MESSAGE__REPLIED_TO: "replied to", QUOTED_MESSAGE__CURRENT_USER: "You", QUOTED_MESSAGE__UNAVAILABLE: "Message unavailable", THREAD__HEADER_TITLE: "Thread", CHANNEL__THREAD_REPLY: "reply", CHANNEL__THREAD_REPLIES: "replies", CHANNEL__THREAD_OVER_MAX: "99+", THREAD__THREAD_REPLY: "reply", THREAD__THREAD_REPLIES: "replies", THREAD__INPUT__REPLY_TO_THREAD: "Reply to thread", THREAD__INPUT__REPLY_IN_THREAD: "Reply in thread", MENTION_NAME__NO_NAME: "(No name)", MENTION_COUNT__OVER_LIMIT: "You can mention up to %d times at a time.", UI__FILE_VIEWER__UNSUPPORT: "Unsupported message", VOICE_RECORDING_PERMISSION_DENIED: `You cannot record the voice since
        voice recording is not permitted in your device system setting`, VOICE_MESSAGE: "Voice Message", CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_GIF: "GIF", CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_PHOTO: "Photo", CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_VIDEO: "Video", CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_AUDIO: "Audio", CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_VOICE_MESSAGE: "Voice message", CHANNEL_PREVIEW_LAST_MESSAGE_FILE_TYPE_GENERAL: "File", CHANNEL_PREVIEW_LAST_MESSAGE_TEMPLATE_MESSAGE: "Message", DATE_FORMAT__MESSAGE_LIST__NOTIFICATION__UNREAD_SINCE: "p 'on' MMM dd", DATE_FORMAT__MESSAGE_LIST__DATE_SEPARATOR: "MMMM dd, yyyy", DATE_FORMAT__THREAD_LIST__DATE_SEPARATOR: "MMM dd, yyyy", DATE_FORMAT__MESSAGE_TIMESTAMP: "p", FILE_UPLOAD_NOTIFICATION__COUNT_LIMIT: "Up to %d files can be attached.", FILE_UPLOAD_NOTIFICATION__SIZE_LIMIT: "The maximum size per file is %d MB.", FEEDBACK_LIKE: "Like", FEEDBACK_DISLIKE: "Dislike", EDIT_COMMENT: "Edit comment", REMOVE_FEEDBACK: "Remove Feedback", FEEDBACK_MODAL_TITLE: "Provide additional feedback (optional)", FEEDBACK_CONTENT_PLACEHOLDER: "Leave a comment", BUTTON__REMOVE_FEEDBACK: "Remove feedback", FEEDBACK_FAILED_SUBMIT: "Couldn’t submit. Try again.", FEEDBACK_FAILED_SAVE: "Couldn’t save. Try again.", FEEDBACK_FAILED_DELETE: "Couldn’t delete. Try again.", FORM_ITEM_REQUIRED: "This field is required", FORM_ITEM_INVALID: "Please check the value" } }, sh = (t = "en") => n3[t], r3 = { lessThanXSeconds: { one: "less than a second", other: "less than {{count}} seconds" }, xSeconds: { one: "1 second", other: "{{count}} seconds" }, halfAMinute: "half a minute", lessThanXMinutes: { one: "less than a minute", other: "less than {{count}} minutes" }, xMinutes: { one: "1 minute", other: "{{count}} minutes" }, aboutXHours: { one: "about 1 hour", other: "about {{count}} hours" }, xHours: { one: "1 hour", other: "{{count}} hours" }, xDays: { one: "1 day", other: "{{count}} days" }, aboutXWeeks: { one: "about 1 week", other: "about {{count}} weeks" }, xWeeks: { one: "1 week", other: "{{count}} weeks" }, aboutXMonths: { one: "about 1 month", other: "about {{count}} months" }, xMonths: { one: "1 month", other: "{{count}} months" }, aboutXYears: { one: "about 1 year", other: "about {{count}} years" }, xYears: { one: "1 year", other: "{{count}} years" }, overXYears: { one: "over 1 year", other: "over {{count}} years" }, almostXYears: { one: "almost 1 year", other: "almost {{count}} years" } };
function Su(t) {
  return (n = {}) => {
    const e = n.width ? String(n.width) : t.defaultWidth;
    return t.formats[e] || t.formats[t.defaultWidth];
  };
}
const i3 = { date: Su({ formats: { full: "EEEE, MMMM do, y", long: "MMMM do, y", medium: "MMM d, y", short: "MM/dd/yyyy" }, defaultWidth: "full" }), time: Su({ formats: { full: "h:mm:ss a zzzz", long: "h:mm:ss a z", medium: "h:mm:ss a", short: "h:mm a" }, defaultWidth: "full" }), dateTime: Su({ formats: { full: "{{date}} 'at' {{time}}", long: "{{date}} 'at' {{time}}", medium: "{{date}}, {{time}}", short: "{{date}}, {{time}}" }, defaultWidth: "full" }) }, s3 = { lastWeek: "'last' eeee 'at' p", yesterday: "'yesterday at' p", today: "'today at' p", tomorrow: "'tomorrow at' p", nextWeek: "eeee 'at' p", other: "P" };
function Da(t) {
  return (n, e) => {
    let r;
    if ((e != null && e.context ? String(e.context) : "standalone") === "formatting" && t.formattingValues) {
      const i = t.defaultFormattingWidth || t.defaultWidth, s = e != null && e.width ? String(e.width) : i;
      r = t.formattingValues[s] || t.formattingValues[i];
    } else {
      const i = t.defaultWidth, s = e != null && e.width ? String(e.width) : t.defaultWidth;
      r = t.values[s] || t.values[i];
    }
    return r[t.argumentCallback ? t.argumentCallback(n) : n];
  };
}
function La(t) {
  return (n, e = {}) => {
    const r = e.width, i = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], s = n.match(i);
    if (!s)
      return null;
    const a = s[0], o = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(o) ? function(u, d) {
      for (let h = 0; h < u.length; h++)
        if (d(u[h]))
          return h;
    }(o, (u) => u.test(a)) : function(u, d) {
      for (const h in u)
        if (Object.prototype.hasOwnProperty.call(u, h) && d(u[h]))
          return h;
    }(o, (u) => u.test(a));
    let c;
    return c = t.valueCallback ? t.valueCallback(l) : l, c = e.valueCallback ? e.valueCallback(c) : c, { value: c, rest: n.slice(a.length) };
  };
}
var Ua;
const Ac = { code: "en-US", formatDistance: (t, n, e) => {
  let r;
  const i = r3[t];
  return r = typeof i == "string" ? i : n === 1 ? i.one : i.other.replace("{{count}}", n.toString()), e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? "in " + r : r + " ago" : r;
}, formatLong: i3, formatRelative: (t, n, e, r) => s3[t], localize: { ordinalNumber: (t, n) => {
  const e = Number(t), r = e % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return e + "st";
      case 2:
        return e + "nd";
      case 3:
        return e + "rd";
    }
  return e + "th";
}, era: Da({ values: { narrow: ["B", "A"], abbreviated: ["BC", "AD"], wide: ["Before Christ", "Anno Domini"] }, defaultWidth: "wide" }), quarter: Da({ values: { narrow: ["1", "2", "3", "4"], abbreviated: ["Q1", "Q2", "Q3", "Q4"], wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"] }, defaultWidth: "wide", argumentCallback: (t) => t - 1 }), month: Da({ values: { narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"], abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"] }, defaultWidth: "wide" }), day: Da({ values: { narrow: ["S", "M", "T", "W", "T", "F", "S"], short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"] }, defaultWidth: "wide" }), dayPeriod: Da({ values: { narrow: { am: "a", pm: "p", midnight: "mi", noon: "n", morning: "morning", afternoon: "afternoon", evening: "evening", night: "night" }, abbreviated: { am: "AM", pm: "PM", midnight: "midnight", noon: "noon", morning: "morning", afternoon: "afternoon", evening: "evening", night: "night" }, wide: { am: "a.m.", pm: "p.m.", midnight: "midnight", noon: "noon", morning: "morning", afternoon: "afternoon", evening: "evening", night: "night" } }, defaultWidth: "wide", formattingValues: { narrow: { am: "a", pm: "p", midnight: "mi", noon: "n", morning: "in the morning", afternoon: "in the afternoon", evening: "in the evening", night: "at night" }, abbreviated: { am: "AM", pm: "PM", midnight: "midnight", noon: "noon", morning: "in the morning", afternoon: "in the afternoon", evening: "in the evening", night: "at night" }, wide: { am: "a.m.", pm: "p.m.", midnight: "midnight", noon: "noon", morning: "in the morning", afternoon: "in the afternoon", evening: "in the evening", night: "at night" } }, defaultFormattingWidth: "wide" }) }, match: { ordinalNumber: (Ua = { matchPattern: /^(\d+)(th|st|nd|rd)?/i, parsePattern: /\d+/i, valueCallback: (t) => parseInt(t, 10) }, (t, n = {}) => {
  const e = t.match(Ua.matchPattern);
  if (!e)
    return null;
  const r = e[0], i = t.match(Ua.parsePattern);
  if (!i)
    return null;
  let s = Ua.valueCallback ? Ua.valueCallback(i[0]) : i[0];
  return s = n.valueCallback ? n.valueCallback(s) : s, { value: s, rest: t.slice(r.length) };
}), era: La({ matchPatterns: { narrow: /^(b|a)/i, abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i, wide: /^(before christ|before common era|anno domini|common era)/i }, defaultMatchWidth: "wide", parsePatterns: { any: [/^b/i, /^(a|c)/i] }, defaultParseWidth: "any" }), quarter: La({ matchPatterns: { narrow: /^[1234]/i, abbreviated: /^q[1234]/i, wide: /^[1234](th|st|nd|rd)? quarter/i }, defaultMatchWidth: "wide", parsePatterns: { any: [/1/i, /2/i, /3/i, /4/i] }, defaultParseWidth: "any", valueCallback: (t) => t + 1 }), month: La({ matchPatterns: { narrow: /^[jfmasond]/i, abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i, wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i }, defaultMatchWidth: "wide", parsePatterns: { narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i], any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i] }, defaultParseWidth: "any" }), day: La({ matchPatterns: { narrow: /^[smtwf]/i, short: /^(su|mo|tu|we|th|fr|sa)/i, abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i, wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i }, defaultMatchWidth: "wide", parsePatterns: { narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i], any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i] }, defaultParseWidth: "any" }), dayPeriod: La({ matchPatterns: { narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i, any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i }, defaultMatchWidth: "any", parsePatterns: { any: { am: /^a/i, pm: /^p/i, midnight: /^mi/i, noon: /^no/i, morning: /morning/i, afternoon: /afternoon/i, evening: /evening/i, night: /night/i } }, defaultParseWidth: "any" }) }, options: { weekStartsOn: 0, firstWeekContainsDate: 1 } }, G_ = { stringSet: sh("en"), dateLocale: Ac }, Ta = Ot.createContext(G_), a3 = (t) => {
  const { children: n } = t;
  return C.jsx(Ta.Provider, { value: { ...G_, ...t }, children: n });
}, jo = () => Ot.useContext(Ta), q_ = "sendbird--mobile-mode", K_ = Ot.createContext({ breakpoint: !1, isMobile: !1 }), Lf = () => {
  try {
    const t = document.querySelector("body");
    t == null || t.classList.add(q_);
  } catch {
  }
}, Uf = () => {
  try {
    const t = document.querySelector("body");
    t == null || t.classList.remove(q_);
  } catch {
  }
}, o3 = (t) => {
  const { children: n, logger: e } = t, r = (t == null ? void 0 : t.breakpoint) || !1, [i, s] = Ye(!1);
  return Tt(() => {
    var o;
    const a = () => {
      var l;
      if (typeof r == "boolean")
        s(r), r ? Lf() : Uf();
      else {
        const c = window.matchMedia(`(max-width: ${r})`);
        (l = e == null ? void 0 : e.info) == null || l.call(e, `MediaQueryProvider: Screensize updated to ${r}`), c.matches ? (s(!0), Lf()) : (s(!1), Uf());
      }
    };
    return a(), window.addEventListener("resize", a), (o = e == null ? void 0 : e.info) == null || o.call(e, "MediaQueryProvider: addEventListener", { updateSize: a }), () => {
      var l;
      window.removeEventListener("resize", a), (l = e == null ? void 0 : e.info) == null || l.call(e, "MediaQueryProvider: removeEventListener", { updateSize: a });
    };
  }, [r]), C.jsx(K_.Provider, { value: { breakpoint: r, isMobile: i }, children: n });
}, Mc = () => Ot.useContext(K_), Nu = "sendbird_message_templates_token_key", na = "sendbird_message_templates_key";
function W_(t) {
  return { lowerCase: t.toLowerCase(), upperCase: t.toUpperCase() };
}
const l3 = 2e3;
function Pf({ logger: t, timeout: n, cb: e }) {
  let r = [], i = null;
  return { push: (s) => {
    if (r.find((l) => l.url === s.url) ? t.info("Channel: Mark as read already in queue", { channel: s }) : r.push(s), i)
      return;
    const o = r.shift();
    o && e(o), i = setInterval(() => {
      if (r.length === 0 && i)
        return clearInterval(i), void (i = null);
      const l = r.shift();
      l && e(l);
    }, n || l3);
  }, clear: () => {
    r = [], i && (clearInterval(i), i = null);
  }, getQueue: () => r };
}
function Iu(t, n = []) {
  hr(() => () => {
    t();
  }, n);
}
const ya = "sendbird-modal-root", c3 = () => C.jsx("div", { id: ya, className: ya }), ah = Ot.forwardRef((t, n) => {
  const { className: e = "", children: r, disabled: i = !1, width: s = "56px", height: a = "56px", type: o = "button", style: l = {}, onBlur: c = () => {
  }, onClick: u = () => {
  }, testID: d } = t, [h, p] = Ye(!1);
  return C.jsx("button", { "data-testid": d, className: [...Array.isArray(e) ? e : [e], "sendbird-iconbutton", h ? "sendbird-iconbutton--pressed" : ""].join(" "), disabled: i, ref: n, type: o, style: { ...l, height: a, width: s }, onClick: (f) => {
    i || (p(!0), u == null || u(f));
  }, onBlur: (f) => {
    p(!1), c == null || c(f);
  }, children: C.jsx("span", { className: "sendbird-iconbutton__inner", children: r }) });
}), mr = { H_1: "H_1", H_2: "H_2", SUBTITLE_1: "SUBTITLE_1", SUBTITLE_2: "SUBTITLE_2", BODY_1: "BODY_1", BODY_2: "BODY_2", BUTTON_1: "BUTTON_1", BUTTON_2: "BUTTON_2", BUTTON_3: "BUTTON_3", CAPTION_1: "CAPTION_1", CAPTION_2: "CAPTION_2", CAPTION_3: "CAPTION_3" }, xr = { ONBACKGROUND_1: "ONBACKGROUND_1", ONBACKGROUND_2: "ONBACKGROUND_2", ONBACKGROUND_3: "ONBACKGROUND_3", ONBACKGROUND_4: "ONBACKGROUND_4", ONCONTENT_1: "ONCONTENT_1", ONCONTENT_2: "ONCONTENT_2", ONCONTENT_INVERSE_1: "ONCONTENT_INVERSE_1", ONCONTENT_INVERSE_3: "ONCONTENT_INVERSE_3", PRIMARY: "PRIMARY", ERROR: "ERROR", SECONDARY_3: "SECONDARY_3" };
function u3(t) {
  switch (t) {
    case mr.H_1:
      return "sendbird-label--h-1";
    case mr.H_2:
      return "sendbird-label--h-2";
    case mr.SUBTITLE_1:
      return "sendbird-label--subtitle-1";
    case mr.SUBTITLE_2:
      return "sendbird-label--subtitle-2";
    case mr.BODY_1:
      return "sendbird-label--body-1";
    case mr.BODY_2:
      return "sendbird-label--body-2";
    case mr.BUTTON_1:
      return "sendbird-label--button-1";
    case mr.BUTTON_2:
      return "sendbird-label--button-2";
    case mr.BUTTON_3:
      return "sendbird-label--button-3";
    case mr.CAPTION_1:
      return "sendbird-label--caption-1";
    case mr.CAPTION_2:
      return "sendbird-label--caption-2";
    case mr.CAPTION_3:
      return "sendbird-label--caption-3";
    default:
      return "";
  }
}
function d3(t) {
  switch (t) {
    case xr.ONBACKGROUND_1:
      return "sendbird-label--color-onbackground-1";
    case xr.ONBACKGROUND_2:
      return "sendbird-label--color-onbackground-2";
    case xr.ONBACKGROUND_3:
      return "sendbird-label--color-onbackground-3";
    case xr.ONBACKGROUND_4:
      return "sendbird-label--color-onbackground-4";
    case xr.ONCONTENT_1:
      return "sendbird-label--color-oncontent-1";
    case xr.ONCONTENT_2:
      return "sendbird-label--color-oncontent-2";
    case xr.ONCONTENT_INVERSE_1:
      return "sendbird-label--color-oncontent-inverse-1";
    case xr.ONCONTENT_INVERSE_3:
      return "sendbird-label--color-oncontent-inverse-3";
    case xr.PRIMARY:
      return "sendbird-label--color-primary";
    case xr.ERROR:
      return "sendbird-label--color-error";
    case xr.SECONDARY_3:
      return "sendbird-label--color-secondary-3";
    default:
      return "";
  }
}
const En = H0(({ className: t = [], type: n, color: e, children: r = null, testID: i, title: s }, a) => C.jsx("span", { title: s, className: [...Array.isArray(t) ? t : [t], "sendbird-label", u3(n), d3(e)].join(" "), ref: a, "data-testid": i, children: r })), Nn = mr, Cn = xr, Q_ = sh("en");
var Un = ((t) => (t.PRIMARY = "PRIMARY", t.SECONDARY = "SECONDARY", t.DANGER = "DANGER", t.DISABLED = "DISABLED", t.WARNING = "WARNING", t))(Un || {}), ba = ((t) => (t.BIG = "BIG", t.SMALL = "SMALL", t))(ba || {});
function h3(t) {
  switch (t) {
    case Un.PRIMARY:
      return "sendbird-button--primary";
    case Un.SECONDARY:
      return "sendbird-button--secondary";
    case Un.DANGER:
      return "sendbird-button--danger";
    case Un.DISABLED:
      return "sendbird-button--disabled";
    case Un.WARNING:
      return "sendbird-button--warning";
    default:
      return "";
  }
}
function p3(t) {
  switch (t) {
    case ba.BIG:
      return "sendbird-button--big";
    case ba.SMALL:
      return "sendbird-button--small";
    default:
      return "";
  }
}
function Ui({ className: t, type: n = Un.PRIMARY, size: e = ba.BIG, children: r = "Button", disabled: i = !1, onClick: s = () => {
}, labelType: a = Nn.BUTTON_1, labelColor: o = Cn.ONCONTENT_1 }) {
  const l = [...Array.isArray(t) ? t : [t], "sendbird-button", i ? "sendbird-button__disabled" : "", h3(n), p3(e)].join(" ");
  return C.jsx("button", { className: l, type: "button", onClick: s, disabled: i, children: C.jsx(En, { className: "sendbird-button__text", type: a, color: o, children: r }) });
}
const pe = { ADD: "ADD", ARROW_LEFT: "ARROW_LEFT", ATTACH: "ATTACH", AUDIO_ON_LINED: "AUDIO_ON_LINED", BAN: "BAN", BROADCAST: "BROADCAST", CAMERA: "CAMERA", CHANNELS: "CHANNELS", CHAT: "CHAT", CHAT_FILLED: "CHAT_FILLED", CHEVRON_DOWN: "CHEVRON_DOWN", CHEVRON_RIGHT: "CHEVRON_RIGHT", CLOSE: "CLOSE", COLLAPSE: "COLLAPSE", COPY: "COPY", CREATE: "CREATE", DELETE: "DELETE", DISCONNECTED: "DISCONNECTED", DOCUMENT: "DOCUMENT", DONE: "DONE", DONE_ALL: "DONE_ALL", DOWNLOAD: "DOWNLOAD", EDIT: "EDIT", EMOJI_MORE: "EMOJI_MORE", ERROR: "ERROR", EXPAND: "EXPAND", FILE_AUDIO: "FILE_AUDIO", FILE_DOCUMENT: "FILE_DOCUMENT", FREEZE: "FREEZE", GIF: "GIF", INFO: "INFO", LEAVE: "LEAVE", MEMBERS: "MEMBERS", MESSAGE: "MESSAGE", MODERATIONS: "MODERATIONS", MORE: "MORE", MUTE: "MUTE", NOTIFICATIONS: "NOTIFICATIONS", NOTIFICATIONS_OFF_FILLED: "NOTIFICATIONS_OFF_FILLED", OPERATOR: "OPERATOR", PHOTO: "PHOTO", PLAY: "PLAY", PLUS: "PLUS", QUESTION: "QUESTION", REFRESH: "REFRESH", REPLY: "REPLY", REMOVE: "REMOVE", SEARCH: "SEARCH", SEND: "SEND", SETTINGS_FILLED: "SETTINGS_FILLED", SLIDE_LEFT: "SLIDE_LEFT", SPINNER: "SPINNER", SUPERGROUP: "SUPERGROUP", THREAD: "THREAD", THUMBNAIL_NONE: "THUMBNAIL_NONE", TOGGLE_OFF: "TOGGLE_OFF", TOGGLE_ON: "TOGGLE_ON", USER: "USER", FEEDBACK_LIKE: "FEEDBACK_LIKE", FEEDBACK_DISLIKE: "FEEDBACK_DISLIKE" }, Sn = { DEFAULT: "DEFAULT", PRIMARY: "PRIMARY", PRIMARY_2: "PRIMARY_2", SECONDARY: "SECONDARY", SECONDARY_2: "SECONDARY_2", CONTENT: "CONTENT", CONTENT_INVERSE: "CONTENT_INVERSE", CONTENT_INVERSE_3: "CONTENT_INVERSE_3", WHITE: "WHITE", GRAY: "GRAY", THUMBNAIL_ICON: "THUMBNAIL_ICON", SENT: "SENT", READ: "READ", ON_BACKGROUND_1: "ON_BACKGROUND_1", ON_BACKGROUND_2: "ON_BACKGROUND_2", ON_BACKGROUND_3: "ON_BACKGROUND_3", ON_BACKGROUND_4: "ON_BACKGROUND_4", BACKGROUND_3: "BACKGROUND_3", ERROR: "ERROR" };
function f3(t) {
  switch (t) {
    case Sn.PRIMARY:
      return "sendbird-icon-color--primary";
    case Sn.PRIMARY_2:
      return "sendbird-icon-color--primary-2";
    case Sn.SECONDARY:
      return "sendbird-icon-color--secondary";
    case Sn.SECONDARY_2:
      return "sendbird-icon-color--secondary-2";
    case Sn.CONTENT:
      return "sendbird-icon-color--content";
    case Sn.CONTENT_INVERSE:
      return "sendbird-icon-color--content-inverse";
    case Sn.CONTENT_INVERSE_3:
      return "sendbird-icon-color--content-inverse-3";
    case Sn.WHITE:
      return "sendbird-icon-color--white";
    case Sn.GRAY:
      return "sendbird-icon-color--gray";
    case Sn.THUMBNAIL_ICON:
      return "sendbird-icon-color--thumbnail-icon";
    case Sn.SENT:
      return "sendbird-icon-color--sent";
    case Sn.READ:
      return "sendbird-icon-color--read";
    case Sn.ON_BACKGROUND_1:
      return "sendbird-icon-color--on-background-1";
    case Sn.ON_BACKGROUND_2:
      return "sendbird-icon-color--on-background-2";
    case Sn.ON_BACKGROUND_3:
      return "sendbird-icon-color--on-background-3";
    case Sn.ON_BACKGROUND_4:
      return "sendbird-icon-color--on-background-4";
    case Sn.BACKGROUND_3:
      return "sendbird-icon-color--background-3";
    case Sn.ERROR:
      return "sendbird-icon-color--error";
    default:
      return "";
  }
}
function m3(t) {
  switch (t) {
    case pe.ADD:
      return "sendbird-icon-add";
    case pe.ARROW_LEFT:
      return "sendbird-icon-arrow-left";
    case pe.ATTACH:
      return "sendbird-icon-attach";
    case pe.AUDIO_ON_LINED:
      return "sendbird-icon-audio-on-lined";
    case pe.BAN:
      return "sendbird-icon-ban";
    case pe.BROADCAST:
      return "sendbird-icon-broadcast";
    case pe.CAMERA:
      return "sendbird-icon-camera";
    case pe.CHANNELS:
      return "sendbird-icon-channels";
    case pe.CHAT:
      return "sendbird-icon-chat";
    case pe.CHAT_FILLED:
      return "sendbird-icon-chat-filled";
    case pe.CHEVRON_DOWN:
      return "sendbird-icon-chevron-down";
    case pe.CHEVRON_RIGHT:
      return "sendbird-icon-chevron-right";
    case pe.CLOSE:
      return "sendbird-icon-close";
    case pe.COLLAPSE:
      return "sendbird-icon-collapse";
    case pe.COPY:
      return "sendbird-icon-copy";
    case pe.CREATE:
      return "sendbird-icon-create";
    case pe.DELETE:
      return "sendbird-icon-delete";
    case pe.DISCONNECTED:
      return "sendbird-icon-disconnected";
    case pe.DOCUMENT:
      return "sendbird-icon-document";
    case pe.DONE:
      return "sendbird-icon-done";
    case pe.DONE_ALL:
      return "sendbird-icon-done-all";
    case pe.DOWNLOAD:
      return "sendbird-icon-down-load";
    case pe.EDIT:
      return "sendbird-icon-edit";
    case pe.EMOJI_MORE:
      return "sendbird-icon-emoji-more";
    case pe.ERROR:
      return "sendbird-icon-error";
    case pe.EXPAND:
      return "sendbird-icon-expand";
    case pe.FILE_AUDIO:
      return "sendbird-icon-file-audio";
    case pe.FILE_DOCUMENT:
      return "sendbird-icon-file-document";
    case pe.FREEZE:
      return "sendbird-icon-freeze";
    case pe.GIF:
      return "sendbird-icon-gif";
    case pe.INFO:
      return "sendbird-icon-info";
    case pe.LEAVE:
      return "sendbird-icon-leave";
    case pe.MEMBERS:
      return "sendbird-icon-members";
    case pe.MESSAGE:
      return "sendbird-icon-message";
    case pe.MODERATIONS:
      return "sendbird-icon-moderations";
    case pe.MORE:
      return "sendbird-icon-more";
    case pe.MUTE:
      return "sendbird-icon-mute";
    case pe.NOTIFICATIONS:
      return "sendbird-icon-notifications";
    case pe.NOTIFICATIONS_OFF_FILLED:
      return "sendbird-icon-notifications-off-filled";
    case pe.OPERATOR:
      return "sendbird-icon-operator";
    case pe.PHOTO:
      return "sendbird-icon-photo";
    case pe.PLAY:
      return "sendbird-icon-play";
    case pe.PLUS:
      return "sendbird-iconn-plus";
    case pe.QUESTION:
      return "sendbird-icon-question";
    case pe.REFRESH:
      return "sendbird-icon-refresh";
    case pe.REMOVE:
      return "sendbird-icon-remove";
    case pe.REPLY:
      return "sendbird-icon-reply";
    case pe.SEARCH:
      return "sendbird-icon-search";
    case pe.SEND:
      return "sendbird-icon-send";
    case pe.SETTINGS_FILLED:
      return "sendbird-icon-settings-filled";
    case pe.SPINNER:
      return "sendbird-icon-spinner";
    case pe.SUPERGROUP:
      return "sendbird-icon-supergroup";
    case pe.THREAD:
      return "sendbird-icon-thread";
    case pe.THUMBNAIL_NONE:
      return "sendbird-icon-thumbnail-none";
    case pe.TOGGLE_OFF:
      return "sendbird-icon-toggle-off";
    case pe.TOGGLE_ON:
      return "sendbird-icon-toggle-on";
    case pe.USER:
      return "sendbird-icon-user";
    case pe.FEEDBACK_LIKE:
      return "sendbird-icon-feedback-like";
    case pe.FEEDBACK_DISLIKE:
      return "sendbird-icon-feedback-dislike";
    default:
      return "sendbird-icon-unknown";
  }
}
const _3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M50.667 5.333a8 8 0 0 1 8 8v37.334a8 8 0 0 1-8 8H13.333a8 8 0 0 1-8-8V13.333a8 8 0 0 1 8-8zm0 5.334H13.333a2.667 2.667 0 0 0-2.666 2.666v37.334a2.667 2.667 0 0 0 2.666 2.666h37.334a2.667 2.667 0 0 0 2.666-2.666V13.333a2.667 2.667 0 0 0-2.666-2.666zm-18.667 8a2.667 2.667 0 0 1 2.649 2.355l.018.311v8h8a2.667 2.667 0 0 1 .311 5.316l-.311.018h-8v8a2.667 2.667 0 0 1-5.316.311l-.018-.311v-8h-8a2.667 2.667 0 0 1-.311-5.316l.311-.018h8v-8A2.667 2.667 0 0 1 32 18.667z", fill: "#000", fillRule: "evenodd" })), g3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M33.886 8.781a2.668 2.668 0 0 1 .221 3.52l-.221.251-16.78 16.781H56a2.667 2.667 0 0 1 .311 5.316l-.311.018-38.895-.001 16.78 16.782a2.666 2.666 0 0 1 .222 3.52l-.221.251a2.668 2.668 0 0 1-3.52.222l-.252-.222L8.781 33.886a2.668 2.668 0 0 1-.222-3.52l.222-.252L30.114 8.781a2.668 2.668 0 0 1 3.772 0z", fill: "#000", fillRule: "evenodd" })), v3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "m55.334 28.926-24.506 23.34c-5.222 4.973-13.74 4.973-18.962 0-5.149-4.903-5.149-12.797 0-17.7l24.506-23.34c3.138-2.988 8.278-2.988 11.416 0 3.064 2.919 3.064 7.594 0 10.513L23.255 45.077c-1.055 1.005-2.815 1.005-3.87.001-.98-.933-.98-2.39 0-3.325l22.64-21.535a2.667 2.667 0 0 0-3.676-3.864L15.709 37.89a7.578 7.578 0 0 0-.001 11.05c3.113 2.966 8.11 2.966 11.224 0l24.533-23.338c5.272-5.021 5.272-13.217 0-18.238-5.197-4.95-13.573-4.95-18.77 0L8.187 30.704c-7.356 7.005-7.356 18.419 0 25.424 7.281 6.935 19.036 6.935 26.318 0l24.506-23.34a2.666 2.666 0 1 0-3.678-3.862z", fill: "#000", fillRule: "evenodd" })), y3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333 2.667 48.2 2.667 32 15.8 2.667 32 2.667zM32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zm12.333 21.333a1 1 0 0 1 1 1v3.334a1 1 0 0 1-1 1H19.667a1 1 0 0 1-1-1v-3.334a1 1 0 0 1 1-1h24.666z", fill: "#000", fillRule: "evenodd" })), b3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M58.545 5.498c.08.258.122.526.122.796v46.079a2.666 2.666 0 0 1-3.462 2.546l-17.951-5.61c-.645 5.273-5.14 9.358-10.587 9.358C20.776 58.667 16 53.89 16 48v-5.334h-5.333a8 8 0 0 1-7.997-7.75l-.003-.25V24a8 8 0 0 1 8-8H16L55.205 3.749a2.665 2.665 0 0 1 3.34 1.75zM21.333 44.587V48a5.333 5.333 0 0 0 10.652.398L32 47.92l-10.667-3.333zm32-34.667-32 9.997v18.83l32 9.997V9.92zM16 21.333h-5.333a2.67 2.67 0 0 0-2.65 2.356L8 24v10.667a2.667 2.667 0 0 0 2.667 2.666H16v-16z", fill: "#000", fillRule: "evenodd" })), E3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M40 5.333c.892 0 1.724.446 2.219 1.188l4.541 6.812H56a8 8 0 0 1 7.986 7.53l.014.47v29.334a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V21.333a8 8 0 0 1 8-8h9.237l4.544-6.812a2.665 2.665 0 0 1 1.888-1.167l.331-.02zm-1.43 5.334H25.428l-4.542 6.812a2.66 2.66 0 0 1-1.887 1.167l-.331.02H8a2.668 2.668 0 0 0-2.667 2.667v29.334A2.667 2.667 0 0 0 8 53.333h48a2.667 2.667 0 0 0 2.667-2.666V21.333A2.667 2.667 0 0 0 56 18.667H45.333a2.665 2.665 0 0 1-2.218-1.188l-4.544-6.812zM32 21.333c7.364 0 13.333 5.97 13.333 13.334C45.333 42.03 39.363 48 32 48c-7.364 0-13.333-5.97-13.333-13.333 0-7.364 5.97-13.334 13.333-13.334zm0 5.334a8 8 0 1 0 0 16 8 8 0 0 0 0-16z", fill: "#000", fillRule: "evenodd" })), C3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "m42.65 5.333.311.017a2.666 2.666 0 0 1 2.373 2.633l-.017.311-1.45 13.04h9.466a2.667 2.667 0 0 1 .311 5.315l-.31.018H43.271l-1.184 10.666h11.245a2.667 2.667 0 0 1 .312 5.316l-.31.018H41.495l-1.512 13.627a2.667 2.667 0 0 1-5.318-.277l.017-.311 1.448-13.04H25.496l-1.512 13.628a2.667 2.667 0 0 1-5.318-.277l.017-.311 1.448-13.04h-9.464a2.667 2.667 0 0 1-.311-5.315l.31-.018h10.057l1.186-10.667H10.667a2.667 2.667 0 0 1-.311-5.315l.31-.018h11.835l1.515-13.627a2.668 2.668 0 0 1 2.634-2.373l.311.017a2.666 2.666 0 0 1 2.373 2.633l-.017.311-1.45 13.04H38.5l1.515-13.628a2.668 2.668 0 0 1 2.634-2.373zm-5.927 32 1.186-10.667H27.272l-1.184 10.667h10.635z", fill: "#000", fillRule: "evenodd" })), Y_ = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333c-4.455 0-8.679-.993-12.461-2.77l-1.753.58c-5.965 1.912-10.133 2.572-12.504 1.981-2.799-.698-3.351-1.919-1.657-3.663 1.171-1.396 2.147-3.14 2.928-5.234.622-1.668.377-4.001-.737-7A29.15 29.15 0 0 1 2.666 32C2.667 15.8 15.8 2.667 32 2.667zM32 8C18.745 8 8 18.745 8 32c0 3.5.747 6.88 2.168 9.978l.405.837.137.271.106.285c1.517 4.085 1.89 7.622.734 10.72l-.382.972-.192.433.235-.05a62.067 62.067 0 0 0 4.886-1.363l1.721-.568 2.04-.696 1.95.917A23.882 23.882 0 0 0 32 56c13.255 0 24-10.745 24-24S45.255 8 32 8z", fill: "#000", fillRule: "evenodd" })), T3 = Object.freeze(Object.defineProperty({ __proto__: null, default: Y_ }, Symbol.toStringTag, { value: "Module" })), w3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333c-4.455 0-8.679-.993-12.461-2.77l-1.753.58c-5.965 1.912-10.133 2.572-12.504 1.981-2.799-.698-3.351-1.919-1.657-3.663 1.171-1.396 2.147-3.14 2.928-5.234.622-1.668.377-4.001-.737-7A29.15 29.15 0 0 1 2.666 32C2.667 15.8 15.8 2.667 32 2.667z", fill: "#000", fillRule: "evenodd" })), $_ = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M16.121 21.879a2.998 2.998 0 0 0-4.242 0 2.998 2.998 0 0 0 0 4.242l18 18a2.998 2.998 0 0 0 4.242 0l18-18a2.998 2.998 0 0 0 0-4.242 2.998 2.998 0 0 0-4.242 0L32 37.757 16.121 21.88z", fill: "#000", fillRule: "evenodd" })), S3 = Object.freeze(Object.defineProperty({ __proto__: null, default: $_ }, Symbol.toStringTag, { value: "Module" })), N3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M22.114 46.114a2.668 2.668 0 0 0 3.772 3.772l16-16a2.668 2.668 0 0 0 0-3.772l-16-16a2.668 2.668 0 0 0-3.772 3.772L36.23 32 22.114 46.114z", fill: "#000", fillRule: "evenodd" })), I3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M52.552 11.448a2.666 2.666 0 0 1 .222 3.52l-.222.251-16.781 16.78 16.781 16.782a2.665 2.665 0 0 1 0 3.771 2.666 2.666 0 0 1-3.52.222l-.251-.222L32 35.771 15.219 52.552a2.665 2.665 0 0 1-3.771 0 2.666 2.666 0 0 1-.222-3.52l.222-.251L28.228 32l-16.78-16.781a2.665 2.665 0 0 1 0-3.771 2.666 2.666 0 0 1 3.52-.222l.251.222 16.78 16.78 16.782-16.78a2.665 2.665 0 0 1 3.771 0z", fill: "#000", fillRule: "evenodd" })), A3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M16 8a2.667 2.667 0 0 0-2.649 2.356l-.018.31v42.667a2.667 2.667 0 0 0 5.316.311l.018-.31V34.666h25.56l-6.113 6.114a2.668 2.668 0 0 0-.221 3.52l.221.251a2.666 2.666 0 0 0 3.52.222l.252-.222 10.666-10.666a2.666 2.666 0 0 0 .222-3.52l-.222-.252-10.666-10.666a2.666 2.666 0 0 0-3.993 3.52l.221.251 6.113 6.114h-25.56V10.667A2.667 2.667 0 0 0 16 8z", fill: "#000", fillRule: "evenodd" })), M3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M53.333 21.333a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8h-24a8 8 0 0 1-8-8v-24a8 8 0 0 1 8-8zm0 5.334h-24a2.667 2.667 0 0 0-2.666 2.666v24A2.667 2.667 0 0 0 29.333 56h24A2.667 2.667 0 0 0 56 53.333v-24a2.667 2.667 0 0 0-2.667-2.666zm-18.666-24a8 8 0 0 1 7.986 7.53l.014.47v2.666a2.667 2.667 0 0 1-5.316.311l-.018-.31v-2.667a2.67 2.67 0 0 0-2.355-2.65L34.667 8h-24a2.67 2.67 0 0 0-2.65 2.356l-.017.31v24a2.67 2.67 0 0 0 2.356 2.65l.31.017h2.667a2.667 2.667 0 0 1 .311 5.316l-.31.018h-2.667a8.001 8.001 0 0 1-7.987-7.53l-.013-.47v-24c0-4.26 3.33-7.743 7.53-7.987l.47-.013h24z", fill: "#000", fillRule: "evenodd" })), x3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333c-4.455 0-8.679-.993-12.461-2.77l-1.753.58c-5.965 1.912-10.133 2.572-12.504 1.981-2.799-.698-3.351-1.919-1.657-3.663 1.171-1.396 2.147-3.14 2.928-5.234.622-1.668.377-4.001-.737-7A29.15 29.15 0 0 1 2.666 32C2.667 15.8 15.8 2.667 32 2.667zM32 8C18.745 8 8 18.745 8 32c0 3.5.747 6.88 2.168 9.978l.405.837.137.271.106.285c1.517 4.085 1.89 7.622.734 10.72l-.382.972-.192.433.235-.05a62.067 62.067 0 0 0 4.886-1.363l1.721-.568 2.04-.696 1.95.917A23.882 23.882 0 0 0 32 56c13.255 0 24-10.745 24-24S45.255 8 32 8zm2.667 16v5.333H40c3.556 0 3.556 5.334 0 5.334h-5.333V40c0 3.556-5.334 3.556-5.334 0v-5.333H24c-3.556 0-3.556-5.334 0-5.334h5.333V24c0-3.556 5.334-3.556 5.334 0z", fill: "#000", fillRule: "evenodd" })), k3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "m54.534 6.069-.248.217-9.736 9.735-.04.04-9.573 9.573c-.15.118-.286.254-.405.404L6.286 54.286a2.423 2.423 0 0 0 3.18 3.645l.248-.217 13.374-13.373a2.419 2.419 0 0 0 1.88-.401 12.119 12.119 0 0 1 14.04 0 2.424 2.424 0 1 0 2.808-3.952 16.951 16.951 0 0 0-11.303-3.072l6.743-6.744a24.105 24.105 0 0 1 10.159 5.021 2.424 2.424 0 0 0 3.11-3.719 28.945 28.945 0 0 0-9.34-5.23l5.633-5.634a36.153 36.153 0 0 1 9.225 5.934 2.425 2.425 0 0 0 3.211-3.633 40.972 40.972 0 0 0-8.796-5.941l7.256-7.256a2.423 2.423 0 0 0-3.18-3.645zm-35.04 21.474a28.936 28.936 0 0 0-6.032 3.942 2.424 2.424 0 0 0 3.137 3.697 24.018 24.018 0 0 1 5.022-3.282 2.425 2.425 0 0 0-2.127-4.357zM4.748 22.909a2.424 2.424 0 0 0 3.207 3.636 36.363 36.363 0 0 1 26.978-8.977 2.424 2.424 0 0 0 .389-4.832A41.204 41.204 0 0 0 4.748 22.909z", fill: "#000", fillRule: "evenodd" })), O3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M37.333 2.667a3.305 3.305 0 0 1 .274.014l.085.01.058.008c.047.007.094.016.141.026l.029.007c.05.01.098.023.146.037l.034.01c.237.07.46.173.663.303l.034.022c.036.023.07.047.104.072l.057.043a2.646 2.646 0 0 1 .261.228l-.126-.117c.05.043.097.088.143.135L55.21 19.438c.047.046.091.094.134.143l.035.04c.026.032.052.063.076.096l.04.054.07.1.024.038c.16.253.279.535.347.836l.01.048c.009.043.017.086.024.13l.006.048.007.051.004.041c.01.09.014.18.014.27v32a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V10.667a8 8 0 0 1 8-8h21.333zM34.666 8H16a2.667 2.667 0 0 0-2.667 2.667v42.666A2.667 2.667 0 0 0 16 56h32a2.667 2.667 0 0 0 2.667-2.667L50.666 24H37.333a2.667 2.667 0 0 1-2.648-2.356l-.018-.31L34.666 8zm12.227 10.667-6.894-6.894.001 6.894h6.893z", fill: "#000", fillRule: "evenodd" })), Z_ = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M12.552 31.448a2.665 2.665 0 1 0-3.771 3.771l13.333 13.333a2.666 2.666 0 0 0 3.772 0L55.219 19.22a2.667 2.667 0 0 0-3.771-3.771L24 42.895 12.552 31.448z", fill: "#000", fillRule: "evenodd" })), R3 = Object.freeze(Object.defineProperty({ __proto__: null, default: Z_ }, Symbol.toStringTag, { value: "Module" })), D3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M5.886 31.448 19.219 44.78a2.667 2.667 0 0 1-3.771 3.771L2.114 35.22a2.667 2.667 0 0 1 3.772-3.771zm52.228-16a2.666 2.666 0 1 1 3.772 3.771L32.552 48.552a2.665 2.665 0 0 1-3.771 0L15.448 35.22a2.665 2.665 0 0 1 0-3.771 2.665 2.665 0 0 1 3.771 0l11.448 11.447zm-9.562 0a2.665 2.665 0 0 1 0 3.771L32.556 35.215a2.665 2.665 0 0 1-3.771 0 2.664 2.664 0 0 1 0-3.77L44.78 15.447a2.665 2.665 0 0 1 3.771 0z", fill: "#000", fillRule: "evenodd" })), L3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M56 42.667a2.667 2.667 0 0 1 2.649 2.355l.018.311v8c0 4.26-3.33 7.743-7.53 7.987l-.47.013H13.333a8 8 0 0 1-7.986-7.53l-.014-.47v-8a2.667 2.667 0 0 1 5.316-.311l.018.311v8a2.67 2.67 0 0 0 2.355 2.65l.311.017h37.334a2.667 2.667 0 0 0 2.648-2.356l.018-.31v-8A2.667 2.667 0 0 1 56 42.667zm-36.552-8.781a2.666 2.666 0 0 1 3.52-3.993l.251.221 6.114 6.114V5.333a2.667 2.667 0 0 1 5.316-.311l.018.311v30.894l6.114-6.113a2.668 2.668 0 0 1 3.52-.221l.251.221a2.666 2.666 0 0 1 .222 3.52l-.222.252-10.658 10.657a2.341 2.341 0 0 1-.135.128l.127-.119a2.67 2.67 0 0 1-.195.176l-.056.045a1.74 1.74 0 0 1-.086.064l-.056.04-.086.056-.06.036-.081.046-.079.04a2.528 2.528 0 0 1-.14.065l-.09.036c-.023.01-.045.017-.067.025l-.09.03-.063.019c-.043.012-.086.024-.13.034l-.013.003a3.06 3.06 0 0 1-.144.028l-.064.01c-.03.005-.061.009-.092.012l-.084.008a1.727 1.727 0 0 1-.103.006l-.069.002h-.095c-.028 0-.055-.002-.082-.003l.139.003c-.084 0-.167-.004-.249-.011l-.061-.007a1.359 1.359 0 0 1-.092-.012l-.09-.015a2.242 2.242 0 0 1-.118-.025l-.04-.01a2.644 2.644 0 0 1-.34-.11l-.015-.006c-.05-.02-.097-.04-.145-.063l-.042-.02L30.71 45a1.16 1.16 0 0 1-.067-.039c-.03-.018-.059-.035-.087-.054l-.062-.041c-.03-.02-.06-.042-.088-.063l-.04-.03-.008-.007a2.796 2.796 0 0 1-.251-.223L19.448 33.886z", fill: "#000", fillRule: "evenodd" })), U3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 65 65", ...t }, Q.createElement("path", { className: "fill", d: "M56 56a2.667 2.667 0 0 1 .311 5.315l-.311.018H8a2.667 2.667 0 0 1-.311-5.316L8 56h48zM35.448 3.448a2.665 2.665 0 0 1 3.771 0l10.667 10.666a2.668 2.668 0 0 1 0 3.772L20.552 47.219c-.5.5-1.178.781-1.885.781H8a2.667 2.667 0 0 1-2.667-2.667V34.667c0-.708.281-1.386.781-1.886zm1.885 5.659L10.667 35.77v6.896h6.89L44.227 16l-6.894-6.893z", fill: "#000", fillRule: "evenodd" })), P3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M32.097 3.22c2.65 0 5.255.357 7.763 1.054a2.134 2.134 0 0 1-1.144 4.111 24.669 24.669 0 0 0-6.619-.899c-13.603 0-24.63 11.027-24.63 24.63s11.027 24.63 24.63 24.63 24.63-11.027 24.63-24.63c0-2.227-.295-4.413-.87-6.518a2.13 2.13 0 0 1 1.494-2.62 2.13 2.13 0 0 1 2.62 1.494 28.895 28.895 0 0 1 1.023 7.644c0 15.96-12.938 28.897-28.897 28.897-15.96 0-28.897-12.937-28.897-28.897C3.2 16.157 16.138 3.22 32.097 3.22zm10.705 34.792a2.133 2.133 0 0 1 2.024 2.808c-1.873 5.623-6.937 9.488-12.729 9.488-5.792 0-10.856-3.865-12.73-9.488a2.134 2.134 0 0 1 1.875-2.803l.15-.005h21.41zm-3.477 4.266H24.867l.294.382c1.539 1.887 3.718 3.113 6.115 3.342l.314.024.507.015c2.617 0 5.037-1.188 6.743-3.151l.193-.23.292-.382zM21.392 21.954c1.087 0 1.985.814 2.116 1.866l.017.267v5.353a2.133 2.133 0 0 1-4.25.268l-.017-.268v-5.353c0-1.178.955-2.133 2.134-2.133zm21.41 0c1.088 0 1.985.814 2.117 1.866l.017.267v5.353a2.133 2.133 0 0 1-4.25.268l-.017-.268v-5.353c0-1.178.955-2.133 2.133-2.133zM54.853 0a.8.8 0 0 1 .8.8v7.786h7.76a.8.8 0 0 1 .8.8v2.667a.8.8 0 0 1-.8.8h-7.76v7.758a.8.8 0 0 1-.8.8h-2.666a.8.8 0 0 1-.8-.8v-7.758h-7.785a.8.8 0 0 1-.8-.8V9.387a.8.8 0 0 1 .8-.8l7.784-.001V.8a.8.8 0 0 1 .8-.8h2.667z", fill: "#000", fillRule: "evenodd" })), X_ = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M32 5.06a8 8 0 0 1 6.561 3.424l.287.439 22.608 37.744a8 8 0 0 1 .022 7.962 8.005 8.005 0 0 1-6.356 4.014l-.535.024H9.384a8.002 8.002 0 0 1-6.862-4.038 8.008 8.008 0 0 1-.226-7.493l.27-.506L25.16 8.91A8.001 8.001 0 0 1 32 5.06zm0 5.333c-.816 0-1.58.372-2.076.99l-.196.28-22.565 37.67a2.669 2.669 0 0 0 1.909 3.973l.341.027h45.144a2.67 2.67 0 0 0 2.45-3.659l-.148-.304L34.28 11.676A2.666 2.666 0 0 0 32 10.393zm0 32.274A2.667 2.667 0 1 1 32 48a2.667 2.667 0 0 1 0-5.333zm0-21.334a2.667 2.667 0 0 1 2.649 2.356l.018.311v10.667a2.667 2.667 0 0 1-5.316.311l-.018-.311V24A2.667 2.667 0 0 1 32 21.333z", fill: "#000", fillRule: "evenodd" })), F3 = Object.freeze(Object.defineProperty({ __proto__: null, default: X_ }, Symbol.toStringTag, { value: "Module" })), j3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M48 8a2.667 2.667 0 0 1 2.649 2.356l.018.31V32l-.001.027v21.306a2.667 2.667 0 0 1-5.315.311l-.018-.31V34.665H19.772l6.114 6.115a2.668 2.668 0 0 1 .221 3.52l-.221.251a2.666 2.666 0 0 1-3.52.222l-.252-.222-10.666-10.666a2.666 2.666 0 0 1-.222-3.52l.222-.252 10.666-10.666a2.666 2.666 0 0 1 3.993 3.52l-.221.251-6.113 6.114h25.56V10.667A2.667 2.667 0 0 1 48 8z", fill: "#000", fillRule: "evenodd" })), J_ = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { className: "fill", d: "M39.414 6.4a2.41 2.41 0 0 1 1.71.701l12.642 12.75c.407.41.634.953.634 1.516v29.765c0 3.542-4.342 6.468-8 6.468H16.16c-3.658 0-6.4-2.926-6.4-6.468L9.6 12.868c0-3.542 2.902-6.468 6.56-6.468zm3.331 35.173-21.49.027-.147.005c-1.066.08-1.908 1.014-1.908 2.155 0 1.193.92 2.16 2.055 2.16l21.49-.027.147-.005c1.066-.08 1.908-1.014 1.908-2.155 0-1.193-.92-2.16-2.055-2.16zm0-8.533-21.49.027-.147.005c-1.066.08-1.908 1.014-1.908 2.155 0 1.193.92 2.16 2.055 2.16l21.49-.027.147-.005c1.066-.08 1.908-1.014 1.908-2.155 0-1.193-.92-2.16-2.055-2.16zm-11.807-8.507h-9.6l-.153.006a2.15 2.15 0 0 0-1.985 2.154c0 1.193.957 2.16 2.138 2.16h9.6l.152-.005a2.152 2.152 0 0 0 1.985-2.155c0-1.193-.957-2.16-2.137-2.16z", fill: "#000", fillRule: "evenodd" })), H3 = Object.freeze(Object.defineProperty({ __proto__: null, default: J_ }, Symbol.toStringTag, { value: "Module" })), B3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333 2.667 48.2 2.667 32 15.8 2.667 32 2.667zM32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zm1.667 21.333a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3.334a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h3.334zm-1.667-8a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z", className: "fill" })), z3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M34.667 37.333c7.17 0 13.018 5.66 13.32 12.755l.013.579V56a2.667 2.667 0 0 1-5.315.311L42.667 56v-5.333c0-4.26-3.33-7.743-7.53-7.987l-.47-.013H13.333a8 8 0 0 0-7.986 7.53l-.014.47V56a2.667 2.667 0 0 1-5.316.311L0 56v-5.333c0-7.17 5.66-13.019 12.755-13.321l.578-.013h21.334zM54 37.765a13.333 13.333 0 0 1 9.986 12.297l.014.605V56a2.667 2.667 0 0 1-5.315.311L58.667 56v-5.331a8 8 0 0 0-6-7.74A2.667 2.667 0 1 1 54 37.765zM24 5.333c7.364 0 13.333 5.97 13.333 13.334C37.333 26.03 31.363 32 24 32c-7.364 0-13.333-5.97-13.333-13.333 0-7.364 5.97-13.334 13.333-13.334zm19.328.43a13.333 13.333 0 0 1 0 25.834 2.667 2.667 0 1 1-1.323-5.167 8 8 0 0 0 0-15.5 2.667 2.667 0 1 1 1.323-5.167zM24 10.667a8 8 0 1 0 0 16 8 8 0 0 0 0-16z", className: "fill" })), eg = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333c-4.455 0-8.679-.993-12.461-2.77l-1.753.58c-5.965 1.912-10.133 2.572-12.504 1.981-2.799-.698-3.351-1.919-1.657-3.663 1.171-1.396 2.147-3.14 2.928-5.234.622-1.668.377-4.001-.737-7A29.15 29.15 0 0 1 2.666 32C2.667 15.8 15.8 2.667 32 2.667zM32 8C18.745 8 8 18.745 8 32c0 3.5.747 6.88 2.168 9.978l.405.837.137.271.106.285c1.517 4.085 1.89 7.622.734 10.72l-.382.972-.192.433.235-.05a62.067 62.067 0 0 0 4.886-1.363l1.721-.568 2.04-.696 1.95.917A23.882 23.882 0 0 0 32 56c13.255 0 24-10.745 24-24S45.255 8 32 8zM18.667 29.333a2.667 2.667 0 1 1-.001 5.333 2.667 2.667 0 0 1 .001-5.333zm13.333 0a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334zm13.333 0a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z", className: "fill" })), V3 = Object.freeze(Object.defineProperty({ __proto__: null, default: eg }, Symbol.toStringTag, { value: "Module" })), G3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M32 45.333a5.333 5.333 0 1 1 0 10.666 5.333 5.333 0 0 1 0-10.666zM32 28a5.333 5.333 0 1 1 0 10.668A5.333 5.333 0 0 1 32 28zm0-17.333c2.946 0 5.333 2.387 5.333 5.333S34.946 21.333 32 21.333 26.667 18.946 26.667 16s2.387-5.333 5.333-5.333z", className: "fill" })), q3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M29.83 6.45a2.667 2.667 0 0 1 4.34 0l11.697 16.374L57 13.918c1.88-1.504 4.573.054 4.32 2.35l-.047.29-8 37.334A2.666 2.666 0 0 1 50.666 56H13.333a2.666 2.666 0 0 1-2.607-2.108l-8-37.333c-.525-2.452 2.315-4.207 4.273-2.641l11.132 8.906zM32 12.587l-11.163 15.63a2.667 2.667 0 0 1-3.836.532l-7.497-5.997 5.984 27.915h33.021l5.984-27.915L47 28.749a2.667 2.667 0 0 1-3.632-.281l-.204-.251L32 12.587zM32 32a5.333 5.333 0 1 1 0 10.668A5.333 5.333 0 0 1 32 32z", className: "fill" })), K3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M51.908 34.75c1.9-1.233 1.896-3.26.013-4.514L19.376 8.577c-1.893-1.26-3.404-.391-3.376 1.968l.522 42.888c.028 2.347 1.596 3.247 3.493 2.016L51.908 34.75z", className: "fill" })), W3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M34.667 29.333h18.666c3.556 0 3.556 5.334 0 5.334H34.667v18.666c0 3.556-5.334 3.556-5.334 0V34.667H10.667c-3.556 0-3.556-5.334 0-5.334h18.666V10.667c0-3.556 5.334-3.556 5.334 0v18.666z", className: "fill" })), Q3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M32 61.333C15.8 61.333 2.667 48.2 2.667 32S15.8 2.667 32 2.667 61.333 15.8 61.333 32 48.2 61.333 32 61.333zM32 56c13.255 0 24-10.745 24-24S45.255 8 32 8 8 18.745 8 32s10.745 24 24 24zm2.213-18.63a2.667 2.667 0 1 1-5.333 0v-2.69c0-1.148.734-2.168 1.823-2.53.173-.058.532-.195 1.01-.407.809-.36 1.616-.79 2.354-1.282 1.835-1.223 2.813-2.528 2.813-3.786a5.333 5.333 0 0 0-10.364-1.777 2.667 2.667 0 0 1-5.032-1.77 10.668 10.668 0 0 1 20.729 3.551c0 3.413-2.022 6.109-5.187 8.22a21.268 21.268 0 0 1-2.813 1.578v.893zm-5.333 7.523a2.667 2.667 0 1 1 5.333 0v.44a2.667 2.667 0 1 1-5.333 0v-.44z", className: "fill" })), tg = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "m46.14 14.43.562.537 6.631 6.167v-7.8a2.67 2.67 0 0 1 2.356-2.65l.311-.017a2.667 2.667 0 0 1 2.649 2.355l.018.311v16a2.67 2.67 0 0 1-2.356 2.65L56 32H40a2.667 2.667 0 0 1-.311-5.315l.311-.018h11.452l-8.44-7.85c-5.964-5.893-15.168-7.182-22.563-3.156-7.38 4.018-11.172 12.357-9.314 20.455 1.859 8.107 8.935 14.032 17.362 14.518 8.43.487 16.162-4.585 18.967-12.426a2.667 2.667 0 0 1 5.022 1.797C48.88 50.082 38.973 56.582 28.19 55.959c-10.785-.623-19.862-8.222-22.254-18.65C3.542 26.872 8.426 16.135 17.9 10.977c9.227-5.024 20.65-3.579 28.241 3.453z", className: "fill" })), Y3 = Object.freeze(Object.defineProperty({ __proto__: null, default: tg }, Symbol.toStringTag, { value: "Module" })), $3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333 2.667 48.2 2.667 32 15.8 2.667 32 2.667zm9.886 19.447a2.668 2.668 0 0 0-3.772 0L32 28.23l-6.114-6.115-.134-.124a2.667 2.667 0 0 0-3.638.124l-.124.134a2.667 2.667 0 0 0 .124 3.638L28.23 32l-6.115 6.114-.124.134a2.667 2.667 0 0 0 .124 3.638l.134.124a2.667 2.667 0 0 0 3.638-.124L32 35.77l6.114 6.115.134.124a2.667 2.667 0 0 0 3.638-.124l.124-.134a2.667 2.667 0 0 0-.124-3.638L35.77 32l6.115-6.114.124-.134a2.667 2.667 0 0 0-.124-3.638z", className: "fill" })), Z3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M11.774 10.5c.062 0 .12-.025.164-.07a.22.22 0 0 0 .062-.164c-.069-1.447-.495-2.678-1.268-3.66-.618-.785-1.455-1.409-2.49-1.855a9.331 9.331 0 0 0-2.406-.655 9.542 9.542 0 0 0-.862-.078V2.225a.225.225 0 0 0-.128-.203.23.23 0 0 0-.24.028L.084 5.692A.221.221 0 0 0 0 5.865c0 .068.03.132.082.175l4.523 3.737c.067.056.16.068.24.03a.222.222 0 0 0 .13-.202v-1.95c1.134-.08 2.178.003 3.107.25a6.39 6.39 0 0 1 2.087.96c1.018.724 1.398 1.5 1.401 1.507a.23.23 0 0 0 .204.128z", className: "fill" })), X3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M26.667 48C14.885 48 5.333 38.449 5.333 26.667c0-11.782 9.552-21.334 21.334-21.334S48 14.885 48 26.667c0 4.93-1.672 9.469-4.48 13.081l13.67 13.67a2.668 2.668 0 0 1-3.772 3.772l-13.67-13.67A21.239 21.239 0 0 1 26.667 48zm0-5.333c8.836 0 16-7.164 16-16 0-8.837-7.164-16-16-16-8.837 0-16 7.163-16 16 0 8.836 7.163 16 16 16z", className: "fill" })), J3 = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M59.795 29.43 7.329 2.979C4.691 1.802 1.76 4.153 2.932 6.798l6.925 18.609a2 2 0 0 0 1.544 1.275l32.273 5.394L11.4 37.47a1.998 1.998 0 0 0-1.544 1.275L2.932 57.353c-.879 2.645 1.76 4.997 4.397 3.527l52.466-26.453c2.051-.882 2.051-3.82 0-4.996z", className: "fill" })), eS = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 32 32", ...t }, Q.createElement("path", { fill: "#000", d: "M21.943 24.39a1.333 1.333 0 0 1-1.886 1.886l-9.333-9.333a1.333 1.333 0 0 1 0-1.886l9.333-9.333a1.333 1.333 0 1 1 1.886 1.885L13.553 16l8.39 8.391Z", className: "fill", clipRule: "evenodd" })), ng = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fillRule: "evenodd", d: "M32 61.333C48.2 61.333 61.333 48.2 61.333 32S48.2 2.667 32 2.667 2.667 15.8 2.667 32a2.838 2.838 0 1 0 5.678 0C8.344 18.935 18.934 8.344 32 8.344c13.065 0 23.656 10.591 23.656 23.656S45.065 55.656 32 55.656a2.838 2.838 0 1 0 0 5.677z", className: "fill" })), tS = Object.freeze(Object.defineProperty({ __proto__: null, default: ng }, Symbol.toStringTag, { value: "Module" })), nS = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M36.889 43.013c6.608 0 12.121 4.685 12.43 10.734l.014.537V58a2.667 2.667 0 0 1-5.316.311L44 58v-3.716c0-3.07-2.87-5.718-6.636-5.925l-.475-.013H27.11c-3.838 0-6.86 2.525-7.096 5.557l-.015.381V58a2.667 2.667 0 0 1-5.315.311L14.667 58v-3.716c0-6.126 5.324-10.986 11.864-11.26l.58-.011h9.778zm18.578-17.291c.266 0 .53.04.784.118 4.632 1.426 7.518 4.801 7.736 9.688l.013.594v12.8a2.667 2.667 0 0 1-5.315.311l-.018-.311V36.124c-.002-2.595-1.163-4.171-3.528-5.034l-.104-.037-2.502.002a2.667 2.667 0 0 1-2.648-2.356l-.018-.31a2.67 2.67 0 0 1 2.355-2.65l.311-.017h2.934zm-44 0 .31.018a2.666 2.666 0 0 1 2.356 2.648l-.018.311a2.666 2.666 0 0 1-2.648 2.356l-2.51-.002-.119.042c-2.246.85-3.503 2.574-3.505 5.147v12.68l-.018.31A2.666 2.666 0 0 1 0 48.922V36.24l.014-.591c.225-4.874 3.203-8.415 7.712-9.809.255-.078.52-.118.788-.118h2.953zM32 19.958c5.512 0 10 4.409 10 9.871 0 5.463-4.488 9.872-10 9.872s-10-4.41-10-9.872 4.488-9.871 10-9.871zm0 5.333c-2.588 0-4.667 2.043-4.667 4.538 0 2.496 2.08 4.538 4.667 4.538 2.588 0 4.667-2.042 4.667-4.538 0-2.495-2.08-4.538-4.667-4.538zM17.333 2.667c5.513 0 10 4.409 10 9.871 0 5.462-4.487 9.871-10 9.871-5.512 0-10-4.409-10-9.871 0-5.462 4.488-9.871 10-9.871zm29.334 0c5.512 0 10 4.409 10 9.871 0 5.462-4.488 9.871-10 9.871-5.513 0-10-4.409-10-9.871 0-5.462 4.487-9.871 10-9.871zM17.333 8c-2.587 0-4.666 2.042-4.666 4.538 0 2.496 2.079 4.538 4.666 4.538 2.588 0 4.667-2.042 4.667-4.538C22 10.042 19.921 8 17.333 8zm29.334 0C44.079 8 42 10.042 42 12.538c0 2.496 2.079 4.538 4.667 4.538 2.587 0 4.666-2.042 4.666-4.538 0-2.496-2.079-4.538-4.666-4.538z", className: "fill" })), rS = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M34.667 5.333a2.667 2.667 0 0 1 0 5.334H13.333a2.667 2.667 0 0 0-2.666 2.666v37.334c0 1.143.72 2.118 1.73 2.497l28.384-28.383a2.667 2.667 0 0 1 3.771 0l8.781 8.78v-4.228a2.667 2.667 0 0 1 2.498-2.661l.169-.005a2.667 2.667 0 0 1 2.667 2.666v21.334a8 8 0 0 1-8 8H13.33a8 8 0 0 1-7.998-8V13.333a8 8 0 0 1 8-8zm8 25.105L19.77 53.333h30.897a2.667 2.667 0 0 0 2.661-2.498l.005-.168v-9.563L42.667 30.438zM22.667 16a6.666 6.666 0 1 1 0 13.333 6.666 6.666 0 0 1 0-13.333zm0 5.333a1.334 1.334 0 1 0 0 2.667 1.334 1.334 0 0 0 0-2.667zM56.78 3.448a2.665 2.665 0 0 1 3.771 0 2.665 2.665 0 0 1 0 3.771l-4.782 4.78 4.782 4.782c.998.998 1.04 2.59.125 3.638l-.125.133a2.665 2.665 0 0 1-3.771 0l-4.782-4.781-4.78 4.781a2.667 2.667 0 0 1-3.638.125l-.133-.125a2.665 2.665 0 0 1 0-3.771L48.228 12l-4.78-4.781a2.667 2.667 0 0 1-.125-3.638l.125-.133a2.665 2.665 0 0 1 3.771 0l4.78 4.78z", className: "fill" })), iS = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 88 48", ...t }, Q.createElement("g", { fill: "none", fillRule: "evenodd" }, Q.createElement("rect", { width: 80, height: 40, x: 4, y: 4, fill: "#000", className: "fill", rx: 20 }), Q.createElement("circle", { cx: 24, cy: 24, r: 12, fill: "#FFF" }), Q.createElement("path", { fill: "#FFF", d: "M64 4c11.046 0 20 8.954 20 20s-8.954 20-20 20H24C12.954 44 4 35.046 4 24S12.954 4 24 4h40zm0 2H24C14.059 6 6 14.059 6 24c0 9.764 7.774 17.712 17.47 17.992L24 42h40c9.941 0 18-8.059 18-18 0-9.764-7.774-17.712-17.47-17.992L64 6z" }), Q.createElement("path", { fill: "#000", d: "M64 0H24C10.745 0 0 10.745 0 24s10.745 24 24 24h40c13.255 0 24-10.745 24-24S77.255 0 64 0zm0 4c11.046 0 20 8.954 20 20s-8.954 20-20 20H24C12.954 44 4 35.046 4 24S12.954 4 24 4h40z", className: "fill" }))), sS = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 88 48", ...t }, Q.createElement("g", { fill: "none", fillRule: "evenodd" }, Q.createElement("rect", { width: 80, height: 40, x: 4, y: 4, fill: "#000", className: "fill", rx: 20 }), Q.createElement("circle", { cx: 64, cy: 24, r: 12, fill: "#FFF" }), Q.createElement("path", { fill: "#FFF", d: "M64 4c11.046 0 20 8.954 20 20s-8.954 20-20 20H24C12.954 44 4 35.046 4 24S12.954 4 24 4h40zm0 2H24C14.059 6 6 14.059 6 24c0 9.764 7.774 17.712 17.47 17.992L24 42h40c9.941 0 18-8.059 18-18 0-9.764-7.774-17.712-17.47-17.992L64 6z" }), Q.createElement("path", { fill: "#000", d: "M64 0H24C10.745 0 0 10.745 0 24s10.745 24 24 24h40c13.255 0 24-10.745 24-24S77.255 0 64 0zm0 4c11.046 0 20 8.954 20 20s-8.954 20-20 20H24C12.954 44 4 35.046 4 24S12.954 4 24 4h40z", className: "fill" }))), aS = (t) => Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, Q.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M42.667 37.333c7.17 0 13.018 5.66 13.32 12.755l.013.579V56a2.667 2.667 0 0 1-5.315.311L50.667 56v-5.333c0-4.26-3.33-7.743-7.53-7.987l-.47-.013H21.333a8 8 0 0 0-7.986 7.53l-.014.47V56a2.667 2.667 0 0 1-5.316.311L8 56v-5.333c0-7.17 5.66-13.019 12.755-13.321l.578-.013h21.334zM32 5.333c7.364 0 13.333 5.97 13.333 13.334C45.333 26.03 39.363 32 32 32c-7.364 0-13.333-5.97-13.333-13.333 0-7.364 5.97-13.334 13.333-13.334zm0 5.334a8 8 0 1 0 0 16 8 8 0 0 0 0-16z", className: "fill" })), rg = (t) => Q.createElement("svg", { width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.346 5.336v-.001c.405-.523 1.182-.524 1.58-.037.162.2.25.443.25.69v3.678c0 .518.42.938.938.938H18.6c.359 0 .7.179.911.488l.001.001.369.548.003.004c.174.256.226.583.134.895l-1.532 5.316c-.131.459-.559.782-1.044.782h-7.075c-.3 0-.593-.127-.8-.345l-1.13-1.222v-6.647l3.91-5.088Zm-4.73 3.078 3.245-4.223.002-.002c1.125-1.456 3.339-1.522 4.517-.075.421.52.671 1.177.671 1.874v2.74h2.55c.99 0 1.908.496 2.462 1.31l.002.004.368.547.002.002a2.93 2.93 0 0 1 .382 2.475v.003l-1.528 5.302a2.963 2.963 0 0 1-2.847 2.142h-7.075a2.988 2.988 0 0 1-2.166-.935l-.007-.007-.066-.072a2.128 2.128 0 0 1-1.821 1.025H4.192a2.13 2.13 0 0 1-2.13-2.13v-8.3a2.13 2.13 0 0 1 2.13-2.13h2.115c.493 0 .948.168 1.31.45Zm-3.678 1.68c0-.141.114-.255.254-.255h2.115c.14 0 .254.114.254.255v8.3c0 .14-.114.255-.254.255H4.192a.255.255 0 0 1-.255-.255v-8.3Z", fill: "#000" })), oS = Object.freeze(Object.defineProperty({ __proto__: null, default: rg }, Symbol.toStringTag, { value: "Module" })), ig = (t) => Q.createElement("svg", { width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.654 18.664v.001c-.405.523-1.182.524-1.58.037-.162-.2-.25-.444-.25-.69v-3.678a.938.938 0 0 0-.938-.938H5.4c-.359 0-.7-.179-.911-.488l-.001-.001-.369-.548-.003-.004a1.054 1.054 0 0 1-.134-.895l1.532-5.316c.131-.459.559-.782 1.044-.782h7.075c.3 0 .593.127.8.345l1.13 1.222v6.647l-3.91 5.088Zm4.73-3.078-3.245 4.223-.002.002c-1.125 1.456-3.339 1.521-4.517.075a2.975 2.975 0 0 1-.671-1.874v-2.74h-2.55c-.99 0-1.908-.496-2.462-1.31l-.002-.004-.368-.547-.002-.002a2.93 2.93 0 0 1-.382-2.475v-.003L3.711 5.63a2.963 2.963 0 0 1 2.847-2.142h7.075c.823 0 1.608.345 2.166.935l.007.007.066.072a2.129 2.129 0 0 1 1.821-1.025h2.115a2.13 2.13 0 0 1 2.13 2.13v8.3a2.13 2.13 0 0 1-2.13 2.13h-2.115a2.12 2.12 0 0 1-1.31-.45Zm3.678-1.68c0 .141-.114.255-.254.255h-2.115a.255.255 0 0 1-.255-.255v-8.3c0-.14.115-.255.255-.255h2.115c.14 0 .255.114.255.255v8.3Z", fill: "#000" })), lS = Object.freeze(Object.defineProperty({ __proto__: null, default: ig }, Symbol.toStringTag, { value: "Module" }));
function cS(t) {
  switch (t) {
    case pe.ADD:
      return C.jsx(_3, {});
    case pe.ARROW_LEFT:
      return C.jsx(g3, {});
    case pe.ATTACH:
      return C.jsx(v3, {});
    case pe.BAN:
      return C.jsx(y3, {});
    case pe.BROADCAST:
      return C.jsx(b3, {});
    case pe.CAMERA:
      return C.jsx(E3, {});
    case pe.CHANNELS:
      return C.jsx(C3, {});
    case pe.CHAT:
      return C.jsx(Y_, {});
    case pe.CHAT_FILLED:
      return C.jsx(w3, {});
    case pe.CHEVRON_DOWN:
      return C.jsx($_, {});
    case pe.CHEVRON_RIGHT:
      return C.jsx(N3, {});
    case pe.CLOSE:
      return C.jsx(I3, {});
    case pe.COLLAPSE:
      return C.jsx(A3, {});
    case pe.COPY:
      return C.jsx(M3, {});
    case pe.CREATE:
      return C.jsx(x3, {});
    case pe.DISCONNECTED:
      return C.jsx(k3, {});
    case pe.DOCUMENT:
      return C.jsx(O3, {});
    case pe.DONE:
      return C.jsx(Z_, {});
    case pe.DONE_ALL:
      return C.jsx(D3, {});
    case pe.DOWNLOAD:
      return C.jsx(L3, {});
    case pe.EDIT:
      return C.jsx(U3, {});
    case pe.EMOJI_MORE:
      return C.jsx(P3, {});
    case pe.ERROR:
      return C.jsx(X_, {});
    case pe.EXPAND:
      return C.jsx(j3, {});
    case pe.FILE_DOCUMENT:
      return C.jsx(J_, {});
    case pe.INFO:
      return C.jsx(B3, {});
    case pe.MEMBERS:
      return C.jsx(z3, {});
    case pe.MESSAGE:
      return C.jsx(eg, {});
    case pe.MORE:
      return C.jsx(G3, {});
    case pe.OPERATOR:
      return C.jsx(q3, {});
    case pe.PLAY:
      return C.jsx(K3, {});
    case pe.PLUS:
      return C.jsx(W3, {});
    case pe.QUESTION:
      return C.jsx(Q3, {});
    case pe.REFRESH:
      return C.jsx(tg, {});
    case pe.REMOVE:
      return C.jsx($3, {});
    case pe.REPLY:
      return C.jsx(Z3, {});
    case pe.SEARCH:
      return C.jsx(X3, {});
    case pe.SEND:
      return C.jsx(J3, {});
    case pe.SLIDE_LEFT:
      return C.jsx(eS, {});
    case pe.SPINNER:
      return C.jsx(ng, {});
    case pe.SUPERGROUP:
      return C.jsx(nS, {});
    case pe.THUMBNAIL_NONE:
      return C.jsx(rS, {});
    case pe.TOGGLE_OFF:
      return C.jsx(iS, {});
    case pe.TOGGLE_ON:
      return C.jsx(sS, {});
    case pe.USER:
      return C.jsx(aS, {});
    case pe.FEEDBACK_LIKE:
      return C.jsx(rg, {});
    case pe.FEEDBACK_DISLIKE:
      return C.jsx(ig, {});
    default:
      return "icon";
  }
}
function fi({ className: t = "", type: n, fillColor: e = Sn.DEFAULT, width: r = 26, height: i = 26, onClick: s = Ur, children: a = null, testID: o }) {
  const l = { width: typeof r == "string" ? r : `${r}px`, minWidth: typeof r == "string" ? r : `${r}px`, height: typeof i == "string" ? i : `${i}px`, minHeight: typeof i == "string" ? i : `${i}px` };
  return C.jsx("div", { className: [...Array.isArray(t) ? t : [t], "sendbird-icon", m3(n), f3(e)].join(" "), "data-testid": o, role: "button", onClick: s, onKeyDown: s, tabIndex: 0, style: l, children: a || cS(n) });
}
const mi = pe, Qr = Sn, uS = ({ titleText: t, onCloseClick: n }) => C.jsxs("div", { className: "sendbird-modal__header", children: [C.jsx(En, { type: Nn.H_1, color: Cn.ONBACKGROUND_1, children: t }), C.jsx("div", { className: "sendbird-modal__close", children: C.jsx(ah, { width: "32px", height: "32px", onClick: n, children: C.jsx(fi, { type: mi.CLOSE, fillColor: Qr.DEFAULT, width: "24px", height: "24px" }) }) })] }), dS = ({ children: t }) => C.jsx("div", { className: "sendbird-modal__body", children: C.jsx(En, { type: Nn.SUBTITLE_1, color: Cn.ONBACKGROUND_2, children: t }) }), Nd = ({ submitText: t, disabled: n = !1, hideCancelButton: e = !1, type: r = Un.DANGER, onSubmit: i, onCancel: s }) => {
  const { stringSet: a } = Mn(Ta);
  return C.jsxs("div", { className: "sendbird-modal__footer", children: [!e && C.jsx(Ui, { type: Un.SECONDARY, onClick: s, children: C.jsx(En, { type: Nn.BUTTON_1, color: Cn.ONBACKGROUND_1, children: a.BUTTON__CANCEL }) }), C.jsx(Ui, { type: r, disabled: n, onClick: i, children: t })] });
};
function xc(t) {
  const { children: n = null, className: e = "", contentClassName: r = "", isCloseOnClickOutside: i = !1, isFullScreenOnMobile: s = !1, titleText: a, submitText: o, disabled: l = !1, hideFooter: c = !1, type: u = Un.DANGER, renderHeader: d, onSubmit: h = Ur, onClose: p, onCancel: f, customFooter: m, rootElementId: v } = t, E = p ?? f ?? Ur, { eventHandlers: y } = Xr(), [b] = Ye(() => `sbu-modal-${xo()}`);
  Tt(() => {
    var w, N;
    return (N = (w = y == null ? void 0 : y.modal) == null ? void 0 : w.onMounted) == null ? void 0 : N.call(w, { close: E, id: b });
  }, []);
  const { isMobile: T } = Mc();
  return Dd(C.jsxs("div", { className: Li("sendbird-modal", e, s && T && "sendbird-modal--full-mobile"), children: [C.jsxs("div", { className: Li("sendbird-modal__content", ...Array.isArray(r) ? r : [r]), children: [(d == null ? void 0 : d()) || C.jsx(uS, { titleText: a ?? "", onCloseClick: E }), C.jsx(dS, { children: n }), !c && (m ?? C.jsx(Nd, { disabled: l, onCancel: E, onSubmit: h, submitText: o ?? "", type: u }))] }), C.jsx("div", { className: Li("sendbird-modal__backdrop", i && "sendbird-modal__backdrop--clickoutside"), onClick: (w) => {
    w == null || w.stopPropagation(), i && E();
  } })] }), document.getElementById(v ?? ya));
}
const sg = ls({ openModal: Ur }), hS = ({ children: t }) => {
  const [n, e] = Ye([]), r = Nr((a) => {
    e((o) => [...o, a]);
  }, []), i = Nr(() => {
    e((a) => a.slice(1));
  }, []), s = sr(() => () => Fo(n).when((a) => a.length === 0, () => C.jsx(C.Fragment, {})).otherwise(() => {
    const { modalProps: a, childElement: o } = n[0];
    return C.jsx(xc, { ...a, className: Li("sendbird-global-modal", a == null ? void 0 : a.className), onClose: () => {
      var l;
      (l = a == null ? void 0 : a.onClose) == null || l.call(a), i();
    }, children: o({ closeModal: i }) });
  }), [n]);
  return C.jsxs(sg.Provider, { value: { openModal: r }, children: [C.jsx(s, {}), t] });
}, pS = { getItem: async (t) => localStorage.getItem(t) ?? null, setItem: async (t, n) => localStorage.setItem(t, n) }, ag = (t) => ({ version: Number(t.ui_template.version), uiTemplate: JSON.stringify(t.ui_template.body.items), colorVariables: t.color_variables }), Ff = (t) => {
  const n = {};
  return t.forEach((e) => {
    n[e.key] = ag(e);
  }), n;
}, { INITIALIZE_MESSAGE_TEMPLATES_INFO: jf, UPSERT_MESSAGE_TEMPLATES: fS, UPSERT_WAITING_TEMPLATE_KEYS: mS, MARK_ERROR_WAITING_TEMPLATE_KEYS: _S } = Ya;
function gS({ sdk: t, logger: n, appInfoStore: e, appInfoDispatcher: r }) {
  const i = e == null ? void 0 : e.messageTemplatesInfo;
  return { getCachedTemplate: (s) => {
    if (!i)
      return null;
    let a = null;
    const o = (i == null ? void 0 : i.templatesMap) ?? null;
    return o && (a = o[s] ?? null), a;
  }, updateMessageTemplatesInfo: async (s, a, o) => {
    var l;
    if (r) {
      r({ type: mS, payload: { keys: s, requestedAt: o } });
      const c = [];
      try {
        let u = !0, d = null;
        for (; u; ) {
          const h = await t.message.getMessageTemplatesByToken(d, { keys: s });
          h.templates.forEach((p) => {
            c.push(JSON.parse(p.template));
          }), u = h.hasMore, d = h.token;
        }
      } catch (u) {
        (l = n == null ? void 0 : n.error) == null || l.call(n, "Sendbird | fetchProcessedMessageTemplates failed", u, s);
      }
      if (c.length > 0) {
        const u = localStorage.getItem(na);
        if (u) {
          const d = JSON.parse(u), h = d.map((p) => p.key);
          c.forEach((p) => {
            h.includes(p.key) || d.push(p);
          }), localStorage.setItem(na, JSON.stringify(d));
        } else
          localStorage.setItem(na, JSON.stringify([c]));
        r({ type: fS, payload: c.map((d) => ({ key: d.key, template: ag(d) })) });
      } else
        r({ type: _S, payload: { keys: s, messageId: a } });
    }
  }, initializeMessageTemplatesInfo: async (s) => {
    var c;
    const a = (c = s.appInfo) == null ? void 0 : c.messageTemplateInfo.token;
    if (!a)
      return localStorage.removeItem(Nu), void localStorage.removeItem(na);
    const o = localStorage.getItem(Nu), l = localStorage.getItem(na);
    if (o && o === a) {
      if (o && o === a && l) {
        const u = JSON.parse(l), d = { token: a, templatesMap: Ff(u) };
        r({ type: jf, payload: d });
      }
    } else {
      const u = await (async (h) => {
        let p = !0, f = null;
        const m = [];
        for (; p; ) {
          const v = await h.message.getMessageTemplatesByToken(f, { limit: 20 });
          p = v.hasMore, f = v.token, v.templates.forEach((E) => {
            m.push(JSON.parse(E.template));
          });
        }
        return m;
      })(s), d = { token: a, templatesMap: Ff(u) };
      r({ type: jf, payload: d }), localStorage.setItem(Nu, a), localStorage.setItem(na, JSON.stringify(u));
    }
  } };
}
const vS = "No sendbird state value available. Make sure you are rendering `<SendbirdProvider>` at the top of your app.";
function Xr() {
  const t = Mn(x_);
  if (!t)
    throw new Error(vS);
  return t;
}
function yS(t) {
  const n = function({ legacyConfig: e, uikitOptions: r = {} }) {
    var h, p, f, m, v, E, y, b, T, w, N, M, I, x, R, L, j, P, q, G, X, Ce;
    const { replyType: i, isMentionEnabled: s, isReactionEnabled: a, disableUserProfile: o, isVoiceMessageEnabled: l, isTypingIndicatorEnabledOnChannelList: c, isMessageReceiptStatusEnabledOnChannelList: u, showSearchIcon: d } = e;
    return { common: { enableUsingDefaultUserProfile: ((h = r.common) == null ? void 0 : h.enableUsingDefaultUserProfile) ?? (typeof o == "boolean" ? !o : void 0) }, groupChannel: { enableOgtag: (p = r.groupChannel) == null ? void 0 : p.enableOgtag, enableMention: ((f = r.groupChannel) == null ? void 0 : f.enableMention) ?? s, enableReactions: ((m = r.groupChannel) == null ? void 0 : m.enableReactions) ?? a, enableReactionsSupergroup: (v = r.groupChannel) == null ? void 0 : v.enableReactionsSupergroup, enableTypingIndicator: (E = r.groupChannel) == null ? void 0 : E.enableTypingIndicator, enableVoiceMessage: ((y = r.groupChannel) == null ? void 0 : y.enableVoiceMessage) ?? l, replyType: ((b = r.groupChannel) == null ? void 0 : b.replyType) ?? (i != null ? W_(i).lowerCase : void 0), threadReplySelectType: (T = r.groupChannel) == null ? void 0 : T.threadReplySelectType, input: { enableDocument: (N = (w = r.groupChannel) == null ? void 0 : w.input) == null ? void 0 : N.enableDocument }, typingIndicatorTypes: (M = r.groupChannel) == null ? void 0 : M.typingIndicatorTypes, enableFeedback: (I = r.groupChannel) == null ? void 0 : I.enableFeedback, enableSuggestedReplies: (x = r.groupChannel) == null ? void 0 : x.enableSuggestedReplies, showSuggestedRepliesFor: (R = r.groupChannel) == null ? void 0 : R.showSuggestedRepliesFor, suggestedRepliesDirection: (L = r.groupChannel) == null ? void 0 : L.suggestedRepliesDirection }, groupChannelList: { enableTypingIndicator: ((j = r.groupChannelList) == null ? void 0 : j.enableTypingIndicator) ?? c, enableMessageReceiptStatus: ((P = r.groupChannelList) == null ? void 0 : P.enableMessageReceiptStatus) ?? u }, groupChannelSettings: { enableMessageSearch: ((q = r.groupChannelSettings) == null ? void 0 : q.enableMessageSearch) ?? d }, openChannel: { enableOgtag: (G = r.openChannel) == null ? void 0 : G.enableOgtag, input: { enableDocument: (Ce = (X = r.openChannel) == null ? void 0 : X.input) == null ? void 0 : Ce.enableDocument } } };
  }({ legacyConfig: { replyType: t.replyType, isMentionEnabled: t.isMentionEnabled, isReactionEnabled: t.isReactionEnabled, disableUserProfile: t.disableUserProfile, isVoiceMessageEnabled: t.isVoiceMessageEnabled, isTypingIndicatorEnabledOnChannelList: t.isTypingIndicatorEnabledOnChannelList, isMessageReceiptStatusEnabledOnChannelList: t.isMessageReceiptStatusEnabledOnChannelList, showSearchIcon: t.showSearchIcon }, uikitOptions: t.uikitOptions });
  return C.jsx(Aw, { storage: pS, localConfigs: { common: n == null ? void 0 : n.common, groupChannel: { channel: n == null ? void 0 : n.groupChannel, channelList: n == null ? void 0 : n.groupChannelList, setting: n == null ? void 0 : n.groupChannelSettings }, openChannel: { channel: n == null ? void 0 : n.openChannel } }, children: C.jsx(bS, { ...t }) });
}
const bS = ({ appId: t, userId: n, children: e, accessToken: r, customApiHost: i, customWebSocketHost: s, configureSession: a, theme: o = "light", config: l = {}, nickname: c = "", colorSet: u, stringSet: d, dateLocale: h, profileUrl: p = "", voiceRecord: f, userListQuery: m, imageCompression: v = {}, allowProfileEdit: E = !1, disableMarkAsDelivered: y = !1, renderUserProfile: b, onUserProfileMessage: T, breakpoint: w = !1, isUserIdUsedForNickname: N = !0, sdkInitParams: M, customExtensionParams: I, isMultipleFilesMessageEnabled: x = !1, eventHandlers: R }) => {
  const { logLevel: L = "", userMention: j = {}, isREMUnitEnabled: P = !1, pubSub: q } = l, { isMobile: G } = Mc(), [X, Ce] = Ye(Df(L)), [Be] = Ye(() => q ?? V_()), [se, Ee] = Ja(Hw, P_), [ee, ge] = Ja(Bw, F_), [ve, H] = Ja(zw, Vw), { configs: oe, configsWithAppAttr: J, initDashboardConfigs: Me } = Mn(M_), V = se.initialized, ie = se == null ? void 0 : se.sdk, { uploadSizeLimit: ae, multipleFilesMessageFileCountLimit: ce } = (ie == null ? void 0 : ie.appInfo) ?? {};
  Pw(u);
  const { getCachedTemplate: le, updateMessageTemplatesInfo: re, initializeMessageTemplatesInfo: te } = gS({ sdk: ie, logger: X, appInfoStore: ve, appInfoDispatcher: H }), Te = { updateMessageTemplatesInfo: re, getCachedTemplate: le }, ke = function(ue, Se) {
    const { userId: Fe, appId: et, accessToken: je, isMobile: Xe, isUserIdUsedForNickname: Et } = ue, { logger: $e, nickname: Rt, profileUrl: xt, configureSession: Gt, customApiHost: qt, customWebSocketHost: Xt, sdk: z, sdkDispatcher: Ne, userDispatcher: Oe, appInfoDispatcher: De, initDashboardConfigs: Ge, sdkInitParams: st, customExtensionParams: Je, eventHandlers: He, initializeMessageTemplatesInfo: lt } = Se, dt = Mt({ appId: "", userId: "" });
    return Tt(() => {
      var Ke;
      (Ke = $e == null ? void 0 : $e.info) == null || Ke.call($e, "SendbirdProvider | useConnect/useEffect", { userId: Fe, appId: et, accessToken: je });
      const qe = dt.current.appId !== et;
      dt.current.appId === et && dt.current.userId === Fe || (dt.current = { appId: et, userId: Fe }, Rf({ userId: Fe, appId: et, isNewApp: qe, accessToken: je, logger: $e, nickname: Rt, profileUrl: xt, configureSession: Gt, customApiHost: qt, customWebSocketHost: Xt, sdk: z, sdkDispatcher: Ne, userDispatcher: Oe, appInfoDispatcher: De, initDashboardConfigs: Ge, isUserIdUsedForNickname: Et, sdkInitParams: st, customExtensionParams: Je, isMobile: Xe, eventHandlers: He, initializeMessageTemplatesInfo: lt }).catch((ct) => {
        var nt;
        (nt = $e == null ? void 0 : $e.error) == null || nt.call($e, "SendbirdProvider | useConnect/useEffect", ct);
      }));
    }, [Fe, et]), Nr(async () => {
      var qe, Ke;
      (qe = $e == null ? void 0 : $e.info) == null || qe.call($e, "SendbirdProvider | useConnect/reconnect/useCallback", { sdk: z });
      try {
        await Rf({ userId: Fe, appId: et, accessToken: je, logger: $e, nickname: Rt, profileUrl: xt, configureSession: Gt, customApiHost: qt, customWebSocketHost: Xt, sdk: z, sdkDispatcher: Ne, userDispatcher: Oe, appInfoDispatcher: De, initDashboardConfigs: Ge, isUserIdUsedForNickname: Et, sdkInitParams: st, customExtensionParams: Je, isMobile: Xe, eventHandlers: He, initializeMessageTemplatesInfo: lt });
      } catch (ct) {
        (Ke = $e == null ? void 0 : $e.error) == null || Ke.call($e, "SendbirdProvider | useConnect/reconnect/useCallback", ct);
      }
    }, [z]);
  }({ appId: t, userId: n, accessToken: r, isUserIdUsedForNickname: N, isMobile: G }, { logger: X, nickname: c, profileUrl: p, configureSession: a, customApiHost: i, customWebSocketHost: s, sdkInitParams: M, customExtensionParams: I, sdk: ie, sdkDispatcher: Ee, userDispatcher: ge, appInfoDispatcher: H, initDashboardConfigs: Me, eventHandlers: R, initializeMessageTemplatesInfo: te });
  Iu(() => {
    typeof ie.disconnectWebSocket == "function" && j_({ logger: X, sdkDispatcher: Ee, userDispatcher: ge, sdk: ie });
  }, [ie.disconnectWebSocket]), Tt(() => {
    Ce(Df(L));
  }, [L]);
  const [he, ye] = Ye(o);
  Tt(() => {
    ye(o);
  }, [o]), Tt(() => {
    const ue = document.querySelector("body");
    ue == null || ue.classList.remove("sendbird-experimental__rem__units"), P && (ue == null || ue.classList.add("sendbird-experimental__rem__units"));
  }, [P]), Tt(() => {
    X.info("Setup theme", `Theme: ${he}`);
    const ue = `sendbird-theme--${he}`, Se = document.querySelector("body");
    if (Se && !Se.classList.contains(ue))
      return Se.classList.remove("sendbird-theme--light", "sendbird-theme--dark"), Se.classList.add(ue), () => {
        Se.classList.remove(ue);
      };
  }, [he]);
  const ze = function(ue, Se) {
    var je;
    const [Fe, et] = Ye(typeof window > "u" || (((je = window == null ? void 0 : window.navigator) == null ? void 0 : je.onLine) ?? !0));
    return Tt(() => {
      var Et;
      et(typeof window > "u" || (((Et = window == null ? void 0 : window.navigator) == null ? void 0 : Et.onLine) ?? !0));
      const Xe = xo();
      try {
        Se.warning("sdk changed", Xe);
        const $e = new d_({ onDisconnected() {
          et(!1), Se.warning("onDisconnected", { isOnline: Fe });
        }, onReconnectStarted() {
          et(!1), Se.warning("onReconnectStarted", { isOnline: Fe });
        }, onReconnectSucceeded() {
          et(!0), Se.warning("onReconnectSucceeded", { isOnline: Fe });
        }, onReconnectFailed() {
          ue.reconnect(), Se.warning("onReconnectFailed");
        } });
        ue != null && ue.addConnectionHandler && (ue.addConnectionHandler(Xe, $e), Se.info("Added ConnectionHandler", Xe));
      } catch {
      }
      return () => {
        try {
          ue.removeConnectionHandler(Xe), Se.info("Removed ConnectionHandler", Xe);
        } catch {
        }
      };
    }, [ue]), Tt(() => {
      const Xe = () => {
        try {
          Se.warning("Try reconnecting SDK"), ue.connectionState !== "OPEN" && ue.reconnect();
        } catch {
        }
      };
      return window.addEventListener("online", Xe), () => {
        window.removeEventListener("online", Xe);
      };
    }, [ue]), Tt(() => {
      const Xe = document.querySelector("body");
      if (Fe || ue != null && ue.isCacheEnabled)
        try {
          Xe == null || Xe.classList.remove("sendbird__offline"), Se.info("Removed class sendbird__offline from body");
        } catch {
        }
      else
        try {
          Xe == null || Xe.classList.add("sendbird__offline"), Se.info("Added class sendbird__offline to body");
        } catch {
        }
    }, [Fe, ue == null ? void 0 : ue.isCacheEnabled]), Fe;
  }(se.sdk, X), ot = function({ isConnected: ue }, { logger: Se }) {
    const Fe = sr(() => Pf({ logger: Se, cb: (et) => {
      try {
        et.markAsRead();
      } catch (je) {
        Se.warning("Channel: Mark as delivered failed", { channel: et, error: je });
      }
    } }), []);
    return Tt(() => {
      ue || Fe.clear();
    }, [ue]), Iu(() => {
      Fe.clear();
    }), Fe;
  }({ isConnected: ze }, { logger: X }), W = function({ isConnected: ue }, { logger: Se }) {
    const Fe = sr(() => Pf({ logger: Se, cb: async (et) => {
      try {
        await et.markAsDelivered();
      } catch (je) {
        Se.warning("Channel: Mark as delivered failed", { channel: et, error: je });
      }
    } }), []);
    return Tt(() => {
      ue || Fe.clear();
    }, [ue]), Iu(() => {
      Fe.clear();
    }), Fe;
  }({ isConnected: ze }, { logger: X }), xe = Ot.useMemo(() => ({ ...sh("en"), ...d }), [d]), be = sr(() => Math.min(10, ce ?? Number.MAX_SAFE_INTEGER), [ce]);
  return C.jsxs(x_.Provider, { value: { stores: { sdkStore: se, userStore: ee, appInfoStore: ve }, dispatchers: { sdkDispatcher: Ee, userDispatcher: ge, appInfoDispatcher: H, reconnect: ke }, config: { disableMarkAsDelivered: y, renderUserProfile: b, onUserProfileMessage: T, allowProfileEdit: E, isOnline: ze, userId: n, appId: t, accessToken: r, theme: he, setCurrentTheme: ye, setCurrenttheme: ye, isMultipleFilesMessageEnabled: x, uikitUploadSizeLimit: ae ?? 26214400, uikitMultipleFilesMessageLimit: be, userListQuery: m, logger: X, pubSub: Be, imageCompression: { compressionRate: 0.7, outputFormat: "preserve", ...v }, voiceRecord: { maxRecordingTime: (f == null ? void 0 : f.maxRecordingTime) ?? 6e5, minRecordingTime: (f == null ? void 0 : f.minRecordingTime) ?? 1e3 }, userMention: { maxMentionCount: (j == null ? void 0 : j.maxMentionCount) || 10, maxSuggestionCount: (j == null ? void 0 : j.maxSuggestionCount) || 15 }, markAsReadScheduler: ot, markAsDeliveredScheduler: W, common: oe.common, groupChannel: { enableOgtag: V && J(ie).groupChannel.channel.enableOgtag, enableTypingIndicator: oe.groupChannel.channel.enableTypingIndicator, enableReactions: V && J(ie).groupChannel.channel.enableReactions, enableReactionsSupergroup: V && J(ie).groupChannel.channel.enableReactionsSupergroup, enableMention: oe.groupChannel.channel.enableMention, replyType: oe.groupChannel.channel.replyType, threadReplySelectType: oe.groupChannel.channel.threadReplySelectType, enableVoiceMessage: oe.groupChannel.channel.enableVoiceMessage, enableDocument: oe.groupChannel.channel.input.enableDocument, typingIndicatorTypes: oe.groupChannel.channel.typingIndicatorTypes, enableFeedback: oe.groupChannel.channel.enableFeedback, enableSuggestedReplies: oe.groupChannel.channel.enableSuggestedReplies, showSuggestedRepliesFor: oe.groupChannel.channel.showSuggestedRepliesFor, suggestedRepliesDirection: oe.groupChannel.channel.suggestedRepliesDirection }, groupChannelList: { enableTypingIndicator: oe.groupChannel.channelList.enableTypingIndicator, enableMessageReceiptStatus: oe.groupChannel.channelList.enableMessageReceiptStatus }, groupChannelSettings: { enableMessageSearch: V && J(ie).groupChannel.setting.enableMessageSearch }, openChannel: { enableOgtag: V && J(ie).openChannel.channel.enableOgtag, enableDocument: oe.openChannel.channel.input.enableDocument }, disableUserProfile: !oe.common.enableUsingDefaultUserProfile, isReactionEnabled: V && J(ie).groupChannel.channel.enableReactions, isMentionEnabled: oe.groupChannel.channel.enableMention, isVoiceMessageEnabled: oe.groupChannel.channel.enableVoiceMessage, replyType: W_(oe.groupChannel.channel.replyType).upperCase, isTypingIndicatorEnabledOnChannelList: oe.groupChannel.channelList.enableTypingIndicator, isMessageReceiptStatusEnabledOnChannelList: oe.groupChannel.channelList.enableMessageReceiptStatus, showSearchIcon: V && J(ie).groupChannel.setting.enableMessageSearch }, eventHandlers: R, utils: Te }, children: [C.jsx(o3, { logger: X, breakpoint: w, children: C.jsx(a3, { stringSet: xe, dateLocale: h, children: C.jsx(hS, { children: e }) }) }), C.jsx(c3, {})] });
};
function pl(t, n, e) {
  const [r, i, s] = function(f) {
    const m = (f = f.replace("#", "")).length / 3;
    return [parseInt(f.slice(0, m), 16), parseInt(f.slice(m, 2 * m), 16), parseInt(f.slice(2 * m), 16)];
  }(t), [a, o, l] = function(f, m, v) {
    f /= 255, m /= 255, v /= 255;
    const E = Math.max(f, m, v), y = Math.min(f, m, v), b = E - y;
    let T = 0, w = 0;
    const N = (E + y) / 2;
    return E !== y && (w = N > 0.5 ? b / (2 - E - y) : b / (E + y)), E === f ? T = (m - v) / b + (m < v ? 6 : 0) : E === m ? T = (v - f) / b + 2 : E === v && (T = (f - m) / b + 4), T /= 6, [T, w, N];
  }(r, i, s), c = Math.max(0, Math.min(1, l * n)), u = Math.max(0, Math.min(1, o * e)), [d, h, p] = function(f, m, v) {
    let E, y, b;
    if (m === 0)
      E = y = b = v;
    else {
      const T = function(M, I, x) {
        return x < 0 && (x += 1), x > 1 && (x -= 1), x < 0.16666666666666666 ? M + 6 * (I - M) * x : x < 0.5 ? I : x < 0.6666666666666666 ? M + (I - M) * (0.6666666666666666 - x) * 6 : M;
      }, w = v < 0.5 ? v * (1 + m) : v + m - v * m, N = 2 * v - w;
      E = T(N, w, f + 1 / 3), y = T(N, w, f), b = T(N, w, f - 1 / 3);
    }
    return [Math.round(255 * E), Math.round(255 * y), Math.round(255 * b)];
  }(a, u, c);
  return `#${[Math.round(d), Math.round(h), Math.round(p)].map((f) => f.toString(16).padStart(2, "0")).join("")}`;
}
const fl = (t, n) => t === "500" ? [0.6, 1.2] : t === "400" ? [0.85, 1.1] : t === "200" ? n === "dark" ? [1.1, 0.95] : [1.5, 0.9] : t === "100" ? n === "dark" ? [1.2, 0.9] : [1.75, 0.8] : [1, 1];
function $a(t, n = "light") {
  const e = {};
  return e[500] = pl(t, ...fl("500", n)), e[400] = pl(t, ...fl("400", n)), e[300] = t, e[200] = pl(t, ...fl("200", n)), e[100] = pl(t, ...fl("100", n)), e;
}
function la(t, n) {
  const e = 0.299 * +`0x${t[1]}${t[2]}` + 0.587 * +`0x${t[3]}${t[4]}` + 0.114 * +`0x${t[5]}${t[6]}`;
  if (n) {
    const r = e > 149 ? 0 : 255;
    return `rgba(${r}, ${r}, ${r}, ${n})`;
  }
  return e > 149 ? "#000000" : "#ffffff";
}
function ES(t, n) {
  const e = $a(t, n);
  return Object.keys(e).reduce((r, i) => (r[`--sendbird-${n}-primary-${i}`] = e[parseInt(i)], r), {});
}
let CS = {};
function kc() {
  return CS;
}
function ko(t, n) {
  var o, l, c, u;
  const e = kc(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((l = (o = n == null ? void 0 : n.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? e.weekStartsOn ?? ((u = (c = e.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, i = jr(t), s = i.getDay(), a = (s < r ? 7 : 0) + s - r;
  return i.setDate(i.getDate() - a), i.setHours(0, 0, 0, 0), i;
}
function Ws(t, n) {
  return t instanceof Date ? new t.constructor(n) : new Date(n);
}
const og = 6048e5, TS = 864e5;
function dc(t) {
  return ko(t, { weekStartsOn: 1 });
}
function lg(t) {
  const n = jr(t), e = n.getFullYear(), r = Ws(t, 0);
  r.setFullYear(e + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = dc(r), s = Ws(t, 0);
  s.setFullYear(e, 0, 4), s.setHours(0, 0, 0, 0);
  const a = dc(s);
  return n.getTime() >= i.getTime() ? e + 1 : n.getTime() >= a.getTime() ? e : e - 1;
}
function hc(t) {
  const n = jr(t);
  return n.setHours(0, 0, 0, 0), n;
}
function Hf(t) {
  const n = jr(t), e = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
  return e.setUTCFullYear(n.getFullYear()), +t - +e;
}
function cg(t, n) {
  return +hc(t) == +hc(n);
}
function wS(t) {
  if (n = t, !(n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]" || typeof t == "number"))
    return !1;
  var n;
  const e = jr(t);
  return !isNaN(Number(e));
}
function Bf(t) {
  const n = jr(t);
  return n.setSeconds(0, 0), n;
}
function SS(t) {
  const n = jr(t);
  return function(r, i) {
    const s = hc(r), a = hc(i), o = +s - Hf(s), l = +a - Hf(a);
    return Math.round((o - l) / TS);
  }(n, function(r) {
    const i = jr(r), s = Ws(r, 0);
    return s.setFullYear(i.getFullYear(), 0, 1), s.setHours(0, 0, 0, 0), s;
  }(n)) + 1;
}
function NS(t) {
  const n = jr(t), e = +dc(n) - +function(r) {
    const i = lg(r), s = Ws(r, 0);
    return s.setFullYear(i, 0, 4), s.setHours(0, 0, 0, 0), dc(s);
  }(n);
  return Math.round(e / og) + 1;
}
function ug(t, n) {
  var u, d, h, p;
  const e = jr(t), r = e.getFullYear(), i = kc(), s = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((p = (h = i.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = Ws(t, 0);
  a.setFullYear(r + 1, 0, s), a.setHours(0, 0, 0, 0);
  const o = ko(a, n), l = Ws(t, 0);
  l.setFullYear(r, 0, s), l.setHours(0, 0, 0, 0);
  const c = ko(l, n);
  return e.getTime() >= o.getTime() ? r + 1 : e.getTime() >= c.getTime() ? r : r - 1;
}
function IS(t, n) {
  const e = jr(t), r = +ko(e, n) - +function(i, s) {
    var u, d, h, p;
    const a = kc(), o = (s == null ? void 0 : s.firstWeekContainsDate) ?? ((d = (u = s == null ? void 0 : s.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((p = (h = a.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, l = ug(i, s), c = Ws(i, 0);
    return c.setFullYear(l, 0, o), c.setHours(0, 0, 0, 0), ko(c, s);
  }(e, n);
  return Math.round(r / og) + 1;
}
function Qt(t, n) {
  return (t < 0 ? "-" : "") + Math.abs(t).toString().padStart(n, "0");
}
const Wi = { y(t, n) {
  const e = t.getFullYear(), r = e > 0 ? e : 1 - e;
  return Qt(n === "yy" ? r % 100 : r, n.length);
}, M(t, n) {
  const e = t.getMonth();
  return n === "M" ? String(e + 1) : Qt(e + 1, 2);
}, d: (t, n) => Qt(t.getDate(), n.length), a(t, n) {
  const e = t.getHours() / 12 >= 1 ? "pm" : "am";
  switch (n) {
    case "a":
    case "aa":
      return e.toUpperCase();
    case "aaa":
      return e;
    case "aaaaa":
      return e[0];
    default:
      return e === "am" ? "a.m." : "p.m.";
  }
}, h: (t, n) => Qt(t.getHours() % 12 || 12, n.length), H: (t, n) => Qt(t.getHours(), n.length), m: (t, n) => Qt(t.getMinutes(), n.length), s: (t, n) => Qt(t.getSeconds(), n.length), S(t, n) {
  const e = n.length, r = t.getMilliseconds();
  return Qt(Math.trunc(r * Math.pow(10, e - 3)), n.length);
} }, AS = "midnight", MS = "noon", xS = "morning", kS = "afternoon", OS = "evening", RS = "night", zf = { G: function(t, n, e) {
  const r = t.getFullYear() > 0 ? 1 : 0;
  switch (n) {
    case "G":
    case "GG":
    case "GGG":
      return e.era(r, { width: "abbreviated" });
    case "GGGGG":
      return e.era(r, { width: "narrow" });
    default:
      return e.era(r, { width: "wide" });
  }
}, y: function(t, n, e) {
  if (n === "yo") {
    const r = t.getFullYear(), i = r > 0 ? r : 1 - r;
    return e.ordinalNumber(i, { unit: "year" });
  }
  return Wi.y(t, n);
}, Y: function(t, n, e, r) {
  const i = ug(t, r), s = i > 0 ? i : 1 - i;
  return n === "YY" ? Qt(s % 100, 2) : n === "Yo" ? e.ordinalNumber(s, { unit: "year" }) : Qt(s, n.length);
}, R: function(t, n) {
  return Qt(lg(t), n.length);
}, u: function(t, n) {
  return Qt(t.getFullYear(), n.length);
}, Q: function(t, n, e) {
  const r = Math.ceil((t.getMonth() + 1) / 3);
  switch (n) {
    case "Q":
      return String(r);
    case "QQ":
      return Qt(r, 2);
    case "Qo":
      return e.ordinalNumber(r, { unit: "quarter" });
    case "QQQ":
      return e.quarter(r, { width: "abbreviated", context: "formatting" });
    case "QQQQQ":
      return e.quarter(r, { width: "narrow", context: "formatting" });
    default:
      return e.quarter(r, { width: "wide", context: "formatting" });
  }
}, q: function(t, n, e) {
  const r = Math.ceil((t.getMonth() + 1) / 3);
  switch (n) {
    case "q":
      return String(r);
    case "qq":
      return Qt(r, 2);
    case "qo":
      return e.ordinalNumber(r, { unit: "quarter" });
    case "qqq":
      return e.quarter(r, { width: "abbreviated", context: "standalone" });
    case "qqqqq":
      return e.quarter(r, { width: "narrow", context: "standalone" });
    default:
      return e.quarter(r, { width: "wide", context: "standalone" });
  }
}, M: function(t, n, e) {
  const r = t.getMonth();
  switch (n) {
    case "M":
    case "MM":
      return Wi.M(t, n);
    case "Mo":
      return e.ordinalNumber(r + 1, { unit: "month" });
    case "MMM":
      return e.month(r, { width: "abbreviated", context: "formatting" });
    case "MMMMM":
      return e.month(r, { width: "narrow", context: "formatting" });
    default:
      return e.month(r, { width: "wide", context: "formatting" });
  }
}, L: function(t, n, e) {
  const r = t.getMonth();
  switch (n) {
    case "L":
      return String(r + 1);
    case "LL":
      return Qt(r + 1, 2);
    case "Lo":
      return e.ordinalNumber(r + 1, { unit: "month" });
    case "LLL":
      return e.month(r, { width: "abbreviated", context: "standalone" });
    case "LLLLL":
      return e.month(r, { width: "narrow", context: "standalone" });
    default:
      return e.month(r, { width: "wide", context: "standalone" });
  }
}, w: function(t, n, e, r) {
  const i = IS(t, r);
  return n === "wo" ? e.ordinalNumber(i, { unit: "week" }) : Qt(i, n.length);
}, I: function(t, n, e) {
  const r = NS(t);
  return n === "Io" ? e.ordinalNumber(r, { unit: "week" }) : Qt(r, n.length);
}, d: function(t, n, e) {
  return n === "do" ? e.ordinalNumber(t.getDate(), { unit: "date" }) : Wi.d(t, n);
}, D: function(t, n, e) {
  const r = SS(t);
  return n === "Do" ? e.ordinalNumber(r, { unit: "dayOfYear" }) : Qt(r, n.length);
}, E: function(t, n, e) {
  const r = t.getDay();
  switch (n) {
    case "E":
    case "EE":
    case "EEE":
      return e.day(r, { width: "abbreviated", context: "formatting" });
    case "EEEEE":
      return e.day(r, { width: "narrow", context: "formatting" });
    case "EEEEEE":
      return e.day(r, { width: "short", context: "formatting" });
    default:
      return e.day(r, { width: "wide", context: "formatting" });
  }
}, e: function(t, n, e, r) {
  const i = t.getDay(), s = (i - r.weekStartsOn + 8) % 7 || 7;
  switch (n) {
    case "e":
      return String(s);
    case "ee":
      return Qt(s, 2);
    case "eo":
      return e.ordinalNumber(s, { unit: "day" });
    case "eee":
      return e.day(i, { width: "abbreviated", context: "formatting" });
    case "eeeee":
      return e.day(i, { width: "narrow", context: "formatting" });
    case "eeeeee":
      return e.day(i, { width: "short", context: "formatting" });
    default:
      return e.day(i, { width: "wide", context: "formatting" });
  }
}, c: function(t, n, e, r) {
  const i = t.getDay(), s = (i - r.weekStartsOn + 8) % 7 || 7;
  switch (n) {
    case "c":
      return String(s);
    case "cc":
      return Qt(s, n.length);
    case "co":
      return e.ordinalNumber(s, { unit: "day" });
    case "ccc":
      return e.day(i, { width: "abbreviated", context: "standalone" });
    case "ccccc":
      return e.day(i, { width: "narrow", context: "standalone" });
    case "cccccc":
      return e.day(i, { width: "short", context: "standalone" });
    default:
      return e.day(i, { width: "wide", context: "standalone" });
  }
}, i: function(t, n, e) {
  const r = t.getDay(), i = r === 0 ? 7 : r;
  switch (n) {
    case "i":
      return String(i);
    case "ii":
      return Qt(i, n.length);
    case "io":
      return e.ordinalNumber(i, { unit: "day" });
    case "iii":
      return e.day(r, { width: "abbreviated", context: "formatting" });
    case "iiiii":
      return e.day(r, { width: "narrow", context: "formatting" });
    case "iiiiii":
      return e.day(r, { width: "short", context: "formatting" });
    default:
      return e.day(r, { width: "wide", context: "formatting" });
  }
}, a: function(t, n, e) {
  const r = t.getHours() / 12 >= 1 ? "pm" : "am";
  switch (n) {
    case "a":
    case "aa":
      return e.dayPeriod(r, { width: "abbreviated", context: "formatting" });
    case "aaa":
      return e.dayPeriod(r, { width: "abbreviated", context: "formatting" }).toLowerCase();
    case "aaaaa":
      return e.dayPeriod(r, { width: "narrow", context: "formatting" });
    default:
      return e.dayPeriod(r, { width: "wide", context: "formatting" });
  }
}, b: function(t, n, e) {
  const r = t.getHours();
  let i;
  switch (i = r === 12 ? MS : r === 0 ? AS : r / 12 >= 1 ? "pm" : "am", n) {
    case "b":
    case "bb":
      return e.dayPeriod(i, { width: "abbreviated", context: "formatting" });
    case "bbb":
      return e.dayPeriod(i, { width: "abbreviated", context: "formatting" }).toLowerCase();
    case "bbbbb":
      return e.dayPeriod(i, { width: "narrow", context: "formatting" });
    default:
      return e.dayPeriod(i, { width: "wide", context: "formatting" });
  }
}, B: function(t, n, e) {
  const r = t.getHours();
  let i;
  switch (i = r >= 17 ? OS : r >= 12 ? kS : r >= 4 ? xS : RS, n) {
    case "B":
    case "BB":
    case "BBB":
      return e.dayPeriod(i, { width: "abbreviated", context: "formatting" });
    case "BBBBB":
      return e.dayPeriod(i, { width: "narrow", context: "formatting" });
    default:
      return e.dayPeriod(i, { width: "wide", context: "formatting" });
  }
}, h: function(t, n, e) {
  if (n === "ho") {
    let r = t.getHours() % 12;
    return r === 0 && (r = 12), e.ordinalNumber(r, { unit: "hour" });
  }
  return Wi.h(t, n);
}, H: function(t, n, e) {
  return n === "Ho" ? e.ordinalNumber(t.getHours(), { unit: "hour" }) : Wi.H(t, n);
}, K: function(t, n, e) {
  const r = t.getHours() % 12;
  return n === "Ko" ? e.ordinalNumber(r, { unit: "hour" }) : Qt(r, n.length);
}, k: function(t, n, e) {
  let r = t.getHours();
  return r === 0 && (r = 24), n === "ko" ? e.ordinalNumber(r, { unit: "hour" }) : Qt(r, n.length);
}, m: function(t, n, e) {
  return n === "mo" ? e.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Wi.m(t, n);
}, s: function(t, n, e) {
  return n === "so" ? e.ordinalNumber(t.getSeconds(), { unit: "second" }) : Wi.s(t, n);
}, S: function(t, n) {
  return Wi.S(t, n);
}, X: function(t, n, e) {
  const r = t.getTimezoneOffset();
  if (r === 0)
    return "Z";
  switch (n) {
    case "X":
      return Gf(r);
    case "XXXX":
    case "XX":
      return Es(r);
    default:
      return Es(r, ":");
  }
}, x: function(t, n, e) {
  const r = t.getTimezoneOffset();
  switch (n) {
    case "x":
      return Gf(r);
    case "xxxx":
    case "xx":
      return Es(r);
    default:
      return Es(r, ":");
  }
}, O: function(t, n, e) {
  const r = t.getTimezoneOffset();
  switch (n) {
    case "O":
    case "OO":
    case "OOO":
      return "GMT" + Vf(r, ":");
    default:
      return "GMT" + Es(r, ":");
  }
}, z: function(t, n, e) {
  const r = t.getTimezoneOffset();
  switch (n) {
    case "z":
    case "zz":
    case "zzz":
      return "GMT" + Vf(r, ":");
    default:
      return "GMT" + Es(r, ":");
  }
}, t: function(t, n, e) {
  return Qt(Math.trunc(t.getTime() / 1e3), n.length);
}, T: function(t, n, e) {
  return Qt(t.getTime(), n.length);
} };
function Vf(t, n = "") {
  const e = t > 0 ? "-" : "+", r = Math.abs(t), i = Math.trunc(r / 60), s = r % 60;
  return s === 0 ? e + String(i) : e + String(i) + n + Qt(s, 2);
}
function Gf(t, n) {
  return t % 60 == 0 ? (t > 0 ? "-" : "+") + Qt(Math.abs(t) / 60, 2) : Es(t, n);
}
function Es(t, n = "") {
  const e = t > 0 ? "-" : "+", r = Math.abs(t);
  return e + Qt(Math.trunc(r / 60), 2) + n + Qt(r % 60, 2);
}
const qf = (t, n) => {
  switch (t) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    default:
      return n.date({ width: "full" });
  }
}, Kf = (t, n) => {
  switch (t) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    default:
      return n.time({ width: "full" });
  }
}, DS = { p: Kf, P: (t, n) => {
  const e = t.match(/(P+)(p+)?/) || [], r = e[1], i = e[2];
  if (!i)
    return qf(t, n);
  let s;
  switch (r) {
    case "P":
      s = n.dateTime({ width: "short" });
      break;
    case "PP":
      s = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = n.dateTime({ width: "long" });
      break;
    default:
      s = n.dateTime({ width: "full" });
  }
  return s.replace("{{date}}", qf(r, n)).replace("{{time}}", Kf(i, n));
} }, LS = /^D+$/, US = /^Y+$/, PS = ["D", "DD", "YY", "YYYY"], FS = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, jS = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, HS = /^'([^]*?)'?$/, BS = /''/g, zS = /[a-zA-Z]/;
function dg(t, n, e) {
  var u, d, h, p, f, m, v, E;
  const r = kc(), i = (e == null ? void 0 : e.locale) ?? r.locale ?? Ac, s = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((d = (u = e == null ? void 0 : e.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((p = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = (e == null ? void 0 : e.weekStartsOn) ?? ((m = (f = e == null ? void 0 : e.locale) == null ? void 0 : f.options) == null ? void 0 : m.weekStartsOn) ?? r.weekStartsOn ?? ((E = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : E.weekStartsOn) ?? 0, o = jr(t);
  if (!wS(o))
    throw new RangeError("Invalid time value");
  let l = n.match(jS).map((y) => {
    const b = y[0];
    return b === "p" || b === "P" ? (0, DS[b])(y, i.formatLong) : y;
  }).join("").match(FS).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const b = y[0];
    if (b === "'")
      return { isToken: !1, value: VS(y) };
    if (zf[b])
      return { isToken: !0, value: y };
    if (b.match(zS))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + b + "`");
    return { isToken: !1, value: y };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(o, l));
  const c = { firstWeekContainsDate: s, weekStartsOn: a, locale: i };
  return l.map((y) => {
    if (!y.isToken)
      return y.value;
    const b = y.value;
    return (!(e != null && e.useAdditionalWeekYearTokens) && function(T) {
      return US.test(T);
    }(b) || !(e != null && e.useAdditionalDayOfYearTokens) && function(T) {
      return LS.test(T);
    }(b)) && function(T, w, N) {
      const M = function(I, x, R) {
        const L = I[0] === "Y" ? "years" : "days of the month";
        return `Use \`${I.toLowerCase()}\` instead of \`${I}\` (in \`${x}\`) for formatting ${L} to the input \`${R}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
      }(T, w, N);
      if (console.warn(M), PS.includes(T))
        throw new RangeError(M);
    }(b, n, String(t)), (0, zf[b[0]])(o, b, i.localize, c);
  }).join("");
}
function VS(t) {
  const n = t.match(HS);
  return n ? n[1].replace(BS, "'") : t;
}
function Wf(t, n) {
  return +Bf(t) == +Bf(n);
}
const xi = { isStreaming(t) {
  const n = Za(t.data);
  return typeof n == "object" && !!n.stream;
}, isBotWelcomeMsg(t, n) {
  if ((t.isUserMessage() || t.isFileMessage()) && t.sender.userId === n) {
    const e = Za(t.data);
    return !(e != null && e.respond_mesg_id) && !(e != null && e.stream);
  }
  return !1;
}, isInputDisabled: (t) => {
  var n;
  return !!((n = t == null ? void 0 : t.extendedMessagePayload) != null && n.disable_chat_input);
}, commerceShopItems: { isValid: (t) => {
  var n;
  return (((n = t.extendedMessagePayload) == null ? void 0 : n.commerce_shop_items) ?? []).length > 0;
}, getItems: (t) => {
  var n;
  return ((n = t.extendedMessagePayload) == null ? void 0 : n.commerce_shop_items) ?? [];
}, getValidItems(t) {
  if (!t.isUserMessage())
    return [];
  const n = function(e) {
    const r = /(https?:\/\/[^\s()]+)/g;
    return e.match(r) ?? [];
  }(t.message);
  return this.getItems(t).filter((e) => n.includes(e.url)).sort((e, r) => n.indexOf(e.url) - n.indexOf(r.url));
} }, functionCalls: { parse: (t) => Za(t.data).function_calls ?? [], isFunctionCall: (t) => !!t && typeof t == "object" && "name" in t && "request" in t && "response_text" in t, getAdapterParams(t) {
  return this.parse(t).filter(this.isFunctionCall).map((n) => ({ name: n.name, request: n.request, response: Za(n.response_text) }));
} } };
function Oo(t, n) {
  return function(e) {
    var r;
    return e ? e.isUserMessage() || e.isFileMessage() || e.isMultipleFilesMessage() ? e.sender.userId : ((r = e == null ? void 0 : e.sender) == null ? void 0 : r.userId) ?? void 0 : void 0;
  }(t) === n;
}
function Za(t) {
  try {
    return JSON.parse(t === "" ? "{}" : t);
  } catch {
    return {};
  }
}
var hg = ((t) => (t.string = "String", t.codeSnippet = "codeSnippet", t))(hg || {});
const GS = (t) => {
  const n = t.match(/```([a-zA-Z]+)([\s\S]*)```/);
  return n ? { type: "codeSnippet", value: n[2], language: n[1] } : { type: "codeSnippet", value: t.substring(3, t.length - 3).trim(), language: "unknown" };
};
function Qf(t, n, e) {
  return n.substring(t, t + e.length) === e;
}
function pg(t, n) {
  const e = function(i) {
    const s = "```", a = [];
    let o = "", l = !1;
    for (let c = 0; c < i.length; c++) {
      const u = i[c];
      l ? Qf(c, i, s) ? (o += s, a.push(o), o = "", l = !1, c += 2) : o += u : Qf(c, i, s) ? (a.push(o), o = s, l = !0, c += 2) : o += u;
    }
    return a.push(o), a;
  }(t), r = e.map((i) => i.startsWith("```") && i.endsWith("```") ? GS(i) : { type: "String", value: i.trim() });
  return r.forEach((i) => {
    i.type === "String" && (i.value = function(s, a) {
      let o = s;
      for (let l = 0; l < a.length; l++) {
        const [c, u] = a[l];
        o = qS(o, c, u);
      }
      return o;
    }(i.value, n));
  }), r;
}
function qS(t, n, e) {
  const r = new RegExp(n, "gi");
  return t.replace(r, e);
}
function Er() {
}
const oh = /iPad|iPhone|iPod/.test(navigator.userAgent), KS = /Android/.test(navigator.userAgent), fg = (t) => t === "mobile" || t !== "desktop" && (oh || KS);
function Yf(t) {
  return t < Date.now();
}
const lh = () => {
  const t = {};
  return { getItem: (n) => {
    try {
      return localStorage.getItem(n);
    } catch {
      return t[n] ?? null;
    }
  }, setItem: (n, e) => {
    try {
      localStorage.setItem(n, e);
    } catch {
      t[n] = e;
    }
  }, deleteItem: (n) => {
    try {
      localStorage.removeItem(n);
    } catch {
      delete t[n];
    }
  } };
};
function mg(t) {
  return t && "chat-ai-widget-preview" in t && t["chat-ai-widget-preview"] === "True";
}
function WS(t) {
  return t ? t === Pa.self.default ? typeof window < "u" && window.Shopify ? Pa.self.shopify : typeof window < "u" && window.wp ? Pa.self.wordpress : Pa.self.default : t : Pa.default;
}
function $f(t) {
  let n = t;
  try {
    n = decodeURIComponent(t);
    const { protocol: e } = new URL(n);
    return ["https:", "http:", "tel:", "mailto:", "sms:"].some((r) => r === e.toLowerCase()) ? n : "#";
  } catch {
    n.startsWith("http://") || n.startsWith("https://") || (n = "https://" + n);
  }
  return n;
}
const QS = 2147483647, _g = 2147483646, YS = { userNickName: "User", betaMark: !1, customBetaMarkText: "BETA", firstMessageData: [], createGroupChannelParams: {}, chatBottomContent: { text: "" }, messageBottomContent: { text: "AI-generated response powered by OpenAI", infoIconText: "This response is generated by AI and may lack complete accuracy." }, replacementTextList: [["the Text extracts", "ChatBot Knowledge Base"]], customRefreshComponent: { icon: (t) => Q.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("path", { d: "M5.77862 3.9151C6.67822 3.4253 7.71549 3.23712 8.73379 3.37975C9.75206 3.52237 10.6945 3.98777 11.4195 4.70418L11.4267 4.71129L12.8126 6H11.3333V7.33333H15.3333V3.33333H14V5.2834L12.3493 3.74844C11.4197 2.83314 10.2159 2.24099 8.91874 2.05931C7.61814 1.87714 6.29243 2.11719 5.14103 2.74409C3.98952 3.37106 3.07391 4.35154 2.5338 5.5392C1.99363 6.727 1.85887 8.0566 2.15031 9.32718C2.44172 10.5977 3.14309 11.7387 4.14693 12.5792C5.15064 13.4195 6.40257 13.914 7.71388 13.9898C9.02517 14.0655 10.3266 13.7185 11.4221 12.9998C12.5178 12.2811 13.3487 11.2291 13.7881 10.0012L12.5327 9.55204C12.1918 10.5048 11.546 11.324 10.6908 11.885C9.83544 12.4461 8.8176 12.718 7.79077 12.6587C6.76397 12.5994 5.78558 12.2121 5.00285 11.5568C4.22025 10.9016 3.67585 10.0142 3.44989 9.02909C3.22395 8.04408 3.32824 7.01314 3.74752 6.09117C4.16687 5.16906 4.87914 4.40484 5.77862 3.9151Z", fill: "#6210CC" })), onClick: Er, style: {}, width: "16px", height: "16px" }, enableSourceMessage: !1, enableEmojiFeedback: !0, enableMention: !0, enableResetHistoryOnConnect: !1, enableWidgetExpandButton: !1, dateLocale: Ac, enableHideWidgetForDeactivatedUser: !1, messageInputControls: { blockWhileBotResponding: 1e4 }, tools: { functionCall: { carouselAdapter: ({ response: t }) => function(n) {
  return !!n && typeof n == "object" && "meals" in n && Array.isArray(n.meals);
}(t) ? t.meals.map((n) => ({ title: n.strMeal, url: "", featured_image: n.strMealThumb })) : [] } } }, _i = { widgetWindow: "aichatbot-widget-window", widgetToggleButton: "aichatbot-widget-button", collapseIcon: "aichatbot-widget-collapse-icon", expandIcon: "aichatbot-widget-expand-icon", closeIcon: "aichatbot-widget-close-icon", refreshIcon: "aichatbot-widget-refresh-icon" }, Pa = { default: "genai-chatbot-widget", playground: "genai-widget-playground", self: { default: "genai-self-service", wordpress: "genai-wordpress-self-service", shopify: "genai-shopify-self-service" }, plugin: { wordpress: "genai-wordpress-plugin", shopify: "genai-shopify-plugin" } }, gg = { messageInputDisabledPlaceholder: "Waiting for the bot’s reply…", formVersionInvalidFallbackMessage: "Form type messages are not available in this version." }, In = YS, vg = ls(null), $S = (t) => {
  var i, s, a, o, l, c;
  const n = fg(t.deviceType), e = n ? "24px" : "16px", r = Nr((u) => {
    var h;
    const d = (h = t.configureSession) == null ? void 0 : h.call(t, u);
    return d ? new tc({ ...d, onSessionTokenRequired: d.onSessionTokenRequired, onSessionClosed: d.onSessionClosed, onSessionError: d.onSessionError, onSessionRefreshed: d.onSessionRefreshed, onSessionExpired: d.onSessionExpired }) : new tc();
  }, [t.configureSession]);
  return C.jsx(vg.Provider, { value: { applicationId: t.applicationId, botId: t.botId, userId: t.userId, sessionToken: t.sessionToken, configureSession: t.configureSession ? r : void 0, userNickName: t.userNickName ?? In.userNickName, apiHost: t.apiHost ?? `https://api-${t.applicationId}.sendbird.com`, wsHost: t.wsHost ?? `wss://ws-${t.applicationId}.sendbird.com`, serviceName: WS(t.serviceName), callbacks: t.callbacks, customUserAgentParam: t.customUserAgentParam, renderWidgetToggleButton: t.renderWidgetToggleButton, deviceType: t.deviceType, isMobileView: n, stringSet: { ...Q_, MESSAGE_INPUT__PLACE_HOLDER__DISABLED: gg.messageInputDisabledPlaceholder, ...t.stringSet }, botStudioEditProps: t.botStudioEditProps, widgetOpenState: t.widgetOpenState, onWidgetOpenStateChange: t.onWidgetOpenStateChange, localCacheEnabled: t.localCacheEnabled, messageInputControls: { ...In.messageInputControls, ...t.messageInputControls }, locale: t.locale ?? navigator.language, dateLocale: t.dateLocale ?? In.dateLocale, autoOpen: t.autoOpen, enableSourceMessage: t.enableSourceMessage ?? In.enableSourceMessage, enableEmojiFeedback: t.enableEmojiFeedback ?? In.enableEmojiFeedback, enableMention: t.enableMention ?? In.enableMention, enableResetHistoryOnConnect: t.enableResetHistoryOnConnect ?? In.enableResetHistoryOnConnect, enableHideWidgetForDeactivatedUser: t.enableHideWidgetForDeactivatedUser ?? In.enableHideWidgetForDeactivatedUser, enableWidgetExpandButton: t.enableWidgetExpandButton ?? In.enableWidgetExpandButton, betaMark: t.betaMark ?? In.betaMark, customBetaMarkText: t.customBetaMarkText ?? In.customBetaMarkText, firstMessageData: t.firstMessageData ?? [], createGroupChannelParams: t.createGroupChannelParams ?? In.createGroupChannelParams, chatBottomContent: t.chatBottomContent ?? In.chatBottomContent, messageBottomContent: t.messageBottomContent ?? In.messageBottomContent, replacementTextList: t.replacementTextList ?? In.replacementTextList, customRefreshComponent: { icon: ((i = t.customRefreshComponent) == null ? void 0 : i.icon) ?? In.customRefreshComponent.icon, width: ((s = t.customRefreshComponent) == null ? void 0 : s.width) ?? e, height: ((a = t.customRefreshComponent) == null ? void 0 : a.height) ?? e, onClick: ((o = t.customRefreshComponent) == null ? void 0 : o.onClick) ?? In.customRefreshComponent.onClick, style: { ...In.customRefreshComponent.style, ...(l = t.customRefreshComponent) == null ? void 0 : l.style } }, tools: { functionCall: { ...In.tools.functionCall, ...(c = t.tools) == null ? void 0 : c.functionCall } } }, children: t.children });
}, $t = () => {
  const t = Mn(vg);
  if (!t)
    throw new Error("useConstantState must be used within ConstantProvider");
  return t;
};
async function ZS({ host: t, botId: n, appId: e, createUserAndChannel: r, createChannel: i, userId: s, locale: a }) {
  var h;
  var o;
  const l = function(p, f) {
    return p.endsWith("/") && (p = p.slice(0, -1)), f.startsWith("/") && (f = f.slice(1)), `${p}/${f}`;
  }(t, `/v3/bots/${n}/${e}/widget_setting?${o = { create_user_and_channel: Zf(r), create_channel: Zf(i), user_id: s, locale: a }, Object.entries(o).filter(([p, f]) => f != null).map(([p, f]) => `${p}=${f}`).join("&")}`), c = await fetch(l), u = await c.json();
  if (!c.ok)
    throw new D(u);
  const d = u;
  return { bot: { replyToFile: ((h = d.bot) == null ? void 0 : h.reply_to_file) ?? !1 }, botStyle: { theme: d.bot_style.color.theme, accentColor: d.bot_style.color.accent_color, botMessageBGColor: d.bot_style.color.bot_message_color, toggleButtonUrl: d.bot_style.toggle_button_url ?? void 0, autoOpen: d.bot_style.auto_open }, user: d.user ? { expireAt: d.user.expire_at, userId: d.user.user_id, sessionToken: d.user.session_token } : void 0, channel: d.channel ? { channelUrl: d.channel.channel_url } : void 0 };
}
function Zf(t) {
  if (t != null)
    return t ? "True" : "False";
}
const XS = (t, n, e) => {
  const r = { onError: Er, onGetBotConfigs: Er, onGetBotStyle: Er, onAutoNonCached: Er, onAutoCached: Er, onManualNonCached: Er, onManualCached: Er }, i = { onError: (s) => (s && (r.onError = s), i), onGetBotConfigs: (s) => (r.onGetBotConfigs = s, i), onGetBotStyle: (s) => (r.onGetBotStyle = s, i), onAutoNonCached: (s) => (r.onAutoNonCached = s, i), onAutoCached: (s) => (r.onAutoCached = s, i), onManualCached: (s) => (r.onManualCached = s, i), onManualNonCached: (s) => (r.onManualNonCached = s, i), get: async () => {
    try {
      const s = await ZS({ host: e.host, appId: e.appId, botId: e.botId, ...JS(t, n, e) });
      r.onGetBotConfigs(s.bot), r.onGetBotStyle(s.botStyle), t === "auto" && function(a) {
        n ? r.onAutoCached({ channel: a.channel }) : a.channel && a.user && r.onAutoNonCached({ channel: a.channel, user: a.user });
      }(s), t === "manual" && function(a) {
        n ? r.onManualCached({ channel: a.channel }) : a.channel ? r.onManualNonCached({ channel: a.channel }) : r.onManualNonCached();
      }(s);
    } catch (s) {
      s instanceof Error && r.onError(s);
    }
  } };
  return i;
};
function JS(t, n, e) {
  return t === "auto" ? n ? { userId: e.userId } : { createUserAndChannel: !0, locale: e.locale } : {};
}
const ch = (t, n) => `@sendbird/chat-ai-widget/${t}/${n}`;
function ml(t) {
  const n = ch(t.appId, t.botId), e = JSON.stringify(t.data);
  lh().setItem(n, e);
}
function uh(t) {
  const n = ch(t.appId, t.botId);
  lh().deleteItem(n);
}
const m6 = uh, yg = ls(null), eN = ({ children: t }) => {
  var I, x;
  const { applicationId: n, botId: e, apiHost: r, userId: i, sessionToken: s, configureSession: a, createGroupChannelParams: o, firstMessageData: l, botStudioEditProps: c, autoOpen: u, callbacks: d, locale: h } = $t();
  if (!n || !e)
    throw new Error("applicationId or botId is not defined");
  const p = typeof a == "function" && i && s ? "manual" : "auto", f = Ot.useRef(!1), [m, v] = Ye(!1), [E, y] = Ye({ replyToFile: !1 }), [b, T] = Ye({ theme: "light", accentColor: "#742DDD", botMessageBGColor: "#EEEEEE", autoOpen: !1 }), [w, N] = Ye(null);
  async function M(R, L = !1) {
    const j = function(G) {
      const X = ch(G.appId, G.botId), Ce = lh().getItem(X);
      try {
        return Ce ? { strategy: "auto", ...JSON.parse(Ce) } : null;
      } catch {
        return null;
      }
    }({ appId: n, botId: e }), P = (q = j, !(L || !q || q.strategy !== R || (q.strategy === "manual" ? Yf(q.expireAt) || q.userId !== i : q.strategy !== "auto" || Yf(q.expireAt))));
    var q;
    await XS(R, P, { host: r, appId: n, botId: e, userId: R === "manual" ? i : j == null ? void 0 : j.userId, locale: h }).onError(d == null ? void 0 : d.onWidgetSettingFailure).onGetBotConfigs((G) => y(G)).onGetBotStyle((G) => T(G)).onAutoNonCached(({ user: G, channel: X }) => {
      const Ce = { strategy: R, userId: G.userId, sessionToken: G.sessionToken, expireAt: G.expireAt, channelUrl: X.channelUrl };
      N(Ce), ml({ appId: n, botId: e, data: Ce });
    }).onAutoCached(({ channel: G }) => {
      if (j) {
        const X = { ...j, channelUrl: (G == null ? void 0 : G.channelUrl) ?? j.channelUrl };
        N(X), ml({ appId: n, botId: e, data: X });
      }
    }).onManualNonCached(() => {
      i && N({ strategy: R, userId: i, sessionToken: s, channelUrl: void 0, expireAt: 0 });
    }).onManualCached(({ channel: G }) => {
      if (j) {
        const X = { ...j, channelUrl: (G == null ? void 0 : G.channelUrl) ?? j.channelUrl };
        N({ ...X, sessionToken: s }), ml({ appId: n, botId: e, data: X });
      }
    }).get(), v(!0);
  }
  return hr(() => {
    f.current || (f.current = !0, M(p).finally(() => {
      f.current = !1;
    }));
  }, [p]), C.jsx(yg.Provider, { value: { initialized: m, botStyle: { ...b, ...c == null ? void 0 : c.styles, accentColor: ((I = c == null ? void 0 : c.styles) == null ? void 0 : I.accentColor) ?? ((x = c == null ? void 0 : c.styles) == null ? void 0 : x.primaryColor) ?? b.accentColor, autoOpen: u ?? b.autoOpen }, botConfigs: E, widgetSession: w, initManualSession: async function(R) {
    if (p === "manual" && i) {
      const j = l ? JSON.stringify({ first_message_data: l }) : void 0, P = await R.groupChannel.createChannel({ name: o.name ?? "AI Chatbot Widget Channel", coverUrl: o.coverUrl, invitedUserIds: [i, e], isDistinct: !1, data: j }), q = { strategy: p, expireAt: (L = 30, (/* @__PURE__ */ new Date()).getTime() + 864e5 * L), userId: i, channelUrl: P.url };
      N((G) => ({ ...G, ...q })), ml({ appId: n, botId: e, data: q });
    }
    var L;
  }, resetSession: () => M(p, !0) }, children: w ? t : null });
}, wa = () => {
  const t = Mn(yg);
  if (!t)
    throw new Error("Not found WidgetSettingContext, useWidgetSetting must be used within an WidgetSettingProvider");
  return t;
}, Ho = () => {
  const { widgetSession: t } = wa();
  if (!t)
    throw new Error("WidgetSession is not initialized. Please make sure to use useWidgetSession under the WidgetSettingProvider's children components.");
  return t;
}, bg = ls(null), tN = ({ children: t }) => {
  const { widgetOpenState: n, onWidgetOpenStateChange: e, enableHideWidgetForDeactivatedUser: r, callbacks: i } = $t(), [s, a] = Ye(!1), [o, l] = Ye(!1), [c, u] = Ye(!r), d = typeof n == "boolean" && typeof e == "function";
  return C.jsx(bg.Provider, { value: { isOpen: d ? n : s, setIsOpen: (h) => {
    d ? e({ value: h }) : a(h);
  }, isVisible: c, setIsVisible: u, isExpanded: o, setIsExpanded: (h) => {
    var p;
    l(h), (p = i == null ? void 0 : i.onWidgetExpandStateChange) == null || p.call(i, h);
  } }, children: t });
}, $r = () => {
  const t = Mn(bg);
  if (t === null)
    throw new Error("useWidgetState must be used within an WidgetStateProvider");
  return t;
}, nN = "5.3.11";
function rN(t) {
  return t instanceof HTMLStyleElement && t.getAttribute("data-styled-version") === nN;
}
const dh = ls({ onDrop: Er, subscribe: () => Er }), iN = ({ children: t }) => {
  const n = Mt(/* @__PURE__ */ new Set());
  return C.jsx(dh.Provider, { value: { onDrop: (e) => {
    var r;
    if (e.preventDefault(), (r = e.dataTransfer) == null ? void 0 : r.files) {
      const i = Array.from(e.dataTransfer.files);
      i.length > 0 && n.current.forEach((s) => s(i));
    }
  }, subscribe: (e) => (n.current.add(e), () => n.current.delete(e)) }, children: t });
}, sN = ({ children: t }) => {
  const { applicationId: n, userNickName: e, configureSession: r, enableMention: i, enableEmojiFeedback: s, customUserAgentParam: a, stringSet: o, apiHost: l, wsHost: c, serviceName: u, isMobileView: d, dateLocale: h, enableHideWidgetForDeactivatedUser: p, localCacheEnabled: f } = $t(), { setIsVisible: m } = $r(), { botConfigs: v, botStyle: E } = wa(), y = Ho(), b = function() {
    const R = Mt(!1), [L, j] = Ye(document.head);
    return hr(() => {
      const P = new MutationObserver((q) => {
        const G = q.find((X) => X.target === document.head && X.addedNodes.length > 0);
        for (const X of (G == null ? void 0 : G.addedNodes) ?? [])
          rN(X) && (R.current ? j(document.body) : R.current = !0);
      });
      return P.observe(document.head, { childList: !0 }), () => P.disconnect();
    }, []), L;
  }(), T = sr(() => {
    const R = { ...a, "chat-ai-widget": "True", "chat-ai-widget-key": "c2VuZGJpcmQhQCM", "chat-ai-widget-service-name": u };
    return mg(R) && delete R["chat-ai-widget-service-name"], R;
  }, []), { theme: w, accentColor: N, botMessageBGColor: M } = E, I = function({ accentColor: R, botMessageBGColor: L }) {
    const j = L ? { light: $a(L, "light"), dark: $a(L, "dark") } : void 0, P = R ? { light: $a(R, "light"), dark: $a(R, "dark") } : void 0, q = L ? la(L) : void 0, G = R ? la(R) : void 0;
    return { light: { bgColor: { base: "var(--sendbird-light-background-50)", messageInput: "var(--sendbird-light-background-100)", incomingMessage: L ?? "var(--sendbird-dark-background-100)", outgoingMessage: R ?? "var(--sendbird-light-primary-300)", suggestedReply: "var(--sendbird-light-background-50)", bottomBanner: "var(--sendbird-light-background-50)", loadingScreen: "var(--sendbird-light-background-50)", hover: { incomingMessage: j ? j.light[400] : "var(--sendbird-light-background-200)", outgoingMessage: P ? P.light[400] : "var(--sendbird-light-primary-400)", suggestedReply: "var(--sendbird-light-background-100)", carouselButton: "var(--sendbird-light-background-100)" }, carouselItem: "var(--sendbird-light-background-50)", carouselButton: "var(--sendbird-light-background-50)", carouselButtonIcon: "var(--sendbird-light-background-400)", formInput: { default: "var(--sendbird-light-background-50)", disabled: "var(--sendbird-dark-ondark-02)" }, formChip: { default: "var(--sendbird-light-background-50)", selected: "var(--sendbird-light-primary-100)", submittedDefault: "var(--sendbird-dark-ondark-02)", submittedSelected: "var(--sendbird-dark-ondark-02)", hover: "var(--sendbird-light-background-50)", focus: "var(--sendbird-light-background-50)" }, formButton: { disabled: "var(--sendbird-light-onlight-04)" }, messageDataContent: { sidebar: "var(--sendbird-light-background-200)" } }, textColor: { incomingMessage: q ?? "var(--sendbird-dark-onlight-01)", outgoingMessage: G ?? "var(--sendbird-light-ondark-01)", errorMessage: "var(--sendbird-dark-onlight-01)", sentTime: "var(--sendbird-dark-onlight-03)", sourceInfo: "var(--sendbird-light-ondark-01)", suggestedReply: R ?? "var(--sendbird-light-primary-300)", bottomBanner: { poweredBy: "#5E5E5E", logo: "#0D0D0D" }, carouselItem: "var(--sendbird-light-onlight-01)", placeholder: "var(--sendbird-light-onlight-03)", formChip: { default: "var(--sendbird-light-onlight-02)", selected: "var(--sendbird-light-primary-300)", submittedDefault: "var(--sendbird-light-onlight-02)", submittedSelected: "var(--sendbird-light-onlight-01)", hover: "var(--sendbird-light-primary-300)", focus: "var(--sendbird-light-onlight-02)" }, formButton: { disabled: "var(--sendbird-light-background-50)" }, activeButton: G ?? "var(--sendbird-dark-ondark-01)", messageDataContent: { default: "var(--sendbird-light-onlight-01)", link: { default: P ? P.light[300] : "var(--sendbird-light-primary-300)", hover: P ? P.light[400] : "var(--sendbird-light-primary-400)", focus: P ? P.light[300] : "var(--sendbird-light-primary-300)", active: "var(--sendbird-light-onlight-01)", disabled: "var(--sendbird-light-onlight-03)" }, sideNote: "var(--sendbird-light-onlight-02)" } }, borderColor: { channelHeader: "var(--sendbird-light-onlight-04)", carouselItem: "var(--sendbird-light-onlight-04)", formInput: { default: "var(--sendbird-light-onlight-04)", active: "var(--sendbird-light-primary-300)", focus: "var(--sendbird-light-primary-300)", error: "var(--sendbird-light-error-300)" }, formChip: { default: "var(--sendbird-light-onlight-04)", selected: "var(--sendbird-light-primary-300)", hover: "var(--sendbird-light-primary-300)", focus: "var(--sendbird-light-primary-300)" }, messageDataContent: { intentType: "var(--sendbird-light-onlight-04)" } }, accentColor: R ?? "var(--sendbird-light-primary-300)" }, dark: { bgColor: { base: "var(--sendbird-dark-background-700)", messageInput: "var(--sendbird-dark-background-500)", incomingMessage: L ?? "var(--sendbird-dark-background-400)", outgoingMessage: R ?? "var(--sendbird-dark-primary-200)", suggestedReply: "var(--sendbird-dark-background-600)", bottomBanner: "var(--sendbird-dark-background-700)", loadingScreen: "var(--sendbird-dark-background-700)", hover: { incomingMessage: j ? j.dark[200] : "var(--sendbird-dark-background-400)", outgoingMessage: P ? P.dark[400] : "var(--sendbird-dark-primary-300)", suggestedReply: "var(--sendbird-dark-background-500)", carouselButton: "var(--sendbird-dark-background-500)" }, carouselItem: "var(--sendbird-dark-background-500)", carouselButton: "var(--sendbird-dark-background-400)", carouselButtonIcon: "var(--sendbird-dark-background-50)", formInput: { default: "var(--sendbird-light-onlight-03)", disabled: "var(--sendbird-light-onlight-04)" }, formChip: { default: "var(--sendbird-light-onlight-03)", selected: "var(--sendbird-dark-background-600)", submittedDefault: "var(--sendbird-dark-background-500)", submittedSelected: "var(--sendbird-light-onlight-04)", hover: "var(--sendbird-light-onlight-03)", focus: "var(--sendbird-light-onlight-03)" }, formButton: { disabled: "var(--sendbird-dark-ondark-04)" }, messageDataContent: { sidebar: "var(--sendbird-dark-background-400)" } }, textColor: { outgoingMessage: G ?? "var(--sendbird-dark-onlight-01)", incomingMessage: q ?? "var(--sendbird-dark-ondark-01)", errorMessage: "var(--sendbird-dark-ondark-01)", sentTime: "var(--sendbird-dark-ondark-03)", sourceInfo: "var(--sendbird-light-ondark-01)", suggestedReply: R ?? "var(--sendbird-dark-primary-200)", bottomBanner: { poweredBy: "var(--sendbird-dark-background-200)", logo: "var(--sendbird-dark-background-50)" }, carouselItem: "var(--sendbird-dark-ondark-01)", placeholder: "var(--sendbird-dark-ondark-03)", formChip: { default: "var(--sendbird-dark-ondark-02)", selected: "var(--sendbird-dark-primary-200)", submittedDefault: "var(--sendbird-dark-ondark-04)", submittedSelected: "var(--sendbird-dark-ondark-01)", hover: "var(--sendbird-dark-primary-200)", focus: "var(--sendbird-dark-ondark-02)" }, formButton: { disabled: "var(--sendbird-light-onlight-01)" }, activeButton: R ? la(R, 0.88) : "var(--sendbird-light-onlight-01)", messageDataContent: { default: "var(--sendbird-dark-ondark-01)", link: { default: P ? P.dark[200] : "var(--sendbird-dark-primary-200)", hover: P ? P.dark[300] : "var(--sendbird-dark-primary-300)", focus: P ? P.dark[200] : "var(--sendbird-dark-primary-200)", active: "var(--sendbird-dark-ondark-01)", disabled: "var(--sendbird-dark-ondark-03)" }, sideNote: "var(--sendbird-dark-ondark-02)" } }, borderColor: { channelHeader: "var(--sendbird-dark-ondark-04)", carouselItem: "var(--sendbird-dark-ondark-04)", formInput: { default: "var(--sendbird-dark-ondark-04)", active: "var(--sendbird-dark-primary-200)", focus: "var(--sendbird-dark-primary-200)", error: "var(--sendbird-dark-error-200)" }, formChip: { default: "var(--sendbird-dark-ondark-04)", selected: "var(--sendbird-dark-primary-200)", hover: "var(--sendbird-dark-primary-200)", focus: "var(--sendbird-dark-ondark-02)" }, messageDataContent: { intentType: "var(--sendbird-dark-ondark-02)" } }, accentColor: R ?? "var(--sendbird-dark-primary-200)" } };
  }({ accentColor: N, botMessageBGColor: M })[w], x = sr(() => {
    if (N)
      return ["light", "dark"].reduce((R, L) => ({ ...R, ...ES(N, L) }), {});
  }, [N]);
  return C.jsx(Lv, { target: b, children: C.jsx(qv, { theme: I, children: n && y.userId && C.jsx(yS, { appId: n, userId: y.userId, accessToken: y.sessionToken, nickname: e, customApiHost: l, customWebSocketHost: c, sdkInitParams: { localCacheEnabled: f }, configureSession: r, customExtensionParams: T, breakpoint: d, theme: w, colorSet: x, stringSet: o, dateLocale: h, eventHandlers: { connection: { onConnected() {
    p && m(!0);
  }, onFailed(R) {
    p && (R.code === me.USER_AUTH_DEACTIVATED ? m(!1) : m(!0));
  } } }, uikitOptions: { groupChannel: { input: { enableDocument: v.replyToFile }, enableVoiceMessage: !1, enableSuggestedReplies: !0, enableMention: i, enableFeedback: s } }, children: t }) }) });
};
function Eg(t) {
  return C.jsx($S, { ...t, children: C.jsx(eN, { children: C.jsx(tN, { children: C.jsx(iN, { children: C.jsx(sN, { children: t.children }) }) }) }) });
}
const aN = (t) => Q.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("path", { d: "M9.7832 15.2022V12.45C9.7832 11.8977 9.33549 11.45 8.7832 11.45C8.23092 11.45 7.7832 11.8977 7.7832 12.45V15.2022C7.7832 15.7545 8.23092 16.2022 8.7832 16.2022C9.33549 16.2022 9.7832 15.7545 9.7832 15.2022Z", fill: "#0D0D0D" }), Q.createElement("path", { d: "M16.2666 15.2022V12.45C16.2666 11.8977 15.8189 11.45 15.2666 11.45C14.7143 11.45 14.2666 11.8977 14.2666 12.45V15.2022C14.2666 15.7545 14.7143 16.2022 15.2666 16.2022C15.8189 16.2022 16.2666 15.7545 16.2666 15.2022Z", fill: "#0D0D0D" }), Q.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0008 0.973633C10.6172 0.973633 9.49558 2.09527 9.49558 3.47888C9.49558 4.50705 10.115 5.39055 11.0009 5.77664L11 7.5H3.25V19C3.25 20.3807 4.36929 21.5 5.75 21.5H18.25C19.6307 21.5 20.75 20.3807 20.75 19V10C20.75 8.61929 19.6307 7.5 18.25 7.5H13L13.0009 5.77653C13.8868 5.3904 14.5061 4.50696 14.5061 3.47888C14.5061 2.09527 13.3844 0.973633 12.0008 0.973633ZM5.25 9.5V19C5.25 19.2761 5.47386 19.5 5.75 19.5H18.25C18.5261 19.5 18.75 19.2761 18.75 19V10C18.75 9.72386 18.5261 9.5 18.25 9.5H5.25Z", fill: "#0D0D0D" }), Q.createElement("path", { d: "M0.250977 16.5788V10.5789H2.25098L2.25098 16.5788H0.250977Z", fill: "#0D0D0D" }), Q.createElement("path", { d: "M21.7511 10.5789V16.5788H23.7511V10.5789H21.7511Z", fill: "#0D0D0D" })), oN = (t) => Q.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.0573 12.9403L8.94291 11.0547L16.0001 18.1119L23.0573 11.0547L24.9429 12.9403L16.0001 21.8831L7.0573 12.9403Z", fill: "white" })), lN = jl`
  &:hover {
    transition: transform 250ms cubic-bezier(0.33, 0, 0, 1);
    transform: scale(1.1);
  }
  &:active {
    transform: scale(0.8);
  }
`, cN = Ie.button`
  position: relative;
  padding: 0;
  width: 48px;
  height: 48px;
  background: ${({ backgroundColor: t }) => t};
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.31, -0.105, 0.43, 1.4);
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow:
    0px 16px 24px 2px rgba(33, 33, 33, 0.12),
    0px 6px 30px 5px rgba(33, 33, 33, 0.08),
    0px 6px 10px -5px rgba(33, 33, 33, 0.04);

  span {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
    transition:
      transform 0.16s linear,
      opacity 0.08s linear,
      scale 0.16s linear;
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 32px;
      height: 32px;
      path {
        fill: ${({ backgroundColor: t }) => la(t)};
      }
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      -webkit-user-drag: none;
      &[data-svg='true'] {
        width: 32px;
        height: 32px;
        filter: ${({ backgroundColor: t }) => la(t) === "#ffffff" ? "grayscale(100%) brightness(2000%)" : "grayscale(100%) invert(100%) saturate(0%) brightness(0%) contrast(1000%)"};
      }
    }
  }
  ${({ animated: t }) => t && lN}
`, Cg = Ie.span`
  position: absolute;
`, uN = Ie(Cg)`
  opacity: ${({ isOpen: t }) => t ? 0 : 1};
  transform: ${({ animated: t, isOpen: n }) => t && (n ? "rotate(-90deg) scale(0)" : "rotate(0deg)")};
`, dN = Ie(Cg)`
  scale: ${({ isOpen: t }) => t ? 1 : 0};
  transform: ${({ animated: t, isOpen: n }) => t && (n ? "rotate(0deg)" : "rotate(-90deg)")};
`, hN = (t) => {
  const { url: n } = t;
  return n ? C.jsx("img", { src: n, alt: "widget-toggle-button", "data-svg": n.endsWith(".svg") }) : C.jsx(aN, {});
}, pN = () => C.jsx(oN, {}), fN = ({ isOpen: t, imageUrl: n, accentColor: e, onClick: r, className: i, animated: s = !0 }) => C.jsxs(cN, { id: _i.widgetToggleButton, "aria-label": "Widget toggle button", className: i, onClick: r, backgroundColor: e, animated: s, children: [C.jsx(uN, { isOpen: t, animated: s, children: C.jsx(hN, { url: n }) }), C.jsx(dN, { isOpen: t, animated: s, children: C.jsx(pN, {}) })] }), mN = Ie(fN)`
  && {
    position: fixed;
    z-index: ${QS};
    bottom: 24px;
    right: 24px;
  }
`;
function Tg() {
  const { botStyle: t } = wa(), { renderWidgetToggleButton: n } = $t(), { isOpen: e, setIsOpen: r } = $r(), i = { isOpen: e, onClick: () => r(!e), accentColor: t.accentColor };
  return typeof n == "function" ? n(i) : C.jsx(mN, { ...i, imageUrl: t.toggleButtonUrl });
}
const _N = Ie.div`
  background: ${({ theme: t }) => t.bgColor.base};
  display: flex;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: auto;
  position: fixed;
  bottom: 84px;
  right: 20px;
  height: 640px;
  min-height: 80px;
  width: 400px;
  max-width: 80vw;
  max-height: 80vh;
  box-shadow:
    0px 16px 24px 2px rgba(33, 33, 33, 0.12),
    0px 6px 30px 5px rgba(33, 33, 33, 0.08),
    0px 6px 10px -5px rgba(33, 33, 33, 0.04);
  border-radius: 16px;
  overflow: hidden;
  transform-origin: right bottom;
  transition:
    width 200ms ease 0s,
    height 200ms ease 0s,
    max-height 200ms ease 0s,
    transform 150ms cubic-bezier(0, 1.2, 1, 1) 0s,
    opacity 83ms ease-out 0s;
  transform: scale(0.15);
  opacity: 0;

  ${({ isOpen: t }) => t && jl`
        z-index: ${_g};
        pointer-events: all;
        transform: scale(1);
        opacity: 1;
        transition:
          width 200ms ease 0s,
          height 200ms ease 0s,
          max-height 200ms ease 0s,
          transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s,
          opacity 83ms ease-out 0s;
      `}

  ${({ isExpanded: t }) => t && jl`
      width: 743px;
      height: 723px;
    `}
`, gN = ({ children: t }) => {
  const { isVisible: n, isOpen: e, isExpanded: r } = $r();
  return C.jsx(_N, { isOpen: e && n, isExpanded: r, id: _i.widgetWindow, children: t });
};
function Xf(t, n = !0) {
  n ? setTimeout(() => {
    t();
  }) : t();
}
function Jf(t, n) {
  return typeof n == "boolean" ? n ? "smooth" : "auto" : t;
}
var Hr = function() {
  const t = Array.prototype.slice.call(arguments).filter(Boolean), n = {}, e = [];
  t.forEach((i) => {
    (i ? i.split(" ") : []).forEach((s) => {
      if (s.startsWith("atm_")) {
        const [, a] = s.split("_");
        n[a] = s;
      } else
        e.push(s);
    });
  });
  const r = [];
  for (const i in n)
    Object.prototype.hasOwnProperty.call(n, i) && r.push(n[i]);
  return r.push(...e), r.join(" ");
};
const _6 = "p1y6azm1", g6 = "a1c6uocy";
function us(t) {
  const { testId: n } = t;
  return e = { "data-testid": n }, Object.entries(e).reduce((r, [i, s]) => (s != null && (r[i] = s), r), {});
  var e;
}
const vN = { loading: { module: null, load: () => import("./Placeholder.loading-EvNUxnov.js").then((t) => t.default) }, error: { module: null, load: () => import("./Placeholder.error-5blNu-5_.js").then((t) => t.default) }, noChannels: { module: null, load: () => import("./Placeholder.noChannels-PYcQVQWx.js").then((t) => t.default) }, noMessages: { module: null, load: () => import("./Placeholder.noMessages-BHwcgPlO.js").then((t) => t.default) } }, Id = ({ className: t, type: n = "loading", testId: e = "sendbird-placeholder", ...r }) => {
  const [i, s] = Ot.useState(vN), a = us({ testId: `${e}-${n}` }), o = i[n], l = o.module;
  return Tt(() => {
    o && !o.module && o.load().then((c) => {
      o.module = c, s((u) => ({ ...u, [n]: o }));
    });
  }, [o]), C.jsx("div", { className: Hr(t, "sendbird-place-holder", "p1rufage"), ...a, children: l ? C.jsx(l, { type: n, ...r }) : null });
};
async function yN(t) {
  if ("file" in t && t.file instanceof File && t.file.type.startsWith("image/")) {
    const e = await (n = t.file, new Promise((r) => {
      const i = new Image();
      i.onload = function() {
        const s = i.width, a = i.height;
        URL.revokeObjectURL(i.src), r(s / a);
      }, i.src = URL.createObjectURL(n);
    }));
    return new Yn({ key: wg, value: [`${e}`] });
  }
  var n;
}
const wg = "KEY_IMG_ASPECT_RATIO", Sg = ls(null), bN = (t) => {
  const { sdk: n, channelUrl: e, stringSet: r, children: i } = t, { applicationId: s, botId: a } = $t(), { resetSession: o } = wa(), [l, c] = Ye(null), [u, d] = Ye(null), h = function(v, E = []) {
    const y = Mt(null), b = Mt(0), T = Mt(0), [w] = Ye(() => V_({ publishSynchronous: !0 })), [N, M] = Ye(!0);
    return hr(() => {
      b.current = 0, T.current = 0, M(!0), y.current && (y.current.scrollTop = y.current.scrollHeight);
    }, E), hr(() => {
      const I = [];
      return I.push(w.subscribe("scrollToBottom", ({ resolve: x, animated: R }) => {
        Xf(() => {
          y.current && (y.current.scroll ? y.current.scroll({ top: y.current.scrollHeight, behavior: Jf(v, R) }) : y.current.scrollTop = y.current.scrollHeight, T.current = 0, M(!0)), x && x();
        });
      })), I.push(w.subscribe("scroll", ({ top: x, animated: R, lazy: L, resolve: j }) => {
        Xf(() => {
          if (!y.current)
            return;
          const { scrollTop: P, scrollHeight: q, clientHeight: G } = y.current;
          y.current.scroll ? y.current.scroll({ top: x, behavior: Jf(v, R) }) : typeof x == "number" && (y.current.scrollTop = x), T.current = Math.max(0, q - P - G), M(T.current === 0), j && j();
        }, L);
      })), () => {
        I.forEach(({ remove: x }) => x());
      };
    }, [v]), { scrollRef: y, scrollPubSub: w, isScrollBottomReached: N, setIsScrollBottomReached: M, scrollDistanceFromBottomRef: T, scrollPositionRef: b };
  }("smooth"), p = () => setTimeout(() => h.scrollPubSub.publish("scrollToBottom", {}), 25), f = ((v) => {
    const { botStudioEditProps: E } = $t(), y = Mt(E == null ? void 0 : E.aiAttributes);
    return y.current = E == null ? void 0 : E.aiAttributes, { onBeforeSendMessage: async (b) => {
      const T = await yN(b);
      return y.current ? { ...b, metaArrays: T ? [T] : void 0, data: JSON.stringify({ ai_attrs: y.current }) } : { ...b, metaArrays: T ? [T] : void 0 };
    }, onAfterSendMessage: v.onScrollToBottom };
  })({ onScrollToBottom: p }), m = Ew(n, l, { shouldCountNewMessages: () => !1, onChannelDeleted: () => uh({ appId: s, botId: a }), onMessagesReceived: p, onMessagesUpdated: p });
  return Tt(() => {
    n != null && n.groupChannel && (c(null), d(null), n.groupChannel.getChannel(e).then(c).catch((v) => {
      v.code === me.NOT_FOUND_IN_DATABASE || v.code === me.NON_AUTHORIZED ? o() : d(r.ERR_CHANNEL_FETCH);
    }));
  }, [n, e]), u ? C.jsx(Id, { type: "error", label: u }) : C.jsx(EN, { channel: l, botUser: l == null ? void 0 : l.members.find((v) => v.userId === a), dataSource: m, scrollSource: h, handlers: f, ...t, children: i });
}, EN = (t) => C.jsx(Sg.Provider, { value: t, children: t.children }), gi = () => {
  const t = Mn(Sg);
  if (!t)
    throw new Error("useChatContext must be used within ChatProvider");
  return t;
};
var e0 = (t, n) => {
  const e = {};
  return Object.keys(t).filter(/* @__PURE__ */ ((r) => (i) => r.indexOf(i) === -1)(n)).forEach((r) => {
    e[r] = t[r];
  }), e;
}, CN = (t, n) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof t == "string" || typeof t == "number" && isFinite(t))
      return;
    const e = typeof t == "object" ? JSON.stringify(t) : String(t);
    console.warn(`An interpolation evaluated to '${e}' in the component '${n}', which is probably a mistake. You should explicitly cast or transform the value to a string.`);
  }
}, TN = 0;
function t0(t) {
  let n = "";
  return process.env.NODE_ENV === "test" && (n += "mocked-styled-" + TN++, t && t.__wyw_meta && t.__wyw_meta.className && (n += ` ${t.__wyw_meta.className}`)), (e) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Array.isArray(e))
      throw new Error('Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup');
    const r = (s, a) => {
      const { as: o = t, class: l = n } = s;
      var c;
      const u = function(h, p, f) {
        const m = e0(p, f);
        if (!h) {
          const v = typeof eo == "function" ? { default: eo } : eo;
          Object.keys(m).forEach((E) => {
            v.default(E) || delete m[E];
          });
        }
        return m;
      }(e.propsAsIs === void 0 ? !(typeof o == "string" && o.indexOf("-") === -1 && (c = o[0], c.toUpperCase() !== c)) : e.propsAsIs, s, ["as", "class"]);
      u.ref = a, u.className = e.atomic ? Hr(e.class, u.className || l) : Hr(u.className || l, e.class);
      const { vars: d } = e;
      if (d) {
        const h = {};
        for (const m in d) {
          const v = d[m], E = v[0], y = v[1] || "", b = typeof E == "function" ? E(s) : E;
          CN(b, e.name), h[`--${m}`] = `${b}${y}`;
        }
        const p = u.style || {}, f = Object.keys(p);
        f.length > 0 && f.forEach((m) => {
          h[m] = p[m];
        }), u.style = h;
      }
      return t.__wyw_meta && t !== o ? (u.as = o, Ot.createElement(t, u)) : Ot.createElement(o, u);
    }, i = Ot.forwardRef ? Ot.forwardRef(r) : (s) => {
      const a = e0(s, ["innerRef"]);
      return r(a, s.innerRef);
    };
    return i.displayName = e.name, i.__wyw_meta = { className: e.class || n, extends: t }, i;
  };
}
var Jr = process.env.NODE_ENV !== "production" ? new Proxy(t0, { get: (t, n) => t(n) }) : t0;
const Mr = "b1ngin29", _l = "l1r2p7v7", Qi = "s1rnpx54", n0 = { onbackground1: "var(--sb-on-bg-1)", onbackground2: "var(--sb-on-bg-2)", onbackground3: "var(--sb-on-bg-3)", onbackground4: "var(--sb-on-bg-4)", bg1: "var(--sb-bg-1)", bg2: "var(--sb-bg-2)", oncontent1: "var(--sb-on-content-1)", oncontent2: "var(--sb-on-content-2)", oncontent_inverse1: "var(--sb-on-content-inverse-1)", oncontent_inverse2: "var(--sb-on-content-inverse-2)", primary: "var(--sb-primary)", error: "var(--sb-error)", secondary: "var(--sb-secondary)" }, Oc = "t1l0bh5p", wN = { onbackground1: "o2rghjl", onbackground2: "obx56t6", onbackground3: "okii037", onbackground4: "o9tr1zi", oncontent1: "o1453q4k", oncontent2: "o1dji2o9", oncontent_inverse1: "os6jkon", oncontent_inverse2: "o1hnr2x6", primary: "pnb7eqn", error: "exizw35", secondary: "scn3xcb" }, r0 = { onbackground1: "o9sjx2z", onbackground2: "oe4tlqd", onbackground3: "o1jrs70d", onbackground4: "o1wrkj17", oncontent1: "ow1a4pz", primary: "p12t6ymf", error: "e4x69t1", secondary: "suj6j40" }, ji = ({ as: t, type: n, color: e, style: r, className: i, testId: s = "sendbird-label", ...a }) => {
  const o = t || "span", l = us({ testId: s }), c = n ? SN[n] : [], u = e ? wN[e] : void 0;
  return C.jsx(o, { className: Hr("sendbird-label", ...c, Oc, u, i), style: { color: e && !u ? e : void 0, ...r }, ...a, ...l });
}, SN = { h1: ["hsegrc9", Mr, _l], h2: ["h9hcnb3", Mr, _l], subtitle1: ["s1twe05c", Mr, _l], subtitle2: ["st3zlu2", Mr, _l], body1: ["b11b7tlq", Mr, Qi], body2: ["b1uip8mz", Mr, Qi], button1: ["btcnunh", Mr, Qi], button2: ["b33rbap", Mr, Qi], button3: ["b10vdy69", Mr, Qi], caption1: ["czxh5b7", Mr, Qi], caption2: ["c17lsiaj", Mr, Qi], caption3: ["c1pnb3s9", Mr, Qi] }, NN = (t) => Q.createElement("svg", { width: 12, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("path", { d: "M7.99994 8.94265L3.80463 13.138L2.86182 12.1952L7.05713 7.99984L2.86192 3.80463L3.80473 2.86182L7.99994 7.05703L12.1951 2.86182L13.138 3.80463L8.94275 7.99984L13.1381 12.1952L12.1952 13.138L7.99994 8.94265Z", fill: "#5E5E5E" })), IN = (t) => Q.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2H7.33333V3.33333L4.27613 3.33333L7.99999 7.05719L7.05718 8L3.33333 4.27616L3.33333 7.33333H2V2ZM14 14H8.66667V12.6667H11.7239L8.00001 8.94281L8.94282 8L12.6667 11.7238V8.66667H14V14Z", fill: "#5E5E5E" })), AN = (t) => Q.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.33348 7.3335L2.00015 7.3335L2.00015 6.00016H5.05735L1.3335 2.27631L2.27631 1.3335L6.00015 5.05734V2.00016L7.33348 2.00016L7.33348 7.3335ZM8.66683 8.66683H14.0002V10.0002L10.943 10.0002L14.6668 13.724L13.724 14.6668L10.0002 10.943V14.0002H8.66683L8.66683 8.66683Z", fill: "#5E5E5E" })), MN = (t) => Q.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0008 0.973633C10.6172 0.973633 9.49558 2.09527 9.49558 3.47888C9.49558 4.50705 10.115 5.39055 11.0009 5.77664V7.47887H13.0009V5.77653C13.8868 5.3904 14.5061 4.50696 14.5061 3.47888C14.5061 2.09527 13.3844 0.973633 12.0008 0.973633ZM0.250977 16.5788L0.250977 10.5789H2.25098L2.25098 16.5788H0.250977ZM21.7511 10.5789V16.5788H23.7511V10.5789H21.7511ZM18.251 7.47888H3.25097V18.9789C3.25097 20.3596 4.37026 21.4789 5.75097 21.4789H18.251C19.6317 21.4789 20.751 20.3596 20.751 18.9789V9.97887C20.751 8.59816 19.6317 7.47888 18.251 7.47888ZM9.78434 11.9539V15.2038C9.78434 15.7561 9.33663 16.2038 8.78434 16.2038C8.23206 16.2038 7.78434 15.7561 7.78434 15.2038V11.9539C7.78434 11.4016 8.23206 10.9539 8.78434 10.9539C9.33663 10.9539 9.78434 11.4016 9.78434 11.9539ZM16.2677 11.9539V15.2038C16.2677 15.7561 15.82 16.2038 15.2677 16.2038C14.7154 16.2038 14.2677 15.7561 14.2677 15.2038V11.9539C14.2677 11.4016 14.7154 10.9539 15.2677 10.9539C15.82 10.9539 16.2677 11.4016 16.2677 11.9539Z", fill: "#0D0D0D" })), xN = Jr("div")({ name: "FaviconContainer", class: "f1yzr738", propsAsIs: !1, vars: { "f1yzr738-0": [({ size: t }) => `${t}px`] } }), kN = Jr("img")({ name: "FaviconImage", class: "fyckcg3", propsAsIs: !1, vars: { "fyckcg3-0": [({ size: t }) => `${t}px`] } }), ON = Jr("span")({ name: "IconContainer", class: "i19bd47y", propsAsIs: !1, vars: { "i19bd47y-0": [({ size: t }) => `${t}px`], "i19bd47y-1": [({ backgroundColor: t }) => t] } }), RN = Jr(MN)({ name: "Icon", class: "i1whlko", propsAsIs: !0, vars: { "i1whlko-0": [({ fill: t }) => t] } });
function hh({ size: t }) {
  const n = Ro(), { botStudioEditProps: e } = $t(), { botUser: r } = gi(), { botInfo: i } = e ?? {}, s = (i == null ? void 0 : i.profileUrl) ?? (r == null ? void 0 : r.profileUrl);
  return s ? (a = s).length < 4 || !a.substring(a.lastIndexOf("/") + 1).startsWith("fav_") ? C.jsx("img", { src: s, style: { borderRadius: "50%", width: t, height: t }, alt: "bot profile" }) : C.jsx(xN, { size: t, children: C.jsx(kN, { size: t, src: s, alt: "bot profile" }) }) : C.jsx(ON, { size: t, backgroundColor: n.accentColor, children: C.jsx(RN, { fill: la(n.accentColor) }) });
  var a;
}
const DN = Ie.div`
  padding: 4px 6px;
  border: 1px solid #1870f3;
  border-radius: 100px;
  font-weight: 700;
  font-size: 11px;
  line-height: 12px;
  color: #1870f3;
`, LN = ({ fullscreen: t }) => {
  const { botStudioEditProps: n, isMobileView: e, enableWidgetExpandButton: r, betaMark: i, customBetaMarkText: s } = $t(), { sdk: a, channel: o, botUser: l, dataSource: c } = gi(), { setIsOpen: u } = $r(), { botInfo: d } = n ?? {}, h = (d == null ? void 0 : d.nickname) ?? (l == null ? void 0 : l.nickname), p = e ? 24 : 16, f = !t && !e;
  return C.jsxs("div", { className: jN, children: [C.jsx("div", { style: { marginRight: 6 }, children: C.jsx(hh, { size: 34 }) }), C.jsxs("div", { className: HN, children: [C.jsx(ji, { type: "h2", color: "onbackground1", className: BN, children: h || (o == null ? void 0 : o.name) }), !e && i && C.jsx(DN, { children: s })] }), C.jsxs("div", { className: zN, children: [C.jsx(UN, { size: p, onClick: async () => {
    a && o && (await Promise.allSettled([a.clearCachedMessages([o.url]), o.resetMyHistory()]), await c.refresh());
  } }), f && r && C.jsx(PN, { size: p }), C.jsx(FN, { size: p, onClick: () => {
    u(!1);
  } })] })] });
}, UN = ({ size: t, onClick: n }) => {
  const { customRefreshComponent: e } = $t(), r = Ro();
  return C.jsx(ph, { id: _i.refreshIcon, "aria-label": "refresh", onClick: () => {
    var i;
    n == null || n(), (i = e == null ? void 0 : e.onClick) == null || i.call(e);
  }, color: r.accentColor, children: C.jsx(e.icon, { style: e.style, width: e.width ?? t, height: e.height ?? t }) });
}, PN = ({ size: t }) => {
  const { isExpanded: n, setIsExpanded: e } = $r(), r = n ? AN : IN;
  return C.jsx(ph, { id: _i.expandIcon, "aria-label": "expand", onClick: () => e(!n), children: C.jsx(r, { width: t, height: t }) });
}, FN = ({ size: t, onClick: n }) => C.jsx(ph, { id: _i.closeIcon, "aria-label": "close", children: C.jsx(NN, { width: t, height: t, onClick: n }) }), jN = "c1scaw54", HN = "h1qojwix", BN = "t1hd16yr", zN = "b1q7vhqr", ph = Jr("button")({ name: "IconButton", class: "i1c5spiv", propsAsIs: !1, vars: { "i1c5spiv-0": [({ color: t }) => t ?? "#5E5E5E"] } }), VN = 10, GN = 15, Ll = "@", i0 = (t) => !!t && t.isFrozen && t.myRole !== "operator", s0 = (t) => !!t && t.myMutedState === "muted", a0 = (t, n) => {
  var e, r, i, s;
  return n && Array.isArray((r = (e = t == null ? void 0 : t.lastMessage) == null ? void 0 : e.extendedMessagePayload) == null ? void 0 : r.suggested_replies) && !!((s = (i = t == null ? void 0 : t.lastMessage) == null ? void 0 : i.extendedMessagePayload) != null && s.disable_chat_input);
}, Ng = (t) => t <= 1, o0 = (t) => t.some((n) => {
  var e;
  return !!n.messageForm && !n.messageForm.isSubmitted && !!((e = n.extendedMessagePayload) != null && e.disable_chat_input) && Ng(n.messageForm.version);
}), Ig = (t) => {
  if (t !== null)
    return typeof t == "number" ? `${t}px` : t;
};
function l0(t, n, e) {
  return `min(${n ?? e}, ${Ig(t) ?? e})`;
}
const qN = (t) => {
  const n = Mt(!1);
  return ((r) => {
    const [i, s] = Ye(!1);
    return hr(() => {
      const a = new IntersectionObserver((o) => {
        const [l] = o;
        l && s(l.isIntersecting);
      });
      return r.current && a.observe(r.current), () => a.disconnect();
    }, [r.current]), i;
  })(t) && (n.current = !0), n.current;
};
function c0(t = !1, n = null) {
  return t ? "50%" : Ig(n);
}
const Ei = ({ className: t = "", url: n, alt: e = "", width: r = null, maxSideLength: i = null, height: s = null, circle: a = !1, fixedSize: o = !1, placeHolder: l = null, defaultComponent: c = null, borderRadius: u = null, onLoad: d = Ur, onError: h = Ur, shadeOnHover: p, isUploaded: f = !0 }) => {
  const m = Mt(null), v = qN(m) ? n : null, [E, y] = Ye(!1), [b, T] = Ye(!0), [w, N] = function({ width: M, height: I, maxSideLength: x, defaultMinLength: R }) {
    return [sr(() => l0(M, x, R), [M]), sr(() => l0(I, x, R), [I])];
  }({ width: r, height: s, maxSideLength: i, defaultMinLength: "400px" });
  return w && N && C.jsxs("div", { ref: m, className: [...Array.isArray(t) ? t : [t], "sendbird-image-renderer"].join(" "), style: { width: "100%", minWidth: w, maxWidth: o ? w : "400px", height: N }, children: [b && (typeof l == "function" ? l({ style: { width: "100%", minWidth: w, maxWidth: o ? w : "400px", height: N, position: "absolute", display: "flex", justifyContent: "center", alignItems: "center" } }) : l), !v || E ? typeof c == "function" ? c() : c : (() => {
    const M = v ? { backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "cover", backgroundImage: `url(${v})` } : {};
    return C.jsx("div", { className: "sendbird-image-renderer__image", style: { width: "100%", minWidth: w, maxWidth: o ? w : "400px", height: N, position: "absolute", borderRadius: c0(a, u), ...M } });
  })(), p && C.jsx("div", { className: "sendbird-multiple-files-image-renderer__image-cover", style: { borderRadius: c0(a, u), ...f ? {} : { display: "inline-flex" } } }), v && C.jsx(KN, { src: v, alt: e, onLoadStart: () => {
    T(!0), y(!1);
  }, onLoad: () => {
    T(!1), y(!1), d();
  }, onError: () => {
    T(!1), y(!0), h();
  } })] });
}, KN = (t) => {
  const { src: n, alt: e, onLoadStart: r = Ur, onLoad: i = Ur, onError: s = Ur } = t, a = Mt({ currSrc: n, prevSrc: n, loadFailure: !1 });
  return a.current.currSrc !== n && (a.current.prevSrc = a.current.currSrc, a.current.currSrc = n), hr(() => {
    if (n) {
      const o = a.current.prevSrc !== a.current.currSrc, l = a.current.loadFailure;
      (o || l) && r();
    }
  }, [n, navigator.onLine]), C.jsx("img", { className: "sendbird-image-renderer__hidden-image-loader", src: n, alt: e, onLoad: () => {
    a.current.loadFailure = !1, i();
  }, onError: () => {
    a.current.loadFailure = !0, s();
  } });
}, pc = (t) => {
  if (typeof t == "number")
    return t;
  if (typeof t == "string") {
    const n = Number.parseFloat(t);
    if (!Number.isNaN(n))
      return n;
  }
  return NaN;
}, WN = (t) => {
  const { width: n, height: e, text: r } = t;
  let i = pc(n), s = pc(e);
  return typeof i != "number" || Number.isNaN(i) || (i *= 0.575), typeof s != "number" || Number.isNaN(s) || (s *= 0.575), C.jsx("div", { className: Li("sendbird-avatar-img--default", r && "text"), style: { width: n, height: e }, children: r ? C.jsx("div", { className: "sendbird-avatar-text", children: r }) : C.jsx(fi, { type: mi.USER, fillColor: Qr.CONTENT, width: i, height: s }) });
}, Ci = "sendbird-avatar-img", QN = ({ src: t = "", alt: n = "", height: e, width: r, customDefaultComponent: i }) => {
  const s = () => i ? i({ width: r, height: e }) : C.jsx(WN, { width: r, height: e });
  return typeof t == "string" ? C.jsx(Ei, { className: Ci, url: t, height: e, width: r, alt: n, defaultComponent: s }) : t && t.length ? t.length === 1 ? C.jsx(Ei, { className: Ci, url: t[0], height: e, width: r, alt: n, defaultComponent: s }) : t.length === 2 ? C.jsxs("div", { className: "sendbird-avatar--inner__two-child", children: [C.jsx(Ei, { className: Ci, url: t[0], height: e, width: r, alt: n, defaultComponent: s }), C.jsx(Ei, { className: Ci, url: t[1], height: e, width: r, alt: n, defaultComponent: s })] }) : t.length === 3 ? C.jsxs(C.Fragment, { children: [C.jsx("div", { className: "sendbird-avatar--inner__three-child--upper", children: C.jsx(Ei, { className: Ci, url: t[0], height: e, width: r, alt: n, defaultComponent: s }) }), C.jsxs("div", { className: "sendbird-avatar--inner__three-child--lower", children: [C.jsx(Ei, { className: Ci, url: t[1], height: e, width: r, alt: n, defaultComponent: s }), C.jsx(Ei, { className: Ci, url: t[2], height: e, width: r, alt: n, defaultComponent: s })] })] }) : C.jsx("div", { className: "sendbird-avatar--inner__four-child", children: t.slice(0, 4).map((a, o) => C.jsx(Ei, { className: Ci, url: a, height: e, width: r, alt: n, defaultComponent: s }, `${a}-${o}`)) }) : C.jsx(Ei, { className: Ci, url: "", height: e, width: r, alt: n, defaultComponent: s });
}, fh = Ot.forwardRef(function({ className: t = "", src: n = "", alt: e = "", width: r = "56px", height: i = "56px", zIndex: s = 0, left: a = "", bottom: o = "", onClick: l, customDefaultComponent: c }, u) {
  return C.jsx("div", { className: [...Array.isArray(t) ? t : [t], "sendbird-avatar"].join(" "), role: "button", ref: u, style: { height: i, width: r, zIndex: s, left: a, bottom: o }, onClick: l, onKeyDown: l, tabIndex: 0, children: C.jsx(QN, { src: n, width: r, height: i, alt: e, customDefaultComponent: c }) });
});
function YN(t) {
  const { member: n, isFocused: e = !1, parentScrollRef: r, onClick: i, onMouseOver: s, onMouseMove: a, renderUserMentionItem: o } = t, l = Mt(null), { stringSet: c } = Mn(Ta);
  return Tt(() => {
    e && (r == null ? void 0 : r.current) != null && (l == null ? void 0 : l.current) != null && (r.current.scrollTop >= l.current.offsetTop || r.current.scrollTop + r.current.clientHeight <= l.current.offsetTop) && l.current.scrollIntoView({ block: "nearest", inline: "nearest" });
  }, [e]), sr(() => {
    if (o)
      return C.jsx("div", { className: "sendbird-mention-suggest-list__user-item", onClick: (d) => i == null ? void 0 : i({ event: d, member: n, itemRef: l }), onMouseOver: (d) => s == null ? void 0 : s({ event: d, member: n, itemRef: l }), onMouseMove: (d) => a == null ? void 0 : a({ event: d, member: n, itemRef: l }), ref: l, children: o({ user: n }) }, (n == null ? void 0 : n.userId) || xo());
  }, [o]) || C.jsxs("div", { className: Li("sendbird-mention-suggest-list__user-item", e && "focused"), onClick: (d) => i == null ? void 0 : i({ event: d, member: n, itemRef: l }), onMouseOver: (d) => s == null ? void 0 : s({ event: d, member: n, itemRef: l }), onMouseMove: (d) => a == null ? void 0 : a({ event: d, member: n, itemRef: l }), ref: l, children: [C.jsx(fh, { className: "sendbird-mention-suggest-list__user-item__avatar", src: n == null ? void 0 : n.profileUrl, alt: "user-profile", width: "24px", height: "24px" }), C.jsx(En, { className: "sendbird-mention-suggest-list__user-item__nickname", testID: "sendbird-mention-suggest-list__user-item__nickname", type: Nn.SUBTITLE_2, color: n != null && n.nickname ? Cn.ONBACKGROUND_1 : Cn.ONBACKGROUND_3, children: (n == null ? void 0 : n.nickname) || (c == null ? void 0 : c.MENTION_NAME__NO_NAME) }), C.jsx(En, { className: "sendbird-mention-suggest-list__user-item__user-id", testID: "sendbird-mention-suggest-list__user-item__user-id", type: Nn.SUBTITLE_2, color: Cn.ONBACKGROUND_2, children: n == null ? void 0 : n.userId })] }, (n == null ? void 0 : n.userId) || xo());
}
const mh = "Enter", Ag = "ArrowUp", Mg = "ArrowDown", $N = "Backspace", Ad = { ElementNode: 1, TextNode: 3 }, ZN = "SPAN", XN = "BR", JN = "DIV";
async function eI(t, n, e, r) {
  return n.members.sort((i, s) => {
    var a;
    return (a = i.nickname) == null ? void 0 : a.localeCompare(s.nickname);
  }).filter((i) => {
    var s;
    return ((s = i.nickname) == null ? void 0 : s.toLowerCase().startsWith(r.toLowerCase())) && i.userId !== t && i.isActive;
  }).slice(0, e);
}
async function tI(t, n, e, r) {
  return n.createMemberListQuery({ limit: e + 1, nicknameStartsWithFilter: r }).next().then((i) => i.filter((s) => t !== (s == null ? void 0 : s.userId)).slice(0, e));
}
const nI = (t) => {
  var j, P, q;
  const { className: n, currentChannel: e, targetNickname: r = "", onUserItemClick: i, onFocusItemChange: s, onFetchUsers: a, renderUserMentionItem: o, inputEvent: l, ableAddMention: c = !0, maxMentionCount: u = VN, maxSuggestionCount: d = GN } = t, { config: h, stores: p } = Xr(), { logger: f } = h, m = ((q = (P = (j = p == null ? void 0 : p.sdkStore) == null ? void 0 : j.sdk) == null ? void 0 : P.currentUser) == null ? void 0 : q.userId) || "", v = Mt(null), { stringSet: E } = jo(), [y, b] = Ye(null), [T, w] = Ye(""), [N, M] = Ye(""), [I, x] = Ye(null), [R, L] = Ye([]);
  return Tt(() => {
    clearTimeout(y ?? void 0), b(setTimeout(() => {
      w(r);
    }, 300));
  }, [r]), Tt(() => {
    if ((l == null ? void 0 : l.key) === mh && I && R.length > 0 && (i == null || i(I)), (l == null ? void 0 : l.key) === Ag) {
      const G = R.findIndex((X) => (X == null ? void 0 : X.userId) === (I == null ? void 0 : I.userId));
      0 < G && (x(R[G - 1]), s == null || s(R[G - 1]));
    }
    if ((l == null ? void 0 : l.key) === Mg) {
      const G = R.findIndex((X) => (X == null ? void 0 : X.userId) === (I == null ? void 0 : I.userId));
      G < R.length - 1 && (x(R[G + 1]), s == null || s(R[G + 1]));
    }
  }, [l]), Tt(() => {
    if (!(N && T.indexOf(N) === 0 && R.length === 0)) {
      if (e != null && e.isSuper && !(e != null && e.createMemberListQuery))
        return void f.warning("SuggestedMentionList: Creating member list query failed");
      (e != null && e.isSuper ? tI : eI)(m, e, d, T.slice(1)).then((G) => {
        G.length < 1 ? f.info("SuggestedMentionList: Fetched member list is empty") : (f.info("SuggestedMentionList: Fetching member list succeeded", { memberList: G }), x(G[0])), M(T), a == null || a(G), L(G);
      }).catch((G) => {
        G && f.error("SuggestedMentionList: Fetching member list failed", G);
      });
    }
  }, [e == null ? void 0 : e.url, e == null ? void 0 : e.members.map((G) => G.nickname).join(), e == null ? void 0 : e.members.map((G) => G.isActive).join(), T, d, m, R.length, N]), c || R.length !== 0 ? C.jsxs("div", { className: Li("sendbird-mention-suggest-list", n), "data-testid": "sendbird-mention-suggest-list", ref: v, children: [c && (R == null ? void 0 : R.map((G) => C.jsx(YN, { member: G, isFocused: (G == null ? void 0 : G.userId) === (I == null ? void 0 : I.userId), parentScrollRef: v, onClick: ({ member: X }) => {
    i == null || i(X);
  }, onMouseOver: ({ member: X }) => {
    x(X);
  }, renderUserMentionItem: o }, (G == null ? void 0 : G.userId) || xo()))), !c && C.jsxs("div", { className: "sendbird-mention-suggest-list__notice-item", children: [C.jsx(fi, { className: "sendbird-mention-suggest-list__notice-item__icon", type: mi.INFO, fillColor: Qr.ON_BACKGROUND_2, width: "20px", height: "20px" }), C.jsx(En, { className: "sendbird-mention-suggest-list__notice-item__text", type: Nn.SUBTITLE_2, color: Cn.ONBACKGROUND_2, children: E.MENTION_COUNT__OVER_LIMIT.replace("%d", String(u)) })] })] }, "sendbird-mention-suggest-list") : null;
}, rI = (t) => C.jsx(nI, { ...t });
function u0(t) {
  if (t) {
    const n = t.querySelectorAll("[data-sb-mention='true']");
    return Array.from(n);
  }
  return [];
}
/*! @license DOMPurify 3.1.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.3/LICENSE */
const { entries: xg, setPrototypeOf: d0, isFrozen: iI, getPrototypeOf: sI, getOwnPropertyDescriptor: aI } = Object;
let { freeze: or, seal: Br, create: kg } = Object, { apply: Md, construct: xd } = typeof Reflect < "u" && Reflect;
or || (or = function(t) {
  return t;
}), Br || (Br = function(t) {
  return t;
}), Md || (Md = function(t, n, e) {
  return t.apply(n, e);
}), xd || (xd = function(t, n) {
  return new t(...n);
});
const gl = pr(Array.prototype.forEach), h0 = pr(Array.prototype.pop), Fa = pr(Array.prototype.push), Ul = pr(String.prototype.toLowerCase), Au = pr(String.prototype.toString), p0 = pr(String.prototype.match), ja = pr(String.prototype.replace), oI = pr(String.prototype.indexOf), lI = pr(String.prototype.trim), Kr = pr(Object.prototype.hasOwnProperty), Jn = pr(RegExp.prototype.test), Ha = (f0 = TypeError, function() {
  for (var t = arguments.length, n = new Array(t), e = 0; e < t; e++)
    n[e] = arguments[e];
  return xd(f0, n);
});
var f0;
const m0 = pr(Number.isNaN);
function pr(t) {
  return function(n) {
    for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++)
      r[i - 1] = arguments[i];
    return Md(t, n, r);
  };
}
function At(t, n) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ul;
  d0 && d0(t, null);
  let r = n.length;
  for (; r--; ) {
    let i = n[r];
    if (typeof i == "string") {
      const s = e(i);
      s !== i && (iI(n) || (n[r] = s), i = s);
    }
    t[i] = !0;
  }
  return t;
}
function cI(t) {
  for (let n = 0; n < t.length; n++)
    Kr(t, n) || (t[n] = null);
  return t;
}
function Cs(t) {
  const n = kg(null);
  for (const [e, r] of xg(t))
    Kr(t, e) && (Array.isArray(r) ? n[e] = cI(r) : r && typeof r == "object" && r.constructor === Object ? n[e] = Cs(r) : n[e] = r);
  return n;
}
function vl(t, n) {
  for (; t !== null; ) {
    const e = aI(t, n);
    if (e) {
      if (e.get)
        return pr(e.get);
      if (typeof e.value == "function")
        return pr(e.value);
    }
    t = sI(t);
  }
  return function() {
    return null;
  };
}
const _0 = or(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Mu = or(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), xu = or(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), uI = or(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ku = or(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), dI = or(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), g0 = or(["#text"]), v0 = or(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ou = or(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), y0 = or(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), yl = or(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), hI = Br(/\{\{[\w\W]*|[\w\W]*\}\}/gm), pI = Br(/<%[\w\W]*|[\w\W]*%>/gm), fI = Br(/\${[\w\W]*}/gm), mI = Br(/^data-[\-\w.\u00B7-\uFFFF]/), _I = Br(/^aria-[\-\w]+$/), Og = Br(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), gI = Br(/^(?:\w+script|data):/i), vI = Br(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), Rg = Br(/^html$/i), yI = Br(/^[a-z][.\w]*(-[.\w]+)+$/i);
var b0 = Object.freeze({ __proto__: null, MUSTACHE_EXPR: hI, ERB_EXPR: pI, TMPLIT_EXPR: fI, DATA_ATTR: mI, ARIA_ATTR: _I, IS_ALLOWED_URI: Og, IS_SCRIPT_OR_DATA: gI, ATTR_WHITESPACE: vI, DOCTYPE_NAME: Rg, CUSTOM_ELEMENT: yI });
const Ru = 1, bI = 3, EI = 7, CI = 8, TI = 9, wI = function() {
  return typeof window > "u" ? null : window;
};
var _h = function t() {
  let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : wI();
  const e = (U) => t(U);
  if (e.version = "3.1.3", e.removed = [], !n || !n.document || n.document.nodeType !== TI)
    return e.isSupported = !1, e;
  let { document: r } = n;
  const i = r, s = i.currentScript, { DocumentFragment: a, HTMLTemplateElement: o, Node: l, Element: c, NodeFilter: u, NamedNodeMap: d = n.NamedNodeMap || n.MozNamedAttrMap, HTMLFormElement: h, DOMParser: p, trustedTypes: f } = n, m = c.prototype, v = vl(m, "cloneNode"), E = vl(m, "nextSibling"), y = vl(m, "childNodes"), b = vl(m, "parentNode");
  if (typeof o == "function") {
    const U = r.createElement("template");
    U.content && U.content.ownerDocument && (r = U.content.ownerDocument);
  }
  let T, w = "";
  const { implementation: N, createNodeIterator: M, createDocumentFragment: I, getElementsByTagName: x } = r, { importNode: R } = i;
  let L = {};
  e.isSupported = typeof xg == "function" && typeof b == "function" && N && N.createHTMLDocument !== void 0;
  const { MUSTACHE_EXPR: j, ERB_EXPR: P, TMPLIT_EXPR: q, DATA_ATTR: G, ARIA_ATTR: X, IS_SCRIPT_OR_DATA: Ce, ATTR_WHITESPACE: Be, CUSTOM_ELEMENT: se } = b0;
  let { IS_ALLOWED_URI: Ee } = b0, ee = null;
  const ge = At({}, [..._0, ...Mu, ...xu, ...ku, ...g0]);
  let ve = null;
  const H = At({}, [...v0, ...Ou, ...y0, ...yl]);
  let oe = Object.seal(kg(null, { tagNameCheck: { writable: !0, configurable: !1, enumerable: !0, value: null }, attributeNameCheck: { writable: !0, configurable: !1, enumerable: !0, value: null }, allowCustomizedBuiltInElements: { writable: !0, configurable: !1, enumerable: !0, value: !1 } })), J = null, Me = null, V = !0, ie = !0, ae = !1, ce = !0, le = !1, re = !0, te = !1, Te = !1, ke = !1, he = !1, ye = !1, ze = !1, ot = !0, W = !1, xe = !0, be = !1, ue = {}, Se = null;
  const Fe = At({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let et = null;
  const je = At({}, ["audio", "video", "img", "source", "image", "track"]);
  let Xe = null;
  const Et = At({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), $e = "http://www.w3.org/1998/Math/MathML", Rt = "http://www.w3.org/2000/svg", xt = "http://www.w3.org/1999/xhtml";
  let Gt = xt, qt = !1, Xt = null;
  const z = At({}, [$e, Rt, xt], Au);
  let Ne = null;
  const Oe = ["application/xhtml+xml", "text/html"];
  let De = null, Ge = null;
  const st = r.createElement("form"), Je = function(U) {
    return U instanceof RegExp || U instanceof Function;
  }, He = function() {
    let U = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!Ge || Ge !== U) {
      if (U && typeof U == "object" || (U = {}), U = Cs(U), Ne = Oe.indexOf(U.PARSER_MEDIA_TYPE) === -1 ? "text/html" : U.PARSER_MEDIA_TYPE, De = Ne === "application/xhtml+xml" ? Au : Ul, ee = Kr(U, "ALLOWED_TAGS") ? At({}, U.ALLOWED_TAGS, De) : ge, ve = Kr(U, "ALLOWED_ATTR") ? At({}, U.ALLOWED_ATTR, De) : H, Xt = Kr(U, "ALLOWED_NAMESPACES") ? At({}, U.ALLOWED_NAMESPACES, Au) : z, Xe = Kr(U, "ADD_URI_SAFE_ATTR") ? At(Cs(Et), U.ADD_URI_SAFE_ATTR, De) : Et, et = Kr(U, "ADD_DATA_URI_TAGS") ? At(Cs(je), U.ADD_DATA_URI_TAGS, De) : je, Se = Kr(U, "FORBID_CONTENTS") ? At({}, U.FORBID_CONTENTS, De) : Fe, J = Kr(U, "FORBID_TAGS") ? At({}, U.FORBID_TAGS, De) : {}, Me = Kr(U, "FORBID_ATTR") ? At({}, U.FORBID_ATTR, De) : {}, ue = !!Kr(U, "USE_PROFILES") && U.USE_PROFILES, V = U.ALLOW_ARIA_ATTR !== !1, ie = U.ALLOW_DATA_ATTR !== !1, ae = U.ALLOW_UNKNOWN_PROTOCOLS || !1, ce = U.ALLOW_SELF_CLOSE_IN_ATTR !== !1, le = U.SAFE_FOR_TEMPLATES || !1, re = U.SAFE_FOR_XML !== !1, te = U.WHOLE_DOCUMENT || !1, he = U.RETURN_DOM || !1, ye = U.RETURN_DOM_FRAGMENT || !1, ze = U.RETURN_TRUSTED_TYPE || !1, ke = U.FORCE_BODY || !1, ot = U.SANITIZE_DOM !== !1, W = U.SANITIZE_NAMED_PROPS || !1, xe = U.KEEP_CONTENT !== !1, be = U.IN_PLACE || !1, Ee = U.ALLOWED_URI_REGEXP || Og, Gt = U.NAMESPACE || xt, oe = U.CUSTOM_ELEMENT_HANDLING || {}, U.CUSTOM_ELEMENT_HANDLING && Je(U.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (oe.tagNameCheck = U.CUSTOM_ELEMENT_HANDLING.tagNameCheck), U.CUSTOM_ELEMENT_HANDLING && Je(U.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (oe.attributeNameCheck = U.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), U.CUSTOM_ELEMENT_HANDLING && typeof U.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (oe.allowCustomizedBuiltInElements = U.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), le && (ie = !1), ye && (he = !0), ue && (ee = At({}, g0), ve = [], ue.html === !0 && (At(ee, _0), At(ve, v0)), ue.svg === !0 && (At(ee, Mu), At(ve, Ou), At(ve, yl)), ue.svgFilters === !0 && (At(ee, xu), At(ve, Ou), At(ve, yl)), ue.mathMl === !0 && (At(ee, ku), At(ve, y0), At(ve, yl))), U.ADD_TAGS && (ee === ge && (ee = Cs(ee)), At(ee, U.ADD_TAGS, De)), U.ADD_ATTR && (ve === H && (ve = Cs(ve)), At(ve, U.ADD_ATTR, De)), U.ADD_URI_SAFE_ATTR && At(Xe, U.ADD_URI_SAFE_ATTR, De), U.FORBID_CONTENTS && (Se === Fe && (Se = Cs(Se)), At(Se, U.FORBID_CONTENTS, De)), xe && (ee["#text"] = !0), te && At(ee, ["html", "head", "body"]), ee.table && (At(ee, ["tbody"]), delete J.tbody), U.TRUSTED_TYPES_POLICY) {
        if (typeof U.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Ha('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof U.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Ha('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        T = U.TRUSTED_TYPES_POLICY, w = T.createHTML("");
      } else
        T === void 0 && (T = function(Le, _e) {
          if (typeof Le != "object" || typeof Le.createPolicy != "function")
            return null;
          let ht = null;
          const Ve = "data-tt-policy-suffix";
          _e && _e.hasAttribute(Ve) && (ht = _e.getAttribute(Ve));
          const at = "dompurify" + (ht ? "#" + ht : "");
          try {
            return Le.createPolicy(at, { createHTML: (Nt) => Nt, createScriptURL: (Nt) => Nt });
          } catch {
            return console.warn("TrustedTypes policy " + at + " could not be created."), null;
          }
        }(f, s)), T !== null && typeof w == "string" && (w = T.createHTML(""));
      or && or(U), Ge = U;
    }
  }, lt = At({}, ["mi", "mo", "mn", "ms", "mtext"]), dt = At({}, ["foreignobject", "annotation-xml"]), qe = At({}, ["title", "style", "font", "a", "script"]), Ke = At({}, [...Mu, ...xu, ...uI]), ct = At({}, [...ku, ...dI]), nt = function(U) {
    Fa(e.removed, { element: U });
    try {
      U.parentNode.removeChild(U);
    } catch {
      U.remove();
    }
  }, ut = function(U, Le) {
    try {
      Fa(e.removed, { attribute: Le.getAttributeNode(U), from: Le });
    } catch {
      Fa(e.removed, { attribute: null, from: Le });
    }
    if (Le.removeAttribute(U), U === "is" && !ve[U])
      if (he || ye)
        try {
          nt(Le);
        } catch {
        }
      else
        try {
          Le.setAttribute(U, "");
        } catch {
        }
  }, ft = function(U) {
    let Le = null, _e = null;
    if (ke)
      U = "<remove></remove>" + U;
    else {
      const at = p0(U, /^[\r\n\t ]+/);
      _e = at && at[0];
    }
    Ne === "application/xhtml+xml" && Gt === xt && (U = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + U + "</body></html>");
    const ht = T ? T.createHTML(U) : U;
    if (Gt === xt)
      try {
        Le = new p().parseFromString(ht, Ne);
      } catch {
      }
    if (!Le || !Le.documentElement) {
      Le = N.createDocument(Gt, "template", null);
      try {
        Le.documentElement.innerHTML = qt ? w : ht;
      } catch {
      }
    }
    const Ve = Le.body || Le.documentElement;
    return U && _e && Ve.insertBefore(r.createTextNode(_e), Ve.childNodes[0] || null), Gt === xt ? x.call(Le, te ? "html" : "body")[0] : te ? Le.documentElement : Ve;
  }, un = function(U) {
    return M.call(U.ownerDocument || U, U, u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT | u.SHOW_PROCESSING_INSTRUCTION | u.SHOW_CDATA_SECTION, null);
  }, dn = function(U) {
    return U instanceof h && (U.__depth !== void 0 && typeof U.__depth != "number" || U.__removalCount !== void 0 && typeof U.__removalCount != "number" || typeof U.nodeName != "string" || typeof U.textContent != "string" || typeof U.removeChild != "function" || !(U.attributes instanceof d) || typeof U.removeAttribute != "function" || typeof U.setAttribute != "function" || typeof U.namespaceURI != "string" || typeof U.insertBefore != "function" || typeof U.hasChildNodes != "function");
  }, hn = function(U) {
    return typeof l == "function" && U instanceof l;
  }, Kt = function(U, Le, _e) {
    L[U] && gl(L[U], (ht) => {
      ht.call(e, Le, _e, Ge);
    });
  }, pn = function(U) {
    let Le = null;
    if (Kt("beforeSanitizeElements", U, null), dn(U))
      return nt(U), !0;
    const _e = De(U.nodeName);
    if (Kt("uponSanitizeElement", U, { tagName: _e, allowedTags: ee }), U.hasChildNodes() && !hn(U.firstElementChild) && Jn(/<[/\w]/g, U.innerHTML) && Jn(/<[/\w]/g, U.textContent) || U.nodeType === EI || re && U.nodeType === CI && Jn(/<[/\w]/g, U.data))
      return nt(U), !0;
    if (!ee[_e] || J[_e]) {
      if (!J[_e] && Tn(_e) && (oe.tagNameCheck instanceof RegExp && Jn(oe.tagNameCheck, _e) || oe.tagNameCheck instanceof Function && oe.tagNameCheck(_e)))
        return !1;
      if (xe && !Se[_e]) {
        const ht = b(U) || U.parentNode, Ve = y(U) || U.childNodes;
        if (Ve && ht)
          for (let at = Ve.length - 1; at >= 0; --at) {
            const Nt = v(Ve[at], !0);
            Nt.__removalCount = (U.__removalCount || 0) + 1, ht.insertBefore(Nt, E(U));
          }
      }
      return nt(U), !0;
    }
    return U instanceof c && !function(ht) {
      let Ve = b(ht);
      Ve && Ve.tagName || (Ve = { namespaceURI: Gt, tagName: "template" });
      const at = Ul(ht.tagName), Nt = Ul(Ve.tagName);
      return !!Xt[ht.namespaceURI] && (ht.namespaceURI === Rt ? Ve.namespaceURI === xt ? at === "svg" : Ve.namespaceURI === $e ? at === "svg" && (Nt === "annotation-xml" || lt[Nt]) : !!Ke[at] : ht.namespaceURI === $e ? Ve.namespaceURI === xt ? at === "math" : Ve.namespaceURI === Rt ? at === "math" && dt[Nt] : !!ct[at] : ht.namespaceURI === xt ? !(Ve.namespaceURI === Rt && !dt[Nt]) && !(Ve.namespaceURI === $e && !lt[Nt]) && !ct[at] && (qe[at] || !Ke[at]) : !(Ne !== "application/xhtml+xml" || !Xt[ht.namespaceURI]));
    }(U) ? (nt(U), !0) : _e !== "noscript" && _e !== "noembed" && _e !== "noframes" || !Jn(/<\/no(script|embed|frames)/i, U.innerHTML) ? (le && U.nodeType === bI && (Le = U.textContent, gl([j, P, q], (ht) => {
      Le = ja(Le, ht, " ");
    }), U.textContent !== Le && (Fa(e.removed, { element: U.cloneNode() }), U.textContent = Le)), Kt("afterSanitizeElements", U, null), !1) : (nt(U), !0);
  }, fn = function(U, Le, _e) {
    if (ot && (Le === "id" || Le === "name") && (_e in r || _e in st || _e === "__depth" || _e === "__removalCount"))
      return !1;
    if (!(ie && !Me[Le] && Jn(G, Le))) {
      if (!(V && Jn(X, Le))) {
        if (!ve[Le] || Me[Le]) {
          if (!(Tn(U) && (oe.tagNameCheck instanceof RegExp && Jn(oe.tagNameCheck, U) || oe.tagNameCheck instanceof Function && oe.tagNameCheck(U)) && (oe.attributeNameCheck instanceof RegExp && Jn(oe.attributeNameCheck, Le) || oe.attributeNameCheck instanceof Function && oe.attributeNameCheck(Le)) || Le === "is" && oe.allowCustomizedBuiltInElements && (oe.tagNameCheck instanceof RegExp && Jn(oe.tagNameCheck, _e) || oe.tagNameCheck instanceof Function && oe.tagNameCheck(_e))))
            return !1;
        } else if (!Xe[Le]) {
          if (!Jn(Ee, ja(_e, Be, ""))) {
            if ((Le !== "src" && Le !== "xlink:href" && Le !== "href" || U === "script" || oI(_e, "data:") !== 0 || !et[U]) && !(ae && !Jn(Ce, ja(_e, Be, "")))) {
              if (_e)
                return !1;
            }
          }
        }
      }
    }
    return !0;
  }, Tn = function(U) {
    return U !== "annotation-xml" && p0(U, se);
  }, mn = function(U) {
    Kt("beforeSanitizeAttributes", U, null);
    const { attributes: Le } = U;
    if (!Le)
      return;
    const _e = { attrName: "", attrValue: "", keepAttr: !0, allowedAttributes: ve };
    let ht = Le.length;
    for (; ht--; ) {
      const Ve = Le[ht], { name: at, namespaceURI: Nt, value: rn } = Ve, kt = De(at);
      let Dt = at === "value" ? rn : lI(rn);
      if (_e.attrName = kt, _e.attrValue = Dt, _e.keepAttr = !0, _e.forceKeepAttr = void 0, Kt("uponSanitizeAttribute", U, _e), Dt = _e.attrValue, _e.forceKeepAttr || (ut(at, U), !_e.keepAttr))
        continue;
      if (!ce && Jn(/\/>/i, Dt)) {
        ut(at, U);
        continue;
      }
      if (re && Jn(/((--!?|])>)|<\/(style|title)/i, Dt)) {
        ut(at, U);
        continue;
      }
      le && gl([j, P, q], (On) => {
        Dt = ja(Dt, On, " ");
      });
      const kn = De(U.nodeName);
      if (fn(kn, kt, Dt)) {
        if (!W || kt !== "id" && kt !== "name" || (ut(at, U), Dt = "user-content-" + Dt), T && typeof f == "object" && typeof f.getAttributeType == "function" && !Nt)
          switch (f.getAttributeType(kn, kt)) {
            case "TrustedHTML":
              Dt = T.createHTML(Dt);
              break;
            case "TrustedScriptURL":
              Dt = T.createScriptURL(Dt);
          }
        try {
          Nt ? U.setAttributeNS(Nt, at, Dt) : U.setAttribute(at, Dt), dn(U) ? nt(U) : h0(e.removed);
        } catch {
        }
      }
    }
    Kt("afterSanitizeAttributes", U, null);
  }, cn = function U(Le) {
    let _e = null;
    const ht = un(Le);
    for (Kt("beforeSanitizeShadowDOM", Le, null); _e = ht.nextNode(); ) {
      if (Kt("uponSanitizeShadowNode", _e, null), pn(_e))
        continue;
      const Ve = b(_e);
      _e.nodeType === Ru && (Ve && Ve.__depth ? _e.__depth = (_e.__removalCount || 0) + Ve.__depth + 1 : _e.__depth = 1), (_e.__depth >= 255 || _e.__depth < 0 || m0(_e.__depth)) && nt(_e), _e.content instanceof a && (_e.content.__depth = _e.__depth, U(_e.content)), mn(_e);
    }
    Kt("afterSanitizeShadowDOM", Le, null);
  };
  return e.sanitize = function(U) {
    let Le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _e = null, ht = null, Ve = null, at = null;
    if (qt = !U, qt && (U = "<!-->"), typeof U != "string" && !hn(U)) {
      if (typeof U.toString != "function")
        throw Ha("toString is not a function");
      if (typeof (U = U.toString()) != "string")
        throw Ha("dirty is not a string, aborting");
    }
    if (!e.isSupported)
      return U;
    if (Te || He(Le), e.removed = [], typeof U == "string" && (be = !1), be) {
      if (U.nodeName) {
        const kt = De(U.nodeName);
        if (!ee[kt] || J[kt])
          throw Ha("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (U instanceof l)
      _e = ft("<!---->"), ht = _e.ownerDocument.importNode(U, !0), ht.nodeType === Ru && ht.nodeName === "BODY" || ht.nodeName === "HTML" ? _e = ht : _e.appendChild(ht);
    else {
      if (!he && !le && !te && U.indexOf("<") === -1)
        return T && ze ? T.createHTML(U) : U;
      if (_e = ft(U), !_e)
        return he ? null : ze ? w : "";
    }
    _e && ke && nt(_e.firstChild);
    const Nt = un(be ? U : _e);
    for (; Ve = Nt.nextNode(); ) {
      if (pn(Ve))
        continue;
      const kt = b(Ve);
      Ve.nodeType === Ru && (kt && kt.__depth ? Ve.__depth = (Ve.__removalCount || 0) + kt.__depth + 1 : Ve.__depth = 1), (Ve.__depth >= 255 || Ve.__depth < 0 || m0(Ve.__depth)) && nt(Ve), Ve.content instanceof a && (Ve.content.__depth = Ve.__depth, cn(Ve.content)), mn(Ve);
    }
    if (be)
      return U;
    if (he) {
      if (ye)
        for (at = I.call(_e.ownerDocument); _e.firstChild; )
          at.appendChild(_e.firstChild);
      else
        at = _e;
      return (ve.shadowroot || ve.shadowrootmode) && (at = R.call(i, at, !0)), at;
    }
    let rn = te ? _e.outerHTML : _e.innerHTML;
    return te && ee["!doctype"] && _e.ownerDocument && _e.ownerDocument.doctype && _e.ownerDocument.doctype.name && Jn(Rg, _e.ownerDocument.doctype.name) && (rn = "<!DOCTYPE " + _e.ownerDocument.doctype.name + `>
` + rn), le && gl([j, P, q], (kt) => {
      rn = ja(rn, kt, " ");
    }), T && ze ? T.createHTML(rn) : rn;
  }, e.setConfig = function() {
    He(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}), Te = !0;
  }, e.clearConfig = function() {
    Ge = null, Te = !1;
  }, e.isValidAttribute = function(U, Le, _e) {
    Ge || He({});
    const ht = De(U), Ve = De(Le);
    return fn(ht, Ve, _e);
  }, e.addHook = function(U, Le) {
    typeof Le == "function" && (L[U] = L[U] || [], Fa(L[U], Le));
  }, e.removeHook = function(U) {
    if (L[U])
      return h0(L[U]);
  }, e.removeHooks = function(U) {
    L[U] && (L[U] = []);
  }, e.removeAllHooks = function() {
    L = {};
  }, e;
}();
const SI = "sendbird-mention-user-label";
function kd({ userId: t, nickname: n }) {
  const e = `<span data-userid="${t}" data-sb-mention="true" class="${SI}">${n}</span>`, r = _h(window).sanitize(e).split(" "), [i, ...s] = r;
  return [i, 'contenteditable="false"', ...s].join(" ");
}
const Eo = (t) => t == null ? void 0 : t.replace(/[\u00A0-\u9999<>]/gim, (n) => "".concat("&#", String(n.charCodeAt(0)), ";")), Od = (t) => t ? Array.from(t) : [];
function Du(t) {
  return t.nodeType === Ad.ElementNode;
}
function E0(t) {
  let n = "", e = "";
  return t.forEach((r) => {
    if (Du(r) && r.nodeName === ZN) {
      const { innerText: i, dataset: s = {} } = r, { userid: a = "" } = s;
      n += i, e += `${Ll}{${a}}`;
    } else if (Du(r) && r.nodeName === XN)
      n += `
`, e += `
`;
    else if (Du(r) && r.nodeName === JN) {
      const { textContent: i = "" } = r;
      n += `
${i}`, e += `
${i}`;
    } else {
      const { textContent: i = "" } = r;
      n += i, e += i;
    }
  }), { messageText: n, mentionTemplate: e };
}
const C0 = "sendbird-uikit__paste-node", Dg = "sendbird-word__mention", Lg = "sendbird-mention-user-label", T0 = `.${Dg}, .${Lg}`, NI = "sendbird-text-message-item-body", II = "sendbird-og-message-item-body__text-bubble";
function w0(t, n) {
  return [t, ...Array.from(t.querySelectorAll(n))].find((e) => e.matches(n));
}
const Ug = (t) => {
  let n = "";
  return t.forEach((e) => {
    const r = e.querySelectorAll(".sendbird-word");
    r.length > 1 ? n += Ug(Array.from(r)) + " " : n += e.innerText + " ";
  }), n;
};
function AI({ ref: t, setIsInput: n, setHeight: e, channel: r, setMentionedUsers: i, onPaste: s }) {
  return Nr((a) => {
    a.preventDefault();
    const o = Array.from(a.clipboardData.files);
    o.length > 0 && (s == null || s("file", o));
    const l = a.clipboardData.getData("text/html");
    if (!l) {
      const h = a.clipboardData.getData("text") || function(p) {
        const f = p.clipboardData.getData("text/uri-list");
        return f.length === 0 ? "" : f.split(`
`).reduce((m, v) => {
          const E = v.trim();
          return E === "" || E.startsWith("#") || (m += E + `
`), m;
        }, "");
      }(a);
      return document.execCommand("insertHTML", !1, Eo(h)), n(!0), void e();
    }
    const c = _h(window).sanitize(l), u = function() {
      const h = document.body.querySelector(`#${C0}`);
      h && (h == null || h.remove());
      const p = document.createElement("div");
      return p.id = C0, p.style.display = "none", p;
    }();
    if (u) {
      if (u.innerHTML = c, d = u, !(d != null && d.querySelector(T0))) {
        const f = Ug(Array.from(u.children));
        return document.execCommand("insertHTML", !1, Eo(f)), u.remove(), n(!0), void e();
      }
      const h = function(f) {
        return f == null ? void 0 : f.reduce((v, E) => {
          var T;
          let y, b = E == null ? void 0 : E.innerText;
          if (E instanceof Text && (y = !1, b = E.textContent ?? ""), E instanceof HTMLElement && (y = E.classList.contains(Dg) || E.classList.contains(Lg) ? E : E.querySelector(T0)), y) {
            const w = E == null ? void 0 : E.innerText, N = (T = y.dataset) == null ? void 0 : T.userid;
            return [...v, { text: w, userId: N }];
          }
          return [...v, { text: b }];
        }, []);
      }(function(f) {
        const m = w0(f, `.${II}`);
        if (m)
          return Od(m.childNodes);
        const v = w0(f, `.${NI}`);
        return Od(v ? v.childNodes : f.childNodes);
      }(u)), p = r.isGroupChannel() ? function(f, m) {
        const v = {}, E = m.members;
        return f.forEach((y) => {
          if (y.userId) {
            const b = E.find((T) => T.userId === y.userId);
            b && (v[y.userId] = b);
          }
        }), Object.values(v);
      }(h, r) : [];
      i(p), function(f) {
        const m = f.map((v) => {
          const { text: E, userId: y } = v;
          return y ? kd({ userId: y, nickname: E }) : Eo(E);
        }).join(" ").concat(" ");
        document.execCommand("insertHTML", !1, m);
      }(h), u.remove();
    }
    var d;
    n(!0), e();
  }, [t, n, e, r, i, s]);
}
const fc = "@", kr = { string: "string", mention: "mention", url: "url", undetermined: "undetermined" };
function MI({ tokens: t, mentionedUsers: n = [], templatePrefix: e = fc }) {
  if (!(n != null && n.length))
    return t;
  const r = function(i, s) {
    const a = s || fc;
    return RegExp(`(${i.map((o) => {
      const l = o.userId.replace(/([.*+?^${}()|[\]\\])/g, "\\$1");
      return `${a}\\{${l}\\}`;
    }).join("|")})`, "g");
  }(n, e);
  return t.map((i) => {
    if (i.type !== kr.undetermined)
      return i;
    const { value: s } = i;
    return s.split(r).map((a) => {
      if (a.match(r)) {
        const o = n.find((l) => `@{${l == null ? void 0 : l.userId}}` === a);
        return { value: (o == null ? void 0 : o.nickname) || "(No name)", type: kr.mention, userId: o == null ? void 0 : o.userId };
      }
      return { value: a, type: kr.undetermined };
    });
  }).flat();
}
function xI({ messageText: t, mentionedUsers: n = [], templatePrefix: e = fc }) {
  return function(i) {
    const s = /(?:https?:\/\/|www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.(xn--)?[a-z]{2,20}\b([-a-zA-Z0-9@:%_+[\],.~#?&/=]*[-a-zA-Z0-9@:%_+~#?&/=])*/g;
    return i.map((o) => {
      if (o.type !== kr.undetermined)
        return o;
      const { value: l = "" } = o, c = Array.from(l.matchAll(s)).map((h) => {
        const p = h[0], f = h.index ?? 0;
        return { text: p, start: f, end: f + p.length };
      }), u = [{ value: l, type: kr.string }];
      let d = 0;
      return c.forEach(({ text: h, start: p, end: f }) => {
        const m = u.pop().value, v = m.slice(0, p - d), E = h, y = m.slice(f - d);
        v.length > 0 && u.push({ value: v, type: kr.string }), u.push({ value: E, type: kr.url }), y.length > 0 && u.push({ value: y, type: kr.string }), d = f;
      }), u;
    }).flat();
  }(MI({ tokens: [{ type: kr.undetermined, value: t }], mentionedUsers: n, templatePrefix: e })).reduce((i, s) => {
    const a = i[i.length - 1];
    return (a == null ? void 0 : a.type) === kr.string && s.type === kr.string ? (a.value = `${a.value}${s.value}`, i) : [...i, s];
  }, []);
}
function kI({ accept: t, multiple: n, disabled: e, onLimitReached: r }) {
  const [i, s] = Ye([]), [a, o] = Ye(), l = Mt(null), c = Nr((d) => {
    const h = d.filter((p) => !t || t.includes(p.type));
    h.length !== 0 && (!n && h.length > 1 || !n && h.length > 0 && i.length > 0 ? r == null || r() : s((p) => [...p, ...h.map((f) => ({ file: f, preview: { url: URL.createObjectURL(f), type: f.type, name: f.name } }))]));
  }, [t, i, n, r]), u = () => {
    s(() => (i.forEach((d) => URL.revokeObjectURL(d.preview.url)), [])), o(void 0);
  };
  return { files: i, addFiles: c, clearFiles: u, renderFileButton: () => C.jsxs(ah, { className: "sendbird-message-input--attach", height: "32px", width: "32px", onClick: () => {
    var d;
    u(), (d = l.current) == null || d.click();
  }, children: [C.jsx(fi, { type: mi.ATTACH, fillColor: e ? Qr.ON_BACKGROUND_4 : Qr.ON_BACKGROUND_2, width: "16px", height: "16px" }), C.jsx("input", { className: "sendbird-message-input--attach-input", type: "file", ref: l, onChange: (d) => {
    const h = d.currentTarget.files;
    h && c(Array.from(h)), d.target.value = "";
  }, accept: t, multiple: n })] }), renderFilePreview: () => i.length === 0 ? null : C.jsx("div", { className: "sendbird-message-input--file-preview", children: i.map(({ preview: d }, h) => C.jsxs("div", { className: "sendbird-message-input--file", onMouseOver: () => o(h), onMouseLeave: () => o(void 0), children: [a === h && C.jsx("span", { onClick: () => {
    return p = h, s((f) => f.filter((m, v) => v !== p && (URL.revokeObjectURL(m.preview.url), !0))), void o(void 0);
    var p;
  }, style: { display: "flex", position: "absolute", insetInlineEnd: -8, insetBlockStart: -8, cursor: "pointer" }, children: C.jsx(OI, {}) }), d.type.startsWith("image/") ? C.jsx("img", { className: "image", alt: "file-image", src: d.url }) : d.type.startsWith("application/pdf") ? C.jsxs("div", { className: "pdf", children: [C.jsx("div", { className: "pdf-icon", children: C.jsx(fi, { type: mi.FILE_DOCUMENT, width: "24px", height: "24px" }) }), C.jsxs("div", { className: "pdf-info", children: [C.jsx(En, { type: "BUTTON_1", className: "pdf-name", title: d.name, children: d.name }), C.jsx(En, { type: "CAPTION_3", className: "pdf-type", children: "PDF" })] })] }) : void 0] }, d.url)) }) };
}
const OI = () => C.jsx("div", { className: "sendbird-message-input--file-remove", title: "Remove file", children: C.jsx(fi, { type: mi.REMOVE, width: "22px", height: "22px" }) }), fr = () => null, Lu = (t) => {
  t && t.current && (t.current.innerHTML = "");
}, S0 = { targetString: "", startNodeIndex: null, startOffsetIndex: null, endNodeIndex: null, endOffsetIndex: null }, RI = Ot.forwardRef((t, n) => {
  var he, ye, ze, ot;
  const { channel: e, className: r = "", messageFieldId: i = "", isEdit: s = !1, isMobile: a = !1, isMentionEnabled: o = !1, disabled: l = !1, message: c = null, placeholder: u = "", maxLength: d = 5e3, onFileUpload: h = fr, onSendMessage: p = fr, onUpdateMessage: f = fr, onCancelEdit: m = fr, onStartTyping: v = fr, channelUrl: E = "", mentionSelectedUser: y = null, onUserMentioned: b = fr, onMentionStringChange: T = fr, onMentionedUserIdsUpdated: w = fr, onKeyUp: N = fr, onKeyDown: M = fr, renderFileUploadIcon: I = fr, renderSendMessageIcon: x = fr, setMentionedUsers: R = fr, acceptableMimeTypes: L, onFileLimitError: j } = t, P = n && "current" in n ? n : null, q = Mt(null), G = i || "sendbird-message-input-text-field", { stringSet: X } = jo(), { config: Ce } = Xr(), Be = (({ channel: W, config: xe }) => Fo(W == null ? void 0 : W.channelType).with("group", () => {
    var be;
    return (be = xe == null ? void 0 : xe.groupChannel) == null ? void 0 : be.enableDocument;
  }).with("open", () => {
    var be;
    return (be = xe == null ? void 0 : xe.openChannel) == null ? void 0 : be.enableDocument;
  }).otherwise(() => !0))({ channel: e, config: Ce }), { files: se, addFiles: Ee, clearFiles: ee, renderFileButton: ge, renderFilePreview: ve } = kI({ disabled: l, accept: Gw(L), multiple: !1, onLimitReached: j }), [H, oe] = Ye(!1), [J, Me] = Ye([]), [V, ie] = Ye({ ...S0 }), ae = Nr(() => {
    const W = P == null ? void 0 : P.current;
    if (W)
      try {
        40 < W.scrollHeight ? (W.style.height = "auto", W.style.height = `${W.scrollHeight}px`) : W.style.height = "";
      } catch {
      }
  }, []), ce = t == null ? void 0 : t.value;
  Tt(() => {
    const W = P == null ? void 0 : P.current;
    try {
      W && ce && (W.innerHTML = ce, ((xe, be) => {
        const ue = document.createRange(), Se = window.getSelection();
        ue.setStart(xe.childNodes[0], be), ue.collapse(!0), Se == null || Se.removeAllRanges(), Se == null || Se.addRange(ue), xe.focus();
      })(W, ce == null ? void 0 : ce.length));
    } catch {
    }
    Me([]), oe(!!(W != null && W.textContent) && W.textContent.trim().length > 0), ae();
  }, [ce]), Tt(() => {
    s || (oe(!1), Lu(P));
  }, [E]), Tt(() => {
    var W;
    if (s && (c != null && c.messageId)) {
      const xe = P == null ? void 0 : P.current;
      if (o && (c != null && c.mentionedUsers) && c.mentionedUsers.length > 0 && (c != null && c.mentionedMessageTemplate) && c.mentionedMessageTemplate.length > 0) {
        const { mentionedUsers: be = [] } = c, ue = xI({ messageText: c == null ? void 0 : c.mentionedMessageTemplate, mentionedUsers: be });
        xe && (xe.innerHTML = ue.map((Se) => {
          if (Se.type === kr.mention) {
            const Fe = be.find((je) => je.userId === Se.userId), et = `${fc}${(Fe == null ? void 0 : Fe.nickname) || Se.value || X.MENTION_NAME__NO_NAME}`;
            return kd({ userId: Se.userId, nickname: et });
          }
          return Eo(Se.value);
        }).join(""));
      } else {
        try {
          xe && (xe.innerHTML = Eo(c == null ? void 0 : c.message) ?? "");
        } catch {
        }
        Me([]);
      }
      oe(!!(xe != null && xe.textContent) && ((W = xe == null ? void 0 : xe.textContent) == null ? void 0 : W.trim().length) > 0), ae();
    }
  }, [s, c]);
  const le = Nr(() => {
    var xe;
    const W = P == null ? void 0 : P.current;
    if (o && W) {
      const be = Array.from(W.getElementsByClassName("sendbird-mention-user-label")).map((ue) => {
        var Se;
        return (Se = ue == null ? void 0 : ue.dataset) == null ? void 0 : Se.userid;
      });
      ((ue, Se) => {
        if (Array.isArray(ue) && Array.isArray(Se) && ue.length === Se.length) {
          for (let Fe = 0; Fe < ue.length; Fe++)
            if (ue[Fe] !== Se[Fe])
              return !1;
          return !0;
        }
        return !1;
      })(J, be) && be.length !== 0 || (w(be), Me(be));
    }
    oe(!!(W != null && W.textContent) && ((xe = W.textContent) == null ? void 0 : xe.trim().length) > 0);
  }, [V, o]);
  Tt(() => {
    var W, xe;
    if (o && y) {
      const { targetString: be, startNodeIndex: ue, startOffsetIndex: Se, endNodeIndex: Fe, endOffsetIndex: et } = V, je = P == null ? void 0 : P.current;
      if (be && ue !== null && Se !== null && et !== null && Fe !== null && je) {
        const Xe = Od(je == null ? void 0 : je.childNodes), Et = ((W = Xe[ue]) == null ? void 0 : W.textContent) ?? "", $e = document.createTextNode(Et.slice(0, Se)), Rt = ((xe = Xe[Fe]) == null ? void 0 : xe.textContent) ?? "", xt = et && document.createTextNode(` ${Rt.slice(et)}`), Gt = kd({ userId: y == null ? void 0 : y.userId, nickname: `${Ll}${(y == null ? void 0 : y.nickname) || X.MENTION_NAME__NO_NAME}` }), qt = document.createElement("div");
        qt.innerHTML = Gt;
        const Xt = [...Xe.slice(0, ue), $e, qt.childNodes[0], xt, ...Xe.slice(Fe + 1)];
        if (je && (je.innerHTML = "", Xt.forEach((z) => {
          z && je.appendChild(z);
        })), b(y), window.getSelection || document.getSelection) {
          const z = window.getSelection() || document.getSelection();
          z == null || z.removeAllRanges();
          const Ne = new Range();
          Ne.selectNodeContents(je), Ne.setStart(je.childNodes[ue + 2], 1), Ne.setEnd(je.childNodes[ue + 2], 1), Ne.collapse(!1), z == null || z.addRange(Ne), je.focus();
        }
        ie({ ...S0 }), ae(), le();
      }
    }
  }, [y, o]);
  const re = Nr(() => {
    var be, ue;
    const W = ((be = window == null ? void 0 : window.getSelection) == null ? void 0 : be.call(window)) || ((ue = document == null ? void 0 : document.getSelection) == null ? void 0 : ue.call(document)), xe = P == null ? void 0 : P.current;
    if ((W == null ? void 0 : W.anchorNode) === xe && T(""), o && xe && W && W.anchorNode === W.focusNode && W.anchorOffset === W.focusOffset) {
      let Se = "", Fe = null, et = null;
      for (let je = 0; je < xe.childNodes.length; je += 1) {
        const Xe = xe.childNodes[je];
        if (Xe.nodeType === Ad.TextNode) {
          const Et = Xe === W.anchorNode ? Xe != null && Xe.textContent ? Xe == null ? void 0 : Xe.textContent.slice(0, W.anchorOffset) : "" : (Xe == null ? void 0 : Xe.textContent) ?? "";
          if (Se.length > 0)
            Se += Et;
          else {
            let $e = Et.lastIndexOf(Ll);
            for (let Rt = $e - 1; Rt > -1 && Et[Rt] === Ll; Rt -= 1)
              $e = Rt;
            $e > -1 && (Se = Et, Fe = je, et = $e);
          }
        } else
          Se = "", Fe = null, et = null;
        if (Xe === W.anchorNode) {
          const Et = Se && et !== null ? Se.slice(et) : "";
          return ie({ targetString: Et, startNodeIndex: Fe, startOffsetIndex: et, endNodeIndex: je, endOffsetIndex: W.anchorOffset }), void T(Et);
        }
      }
    }
  }, [o]), te = () => {
    var et;
    if (s)
      return;
    const W = P == null ? void 0 : P.current, xe = se.length > 0, be = ((et = W == null ? void 0 : W.textContent) == null ? void 0 : et.length) > 0, { messageText: ue = "", mentionTemplate: Se } = E0(W.childNodes), Fe = { message: ue, mentionTemplate: Se };
    if (xe)
      h(se.map((je) => je.file), Fe);
    else {
      if (!be)
        return;
      p(Fe);
    }
    ee(), Lu(P), xf(navigator.userAgent) ? (q.current && q.current.focus(), requestAnimationFrame(() => W.focus())) : W.focus(), oe(!1), ae();
  }, Te = !((ye = (he = P == null ? void 0 : P.current) == null ? void 0 : he.textContent) != null && ye.trim()), ke = AI({ ref: P, setMentionedUsers: R, channel: e, setIsInput: oe, setHeight: ae, onPaste: (W, xe) => {
    W === "file" && Ee(xe);
  } });
  return (({ onDropFiles: W }) => {
    const { subscribe: xe } = Mn(dh);
    Tt(() => xe(W), [W]);
  })({ onDropFiles: (W) => {
    Ee(W);
  } }), C.jsxs("form", { className: Li(...Array.isArray(r) ? r : [r], s && "sendbird-message-input__edit", l && "sendbird-message-input-form__disabled"), children: [C.jsxs("div", { className: Li("sendbird-message-input", l && "sendbird-message-input__disabled"), "data-testid": "sendbird-message-input", children: [C.jsxs("div", { className: "sendbird-message-input--area", children: [ve(), C.jsxs("div", { style: { position: "relative" }, children: [xf(navigator.userAgent) && C.jsx("input", { id: "ghost-input-reset-ime-cjk", ref: q, style: { opacity: 0, padding: 0, margin: 0, height: 0, border: "none", position: "absolute", top: -9999 }, defaultValue: "_" }), C.jsx("div", { id: `${G}${s ? c == null ? void 0 : c.messageId : ""}`, className: `sendbird-message-input--textarea ${G}`, style: { paddingInlineEnd: 12 + (se.length > 0 ? 0 : 40) }, contentEditable: !l, role: "textbox", "aria-label": "Text Input", ref: n, disabled: l, maxLength: d, onKeyDown: (W) => {
    var xe, be, ue, Se;
    M(W) ? W.preventDefault() : (!W.shiftKey && W.key === mh && !a && ((xe = P == null ? void 0 : P.current) != null && xe.textContent) && P.current.textContent.trim().length > 0 && ((be = W == null ? void 0 : W.nativeEvent) == null ? void 0 : be.isComposing) !== !0 && (W.preventDefault(), te()), W.key !== $N || ((Se = (ue = P == null ? void 0 : P.current) == null ? void 0 : ue.childNodes) == null ? void 0 : Se.length) !== 2 || P.current.childNodes[0].textContent || P.current.childNodes[1].nodeType !== Ad.ElementNode || P.current.removeChild(P.current.childNodes[1]));
  }, onKeyUp: (W) => {
    N(W) ? W.preventDefault() : re();
  }, onClick: () => {
    re();
  }, onInput: () => {
    var W;
    ae(), v(), oe(!!((W = P == null ? void 0 : P.current) != null && W.textContent) && P.current.textContent.trim().length > 0), le();
  }, onPaste: ke }), (((ot = (ze = P == null ? void 0 : P.current) == null ? void 0 : ze.textContent) == null ? void 0 : ot.length) ?? 0) === 0 && C.jsx(En, { className: "sendbird-message-input--placeholder", type: Nn.BODY_1, color: l ? Cn.ONBACKGROUND_4 : Cn.ONBACKGROUND_3, children: u || X.MESSAGE_INPUT__PLACE_HOLDER })] }), !s && se.length === 0 && ((I == null ? void 0 : I()) || Be && ge())] }), !s && (H || se.length > 0) && C.jsx(ah, { className: "sendbird-message-input--send", height: "32px", width: "32px", onClick: () => te(), testID: "sendbird-message-input-send-button", children: (x == null ? void 0 : x()) || C.jsx(fi, { type: mi.SEND, fillColor: l ? Qr.ON_BACKGROUND_4 : Qr.PRIMARY, width: "20px", height: "20px" }) })] }), s && C.jsxs("div", { className: "sendbird-message-input--edit-action", "data-testid": "sendbird-message-input--edit-action", children: [C.jsx(Ui, { className: "sendbird-message-input--edit-action__cancel", type: Un.SECONDARY, size: ba.SMALL, onClick: m, children: X.BUTTON__CANCEL }), C.jsx(Ui, { className: "sendbird-message-input--edit-action__save", type: Un.PRIMARY, size: ba.SMALL, disabled: Te, onClick: () => (() => {
    const W = P == null ? void 0 : P.current, xe = c == null ? void 0 : c.messageId;
    if (s && xe && W) {
      const { messageText: be, mentionTemplate: ue } = E0(W.childNodes);
      f({ messageId: xe, message: be, mentionTemplate: ue }), Lu(P);
    }
  })(), children: X.BUTTON__SAVE })] })] });
}), DI = async ({ files: t, logger: n, imageCompression: e }) => {
  const { compressionRate: r, outputFormat: i = "preserve" } = e, s = e.resizingWidth ? pc(e.resizingWidth) : void 0, a = e.resizingHeight ? pc(e.resizingHeight) : void 0, o = { failedIndexes: [], compressedFiles: [] };
  return Array.isArray(t) && t.length > 0 ? !r || r < 0 || 1 < r ? (n == null || n.warning("utils - compressImages: The compressionRate is not acceptable.", r), o) : (await Promise.all(t.map(async (l, c) => {
    if (l.type !== "image/jpg" && l.type !== "image/png" && l.type !== "image/jpeg")
      return n == null || n.warning("utils - compressImages: The fileType is not compressible.", { file: l, index: c }), o.failedIndexes.push(c), void o.compressedFiles.push(l);
    try {
      const u = await (({ imageFile: d, compressionRate: h, resizingWidth: p, resizingHeight: f, outputFormat: m }) => {
        const v = document.createElement("img");
        return new Promise((E, y) => {
          v.src = URL.createObjectURL(d), v.onerror = y, v.onload = () => {
            URL.revokeObjectURL(v.src);
            const b = document.createElement("canvas"), T = v.width, w = v.height;
            let N = !p || p > T ? T : p, M = !f || f > w ? w : f;
            const I = T / N, x = w / M;
            I > x ? M = w / (p ? I : 1) : x > I && (N = T / (f ? x : 1)), b.width = N, b.height = M;
            const R = b.getContext("2d");
            if (!R)
              return void y(new Error("Failed to get canvas 2d context"));
            R.drawImage(v, 0, 0, N, M);
            const L = m === "preserve" ? d.type : `image/${m}`, j = L.split("/").pop(), P = d.name.lastIndexOf("."), q = `${P === -1 ? d.name : d.name.substring(0, P)}.${j}`;
            R.canvas.toBlob((G) => {
              if (G) {
                const X = new File([G], q, { type: L });
                E(X);
              } else
                y(new Error("Failed to compress image"));
            }, L, h);
          };
        });
      })({ imageFile: l, compressionRate: r, resizingWidth: s, resizingHeight: a, outputFormat: i });
      o.compressedFiles.push(u);
    } catch (u) {
      o.compressedFiles.push(l), o.failedIndexes.push(c), n == null || n.warning("utils - compressImages: Failed to compress image file", { file: l, err: u });
    }
  })), n == null || n.info("utils - compressImages: Finished compressing images", o), o) : (n == null || n.warning("utils - compressImages: There are no files.", t), o);
}, LI = ({ sendFileMessage: t, sendMultipleFilesMessage: n, quoteMessage: e }, { logger: r }) => {
  const { stringSet: i } = jo(), { config: s } = Xr(), { imageCompression: a } = s, o = s == null ? void 0 : s.uikitUploadSizeLimit, l = s == null ? void 0 : s.uikitMultipleFilesMessageLimit, { openModal: c } = Mn(sg);
  return Nr(async (u, d) => {
    if (u.length === 0)
      return void r.warning("Channel|useHandleUploadFiles: given file list is empty.", { files: u });
    if (u.length > l)
      return r.info(`Channel|useHandleUploadFiles: Cannot upload files more than ${l}`), void c({ modalProps: { titleText: i.FILE_UPLOAD_NOTIFICATION__COUNT_LIMIT.replace("%d", `${o}`), hideFooter: !0 }, childElement: ({ closeModal: f }) => C.jsx(Nd, { type: Un.PRIMARY, submitText: i.BUTTON__OK, hideCancelButton: !0, onCancel: f, onSubmit: f }) });
    if (u.some((f) => f.size > o))
      return r.info(`Channel|useHandleUploadFiles: Cannot upload file size exceeding ${o}`), void c({ modalProps: { titleText: i.FILE_UPLOAD_NOTIFICATION__SIZE_LIMIT.replace("%d", `${Math.floor(o / 1048576)}`), hideFooter: !0 }, childElement: ({ closeModal: m }) => C.jsx(Nd, { type: Un.PRIMARY, submitText: i.BUTTON__OK, hideCancelButton: !0, onCancel: m, onSubmit: m }) });
    const { compressedFiles: h } = await DI({ files: u, imageCompression: a, logger: r }), p = h;
    if (p.length === 1) {
      r.info("Channel|useHandleUploadFiles: sending one file.");
      const [f] = p;
      return t({ ...d, file: f, parentMessageId: e == null ? void 0 : e.messageId });
    }
    if (p.length > 1) {
      r.info("Channel|useHandleUploadFiles: sending multiple files.");
      const f = [], m = [];
      return p.forEach((v) => {
        Ic(v.type) ? f.push(v) : m.push(v);
      }), m.reduce((v, E) => v.then(() => t({ ...d, file: E, parentMessageId: e == null ? void 0 : e.messageId })), f.length === 0 ? Promise.resolve() : f.length === 1 ? t({ ...d, file: f[0] }) : n == null ? void 0 : n({ ...d, fileInfoList: f.map((v) => ({ file: v, fileName: v.name, fileSize: v.size, mimeType: v.type })), parentMessageId: e == null ? void 0 : e.messageId }));
    }
  }, [t, n, e]);
}, UI = Ot.forwardRef((t, n) => {
  const { currentChannel: e, messages: r, loading: i, messageInputRef: s, sendUserMessage: a, sendFileMessage: o, renderUserMentionItem: l, renderFileUploadIcon: c, renderSendMessageIcon: u, acceptableMimeTypes: d = ["application/pdf", "image/jpeg", "image/jpg", "image/png"], disabled: h, onFileLimitError: p } = t, { stringSet: f } = jo(), { isMobile: m } = Mc(), { stores: v, config: E } = Xr(), { isOnline: y, userMention: b, logger: T, groupChannel: w } = E, N = v.sdkStore.sdk, { maxMentionCount: M, maxSuggestionCount: I } = b, x = e == null ? void 0 : e.isBroadcast, R = w.enableMention, [L, j] = Ye(""), [P, q] = Ye([]), [G, X] = Ye([]), [Ce, Be] = Ye(null), [se, Ee] = Ye([]), [ee, ge] = Ye(null), ve = i || !e || !N || !N.isCacheEnabled && !y || i0(e) || s0(e) || a0(e, E.groupChannel.enableSuggestedReplies) || o0(r) || h, H = !ve && R && L.length > 0 && !x, oe = function({ ref: V }, { logger: ie }) {
    const ae = V.current, [ce, le] = Ye([]);
    return hr(() => {
      if (ae) {
        const re = u0(ae);
        le(re);
      }
    }, [ae]), Tt(() => {
      const re = { childList: !0, subtree: !0 }, te = new MutationObserver((Te) => {
        Te.length > 0 && le(u0(ae));
      });
      return ae && te.observe(ae, re), () => {
        try {
          te.disconnect();
        } catch {
          ie.error("useDirtyGetMentions: observer disconnect failed", { observer: te });
        }
      };
    }, [ae]), ce;
  }({ ref: n || s }, { logger: T }), J = (oe == null ? void 0 : oe.length) < M;
  Tt(() => {
    j(""), q([]), X([]), Be(null), Ee([]), ge(null);
  }, [e == null ? void 0 : e.url]), Tt(() => {
    q(P.filter(({ userId: V }) => {
      const ie = G.indexOf(V);
      return !(ie < 0) && (G.splice(ie, 1), !0);
    }));
  }, [G]);
  const Me = LI({ sendFileMessage: o }, { logger: T });
  return C.jsxs("div", { className: "sendbird-message-input-wrapper", children: [H && C.jsx(rI, { currentChannel: e, targetNickname: L, inputEvent: ee ?? void 0, renderUserMentionItem: l, onUserItemClick: (V) => {
    V && q([...P, V]), j(""), Be(V), ge(null);
  }, onFocusItemChange: () => {
    ge(null);
  }, onFetchUsers: (V) => {
    Ee(V);
  }, ableAddMention: J, maxMentionCount: M, maxSuggestionCount: I }), C.jsx(RI, { className: "sendbird-message-input-wrapper__message-input", channel: e, channelUrl: e == null ? void 0 : e.url, isMobile: m, acceptableMimeTypes: d, mentionSelectedUser: Ce, isMentionEnabled: R, setMentionedUsers: q, placeholder: i0(e) && f.MESSAGE_INPUT__PLACE_HOLDER__FROZEN || s0(e) && (m ? f.MESSAGE_INPUT__PLACE_HOLDER__MUTED_SHORT : f.MESSAGE_INPUT__PLACE_HOLDER__MUTED) || a0(e, E.groupChannel.enableSuggestedReplies) && f.MESSAGE_INPUT__PLACE_HOLDER__SUGGESTED_REPLIES || o0(r) && f.MESSAGE_INPUT__PLACE_HOLDER__MESSAGE_FORM || h && (E.isOnline ? f.MESSAGE_INPUT__PLACE_HOLDER__DISABLED : f.MESSAGE_INPUT__PLACE_HOLDER__DISABLED_FOR_OFFLINE) || void 0, ref: n || s, disabled: ve, renderFileUploadIcon: c, renderSendMessageIcon: u, onStartTyping: () => {
    e == null || e.startTyping();
  }, onSendMessage: ({ message: V, mentionTemplate: ie }) => {
    var ae;
    a({ message: V, mentionedUsers: P, mentionedMessageTemplate: ie }), j(""), q([]), (ae = e == null ? void 0 : e.endTyping) == null || ae.call(e);
  }, onFileUpload: (V, ie) => {
    Me(V, ie);
  }, onUserMentioned: (V) => {
    (Ce == null ? void 0 : Ce.userId) === (V == null ? void 0 : V.userId) && (Be(null), j(""));
  }, onMentionStringChange: (V) => {
    j(V);
  }, onMentionedUserIdsUpdated: (V) => {
    X(V);
  }, onKeyDown: (V) => !!(H && (se == null ? void 0 : se.length) > 0 && (V.key === mh && J || V.key === Ag || V.key === Mg)) && (ge(V), !0), onFileLimitError: p })] });
}), PI = ({ lastMessage: t, botUser: n }) => {
  const { userId: e } = Ho(), { messageInputControls: r } = $t(), i = r == null ? void 0 : r.blockWhileBotResponding, s = Mt(void 0), [a, o] = Ye(!1), l = () => {
    s.current && clearTimeout(s.current), o(!1);
  };
  return Tt(() => {
    i && e && n && t && (((c) => !!c && "sender" in c)(t) && Oo(t, e) ? t.sendingStatus === "pending" ? (typeof i == "number" && (s.current = setTimeout(() => {
      o(!1);
    }, i)), o(!0)) : t.sendingStatus === "failed" && l() : Oo(t, n.userId) && (xi.isStreaming(t) || l()));
  }, [e, n == null ? void 0 : n.userId, t, i]), a;
};
function Pg(t, n) {
  return hr(() => {
    var e;
    (e = t.current) == null || e.focus();
  }, [t.current]), wn((e) => {
    const r = n[e.key];
    r == null || r(e), e.stopPropagation();
  });
}
function FI(t) {
  const { text: n, rootElementId: e, onCancel: r } = t, { stringSet: i } = Mn(Ta), s = Pg(Mt(null), { Enter: () => r == null ? void 0 : r(), Escape: () => r == null ? void 0 : r() });
  return C.jsx("div", { onKeyDown: s, children: C.jsx(xc, { contentClassName: "sendbird-message-feedback-modal-content__mobile", type: Un.PRIMARY, onSubmit: r, onClose: r, submitText: i.BUTTON__OK, renderHeader: () => C.jsx("div", { className: "sendbird-modal__header", children: C.jsx(En, { type: Nn.H_1, color: Cn.ONBACKGROUND_1, className: "sendbird-message-feedback-modal-header", children: n }) }), customFooter: C.jsx("div", { className: "sendbird-message-feedback-modal-footer__root_failed", children: C.jsx(Ui, { onClick: r, children: C.jsx(En, { type: Nn.BUTTON_3, color: Cn.ONCONTENT_1, children: i.BUTTON__OK }) }) }), rootElementId: e }) });
}
const gh = ({ message: t, onClose: n }) => C.jsx(FI, { text: t, rootElementId: _i.widgetWindow, onCancel: n }), jI = () => {
  const { channel: t, botUser: n, dataSource: e, handlers: r } = gi(), i = Mt(null), [s, a] = Ye(!1), { config: o } = Xr(), l = PI({ lastMessage: e.messages[e.messages.length - 1], botUser: n });
  return C.jsxs("div", { className: Hr(BI, oh && HI), children: [C.jsx(UI, { loading: !1, disabled: !o.isOnline || l, messageInputRef: i, currentChannel: t, messages: e.messages, sendUserMessage: async (c) => {
    const u = await r.onBeforeSendMessage(c), d = await e.sendUserMessage(u, () => r.onAfterSendMessage());
    return r.onAfterSendMessage(), d;
  }, sendFileMessage: async (c) => {
    const u = await r.onBeforeSendMessage(c), d = await e.sendFileMessage(u, () => r.onAfterSendMessage());
    return r.onAfterSendMessage(), d;
  }, onFileLimitError: () => a(!0) }), s && C.jsx(gh, { message: "You can't upload more than one image", onClose: () => a(!1) })] });
}, HI = "i1clwesp", BI = "c14bbh9b", Fg = ({ className: t, children: n, locale: e, date: r = Date.now(), formatString: i = "MMMM dd, yyyy", separatorColor: s, testId: a = "sendbird-date-separator" }) => {
  const o = us({ testId: a }), l = s ? r0[s] : r0.onbackground4;
  return C.jsxs("div", { className: Hr("sendbird-separator", "d11vwefh", Oc, t), ...o, children: [C.jsx(N0, { className: l, color: s && !l ? s : void 0 }), C.jsx("div", { className: "dxxpm7h", children: n ?? C.jsx(ji, { type: "caption2", color: "onbackground2", children: dg(r, i, { locale: e }) }) }), C.jsx(N0, { className: l, color: s && !l ? s : void 0 })] });
}, N0 = Jr("div")({ name: "Separator", class: "sylv9lb", propsAsIs: !1, vars: { "sylv9lb-0": [({ color: t }) => t ? `background-color: ${t};` : ""] } }), zI = ({ className: t, label: n = "Channel frozen", testId: e = "sendbird-frozen-banner" }) => {
  const r = us({ testId: e });
  return C.jsx("div", { ...r, className: Hr("f12pi7x1", t), children: C.jsx(ji, { type: "caption2", children: n }) });
}, VI = H0(function(t, n) {
  const { messages: e, renderMessage: r, messageTopArea: i, messageBottomArea: s, overlayArea: a, onLoadPrev: o, onLoadNext: l, loadThreshold: c = 0.05, onScrollPosition: u = Er, depsForResetScrollPositionToBottom: d, scrollPositionRef: h, scrollDistanceFromBottomRef: p, stackDirection: f = "top" } = t, m = n && "current" in n ? n : { current: null }, v = Mt(!1), E = Mt(), y = Mt(0), b = Mt(0), T = Mt(0), w = h ?? b, N = p ?? T;
  return hr(() => {
    m.current && (m.current.scrollTop = m.current.scrollHeight);
  }, d), hr(() => {
    m.current && (E.current === "top" && (m.current.scrollTop = m.current.scrollHeight - w.current), E.current === "bottom" && (m.current.scrollTop = y.current), E.current = void 0);
  }, [m.current, e.length]), C.jsxs("div", { id: "infinite-list-container", className: "i1xbb14n", children: [C.jsxs("div", { id: "infinite-list-inner", ref: m, onScroll: async () => {
    if (!m.current)
      return;
    const M = m.current;
    if (u(function(x) {
      return x.scrollTop <= I0 ? "top" : x.scrollHeight - (x.scrollTop + x.clientHeight) <= I0 ? "bottom" : "middle";
    }(M)), w.current = M.scrollHeight - M.scrollTop, N.current = w.current - M.clientHeight, y.current = M.scrollTop, v.current)
      return;
    const I = M.clientHeight * Math.min(Math.max(0, c), 1);
    M.scrollTop <= I ? (v.current = !0, E.current = "top", await o(), v.current = !1) : M.scrollHeight - M.scrollTop - M.clientHeight <= I ? (v.current = !0, E.current = "bottom", await l(), v.current = !1) : E.current = void 0;
  }, className: "i9cu81a", children: [f === "bottom" && C.jsx("div", { style: { flexGrow: 1 } }), i, e.map((M, I) => r({ message: M, index: I })), s] }), C.jsx("div", { id: "infinite-list-overlay-container", className: "iyi10wz", children: C.jsx("div", { id: "infinite-list-overlay", className: "i1y8lr1x", children: a }) })] });
}), I0 = 10, jg = (t) => {
  const n = t.size;
  return typeof n == "number" ? `${n}px` : n;
}, GI = { spinner: { module: null, load: () => Promise.resolve().then(() => tS).then((t) => t.default) }, chat: { module: null, load: () => Promise.resolve().then(() => T3).then((t) => t.default) }, message: { module: null, load: () => Promise.resolve().then(() => V3).then((t) => t.default) }, error: { module: null, load: () => Promise.resolve().then(() => F3).then((t) => t.default) }, refresh: { module: null, load: () => Promise.resolve().then(() => Y3).then((t) => t.default) }, "chevron-down": { module: null, load: () => Promise.resolve().then(() => S3).then((t) => t.default) }, "feedback-like": { module: null, load: () => Promise.resolve().then(() => oS).then((t) => t.default) }, "feedback-dislike": { module: null, load: () => Promise.resolve().then(() => lS).then((t) => t.default) }, done: { module: null, load: () => Promise.resolve().then(() => R3).then((t) => t.default) }, "file-document": { module: null, load: () => Promise.resolve().then(() => H3).then((t) => t.default) } }, vi = (t) => {
  const [n, e] = Ye(GI), r = us(t), { type: i, size: s = 24, className: a, color: o } = t, l = n[i], c = l.module, u = n0[o], d = u ?? (o && !u ? o : void 0) ?? n0.primary;
  return Tt(() => {
    l && !l.module && l.load().then((h) => {
      l.module = h, e({ ...n, [i]: l });
    });
  }, [l]), C.jsx(qI, { className: Hr("sendbird-icon", Oc, a), size: s, color: d, role: "button", tabIndex: 0, ...r, children: c && C.jsx(c, {}) });
}, qI = Jr("div")({ name: "Container", class: "c1eqvdnz", propsAsIs: !1, vars: { "c1eqvdnz-0": [jg], "c1eqvdnz-1": [({ color: t }) => t] } }), KI = ({ className: t, onClick: n, testId: e = "sendbird-scroll-to-bottom-button" }) => {
  const r = us({ testId: e });
  return C.jsx("button", { className: Hr("b1hu53uz", t), onClick: n, tabIndex: 0, ...r, children: C.jsx(vi, { size: 24, type: "chevron-down", color: "primary" }) });
}, WI = Ie.div`
  display: flex;
  justify-content: center;
  align-items: end;
  margin-bottom: 6px;
  flex-wrap: wrap-reverse;
  gap: 8px;
`, QI = Ie.div`
  max-width: calc(100% - 90px);
  font-size: 11px;
  width: fit-content;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
`, YI = Ie.div`
  color: #808080;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 12px;
  gap: 12px;
  border-radius: 16px;
  white-space: pre-wrap;
`, $I = Ie.div`
  white-space: pre-line;
`;
function ZI(t) {
  const { message: n } = t;
  return C.jsx(WI, { children: C.jsx(QI, { children: C.jsx(YI, { children: C.jsx($I, { children: n.message }) }) }) });
}
const A0 = Ot.forwardRef((t, n) => {
  const { children: e, isSelected: r, onClick: i = () => {
  }, disabled: s = !1 } = t;
  return C.jsx("button", { className: ["sendbird-iconbutton__feedback", r ? "sendbird-iconbutton__feedback__pressed" : "", s ? "sendbird-iconbutton__feedback__disabled" : ""].join(" "), ref: n, type: "button", onClick: (a) => {
    i == null || i(a);
  }, disabled: s, children: C.jsx("span", { className: ["sendbird-iconbutton__feedback__inner", r ? "sendbird-iconbutton__feedback__inner__pressed" : "", s ? "sendbird-iconbutton__feedback__inner__disabled" : ""].join(" "), children: e }) });
}), XI = Ot.forwardRef((t, n) => {
  const { name: e, required: r, disabled: i, value: s, placeHolder: a, autoFocus: o = !1 } = t, [l, c] = Ye(s);
  return C.jsxs("div", { className: "sendbird-input", children: [C.jsx("input", { className: "sendbird-input__input", ref: n, name: e, required: r, disabled: i, value: l, onChange: (u) => {
    c(u.target.value);
  }, autoFocus: o }), a && !l && C.jsx(En, { className: "sendbird-input__placeholder", type: Nn.BODY_1, color: Cn.ONBACKGROUND_3, children: a })] });
});
function JI(t) {
  var E, y;
  const { selectedFeedback: n, message: e, onClose: r, onSubmit: i, onUpdate: s, onRemove: a, isMobile: o } = t, { stringSet: l } = Mn(Ta), c = Mc(), u = o ?? c.isMobile, d = (e == null ? void 0 : e.myFeedback) && n === e.myFeedback.rating, h = (E = e == null ? void 0 : e.myFeedback) == null ? void 0 : E.comment, p = () => {
    var T, w;
    if (!n)
      return;
    const b = ((T = m.current) == null ? void 0 : T.value) ?? "";
    d ? b !== ((w = e.myFeedback) == null ? void 0 : w.comment) ? s == null || s(n, b) : r == null || r() : e.myFeedback || (i == null || i(n, b));
  }, f = Mt(), m = Mt(), v = Pg(f, { Enter: () => p(), Escape: () => r == null ? void 0 : r() });
  return C.jsx("div", { onKeyDown: v, children: C.jsx(xc, { rootElementId: t.rootElementId, contentClassName: "sendbird-message-feedback-modal-content__mobile", type: Un.PRIMARY, onCancel: r, onSubmit: () => {
    p();
  }, submitText: l.BUTTON__SUBMIT, renderHeader: () => C.jsx("div", { className: "sendbird-modal__header", children: C.jsx(En, { type: Nn.H_1, color: Cn.ONBACKGROUND_1, className: "sendbird-message-feedback-modal-header", children: l.FEEDBACK_MODAL_TITLE }) }), customFooter: C.jsxs("div", { className: "sendbird-message-feedback-modal-footer__root", children: [!u && (e != null && e.myFeedback) && n === e.myFeedback.rating ? C.jsx(Ui, { type: Un.WARNING, onClick: a, labelType: Nn.BUTTON_3, children: l.BUTTON__REMOVE_FEEDBACK }) : C.jsx("div", {}), C.jsxs("div", { className: "sendbird-message-feedback-modal-footer__right-content", children: [C.jsx(Ui, { type: Un.SECONDARY, onClick: r, children: C.jsx(En, { type: Nn.BUTTON_3, color: Cn.ONBACKGROUND_1, children: l.BUTTON__CANCEL }) }), C.jsx(Ui, { onClick: () => p(), children: C.jsx(En, { type: Nn.BUTTON_3, color: Cn.ONCONTENT_1, children: h ? l.BUTTON__SAVE : l.BUTTON__SUBMIT }) })] })] }), children: C.jsx("div", { className: "sendbird-message-feedback-modal-body__root", children: C.jsx(XI, { name: "sendbird-message-feedback-modal-body__root", ref: m, value: d ? (y = e.myFeedback) == null ? void 0 : y.comment : "", placeHolder: l.FEEDBACK_CONTENT_PLACEHOLDER, autoFocus: !0 }) }) }) });
}
const eA = (t) => {
  var a, o;
  const { className: n = "", children: e, onBackdropClick: r } = t, i = (o = (a = Xr()) == null ? void 0 : a.config) == null ? void 0 : o.logger, s = Mt();
  return s.current = function() {
    var u;
    const l = t.rootElementId ? document.getElementById(t.rootElementId) : document.getElementById(ya);
    if (l)
      return l;
    (u = i == null ? void 0 : i.warning) == null || u.call(i, "@sendbird/uikit-react/ui/BottomSheet | Should put a ModalRoot to use the BottomSheet.");
    const c = document.createElement("div");
    return c.setAttribute("id", ya), document.body.appendChild(c), c;
  }(), Dd(C.jsxs("div", { className: `${n} sendbird-bottomsheet`, children: [C.jsx("div", { className: "sendbird-bottomsheet__content", role: "dialog", "aria-modal": "true", "aria-expanded": "true", children: e }), C.jsx("div", { className: "sendbird-bottomsheet__backdrop", onClick: (l) => {
    l == null || l.stopPropagation(), r == null || r();
  } })] }), s.current);
};
function tA(t) {
  const { hideMenu: n, onEditFeedback: e, onRemoveFeedback: r, rootElementId: i } = t, { stringSet: s } = jo();
  return C.jsx(eA, { rootElementId: i, onBackdropClick: n, children: C.jsxs("div", { className: "sendbird-message__bottomsheet--feedback-options-menu", children: [C.jsx("div", { className: "sendbird-message__bottomsheet--feedback-option", onClick: () => {
    n(), e();
  }, children: C.jsx(En, { type: Nn.BODY_1, color: Cn.ONBACKGROUND_1, children: s.EDIT_COMMENT }) }), C.jsx("div", { className: "sendbird-message__bottomsheet--feedback-option", onClick: () => {
    n(), r();
  }, children: C.jsx(En, { type: Nn.BODY_1, color: Cn.ERROR, children: s.REMOVE_FEEDBACK }) })] }) });
}
function nA({ message: t }) {
  var a, o;
  const { stringSet: n } = $t(), [e, r] = Ja((l, c) => ({ ...l, ...c }), { errorText: "", modalVisible: !1, menuVisible: !1 }), i = () => r({ menuVisible: !0 }), s = () => r({ modalVisible: !1 });
  return C.jsxs(C.Fragment, { children: [C.jsxs("div", { className: "sendbird-message-content__middle__body-container__feedback-buttons-container", children: [C.jsx(A0, { "aria-label": "Like the bot answer", isSelected: ((a = t.myFeedback) == null ? void 0 : a.rating) === $i.GOOD, onClick: async () => {
    var l;
    if (t.myFeedback)
      i();
    else
      try {
        await t.submitFeedback({ rating: $i.GOOD }), r({ modalVisible: !0 });
      } catch (c) {
        (l = console.error) == null || l.call(console, "Channel: Submit feedback failed.", c), r({ errorText: n.FEEDBACK_FAILED_SUBMIT });
      }
  }, disabled: !!t.myFeedback && t.myFeedback.rating !== $i.GOOD, children: C.jsx(vi, { type: "feedback-like", size: 24 }) }), C.jsx(A0, { "aria-label": "Dislike the bot answer", isSelected: ((o = t.myFeedback) == null ? void 0 : o.rating) === $i.BAD, onClick: async () => {
    var l;
    if (t.myFeedback)
      i();
    else
      try {
        await t.submitFeedback({ rating: $i.BAD }), r({ modalVisible: !0 });
      } catch (c) {
        (l = console.error) == null || l.call(console, "Channel: Submit feedback failed.", c), r({ errorText: n.FEEDBACK_FAILED_SUBMIT });
      }
  }, disabled: !!t.myFeedback && t.myFeedback.rating !== $i.BAD, children: C.jsx(vi, { type: "feedback-dislike", size: 24 }) })] }), t.myFeedback && e.menuVisible && C.jsx(tA, { rootElementId: _i.widgetWindow, hideMenu: () => {
    r({ menuVisible: !1 });
  }, onEditFeedback: () => {
    r({ menuVisible: !1, modalVisible: !0 });
  }, onRemoveFeedback: async () => {
    var l;
    if (t.myFeedback) {
      try {
        await t.deleteFeedback(t.myFeedback.id);
      } catch (c) {
        (l = console.error) == null || l.call(console, "Channel: Delete feedback failed.", c), r({ errorText: n.FEEDBACK_FAILED_DELETE });
      }
      r({ menuVisible: !1 });
    }
  } }), t.myFeedback && e.modalVisible && C.jsx(JI, { isMobile: !0, rootElementId: _i.widgetWindow, selectedFeedback: t.myFeedback.rating, message: t, onUpdate: async (l, c) => {
    if (t.myFeedback)
      try {
        const u = new ki({ id: t.myFeedback.id, rating: l, comment: c });
        await t.updateFeedback(u);
      } catch (u) {
        console.error("Channel: Update feedback failed.", u), r({ errorText: n.FEEDBACK_FAILED_SAVE });
      }
    s();
  }, onClose: s, onRemove: async () => {
    if (t.myFeedback)
      try {
        await t.deleteFeedback(t.myFeedback.id);
      } catch (l) {
        console.error("Channel: Delete feedback failed.", l), r({ errorText: n.FEEDBACK_FAILED_DELETE });
      }
    s();
  } }), !!e.errorText && C.jsx(gh, { message: e.errorText, onClose: () => r({ errorText: "" }) })] });
}
const vh = Ie.span`
  width: fit-content;
  color: ${({ theme: t }) => t.textColor.sentTime};
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
`, Hg = Ie(vh)`
  margin-bottom: 2px;
`, rA = Ie(vh)`
  margin-top: 4px;
  display: block;
  height: 14px;
`, yh = Ie.div`
  font-size: 14px;
  color: ${({ theme: t }) => t.textColor.incomingMessage};
  max-width: calc(100% - 36px);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
`, iA = Ie(yh)`
  flex: 1;
`, Bg = Ie.div`
  background-color: ${({ theme: t }) => t.bgColor.outgoingMessage};
  color: ${({ theme: t }) => t.textColor.outgoingMessage};
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 12px;
  gap: 12px;
  border-radius: 16px;
  white-space: pre-wrap;
  word-break: break-word;
`;
function mc(t, n = Ac) {
  return dg(t || 0, "p", { locale: n });
}
const sA = Ie.span`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 8px;
  position: relative;
`, aA = Ie.div`
  padding: 0 0 4px 12px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 246px;
`, oA = Ie.div`
  flex: 1;
  display: flex;
  align-items: end;
  gap: 4px;
`, lA = Ie.div`
  width: 28px;
`, M0 = { FEEDBACK: 40, TIMESTAMP: 18 };
function Xa(t) {
  const { botUser: n } = gi(), { botStudioEditProps: e, dateLocale: r } = $t(), { createdAt: i, bodyComponent: s, chainTop: a, chainBottom: o, messageFeedback: l, wideContainer: c = !1 } = t, u = (l ? M0.FEEDBACK : 0) + (c ? M0.TIMESTAMP : 0), d = a == null && o == null, h = d || a, p = d || o, { nickname: f } = (e == null ? void 0 : e.botInfo) ?? {}, m = f ?? (n == null ? void 0 : n.nickname);
  return C.jsxs(sA, { children: [p ? C.jsx("div", { style: { paddingBottom: u }, children: C.jsx(hh, { size: 28 }) }) : C.jsx(lA, {}), C.jsxs(iA, { children: [h && C.jsx(aA, { children: C.jsx(ji, { type: "caption2", color: "onbackground2", children: m }) }), C.jsxs(oA, { children: [s, !c && !!i && C.jsx(Hg, { children: mc(i, r) })] }), c && !!i && C.jsx(rA, { children: mc(i, r) }), p && l] })] });
}
const zg = ({ className: t, children: n, size: e = 26, testId: r = "sendbird-loader" }) => {
  const i = us({ testId: r });
  return C.jsx(cA, { className: Hr(t, "sendbird-loader"), size: e, ...i, children: n ?? C.jsx(vi, { type: "spinner", size: e }) });
}, cA = Jr("div")({ name: "Container", class: "cikvymb", propsAsIs: !1, vars: { "cikvymb-0": [jg] } });
function Vg(t) {
  const { message: n, dateLocale: e } = t, r = Ro();
  switch (n.sendingStatus) {
    case St.PENDING:
      return C.jsx(zg, { className: x0, size: 16, children: C.jsx(vi, { type: "spinner", color: r.bgColor.outgoingMessage, size: 16 }) });
    case St.FAILED:
      return C.jsx("div", { className: x0, children: C.jsx(vi, { type: "error", color: "error", size: 16 }) });
    default:
      return C.jsx(Hg, { children: mc(n.createdAt, e) });
  }
}
const x0 = "s1idgyaa", uA = Jr("div")({ name: "Root", class: "r97bvy4", propsAsIs: !1 });
function dA(t) {
  const { enableEmojiFeedback: n, dateLocale: e } = $t(), { message: r } = t;
  return C.jsxs(uA, { enableEmojiFeedback: n, children: [C.jsx(Vg, { message: r, dateLocale: e }), C.jsx(yh, { children: C.jsx(Bg, { children: C.jsx("div", { className: "sendbird-word", children: r.message }) }) })] });
}
const hA = Ie.div`
  display: flex;
  align-items: flex-start;
`, pA = Ie.span`
  width: 100%;
  text-align: left;
  white-space: pre-line;
  word-break: break-word;
  line-height: 1.43;

  padding: 8px 12px;
  gap: 8px;
  border-radius: 16px;
  background-color: ${({ theme: t }) => t.bgColor.incomingMessage};
  &:hover {
    background-color: ${({ theme: t }) => t.bgColor.hover.incomingMessage};
  }
`;
function fA(t) {
  const { message: n } = t, e = _h.sanitize(n);
  return C.jsx(hA, { children: C.jsx(pA, { className: "sendbird-word", children: e }) });
}
const Gg = ({ className: t, testId: n }) => {
  const e = Ro(), r = us({ testId: n });
  return C.jsx("div", { className: Hr("t1v3wg7c", t), style: { background: e.bgColor.incomingMessage }, ...r, children: [0, 1, 2].map((i) => C.jsx("span", { className: "tch6ath", style: { background: e.textColor.incomingMessage } }, i)) });
};
function k0() {
  return C.jsxs("div", { style: { display: "flex", alignItems: "flex-end", gap: 8, marginTop: 16 }, children: [C.jsx(hh, { size: 28 }), C.jsx(Gg, {})] });
}
const mA = ({ message: t, onCancel: n, onDownloadClick: e, profile: r }) => {
  const { sender: i, type: s, url: a, name: o = "", threadInfo: l } = t, { profileUrl: c, nickname: u, userId: d } = i, { config: h } = Xr();
  return Dd(C.jsx(_A, { profileUrl: c, profile: r, nickname: u, type: s, url: a, name: o, onCancel: n, isByMe: h.userId === d, disableDelete: !!(l != null && l.replyCount) && l.replyCount > 0, onDownloadClick: e }), document.getElementById(ya));
}, _A = ({ profileUrl: t, nickname: n, name: e, type: r, url: i, isByMe: s, onCancel: a, onDelete: o, disableDelete: l, onDownloadClick: c, profile: u }) => C.jsx(xc, { onClose: a, children: C.jsxs("div", { className: "sendbird-fileviewer", "data-testid": "sendbird-fileviewer", children: [C.jsxs("div", { className: "sendbird-fileviewer__header", children: [C.jsxs("div", { className: "sendbird-fileviewer__header__left", children: [C.jsx("div", { className: "sendbird-fileviewer__header__left__avatar", children: u ?? C.jsx(fh, { height: "32px", width: "32px", src: t }) }), C.jsx(En, { className: "sendbird-fileviewer__header__left__filename", type: Nn.H_2, color: Cn.ONBACKGROUND_1, children: e }), C.jsx(En, { className: "sendbird-fileviewer__header__left__sender-name", type: Nn.BODY_1, color: Cn.ONBACKGROUND_2, children: n })] }), C.jsxs("div", { className: "sendbird-fileviewer__header__right", children: [Sd(r) && C.jsxs("div", { className: "sendbird-fileviewer__header__right__actions", children: [C.jsx("a", { className: "sendbird-fileviewer__header__right__actions__download", rel: "noopener noreferrer", href: i, target: "_blank", onClick: c, children: C.jsx(fi, { type: mi.DOWNLOAD, fillColor: Qr.ON_BACKGROUND_1, height: "24px", width: "24px" }) }), o && s && C.jsx("div", { className: "sendbird-fileviewer__header__right__actions__delete", children: C.jsx(fi, { className: l ? "disabled" : "", type: mi.DELETE, fillColor: l ? Qr.GRAY : Qr.ON_BACKGROUND_1, height: "24px", width: "24px", onClick: () => {
  l || o();
} }) })] }), C.jsx("div", { className: "sendbird-fileviewer__header__right__actions__close", children: C.jsx(fi, { type: mi.CLOSE, fillColor: Qr.ON_BACKGROUND_1, height: "24px", width: "24px", onClick: a }) })] })] }), C.jsxs("div", { className: "sendbird-fileviewer__content", children: [rh(r) && C.jsx("video", { controls: !0, className: "sendbird-fileviewer__content__video", children: C.jsx("source", { src: i, type: r }) }), Ic(r) && C.jsx("img", { src: i, alt: e, className: "sendbird-fileviewer__content__img" }), !Sd(r) && C.jsx("div", { className: "sendbird-fileviewer__content__unsupported", children: C.jsx(En, { type: Nn.H_1, color: Cn.ONBACKGROUND_1, children: Q_.UI__FILE_VIEWER__UNSUPPORT }) })] })] }) }), qg = ({ message: t, onClose: n }) => C.jsx(mA, { message: t, onCancel: n });
function gA(t) {
  const { message: n } = t, { scrollSource: e } = gi(), [r, i] = Ye(!1);
  return C.jsxs("div", { className: "sendbird-ai-widget-file-message-root", children: [z_(n) && C.jsxs("video", { controls: !0, className: "sendbird-ai-widget-file-message", children: [C.jsx("source", { src: n.url, type: n.type }), C.jsx("track", { kind: "captions" })] }), qw(n) && C.jsx("img", { className: "sendbird-ai-widget-file-message", src: n.url, alt: "", onLoad: () => e.scrollPubSub.publish("scrollToBottom", {}), onClick: () => i(!0) }), r && C.jsx(qg, { message: n, onClose: () => i(!1) })] });
}
const vA = (t) => Q.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#000", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("g", { id: "chevron-left" }, Q.createElement("path", { id: "Fill", fillRule: "evenodd", clipRule: "evenodd", d: "M14.293 5.29297L15.7073 6.70718L10.4144 12.0001L15.7073 17.293L14.293 18.7072L7.58594 12.0001L14.293 5.29297Z", fill: "current" }))), Kg = (t) => Q.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "#6210CC", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("g", { id: "chevron-right" }, Q.createElement("path", { id: "Fill", fillRule: "evenodd", clipRule: "evenodd", d: "M6.47137 3.52881L5.52856 4.47162L9.05716 8.00021L5.52856 11.5288L6.47137 12.4716L10.9428 8.00021L6.47137 3.52881Z", fill: "current" }))), yA = Ie.div({ display: "flex", flexDirection: "row", scrollSnapType: "x mandatory", overflowY: "scroll", gap: 12, scrollPadding: 0, paddingLeft: 0, scrollbarWidth: "none", userSelect: "none", "::-webkit-scrollbar": { display: "none" } }), bA = Ie.div(({ theme: t, focused: n }) => ({ display: "flex", flexShrink: 0, scrollSnapAlign: "start", flexDirection: "column", borderRadius: 16, overflow: "hidden", border: `1px solid ${t.borderColor.carouselItem}`, backgroundColor: t.bgColor.carouselItem, boxSizing: "border-box", cursor: n ? "pointer" : "auto" })), Wg = ls({ activeIndex: 0, scrollTo: Er }), Rd = ({ gap: t = 0, startPadding: n = 0, endPadding: e = 0, style: r, children: i, renderButtons: s }) => {
  var h;
  const a = Mt(null), [o, l] = Ye(0), c = Ot.Children.toArray(i).length, u = sr(() => {
    var p;
    return ((((p = a.current) == null ? void 0 : p.scrollWidth) ?? 0) - (n + e + t * (c - 1))) / c;
  }, [(h = a.current) == null ? void 0 : h.scrollWidth, c, t, n, e]), d = (p) => {
    if (a.current) {
      const f = Math.min(Math.max(0, p), c - 1);
      a.current.scroll({ left: f * u, behavior: "smooth" });
    }
  };
  return C.jsxs(Wg.Provider, { value: { activeIndex: o, scrollTo: d }, children: [C.jsx(yA, { onScroll: (p) => {
    const f = Math.round(p.currentTarget.scrollLeft / u);
    f !== o && l(f);
  }, ref: a, style: { gap: t, scrollPadding: n, paddingLeft: n, paddingRight: e, ...r }, children: Ot.Children.map(i, (p, f) => Ot.isValidElement(p) ? Ot.cloneElement(p, { ...p.props, index: f }) : null) }), s == null ? void 0 : s({ activeIndex: o, onClickPrev() {
    d(o - 1);
  }, onClickNext() {
    d(o + 1);
  } })] });
};
Rd.Item = function({ children: t, onClick: n, height: e, width: r, index: i = 0 }) {
  const { activeIndex: s } = Mn(Wg), a = i === s;
  return C.jsx(bA, { focused: a, onClick: () => a && (n == null ? void 0 : n()), role: "button", style: { width: r, height: e }, children: t });
};
const O0 = Ie.div({ display: "flex", flexWrap: "wrap", position: "relative" }), EA = Ie.div({ display: "flex", flexDirection: "column", gap: 4, width: "100%" }), CA = Ie.div`
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  word-break: break-word;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme: t }) => t.textColor.carouselItem};
`, TA = Ie.img`
  flex-shrink: 0;
  width: 100%;
  height: 134px;
  object-fit: cover;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  background-color: ${({ theme: t }) => t.bgColor.carouselItem};
`, R0 = Ie.button(({ theme: t, direction: n }) => ({ display: "flex", justifyContent: "center", alignItems: "center", position: "absolute", top: "50%", transform: "translateY(-50%)", border: "none", cursor: "pointer", borderRadius: n === "right" ? "100px 0px 0px 100px" : "0px 100px 100px 0px", padding: n === "right" ? "8px 8px 8px 12px" : "8px 12px 8px 8px", backgroundColor: t.bgColor.carouselButton, boxShadow: "0px 8px 10px 1px rgba(13, 13, 13, 0.12), 0px 3px 14px 2px rgba(13, 13, 13, 0.08), 0px 3px 5px -3px rgba(13, 13, 13, 0.04)", "&:hover": { backgroundColor: t.bgColor.hover.carouselButton } })), wA = ({ streaming: t, textBody: n, streamingBody: e, items: r }) => {
  const i = Ro(), { isMobileView: s } = $t(), a = t || r.length > 0, o = !s && r.length >= 2;
  return C.jsxs(EA, { children: [C.jsx(O0, { children: n }), a && C.jsx(O0, { children: t ? e : C.jsx(Rd, { startPadding: 52, endPadding: 16, gap: 8, style: { marginLeft: -52, marginRight: -16 }, renderButtons: ({ activeIndex: l, onClickPrev: c, onClickNext: u }) => o && C.jsxs(C.Fragment, { children: [l !== 0 && C.jsx(R0, { style: { left: -52 }, onClick: c, direction: "left", children: C.jsx(vA, { width: 24, height: 24, fill: i.bgColor.carouselButtonIcon }) }), l !== r.length - 1 && C.jsx(R0, { style: { right: -16 }, onClick: u, direction: "right", children: C.jsx(Kg, { width: 24, height: 24, fill: i.bgColor.carouselButtonIcon }) })] }), children: r.map((l, c) => C.jsxs(Rd.Item, { width: 240, height: 198, onClick: () => async function(u) {
    let d = u;
    d && (d.startsWith("http://") || d.startsWith("https://") || (d = "https://" + d), window.open(d, "_blank", "noopener,noreferrer"));
  }(l.url), children: [C.jsx(TA, { src: l.featured_image, alt: l.title }), C.jsx("div", { style: { padding: 12, backgroundColor: i.bgColor.carouselItem }, children: C.jsx(CA, { children: l.title }) })] }, c)) }) })] });
}, SA = Ie.div`
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  padding: 8px 12px;
  border-radius: 16px;
  background-color: ${({ theme: t }) => t.bgColor.incomingMessage};
`, NA = Ie.div`
  color: ${({ theme: t }) => t.textColor.placeholder};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
function IA({ text: t }) {
  return C.jsx(SA, { children: C.jsx(NA, { children: t }) });
}
const Qg = Ie(ji)`
  line-height: 14px;
  display: block;
  margin: 0;
`, AA = ({ children: t }) => C.jsx("div", { style: { marginBottom: "6px" }, children: C.jsx(Qg, { className: "sendbird-input-label", type: "caption2", color: "onbackground2", children: t }) }), MA = Ie.div`
  display: inline-block;
`, xA = Ie.span`
  color: ${({ theme: t }) => t.textColor.placeholder};
`, kA = Ie.div`
  padding-bottom: 12px;
  width: 100%;

  .sendbird-input .sendbird-input__input {
    color: ${({ theme: t }) => t.textColor.incomingMessage} !important;
    height: fit-content;
    background-color: ${({ theme: t }) => t.bgColor.formInput.default} !important;
    border: ${({ theme: t, errorMessage: n }) => `solid 1px ${n ? t.borderColor.formInput.error : t.borderColor.formInput.default}`} !important;

    &:disabled {
      pointer-events: none;
      background-color: ${({ theme: t }) => t.bgColor.formInput.disabled} !important;
      border: none !important;
    }

    &:focus {
      border: ${({ theme: t }) => `solid 1px ${t.borderColor.formInput.focus}`} !important;
      outline: none;
      box-shadow: 0 0 0 1px ${({ theme: t }) => t.borderColor.formInput.focus};
    }

    &:active {
      border: ${({ theme: t }) => `solid 1px ${t.borderColor.formInput.active}`} !important;
    }
  }
`, bl = Ie.div`
  width: calc(100% - 26px); // (12px side padding + 1px border) * 2 = 26px
  height: calc(100% - 16px); // (7px padding + 1px border) * 2 = 16px
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${({ numMaxLines: t }) => t ?? 1};
  -webkit-box-orient: vertical;
  position: absolute;
  pointer-events: none;
  top: 8px;
  left: 13px;
  font-size: 14px;
  line-height: 1.43;
  color: ${({ theme: t }) => t.textColor.placeholder};
`, OA = Ie.div`
  border-radius: 100px;
  padding: ${({ isSubmitted: t }) => t ? "6px 16px" : "5px 15px"};
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: calc(100% - 32px);

  ${({ theme: t, state: n }) => {
  switch (n) {
    case "default":
      return { color: t.textColor.formChip.default, backgroundColor: t.bgColor.formChip.default, border: `1px solid ${t.borderColor.formChip.default}`, cursor: "pointer", "&:hover": { color: t.textColor.formChip.hover, "background-color": t.bgColor.formChip.hover, border: `1px solid ${t.borderColor.formChip.hover}` }, "&:focus": { color: t.textColor.formChip.focus, "background-color": t.bgColor.formChip.focus, border: `1px solid ${t.borderColor.formChip.focus}`, outline: "none", "box-shadow": `0 0 0 1px ${t.borderColor.formChip.focus}` }, "&:active": { color: t.textColor.formChip.selected, backgroundColor: t.bgColor.formChip.selected, border: `1px solid ${t.borderColor.formChip.selected}` } };
    case "selected":
      return { color: t.textColor.formChip.selected, backgroundColor: t.bgColor.formChip.selected, border: `1px solid ${t.borderColor.formChip.selected}`, cursor: "pointer", "&:hover": { color: t.textColor.formChip.hover, "background-color": t.bgColor.formChip.hover, border: `1px solid ${t.borderColor.formChip.hover}` }, "&:focus": { color: t.textColor.formChip.focus, "background-color": t.bgColor.formChip.focus, border: `1px solid ${t.borderColor.formChip.focus}`, outline: "none", "box-shadow": `0 0 0 1px ${t.borderColor.formChip.focus}` }, "&:active": { color: t.textColor.formChip.selected, backgroundColor: t.bgColor.formChip.selected, border: `1px solid ${t.borderColor.formChip.selected}` } };
    case "submittedDefault":
      return { color: t.textColor.formChip.submittedDefault, backgroundColor: t.bgColor.formChip.submittedDefault, border: "none", cursor: "default" };
    case "submittedSelected":
      return { color: t.textColor.formChip.submittedSelected, backgroundColor: t.bgColor.formChip.submittedSelected, border: "none", cursor: "default" };
    default:
      return {};
  }
}};
`, RA = Ie.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
`, DA = Ie.input`
  padding: 7px 12px !important;
`, LA = Ie.textarea`
  display: block; // Without this, parent height does not fit this height.
  ::placeholder {
    color: var(--sendbird-light-onlight-03);
  }
  resize: none;
  height: 96px !important;
  padding: 8px 12px !important;
`, UA = Ie.div`
  display: flex;
  word-wrap: break-word;
  width: calc(100% - 24px);
  color: ${({ theme: t }) => t.textColor.incomingMessage};
  background-color: ${({ theme: t }) => t.bgColor.formInput.disabled} !important;
  border: none;
  pointer-events: none;
  ${({ isTextarea: t }) => t ? { padding: "9px 12px", "min-height": "78px" } : { padding: "8px 12px", "min-height": "20px" }};
  border-radius: 4px;
  overflow-wrap: break-word;
  white-space: pre-wrap;
`, D0 = ({ layout: t, currentValue: n, isValid: e }) => C.jsxs(UA, { isTextarea: t === "textarea", children: [C.jsx(PA, { children: n }), e && C.jsx(jA, { children: C.jsx(vi, { type: "done", color: "secondary", size: 20 }) })] }), PA = Ie.div`
  width: calc(100% - 24px);
  line-height: 20px;
`, FA = Ie(Qg)`
  margin-top: 4px;
  color: var(--sendbird-light-error-300);
`, jA = Ie.div`
  display: flex;
  height: auto;
  align-items: flex-end;
`, HA = Ie(vi)`
  margin-left: 4px;
`, L0 = Ie.div`
  width: 100%;
  position: relative;
`, BA = (t) => {
  const { layout: n, name: e, required: r, errorMessage: i, isValid: s, values: a, isInvalidated: o, isSubmitTried: l, style: c, onFocused: u, onChange: d, placeHolder: h, isSubmitted: p } = t, { options: f = [], resultCount: m } = c, { min: v = 1, max: E = 1 } = m ?? {}, y = p ? f.map((w) => ({ state: a.includes(w) ? "submittedSelected" : "submittedDefault", option: w })) : f.map((w) => ({ state: a.includes(w) ? "selected" : "default", option: w })), b = () => {
    u == null || u(!0);
  }, T = () => {
    u == null || u(!1);
  };
  return C.jsxs(kA, { errorMessage: i, children: [C.jsx(AA, { children: C.jsxs(MA, { children: [e, " ", !r && C.jsx(xA, { children: "(optional)" })] }) }), C.jsxs("div", { className: "sendbird-input", style: { height: "unset" }, children: [(() => {
    switch (n) {
      case "chip":
        return C.jsx("div", { className: "sendbird-form-chip__container", children: y.map((w, N) => C.jsxs(OA, { state: w.state, onClick: () => ((M) => {
          if (p)
            return;
          let I;
          I = v === 1 && E === 1 ? y[M].state === "selected" ? [] : [y[M].option] : y.reduce((x, R, L) => (L === M ? R.state === "default" && a.length < E && x.push(R.option) : R.state === "selected" && x.push(R.option), x), []), d(I);
        })(N), isSubmitted: p, children: [C.jsx(RA, { children: w.option }), p && w.state === "submittedSelected" && C.jsx(HA, { type: "done", color: "secondary", size: 20 })] }, N)) });
      case "textarea": {
        const w = a.length > 0 ? a[0] : "";
        return C.jsx(L0, { children: p ? C.jsxs(C.Fragment, { children: [C.jsx(D0, { layout: n, currentValue: w, isValid: s }), !w && C.jsx(bl, { children: "No Response" })] }) : C.jsxs(C.Fragment, { children: [C.jsx(LA, { className: "sendbird-input__input", required: r, disabled: p, value: w, onFocus: b, onBlur: T, onChange: (N) => {
          const M = N.target.value;
          d(M ? [M] : []);
        } }), h && !w && C.jsx(bl, { numMaxLines: 4, children: h })] }) });
      }
      case "text":
      case "number":
      case "phone":
      case "email": {
        const w = a.length > 0 ? a[0] : "";
        return C.jsx(L0, { children: p ? C.jsxs(C.Fragment, { children: [C.jsx(D0, { layout: n, currentValue: w, isValid: s }), !w && C.jsx(bl, { children: "No Response" })] }) : C.jsxs(C.Fragment, { children: [C.jsx(DA, { type: n === "number" ? "text" : n, inputMode: n === "number" ? "numeric" : "text", className: "sendbird-input__input", name: e, required: r, disabled: p, value: w, onFocus: b, onBlur: T, onChange: (N) => {
          const M = N.target.value;
          d(M ? [M] : []);
        } }), h && !w && C.jsx(bl, { children: h })] }) });
      }
      default:
        return C.jsx(C.Fragment, {});
    }
  })(), i && (l || o) && C.jsx(FA, { type: "caption3", children: i })] })] });
}, zA = Ie.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 12px;
  border-radius: 16px;
  overflow: hidden;
  background-color: ${({ theme: t }) => t.bgColor.incomingMessage};
`, VA = Ie(Ui)`
  width: 100%;

  &&& {
    ${({ theme: t, disabled: n }) => {
  if (n) {
    const e = `${t.bgColor.formButton.disabled};`;
    return { "background-color": e, "&:hover": { "background-color": e } };
  }
}};
  }
`, GA = Ie.div`
  color: ${({ theme: t, disabled: n }) => n ? t.textColor.formButton.disabled : t.textColor.activeButton};
`;
function qA(t) {
  const { message: n, form: e } = t, { items: r } = e, { stringSet: i } = $t(), [s, a] = Ye(!1), [o, l] = Ye(!1), [c, u] = Ye(() => {
    const m = [];
    return r.forEach(({ id: v, required: E, style: y }) => {
      const { defaultOptions: b = [], layout: T } = y;
      m.push({ itemId: v, draftValues: T === "chip" ? b : [], required: E, errorMessage: null, isInvalidated: !1 });
    }), m;
  });
  if (!Ng(t.form.version))
    return C.jsx(IA, { text: gg.formVersionInvalidFallbackMessage });
  const d = e.isSubmitted, h = c.some(({ errorMessage: m }) => !!m), p = c.some(({ isInvalidated: m }) => m), f = h && (o || p) || d;
  return C.jsxs(zA, { children: [r.map((m, v) => {
    const { name: E, placeholder: y, id: b, required: T, style: w } = m, { draftValues: N = [], errorMessage: M } = c[v];
    return C.jsx(BA, { layout: m.style.layout, style: w, placeHolder: y, values: m.submittedValues ?? N, isInvalidated: c[v].isInvalidated, isSubmitTried: o, errorMessage: M, isValid: d, isSubmitted: d, name: E, required: T, onFocused: (I) => {
      !M || I || c[v].isInvalidated ? M || u(([...x]) => (x[v] = { ...x[v], isInvalidated: !1 }, x)) : u(([...x]) => (x[v] = { ...x[v], isInvalidated: !0 }, x));
    }, onChange: (I) => {
      u(([...x]) => (x[v] = { ...x[v], draftValues: I, errorMessage: m.isValid(I) ? T && I.length === 0 ? i.FORM_ITEM_REQUIRED : null : i.FORM_ITEM_INVALID }, x));
    } }, b);
  }), C.jsx(VA, { onClick: async () => {
    l(!0);
    try {
      if (c.some((m) => m.required && (!m.draftValues || m.draftValues.length === 0)))
        return void u((m) => m.map((v) => v.required && v.draftValues.length === 0 ? { ...v, errorMessage: i.FORM_ITEM_REQUIRED } : v));
      if (c.some(({ errorMessage: m }) => m))
        return;
      c.forEach((m, v) => {
        r[v].draftValues = m.draftValues;
      }), await n.submitMessageForm();
    } catch (m) {
      a(!0), console.error(m);
    }
  }, disabled: f, children: C.jsx(ji, { type: "button2", children: C.jsx(GA, { disabled: f, children: d ? "Submitted successfully" : "Submit" }) }) }), s && C.jsx(gh, { message: "Submit failed.", onClose: () => a(!1) })] });
}
const KA = ({ message: t }) => {
  const { dateLocale: n } = $t(), e = !!t.message, r = t.type.startsWith("image/") ? "image" : t.type.startsWith("application/pdf") ? "pdf" : "unknown", i = r === "image" ? C.jsx($A, { message: t }) : r === "pdf" ? C.jsx(ZA, { message: t }) : void 0, s = () => C.jsx("div", { className: YA, children: C.jsx(Vg, { message: t, dateLocale: n }) });
  return C.jsxs("div", { className: WA, children: [C.jsxs("div", { className: U0, children: [!e && i && s(), C.jsx("div", { className: QA, children: i })] }), (e || r === "unknown") && C.jsxs("div", { className: U0, children: [s(), C.jsx(yh, { style: { maxWidth: 244 }, children: C.jsx(Bg, { children: C.jsx("div", { className: "sendbird-word", children: t.message || "Unknown file type" }) }) })] })] });
}, WA = "c6jz5ew", U0 = "bgdbf30", QA = "pn3chz8", YA = "taopgxt", $A = ({ message: t }) => {
  var s, a;
  const [n, e] = Ye(!1), [r] = Ye(() => {
    var o, l;
    return ((o = t.messageParams) == null ? void 0 : o.file) instanceof File ? URL.createObjectURL((l = t.messageParams) == null ? void 0 : l.file) : t.url;
  }), i = (a = (s = t.metaArrays.find((o) => o.key === wg)) == null ? void 0 : s.value) == null ? void 0 : a[0];
  return C.jsxs(C.Fragment, { children: [C.jsx(eM, { src: r, alt: "file preview", aspectRatio: i ?? "1", onClick: () => e(!0) }), n && C.jsx(qg, { message: t, onClose: () => e(!1) })] });
}, ZA = ({ message: t }) => C.jsx("div", { className: "sendbird-message-input--file", children: C.jsxs("div", { className: "pdf", style: { flex: 1 }, children: [C.jsx("div", { className: "pdf-icon", children: C.jsx(vi, { type: "file-document", size: 24 }) }), C.jsxs("div", { className: "pdf-info", children: [C.jsx(ji, { type: "button1", className: "pdf-name", title: t.name, children: t.name }), C.jsx(ji, { type: "caption3", className: "pdf-type", children: "PDF" })] })] }) }), XA = Jr("div")({ name: "ImageContainer", class: "ih5ednu", propsAsIs: !1, vars: { "ih5ednu-0": [(t) => t.ratio] } }), JA = Jr("img")({ name: "StyledImage", class: "s5pvtsc", propsAsIs: !1, vars: { "s5pvtsc-0": [(t) => t.loaded ? 1 : 0] } }), eM = ({ src: t, alt: n, aspectRatio: e, onClick: r }) => {
  const [i, s] = Ye(!1);
  return C.jsxs(XA, { ratio: e, onClick: r, children: [!i && C.jsx(zg, { size: 26, children: C.jsx(vi, { type: "spinner", color: "onbackground3", size: 26 }) }), C.jsx(JA, { loaded: i, src: t, alt: n, onLoad: () => s(!0) })] });
}, tM = Ie.div`
  color: ${({ theme: t }) => t.textColor.incomingMessage};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
`, nM = Ie.div`
  width: 100%;
  position: relative;
`, rM = Ie.div`
  //border-radius: 0 0 16px 16px;
  display: flex;
  justify-content: flex-start;
  gap: 7.5px;
  align-items: center;
  width: 100%;
  padding: 12px 0 4px;
`, iM = Ie.div`
  position: absolute;
  width: calc(100% + 24px);
  transform: translateX(-12px);
  border-top: 1px solid var(--sendbird-light-onlight-04);
`;
function sM() {
  const { messageBottomContent: t } = $t();
  return C.jsx(C.Fragment, { children: C.jsxs(nM, { children: [C.jsx(iM, {}), C.jsx(rM, { children: C.jsx(tM, { children: t.text }) })] }) });
}
const aM = (t) => Q.createElement("svg", { width: 13, height: 13, viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("path", { d: "M10.7239 1.33333H8.33335V0H13V4.66667H11.6667V2.27614L6.33325 7.60958L5.39044 6.66677L10.7239 1.33333Z", fill: "#0D0D0D" }), Q.createElement("path", { d: "M0.334656 0.666667H5.25502V2H1.66799V11C1.66799 11.1841 1.81723 11.3333 2.00132 11.3333H10.668C10.8521 11.3333 11.0013 11.1841 11.0013 11V7.94903H12.3347V11C12.3347 11.9205 11.5885 12.6667 10.668 12.6667H2.00132C1.08085 12.6667 0.334656 11.9205 0.334656 11V0.666667Z", fill: "#0D0D0D" })), oM = Ie.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 0;
  gap: 4px;
  width: 100%;
`, lM = Ie.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme: t }) => t.textColor.incomingMessage};
  padding-bottom: 4px;
`, cM = Ie.a`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.1px;
  color: ${({ theme: t }) => t.textColor.incomingMessage};
  width: fit-content;
  block-size: fit-content;
`, uM = Ie.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
`, dM = Ie.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  padding: 0 1px;

  svg {
    path {
      fill: ${({ theme: t }) => t.textColor.incomingMessage};
    }
  }
`;
function hM(t) {
  const { sources: n } = t, e = n[0];
  return C.jsxs(oM, { children: [C.jsx(lM, { children: "Source" }), C.jsxs(uM, { children: [C.jsx("div", { children: C.jsx(cM, { href: e.source, id: "openLinkText", target: "_blank", children: e.title }) }), C.jsx(dM, { href: e.source, id: "openLinkIcon", target: "_blank", "aria-label": "Source link", children: C.jsx(aM, { width: "15px", height: "15px" }) })] })] });
}
const pM = Ie.div`
  position: relative;
  padding: 20px;
  background: #000;
`, fM = Ie.div`
  color: #f8f8f8;
  overflow-x: auto;
  white-space: pre;
`, mM = Ie.div`
  display: table-row;
`, _M = Ie.span`
  display: table-cell;
  text-align: right;
  padding-right: 10px;
  user-select: none;
  opacity: 0.5;
`, gM = Ie.span`
  display: table-cell;
`, vM = Ie.button`
  position: absolute;
  top: 8px;
  right: 12px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background: #000;
  margin-top: 3px;
  border-radius: 4px;
  height: 26px;
  width: 26px;
  padding: 2px;
`, yM = ({ token: t }) => {
  const [n, e] = Ye(!1), r = t.value, i = r.split(`
`).map((s, a) => C.jsxs(mM, { children: [C.jsx(_M, { children: a + 1 }), C.jsx(gM, { children: s })] }, a));
  return C.jsxs(pM, { children: [C.jsx(vM, { onClick: () => {
    (async () => {
      try {
        await navigator.clipboard.writeText(r), e(!0), setTimeout(() => e(!1), 2e3);
      } catch (s) {
        console.error("Failed to copy!", s);
      }
    })();
  }, children: n ? "✅" : "📋" }), C.jsx(fM, { children: i })] });
}, bM = /(?:https?:\/\/|www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.(xn--)?[a-z]{2,20}\b([-a-zA-Z0-9@:%_+[\],.~#?&/=]*[-a-zA-Z0-9@:%_+~#?&/=])*/g, EM = /\[(.*?)\]\((.*?)\)/g, CM = /\*\*(.*?)\*\*/g, TM = Ie.div`
  width: 100%;
`, wM = Ie.div`
  border-radius: 16px;
  overflow: auto;
  background-color: ${({ theme: t }) => t.bgColor.incomingMessage};
`, Yg = Ie.div`
  width: inherit;
  text-align: left;
  word-break: break-word;
  padding: 8px 12px;
  gap: 12px;
  white-space: pre-wrap;
`, SM = ({ children: t, patterns: n }) => {
  if (n.length === 0 || typeof t != "string")
    return C.jsx(C.Fragment, { children: t });
  const e = [t];
  return n.forEach(({ regex: r, replacer: i }) => {
    const s = e.concat();
    let a = 0;
    s.forEach((o, l) => {
      if (typeof o == "string" && o) {
        const c = ((u, d, h) => {
          const p = [...u.matchAll(d)].map((v) => {
            const E = v[0], y = v.index ?? 0;
            return { text: E, start: y, end: y + E.length, groups: v, matchIndex: v.index };
          }), f = [u];
          let m = 0;
          return p.forEach(({ text: v, start: E, end: y, groups: b }, T) => {
            const w = f.pop(), N = w.slice(0, E - m), M = h({ match: v, groups: b, index: T }), I = w.slice(y - m);
            f.push(N, M, I), m = y;
          }), f;
        })(o, r, i);
        c.length > 1 && (e.splice(l + a, 1, ...c), a += c.length - 1);
      }
    });
  }), C.jsx(Yg, { children: e });
};
function NM({ tokens: t, sources: n }) {
  const { enableSourceMessage: e } = $t();
  return C.jsxs(wM, { className: "sendbird-word", children: [t.map((r, i) => r.type === hg.string ? C.jsx(SM, { patterns: [{ regex: CM, replacer: ({ match: s, groups: a, index: o }) => C.jsx("strong", { children: a[1] }, `${s}-${o}`) }, { regex: EM, replacer: ({ match: s, groups: a, index: o }) => C.jsx("a", { className: "sendbird-word__url", href: $f(a[2]), target: "_blank", rel: "noreferrer", children: a[1] }, `${s}-${o}`) }, { regex: bM, replacer: ({ match: s, index: a }) => C.jsx("a", { className: "sendbird-word__url", href: $f(s), target: "_blank", rel: "noreferrer", children: s }, `${s}-${a}`) }], children: r.value }, "token" + i) : C.jsx(TM, { children: C.jsx(yM, { token: r }) }, "token" + i)), n && n.length > 0 && e ? C.jsxs("div", { style: { padding: "8px 12px" }, children: [C.jsx(hM, { sources: n }), C.jsx(sM, {})] }) : null] });
}
function $g(t) {
  const { text: n, tokens: e, sources: r } = t;
  return e && e.length > 0 ? C.jsx(NM, { tokens: e, sources: r }) : C.jsx(Yg, { className: "sendbird-word", style: { borderRadius: 16 }, children: n });
}
const IM = Ie.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  position: relative;
`, AM = Ie(ji)`
  margin: 0 0 4px 12px;
  text-align: left;
`, MM = Ie.div`
  font-size: 14px;
  color: ${({ theme: t }) => t.textColor.incomingMessage};
  max-width: calc(100% - 96px);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
`, xM = Ie.div`
  display: flex;
  align-items: end;
  gap: 4px;
`, kM = Ie.div`
  width: 28px;
`;
function OM(t) {
  const { user: n, message: e, bodyComponent: r, chainTop: i, chainBottom: s, locale: a } = t, o = i == null && s == null, l = o || s, c = o || i;
  return C.jsxs(IM, { children: [l ? C.jsx("div", { children: C.jsx(fh, { height: "28px", width: "28px", src: n == null ? void 0 : n.profileUrl }) }) : C.jsx(kM, {}), C.jsxs(MM, { children: [c && C.jsx(AM, { type: "caption2", color: "onbackground2", children: n.nickname }), C.jsxs(xM, { children: [r, !!(e != null && e.createdAt) && C.jsx(vh, { children: mc(e.createdAt, a) })] })] })] });
}
function RM(t) {
  const { botUser: n } = gi(), { message: e, activeSpinnerId: r } = t, { replacementTextList: i, enableEmojiFeedback: s } = $t(), { userId: a } = Ho(), o = function(d) {
    const { tools: h } = $t();
    return () => {
      if (xi.commerceShopItems.isValid(d))
        return xi.commerceShopItems.getValidItems(d);
      const p = xi.functionCalls.getAdapterParams(d);
      if (p.length > 0 && h.functionCall.carouselAdapter)
        try {
          return p.map((f) => {
            var m, v;
            return (v = (m = h.functionCall).carouselAdapter) == null ? void 0 : v.call(m, f);
          }).flat().filter((f) => !!f);
        } catch (f) {
          return console.warn("Failed to run carousel adapter:", f), [];
        }
      return [];
    };
  }(e), l = n == null ? void 0 : n.userId, c = r === e.messageId && !!n, u = () => !s || e.myFeedbackStatus === "NOT_APPLICABLE" || xi.isStreaming(e) || xi.isBotWelcomeMsg(e, l ?? "") ? null : C.jsx(nA, { message: e });
  if (e.isAdminMessage())
    return C.jsx(ZI, { message: e });
  if (Oo(e, a)) {
    if (e.isUserMessage())
      return C.jsxs("div", { children: [C.jsx(dA, { message: e }), c && C.jsx(k0, {})] });
    if (e.isFileMessage())
      return C.jsxs("div", { children: [C.jsx(KA, { message: e }), c && C.jsx(k0, {})] });
  }
  if (Oo(e, l)) {
    if (e.messageForm)
      return C.jsx(Xa, { ...t, bodyComponent: C.jsx(qA, { form: e.messageForm, message: e }), createdAt: e.createdAt });
    if (e.isFileMessage())
      return C.jsx(Xa, { wideContainer: z_(e), ...t, bodyComponent: C.jsx(gA, { message: e }), createdAt: e.createdAt, messageFeedback: u() });
    if (e.isUserMessage()) {
      const d = function(m) {
        var E;
        const v = Za(m.data);
        return Array.isArray(v.metadatas) ? (E = v.metadatas) == null ? void 0 : E.filter((y) => y.source_type !== "file") : [];
      }(e), h = pg(e.message, i), p = C.jsx($g, { text: e.message, tokens: h, sources: d }), f = o();
      return f.length > 0 ? C.jsx(Xa, { wideContainer: !0, ...t, bodyComponent: C.jsx(wA, { streaming: xi.isStreaming(e), items: f, streamingBody: C.jsx(Gg, {}), textBody: p }), createdAt: e.createdAt, messageFeedback: u() }) : C.jsx(Xa, { ...t, bodyComponent: p, createdAt: e.createdAt, messageFeedback: u() });
    }
  }
  return e.isUserMessage() ? C.jsx(OM, { ...t, message: e, user: e.sender, bodyComponent: C.jsx(fA, { message: e.message }) }) : C.jsx(C.Fragment, {});
}
const DM = (t) => Q.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("g", { id: "metadata" }, Q.createElement("g", { id: "Fill" }, Q.createElement("path", { d: "M0.666626 7.33317V8.7041H1.33329C1.39843 8.7041 1.46284 8.70099 1.52639 8.6949C1.80042 8.77769 1.99996 9.03213 1.99996 9.33317V12.7041C1.99996 13.6246 2.74615 14.3708 3.66663 14.3708H5.33329V13.0374H3.66663C3.48253 13.0374 3.33329 12.8882 3.33329 12.7041V9.33317C3.33329 8.82995 3.14745 8.37015 2.84064 8.01864C3.14745 7.66713 3.33329 7.20732 3.33329 6.7041V3.33317C3.33329 3.14908 3.48253 2.99984 3.66663 2.99984H5.33329V1.6665H3.66663C2.74615 1.6665 1.99996 2.4127 1.99996 3.33317V6.7041C1.99996 7.00514 1.80042 7.25958 1.52639 7.34237C1.46285 7.33629 1.39843 7.33317 1.33329 7.33317H0.666626Z", fill: "#0D0D0D" }), Q.createElement("path", { d: "M14 6.7041C14 7.00514 14.1995 7.25958 14.4735 7.34237C14.5371 7.33629 14.6015 7.33317 14.6666 7.33317H15.3333V8.7041H14.6666C14.6015 8.7041 14.5371 8.70099 14.4735 8.6949C14.1995 8.77769 14 9.03213 14 9.33317V12.7041C14 13.6246 13.2538 14.3708 12.3333 14.3708H11V13.0374H12.3333C12.5174 13.0374 12.6666 12.8882 12.6666 12.7041V9.33317C12.6666 8.82995 12.8525 8.37015 13.1593 8.01864C12.8525 7.66713 12.6666 7.20732 12.6666 6.7041V3.33317C12.6666 3.14908 12.5174 2.99984 12.3333 2.99984H10.6666V1.6665H12.3333C13.2538 1.6665 14 2.4127 14 3.33317V6.7041Z", fill: "#0D0D0D" }), Q.createElement("path", { d: "M7.99996 8.6665C8.36815 8.6665 8.66663 8.36803 8.66663 7.99984C8.66663 7.63165 8.36815 7.33317 7.99996 7.33317C7.63177 7.33317 7.33329 7.63165 7.33329 7.99984C7.33329 8.36803 7.63177 8.6665 7.99996 8.6665Z", fill: "#0D0D0D" }), Q.createElement("path", { d: "M11.3333 7.99984C11.3333 8.36803 11.0348 8.6665 10.6666 8.6665C10.2984 8.6665 9.99996 8.36803 9.99996 7.99984C9.99996 7.63165 10.2984 7.33317 10.6666 7.33317C11.0348 7.33317 11.3333 7.63165 11.3333 7.99984Z", fill: "#0D0D0D" }), Q.createElement("path", { d: "M5.33329 8.6665C5.70148 8.6665 5.99996 8.36803 5.99996 7.99984C5.99996 7.63165 5.70148 7.33317 5.33329 7.33317C4.9651 7.33317 4.66663 7.63165 4.66663 7.99984C4.66663 8.36803 4.9651 8.6665 5.33329 8.6665Z", fill: "#0D0D0D" })))), LM = (t) => Q.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("g", { id: "reply-thread" }, Q.createElement("g", { id: "Fll" }, Q.createElement("path", { d: "M11.3334 6.00016H4.66671V4.66683H11.3334V6.00016Z", fill: "#0D0D0D" }), Q.createElement("path", { d: "M4.66671 8.66683H10V7.3335H4.66671V8.66683Z", fill: "#0D0D0D" }), Q.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.00004 1.3335C2.07957 1.3335 1.33337 2.07969 1.33337 3.00016V14.6668L4.00004 12.0002H13C13.9205 12.0002 14.6667 11.254 14.6667 10.3335L14.6667 3.00016C14.6667 2.07969 13.9205 1.3335 13 1.3335H3.00004ZM13 10.6668C13.1841 10.6668 13.3334 10.5176 13.3334 10.3335L13.3334 3.00016C13.3334 2.81607 13.1841 2.66683 13 2.66683H3.00004C2.81595 2.66683 2.66671 2.81607 2.66671 3.00016V11.4479L3.44776 10.6668H13Z", fill: "#0D0D0D" })))), P0 = Ie.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.1px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  word-break: break-word;
`, UM = Ie.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.1px;
  white-space: nowrap;
`, PM = Ie.div`
  display: flex;
  align-items: center;
  ${({ theme: t }) => {
  const n = t.textColor.messageDataContent.link;
  return { color: n.default, path: { fill: n.default }, "&:hover": { color: n.hover, cursor: "pointer", path: { fill: n.hover } }, "&:focus": { border: `2px solid ${n.focus}` }, "&:active": { color: n.active, path: { fill: n.active } }, "&:disabled": { color: n.disabled, path: { fill: n.disabled } } };
}};
`, FM = Ie.div`
  display: flex;
  align-items: center;
  height: 20px;
`, jM = Ie.div`
  border-radius: 2px;
  border: 1px solid ${({ theme: t }) => t.borderColor.messageDataContent.intentType};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  padding: 0 4px;
  white-space: nowrap;
`, HM = Ie.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 16px;
  padding-left: 36px;
`, BM = Ie.div`
  width: 4px;
  border-radius: 100px;
  background-color: ${({ theme: t }) => t.bgColor.messageDataContent.sidebar};
  margin-left: 8px;
`, zM = Ie.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  margin-left: 16px;
  flex: 1; // Without this, Sidebar width is reduced.
  color: ${({ theme: t }) => t.textColor.messageDataContent.default};
`, F0 = Ie.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`, VM = Ie.div`
  color: ${({ theme: t }) => t.textColor.messageDataContent.sideNote};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-top: 5px;
`, j0 = Ie.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 20px;

  svg {
    path {
      fill: ${({ theme: t }) => t.textColor.messageDataContent.default};
    }
  }
`;
var Zg = ((t) => (t.EXACT_MATCHED = "exact_question_match", t.KEYWORD_MATCHED = "keyword_match", t.SIMILAR_MATCHED = "similar_question_match", t))(Zg || {});
const GM = { exact_question_match: "Exact match", keyword_match: "Keyword", similar_question_match: "Intent classified" };
function qM({ messageData: t }) {
  const { callbacks: n } = $t(), e = n == null ? void 0 : n.onViewDetailClick, [r, i] = function() {
    let s = null;
    const a = [];
    try {
      const o = JSON.parse(t), l = o == null ? void 0 : o.function_calls;
      Array.isArray(l) && l.length > 0 && function(u) {
        return Array.isArray(u) && u.length > 0 && u.every((d) => function(h) {
          const { name: p, request: f, response_text: m, status_code: v } = h ?? {};
          return typeof p == "string" && typeof f == "object" && typeof m == "string" && typeof v == "number";
        }(d));
      }(l) && l.forEach((u) => {
        if (u.name) {
          const d = typeof e == "function" ? e : Er;
          a.push({ name: u.name, onClick: () => d(u) });
        }
      });
      const c = o == null ? void 0 : o.workflow;
      return function(u) {
        const { name: d, intent_type: h } = u ?? {};
        return typeof d == "string" && Object.values(Zg).includes(h);
      }(c) && (s = { name: c.name, type: GM[c.intent_type] }), [s, a];
    } catch {
      return [s, a];
    }
  }();
  return r || i.length !== 0 ? C.jsxs(HM, { children: [C.jsx(BM, {}), C.jsxs(zM, { children: [r && C.jsxs(F0, { children: [C.jsx(j0, { children: C.jsx(LM, { id: "aichatbot-widget-ellipsis-icon" }) }), C.jsx(P0, { children: r.name }), C.jsx(FM, { children: C.jsx(jM, { children: r.type }) })] }), i.map((s, a) => C.jsxs(F0, { children: [C.jsx(j0, { children: C.jsx(DM, { id: "aichatbot-widget-message-bubble-icon" }) }), C.jsx(P0, { children: s.name }), C.jsxs(PM, { onClick: s.onClick, children: [C.jsx(UM, { children: "View details" }), C.jsx(Kg, { id: "aichatbot-widget-chevron-right-icon" })] })] }, a)), C.jsx(VM, { children: "Only visible in the dashboard widget" })] })] }) : null;
}
const KM = ({ value: t, onClickReply: n, type: e = "vertical" }) => C.jsx("div", { className: `sendbird-suggested-replies__option ${e}`, id: t, onClick: (r) => n(r, t), children: t }), WM = ({ replyOptions: t, onSendMessage: n, type: e = "vertical" }) => {
  const [r, i] = Ye(!1), s = (o, l) => {
    o.preventDefault(), n({ message: l }), i(!0);
  };
  if (r)
    return null;
  const a = t.map((o, l) => C.jsx(KM, { value: o, onClickReply: s, type: e }, l));
  return C.jsx("div", { className: `sendbird-suggested-replies ${e}`, children: a });
}, Xg = ({ replies: t = [], type: n = "vertical", sendUserMessage: e }) => t.length <= 0 ? null : C.jsx("div", { style: { marginTop: 8 }, children: C.jsx(WM, { replyOptions: t, onSendMessage: ({ message: r }) => e == null ? void 0 : e({ message: r }), type: n }) }), QM = () => {
  const { botStudioEditProps: t = {}, botId: n, replacementTextList: e, stringSet: r, dateLocale: i } = $t(), { dataSource: s, handlers: a } = gi(), { suggestedRepliesDirection: o, welcomeMessages: l = [] } = t, { messages: c } = s, u = function(p, f) {
    return p.filter((m) => xi.isBotWelcomeMsg(m, f));
  }(c, n), d = c[u.length + 1], h = u[0] ?? d;
  return { filteredMessages: c.filter((p) => !function(f) {
    return !!f.isAdminMessage() && f.message === "The channel's custom_type was updated.";
  }(p) && (!(l.length > 0) || !xi.isBotWelcomeMsg(p, n))), shouldShowOriginalDate: (p) => p > 0 || l.length === 0 || d && !cg(d.createdAt, h == null ? void 0 : h.createdAt), renderBotStudioWelcomeMessages: () => l.length === 0 ? null : C.jsxs(C.Fragment, { children: [C.jsx(Fg, { className: YM, date: h == null ? void 0 : h.createdAt, formatString: r.DATE_FORMAT__MESSAGE_LIST__DATE_SEPARATOR, locale: i }), l.map((p, f) => {
    if ("message" in p) {
      const m = p.message, v = pg(m, e), E = u.length === c.length, y = f === l.length - 1;
      return C.jsxs("div", { style: { padding: "0 16px", marginBottom: 16 }, children: [C.jsx(Xa, { chainTop: f === 0, chainBottom: f === l.length - 1, bodyComponent: C.jsx($g, { text: m, tokens: v }), createdAt: h == null ? void 0 : h.createdAt }), E && y && C.jsx(Xg, { replies: p.suggestedReplies, type: o, sendUserMessage: (b) => {
        s.sendUserMessage(b, a.onAfterSendMessage).then(a.onAfterSendMessage);
      } })] }, f);
    }
    return C.jsx(C.Fragment, {});
  })] }) };
}, YM = "d1ek3d9d", $M = () => {
  const { channel: t, dataSource: n, scrollSource: e, handlers: r } = gi(), { botStudioEditProps: i, customUserAgentParam: s, stringSet: a, dateLocale: o } = $t(), l = (() => {
    const { userId: h } = Ho(), { channel: p, dataSource: f, scrollSource: m } = gi(), [v, E] = Ye(-1), y = f.messages[f.messages.length - 1];
    return Tt(() => {
      if (y) {
        const b = Oo(y, h) && (y.isUserMessage() || y.isFileMessage()) && y.sendingStatus === St.SUCCEEDED && (p == null ? void 0 : p.memberCount) === 2;
        E(b ? y.messageId : -1), setTimeout(() => m.scrollPubSub.publish("scrollToBottom", {}), 150);
      }
    }, [y == null ? void 0 : y.messageId]), v;
  })(), { filteredMessages: c, shouldShowOriginalDate: u, renderBotStudioWelcomeMessages: d } = QM();
  return C.jsxs("div", { id: "widget-chat-message-list", className: XM, children: [(() => {
    if (!n.initialized)
      return C.jsx(Id, { type: "loading" });
    if (n.messages.length === 0) {
      const h = d();
      return h ? C.jsx("div", { style: { width: "100%" }, children: h }) : C.jsx(Id, { type: "noMessages" });
    }
    return C.jsx(VI, { ref: e.scrollRef, scrollPositionRef: e.scrollPositionRef, scrollDistanceFromBottomRef: e.scrollDistanceFromBottomRef, onScrollPosition: (h) => e.setIsScrollBottomReached(h === "bottom"), stackDirection: "bottom", messages: c, onLoadPrev: n.loadPrevious, onLoadNext: n.loadNext, depsForResetScrollPositionToBottom: [n.initialized, n.messages.length !== 0], messageTopArea: d(), renderMessage: ({ message: h, index: p }) => {
      var M, I;
      const f = ((M = c[p - 1]) == null ? void 0 : M.createdAt) ?? 0, m = h.suggestedReplies ?? [], v = c[c.length - 1], E = h.messageId === (v == null ? void 0 : v.messageId), [y, b] = (T = h, w = c[p - 1], N = c[p + 1], T.isUserMessage() || T.isFileMessage() ? [(() => {
        if (!w || !w.isUserMessage() && !w.isFileMessage())
          return !0;
        const x = w.sender.userId === T.sender.userId, R = Wf(w.createdAt, T.createdAt);
        return !x || !R;
      })(), (() => {
        if (!N || !N.isUserMessage() && !N.isFileMessage())
          return !0;
        const x = N.sender.userId === T.sender.userId, R = Wf(N.createdAt, T.createdAt);
        return !x || !R;
      })()] : [!1, !1]);
      var T, w, N;
      return C.jsxs("div", { style: { padding: "0 16px" }, children: [!cg(f, h.createdAt) && u(p) && C.jsx(Fg, { className: JM, date: h.createdAt, formatString: a.DATE_FORMAT__MESSAGE_LIST__DATE_SEPARATOR, locale: o }), C.jsxs("div", { style: { marginBottom: p === c.length - 1 ? 0 : 16 }, children: [C.jsx(RM, { message: h, activeSpinnerId: l, chainTop: y, chainBottom: b }), h.data && mg(s) && h.messageId === ((I = t == null ? void 0 : t.lastMessage) == null ? void 0 : I.messageId) && C.jsx(qM, { messageData: h.data }), E && m.length > 0 && C.jsx(Xg, { replies: m, type: i == null ? void 0 : i.suggestedRepliesDirection, sendUserMessage: (x) => {
        n.sendUserMessage(x, r.onAfterSendMessage).then(r.onAfterSendMessage);
      } })] })] }, function(x) {
        return "sendingStatus" in x ? x.sendingStatus === "succeeded" ? String(x.messageId) : x.reqId : String(x.messageId);
      }(h));
    }, overlayArea: C.jsx(C.Fragment, { children: !e.isScrollBottomReached && C.jsx(KI, { className: e6, onClick: () => e.scrollPubSub.publish("scrollToBottom", {}) }) }) });
  })(), (t == null ? void 0 : t.isFrozen) && C.jsx(zI, { className: ZM, label: a.CHANNEL_FROZEN })] });
}, ZM = "fwddfv3", XM = "llwuboj", JM = "d1lure63", e6 = "s19jj9sn", t6 = (t) => Q.createElement("svg", { width: 146, height: 25, viewBox: "0 0 146 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, Q.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.45 0C19.3 0 24.87 5.65 24.87 12.51C24.87 19.37 19.28 25 12.42 25C5.56 25 0 19.38 0 12.49H6.1C2.71 12.42 0 9.64 0 6.24V0H12.45ZM92.81 0.73V21.54H88.5V19.4C87.46 20.98 85.84 21.86 83.73 21.86C79.88 21.86 76.78 18.31 76.78 14C76.78 9.69 79.86 6.19 83.73 6.19C85.79 6.19 87.41 7.07 88.45 8.58L88.5 8.65V0.73H92.81ZM35.76 6.16C38.96 6.16 41.84 7.82 42.25 11.08V11.18H37.92C37.87 10.42 37.05 9.74 35.67 9.74C34.7 9.74 33.97 10.08 33.97 10.79C33.97 13.15 42.4 10.67 42.42 17C42.42 19.75 39.83 21.87 36.44 21.87C32.59 21.87 29.88 19.92 29.51 16.56V16.46H33.63C33.73 17.46 34.79 18.14 36.22 18.14C37.5 18.14 38.23 17.7 38.23 17C38.23 14.52 29.8 16.73 29.8 11.11C29.81 8.28 32.08 6.16 35.76 6.16ZM145.28 0.73V21.52H141V19.38C139.96 20.96 138.34 21.84 136.23 21.84C132.33 21.84 129.26 18.29 129.26 13.98C129.26 9.67 132.34 6.17 136.21 6.17C138.27 6.17 139.89 7.05 140.93 8.56L140.98 8.63V0.73H145.28ZM99.42 0.73V8.57C100.46 7.01 102.06 6.16 104.14 6.16C108.04 6.16 111.11 9.69 111.11 14C111.11 18.31 108.03 21.84 104.16 21.84C102.15 21.84 100.53 20.99 99.49 19.48L99.44 19.41V21.53H95.13V0.73H99.42ZM51.74 6.16C55.81 6.16 59.13 9.37 59.13 13.51C59.13 13.95 59.11 14.39 59.06 14.83L59.04 15.05H47.92C48.21 17 49.71 18.26 51.72 18.26C53.37 18.26 54.41 17.55 54.67 16.53L54.69 16.48H58.9C58.42 19.69 55.63 21.79 51.95 21.83H51.64C47.33 21.78 43.92 18.23 43.96 13.92C43.97 9.52 47.38 6.16 51.74 6.16ZM127.51 6.13C127.95 6.15 128.36 6.2 128.77 6.3L128.94 6.32V10.26C128.43 10.11 127.92 10.04 127.39 10.04C125.33 10.04 123.69 11.26 123.64 13.98V21.5H119.33V6.45H123.64V8.15C124.49 6.91 125.84 6.15 127.32 6.13H127.51ZM69.03 6.16C72.84 6.16 75.16 8.71 75.18 12.87V21.52H70.87V13.54C70.87 11.57 69.71 10.28 67.92 10.28C66.15 10.28 64.99 11.52 64.97 13.45V21.53H60.66V6.45H64.97V8.4C65.91 6.99 67.31 6.16 69.03 6.16ZM116.98 6.45V21.49H112.67V6.45H116.98ZM133.56 13.95C133.54 15.97 135.11 17.65 137.12 17.72H137.31C139.32 17.67 140.94 16.02 140.94 14C140.94 11.98 139.32 10.32 137.31 10.3C135.3 10.25 133.61 11.88 133.56 13.95ZM81.11 13.95C81.09 15.97 82.66 17.65 84.67 17.72H84.86C86.87 17.67 88.49 16.02 88.49 14C88.49 11.98 86.87 10.32 84.86 10.3C82.83 10.25 81.14 11.88 81.11 13.95ZM103.3 10.2H103.15C101.09 10.22 99.45 11.93 99.47 14C99.47 16.09 101.12 17.7 103.25 17.7C105.31 17.65 106.95 15.95 106.93 13.9C106.9 11.88 105.28 10.25 103.3 10.2ZM51.55 9.69C49.93 9.69 48.67 10.49 48.14 12.2L48.12 12.3H54.63C54.5 10.73 53.15 9.69 51.55 9.69ZM114.8 0C116.23 0 117.41 1.17 117.41 2.6C117.41 4.03 116.27 5.23 114.82 5.23C113.39 5.23 112.21 4.09 112.21 2.63C112.2 1.17 113.34 0 114.8 0Z", fill: "#6210CC" }));
function n6() {
  return function(t) {
    var e;
    const n = (e = t == null ? void 0 : t.appInfo) == null ? void 0 : e.applicationAttributes;
    return !!Array.isArray(n) && n.includes("remove_powered_by");
  }(Xr().stores.sdkStore.sdk) ? null : C.jsx(s6, {});
}
const r6 = Ie.div`
  padding-bottom: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme: t, chatBottomBackgroundColor: n }) => n || t.bgColor.bottomBanner};
  color: ${({ theme: t }) => t.textColor.bottomBanner.poweredBy};
  flex-wrap: wrap;
  font-size: 13px;

  svg {
    path {
      fill: ${({ theme: t }) => t.textColor.bottomBanner.logo};
    }
  }
`, i6 = Ie.a`
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
`;
function s6() {
  const { chatBottomContent: t } = $t();
  return C.jsxs(r6, { chatBottomBackgroundColor: t.backgroundColor, children: [t == null ? void 0 : t.text, "   Powered by ", C.jsx(i6, { "aria-label": "Learn more about Sendbird", href: "https://sendbird.com?utm_medium=product&utm_source=chatbot&utm_campaign=fy25-glbl-ai-chat-poweredby", rel: "noopener noreferrer nofollow", target: "_blank", children: C.jsx(t6, { width: "75px" }) })] });
}
const a6 = ({ fullscreen: t }) => {
  const n = (() => {
    const { onDrop: e } = Mn(dh);
    return { onDrop: e, onDragOver: (r) => r.preventDefault() };
  })();
  return C.jsxs("div", { className: Hr(o6, Oc), ...n, children: [C.jsx(LN, { fullscreen: t }), C.jsx($M, {}), C.jsx(jI, {}), C.jsx(n6, {})] });
}, o6 = "c19n01aj", bh = ({ fullscreen: t = !1 }) => {
  const { stores: n } = Xr(), { locale: e } = $t(), r = wa(), i = Ho();
  return Tt(() => {
    r.initialized && n.sdkStore.initialized && (i.strategy !== "manual" || i.channelUrl || r.initManualSession(n.sdkStore.sdk));
  }, [r.initialized, i.strategy, i.channelUrl, n.sdkStore.sdk, n.sdkStore.initialized]), Tt(() => {
    e && n.sdkStore.initialized && n.sdkStore.sdk && n.sdkStore.sdk.setLocaleForChatbot(e);
  }, [e, n.sdkStore.initialized, n.sdkStore.sdk]), C.jsxs(bN, { sdk: n.sdkStore.sdk, channelUrl: (i == null ? void 0 : i.channelUrl) ?? "", stringSet: { ERR_CHANNEL_FETCH: "Failed to retrieve channel information" }, children: [C.jsx(l6, { fullscreen: t }), C.jsx(a6, { fullscreen: t })] });
}, l6 = ({ fullscreen: t }) => (function() {
  const { applicationId: n, botId: e } = $t(), { setIsOpen: r } = $r();
  hr(() => {
    window.sbWidget = { open: () => r(!0), close: () => r(!1), clearCache: () => uh({ appId: n, botId: e }) };
  });
}(), function() {
  const { enableResetHistoryOnConnect: n } = $t(), { sdk: e, channel: r, dataSource: i } = gi();
  Tt(() => {
    n && r && e && i.initialized && (async () => (await Promise.allSettled([e.clearCachedMessages([r.url]), r.resetMyHistory()]), await i.refresh()))();
  }, [n, r == null ? void 0 : r.url, e, i.initialized]);
}(), function(n) {
  const { isOpen: e } = $r(), r = Xr(), i = Mt(null), { sdk: s, initialized: a } = r.stores.sdkStore;
  Tt(() => {
    !n && s && a && (e ? (s.connectionState === "CLOSED" && s.reconnect(), i.current && (clearTimeout(i.current), i.current = null)) : i.current = setTimeout(() => {
      s.disconnectWebSocket();
    }, 6e4));
  }, [n, s, a, e]);
}(t), function() {
  const n = Mt([]);
  Tt(() => {
    const e = () => {
      setTimeout(() => {
        document.activeElement instanceof HTMLElement && document.activeElement.blur();
      }, 200);
    }, r = (o) => {
      o.key === "Enter" && oh && e();
    }, i = new MutationObserver((o) => {
      o.forEach((l) => {
        l.type === "childList" && l.addedNodes.forEach((c) => {
          c.nodeType === Node.ELEMENT_NODE && c.matches(".sendbird-message-input--send") && (c.removeEventListener("click", e), c.addEventListener("click", e), n.current.push(c));
        });
      });
    }), s = { childList: !0, subtree: !0 }, a = document.querySelector(".sendbird-message-input");
    return a ? (i.observe(a, s), a.removeEventListener("keydown", r), a.addEventListener("keydown", r)) : console.warn("Input element not found for mutation observer"), () => {
      i.disconnect(), n.current.forEach((o) => o.removeEventListener("click", e)), a && a.removeEventListener("keydown", r);
    };
  }, []);
}(), null), c6 = Ie.div`
  position: fixed;
  z-index: ${_g};
  top: 0;
  left: 0;
  width: ${({ width: t }) => `${t}px`};
  height: 100%;
  overflow: hidden;
  background-color: white;
`, u6 = () => {
  const { isVisible: t } = $r();
  return function() {
    const { isMobileView: n } = $t(), { isOpen: e, setIsOpen: r } = $r(), { botStyle: i } = wa(), s = Mt();
    e && s.current && (clearTimeout(s.current), s.current = void 0), Tt(() => (i.autoOpen && (s.current = setTimeout(() => {
      n || r(!0);
    }, 100)), () => {
      s.current && (clearTimeout(s.current), s.current = void 0);
    }), [i.autoOpen]);
  }(), C.jsxs(C.Fragment, { children: [C.jsx(gN, { children: C.jsx(bh, {}) }), t && C.jsx(Tg, {})] });
}, d6 = () => {
  const { isOpen: t, isVisible: n } = $r(), { width: e } = function() {
    const { isMobileView: r } = $t(), { isOpen: i } = $r(), [s, a] = Ye({ width: window.innerWidth, height: window.innerHeight });
    return Tt(() => {
      const o = () => {
        a({ width: window.innerWidth, height: window.innerHeight });
      };
      return window.addEventListener("resize", o), () => {
        window.removeEventListener("resize", o);
      };
    }, []), Tt(() => {
      const o = document.body.style.position;
      let l = document.body.style.top;
      function c() {
        document.body.style.position = o, document.body.style.top = l, o === "fixed" && window.scrollTo(0, -1 * parseInt(l || "0"));
      }
      return i && r ? (l = `${window.scrollY}px`, document.body.style.position = "fixed", document.body.style.top = `-${l}`, document.body.style.width = "100%") : c(), () => {
        c();
      };
    }, [i, r]), sr(() => ({ width: s.width, height: s.height }), []);
  }();
  return C.jsxs(C.Fragment, { children: [C.jsx(c6, { style: { display: t && n ? "block" : "none" }, width: e, id: _i.widgetWindow, children: C.jsx(bh, {}) }), n && !t && C.jsx(Tg, {})] });
};
function v6(t) {
  return C.jsx(Eg, { ...t, children: fg(t.deviceType) ? C.jsx(d6, {}) : C.jsx(u6, {}) });
}
function y6(t) {
  return C.jsx(Eg, { ...t, children: C.jsx("div", { id: _i.widgetWindow, style: { position: "fixed", left: 0, top: 0, width: "100%", height: "100%", transform: "scale(1)" }, children: C.jsx(bh, { fullscreen: !0 }) }) });
}
export {
  am as B,
  v6 as C,
  fa as F,
  vi as I,
  zg as L,
  ne as P,
  Hd as V,
  y6 as W,
  g6 as a,
  ji as b,
  Hr as c,
  f6 as d,
  k as e,
  uh as f,
  m6 as g,
  fN as h,
  C as j,
  Vl as n,
  _6 as p,
  $n as t,
  D as v,
  Pa as w
};
